(() => {
  var t = {
      646: (t, e) => {
        "use strict";
        function i() {
          return window
            .getComputedStyle(document.documentElement, ":after")
            .getPropertyValue("content")
            .replace(/"/g, "");
        }
        Object.defineProperty(e, "__esModule", { value: !0 });
        var n = [],
          s = window
            .getComputedStyle(document.documentElement, ":before")
            .getPropertyValue("content")
            .replace(/"/g, "")
            .split(","),
          o = (function () {
            function t(t) {
              this.cssBreakpoint = t;
            }
            return (
              Object.defineProperty(t.prototype, "value", {
                get: function () {
                  return this.cssBreakpoint;
                },
                enumerable: !0,
                configurable: !0,
              }),
              (t.prototype.min = function (t) {
                return s.indexOf(this.value) - s.indexOf(t) >= 0;
              }),
              (t.prototype.max = function (t) {
                return s.indexOf(this.value) - s.indexOf(t) <= 0;
              }),
              (t.prototype.range = function (t, e) {
                var i = s.indexOf(this.value),
                  n = s.indexOf(t),
                  o = s.indexOf(e);
                return n <= i && i <= o;
              }),
              (t.prototype.is = function () {
                for (var t = this, e = [], i = 0; i < arguments.length; i++)
                  e[i] = arguments[i];
                return e.some(function (e) {
                  return e === t.value;
                });
              }),
              t
            );
          })(),
          r = { previous: new o(i()), current: new o(i()) };
        (e.get = function () {
          return r;
        }),
          (e.onChange = function (t) {
            -1 === n.indexOf(t) && n.push(t);
          }),
          (e.offChange = function (t) {
            var e = n.indexOf(t);
            -1 !== e && n.splice(e, 1);
          });
        e.min = function (t) {
          return r.current.min(t);
        };
        e.max = function (t) {
          return r.current.max(t);
        };
        e.range = function (t, e) {
          return r.current.range(t, e);
        };
        e.is = function () {
          for (var t, e = [], i = 0; i < arguments.length; i++)
            e[i] = arguments[i];
          return (t = r.current).is.apply(t, e);
        };
        var a = document.styleSheets,
          l = Object.keys(a).reduce(function (t, e) {
            var i = a[e];
            if (!i.href || -1 === i.href.indexOf("theme")) return t;
            try {
              for (var n = i.cssRules, s = 0; s < n.length; s++) {
                var o = i.cssRules[s];
                if (o instanceof CSSMediaRule)
                  for (var r = 0; r < n.length; r++) {
                    var l = o.cssRules[r];
                    l instanceof CSSStyleRule &&
                      l.selectorText &&
                      -1 !== l.selectorText.indexOf("html::after") &&
                      t.push(o.media);
                  }
              }
            } catch (e) {
              return t;
            }
            return t;
          }, []);
        l.length > 0
          ? l.forEach(function (t) {
              window.matchMedia(t.mediaText).addListener(function () {
                var t = i();
                r.current.value !== t &&
                  ((r.previous = r.current),
                  (r.current = new o(t)),
                  n.forEach(function (t) {
                    return t(r);
                  }));
              });
            })
          : window.addEventListener("resize", function () {
              var t = i();
              r.current.value !== t &&
                ((r.previous = r.current),
                (r.current = new o(t)),
                n.forEach(function (t) {
                  return t(r);
                }));
            });
      },
      766: (t, e) => {
        "use strict";
        var i = (function () {
          function t() {
            this.events = [];
          }
          return (
            (t.prototype.register = function (t, e, i) {
              return t && e && i
                ? (this.events.push({ el: t, event: e, listener: i }),
                  t.addEventListener(e, i),
                  { el: t, event: e, listener: i })
                : null;
            }),
            (t.prototype.unregister = function (t) {
              var e = t.el,
                i = t.event,
                n = t.listener;
              return e && i && n
                ? ((this.events = this.events.filter(function (t) {
                    return e !== t.el || i !== t.event || n !== t.listener;
                  })),
                  e.removeEventListener(i, n),
                  { el: e, event: i, listener: n })
                : null;
            }),
            (t.prototype.unregisterAll = function () {
              this.events.forEach(function (t) {
                var e = t.el,
                  i = t.event,
                  n = t.listener;
                return e.removeEventListener(i, n);
              }),
                (this.events = []);
            }),
            t
          );
        })();
        e.Z = i;
      },
      722: () => {
        class t extends HTMLElement {
          static get observedAttributes() {
            return ["variant"];
          }
          constructor() {
            super(),
              (this._loaded = !1),
              (this._productFetcher = Promise.resolve(!1)),
              (this._onMainElChange = (t) => {
                this.variant = t.currentTarget.value;
              });
            const t = this.querySelector("input[data-variants]");
            this._mainEl = t || this.querySelector("select[data-variants]");
          }
          set variant(t) {
            t
              ? this.setAttribute("variant", t)
              : this.removeAttribute("variant");
          }
          get variant() {
            return this.getAttribute("variant");
          }
          connectedCallback() {
            this._productFetcher = this._fetchProduct();
            const t = this.querySelector("input[data-variants]");
            (this._mainEl = t || this.querySelector("select[data-variants]")),
              this._mainEl.addEventListener("change", this._onMainElChange),
              (this.variant = this._mainEl.value);
          }
          disconnectedCallback() {
            this._mainEl.removeEventListener("change", this._onMainElChange),
              (this._mainEl = null);
          }
          attributeChangedCallback(t, e, i) {
            if (e !== i && "variant" === t) this._changeVariant(i);
          }
          getProduct() {
            return this._loaded
              ? Promise.resolve(this._product)
              : this._productFetcher;
          }
          getVariant() {
            return this.getProduct()
              .then(
                (t) =>
                  (t &&
                    t.variants.find((t) => t.id.toString() === this.variant)) ||
                  !1
              )
              .catch(() => !1);
          }
          getState() {
            return this.getVariant().then((t) =>
              t ? "selected" : this.getAttribute("variant")
            );
          }
          _changeVariant(t) {
            this._dispatchEvent(t).then(() => {
              this._mainEl.value = t;
            });
          }
          _fetchProduct() {
            return fetch(this.getAttribute("product-url"))
              .then((t) => t.json())
              .then((t) => ((this._product = t), t))
              .catch(() => {
                this._product = null;
              })
              .finally(() => {
                this._loaded = !0;
              });
          }
          _dispatchEvent(t) {
            return this.getProduct().then((e) => {
              const i =
                  (e && e.variants.find((e) => e.id.toString() === t)) || !1,
                n = new CustomEvent("variant-change", {
                  detail: { product: e, variant: i, state: i ? "selected" : t },
                });
              this.dispatchEvent(n);
            });
          }
        }
        const e = "option",
          i = 'input[type="radio"]';
        function n(t) {
          const n = [],
            s = [];
          for (let o = 0; o < t.length; o++) {
            const r = t[o],
              a = r.matches("[data-variant-option-value-wrapper]")
                ? [r]
                : Array.prototype.slice.call(
                    r.querySelectorAll("[data-variant-option-value-wrapper]")
                  ),
              l = r.matches("[data-variant-option-value]")
                ? [r]
                : Array.prototype.slice.call(
                    r.querySelectorAll("[data-variant-option-value]")
                  );
            if (!l.length) break;
            const c = { option: r, wrappers: a, values: l };
            l[0].matches(e) ? n.push(c) : l[0].matches(i) && s.push(c);
          }
          return { select: n, radio: s };
        }
        function s(t, e, i) {
          const n = t.options.map(() => "not-selected");
          return (
            e.forEach(({ option: t }) => {
              "not-selected" !== t.value &&
                (n[parseInt(t.dataset.variantOptionIndex, 10)] = t.value);
            }),
            i.forEach(({ values: t }) => {
              t.forEach((t) => {
                t.checked &&
                  (n[parseInt(t.dataset.variantOptionValueIndex, 10)] =
                    t.value);
              });
            }),
            n
          );
        }
        function o(t, e, i, n, s = null, o = null) {
          const r = { ...i },
            a = [n, s, o].filter((t) => !!t),
            l = (function (t, e) {
              return t.find((t) => t.options.every((t, i) => t === e[i]));
            })(t.variants, a),
            c = a.filter((t, i) => t === e[i]).length,
            h = c === t.options.length,
            d = c === t.options.length - 1;
          for (let t = 0; t < a.length; t++) {
            const e = a[t];
            if (e) {
              let {
                setByCurrentVariant: n,
                setByNeighbor: s,
                accessible: o,
                available: a,
              } = i[t][e];
              l
                ? ((o = l.available || o),
                  h
                    ? ((n = !0), ({ available: a } = l))
                    : !n && d && ((a = (s && a) || l.available), (s = !0)))
                : h
                ? ((n = !0), (a = !1))
                : !n && d && ((a = !!s && a), (s = !0)),
                n || s || (a = o),
                (r[t][e] = {
                  setByCurrentVariant: n,
                  setByNeighbor: s,
                  accessible: o,
                  available: a,
                });
            }
          }
          return r;
        }
        function r(t, e, i, n, s, r) {
          const a = [...e, ...i];
          if (0 === a.length) return;
          const l = (function (t, e) {
            let i = t.options.map(() => ({}));
            for (let e = 0; e < t.options.length; e++)
              for (let n = 0; n < t.variants.length; n++) {
                const s = t.variants[n].options[e];
                i[e][s] = {
                  setByCurrentVariant: !1,
                  setByNeighbor: !1,
                  accessible: !1,
                  available: !1,
                };
              }
            const n = i.length >= 1 ? Object.keys(i[0]) : [],
              s = i.length >= 2 ? Object.keys(i[1]) : [],
              r = i.length >= 3 ? Object.keys(i[2]) : [];
            return (
              n.forEach((n) => {
                s.forEach((s) => {
                  r.forEach((r) => {
                    i = o(t, e, i, n, s, r);
                  }),
                    r.length || (i = o(t, e, i, n, s));
                }),
                  s.length || (i = o(t, e, i, n));
              }),
              i
            );
          })(t, n);
          for (let e = 0; e < t.options.length; e++) {
            const t = a.find(
              ({ option: t }) =>
                parseInt(t.dataset.variantOptionIndex, 10) === e
            );
            if (t) {
              const i = document.createDocumentFragment(),
                { option: n, wrappers: o, values: a } = t;
              for (let t = a.length - 1; t >= 0; t--) {
                const n = o[t],
                  c = a[t],
                  { value: h } = c,
                  { available: d } = h in l[e] && l[e][h],
                  { accessible: u } = h in l[e] && l[e][h],
                  p = "not-selected" === h;
                (c.disabled = p || (s && !u)),
                  (c.dataset.variantOptionAccessible = u),
                  (c.dataset.variantOptionAvailable = d),
                  (!r || u || p) && i.insertBefore(n, i.firstElementChild);
              }
              (n.innerHTML = ""), n.appendChild(i);
              const c = a.find((t) => t.selected || t.checked);
              n.dataset.variantOptionChosenValue =
                !(!c || "not-selected" === c.value) && c.value;
            }
          }
        }
        class a extends HTMLElement {
          static get observedAttributes() {
            return [
              "variant-selection",
              "disable-unavailable",
              "remove-unavailable",
            ];
          }
          static synchronize(t) {
            const e = t.getVariantSelection();
            return e
              ? t
                  .getSelectedOptions()
                  .then((i) => {
                    document
                      .querySelectorAll("options-selection")
                      .forEach((n) => {
                        n !== t &&
                          n.getVariantSelection() === e &&
                          n.setSelectedOptions(i);
                      });
                  })
                  .then(() => !0)
              : Promise.resolve(!1);
          }
          constructor() {
            super(),
              (this.style.display = ""),
              (this._events = []),
              (this._onChangeFn = this._onOptionChange.bind(this)),
              (this._optionsEls = this.querySelectorAll(
                "[data-variant-option]"
              )),
              ({ select: this._selectOptions, radio: this._radioOptions } = n(
                this._optionsEls
              )),
              this._associateVariantSelection(
                this.getAttribute("variant-selection")
              );
          }
          set variantSelection(t) {
            t
              ? this.setAttribute("variant-selection", t)
              : this.removeAttribute("variant-selection");
          }
          get variantSelection() {
            return this.getAttribute("variant-selection");
          }
          connectedCallback() {
            (this._optionsEls = this.querySelectorAll("[data-variant-option]")),
              ({ select: this._selectOptions, radio: this._radioOptions } = n(
                this._optionsEls
              )),
              this._associateVariantSelection(
                this.getAttribute("variant-selection")
              ),
              this._selectOptions.forEach(({ option: t }) => {
                t.addEventListener("change", this._onChangeFn),
                  this._events.push({ el: t, fn: this._onChangeFn });
              }),
              this._radioOptions.forEach(({ values: t }) => {
                t.forEach((t) => {
                  t.addEventListener("change", this._onChangeFn),
                    this._events.push({ el: t, fn: this._onChangeFn });
                });
              }),
              this._onOptionChange();
          }
          disconnectedCallback() {
            this._resetOptions(),
              this._events.forEach(({ el: t, fn: e }) =>
                t.removeEventListener("change", e)
              ),
              (this._events = []);
          }
          attributeChangedCallback(t, e, i) {
            switch (t) {
              case "variant-selection":
                this._associateVariantSelection(i);
                break;
              case "disable-unavailable":
              case "remove-unavailable":
                this._updateOptions(
                  this.hasAttribute("disable-unavailable"),
                  this.hasAttribute("remove-unavailable")
                );
            }
          }
          getSelectedOptions() {
            return this._variantSelection
              ? this._variantSelection
                  .getProduct()
                  .then((t) =>
                    t ? s(t, this._selectOptions, this._radioOptions) : null
                  )
              : Promise.resolve(null);
          }
          getVariantSelection() {
            return this._variantSelection;
          }
          setSelectedOptions(t) {
            return (
              (function (t, e, i) {
                t.forEach(({ option: t }) => {
                  t.value = i[parseInt(t.dataset.variantOptionIndex, 10)];
                }),
                  e.forEach(({ values: t }) => {
                    t.forEach((t) => {
                      t.checked =
                        t.value ===
                        i[parseInt(t.dataset.variantOptionValueIndex, 10)];
                    });
                  });
              })(this._selectOptions, this._radioOptions, t),
              this._updateOptions(
                this.hasAttribute("disable-unavailable"),
                this.hasAttribute("remove-unavailable"),
                t
              )
            );
          }
          _associateVariantSelection(t) {
            this._variantSelection = t
              ? document.getElementById(t)
              : this.closest("variant-selection");
          }
          _updateLabels() {
            for (let t = 0; t < this._optionsEls.length; t++) {
              const e = this._optionsEls[t];
              let i = null,
                { parentElement: n } = e;
              for (; n && !i; ) {
                const t = n.querySelector("[data-variant-option-name]");
                t && (i = t), ({ parentElement: n } = n);
              }
              if (i)
                if (
                  ((i.dataset.variantOptionChosenValue =
                    e.dataset.variantOptionChosenValue),
                  "false" !== e.dataset.variantOptionChosenValue)
                ) {
                  i.innerHTML = i.dataset.variantOptionName;
                  const t = i.querySelector("span");
                  t && (t.innerHTML = e.dataset.variantOptionChosenValue);
                } else i.innerHTML = i.dataset.variantOptionChooseName;
            }
          }
          _resetOptions() {
            return this._updateOptions(!1, !1);
          }
          _updateOptions(t, e, i = null) {
            return this._variantSelection
              ? this._variantSelection
                  .getProduct()
                  .then((n) => {
                    r(
                      n,
                      this._selectOptions,
                      this._radioOptions,
                      i || s(n, this._selectOptions, this._radioOptions),
                      t,
                      e
                    ),
                      this._updateLabels();
                  })
                  .then(() => !0)
              : Promise.resolve(!1);
          }
          _updateVariantSelection(t, e) {
            if (!this._variantSelection) return;
            const i = (function (t, e) {
                for (let i = 0; i < t.length; i++) {
                  const n = t[i];
                  if (n.options.every((t, i) => t === e[i])) return n;
                }
                return !1;
              })(t.variants, e),
              n = e.some((t) => "not-selected" === t);
            this._variantSelection.variant = i
              ? i.id
              : n
              ? "not-selected"
              : "unavailable";
          }
          _onOptionChange() {
            this._variantSelection &&
              this._variantSelection.getProduct().then((t) => {
                if (!t) return;
                const e = s(t, this._selectOptions, this._radioOptions);
                this._updateOptions(
                  this.hasAttribute("disable-unavailable"),
                  this.hasAttribute("remove-unavailable"),
                  e
                ),
                  this._updateVariantSelection(t, e),
                  a.synchronize(this);
              });
          }
        }
        customElements.get("variant-selection") ||
          customElements.define("variant-selection", t),
          customElements.get("options-selection") ||
            customElements.define("options-selection", a);
      },
      741: (t, e, i) => {
        var n, s;
        !(function (o, r) {
          "use strict";
          void 0 ===
            (s = "function" == typeof (n = r) ? n.call(e, i, e, t) : n) ||
            (t.exports = s);
        })(window, function () {
          "use strict";
          var t = (function () {
            var t = window.Element.prototype;
            if (t.matches) return "matches";
            if (t.matchesSelector) return "matchesSelector";
            for (
              var e = ["webkit", "moz", "ms", "o"], i = 0;
              i < e.length;
              i++
            ) {
              var n = e[i] + "MatchesSelector";
              if (t[n]) return n;
            }
          })();
          return function (e, i) {
            return e[t](i);
          };
        });
      },
      158: function (t, e, i) {
        var n, s;
        "undefined" != typeof window && window,
          void 0 ===
            (s =
              "function" ==
              typeof (n = function () {
                "use strict";
                function t() {}
                var e = t.prototype;
                return (
                  (e.on = function (t, e) {
                    if (t && e) {
                      var i = (this._events = this._events || {}),
                        n = (i[t] = i[t] || []);
                      return -1 == n.indexOf(e) && n.push(e), this;
                    }
                  }),
                  (e.once = function (t, e) {
                    if (t && e) {
                      this.on(t, e);
                      var i = (this._onceEvents = this._onceEvents || {});
                      return ((i[t] = i[t] || {})[e] = !0), this;
                    }
                  }),
                  (e.off = function (t, e) {
                    var i = this._events && this._events[t];
                    if (i && i.length) {
                      var n = i.indexOf(e);
                      return -1 != n && i.splice(n, 1), this;
                    }
                  }),
                  (e.emitEvent = function (t, e) {
                    var i = this._events && this._events[t];
                    if (i && i.length) {
                      (i = i.slice(0)), (e = e || []);
                      for (
                        var n = this._onceEvents && this._onceEvents[t], s = 0;
                        s < i.length;
                        s++
                      ) {
                        var o = i[s];
                        n && n[o] && (this.off(t, o), delete n[o]),
                          o.apply(this, e);
                      }
                      return this;
                    }
                  }),
                  (e.allOff = function () {
                    delete this._events, delete this._onceEvents;
                  }),
                  t
                );
              })
                ? n.call(e, i, e, t)
                : n) || (t.exports = s);
      },
      729: (t) => {
        var e = [
            'iframe[src*="player.vimeo.com"]',
            'iframe[src*="youtube.com"]',
            'iframe[src*="youtube-nocookie.com"]',
            'iframe[src*="kickstarter.com"][src*="video.html"]',
            "object",
          ],
          i =
            ".fluid-width-video-wrapper{width:100%;position:relative;padding:0;}.fluid-width-video-wrapper iframe,.fluid-width-video-wrapper object,.fluid-width-video-wrapper embed {position:absolute;top:0;left:0;width:100%;height:100%;}";
        function n(t, e) {
          return (
            "string" == typeof t && ((e = t), (t = document)),
            Array.prototype.slice.call(t.querySelectorAll(e))
          );
        }
        function s(t) {
          return "string" == typeof t
            ? t.split(",").map(r).filter(o)
            : (function (t) {
                return "[object Array]" === Object.prototype.toString.call(t);
              })(t)
            ? (function (t) {
                return [].concat.apply([], t);
              })(t.map(s).filter(o))
            : t || [];
        }
        function o(t) {
          return t.length > 0;
        }
        function r(t) {
          return t.replace(/^\s+|\s+$/g, "");
        }
        t.exports = function (t, r) {
          var a;
          (r = r || {}),
            (a = t = t || "body"),
            "[object Object]" === Object.prototype.toString.call(a) &&
              ((r = t), (t = "body")),
            (r.ignore = r.ignore || ""),
            (r.players = r.players || "");
          var l = n(t);
          if (o(l)) {
            var c;
            if (!document.getElementById("fit-vids-style"))
              (
                document.head || document.getElementsByTagName("head")[0]
              ).appendChild(
                (((c = document.createElement("div")).innerHTML =
                  '<p>x</p><style id="fit-vids-style">' + i + "</style>"),
                c.childNodes[1])
              );
            var h = s(r.players),
              d = s(r.ignore),
              u = d.length > 0 ? d.join() : null,
              p = e.concat(h).join();
            o(p) &&
              l.forEach(function (t) {
                n(t, p).forEach(function (t) {
                  (u && t.matches(u)) ||
                    (function (t) {
                      if (
                        /fluid-width-video-wrapper/.test(t.parentNode.className)
                      )
                        return;
                      var e = parseInt(t.getAttribute("width"), 10),
                        i = parseInt(t.getAttribute("height"), 10),
                        n = isNaN(e) ? t.clientWidth : e,
                        s = (isNaN(i) ? t.clientHeight : i) / n;
                      t.removeAttribute("width"), t.removeAttribute("height");
                      var o = document.createElement("div");
                      t.parentNode.insertBefore(o, t),
                        (o.className = "fluid-width-video-wrapper"),
                        (o.style.paddingTop = 100 * s + "%"),
                        o.appendChild(t);
                    })(t);
                });
              });
          }
        };
      },
      47: (t, e, i) => {
        var n, s;
        !(function (o, r) {
          (n = [i(741)]),
            (s = function (t) {
              return (function (t, e) {
                "use strict";
                var i = {
                    extend: function (t, e) {
                      for (var i in e) t[i] = e[i];
                      return t;
                    },
                    modulo: function (t, e) {
                      return ((t % e) + e) % e;
                    },
                  },
                  n = Array.prototype.slice;
                (i.makeArray = function (t) {
                  return Array.isArray(t)
                    ? t
                    : null == t
                    ? []
                    : "object" == typeof t && "number" == typeof t.length
                    ? n.call(t)
                    : [t];
                }),
                  (i.removeFrom = function (t, e) {
                    var i = t.indexOf(e);
                    -1 != i && t.splice(i, 1);
                  }),
                  (i.getParent = function (t, i) {
                    for (; t.parentNode && t != document.body; )
                      if (((t = t.parentNode), e(t, i))) return t;
                  }),
                  (i.getQueryElement = function (t) {
                    return "string" == typeof t ? document.querySelector(t) : t;
                  }),
                  (i.handleEvent = function (t) {
                    var e = "on" + t.type;
                    this[e] && this[e](t);
                  }),
                  (i.filterFindElements = function (t, n) {
                    t = i.makeArray(t);
                    var s = [];
                    return (
                      t.forEach(function (t) {
                        if (t instanceof HTMLElement)
                          if (n) {
                            e(t, n) && s.push(t);
                            for (
                              var i = t.querySelectorAll(n), o = 0;
                              o < i.length;
                              o++
                            )
                              s.push(i[o]);
                          } else s.push(t);
                      }),
                      s
                    );
                  }),
                  (i.debounceMethod = function (t, e, i) {
                    i = i || 100;
                    var n = t.prototype[e],
                      s = e + "Timeout";
                    t.prototype[e] = function () {
                      var t = this[s];
                      clearTimeout(t);
                      var e = arguments,
                        o = this;
                      this[s] = setTimeout(function () {
                        n.apply(o, e), delete o[s];
                      }, i);
                    };
                  }),
                  (i.docReady = function (t) {
                    var e = document.readyState;
                    "complete" == e || "interactive" == e
                      ? setTimeout(t)
                      : document.addEventListener("DOMContentLoaded", t);
                  }),
                  (i.toDashed = function (t) {
                    return t
                      .replace(/(.)([A-Z])/g, function (t, e, i) {
                        return e + "-" + i;
                      })
                      .toLowerCase();
                  });
                var s = t.console;
                return (
                  (i.htmlInit = function (e, n) {
                    i.docReady(function () {
                      var o = i.toDashed(n),
                        r = "data-" + o,
                        a = document.querySelectorAll("[" + r + "]"),
                        l = document.querySelectorAll(".js-" + o),
                        c = i.makeArray(a).concat(i.makeArray(l)),
                        h = r + "-options",
                        d = t.jQuery;
                      c.forEach(function (t) {
                        var i,
                          o = t.getAttribute(r) || t.getAttribute(h);
                        try {
                          i = o && JSON.parse(o);
                        } catch (e) {
                          return void (
                            s &&
                            s.error(
                              "Error parsing " +
                                r +
                                " on " +
                                t.className +
                                ": " +
                                e
                            )
                          );
                        }
                        var a = new e(t, i);
                        d && d.data(t, n, a);
                      });
                    });
                  }),
                  i
                );
              })(o, t);
            }.apply(e, n)),
            void 0 === s || (t.exports = s);
        })(window);
      },
      597: (t, e, i) => {
        var n, s;
        window,
          (n = [i(217), i(47)]),
          void 0 ===
            (s = function (t, e) {
              return (function (t, e, i) {
                "use strict";
                function n(t) {
                  var e = document.createDocumentFragment();
                  return (
                    t.forEach(function (t) {
                      e.appendChild(t.element);
                    }),
                    e
                  );
                }
                var s = e.prototype;
                return (
                  (s.insert = function (t, e) {
                    var i = this._makeCells(t);
                    if (i && i.length) {
                      var s = this.cells.length;
                      e = void 0 === e ? s : e;
                      var o = n(i),
                        r = e == s;
                      if (r) this.slider.appendChild(o);
                      else {
                        var a = this.cells[e].element;
                        this.slider.insertBefore(o, a);
                      }
                      if (0 === e) this.cells = i.concat(this.cells);
                      else if (r) this.cells = this.cells.concat(i);
                      else {
                        var l = this.cells.splice(e, s - e);
                        this.cells = this.cells.concat(i).concat(l);
                      }
                      this._sizeCells(i), this.cellChange(e, !0);
                    }
                  }),
                  (s.append = function (t) {
                    this.insert(t, this.cells.length);
                  }),
                  (s.prepend = function (t) {
                    this.insert(t, 0);
                  }),
                  (s.remove = function (t) {
                    var e = this.getCells(t);
                    if (e && e.length) {
                      var n = this.cells.length - 1;
                      e.forEach(function (t) {
                        t.remove();
                        var e = this.cells.indexOf(t);
                        (n = Math.min(e, n)), i.removeFrom(this.cells, t);
                      }, this),
                        this.cellChange(n, !0);
                    }
                  }),
                  (s.cellSizeChange = function (t) {
                    var e = this.getCell(t);
                    if (e) {
                      e.getSize();
                      var i = this.cells.indexOf(e);
                      this.cellChange(i);
                    }
                  }),
                  (s.cellChange = function (t, e) {
                    var i = this.selectedElement;
                    this._positionCells(t),
                      this._getWrapShiftCells(),
                      this.setGallerySize();
                    var n = this.getCell(i);
                    n && (this.selectedIndex = this.getCellSlideIndex(n)),
                      (this.selectedIndex = Math.min(
                        this.slides.length - 1,
                        this.selectedIndex
                      )),
                      this.emitEvent("cellChange", [t]),
                      this.select(this.selectedIndex),
                      e && this.positionSliderAtSelected();
                  }),
                  e
                );
              })(0, t, e);
            }.apply(e, n)) || (t.exports = s);
      },
      880: (t, e, i) => {
        var n, s;
        window,
          (n = [i(47)]),
          void 0 ===
            (s = function (t) {
              return (function (t, e) {
                "use strict";
                var i = {
                  startAnimation: function () {
                    this.isAnimating ||
                      ((this.isAnimating = !0),
                      (this.restingFrames = 0),
                      this.animate());
                  },
                  animate: function () {
                    this.applyDragForce(), this.applySelectedAttraction();
                    var t = this.x;
                    if (
                      (this.integratePhysics(),
                      this.positionSlider(),
                      this.settle(t),
                      this.isAnimating)
                    ) {
                      var e = this;
                      requestAnimationFrame(function () {
                        e.animate();
                      });
                    }
                  },
                  positionSlider: function () {
                    var t = this.x;
                    this.options.wrapAround &&
                      this.cells.length > 1 &&
                      ((t = e.modulo(t, this.slideableWidth)),
                      (t -= this.slideableWidth),
                      this.shiftWrapCells(t)),
                      this.setTranslateX(t, this.isAnimating),
                      this.dispatchScrollEvent();
                  },
                  setTranslateX: function (t, e) {
                    (t += this.cursorPosition),
                      (t = this.options.rightToLeft ? -t : t);
                    var i = this.getPositionValue(t);
                    this.slider.style.transform = e
                      ? "translate3d(" + i + ",0,0)"
                      : "translateX(" + i + ")";
                  },
                  dispatchScrollEvent: function () {
                    var t = this.slides[0];
                    if (t) {
                      var e = -this.x - t.target,
                        i = e / this.slidesWidth;
                      this.dispatchEvent("scroll", null, [i, e]);
                    }
                  },
                  positionSliderAtSelected: function () {
                    this.cells.length &&
                      ((this.x = -this.selectedSlide.target),
                      (this.velocity = 0),
                      this.positionSlider());
                  },
                  getPositionValue: function (t) {
                    return this.options.percentPosition
                      ? 0.01 * Math.round((t / this.size.innerWidth) * 1e4) +
                          "%"
                      : Math.round(t) + "px";
                  },
                  settle: function (t) {
                    this.isPointerDown ||
                      Math.round(100 * this.x) != Math.round(100 * t) ||
                      this.restingFrames++,
                      this.restingFrames > 2 &&
                        ((this.isAnimating = !1),
                        delete this.isFreeScrolling,
                        this.positionSlider(),
                        this.dispatchEvent("settle", null, [
                          this.selectedIndex,
                        ]));
                  },
                  shiftWrapCells: function (t) {
                    var e = this.cursorPosition + t;
                    this._shiftCells(this.beforeShiftCells, e, -1);
                    var i =
                      this.size.innerWidth -
                      (t + this.slideableWidth + this.cursorPosition);
                    this._shiftCells(this.afterShiftCells, i, 1);
                  },
                  _shiftCells: function (t, e, i) {
                    for (var n = 0; n < t.length; n++) {
                      var s = t[n],
                        o = e > 0 ? i : 0;
                      s.wrapShift(o), (e -= s.size.outerWidth);
                    }
                  },
                  _unshiftCells: function (t) {
                    if (t && t.length)
                      for (var e = 0; e < t.length; e++) t[e].wrapShift(0);
                  },
                  integratePhysics: function () {
                    (this.x += this.velocity),
                      (this.velocity *= this.getFrictionFactor());
                  },
                  applyForce: function (t) {
                    this.velocity += t;
                  },
                  getFrictionFactor: function () {
                    return (
                      1 -
                      this.options[
                        this.isFreeScrolling ? "freeScrollFriction" : "friction"
                      ]
                    );
                  },
                  getRestingPosition: function () {
                    return (
                      this.x + this.velocity / (1 - this.getFrictionFactor())
                    );
                  },
                  applyDragForce: function () {
                    if (this.isDraggable && this.isPointerDown) {
                      var t = this.dragX - this.x - this.velocity;
                      this.applyForce(t);
                    }
                  },
                  applySelectedAttraction: function () {
                    if (
                      (!this.isDraggable || !this.isPointerDown) &&
                      !this.isFreeScrolling &&
                      this.slides.length
                    ) {
                      var t =
                        (-1 * this.selectedSlide.target - this.x) *
                        this.options.selectedAttraction;
                      this.applyForce(t);
                    }
                  },
                };
                return i;
              })(0, t);
            }.apply(e, n)) || (t.exports = s);
      },
      229: (t, e, i) => {
        var n, s;
        window,
          (n = [i(131)]),
          void 0 ===
            (s = function (t) {
              return (function (t, e) {
                "use strict";
                function i(t, e) {
                  (this.element = t), (this.parent = e), this.create();
                }
                var n = i.prototype;
                return (
                  (n.create = function () {
                    (this.element.style.position = "absolute"),
                      this.element.setAttribute("aria-hidden", "true"),
                      (this.x = 0),
                      (this.shift = 0);
                  }),
                  (n.destroy = function () {
                    this.unselect(), (this.element.style.position = "");
                    var t = this.parent.originSide;
                    this.element.style[t] = "";
                  }),
                  (n.getSize = function () {
                    this.size = e(this.element);
                  }),
                  (n.setPosition = function (t) {
                    (this.x = t), this.updateTarget(), this.renderPosition(t);
                  }),
                  (n.updateTarget = n.setDefaultTarget =
                    function () {
                      var t =
                        "left" == this.parent.originSide
                          ? "marginLeft"
                          : "marginRight";
                      this.target =
                        this.x +
                        this.size[t] +
                        this.size.width * this.parent.cellAlign;
                    }),
                  (n.renderPosition = function (t) {
                    var e = this.parent.originSide;
                    this.element.style[e] = this.parent.getPositionValue(t);
                  }),
                  (n.select = function () {
                    this.element.classList.add("is-selected"),
                      this.element.removeAttribute("aria-hidden");
                  }),
                  (n.unselect = function () {
                    this.element.classList.remove("is-selected"),
                      this.element.setAttribute("aria-hidden", "true");
                  }),
                  (n.wrapShift = function (t) {
                    (this.shift = t),
                      this.renderPosition(
                        this.x + this.parent.slideableWidth * t
                      );
                  }),
                  (n.remove = function () {
                    this.element.parentNode.removeChild(this.element);
                  }),
                  i
                );
              })(0, t);
            }.apply(e, n)) || (t.exports = s);
      },
      690: (t, e, i) => {
        var n, s;
        !(function (o, r) {
          (n = [i(217), i(842), i(47)]),
            (s = function (t, e, i) {
              return (function (t, e, i, n) {
                "use strict";
                n.extend(e.defaults, { draggable: ">1", dragThreshold: 3 }),
                  e.createMethods.push("_createDrag");
                var s = e.prototype;
                n.extend(s, i.prototype), (s._touchActionValue = "pan-y");
                var o = "createTouch" in document,
                  r = !1;
                (s._createDrag = function () {
                  this.on("activate", this.onActivateDrag),
                    this.on("uiChange", this._uiChangeDrag),
                    this.on("deactivate", this.onDeactivateDrag),
                    this.on("cellChange", this.updateDraggable),
                    o &&
                      !r &&
                      (t.addEventListener("touchmove", function () {}),
                      (r = !0));
                }),
                  (s.onActivateDrag = function () {
                    (this.handles = [this.viewport]),
                      this.bindHandles(),
                      this.updateDraggable();
                  }),
                  (s.onDeactivateDrag = function () {
                    this.unbindHandles(),
                      this.element.classList.remove("is-draggable");
                  }),
                  (s.updateDraggable = function () {
                    ">1" == this.options.draggable
                      ? (this.isDraggable = this.slides.length > 1)
                      : (this.isDraggable = this.options.draggable),
                      this.isDraggable
                        ? this.element.classList.add("is-draggable")
                        : this.element.classList.remove("is-draggable");
                  }),
                  (s.bindDrag = function () {
                    (this.options.draggable = !0), this.updateDraggable();
                  }),
                  (s.unbindDrag = function () {
                    (this.options.draggable = !1), this.updateDraggable();
                  }),
                  (s._uiChangeDrag = function () {
                    delete this.isFreeScrolling;
                  }),
                  (s.pointerDown = function (e, i) {
                    this.isDraggable
                      ? this.okayPointerDown(e) &&
                        (this._pointerDownPreventDefault(e),
                        this.pointerDownFocus(e),
                        document.activeElement != this.element &&
                          this.pointerDownBlur(),
                        (this.dragX = this.x),
                        this.viewport.classList.add("is-pointer-down"),
                        (this.pointerDownScroll = l()),
                        t.addEventListener("scroll", this),
                        this._pointerDownDefault(e, i))
                      : this._pointerDownDefault(e, i);
                  }),
                  (s._pointerDownDefault = function (t, e) {
                    (this.pointerDownPointer = {
                      pageX: e.pageX,
                      pageY: e.pageY,
                    }),
                      this._bindPostStartEvents(t),
                      this.dispatchEvent("pointerDown", t, [e]);
                  });
                var a = { INPUT: !0, TEXTAREA: !0, SELECT: !0 };
                function l() {
                  return { x: t.pageXOffset, y: t.pageYOffset };
                }
                return (
                  (s.pointerDownFocus = function (t) {
                    a[t.target.nodeName] || this.focus();
                  }),
                  (s._pointerDownPreventDefault = function (t) {
                    var e = "touchstart" == t.type,
                      i = "touch" == t.pointerType,
                      n = a[t.target.nodeName];
                    e || i || n || t.preventDefault();
                  }),
                  (s.hasDragStarted = function (t) {
                    return Math.abs(t.x) > this.options.dragThreshold;
                  }),
                  (s.pointerUp = function (t, e) {
                    delete this.isTouchScrolling,
                      this.viewport.classList.remove("is-pointer-down"),
                      this.dispatchEvent("pointerUp", t, [e]),
                      this._dragPointerUp(t, e);
                  }),
                  (s.pointerDone = function () {
                    t.removeEventListener("scroll", this),
                      delete this.pointerDownScroll;
                  }),
                  (s.dragStart = function (e, i) {
                    this.isDraggable &&
                      ((this.dragStartPosition = this.x),
                      this.startAnimation(),
                      t.removeEventListener("scroll", this),
                      this.dispatchEvent("dragStart", e, [i]));
                  }),
                  (s.pointerMove = function (t, e) {
                    var i = this._dragPointerMove(t, e);
                    this.dispatchEvent("pointerMove", t, [e, i]),
                      this._dragMove(t, e, i);
                  }),
                  (s.dragMove = function (t, e, i) {
                    if (this.isDraggable) {
                      t.preventDefault(), (this.previousDragX = this.dragX);
                      var n = this.options.rightToLeft ? -1 : 1;
                      this.options.wrapAround &&
                        (i.x = i.x % this.slideableWidth);
                      var s = this.dragStartPosition + i.x * n;
                      if (!this.options.wrapAround && this.slides.length) {
                        var o = Math.max(
                          -this.slides[0].target,
                          this.dragStartPosition
                        );
                        s = s > o ? 0.5 * (s + o) : s;
                        var r = Math.min(
                          -this.getLastSlide().target,
                          this.dragStartPosition
                        );
                        s = s < r ? 0.5 * (s + r) : s;
                      }
                      (this.dragX = s),
                        (this.dragMoveTime = new Date()),
                        this.dispatchEvent("dragMove", t, [e, i]);
                    }
                  }),
                  (s.dragEnd = function (t, e) {
                    if (this.isDraggable) {
                      this.options.freeScroll && (this.isFreeScrolling = !0);
                      var i = this.dragEndRestingSelect();
                      if (this.options.freeScroll && !this.options.wrapAround) {
                        var n = this.getRestingPosition();
                        this.isFreeScrolling =
                          -n > this.slides[0].target &&
                          -n < this.getLastSlide().target;
                      } else
                        this.options.freeScroll ||
                          i != this.selectedIndex ||
                          (i += this.dragEndBoostSelect());
                      delete this.previousDragX,
                        (this.isDragSelect = this.options.wrapAround),
                        this.select(i),
                        delete this.isDragSelect,
                        this.dispatchEvent("dragEnd", t, [e]);
                    }
                  }),
                  (s.dragEndRestingSelect = function () {
                    var t = this.getRestingPosition(),
                      e = Math.abs(
                        this.getSlideDistance(-t, this.selectedIndex)
                      ),
                      i = this._getClosestResting(t, e, 1),
                      n = this._getClosestResting(t, e, -1);
                    return i.distance < n.distance ? i.index : n.index;
                  }),
                  (s._getClosestResting = function (t, e, i) {
                    for (
                      var n = this.selectedIndex,
                        s = 1 / 0,
                        o =
                          this.options.contain && !this.options.wrapAround
                            ? function (t, e) {
                                return t <= e;
                              }
                            : function (t, e) {
                                return t < e;
                              };
                      o(e, s) &&
                      ((n += i),
                      (s = e),
                      null !== (e = this.getSlideDistance(-t, n)));

                    )
                      e = Math.abs(e);
                    return { distance: s, index: n - i };
                  }),
                  (s.getSlideDistance = function (t, e) {
                    var i = this.slides.length,
                      s = this.options.wrapAround && i > 1,
                      o = s ? n.modulo(e, i) : e,
                      r = this.slides[o];
                    if (!r) return null;
                    var a = s ? this.slideableWidth * Math.floor(e / i) : 0;
                    return t - (r.target + a);
                  }),
                  (s.dragEndBoostSelect = function () {
                    if (
                      void 0 === this.previousDragX ||
                      !this.dragMoveTime ||
                      new Date() - this.dragMoveTime > 100
                    )
                      return 0;
                    var t = this.getSlideDistance(
                        -this.dragX,
                        this.selectedIndex
                      ),
                      e = this.previousDragX - this.dragX;
                    return t > 0 && e > 0 ? 1 : t < 0 && e < 0 ? -1 : 0;
                  }),
                  (s.staticClick = function (t, e) {
                    var i = this.getParentCell(t.target),
                      n = i && i.element,
                      s = i && this.cells.indexOf(i);
                    this.dispatchEvent("staticClick", t, [e, n, s]);
                  }),
                  (s.onscroll = function () {
                    var t = l(),
                      e = this.pointerDownScroll.x - t.x,
                      i = this.pointerDownScroll.y - t.y;
                    (Math.abs(e) > 3 || Math.abs(i) > 3) && this._pointerDone();
                  }),
                  e
                );
              })(o, t, e, i);
            }.apply(e, n)),
            void 0 === s || (t.exports = s);
        })(window);
      },
      217: (t, e, i) => {
        var n, s;
        !(function (o, r) {
          (n = [i(158), i(131), i(47), i(229), i(714), i(880)]),
            (s = function (t, e, i, n, s, r) {
              return (function (t, e, i, n, s, o, r) {
                "use strict";
                var a = t.jQuery,
                  l = t.getComputedStyle,
                  c = t.console;
                function h(t, e) {
                  for (t = n.makeArray(t); t.length; ) e.appendChild(t.shift());
                }
                var d = 0,
                  u = {};
                function p(t, e) {
                  var i = n.getQueryElement(t);
                  if (i) {
                    if (((this.element = i), this.element.flickityGUID)) {
                      var s = u[this.element.flickityGUID];
                      return s.option(e), s;
                    }
                    a && (this.$element = a(this.element)),
                      (this.options = n.extend({}, this.constructor.defaults)),
                      this.option(e),
                      this._create();
                  } else c && c.error("Bad element for Flickity: " + (i || t));
                }
                (p.defaults = {
                  accessibility: !0,
                  cellAlign: "center",
                  freeScrollFriction: 0.075,
                  friction: 0.28,
                  namespaceJQueryEvents: !0,
                  percentPosition: !0,
                  resize: !0,
                  selectedAttraction: 0.025,
                  setGallerySize: !0,
                }),
                  (p.createMethods = []);
                var f = p.prototype;
                n.extend(f, e.prototype),
                  (f._create = function () {
                    var e = (this.guid = ++d);
                    for (var i in ((this.element.flickityGUID = e),
                    (u[e] = this),
                    (this.selectedIndex = 0),
                    (this.restingFrames = 0),
                    (this.x = 0),
                    (this.velocity = 0),
                    (this.originSide = this.options.rightToLeft
                      ? "right"
                      : "left"),
                    (this.viewport = document.createElement("div")),
                    (this.viewport.className = "flickity-viewport"),
                    this._createSlider(),
                    (this.options.resize || this.options.watchCSS) &&
                      t.addEventListener("resize", this),
                    this.options.on)) {
                      var n = this.options.on[i];
                      this.on(i, n);
                    }
                    p.createMethods.forEach(function (t) {
                      this[t]();
                    }, this),
                      this.options.watchCSS ? this.watchCSS() : this.activate();
                  }),
                  (f.option = function (t) {
                    n.extend(this.options, t);
                  }),
                  (f.activate = function () {
                    this.isActive ||
                      ((this.isActive = !0),
                      this.element.classList.add("flickity-enabled"),
                      this.options.rightToLeft &&
                        this.element.classList.add("flickity-rtl"),
                      this.getSize(),
                      h(
                        this._filterFindCellElements(this.element.children),
                        this.slider
                      ),
                      this.viewport.appendChild(this.slider),
                      this.element.appendChild(this.viewport),
                      this.reloadCells(),
                      this.options.accessibility &&
                        ((this.element.tabIndex = 0),
                        this.element.addEventListener("keydown", this)),
                      this.emitEvent("activate"),
                      this.selectInitialIndex(),
                      (this.isInitActivated = !0),
                      this.dispatchEvent("ready"));
                  }),
                  (f._createSlider = function () {
                    var t = document.createElement("div");
                    (t.className = "flickity-slider"),
                      (t.style[this.originSide] = 0),
                      (this.slider = t);
                  }),
                  (f._filterFindCellElements = function (t) {
                    return n.filterFindElements(t, this.options.cellSelector);
                  }),
                  (f.reloadCells = function () {
                    (this.cells = this._makeCells(this.slider.children)),
                      this.positionCells(),
                      this._getWrapShiftCells(),
                      this.setGallerySize();
                  }),
                  (f._makeCells = function (t) {
                    return this._filterFindCellElements(t).map(function (t) {
                      return new s(t, this);
                    }, this);
                  }),
                  (f.getLastCell = function () {
                    return this.cells[this.cells.length - 1];
                  }),
                  (f.getLastSlide = function () {
                    return this.slides[this.slides.length - 1];
                  }),
                  (f.positionCells = function () {
                    this._sizeCells(this.cells), this._positionCells(0);
                  }),
                  (f._positionCells = function (t) {
                    (t = t || 0),
                      (this.maxCellHeight = (t && this.maxCellHeight) || 0);
                    var e = 0;
                    if (t > 0) {
                      var i = this.cells[t - 1];
                      e = i.x + i.size.outerWidth;
                    }
                    for (var n = this.cells.length, s = t; s < n; s++) {
                      var o = this.cells[s];
                      o.setPosition(e),
                        (e += o.size.outerWidth),
                        (this.maxCellHeight = Math.max(
                          o.size.outerHeight,
                          this.maxCellHeight
                        ));
                    }
                    (this.slideableWidth = e),
                      this.updateSlides(),
                      this._containSlides(),
                      (this.slidesWidth = n
                        ? this.getLastSlide().target - this.slides[0].target
                        : 0);
                  }),
                  (f._sizeCells = function (t) {
                    t.forEach(function (t) {
                      t.getSize();
                    });
                  }),
                  (f.updateSlides = function () {
                    if (((this.slides = []), this.cells.length)) {
                      var t = new o(this);
                      this.slides.push(t);
                      var e =
                          "left" == this.originSide
                            ? "marginRight"
                            : "marginLeft",
                        i = this._getCanCellFit();
                      this.cells.forEach(function (n, s) {
                        if (t.cells.length) {
                          var r =
                            t.outerWidth -
                            t.firstMargin +
                            (n.size.outerWidth - n.size[e]);
                          i.call(this, s, r) ||
                            (t.updateTarget(),
                            (t = new o(this)),
                            this.slides.push(t)),
                            t.addCell(n);
                        } else t.addCell(n);
                      }, this),
                        t.updateTarget(),
                        this.updateSelectedSlide();
                    }
                  }),
                  (f._getCanCellFit = function () {
                    var t = this.options.groupCells;
                    if (!t)
                      return function () {
                        return !1;
                      };
                    if ("number" == typeof t) {
                      var e = parseInt(t, 10);
                      return function (t) {
                        return t % e != 0;
                      };
                    }
                    var i = "string" == typeof t && t.match(/^(\d+)%$/),
                      n = i ? parseInt(i[1], 10) / 100 : 1;
                    return function (t, e) {
                      return e <= (this.size.innerWidth + 1) * n;
                    };
                  }),
                  (f._init = f.reposition =
                    function () {
                      this.positionCells(), this.positionSliderAtSelected();
                    }),
                  (f.getSize = function () {
                    (this.size = i(this.element)),
                      this.setCellAlign(),
                      (this.cursorPosition =
                        this.size.innerWidth * this.cellAlign);
                  });
                var m = {
                  center: { left: 0.5, right: 0.5 },
                  left: { left: 0, right: 1 },
                  right: { right: 0, left: 1 },
                };
                (f.setCellAlign = function () {
                  var t = m[this.options.cellAlign];
                  this.cellAlign = t
                    ? t[this.originSide]
                    : this.options.cellAlign;
                }),
                  (f.setGallerySize = function () {
                    if (this.options.setGallerySize) {
                      var t =
                        this.options.adaptiveHeight && this.selectedSlide
                          ? this.selectedSlide.height
                          : this.maxCellHeight;
                      this.viewport.style.height = t + "px";
                    }
                  }),
                  (f._getWrapShiftCells = function () {
                    if (this.options.wrapAround) {
                      this._unshiftCells(this.beforeShiftCells),
                        this._unshiftCells(this.afterShiftCells);
                      var t = this.cursorPosition,
                        e = this.cells.length - 1;
                      (this.beforeShiftCells = this._getGapCells(t, e, -1)),
                        (t = this.size.innerWidth - this.cursorPosition),
                        (this.afterShiftCells = this._getGapCells(t, 0, 1));
                    }
                  }),
                  (f._getGapCells = function (t, e, i) {
                    for (var n = []; t > 0; ) {
                      var s = this.cells[e];
                      if (!s) break;
                      n.push(s), (e += i), (t -= s.size.outerWidth);
                    }
                    return n;
                  }),
                  (f._containSlides = function () {
                    if (
                      this.options.contain &&
                      !this.options.wrapAround &&
                      this.cells.length
                    ) {
                      var t = this.options.rightToLeft,
                        e = t ? "marginRight" : "marginLeft",
                        i = t ? "marginLeft" : "marginRight",
                        n = this.slideableWidth - this.getLastCell().size[i],
                        s = n < this.size.innerWidth,
                        o = this.cursorPosition + this.cells[0].size[e],
                        r = n - this.size.innerWidth * (1 - this.cellAlign);
                      this.slides.forEach(function (t) {
                        s
                          ? (t.target = n * this.cellAlign)
                          : ((t.target = Math.max(t.target, o)),
                            (t.target = Math.min(t.target, r)));
                      }, this);
                    }
                  }),
                  (f.dispatchEvent = function (t, e, i) {
                    var n = e ? [e].concat(i) : i;
                    if ((this.emitEvent(t, n), a && this.$element)) {
                      var s = (t += this.options.namespaceJQueryEvents
                        ? ".flickity"
                        : "");
                      if (e) {
                        var o = a.Event(e);
                        (o.type = t), (s = o);
                      }
                      this.$element.trigger(s, i);
                    }
                  }),
                  (f.select = function (t, e, i) {
                    if (
                      this.isActive &&
                      ((t = parseInt(t, 10)),
                      this._wrapSelect(t),
                      (this.options.wrapAround || e) &&
                        (t = n.modulo(t, this.slides.length)),
                      this.slides[t])
                    ) {
                      var s = this.selectedIndex;
                      (this.selectedIndex = t),
                        this.updateSelectedSlide(),
                        i
                          ? this.positionSliderAtSelected()
                          : this.startAnimation(),
                        this.options.adaptiveHeight && this.setGallerySize(),
                        this.dispatchEvent("select", null, [t]),
                        t != s && this.dispatchEvent("change", null, [t]),
                        this.dispatchEvent("cellSelect");
                    }
                  }),
                  (f._wrapSelect = function (t) {
                    var e = this.slides.length;
                    if (!(this.options.wrapAround && e > 1)) return t;
                    var i = n.modulo(t, e),
                      s = Math.abs(i - this.selectedIndex),
                      o = Math.abs(i + e - this.selectedIndex),
                      r = Math.abs(i - e - this.selectedIndex);
                    !this.isDragSelect && o < s
                      ? (t += e)
                      : !this.isDragSelect && r < s && (t -= e),
                      t < 0
                        ? (this.x -= this.slideableWidth)
                        : t >= e && (this.x += this.slideableWidth);
                  }),
                  (f.previous = function (t, e) {
                    this.select(this.selectedIndex - 1, t, e);
                  }),
                  (f.next = function (t, e) {
                    this.select(this.selectedIndex + 1, t, e);
                  }),
                  (f.updateSelectedSlide = function () {
                    var t = this.slides[this.selectedIndex];
                    t &&
                      (this.unselectSelectedSlide(),
                      (this.selectedSlide = t),
                      t.select(),
                      (this.selectedCells = t.cells),
                      (this.selectedElements = t.getCellElements()),
                      (this.selectedCell = t.cells[0]),
                      (this.selectedElement = this.selectedElements[0]));
                  }),
                  (f.unselectSelectedSlide = function () {
                    this.selectedSlide && this.selectedSlide.unselect();
                  }),
                  (f.selectInitialIndex = function () {
                    var t = this.options.initialIndex;
                    if (this.isInitActivated)
                      this.select(this.selectedIndex, !1, !0);
                    else {
                      if (t && "string" == typeof t)
                        if (this.queryCell(t))
                          return void this.selectCell(t, !1, !0);
                      var e = 0;
                      t && this.slides[t] && (e = t), this.select(e, !1, !0);
                    }
                  }),
                  (f.selectCell = function (t, e, i) {
                    var n = this.queryCell(t);
                    if (n) {
                      var s = this.getCellSlideIndex(n);
                      this.select(s, e, i);
                    }
                  }),
                  (f.getCellSlideIndex = function (t) {
                    for (var e = 0; e < this.slides.length; e++) {
                      if (-1 != this.slides[e].cells.indexOf(t)) return e;
                    }
                  }),
                  (f.getCell = function (t) {
                    for (var e = 0; e < this.cells.length; e++) {
                      var i = this.cells[e];
                      if (i.element == t) return i;
                    }
                  }),
                  (f.getCells = function (t) {
                    t = n.makeArray(t);
                    var e = [];
                    return (
                      t.forEach(function (t) {
                        var i = this.getCell(t);
                        i && e.push(i);
                      }, this),
                      e
                    );
                  }),
                  (f.getCellElements = function () {
                    return this.cells.map(function (t) {
                      return t.element;
                    });
                  }),
                  (f.getParentCell = function (t) {
                    var e = this.getCell(t);
                    return (
                      e ||
                      ((t = n.getParent(t, ".flickity-slider > *")),
                      this.getCell(t))
                    );
                  }),
                  (f.getAdjacentCellElements = function (t, e) {
                    if (!t) return this.selectedSlide.getCellElements();
                    e = void 0 === e ? this.selectedIndex : e;
                    var i = this.slides.length;
                    if (1 + 2 * t >= i) return this.getCellElements();
                    for (var s = [], o = e - t; o <= e + t; o++) {
                      var r = this.options.wrapAround ? n.modulo(o, i) : o,
                        a = this.slides[r];
                      a && (s = s.concat(a.getCellElements()));
                    }
                    return s;
                  }),
                  (f.queryCell = function (t) {
                    if ("number" == typeof t) return this.cells[t];
                    if ("string" == typeof t) {
                      if (t.match(/^[#\.]?[\d\/]/)) return;
                      t = this.element.querySelector(t);
                    }
                    return this.getCell(t);
                  }),
                  (f.uiChange = function () {
                    this.emitEvent("uiChange");
                  }),
                  (f.childUIPointerDown = function (t) {
                    "touchstart" != t.type && t.preventDefault(), this.focus();
                  }),
                  (f.onresize = function () {
                    this.watchCSS(), this.resize();
                  }),
                  n.debounceMethod(p, "onresize", 150),
                  (f.resize = function () {
                    if (this.isActive) {
                      this.getSize(),
                        this.options.wrapAround &&
                          (this.x = n.modulo(this.x, this.slideableWidth)),
                        this.positionCells(),
                        this._getWrapShiftCells(),
                        this.setGallerySize(),
                        this.emitEvent("resize");
                      var t = this.selectedElements && this.selectedElements[0];
                      this.selectCell(t, !1, !0);
                    }
                  }),
                  (f.watchCSS = function () {
                    this.options.watchCSS &&
                      (-1 !=
                      l(this.element, ":after").content.indexOf("flickity")
                        ? this.activate()
                        : this.deactivate());
                  }),
                  (f.onkeydown = function (t) {
                    var e =
                      document.activeElement &&
                      document.activeElement != this.element;
                    if (this.options.accessibility && !e) {
                      var i = p.keyboardHandlers[t.keyCode];
                      i && i.call(this);
                    }
                  }),
                  (p.keyboardHandlers = {
                    37: function () {
                      var t = this.options.rightToLeft ? "next" : "previous";
                      this.uiChange(), this[t]();
                    },
                    39: function () {
                      var t = this.options.rightToLeft ? "previous" : "next";
                      this.uiChange(), this[t]();
                    },
                  }),
                  (f.focus = function () {
                    var e = t.pageYOffset;
                    this.element.focus({ preventScroll: !0 }),
                      t.pageYOffset != e && t.scrollTo(t.pageXOffset, e);
                  }),
                  (f.deactivate = function () {
                    this.isActive &&
                      (this.element.classList.remove("flickity-enabled"),
                      this.element.classList.remove("flickity-rtl"),
                      this.unselectSelectedSlide(),
                      this.cells.forEach(function (t) {
                        t.destroy();
                      }),
                      this.element.removeChild(this.viewport),
                      h(this.slider.children, this.element),
                      this.options.accessibility &&
                        (this.element.removeAttribute("tabIndex"),
                        this.element.removeEventListener("keydown", this)),
                      (this.isActive = !1),
                      this.emitEvent("deactivate"));
                  }),
                  (f.destroy = function () {
                    this.deactivate(),
                      t.removeEventListener("resize", this),
                      this.allOff(),
                      this.emitEvent("destroy"),
                      a &&
                        this.$element &&
                        a.removeData(this.element, "flickity"),
                      delete this.element.flickityGUID,
                      delete u[this.guid];
                  }),
                  n.extend(f, r),
                  (p.data = function (t) {
                    var e = (t = n.getQueryElement(t)) && t.flickityGUID;
                    return e && u[e];
                  }),
                  n.htmlInit(p, "flickity"),
                  a && a.bridget && a.bridget("flickity", p);
                return (
                  (p.setJQuery = function (t) {
                    a = t;
                  }),
                  (p.Cell = s),
                  (p.Slide = o),
                  p
                );
              })(o, t, e, i, n, s, r);
            }.apply(e, n)),
            void 0 === s || (t.exports = s);
        })(window);
      },
      442: (t, e, i) => {
        var n, s, o;
        /*!
         * Flickity v2.2.0
         * Touch, responsive, flickable carousels
         *
         * Licensed GPLv3 for open source use
         * or Flickity Commercial License for commercial use
         *
         * https://flickity.metafizzy.co
         * Copyright 2015-2018 Metafizzy
         */ window,
          (s = [i(217), i(690), i(410), i(573), i(516), i(597), i(227)]),
          void 0 ===
            (o =
              "function" ==
              typeof (n = function (t) {
                return t;
              })
                ? n.apply(e, s)
                : n) || (t.exports = o);
      },
      227: (t, e, i) => {
        var n, s;
        window,
          (n = [i(217), i(47)]),
          void 0 ===
            (s = function (t, e) {
              return (function (t, e, i) {
                "use strict";
                e.createMethods.push("_createLazyload");
                var n = e.prototype;
                function s(t) {
                  if ("IMG" == t.nodeName) {
                    var e = t.getAttribute("data-flickity-lazyload"),
                      n = t.getAttribute("data-flickity-lazyload-src"),
                      s = t.getAttribute("data-flickity-lazyload-srcset");
                    if (e || n || s) return [t];
                  }
                  var o =
                      "img[data-flickity-lazyload], img[data-flickity-lazyload-src], img[data-flickity-lazyload-srcset]",
                    r = t.querySelectorAll(o);
                  return i.makeArray(r);
                }
                function o(t, e) {
                  (this.img = t), (this.flickity = e), this.load();
                }
                return (
                  (n._createLazyload = function () {
                    this.on("select", this.lazyLoad);
                  }),
                  (n.lazyLoad = function () {
                    var t = this.options.lazyLoad;
                    if (t) {
                      var e = "number" == typeof t ? t : 0,
                        i = this.getAdjacentCellElements(e),
                        n = [];
                      i.forEach(function (t) {
                        var e = s(t);
                        n = n.concat(e);
                      }),
                        n.forEach(function (t) {
                          new o(t, this);
                        }, this);
                    }
                  }),
                  (o.prototype.handleEvent = i.handleEvent),
                  (o.prototype.load = function () {
                    this.img.addEventListener("load", this),
                      this.img.addEventListener("error", this);
                    var t =
                        this.img.getAttribute("data-flickity-lazyload") ||
                        this.img.getAttribute("data-flickity-lazyload-src"),
                      e = this.img.getAttribute(
                        "data-flickity-lazyload-srcset"
                      );
                    (this.img.src = t),
                      e && this.img.setAttribute("srcset", e),
                      this.img.removeAttribute("data-flickity-lazyload"),
                      this.img.removeAttribute("data-flickity-lazyload-src"),
                      this.img.removeAttribute("data-flickity-lazyload-srcset");
                  }),
                  (o.prototype.onload = function (t) {
                    this.complete(t, "flickity-lazyloaded");
                  }),
                  (o.prototype.onerror = function (t) {
                    this.complete(t, "flickity-lazyerror");
                  }),
                  (o.prototype.complete = function (t, e) {
                    this.img.removeEventListener("load", this),
                      this.img.removeEventListener("error", this);
                    var i = this.flickity.getParentCell(this.img),
                      n = i && i.element;
                    this.flickity.cellSizeChange(n),
                      this.img.classList.add(e),
                      this.flickity.dispatchEvent("lazyLoad", t, n);
                  }),
                  (e.LazyLoader = o),
                  e
                );
              })(0, t, e);
            }.apply(e, n)) || (t.exports = s);
      },
      573: (t, e, i) => {
        var n, s;
        window,
          (n = [i(217), i(704), i(47)]),
          void 0 ===
            (s = function (t, e, i) {
              return (function (t, e, i, n) {
                "use strict";
                function s(t) {
                  (this.parent = t), this._create();
                }
                (s.prototype = Object.create(i.prototype)),
                  (s.prototype._create = function () {
                    (this.holder = document.createElement("ol")),
                      (this.holder.className = "flickity-page-dots"),
                      (this.dots = []),
                      (this.handleClick = this.onClick.bind(this)),
                      this.on(
                        "pointerDown",
                        this.parent.childUIPointerDown.bind(this.parent)
                      );
                  }),
                  (s.prototype.activate = function () {
                    this.setDots(),
                      this.holder.addEventListener("click", this.handleClick),
                      this.bindStartEvent(this.holder),
                      this.parent.element.appendChild(this.holder);
                  }),
                  (s.prototype.deactivate = function () {
                    this.holder.removeEventListener("click", this.handleClick),
                      this.unbindStartEvent(this.holder),
                      this.parent.element.removeChild(this.holder);
                  }),
                  (s.prototype.setDots = function () {
                    var t = this.parent.slides.length - this.dots.length;
                    t > 0 ? this.addDots(t) : t < 0 && this.removeDots(-t);
                  }),
                  (s.prototype.addDots = function (t) {
                    for (
                      var e = document.createDocumentFragment(),
                        i = [],
                        n = this.dots.length,
                        s = n + t,
                        o = n;
                      o < s;
                      o++
                    ) {
                      var r = document.createElement("li");
                      (r.className = "dot"),
                        r.setAttribute("aria-label", "Page dot " + (o + 1)),
                        e.appendChild(r),
                        i.push(r);
                    }
                    this.holder.appendChild(e),
                      (this.dots = this.dots.concat(i));
                  }),
                  (s.prototype.removeDots = function (t) {
                    this.dots
                      .splice(this.dots.length - t, t)
                      .forEach(function (t) {
                        this.holder.removeChild(t);
                      }, this);
                  }),
                  (s.prototype.updateSelected = function () {
                    this.selectedDot &&
                      ((this.selectedDot.className = "dot"),
                      this.selectedDot.removeAttribute("aria-current")),
                      this.dots.length &&
                        ((this.selectedDot =
                          this.dots[this.parent.selectedIndex]),
                        (this.selectedDot.className = "dot is-selected"),
                        this.selectedDot.setAttribute("aria-current", "step"));
                  }),
                  (s.prototype.onTap = s.prototype.onClick =
                    function (t) {
                      var e = t.target;
                      if ("LI" == e.nodeName) {
                        this.parent.uiChange();
                        var i = this.dots.indexOf(e);
                        this.parent.select(i);
                      }
                    }),
                  (s.prototype.destroy = function () {
                    this.deactivate(), this.allOff();
                  }),
                  (e.PageDots = s),
                  n.extend(e.defaults, { pageDots: !0 }),
                  e.createMethods.push("_createPageDots");
                var o = e.prototype;
                return (
                  (o._createPageDots = function () {
                    this.options.pageDots &&
                      ((this.pageDots = new s(this)),
                      this.on("activate", this.activatePageDots),
                      this.on("select", this.updateSelectedPageDots),
                      this.on("cellChange", this.updatePageDots),
                      this.on("resize", this.updatePageDots),
                      this.on("deactivate", this.deactivatePageDots));
                  }),
                  (o.activatePageDots = function () {
                    this.pageDots.activate();
                  }),
                  (o.updateSelectedPageDots = function () {
                    this.pageDots.updateSelected();
                  }),
                  (o.updatePageDots = function () {
                    this.pageDots.setDots();
                  }),
                  (o.deactivatePageDots = function () {
                    this.pageDots.deactivate();
                  }),
                  (e.PageDots = s),
                  e
                );
              })(0, t, e, i);
            }.apply(e, n)) || (t.exports = s);
      },
      516: (t, e, i) => {
        var n, s;
        window,
          (n = [i(158), i(47), i(217)]),
          void 0 ===
            (s = function (t, e, i) {
              return (function (t, e, i) {
                "use strict";
                function n(t) {
                  (this.parent = t),
                    (this.state = "stopped"),
                    (this.onVisibilityChange =
                      this.visibilityChange.bind(this)),
                    (this.onVisibilityPlay = this.visibilityPlay.bind(this));
                }
                (n.prototype = Object.create(t.prototype)),
                  (n.prototype.play = function () {
                    "playing" != this.state &&
                      (document.hidden
                        ? document.addEventListener(
                            "visibilitychange",
                            this.onVisibilityPlay
                          )
                        : ((this.state = "playing"),
                          document.addEventListener(
                            "visibilitychange",
                            this.onVisibilityChange
                          ),
                          this.tick()));
                  }),
                  (n.prototype.tick = function () {
                    if ("playing" == this.state) {
                      var t = this.parent.options.autoPlay;
                      t = "number" == typeof t ? t : 3e3;
                      var e = this;
                      this.clear(),
                        (this.timeout = setTimeout(function () {
                          e.parent.next(!0), e.tick();
                        }, t));
                    }
                  }),
                  (n.prototype.stop = function () {
                    (this.state = "stopped"),
                      this.clear(),
                      document.removeEventListener(
                        "visibilitychange",
                        this.onVisibilityChange
                      );
                  }),
                  (n.prototype.clear = function () {
                    clearTimeout(this.timeout);
                  }),
                  (n.prototype.pause = function () {
                    "playing" == this.state &&
                      ((this.state = "paused"), this.clear());
                  }),
                  (n.prototype.unpause = function () {
                    "paused" == this.state && this.play();
                  }),
                  (n.prototype.visibilityChange = function () {
                    this[document.hidden ? "pause" : "unpause"]();
                  }),
                  (n.prototype.visibilityPlay = function () {
                    this.play(),
                      document.removeEventListener(
                        "visibilitychange",
                        this.onVisibilityPlay
                      );
                  }),
                  e.extend(i.defaults, { pauseAutoPlayOnHover: !0 }),
                  i.createMethods.push("_createPlayer");
                var s = i.prototype;
                return (
                  (s._createPlayer = function () {
                    (this.player = new n(this)),
                      this.on("activate", this.activatePlayer),
                      this.on("uiChange", this.stopPlayer),
                      this.on("pointerDown", this.stopPlayer),
                      this.on("deactivate", this.deactivatePlayer);
                  }),
                  (s.activatePlayer = function () {
                    this.options.autoPlay &&
                      (this.player.play(),
                      this.element.addEventListener("mouseenter", this));
                  }),
                  (s.playPlayer = function () {
                    this.player.play();
                  }),
                  (s.stopPlayer = function () {
                    this.player.stop();
                  }),
                  (s.pausePlayer = function () {
                    this.player.pause();
                  }),
                  (s.unpausePlayer = function () {
                    this.player.unpause();
                  }),
                  (s.deactivatePlayer = function () {
                    this.player.stop(),
                      this.element.removeEventListener("mouseenter", this);
                  }),
                  (s.onmouseenter = function () {
                    this.options.pauseAutoPlayOnHover &&
                      (this.player.pause(),
                      this.element.addEventListener("mouseleave", this));
                  }),
                  (s.onmouseleave = function () {
                    this.player.unpause(),
                      this.element.removeEventListener("mouseleave", this);
                  }),
                  (i.Player = n),
                  i
                );
              })(t, e, i);
            }.apply(e, n)) || (t.exports = s);
      },
      410: (t, e, i) => {
        var n, s;
        window,
          (n = [i(217), i(704), i(47)]),
          void 0 ===
            (s = function (t, e, i) {
              return (function (t, e, i, n) {
                "use strict";
                var s = "http://www.w3.org/2000/svg";
                function o(t, e) {
                  (this.direction = t), (this.parent = e), this._create();
                }
                function r(t) {
                  return "string" == typeof t
                    ? t
                    : "M " +
                        t.x0 +
                        ",50 L " +
                        t.x1 +
                        "," +
                        (t.y1 + 50) +
                        " L " +
                        t.x2 +
                        "," +
                        (t.y2 + 50) +
                        " L " +
                        t.x3 +
                        ",50  L " +
                        t.x2 +
                        "," +
                        (50 - t.y2) +
                        " L " +
                        t.x1 +
                        "," +
                        (50 - t.y1) +
                        " Z";
                }
                (o.prototype = Object.create(i.prototype)),
                  (o.prototype._create = function () {
                    (this.isEnabled = !0),
                      (this.isPrevious = -1 == this.direction);
                    var t = this.parent.options.rightToLeft ? 1 : -1;
                    this.isLeft = this.direction == t;
                    var e = (this.element = document.createElement("button"));
                    (e.className = "flickity-button flickity-prev-next-button"),
                      (e.className += this.isPrevious ? " previous" : " next"),
                      e.setAttribute("type", "button"),
                      this.disable(),
                      e.setAttribute(
                        "aria-label",
                        this.isPrevious ? "Previous" : "Next"
                      );
                    var i = this.createSVG();
                    e.appendChild(i),
                      this.parent.on("select", this.update.bind(this)),
                      this.on(
                        "pointerDown",
                        this.parent.childUIPointerDown.bind(this.parent)
                      );
                  }),
                  (o.prototype.activate = function () {
                    this.bindStartEvent(this.element),
                      this.element.addEventListener("click", this),
                      this.parent.element.appendChild(this.element);
                  }),
                  (o.prototype.deactivate = function () {
                    this.parent.element.removeChild(this.element),
                      this.unbindStartEvent(this.element),
                      this.element.removeEventListener("click", this);
                  }),
                  (o.prototype.createSVG = function () {
                    var t = document.createElementNS(s, "svg");
                    t.setAttribute("class", "flickity-button-icon"),
                      t.setAttribute("viewBox", "0 0 100 100");
                    var e = document.createElementNS(s, "path"),
                      i = r(this.parent.options.arrowShape);
                    return (
                      e.setAttribute("d", i),
                      e.setAttribute("class", "arrow"),
                      this.isLeft ||
                        e.setAttribute(
                          "transform",
                          "translate(100, 100) rotate(180) "
                        ),
                      t.appendChild(e),
                      t
                    );
                  }),
                  (o.prototype.handleEvent = n.handleEvent),
                  (o.prototype.onclick = function () {
                    if (this.isEnabled) {
                      this.parent.uiChange();
                      var t = this.isPrevious ? "previous" : "next";
                      this.parent[t]();
                    }
                  }),
                  (o.prototype.enable = function () {
                    this.isEnabled ||
                      ((this.element.disabled = !1), (this.isEnabled = !0));
                  }),
                  (o.prototype.disable = function () {
                    this.isEnabled &&
                      ((this.element.disabled = !0), (this.isEnabled = !1));
                  }),
                  (o.prototype.update = function () {
                    var t = this.parent.slides;
                    if (this.parent.options.wrapAround && t.length > 1)
                      this.enable();
                    else {
                      var e = t.length ? t.length - 1 : 0,
                        i = this.isPrevious ? 0 : e;
                      this[
                        this.parent.selectedIndex == i ? "disable" : "enable"
                      ]();
                    }
                  }),
                  (o.prototype.destroy = function () {
                    this.deactivate(), this.allOff();
                  }),
                  n.extend(e.defaults, {
                    prevNextButtons: !0,
                    arrowShape: {
                      x0: 10,
                      x1: 60,
                      y1: 50,
                      x2: 70,
                      y2: 40,
                      x3: 30,
                    },
                  }),
                  e.createMethods.push("_createPrevNextButtons");
                var a = e.prototype;
                return (
                  (a._createPrevNextButtons = function () {
                    this.options.prevNextButtons &&
                      ((this.prevButton = new o(-1, this)),
                      (this.nextButton = new o(1, this)),
                      this.on("activate", this.activatePrevNextButtons));
                  }),
                  (a.activatePrevNextButtons = function () {
                    this.prevButton.activate(),
                      this.nextButton.activate(),
                      this.on("deactivate", this.deactivatePrevNextButtons);
                  }),
                  (a.deactivatePrevNextButtons = function () {
                    this.prevButton.deactivate(),
                      this.nextButton.deactivate(),
                      this.off("deactivate", this.deactivatePrevNextButtons);
                  }),
                  (e.PrevNextButton = o),
                  e
                );
              })(0, t, e, i);
            }.apply(e, n)) || (t.exports = s);
      },
      714: (t, e, i) => {
        var n, s;
        window,
          void 0 ===
            (s =
              "function" ==
              typeof (n = function () {
                "use strict";
                function t(t) {
                  (this.parent = t),
                    (this.isOriginLeft = "left" == t.originSide),
                    (this.cells = []),
                    (this.outerWidth = 0),
                    (this.height = 0);
                }
                var e = t.prototype;
                return (
                  (e.addCell = function (t) {
                    if (
                      (this.cells.push(t),
                      (this.outerWidth += t.size.outerWidth),
                      (this.height = Math.max(t.size.outerHeight, this.height)),
                      1 == this.cells.length)
                    ) {
                      this.x = t.x;
                      var e = this.isOriginLeft ? "marginLeft" : "marginRight";
                      this.firstMargin = t.size[e];
                    }
                  }),
                  (e.updateTarget = function () {
                    var t = this.isOriginLeft ? "marginRight" : "marginLeft",
                      e = this.getLastCell(),
                      i = e ? e.size[t] : 0,
                      n = this.outerWidth - (this.firstMargin + i);
                    this.target =
                      this.x + this.firstMargin + n * this.parent.cellAlign;
                  }),
                  (e.getLastCell = function () {
                    return this.cells[this.cells.length - 1];
                  }),
                  (e.select = function () {
                    this.cells.forEach(function (t) {
                      t.select();
                    });
                  }),
                  (e.unselect = function () {
                    this.cells.forEach(function (t) {
                      t.unselect();
                    });
                  }),
                  (e.getCellElements = function () {
                    return this.cells.map(function (t) {
                      return t.element;
                    });
                  }),
                  t
                );
              })
                ? n.call(e, i, e, t)
                : n) || (t.exports = s);
      },
      131: (t, e, i) => {
        var n, s;
        /*!
         * getSize v2.0.3
         * measure size of elements
         * MIT license
         */ window,
          void 0 ===
            (s =
              "function" ==
              typeof (n = function () {
                "use strict";
                function t(t) {
                  var e = parseFloat(t);
                  return -1 == t.indexOf("%") && !isNaN(e) && e;
                }
                function e() {}
                var i =
                    "undefined" == typeof console
                      ? e
                      : function (t) {
                          console.error(t);
                        },
                  n = [
                    "paddingLeft",
                    "paddingRight",
                    "paddingTop",
                    "paddingBottom",
                    "marginLeft",
                    "marginRight",
                    "marginTop",
                    "marginBottom",
                    "borderLeftWidth",
                    "borderRightWidth",
                    "borderTopWidth",
                    "borderBottomWidth",
                  ],
                  s = n.length;
                function o() {
                  for (
                    var t = {
                        width: 0,
                        height: 0,
                        innerWidth: 0,
                        innerHeight: 0,
                        outerWidth: 0,
                        outerHeight: 0,
                      },
                      e = 0;
                    e < s;
                    e++
                  )
                    t[n[e]] = 0;
                  return t;
                }
                function r(t) {
                  var e = getComputedStyle(t);
                  return (
                    e ||
                      i(
                        "Style returned " +
                          e +
                          ". Are you running this code in a hidden iframe on Firefox? See https://bit.ly/getsizebug1"
                      ),
                    e
                  );
                }
                var a,
                  l = !1;
                function c() {
                  if (!l) {
                    l = !0;
                    var e = document.createElement("div");
                    (e.style.width = "200px"),
                      (e.style.padding = "1px 2px 3px 4px"),
                      (e.style.borderStyle = "solid"),
                      (e.style.borderWidth = "1px 2px 3px 4px"),
                      (e.style.boxSizing = "border-box");
                    var i = document.body || document.documentElement;
                    i.appendChild(e);
                    var n = r(e);
                    (a = 200 == Math.round(t(n.width))),
                      (h.isBoxSizeOuter = a),
                      i.removeChild(e);
                  }
                }
                function h(e) {
                  if (
                    (c(),
                    "string" == typeof e && (e = document.querySelector(e)),
                    e && "object" == typeof e && e.nodeType)
                  ) {
                    var i = r(e);
                    if ("none" == i.display) return o();
                    var l = {};
                    (l.width = e.offsetWidth), (l.height = e.offsetHeight);
                    for (
                      var h = (l.isBorderBox = "border-box" == i.boxSizing),
                        d = 0;
                      d < s;
                      d++
                    ) {
                      var u = n[d],
                        p = i[u],
                        f = parseFloat(p);
                      l[u] = isNaN(f) ? 0 : f;
                    }
                    var m = l.paddingLeft + l.paddingRight,
                      g = l.paddingTop + l.paddingBottom,
                      v = l.marginLeft + l.marginRight,
                      y = l.marginTop + l.marginBottom,
                      b = l.borderLeftWidth + l.borderRightWidth,
                      w = l.borderTopWidth + l.borderBottomWidth,
                      _ = h && a,
                      S = t(i.width);
                    !1 !== S && (l.width = S + (_ ? 0 : m + b));
                    var C = t(i.height);
                    return (
                      !1 !== C && (l.height = C + (_ ? 0 : g + w)),
                      (l.innerWidth = l.width - (m + b)),
                      (l.innerHeight = l.height - (g + w)),
                      (l.outerWidth = l.width + v),
                      (l.outerHeight = l.height + y),
                      l
                    );
                  }
                }
                return h;
              })
                ? n.call(e, i, e, t)
                : n) || (t.exports = s);
      },
      414: (t) => {
        "use strict";
        function e(t, e, i) {
          var n = 0;
          for (n = 0; n < t.length; n += 1) e.call(i, t[n], n);
        }
        function i(t, e) {
          var i = new RegExp("^" + e + "| +" + e, "g");
          return t.className.match(i);
        }
        function n(t, e) {
          i(t, e) || (t.className += " " + e);
        }
        function s(t, e) {
          if (i(t, e)) {
            var n = new RegExp("^" + e + "| +" + e, "g");
            t.className = t.className.replace(n, "");
          }
        }
        function o(t, e) {
          i(t, e) ? s(t, e) : n(t, e);
        }
        function r(t, i) {
          var n = null;
          return (
            e(t, function (t) {
              t.trigger === i && (n = t);
            }),
            n
          );
        }
        var a = {
            init: function (t) {
              var n = t.triggers,
                s = t.pairings;
              n.setAttribute("role", "tablist"),
                e(s, function (n, s) {
                  n.trigger.setAttribute("role", "tab"),
                    n.trigger.setAttribute(
                      "aria-controls",
                      t.namespace + "-" + t.id + "-" + s + "-content"
                    ),
                    n.trigger.children.length > 0 &&
                      e(n.trigger.children, function (t) {
                        t.setAttribute("tabIndex", "-1");
                      }),
                    i(n.trigger, "active")
                      ? (n.trigger.setAttribute("aria-selected", "true"),
                        n.trigger.setAttribute("tabIndex", "0"))
                      : n.trigger.setAttribute("tabIndex", "-1"),
                    (n.content.id =
                      t.namespace + "-" + t.id + "-" + s + "-content"),
                    n.content.setAttribute("role", "tabpanel"),
                    i(n.content, "active") ||
                      n.content.setAttribute("aria-hidden", "true");
                });
            },
            update: function (t) {
              e(t.pairings, function (t) {
                t.trigger.removeAttribute("aria-selected"),
                  t.content.removeAttribute("aria-hidden"),
                  i(t.trigger, "active")
                    ? (t.trigger.setAttribute("aria-selected", "true"),
                      t.trigger.setAttribute("tabIndex", "0"))
                    : t.trigger.setAttribute("tabIndex", "-1"),
                  i(t.content, "active") ||
                    t.content.setAttribute("aria-hidden", "true");
              });
            },
          },
          l =
            ((function () {
              function t(t) {
                this.value = t;
              }
              function e(e) {
                var i, n;
                function s(i, n) {
                  try {
                    var r = e[i](n),
                      a = r.value;
                    a instanceof t
                      ? Promise.resolve(a.value).then(
                          function (t) {
                            s("next", t);
                          },
                          function (t) {
                            s("throw", t);
                          }
                        )
                      : o(r.done ? "return" : "normal", r.value);
                  } catch (t) {
                    o("throw", t);
                  }
                }
                function o(t, e) {
                  switch (t) {
                    case "return":
                      i.resolve({ value: e, done: !0 });
                      break;
                    case "throw":
                      i.reject(e);
                      break;
                    default:
                      i.resolve({ value: e, done: !1 });
                  }
                  (i = i.next) ? s(i.key, i.arg) : (n = null);
                }
                (this._invoke = function (t, e) {
                  return new Promise(function (o, r) {
                    var a = {
                      key: t,
                      arg: e,
                      resolve: o,
                      reject: r,
                      next: null,
                    };
                    n ? (n = n.next = a) : ((i = n = a), s(t, e));
                  });
                }),
                  "function" != typeof e.return && (this.return = void 0);
              }
              "function" == typeof Symbol &&
                Symbol.asyncIterator &&
                (e.prototype[Symbol.asyncIterator] = function () {
                  return this;
                }),
                (e.prototype.next = function (t) {
                  return this._invoke("next", t);
                }),
                (e.prototype.throw = function (t) {
                  return this._invoke("throw", t);
                }),
                (e.prototype.return = function (t) {
                  return this._invoke("return", t);
                });
            })(),
            function (t, e) {
              if (!(t instanceof e))
                throw new TypeError("Cannot call a class as a function");
            }),
          c = (function () {
            function t(t, e) {
              for (var i = 0; i < e.length; i++) {
                var n = e[i];
                (n.enumerable = n.enumerable || !1),
                  (n.configurable = !0),
                  "value" in n && (n.writable = !0),
                  Object.defineProperty(t, n.key, n);
              }
            }
            return function (e, i, n) {
              return i && t(e.prototype, i), n && t(e, n), e;
            };
          })(),
          h = (function () {
            function t(e) {
              l(this, t),
                (this.groupedContent = e),
                (this.pairings = e.pairings),
                (this.events = []),
                (this._handleKeydown = this._handleKeydown.bind(this)),
                (this._handleClick = this._handleClick.bind(this)),
                this._init(),
                a.init(this.groupedContent);
            }
            return (
              c(t, [
                {
                  key: "unload",
                  value: function () {
                    e(this.events, function (t) {
                      t.trigger.removeEventListener(t.type, t.fn);
                    });
                  },
                },
                {
                  key: "_init",
                  value: function () {
                    var t = this,
                      s = !1;
                    e(this.pairings, function (e) {
                      var n = e.trigger;
                      i(n, "active") && (s = !0),
                        n.addEventListener("keydown", t._handleKeydown),
                        n.addEventListener("click", t._handleClick),
                        t.events.push({
                          trigger: n,
                          type: "keydown",
                          fn: t._handleKeydown,
                        }),
                        t.events.push({
                          trigger: n,
                          type: "click",
                          fn: t._handleClick,
                        });
                    }),
                      s ||
                        (n(this.pairings[0].trigger, "active"),
                        n(this.pairings[0].content, "active"));
                  },
                },
                {
                  key: "_handleKeydown",
                  value: function (t) {
                    var i = t.currentTarget,
                      o = r(this.pairings, i),
                      l = this.pairings.indexOf(o),
                      c = l - 1 < 0 ? this.pairings.length - 1 : l - 1,
                      h = l + 1 >= this.pairings.length ? 0 : l + 1,
                      d = null;
                    switch (t.key) {
                      case "ArrowLeft":
                        d = this.pairings[c];
                        break;
                      case "ArrowRight":
                        d = this.pairings[h];
                        break;
                      default:
                        d = null;
                    }
                    null !== d &&
                      (t.preventDefault(),
                      e(this.pairings, function (t) {
                        s(t.trigger, "active"), s(t.content, "active");
                      }),
                      n(d.trigger, "active"),
                      n(d.content, "active"),
                      d.trigger.focus(),
                      a.update(this.groupedContent));
                  },
                },
                {
                  key: "_handleClick",
                  value: function (t) {
                    var i = t.currentTarget,
                      o = r(this.pairings, i);
                    null !== o &&
                      (t.preventDefault(),
                      e(this.pairings, function (t) {
                        s(t.trigger, "active"), s(t.content, "active");
                      }),
                      n(o.trigger, "active"),
                      n(o.content, "active"),
                      a.update(this.groupedContent));
                  },
                },
              ]),
              t
            );
          })();
        var d = {
            init: function (t) {
              e(t.pairings, function (n, s) {
                n.trigger.setAttribute("role", "button"),
                  n.trigger.setAttribute(
                    "aria-controls",
                    t.namespace + "-" + t.id + "-" + s + "-content"
                  ),
                  n.trigger.setAttribute("tabIndex", "0"),
                  n.trigger.children.length > 0 &&
                    e(n.trigger.children, function (t) {
                      t.setAttribute("tabIndex", "-1");
                    }),
                  i(n.trigger, "active")
                    ? n.trigger.setAttribute("aria-expanded", "true")
                    : n.trigger.setAttribute("aria-expanded", "false"),
                  (n.content.id =
                    t.namespace + "-" + t.id + "-" + s + "-content"),
                  i(n.content, "active") ||
                    n.content.setAttribute("aria-hidden", "true");
              });
            },
            update: function (t) {
              e(t.pairings, function (t) {
                t.content.removeAttribute("aria-hidden"),
                  i(t.trigger, "active")
                    ? t.trigger.setAttribute("aria-expanded", "true")
                    : t.trigger.setAttribute("aria-expanded", "false"),
                  i(t.content, "active") ||
                    t.content.setAttribute("aria-hidden", "true");
              });
            },
          },
          u = (function () {
            function t(e) {
              l(this, t),
                (this.groupedContent = e),
                (this.pairings = e.pairings),
                (this.events = []),
                (this._handleKeydown = this._handleKeydown.bind(this)),
                (this._handleClick = this._handleClick.bind(this)),
                this._init(this.pairings),
                d.init(this.groupedContent);
            }
            return (
              c(t, [
                {
                  key: "unload",
                  value: function () {
                    e(this.events, function (t) {
                      t.trigger.removeEventListener(t.type, t.fn);
                    });
                  },
                },
                {
                  key: "_init",
                  value: function () {
                    var t = this;
                    e(this.pairings, function (e) {
                      var i = e.trigger,
                        n = e.content;
                      i.parentNode.insertBefore(n, i.nextSibling),
                        i.addEventListener("keydown", t._handleKeydown),
                        i.addEventListener("click", t._handleClick),
                        t.events.push({
                          trigger: i,
                          type: "keydown",
                          fn: t._handleKeydown,
                        }),
                        t.events.push({
                          trigger: i,
                          type: "click",
                          fn: t._handleClick,
                        });
                    }),
                      this.groupedContent.contents.remove();
                  },
                },
                {
                  key: "_handleKeydown",
                  value: function (t) {
                    var e = t.currentTarget,
                      i = r(this.pairings, e);
                    "Enter" === t.key &&
                      null !== i &&
                      (t.preventDefault(),
                      o(i.trigger, "active"),
                      o(i.content, "active"),
                      d.update(this.groupedContent));
                  },
                },
                {
                  key: "_handleClick",
                  value: function (t) {
                    var e = t.currentTarget,
                      i = r(this.pairings, e);
                    null !== i &&
                      (t.preventDefault(),
                      o(i.trigger, "active"),
                      o(i.content, "active"),
                      d.update(this.groupedContent));
                  },
                },
              ]),
              t
            );
          })();
        function p(t) {
          for (
            var e = ["H1", "H2", "H3", "H4", "H5", "H6"],
              i = e.indexOf(t.tagName),
              n = [],
              s = t.nextElementSibling;
            null !== s &&
            (-1 === e.indexOf(s.tagName) || e.indexOf(s.tagName) > i);

          )
            n.push(s), (s = s.nextElementSibling);
          return n;
        }
        function f(t, e) {
          for (
            var i =
                arguments.length > 2 && void 0 !== arguments[2] && arguments[2],
              n = ["H1", "H2", "H3", "H4", "H5", "H6"],
              s = n.indexOf(t.tagName),
              o = [],
              r = 5,
              a = 0;
            a < e.length;
            a += 1
          ) {
            var l = e[a],
              c = n.indexOf(l.tagName);
            if (
              (-1 !== c && c < r && (r = c),
              (i && -1 !== c && c <= r) || (!i && -1 !== c && c === s + 1))
            ) {
              var h = p(l),
                d = { el: l, content: h, children: f(l, h) };
              o.push(d);
            }
          }
          return o;
        }
        function m(t) {
          var e = [],
            i = t[0].el,
            n = document.createElement("div"),
            s = document.createElement("div");
          (s = i.parentNode.insertBefore(s, i.nextSibling)),
            (n = i.parentNode.insertBefore(n, i.nextSibling));
          for (var o = 0; o < t.length; o += 1) {
            var r = t[o],
              a = r.el,
              l = document.createElement("div");
            (a = n.appendChild(a)), (l = s.appendChild(l));
            for (var c = 0; c < r.content.length; c += 1)
              l.appendChild(r.content[c]);
            e.push({ trigger: a, content: l });
          }
          return { triggers: n, contents: s, pairings: e };
        }
        function g(t) {
          var e = t.children,
            i = [],
            n = [];
          if (0 === e.length) return [];
          for (var s = 0; s < e.length; s += 1) {
            var o = g(e[s]);
            o.length > 0 && (i.push(s), (n = n.concat(o)));
          }
          for (
            var r = (function (t, e, i) {
                for (var n = [], s = [], o = 0, r = 0; r < t.length; r += 1)
                  -1 === e.indexOf(r) &&
                    (s.push(t[r]),
                    (o += 1),
                    r !== t.length - 1 &&
                    t[r].el.tagName !== t[r + 1].el.tagName &&
                    e.indexOf(r + 1)
                      ? ((s = []), (o = 0))
                      : 0 !== r &&
                        t[r].el.tagName !== t[r - 1].el.tagName &&
                        (s.pop(),
                        (o -= 1) >= i && n.push(s),
                        (s = [t[r]]),
                        (o = 1)));
                return o >= i && n.push(s), n;
              })(e, i, 3),
              a = 0;
            a < r.length;
            a += 1
          )
            n.push(m(r[a]));
          return n;
        }
        function v(t) {
          var e = t.children,
            i = t.querySelector("h1, h2, h3, h4, h5, h6");
          return 0 === e.length
            ? []
            : g({ el: t, content: null, children: f(i, e, !0) });
        }
        var y = (function () {
          function t(i) {
            var s = this,
              o =
                arguments.length > 1 && void 0 !== arguments[1]
                  ? arguments[1]
                  : {};
            l(this, t),
              (this.namespace = "grouped-content"),
              (this.el = i),
              (this.groupedContentInstances = []);
            var r = o.layout || "tabs";
            e(
              (function (t) {
                return arguments.length > 1 &&
                  void 0 !== arguments[1] &&
                  arguments[1]
                  ? v(t)
                  : (function (t) {
                      for (
                        var e = [], i = t.querySelectorAll(".tabs"), n = 0;
                        n < i.length;
                        n += 1
                      ) {
                        var s = i[n].children,
                          o = i[n].nextElementSibling.children;
                        if (s.length === o.length)
                          for (
                            var r =
                                e.push({
                                  triggers: i[n],
                                  contents: i[n].nextElementSibling,
                                  pairings: [],
                                }) - 1,
                              a = 0;
                            a < s.length;
                            a += 1
                          ) {
                            var l = { trigger: s[a], content: o[a] };
                            e[r].pairings.push(l);
                          }
                      }
                      return e;
                    })(t);
              })(i, !!o.intelliparse),
              function (t) {
                var i = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
                    /[xy]/g,
                    function (t) {
                      var e = (16 * Math.random()) | 0;
                      return ("x" === t ? e : (3 & e) | 8).toString(16);
                    }
                  ),
                  o = null,
                  a = document.createElement("div");
                if (
                  (n(
                    (a = t.triggers.parentNode.insertBefore(
                      a,
                      t.triggers.nextSibling
                    )),
                    s.namespace
                  ),
                  n(a, s.namespace + "-layout-" + r),
                  a.appendChild(t.triggers),
                  a.appendChild(t.contents),
                  (t.namespace = s.namespace),
                  (t.id = i),
                  (t.triggers.id = s.namespace + "-" + i + "-triggers"),
                  (t.contents.id = s.namespace + "-" + i + "-contents"),
                  n(t.triggers, s.namespace + "-triggers"),
                  n(t.contents, s.namespace + "-contents"),
                  e(t.pairings, function (t) {
                    n(t.trigger, s.namespace + "-trigger"),
                      n(t.content, s.namespace + "-content");
                  }),
                  "accordion" === r)
                )
                  o = new u(t);
                else o = new h(t);
                s.groupedContentInstances.push({
                  groupedContent: t,
                  instance: o,
                });
              }
            );
          }
          return (
            c(t, [
              {
                key: "unload",
                value: function () {
                  e(this.groupedContentInstances, function (t) {
                    t.instance.unload();
                  });
                },
              },
            ]),
            t
          );
        })();
        t.exports = y;
      },
      458: (t) => {
        function e(t, e) {
          for (var i = 0; i < e.length; i++) {
            var n = e[i];
            (n.enumerable = n.enumerable || !1),
              (n.configurable = !0),
              "value" in n && (n.writable = !0),
              Object.defineProperty(t, n.key, n);
          }
        }
        function i(t, e, i) {
          return (
            e in t
              ? Object.defineProperty(t, e, {
                  value: i,
                  enumerable: !0,
                  configurable: !0,
                  writable: !0,
                })
              : (t[e] = i),
            t
          );
        }
        function n(t, e) {
          return (
            (function (t) {
              if (Array.isArray(t)) return t;
            })(t) ||
            (function (t, e) {
              var i =
                null == t
                  ? null
                  : ("undefined" != typeof Symbol && t[Symbol.iterator]) ||
                    t["@@iterator"];
              if (null == i) return;
              var n,
                s,
                o = [],
                r = !0,
                a = !1;
              try {
                for (
                  i = i.call(t);
                  !(r = (n = i.next()).done) &&
                  (o.push(n.value), !e || o.length !== e);
                  r = !0
                );
              } catch (t) {
                (a = !0), (s = t);
              } finally {
                try {
                  r || null == i.return || i.return();
                } finally {
                  if (a) throw s;
                }
              }
              return o;
            })(t, e) ||
            (function (t, e) {
              if (!t) return;
              if ("string" == typeof t) return s(t, e);
              var i = Object.prototype.toString.call(t).slice(8, -1);
              "Object" === i && t.constructor && (i = t.constructor.name);
              if ("Map" === i || "Set" === i) return Array.from(t);
              if (
                "Arguments" === i ||
                /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(i)
              )
                return s(t, e);
            })(t, e) ||
            (function () {
              throw new TypeError(
                "Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."
              );
            })()
          );
        }
        function s(t, e) {
          (null == e || e > t.length) && (e = t.length);
          for (var i = 0, n = new Array(e); i < e; i++) n[i] = t[i];
          return n;
        }
        function o(t, e) {
          return (function (t, e) {
            if (e.get) return e.get.call(t);
            return e.value;
          })(t, a(t, e, "get"));
        }
        function r(t, e, i) {
          return (
            (function (t, e, i) {
              if (e.set) e.set.call(t, i);
              else {
                if (!e.writable)
                  throw new TypeError(
                    "attempted to set read only private field"
                  );
                e.value = i;
              }
            })(t, a(t, e, "set"), i),
            i
          );
        }
        function a(t, e, i) {
          if (!e.has(t))
            throw new TypeError(
              "attempted to " + i + " private field on non-instance"
            );
          return e.get(t);
        }
        function l(t, e, i) {
          if (!e.has(t))
            throw new TypeError(
              "attempted to get private field on non-instance"
            );
          return i;
        }
        function c(t, e) {
          if (e.has(t))
            throw new TypeError(
              "Cannot initialize the same private elements twice on an object"
            );
        }
        function h(t, e, i) {
          c(t, e), e.set(t, i);
        }
        function d(t, e) {
          c(t, e), e.add(t);
        }
        var u = [
          " daum[ /]",
          " deusu/",
          "(?:^| )site",
          "@[a-z]",
          "\\(at\\)[a-z]",
          "\\(github\\.com/",
          "\\[at\\][a-z]",
          "^12345",
          "^<",
          "^[\\w \\.\\-\\(\\)]+(/v?\\d+(\\.\\d+)?(\\.\\d{1,10})?)?$",
          "^[^ ]{50,}$",
          "^active",
          "^ad muncher",
          "^anglesharp/",
          "^anonymous",
          "^avsdevicesdk/",
          "^axios/",
          "^bidtellect/",
          "^biglotron",
          "^castro",
          "^clamav[ /]",
          "^cobweb/",
          "^coccoc",
          "^custom",
          "^ddg[_-]android",
          "^discourse",
          "^dispatch/\\d",
          "^downcast/",
          "^duckduckgo",
          "^facebook",
          "^fdm[ /]\\d",
          "^getright/",
          "^gozilla/",
          "^hatena",
          "^hobbit",
          "^hotzonu",
          "^hwcdn/",
          "^jeode/",
          "^jetty/",
          "^jigsaw",
          "^linkdex",
          "^lwp[-: ]",
          "^metauri",
          "^microsoft bits",
          "^movabletype",
          "^mozilla/\\d\\.\\d \\(compatible;?\\)$",
          "^mozilla/\\d\\.\\d \\w*$",
          "^navermailapp",
          "^netsurf",
          "^offline explorer",
          "^phantom",
          "^php",
          "^postman",
          "^postrank",
          "^python",
          "^read",
          "^reed",
          "^restsharp/",
          "^snapchat",
          "^space bison",
          "^svn",
          "^swcd ",
          "^taringa",
          "^test certificate info",
          "^thumbor/",
          "^tumblr/",
          "^user-agent:mozilla",
          "^valid",
          "^venus/fedoraplanet",
          "^w3c",
          "^webbandit/",
          "^webcopier",
          "^wget",
          "^whatsapp",
          "^xenu link sleuth",
          "^yahoo",
          "^yandex",
          "^zdm/\\d",
          "^zoom marketplace/",
          "^$",
          "adbeat\\.com",
          "appinsights",
          "archive",
          "ask jeeves/teoma",
          "bit\\.ly/",
          "bluecoat drtr",
          "bot",
          "browsex",
          "burpcollaborator",
          "capture",
          "catch",
          "check",
          "chrome-lighthouse",
          "chromeframe",
          "client",
          "cloud",
          "crawl",
          "dareboost",
          "datanyze",
          "dataprovider",
          "dejaclick",
          "dmbrowser",
          "download",
          "evc-batch/",
          "feed",
          "firephp",
          "freesafeip",
          "ghost",
          "gomezagent",
          "google",
          "headlesschrome/",
          "http",
          "httrack",
          "hubspot marketing grader",
          "hydra",
          "ibisbrowser",
          "images",
          "iplabel",
          "ips-agent",
          "java",
          "library",
          "mail\\.ru/",
          "manager",
          "monitor",
          "morningscore/",
          "neustar wpm",
          "news",
          "nutch",
          "offbyone",
          "optimize",
          "pageburst",
          "pagespeed",
          "perl",
          "pingdom",
          "powermarks",
          "preview",
          "proxy",
          "ptst[ /]\\d",
          "reader",
          "rexx;",
          "rigor",
          "rss",
          "scan",
          "scrape",
          "search",
          "serp ?reputation ?management",
          "server",
          "sogou",
          "sparkler/",
          "spider",
          "statuscake",
          "stumbleupon\\.com",
          "supercleaner",
          "synapse",
          "synthetic",
          "taginspector/",
          "torrent",
          "tracemyfile",
          "transcoder",
          "trendsmapresolver",
          "twingly recon",
          "url",
          "virtuoso",
          "wappalyzer",
          "webglance",
          "webkit2png",
          "websitemetadataretriever",
          "whatcms/",
          "wordpress",
          "zgrab",
        ];
        !(function (t) {
          try {
            new RegExp("(?<! cu)bot").test("dangerbot");
          } catch (e) {
            return t;
          }
          [
            ["bot", "(?<! cu)bot"],
            [
              "google",
              "(?<! (?:channel/|google/))google(?!(app|/google| pixel))",
            ],
            ["http", "(?<!(?:lib))http"],
            ["java", "java(?!;)"],
            ["search", "(?<! ya(?:yandex)?)search"],
          ].forEach(function (e) {
            var i = n(e, 2),
              s = i[0],
              o = i[1],
              r = t.lastIndexOf(s);
            ~r && t.splice(r, 1, o);
          });
        })(u);
        var p = new WeakMap(),
          f = new WeakMap(),
          m = new WeakSet(),
          g = new WeakSet();
        function v() {
          r(this, f, new RegExp(o(this, p).join("|"), "i"));
        }
        function y(t) {
          return o(this, p).indexOf(t.toLowerCase());
        }
        var b = new ((function () {
          function t(e) {
            var s = this;
            !(function (t, e) {
              if (!(t instanceof e))
                throw new TypeError("Cannot call a class as a function");
            })(this, t),
              d(this, g),
              d(this, m),
              h(this, p, { writable: !0, value: void 0 }),
              h(this, f, { writable: !0, value: void 0 }),
              r(this, p, e || u.slice()),
              l(this, m, v).call(this);
            return Object.defineProperties(
              function (t) {
                return s.test(t);
              },
              Object.entries(
                Object.getOwnPropertyDescriptors(t.prototype)
              ).reduce(function (t, e) {
                var o = n(e, 2),
                  r = o[0],
                  a = o[1];
                return (
                  "function" == typeof a.value &&
                    Object.assign(t, i({}, r, { value: s[r].bind(s) })),
                  "function" == typeof a.get &&
                    Object.assign(
                      t,
                      i({}, r, {
                        get: function () {
                          return s[r];
                        },
                      })
                    ),
                  t
                );
              }, {})
            );
          }
          var s, a, c;
          return (
            (s = t),
            (a = [
              {
                key: "pattern",
                get: function () {
                  return new RegExp(o(this, f));
                },
              },
              {
                key: "test",
                value: function (t) {
                  return Boolean(t) && o(this, f).test(t);
                },
              },
              {
                key: "find",
                value: function () {
                  var t = (
                    arguments.length > 0 && void 0 !== arguments[0]
                      ? arguments[0]
                      : ""
                  ).match(o(this, f));
                  return t && t[0];
                },
              },
              {
                key: "matches",
                value: function () {
                  var t =
                    arguments.length > 0 && void 0 !== arguments[0]
                      ? arguments[0]
                      : "";
                  return o(this, p).filter(function (e) {
                    return new RegExp(e, "i").test(t);
                  });
                },
              },
              {
                key: "clear",
                value: function () {
                  var t =
                    arguments.length > 0 && void 0 !== arguments[0]
                      ? arguments[0]
                      : "";
                  this.exclude(this.matches(t));
                },
              },
              {
                key: "extend",
                value: function () {
                  var t = this,
                    e =
                      arguments.length > 0 && void 0 !== arguments[0]
                        ? arguments[0]
                        : [];
                  [].push.apply(
                    o(this, p),
                    e
                      .filter(function (e) {
                        return -1 === l(t, g, y).call(t, e);
                      })
                      .map(function (t) {
                        return t.toLowerCase();
                      })
                  ),
                    l(this, m, v).call(this);
                },
              },
              {
                key: "exclude",
                value: function () {
                  for (
                    var t =
                        arguments.length > 0 && void 0 !== arguments[0]
                          ? arguments[0]
                          : [],
                      e = t.length;
                    e--;

                  ) {
                    var i = l(this, g, y).call(this, t[e]);
                    i > -1 && o(this, p).splice(i, 1);
                  }
                  l(this, m, v).call(this);
                },
              },
              {
                key: "spawn",
                value: function (e) {
                  return new t(e || o(this, p));
                },
              },
            ]),
            a && e(s.prototype, a),
            c && e(s, c),
            Object.defineProperty(s, "prototype", { writable: !1 }),
            t
          );
        })())();
        t.exports = b;
      },
      220: () => {
        /*!
         * Revealer 3.0.0
         *
         * Copyright 2021, Pixel Union - http://pixelunion.net
         * Released under the MIT license
         */
        !(function (t) {
          "object" != typeof t.event.special.trend &&
            console.warn(
              "Please make sure jquery.trend is included! Otherwise revealer won't work."
            );
          var e =
              window.requestAnimationFrame ||
              window.mozRequestAnimationFrame ||
              window.webkitRequestAnimationFrame ||
              function (t) {
                window.setTimeout(t, 1e3 / 60);
              },
            i = {
              isVisible: function (t) {
                return !!t.data("revealer-visible");
              },
              show: function (t, n) {
                return i.isVisible(t)
                  ? (t.removeClass("animating animating-in"),
                    void t.off("revealer-animating revealer-show"))
                  : (t.data("revealer-visible", !0),
                    t.off("trend"),
                    n
                      ? (t.addClass("visible"),
                        void e(function () {
                          t.trigger("revealer-animating"),
                            t.trigger("revealer-show");
                        }))
                      : void e(function () {
                          t.addClass("animating animating-in"),
                            t.trigger("revealer-animating"),
                            e(function () {
                              t.addClass("visible"),
                                t.one("trend", function () {
                                  t.removeClass("animating animating-in"),
                                    t.trigger("revealer-show");
                                });
                            });
                        }));
              },
              hide: function (t, n) {
                return i.isVisible(t)
                  ? (t.data("revealer-visible", !1),
                    t.off("trend"),
                    n
                      ? (t.removeClass("visible"),
                        void e(function () {
                          t.trigger("revealer-animating"),
                            t.trigger("revealer-hide");
                        }))
                      : void e(function () {
                          t.addClass("animating animating-out"),
                            t.trigger("revealer-animating"),
                            e(function () {
                              t.removeClass("visible"),
                                t.one("trend", function () {
                                  t.removeClass(
                                    "animating animating-in animating-out"
                                  ),
                                    t.trigger("revealer-hide");
                                });
                            });
                        }))
                  : (t.removeClass("animating animating-out visible"),
                    void t.off("revealer-animating revealer-hide"));
              },
              toggle: function (t, e) {
                i.isVisible(t) ? i.hide(t, e) : i.show(t, e);
              },
            };
          t.fn.revealer = function (e, n) {
            var s = i[e || "toggle"];
            return s
              ? "isVisible" === e
                ? s(this)
                : this.each(function () {
                    s(t(this), n);
                  })
              : this;
          };
        })(jQuery);
      },
      72: () => {
        !(function (t) {
          var e =
              "webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend",
            i = [
              "transition-duration",
              "-moz-transition-duration",
              "-webkit-transition-duration",
              "-ms-transition-duration",
              "-o-transition-duration",
              "-khtml-transition-duration",
            ],
            n = [
              "transition-delay",
              "-moz-transition-delay",
              "-webkit-transition-delay",
              "-ms-transition-delay",
              "-o-transition-delay",
              "-khtml-transition-delay",
            ],
            s = function (t) {
              t = t.replace(/\s/, "");
              var e = window.parseFloat(t);
              return t.match(/[^m]s$/i) ? 1e3 * e : e;
            },
            o = function (t, e) {
              for (var i = 0, n = 0; n < e.length; n++) {
                var o = t.css(e[n]);
                if (o) {
                  if (-1 !== o.indexOf(",")) {
                    var r = o.split(","),
                      a = (function () {
                        for (var t = [], e = 0; e < r.length; e++) {
                          var i = s(r[e]);
                          t.push(i);
                        }
                        return t;
                      })();
                    i = Math.max.apply(Math, a);
                  } else i = s(o);
                  break;
                }
              }
              return i;
            };
          t.event.special.trend = {
            add: function (s) {
              var r = t(this),
                a = !1;
              r.data("trend", !0);
              var l = o(r, i) + o(r, n) + 20,
                c = function (t) {
                  a ||
                    (t && t.srcElement !== r[0]) ||
                    (r.data("trend", !1), (a = !0), s.handler && s.handler());
                };
              r.one(e, c), r.data("trend-timeout", window.setTimeout(c, l));
            },
            remove: function (i) {
              var n = t(this);
              n.off(e), window.clearTimeout(n.data("trend-timeout"));
            },
          };
        })(jQuery);
      },
      755: function (t, e) {
        var i;
        /*!
         * jQuery JavaScript Library v3.5.1
         * https://jquery.com/
         *
         * Includes Sizzle.js
         * https://sizzlejs.com/
         *
         * Copyright JS Foundation and other contributors
         * Released under the MIT license
         * https://jquery.org/license
         *
         * Date: 2020-05-04T22:49Z
         */ !(function (e, i) {
          "use strict";
          "object" == typeof t.exports
            ? (t.exports = e.document
                ? i(e, !0)
                : function (t) {
                    if (!t.document)
                      throw new Error(
                        "jQuery requires a window with a document"
                      );
                    return i(t);
                  })
            : i(e);
        })("undefined" != typeof window ? window : this, function (n, s) {
          "use strict";
          var o = [],
            r = Object.getPrototypeOf,
            a = o.slice,
            l = o.flat
              ? function (t) {
                  return o.flat.call(t);
                }
              : function (t) {
                  return o.concat.apply([], t);
                },
            c = o.push,
            h = o.indexOf,
            d = {},
            u = d.toString,
            p = d.hasOwnProperty,
            f = p.toString,
            m = f.call(Object),
            g = {},
            v = function (t) {
              return "function" == typeof t && "number" != typeof t.nodeType;
            },
            y = function (t) {
              return null != t && t === t.window;
            },
            b = n.document,
            w = { type: !0, src: !0, nonce: !0, noModule: !0 };
          function _(t, e, i) {
            var n,
              s,
              o = (i = i || b).createElement("script");
            if (((o.text = t), e))
              for (n in w)
                (s = e[n] || (e.getAttribute && e.getAttribute(n))) &&
                  o.setAttribute(n, s);
            i.head.appendChild(o).parentNode.removeChild(o);
          }
          function S(t) {
            return null == t
              ? t + ""
              : "object" == typeof t || "function" == typeof t
              ? d[u.call(t)] || "object"
              : typeof t;
          }
          var C = "3.5.1",
            k = function (t, e) {
              return new k.fn.init(t, e);
            };
          function x(t) {
            var e = !!t && "length" in t && t.length,
              i = S(t);
            return (
              !v(t) &&
              !y(t) &&
              ("array" === i ||
                0 === e ||
                ("number" == typeof e && e > 0 && e - 1 in t))
            );
          }
          (k.fn = k.prototype =
            {
              jquery: C,
              constructor: k,
              length: 0,
              toArray: function () {
                return a.call(this);
              },
              get: function (t) {
                return null == t
                  ? a.call(this)
                  : t < 0
                  ? this[t + this.length]
                  : this[t];
              },
              pushStack: function (t) {
                var e = k.merge(this.constructor(), t);
                return (e.prevObject = this), e;
              },
              each: function (t) {
                return k.each(this, t);
              },
              map: function (t) {
                return this.pushStack(
                  k.map(this, function (e, i) {
                    return t.call(e, i, e);
                  })
                );
              },
              slice: function () {
                return this.pushStack(a.apply(this, arguments));
              },
              first: function () {
                return this.eq(0);
              },
              last: function () {
                return this.eq(-1);
              },
              even: function () {
                return this.pushStack(
                  k.grep(this, function (t, e) {
                    return (e + 1) % 2;
                  })
                );
              },
              odd: function () {
                return this.pushStack(
                  k.grep(this, function (t, e) {
                    return e % 2;
                  })
                );
              },
              eq: function (t) {
                var e = this.length,
                  i = +t + (t < 0 ? e : 0);
                return this.pushStack(i >= 0 && i < e ? [this[i]] : []);
              },
              end: function () {
                return this.prevObject || this.constructor();
              },
              push: c,
              sort: o.sort,
              splice: o.splice,
            }),
            (k.extend = k.fn.extend =
              function () {
                var t,
                  e,
                  i,
                  n,
                  s,
                  o,
                  r = arguments[0] || {},
                  a = 1,
                  l = arguments.length,
                  c = !1;
                for (
                  "boolean" == typeof r &&
                    ((c = r), (r = arguments[a] || {}), a++),
                    "object" == typeof r || v(r) || (r = {}),
                    a === l && ((r = this), a--);
                  a < l;
                  a++
                )
                  if (null != (t = arguments[a]))
                    for (e in t)
                      (n = t[e]),
                        "__proto__" !== e &&
                          r !== n &&
                          (c &&
                          n &&
                          (k.isPlainObject(n) || (s = Array.isArray(n)))
                            ? ((i = r[e]),
                              (o =
                                s && !Array.isArray(i)
                                  ? []
                                  : s || k.isPlainObject(i)
                                  ? i
                                  : {}),
                              (s = !1),
                              (r[e] = k.extend(c, o, n)))
                            : void 0 !== n && (r[e] = n));
                return r;
              }),
            k.extend({
              expando: "jQuery" + (C + Math.random()).replace(/\D/g, ""),
              isReady: !0,
              error: function (t) {
                throw new Error(t);
              },
              noop: function () {},
              isPlainObject: function (t) {
                var e, i;
                return (
                  !(!t || "[object Object]" !== u.call(t)) &&
                  (!(e = r(t)) ||
                    ("function" ==
                      typeof (i = p.call(e, "constructor") && e.constructor) &&
                      f.call(i) === m))
                );
              },
              isEmptyObject: function (t) {
                var e;
                for (e in t) return !1;
                return !0;
              },
              globalEval: function (t, e, i) {
                _(t, { nonce: e && e.nonce }, i);
              },
              each: function (t, e) {
                var i,
                  n = 0;
                if (x(t))
                  for (
                    i = t.length;
                    n < i && !1 !== e.call(t[n], n, t[n]);
                    n++
                  );
                else for (n in t) if (!1 === e.call(t[n], n, t[n])) break;
                return t;
              },
              makeArray: function (t, e) {
                var i = e || [];
                return (
                  null != t &&
                    (x(Object(t))
                      ? k.merge(i, "string" == typeof t ? [t] : t)
                      : c.call(i, t)),
                  i
                );
              },
              inArray: function (t, e, i) {
                return null == e ? -1 : h.call(e, t, i);
              },
              merge: function (t, e) {
                for (var i = +e.length, n = 0, s = t.length; n < i; n++)
                  t[s++] = e[n];
                return (t.length = s), t;
              },
              grep: function (t, e, i) {
                for (var n = [], s = 0, o = t.length, r = !i; s < o; s++)
                  !e(t[s], s) !== r && n.push(t[s]);
                return n;
              },
              map: function (t, e, i) {
                var n,
                  s,
                  o = 0,
                  r = [];
                if (x(t))
                  for (n = t.length; o < n; o++)
                    null != (s = e(t[o], o, i)) && r.push(s);
                else for (o in t) null != (s = e(t[o], o, i)) && r.push(s);
                return l(r);
              },
              guid: 1,
              support: g,
            }),
            "function" == typeof Symbol &&
              (k.fn[Symbol.iterator] = o[Symbol.iterator]),
            k.each(
              "Boolean Number String Function Array Date RegExp Object Error Symbol".split(
                " "
              ),
              function (t, e) {
                d["[object " + e + "]"] = e.toLowerCase();
              }
            );
          var E =
            /*!
             * Sizzle CSS Selector Engine v2.3.5
             * https://sizzlejs.com/
             *
             * Copyright JS Foundation and other contributors
             * Released under the MIT license
             * https://js.foundation/
             *
             * Date: 2020-03-14
             */
            (function (t) {
              var e,
                i,
                n,
                s,
                o,
                r,
                a,
                l,
                c,
                h,
                d,
                u,
                p,
                f,
                m,
                g,
                v,
                y,
                b,
                w = "sizzle" + 1 * new Date(),
                _ = t.document,
                S = 0,
                C = 0,
                k = lt(),
                x = lt(),
                E = lt(),
                A = lt(),
                T = function (t, e) {
                  return t === e && (d = !0), 0;
                },
                L = {}.hasOwnProperty,
                D = [],
                I = D.pop,
                P = D.push,
                M = D.push,
                O = D.slice,
                F = function (t, e) {
                  for (var i = 0, n = t.length; i < n; i++)
                    if (t[i] === e) return i;
                  return -1;
                },
                q =
                  "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",
                $ = "[\\x20\\t\\r\\n\\f]",
                B =
                  "(?:\\\\[\\da-fA-F]{1,6}" +
                  $ +
                  "?|\\\\[^\\r\\n\\f]|[\\w-]|[^\0-\\x7f])+",
                N =
                  "\\[" +
                  $ +
                  "*(" +
                  B +
                  ")(?:" +
                  $ +
                  "*([*^$|!~]?=)" +
                  $ +
                  "*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" +
                  B +
                  "))|)" +
                  $ +
                  "*\\]",
                R =
                  ":(" +
                  B +
                  ")(?:\\((('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|((?:\\\\.|[^\\\\()[\\]]|" +
                  N +
                  ")*)|.*)\\)|)",
                z = new RegExp($ + "+", "g"),
                H = new RegExp(
                  "^" + $ + "+|((?:^|[^\\\\])(?:\\\\.)*)" + $ + "+$",
                  "g"
                ),
                U = new RegExp("^" + $ + "*," + $ + "*"),
                j = new RegExp("^" + $ + "*([>+~]|" + $ + ")" + $ + "*"),
                W = new RegExp($ + "|>"),
                V = new RegExp(R),
                G = new RegExp("^" + B + "$"),
                X = {
                  ID: new RegExp("^#(" + B + ")"),
                  CLASS: new RegExp("^\\.(" + B + ")"),
                  TAG: new RegExp("^(" + B + "|[*])"),
                  ATTR: new RegExp("^" + N),
                  PSEUDO: new RegExp("^" + R),
                  CHILD: new RegExp(
                    "^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" +
                      $ +
                      "*(even|odd|(([+-]|)(\\d*)n|)" +
                      $ +
                      "*(?:([+-]|)" +
                      $ +
                      "*(\\d+)|))" +
                      $ +
                      "*\\)|)",
                    "i"
                  ),
                  bool: new RegExp("^(?:" + q + ")$", "i"),
                  needsContext: new RegExp(
                    "^" +
                      $ +
                      "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" +
                      $ +
                      "*((?:-\\d)?\\d*)" +
                      $ +
                      "*\\)|)(?=[^-]|$)",
                    "i"
                  ),
                },
                Z = /HTML$/i,
                Q = /^(?:input|select|textarea|button)$/i,
                Y = /^h\d$/i,
                K = /^[^{]+\{\s*\[native \w/,
                J = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,
                tt = /[+~]/,
                et = new RegExp(
                  "\\\\[\\da-fA-F]{1,6}" + $ + "?|\\\\([^\\r\\n\\f])",
                  "g"
                ),
                it = function (t, e) {
                  var i = "0x" + t.slice(1) - 65536;
                  return (
                    e ||
                    (i < 0
                      ? String.fromCharCode(i + 65536)
                      : String.fromCharCode(
                          (i >> 10) | 55296,
                          (1023 & i) | 56320
                        ))
                  );
                },
                nt = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\0-\x1f\x7f-\uFFFF\w-]/g,
                st = function (t, e) {
                  return e
                    ? "\0" === t
                      ? "�"
                      : t.slice(0, -1) +
                        "\\" +
                        t.charCodeAt(t.length - 1).toString(16) +
                        " "
                    : "\\" + t;
                },
                ot = function () {
                  u();
                },
                rt = wt(
                  function (t) {
                    return (
                      !0 === t.disabled &&
                      "fieldset" === t.nodeName.toLowerCase()
                    );
                  },
                  { dir: "parentNode", next: "legend" }
                );
              try {
                M.apply((D = O.call(_.childNodes)), _.childNodes),
                  D[_.childNodes.length].nodeType;
              } catch (t) {
                M = {
                  apply: D.length
                    ? function (t, e) {
                        P.apply(t, O.call(e));
                      }
                    : function (t, e) {
                        for (var i = t.length, n = 0; (t[i++] = e[n++]); );
                        t.length = i - 1;
                      },
                };
              }
              function at(t, e, n, s) {
                var o,
                  a,
                  c,
                  h,
                  d,
                  f,
                  v,
                  y = e && e.ownerDocument,
                  _ = e ? e.nodeType : 9;
                if (
                  ((n = n || []),
                  "string" != typeof t ||
                    !t ||
                    (1 !== _ && 9 !== _ && 11 !== _))
                )
                  return n;
                if (!s && (u(e), (e = e || p), m)) {
                  if (11 !== _ && (d = J.exec(t)))
                    if ((o = d[1])) {
                      if (9 === _) {
                        if (!(c = e.getElementById(o))) return n;
                        if (c.id === o) return n.push(c), n;
                      } else if (
                        y &&
                        (c = y.getElementById(o)) &&
                        b(e, c) &&
                        c.id === o
                      )
                        return n.push(c), n;
                    } else {
                      if (d[2]) return M.apply(n, e.getElementsByTagName(t)), n;
                      if (
                        (o = d[3]) &&
                        i.getElementsByClassName &&
                        e.getElementsByClassName
                      )
                        return M.apply(n, e.getElementsByClassName(o)), n;
                    }
                  if (
                    i.qsa &&
                    !A[t + " "] &&
                    (!g || !g.test(t)) &&
                    (1 !== _ || "object" !== e.nodeName.toLowerCase())
                  ) {
                    if (
                      ((v = t), (y = e), 1 === _ && (W.test(t) || j.test(t)))
                    ) {
                      for (
                        ((y = (tt.test(t) && vt(e.parentNode)) || e) === e &&
                          i.scope) ||
                          ((h = e.getAttribute("id"))
                            ? (h = h.replace(nt, st))
                            : e.setAttribute("id", (h = w))),
                          a = (f = r(t)).length;
                        a--;

                      )
                        f[a] = (h ? "#" + h : ":scope") + " " + bt(f[a]);
                      v = f.join(",");
                    }
                    try {
                      return M.apply(n, y.querySelectorAll(v)), n;
                    } catch (e) {
                      A(t, !0);
                    } finally {
                      h === w && e.removeAttribute("id");
                    }
                  }
                }
                return l(t.replace(H, "$1"), e, n, s);
              }
              function lt() {
                var t = [];
                return function e(i, s) {
                  return (
                    t.push(i + " ") > n.cacheLength && delete e[t.shift()],
                    (e[i + " "] = s)
                  );
                };
              }
              function ct(t) {
                return (t[w] = !0), t;
              }
              function ht(t) {
                var e = p.createElement("fieldset");
                try {
                  return !!t(e);
                } catch (t) {
                  return !1;
                } finally {
                  e.parentNode && e.parentNode.removeChild(e), (e = null);
                }
              }
              function dt(t, e) {
                for (var i = t.split("|"), s = i.length; s--; )
                  n.attrHandle[i[s]] = e;
              }
              function ut(t, e) {
                var i = e && t,
                  n =
                    i &&
                    1 === t.nodeType &&
                    1 === e.nodeType &&
                    t.sourceIndex - e.sourceIndex;
                if (n) return n;
                if (i) for (; (i = i.nextSibling); ) if (i === e) return -1;
                return t ? 1 : -1;
              }
              function pt(t) {
                return function (e) {
                  return "input" === e.nodeName.toLowerCase() && e.type === t;
                };
              }
              function ft(t) {
                return function (e) {
                  var i = e.nodeName.toLowerCase();
                  return ("input" === i || "button" === i) && e.type === t;
                };
              }
              function mt(t) {
                return function (e) {
                  return "form" in e
                    ? e.parentNode && !1 === e.disabled
                      ? "label" in e
                        ? "label" in e.parentNode
                          ? e.parentNode.disabled === t
                          : e.disabled === t
                        : e.isDisabled === t ||
                          (e.isDisabled !== !t && rt(e) === t)
                      : e.disabled === t
                    : "label" in e && e.disabled === t;
                };
              }
              function gt(t) {
                return ct(function (e) {
                  return (
                    (e = +e),
                    ct(function (i, n) {
                      for (var s, o = t([], i.length, e), r = o.length; r--; )
                        i[(s = o[r])] && (i[s] = !(n[s] = i[s]));
                    })
                  );
                });
              }
              function vt(t) {
                return t && void 0 !== t.getElementsByTagName && t;
              }
              for (e in ((i = at.support = {}),
              (o = at.isXML =
                function (t) {
                  var e = t.namespaceURI,
                    i = (t.ownerDocument || t).documentElement;
                  return !Z.test(e || (i && i.nodeName) || "HTML");
                }),
              (u = at.setDocument =
                function (t) {
                  var e,
                    s,
                    r = t ? t.ownerDocument || t : _;
                  return r != p && 9 === r.nodeType && r.documentElement
                    ? ((f = (p = r).documentElement),
                      (m = !o(p)),
                      _ != p &&
                        (s = p.defaultView) &&
                        s.top !== s &&
                        (s.addEventListener
                          ? s.addEventListener("unload", ot, !1)
                          : s.attachEvent && s.attachEvent("onunload", ot)),
                      (i.scope = ht(function (t) {
                        return (
                          f.appendChild(t).appendChild(p.createElement("div")),
                          void 0 !== t.querySelectorAll &&
                            !t.querySelectorAll(":scope fieldset div").length
                        );
                      })),
                      (i.attributes = ht(function (t) {
                        return (
                          (t.className = "i"), !t.getAttribute("className")
                        );
                      })),
                      (i.getElementsByTagName = ht(function (t) {
                        return (
                          t.appendChild(p.createComment("")),
                          !t.getElementsByTagName("*").length
                        );
                      })),
                      (i.getElementsByClassName = K.test(
                        p.getElementsByClassName
                      )),
                      (i.getById = ht(function (t) {
                        return (
                          (f.appendChild(t).id = w),
                          !p.getElementsByName || !p.getElementsByName(w).length
                        );
                      })),
                      i.getById
                        ? ((n.filter.ID = function (t) {
                            var e = t.replace(et, it);
                            return function (t) {
                              return t.getAttribute("id") === e;
                            };
                          }),
                          (n.find.ID = function (t, e) {
                            if (void 0 !== e.getElementById && m) {
                              var i = e.getElementById(t);
                              return i ? [i] : [];
                            }
                          }))
                        : ((n.filter.ID = function (t) {
                            var e = t.replace(et, it);
                            return function (t) {
                              var i =
                                void 0 !== t.getAttributeNode &&
                                t.getAttributeNode("id");
                              return i && i.value === e;
                            };
                          }),
                          (n.find.ID = function (t, e) {
                            if (void 0 !== e.getElementById && m) {
                              var i,
                                n,
                                s,
                                o = e.getElementById(t);
                              if (o) {
                                if (
                                  (i = o.getAttributeNode("id")) &&
                                  i.value === t
                                )
                                  return [o];
                                for (
                                  s = e.getElementsByName(t), n = 0;
                                  (o = s[n++]);

                                )
                                  if (
                                    (i = o.getAttributeNode("id")) &&
                                    i.value === t
                                  )
                                    return [o];
                              }
                              return [];
                            }
                          })),
                      (n.find.TAG = i.getElementsByTagName
                        ? function (t, e) {
                            return void 0 !== e.getElementsByTagName
                              ? e.getElementsByTagName(t)
                              : i.qsa
                              ? e.querySelectorAll(t)
                              : void 0;
                          }
                        : function (t, e) {
                            var i,
                              n = [],
                              s = 0,
                              o = e.getElementsByTagName(t);
                            if ("*" === t) {
                              for (; (i = o[s++]); )
                                1 === i.nodeType && n.push(i);
                              return n;
                            }
                            return o;
                          }),
                      (n.find.CLASS =
                        i.getElementsByClassName &&
                        function (t, e) {
                          if (void 0 !== e.getElementsByClassName && m)
                            return e.getElementsByClassName(t);
                        }),
                      (v = []),
                      (g = []),
                      (i.qsa = K.test(p.querySelectorAll)) &&
                        (ht(function (t) {
                          var e;
                          (f.appendChild(t).innerHTML =
                            "<a id='" +
                            w +
                            "'></a><select id='" +
                            w +
                            "-\r\\' msallowcapture=''><option selected=''></option></select>"),
                            t.querySelectorAll("[msallowcapture^='']").length &&
                              g.push("[*^$]=" + $ + "*(?:''|\"\")"),
                            t.querySelectorAll("[selected]").length ||
                              g.push("\\[" + $ + "*(?:value|" + q + ")"),
                            t.querySelectorAll("[id~=" + w + "-]").length ||
                              g.push("~="),
                            (e = p.createElement("input")).setAttribute(
                              "name",
                              ""
                            ),
                            t.appendChild(e),
                            t.querySelectorAll("[name='']").length ||
                              g.push(
                                "\\[" +
                                  $ +
                                  "*name" +
                                  $ +
                                  "*=" +
                                  $ +
                                  "*(?:''|\"\")"
                              ),
                            t.querySelectorAll(":checked").length ||
                              g.push(":checked"),
                            t.querySelectorAll("a#" + w + "+*").length ||
                              g.push(".#.+[+~]"),
                            t.querySelectorAll("\\\f"),
                            g.push("[\\r\\n\\f]");
                        }),
                        ht(function (t) {
                          t.innerHTML =
                            "<a href='' disabled='disabled'></a><select disabled='disabled'><option/></select>";
                          var e = p.createElement("input");
                          e.setAttribute("type", "hidden"),
                            t.appendChild(e).setAttribute("name", "D"),
                            t.querySelectorAll("[name=d]").length &&
                              g.push("name" + $ + "*[*^$|!~]?="),
                            2 !== t.querySelectorAll(":enabled").length &&
                              g.push(":enabled", ":disabled"),
                            (f.appendChild(t).disabled = !0),
                            2 !== t.querySelectorAll(":disabled").length &&
                              g.push(":enabled", ":disabled"),
                            t.querySelectorAll("*,:x"),
                            g.push(",.*:");
                        })),
                      (i.matchesSelector = K.test(
                        (y =
                          f.matches ||
                          f.webkitMatchesSelector ||
                          f.mozMatchesSelector ||
                          f.oMatchesSelector ||
                          f.msMatchesSelector)
                      )) &&
                        ht(function (t) {
                          (i.disconnectedMatch = y.call(t, "*")),
                            y.call(t, "[s!='']:x"),
                            v.push("!=", R);
                        }),
                      (g = g.length && new RegExp(g.join("|"))),
                      (v = v.length && new RegExp(v.join("|"))),
                      (e = K.test(f.compareDocumentPosition)),
                      (b =
                        e || K.test(f.contains)
                          ? function (t, e) {
                              var i = 9 === t.nodeType ? t.documentElement : t,
                                n = e && e.parentNode;
                              return (
                                t === n ||
                                !(
                                  !n ||
                                  1 !== n.nodeType ||
                                  !(i.contains
                                    ? i.contains(n)
                                    : t.compareDocumentPosition &&
                                      16 & t.compareDocumentPosition(n))
                                )
                              );
                            }
                          : function (t, e) {
                              if (e)
                                for (; (e = e.parentNode); )
                                  if (e === t) return !0;
                              return !1;
                            }),
                      (T = e
                        ? function (t, e) {
                            if (t === e) return (d = !0), 0;
                            var n =
                              !t.compareDocumentPosition -
                              !e.compareDocumentPosition;
                            return (
                              n ||
                              (1 &
                                (n =
                                  (t.ownerDocument || t) ==
                                  (e.ownerDocument || e)
                                    ? t.compareDocumentPosition(e)
                                    : 1) ||
                              (!i.sortDetached &&
                                e.compareDocumentPosition(t) === n)
                                ? t == p || (t.ownerDocument == _ && b(_, t))
                                  ? -1
                                  : e == p || (e.ownerDocument == _ && b(_, e))
                                  ? 1
                                  : h
                                  ? F(h, t) - F(h, e)
                                  : 0
                                : 4 & n
                                ? -1
                                : 1)
                            );
                          }
                        : function (t, e) {
                            if (t === e) return (d = !0), 0;
                            var i,
                              n = 0,
                              s = t.parentNode,
                              o = e.parentNode,
                              r = [t],
                              a = [e];
                            if (!s || !o)
                              return t == p
                                ? -1
                                : e == p
                                ? 1
                                : s
                                ? -1
                                : o
                                ? 1
                                : h
                                ? F(h, t) - F(h, e)
                                : 0;
                            if (s === o) return ut(t, e);
                            for (i = t; (i = i.parentNode); ) r.unshift(i);
                            for (i = e; (i = i.parentNode); ) a.unshift(i);
                            for (; r[n] === a[n]; ) n++;
                            return n
                              ? ut(r[n], a[n])
                              : r[n] == _
                              ? -1
                              : a[n] == _
                              ? 1
                              : 0;
                          }),
                      p)
                    : p;
                }),
              (at.matches = function (t, e) {
                return at(t, null, null, e);
              }),
              (at.matchesSelector = function (t, e) {
                if (
                  (u(t),
                  i.matchesSelector &&
                    m &&
                    !A[e + " "] &&
                    (!v || !v.test(e)) &&
                    (!g || !g.test(e)))
                )
                  try {
                    var n = y.call(t, e);
                    if (
                      n ||
                      i.disconnectedMatch ||
                      (t.document && 11 !== t.document.nodeType)
                    )
                      return n;
                  } catch (t) {
                    A(e, !0);
                  }
                return at(e, p, null, [t]).length > 0;
              }),
              (at.contains = function (t, e) {
                return (t.ownerDocument || t) != p && u(t), b(t, e);
              }),
              (at.attr = function (t, e) {
                (t.ownerDocument || t) != p && u(t);
                var s = n.attrHandle[e.toLowerCase()],
                  o =
                    s && L.call(n.attrHandle, e.toLowerCase())
                      ? s(t, e, !m)
                      : void 0;
                return void 0 !== o
                  ? o
                  : i.attributes || !m
                  ? t.getAttribute(e)
                  : (o = t.getAttributeNode(e)) && o.specified
                  ? o.value
                  : null;
              }),
              (at.escape = function (t) {
                return (t + "").replace(nt, st);
              }),
              (at.error = function (t) {
                throw new Error("Syntax error, unrecognized expression: " + t);
              }),
              (at.uniqueSort = function (t) {
                var e,
                  n = [],
                  s = 0,
                  o = 0;
                if (
                  ((d = !i.detectDuplicates),
                  (h = !i.sortStable && t.slice(0)),
                  t.sort(T),
                  d)
                ) {
                  for (; (e = t[o++]); ) e === t[o] && (s = n.push(o));
                  for (; s--; ) t.splice(n[s], 1);
                }
                return (h = null), t;
              }),
              (s = at.getText =
                function (t) {
                  var e,
                    i = "",
                    n = 0,
                    o = t.nodeType;
                  if (o) {
                    if (1 === o || 9 === o || 11 === o) {
                      if ("string" == typeof t.textContent)
                        return t.textContent;
                      for (t = t.firstChild; t; t = t.nextSibling) i += s(t);
                    } else if (3 === o || 4 === o) return t.nodeValue;
                  } else for (; (e = t[n++]); ) i += s(e);
                  return i;
                }),
              (n = at.selectors =
                {
                  cacheLength: 50,
                  createPseudo: ct,
                  match: X,
                  attrHandle: {},
                  find: {},
                  relative: {
                    ">": { dir: "parentNode", first: !0 },
                    " ": { dir: "parentNode" },
                    "+": { dir: "previousSibling", first: !0 },
                    "~": { dir: "previousSibling" },
                  },
                  preFilter: {
                    ATTR: function (t) {
                      return (
                        (t[1] = t[1].replace(et, it)),
                        (t[3] = (t[3] || t[4] || t[5] || "").replace(et, it)),
                        "~=" === t[2] && (t[3] = " " + t[3] + " "),
                        t.slice(0, 4)
                      );
                    },
                    CHILD: function (t) {
                      return (
                        (t[1] = t[1].toLowerCase()),
                        "nth" === t[1].slice(0, 3)
                          ? (t[3] || at.error(t[0]),
                            (t[4] = +(t[4]
                              ? t[5] + (t[6] || 1)
                              : 2 * ("even" === t[3] || "odd" === t[3]))),
                            (t[5] = +(t[7] + t[8] || "odd" === t[3])))
                          : t[3] && at.error(t[0]),
                        t
                      );
                    },
                    PSEUDO: function (t) {
                      var e,
                        i = !t[6] && t[2];
                      return X.CHILD.test(t[0])
                        ? null
                        : (t[3]
                            ? (t[2] = t[4] || t[5] || "")
                            : i &&
                              V.test(i) &&
                              (e = r(i, !0)) &&
                              (e = i.indexOf(")", i.length - e) - i.length) &&
                              ((t[0] = t[0].slice(0, e)),
                              (t[2] = i.slice(0, e))),
                          t.slice(0, 3));
                    },
                  },
                  filter: {
                    TAG: function (t) {
                      var e = t.replace(et, it).toLowerCase();
                      return "*" === t
                        ? function () {
                            return !0;
                          }
                        : function (t) {
                            return t.nodeName && t.nodeName.toLowerCase() === e;
                          };
                    },
                    CLASS: function (t) {
                      var e = k[t + " "];
                      return (
                        e ||
                        ((e = new RegExp(
                          "(^|" + $ + ")" + t + "(" + $ + "|$)"
                        )) &&
                          k(t, function (t) {
                            return e.test(
                              ("string" == typeof t.className && t.className) ||
                                (void 0 !== t.getAttribute &&
                                  t.getAttribute("class")) ||
                                ""
                            );
                          }))
                      );
                    },
                    ATTR: function (t, e, i) {
                      return function (n) {
                        var s = at.attr(n, t);
                        return null == s
                          ? "!=" === e
                          : !e ||
                              ((s += ""),
                              "=" === e
                                ? s === i
                                : "!=" === e
                                ? s !== i
                                : "^=" === e
                                ? i && 0 === s.indexOf(i)
                                : "*=" === e
                                ? i && s.indexOf(i) > -1
                                : "$=" === e
                                ? i && s.slice(-i.length) === i
                                : "~=" === e
                                ? (" " + s.replace(z, " ") + " ").indexOf(i) >
                                  -1
                                : "|=" === e &&
                                  (s === i ||
                                    s.slice(0, i.length + 1) === i + "-"));
                      };
                    },
                    CHILD: function (t, e, i, n, s) {
                      var o = "nth" !== t.slice(0, 3),
                        r = "last" !== t.slice(-4),
                        a = "of-type" === e;
                      return 1 === n && 0 === s
                        ? function (t) {
                            return !!t.parentNode;
                          }
                        : function (e, i, l) {
                            var c,
                              h,
                              d,
                              u,
                              p,
                              f,
                              m = o !== r ? "nextSibling" : "previousSibling",
                              g = e.parentNode,
                              v = a && e.nodeName.toLowerCase(),
                              y = !l && !a,
                              b = !1;
                            if (g) {
                              if (o) {
                                for (; m; ) {
                                  for (u = e; (u = u[m]); )
                                    if (
                                      a
                                        ? u.nodeName.toLowerCase() === v
                                        : 1 === u.nodeType
                                    )
                                      return !1;
                                  f = m = "only" === t && !f && "nextSibling";
                                }
                                return !0;
                              }
                              if (
                                ((f = [r ? g.firstChild : g.lastChild]), r && y)
                              ) {
                                for (
                                  b =
                                    (p =
                                      (c =
                                        (h =
                                          (d = (u = g)[w] || (u[w] = {}))[
                                            u.uniqueID
                                          ] || (d[u.uniqueID] = {}))[t] ||
                                        [])[0] === S && c[1]) && c[2],
                                    u = p && g.childNodes[p];
                                  (u =
                                    (++p && u && u[m]) ||
                                    (b = p = 0) ||
                                    f.pop());

                                )
                                  if (1 === u.nodeType && ++b && u === e) {
                                    h[t] = [S, p, b];
                                    break;
                                  }
                              } else if (
                                (y &&
                                  (b = p =
                                    (c =
                                      (h =
                                        (d = (u = e)[w] || (u[w] = {}))[
                                          u.uniqueID
                                        ] || (d[u.uniqueID] = {}))[t] ||
                                      [])[0] === S && c[1]),
                                !1 === b)
                              )
                                for (
                                  ;
                                  (u =
                                    (++p && u && u[m]) ||
                                    (b = p = 0) ||
                                    f.pop()) &&
                                  ((a
                                    ? u.nodeName.toLowerCase() !== v
                                    : 1 !== u.nodeType) ||
                                    !++b ||
                                    (y &&
                                      ((h =
                                        (d = u[w] || (u[w] = {}))[u.uniqueID] ||
                                        (d[u.uniqueID] = {}))[t] = [S, b]),
                                    u !== e));

                                );
                              return (
                                (b -= s) === n || (b % n == 0 && b / n >= 0)
                              );
                            }
                          };
                    },
                    PSEUDO: function (t, e) {
                      var i,
                        s =
                          n.pseudos[t] ||
                          n.setFilters[t.toLowerCase()] ||
                          at.error("unsupported pseudo: " + t);
                      return s[w]
                        ? s(e)
                        : s.length > 1
                        ? ((i = [t, t, "", e]),
                          n.setFilters.hasOwnProperty(t.toLowerCase())
                            ? ct(function (t, i) {
                                for (var n, o = s(t, e), r = o.length; r--; )
                                  t[(n = F(t, o[r]))] = !(i[n] = o[r]);
                              })
                            : function (t) {
                                return s(t, 0, i);
                              })
                        : s;
                    },
                  },
                  pseudos: {
                    not: ct(function (t) {
                      var e = [],
                        i = [],
                        n = a(t.replace(H, "$1"));
                      return n[w]
                        ? ct(function (t, e, i, s) {
                            for (
                              var o, r = n(t, null, s, []), a = t.length;
                              a--;

                            )
                              (o = r[a]) && (t[a] = !(e[a] = o));
                          })
                        : function (t, s, o) {
                            return (
                              (e[0] = t),
                              n(e, null, o, i),
                              (e[0] = null),
                              !i.pop()
                            );
                          };
                    }),
                    has: ct(function (t) {
                      return function (e) {
                        return at(t, e).length > 0;
                      };
                    }),
                    contains: ct(function (t) {
                      return (
                        (t = t.replace(et, it)),
                        function (e) {
                          return (e.textContent || s(e)).indexOf(t) > -1;
                        }
                      );
                    }),
                    lang: ct(function (t) {
                      return (
                        G.test(t || "") || at.error("unsupported lang: " + t),
                        (t = t.replace(et, it).toLowerCase()),
                        function (e) {
                          var i;
                          do {
                            if (
                              (i = m
                                ? e.lang
                                : e.getAttribute("xml:lang") ||
                                  e.getAttribute("lang"))
                            )
                              return (
                                (i = i.toLowerCase()) === t ||
                                0 === i.indexOf(t + "-")
                              );
                          } while ((e = e.parentNode) && 1 === e.nodeType);
                          return !1;
                        }
                      );
                    }),
                    target: function (e) {
                      var i = t.location && t.location.hash;
                      return i && i.slice(1) === e.id;
                    },
                    root: function (t) {
                      return t === f;
                    },
                    focus: function (t) {
                      return (
                        t === p.activeElement &&
                        (!p.hasFocus || p.hasFocus()) &&
                        !!(t.type || t.href || ~t.tabIndex)
                      );
                    },
                    enabled: mt(!1),
                    disabled: mt(!0),
                    checked: function (t) {
                      var e = t.nodeName.toLowerCase();
                      return (
                        ("input" === e && !!t.checked) ||
                        ("option" === e && !!t.selected)
                      );
                    },
                    selected: function (t) {
                      return (
                        t.parentNode && t.parentNode.selectedIndex,
                        !0 === t.selected
                      );
                    },
                    empty: function (t) {
                      for (t = t.firstChild; t; t = t.nextSibling)
                        if (t.nodeType < 6) return !1;
                      return !0;
                    },
                    parent: function (t) {
                      return !n.pseudos.empty(t);
                    },
                    header: function (t) {
                      return Y.test(t.nodeName);
                    },
                    input: function (t) {
                      return Q.test(t.nodeName);
                    },
                    button: function (t) {
                      var e = t.nodeName.toLowerCase();
                      return (
                        ("input" === e && "button" === t.type) || "button" === e
                      );
                    },
                    text: function (t) {
                      var e;
                      return (
                        "input" === t.nodeName.toLowerCase() &&
                        "text" === t.type &&
                        (null == (e = t.getAttribute("type")) ||
                          "text" === e.toLowerCase())
                      );
                    },
                    first: gt(function () {
                      return [0];
                    }),
                    last: gt(function (t, e) {
                      return [e - 1];
                    }),
                    eq: gt(function (t, e, i) {
                      return [i < 0 ? i + e : i];
                    }),
                    even: gt(function (t, e) {
                      for (var i = 0; i < e; i += 2) t.push(i);
                      return t;
                    }),
                    odd: gt(function (t, e) {
                      for (var i = 1; i < e; i += 2) t.push(i);
                      return t;
                    }),
                    lt: gt(function (t, e, i) {
                      for (var n = i < 0 ? i + e : i > e ? e : i; --n >= 0; )
                        t.push(n);
                      return t;
                    }),
                    gt: gt(function (t, e, i) {
                      for (var n = i < 0 ? i + e : i; ++n < e; ) t.push(n);
                      return t;
                    }),
                  },
                }),
              (n.pseudos.nth = n.pseudos.eq),
              { radio: !0, checkbox: !0, file: !0, password: !0, image: !0 }))
                n.pseudos[e] = pt(e);
              for (e in { submit: !0, reset: !0 }) n.pseudos[e] = ft(e);
              function yt() {}
              function bt(t) {
                for (var e = 0, i = t.length, n = ""; e < i; e++)
                  n += t[e].value;
                return n;
              }
              function wt(t, e, i) {
                var n = e.dir,
                  s = e.next,
                  o = s || n,
                  r = i && "parentNode" === o,
                  a = C++;
                return e.first
                  ? function (e, i, s) {
                      for (; (e = e[n]); )
                        if (1 === e.nodeType || r) return t(e, i, s);
                      return !1;
                    }
                  : function (e, i, l) {
                      var c,
                        h,
                        d,
                        u = [S, a];
                      if (l) {
                        for (; (e = e[n]); )
                          if ((1 === e.nodeType || r) && t(e, i, l)) return !0;
                      } else
                        for (; (e = e[n]); )
                          if (1 === e.nodeType || r)
                            if (
                              ((h =
                                (d = e[w] || (e[w] = {}))[e.uniqueID] ||
                                (d[e.uniqueID] = {})),
                              s && s === e.nodeName.toLowerCase())
                            )
                              e = e[n] || e;
                            else {
                              if ((c = h[o]) && c[0] === S && c[1] === a)
                                return (u[2] = c[2]);
                              if (((h[o] = u), (u[2] = t(e, i, l)))) return !0;
                            }
                      return !1;
                    };
              }
              function _t(t) {
                return t.length > 1
                  ? function (e, i, n) {
                      for (var s = t.length; s--; )
                        if (!t[s](e, i, n)) return !1;
                      return !0;
                    }
                  : t[0];
              }
              function St(t, e, i, n, s) {
                for (
                  var o, r = [], a = 0, l = t.length, c = null != e;
                  a < l;
                  a++
                )
                  (o = t[a]) &&
                    ((i && !i(o, n, s)) || (r.push(o), c && e.push(a)));
                return r;
              }
              function Ct(t, e, i, n, s, o) {
                return (
                  n && !n[w] && (n = Ct(n)),
                  s && !s[w] && (s = Ct(s, o)),
                  ct(function (o, r, a, l) {
                    var c,
                      h,
                      d,
                      u = [],
                      p = [],
                      f = r.length,
                      m =
                        o ||
                        (function (t, e, i) {
                          for (var n = 0, s = e.length; n < s; n++)
                            at(t, e[n], i);
                          return i;
                        })(e || "*", a.nodeType ? [a] : a, []),
                      g = !t || (!o && e) ? m : St(m, u, t, a, l),
                      v = i ? (s || (o ? t : f || n) ? [] : r) : g;
                    if ((i && i(g, v, a, l), n))
                      for (c = St(v, p), n(c, [], a, l), h = c.length; h--; )
                        (d = c[h]) && (v[p[h]] = !(g[p[h]] = d));
                    if (o) {
                      if (s || t) {
                        if (s) {
                          for (c = [], h = v.length; h--; )
                            (d = v[h]) && c.push((g[h] = d));
                          s(null, (v = []), c, l);
                        }
                        for (h = v.length; h--; )
                          (d = v[h]) &&
                            (c = s ? F(o, d) : u[h]) > -1 &&
                            (o[c] = !(r[c] = d));
                      }
                    } else (v = St(v === r ? v.splice(f, v.length) : v)), s ? s(null, r, v, l) : M.apply(r, v);
                  })
                );
              }
              function kt(t) {
                for (
                  var e,
                    i,
                    s,
                    o = t.length,
                    r = n.relative[t[0].type],
                    a = r || n.relative[" "],
                    l = r ? 1 : 0,
                    h = wt(
                      function (t) {
                        return t === e;
                      },
                      a,
                      !0
                    ),
                    d = wt(
                      function (t) {
                        return F(e, t) > -1;
                      },
                      a,
                      !0
                    ),
                    u = [
                      function (t, i, n) {
                        var s =
                          (!r && (n || i !== c)) ||
                          ((e = i).nodeType ? h(t, i, n) : d(t, i, n));
                        return (e = null), s;
                      },
                    ];
                  l < o;
                  l++
                )
                  if ((i = n.relative[t[l].type])) u = [wt(_t(u), i)];
                  else {
                    if (
                      (i = n.filter[t[l].type].apply(null, t[l].matches))[w]
                    ) {
                      for (s = ++l; s < o && !n.relative[t[s].type]; s++);
                      return Ct(
                        l > 1 && _t(u),
                        l > 1 &&
                          bt(
                            t
                              .slice(0, l - 1)
                              .concat({
                                value: " " === t[l - 2].type ? "*" : "",
                              })
                          ).replace(H, "$1"),
                        i,
                        l < s && kt(t.slice(l, s)),
                        s < o && kt((t = t.slice(s))),
                        s < o && bt(t)
                      );
                    }
                    u.push(i);
                  }
                return _t(u);
              }
              return (
                (yt.prototype = n.filters = n.pseudos),
                (n.setFilters = new yt()),
                (r = at.tokenize =
                  function (t, e) {
                    var i,
                      s,
                      o,
                      r,
                      a,
                      l,
                      c,
                      h = x[t + " "];
                    if (h) return e ? 0 : h.slice(0);
                    for (a = t, l = [], c = n.preFilter; a; ) {
                      for (r in ((i && !(s = U.exec(a))) ||
                        (s && (a = a.slice(s[0].length) || a),
                        l.push((o = []))),
                      (i = !1),
                      (s = j.exec(a)) &&
                        ((i = s.shift()),
                        o.push({ value: i, type: s[0].replace(H, " ") }),
                        (a = a.slice(i.length))),
                      n.filter))
                        !(s = X[r].exec(a)) ||
                          (c[r] && !(s = c[r](s))) ||
                          ((i = s.shift()),
                          o.push({ value: i, type: r, matches: s }),
                          (a = a.slice(i.length)));
                      if (!i) break;
                    }
                    return e ? a.length : a ? at.error(t) : x(t, l).slice(0);
                  }),
                (a = at.compile =
                  function (t, e) {
                    var i,
                      s = [],
                      o = [],
                      a = E[t + " "];
                    if (!a) {
                      for (e || (e = r(t)), i = e.length; i--; )
                        (a = kt(e[i]))[w] ? s.push(a) : o.push(a);
                      (a = E(
                        t,
                        (function (t, e) {
                          var i = e.length > 0,
                            s = t.length > 0,
                            o = function (o, r, a, l, h) {
                              var d,
                                f,
                                g,
                                v = 0,
                                y = "0",
                                b = o && [],
                                w = [],
                                _ = c,
                                C = o || (s && n.find.TAG("*", h)),
                                k = (S += null == _ ? 1 : Math.random() || 0.1),
                                x = C.length;
                              for (
                                h && (c = r == p || r || h);
                                y !== x && null != (d = C[y]);
                                y++
                              ) {
                                if (s && d) {
                                  for (
                                    f = 0,
                                      r ||
                                        d.ownerDocument == p ||
                                        (u(d), (a = !m));
                                    (g = t[f++]);

                                  )
                                    if (g(d, r || p, a)) {
                                      l.push(d);
                                      break;
                                    }
                                  h && (S = k);
                                }
                                i && ((d = !g && d) && v--, o && b.push(d));
                              }
                              if (((v += y), i && y !== v)) {
                                for (f = 0; (g = e[f++]); ) g(b, w, r, a);
                                if (o) {
                                  if (v > 0)
                                    for (; y--; )
                                      b[y] || w[y] || (w[y] = I.call(l));
                                  w = St(w);
                                }
                                M.apply(l, w),
                                  h &&
                                    !o &&
                                    w.length > 0 &&
                                    v + e.length > 1 &&
                                    at.uniqueSort(l);
                              }
                              return h && ((S = k), (c = _)), b;
                            };
                          return i ? ct(o) : o;
                        })(o, s)
                      )),
                        (a.selector = t);
                    }
                    return a;
                  }),
                (l = at.select =
                  function (t, e, i, s) {
                    var o,
                      l,
                      c,
                      h,
                      d,
                      u = "function" == typeof t && t,
                      p = !s && r((t = u.selector || t));
                    if (((i = i || []), 1 === p.length)) {
                      if (
                        (l = p[0] = p[0].slice(0)).length > 2 &&
                        "ID" === (c = l[0]).type &&
                        9 === e.nodeType &&
                        m &&
                        n.relative[l[1].type]
                      ) {
                        if (
                          !(e = (n.find.ID(c.matches[0].replace(et, it), e) ||
                            [])[0])
                        )
                          return i;
                        u && (e = e.parentNode),
                          (t = t.slice(l.shift().value.length));
                      }
                      for (
                        o = X.needsContext.test(t) ? 0 : l.length;
                        o-- && ((c = l[o]), !n.relative[(h = c.type)]);

                      )
                        if (
                          (d = n.find[h]) &&
                          (s = d(
                            c.matches[0].replace(et, it),
                            (tt.test(l[0].type) && vt(e.parentNode)) || e
                          ))
                        ) {
                          if ((l.splice(o, 1), !(t = s.length && bt(l))))
                            return M.apply(i, s), i;
                          break;
                        }
                    }
                    return (
                      (u || a(t, p))(
                        s,
                        e,
                        !m,
                        i,
                        !e || (tt.test(t) && vt(e.parentNode)) || e
                      ),
                      i
                    );
                  }),
                (i.sortStable = w.split("").sort(T).join("") === w),
                (i.detectDuplicates = !!d),
                u(),
                (i.sortDetached = ht(function (t) {
                  return (
                    1 & t.compareDocumentPosition(p.createElement("fieldset"))
                  );
                })),
                ht(function (t) {
                  return (
                    (t.innerHTML = "<a href='#'></a>"),
                    "#" === t.firstChild.getAttribute("href")
                  );
                }) ||
                  dt("type|href|height|width", function (t, e, i) {
                    if (!i)
                      return t.getAttribute(
                        e,
                        "type" === e.toLowerCase() ? 1 : 2
                      );
                  }),
                (i.attributes &&
                  ht(function (t) {
                    return (
                      (t.innerHTML = "<input/>"),
                      t.firstChild.setAttribute("value", ""),
                      "" === t.firstChild.getAttribute("value")
                    );
                  })) ||
                  dt("value", function (t, e, i) {
                    if (!i && "input" === t.nodeName.toLowerCase())
                      return t.defaultValue;
                  }),
                ht(function (t) {
                  return null == t.getAttribute("disabled");
                }) ||
                  dt(q, function (t, e, i) {
                    var n;
                    if (!i)
                      return !0 === t[e]
                        ? e.toLowerCase()
                        : (n = t.getAttributeNode(e)) && n.specified
                        ? n.value
                        : null;
                  }),
                at
              );
            })(n);
          (k.find = E),
            (k.expr = E.selectors),
            (k.expr[":"] = k.expr.pseudos),
            (k.uniqueSort = k.unique = E.uniqueSort),
            (k.text = E.getText),
            (k.isXMLDoc = E.isXML),
            (k.contains = E.contains),
            (k.escapeSelector = E.escape);
          var A = function (t, e, i) {
              for (
                var n = [], s = void 0 !== i;
                (t = t[e]) && 9 !== t.nodeType;

              )
                if (1 === t.nodeType) {
                  if (s && k(t).is(i)) break;
                  n.push(t);
                }
              return n;
            },
            T = function (t, e) {
              for (var i = []; t; t = t.nextSibling)
                1 === t.nodeType && t !== e && i.push(t);
              return i;
            },
            L = k.expr.match.needsContext;
          function D(t, e) {
            return t.nodeName && t.nodeName.toLowerCase() === e.toLowerCase();
          }
          var I =
            /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i;
          function P(t, e, i) {
            return v(e)
              ? k.grep(t, function (t, n) {
                  return !!e.call(t, n, t) !== i;
                })
              : e.nodeType
              ? k.grep(t, function (t) {
                  return (t === e) !== i;
                })
              : "string" != typeof e
              ? k.grep(t, function (t) {
                  return h.call(e, t) > -1 !== i;
                })
              : k.filter(e, t, i);
          }
          (k.filter = function (t, e, i) {
            var n = e[0];
            return (
              i && (t = ":not(" + t + ")"),
              1 === e.length && 1 === n.nodeType
                ? k.find.matchesSelector(n, t)
                  ? [n]
                  : []
                : k.find.matches(
                    t,
                    k.grep(e, function (t) {
                      return 1 === t.nodeType;
                    })
                  )
            );
          }),
            k.fn.extend({
              find: function (t) {
                var e,
                  i,
                  n = this.length,
                  s = this;
                if ("string" != typeof t)
                  return this.pushStack(
                    k(t).filter(function () {
                      for (e = 0; e < n; e++)
                        if (k.contains(s[e], this)) return !0;
                    })
                  );
                for (i = this.pushStack([]), e = 0; e < n; e++)
                  k.find(t, s[e], i);
                return n > 1 ? k.uniqueSort(i) : i;
              },
              filter: function (t) {
                return this.pushStack(P(this, t || [], !1));
              },
              not: function (t) {
                return this.pushStack(P(this, t || [], !0));
              },
              is: function (t) {
                return !!P(
                  this,
                  "string" == typeof t && L.test(t) ? k(t) : t || [],
                  !1
                ).length;
              },
            });
          var M,
            O = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/;
          ((k.fn.init = function (t, e, i) {
            var n, s;
            if (!t) return this;
            if (((i = i || M), "string" == typeof t)) {
              if (
                !(n =
                  "<" === t[0] && ">" === t[t.length - 1] && t.length >= 3
                    ? [null, t, null]
                    : O.exec(t)) ||
                (!n[1] && e)
              )
                return !e || e.jquery
                  ? (e || i).find(t)
                  : this.constructor(e).find(t);
              if (n[1]) {
                if (
                  ((e = e instanceof k ? e[0] : e),
                  k.merge(
                    this,
                    k.parseHTML(
                      n[1],
                      e && e.nodeType ? e.ownerDocument || e : b,
                      !0
                    )
                  ),
                  I.test(n[1]) && k.isPlainObject(e))
                )
                  for (n in e) v(this[n]) ? this[n](e[n]) : this.attr(n, e[n]);
                return this;
              }
              return (
                (s = b.getElementById(n[2])) &&
                  ((this[0] = s), (this.length = 1)),
                this
              );
            }
            return t.nodeType
              ? ((this[0] = t), (this.length = 1), this)
              : v(t)
              ? void 0 !== i.ready
                ? i.ready(t)
                : t(k)
              : k.makeArray(t, this);
          }).prototype = k.fn),
            (M = k(b));
          var F = /^(?:parents|prev(?:Until|All))/,
            q = { children: !0, contents: !0, next: !0, prev: !0 };
          function $(t, e) {
            for (; (t = t[e]) && 1 !== t.nodeType; );
            return t;
          }
          k.fn.extend({
            has: function (t) {
              var e = k(t, this),
                i = e.length;
              return this.filter(function () {
                for (var t = 0; t < i; t++)
                  if (k.contains(this, e[t])) return !0;
              });
            },
            closest: function (t, e) {
              var i,
                n = 0,
                s = this.length,
                o = [],
                r = "string" != typeof t && k(t);
              if (!L.test(t))
                for (; n < s; n++)
                  for (i = this[n]; i && i !== e; i = i.parentNode)
                    if (
                      i.nodeType < 11 &&
                      (r
                        ? r.index(i) > -1
                        : 1 === i.nodeType && k.find.matchesSelector(i, t))
                    ) {
                      o.push(i);
                      break;
                    }
              return this.pushStack(o.length > 1 ? k.uniqueSort(o) : o);
            },
            index: function (t) {
              return t
                ? "string" == typeof t
                  ? h.call(k(t), this[0])
                  : h.call(this, t.jquery ? t[0] : t)
                : this[0] && this[0].parentNode
                ? this.first().prevAll().length
                : -1;
            },
            add: function (t, e) {
              return this.pushStack(k.uniqueSort(k.merge(this.get(), k(t, e))));
            },
            addBack: function (t) {
              return this.add(
                null == t ? this.prevObject : this.prevObject.filter(t)
              );
            },
          }),
            k.each(
              {
                parent: function (t) {
                  var e = t.parentNode;
                  return e && 11 !== e.nodeType ? e : null;
                },
                parents: function (t) {
                  return A(t, "parentNode");
                },
                parentsUntil: function (t, e, i) {
                  return A(t, "parentNode", i);
                },
                next: function (t) {
                  return $(t, "nextSibling");
                },
                prev: function (t) {
                  return $(t, "previousSibling");
                },
                nextAll: function (t) {
                  return A(t, "nextSibling");
                },
                prevAll: function (t) {
                  return A(t, "previousSibling");
                },
                nextUntil: function (t, e, i) {
                  return A(t, "nextSibling", i);
                },
                prevUntil: function (t, e, i) {
                  return A(t, "previousSibling", i);
                },
                siblings: function (t) {
                  return T((t.parentNode || {}).firstChild, t);
                },
                children: function (t) {
                  return T(t.firstChild);
                },
                contents: function (t) {
                  return null != t.contentDocument && r(t.contentDocument)
                    ? t.contentDocument
                    : (D(t, "template") && (t = t.content || t),
                      k.merge([], t.childNodes));
                },
              },
              function (t, e) {
                k.fn[t] = function (i, n) {
                  var s = k.map(this, e, i);
                  return (
                    "Until" !== t.slice(-5) && (n = i),
                    n && "string" == typeof n && (s = k.filter(n, s)),
                    this.length > 1 &&
                      (q[t] || k.uniqueSort(s), F.test(t) && s.reverse()),
                    this.pushStack(s)
                  );
                };
              }
            );
          var B = /[^\x20\t\r\n\f]+/g;
          function N(t) {
            return t;
          }
          function R(t) {
            throw t;
          }
          function z(t, e, i, n) {
            var s;
            try {
              t && v((s = t.promise))
                ? s.call(t).done(e).fail(i)
                : t && v((s = t.then))
                ? s.call(t, e, i)
                : e.apply(void 0, [t].slice(n));
            } catch (t) {
              i.apply(void 0, [t]);
            }
          }
          (k.Callbacks = function (t) {
            t =
              "string" == typeof t
                ? (function (t) {
                    var e = {};
                    return (
                      k.each(t.match(B) || [], function (t, i) {
                        e[i] = !0;
                      }),
                      e
                    );
                  })(t)
                : k.extend({}, t);
            var e,
              i,
              n,
              s,
              o = [],
              r = [],
              a = -1,
              l = function () {
                for (s = s || t.once, n = e = !0; r.length; a = -1)
                  for (i = r.shift(); ++a < o.length; )
                    !1 === o[a].apply(i[0], i[1]) &&
                      t.stopOnFalse &&
                      ((a = o.length), (i = !1));
                t.memory || (i = !1), (e = !1), s && (o = i ? [] : "");
              },
              c = {
                add: function () {
                  return (
                    o &&
                      (i && !e && ((a = o.length - 1), r.push(i)),
                      (function e(i) {
                        k.each(i, function (i, n) {
                          v(n)
                            ? (t.unique && c.has(n)) || o.push(n)
                            : n && n.length && "string" !== S(n) && e(n);
                        });
                      })(arguments),
                      i && !e && l()),
                    this
                  );
                },
                remove: function () {
                  return (
                    k.each(arguments, function (t, e) {
                      for (var i; (i = k.inArray(e, o, i)) > -1; )
                        o.splice(i, 1), i <= a && a--;
                    }),
                    this
                  );
                },
                has: function (t) {
                  return t ? k.inArray(t, o) > -1 : o.length > 0;
                },
                empty: function () {
                  return o && (o = []), this;
                },
                disable: function () {
                  return (s = r = []), (o = i = ""), this;
                },
                disabled: function () {
                  return !o;
                },
                lock: function () {
                  return (s = r = []), i || e || (o = i = ""), this;
                },
                locked: function () {
                  return !!s;
                },
                fireWith: function (t, i) {
                  return (
                    s ||
                      ((i = [t, (i = i || []).slice ? i.slice() : i]),
                      r.push(i),
                      e || l()),
                    this
                  );
                },
                fire: function () {
                  return c.fireWith(this, arguments), this;
                },
                fired: function () {
                  return !!n;
                },
              };
            return c;
          }),
            k.extend({
              Deferred: function (t) {
                var e = [
                    [
                      "notify",
                      "progress",
                      k.Callbacks("memory"),
                      k.Callbacks("memory"),
                      2,
                    ],
                    [
                      "resolve",
                      "done",
                      k.Callbacks("once memory"),
                      k.Callbacks("once memory"),
                      0,
                      "resolved",
                    ],
                    [
                      "reject",
                      "fail",
                      k.Callbacks("once memory"),
                      k.Callbacks("once memory"),
                      1,
                      "rejected",
                    ],
                  ],
                  i = "pending",
                  s = {
                    state: function () {
                      return i;
                    },
                    always: function () {
                      return o.done(arguments).fail(arguments), this;
                    },
                    catch: function (t) {
                      return s.then(null, t);
                    },
                    pipe: function () {
                      var t = arguments;
                      return k
                        .Deferred(function (i) {
                          k.each(e, function (e, n) {
                            var s = v(t[n[4]]) && t[n[4]];
                            o[n[1]](function () {
                              var t = s && s.apply(this, arguments);
                              t && v(t.promise)
                                ? t
                                    .promise()
                                    .progress(i.notify)
                                    .done(i.resolve)
                                    .fail(i.reject)
                                : i[n[0] + "With"](this, s ? [t] : arguments);
                            });
                          }),
                            (t = null);
                        })
                        .promise();
                    },
                    then: function (t, i, s) {
                      var o = 0;
                      function r(t, e, i, s) {
                        return function () {
                          var a = this,
                            l = arguments,
                            c = function () {
                              var n, c;
                              if (!(t < o)) {
                                if ((n = i.apply(a, l)) === e.promise())
                                  throw new TypeError(
                                    "Thenable self-resolution"
                                  );
                                (c =
                                  n &&
                                  ("object" == typeof n ||
                                    "function" == typeof n) &&
                                  n.then),
                                  v(c)
                                    ? s
                                      ? c.call(n, r(o, e, N, s), r(o, e, R, s))
                                      : (o++,
                                        c.call(
                                          n,
                                          r(o, e, N, s),
                                          r(o, e, R, s),
                                          r(o, e, N, e.notifyWith)
                                        ))
                                    : (i !== N && ((a = void 0), (l = [n])),
                                      (s || e.resolveWith)(a, l));
                              }
                            },
                            h = s
                              ? c
                              : function () {
                                  try {
                                    c();
                                  } catch (n) {
                                    k.Deferred.exceptionHook &&
                                      k.Deferred.exceptionHook(n, h.stackTrace),
                                      t + 1 >= o &&
                                        (i !== R && ((a = void 0), (l = [n])),
                                        e.rejectWith(a, l));
                                  }
                                };
                          t
                            ? h()
                            : (k.Deferred.getStackHook &&
                                (h.stackTrace = k.Deferred.getStackHook()),
                              n.setTimeout(h));
                        };
                      }
                      return k
                        .Deferred(function (n) {
                          e[0][3].add(r(0, n, v(s) ? s : N, n.notifyWith)),
                            e[1][3].add(r(0, n, v(t) ? t : N)),
                            e[2][3].add(r(0, n, v(i) ? i : R));
                        })
                        .promise();
                    },
                    promise: function (t) {
                      return null != t ? k.extend(t, s) : s;
                    },
                  },
                  o = {};
                return (
                  k.each(e, function (t, n) {
                    var r = n[2],
                      a = n[5];
                    (s[n[1]] = r.add),
                      a &&
                        r.add(
                          function () {
                            i = a;
                          },
                          e[3 - t][2].disable,
                          e[3 - t][3].disable,
                          e[0][2].lock,
                          e[0][3].lock
                        ),
                      r.add(n[3].fire),
                      (o[n[0]] = function () {
                        return (
                          o[n[0] + "With"](
                            this === o ? void 0 : this,
                            arguments
                          ),
                          this
                        );
                      }),
                      (o[n[0] + "With"] = r.fireWith);
                  }),
                  s.promise(o),
                  t && t.call(o, o),
                  o
                );
              },
              when: function (t) {
                var e = arguments.length,
                  i = e,
                  n = Array(i),
                  s = a.call(arguments),
                  o = k.Deferred(),
                  r = function (t) {
                    return function (i) {
                      (n[t] = this),
                        (s[t] = arguments.length > 1 ? a.call(arguments) : i),
                        --e || o.resolveWith(n, s);
                    };
                  };
                if (
                  e <= 1 &&
                  (z(t, o.done(r(i)).resolve, o.reject, !e),
                  "pending" === o.state() || v(s[i] && s[i].then))
                )
                  return o.then();
                for (; i--; ) z(s[i], r(i), o.reject);
                return o.promise();
              },
            });
          var H = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;
          (k.Deferred.exceptionHook = function (t, e) {
            n.console &&
              n.console.warn &&
              t &&
              H.test(t.name) &&
              n.console.warn(
                "jQuery.Deferred exception: " + t.message,
                t.stack,
                e
              );
          }),
            (k.readyException = function (t) {
              n.setTimeout(function () {
                throw t;
              });
            });
          var U = k.Deferred();
          function j() {
            b.removeEventListener("DOMContentLoaded", j),
              n.removeEventListener("load", j),
              k.ready();
          }
          (k.fn.ready = function (t) {
            return (
              U.then(t).catch(function (t) {
                k.readyException(t);
              }),
              this
            );
          }),
            k.extend({
              isReady: !1,
              readyWait: 1,
              ready: function (t) {
                (!0 === t ? --k.readyWait : k.isReady) ||
                  ((k.isReady = !0),
                  (!0 !== t && --k.readyWait > 0) || U.resolveWith(b, [k]));
              },
            }),
            (k.ready.then = U.then),
            "complete" === b.readyState ||
            ("loading" !== b.readyState && !b.documentElement.doScroll)
              ? n.setTimeout(k.ready)
              : (b.addEventListener("DOMContentLoaded", j),
                n.addEventListener("load", j));
          var W = function (t, e, i, n, s, o, r) {
              var a = 0,
                l = t.length,
                c = null == i;
              if ("object" === S(i))
                for (a in ((s = !0), i)) W(t, e, a, i[a], !0, o, r);
              else if (
                void 0 !== n &&
                ((s = !0),
                v(n) || (r = !0),
                c &&
                  (r
                    ? (e.call(t, n), (e = null))
                    : ((c = e),
                      (e = function (t, e, i) {
                        return c.call(k(t), i);
                      }))),
                e)
              )
                for (; a < l; a++)
                  e(t[a], i, r ? n : n.call(t[a], a, e(t[a], i)));
              return s ? t : c ? e.call(t) : l ? e(t[0], i) : o;
            },
            V = /^-ms-/,
            G = /-([a-z])/g;
          function X(t, e) {
            return e.toUpperCase();
          }
          function Z(t) {
            return t.replace(V, "ms-").replace(G, X);
          }
          var Q = function (t) {
            return 1 === t.nodeType || 9 === t.nodeType || !+t.nodeType;
          };
          function Y() {
            this.expando = k.expando + Y.uid++;
          }
          (Y.uid = 1),
            (Y.prototype = {
              cache: function (t) {
                var e = t[this.expando];
                return (
                  e ||
                    ((e = {}),
                    Q(t) &&
                      (t.nodeType
                        ? (t[this.expando] = e)
                        : Object.defineProperty(t, this.expando, {
                            value: e,
                            configurable: !0,
                          }))),
                  e
                );
              },
              set: function (t, e, i) {
                var n,
                  s = this.cache(t);
                if ("string" == typeof e) s[Z(e)] = i;
                else for (n in e) s[Z(n)] = e[n];
                return s;
              },
              get: function (t, e) {
                return void 0 === e
                  ? this.cache(t)
                  : t[this.expando] && t[this.expando][Z(e)];
              },
              access: function (t, e, i) {
                return void 0 === e ||
                  (e && "string" == typeof e && void 0 === i)
                  ? this.get(t, e)
                  : (this.set(t, e, i), void 0 !== i ? i : e);
              },
              remove: function (t, e) {
                var i,
                  n = t[this.expando];
                if (void 0 !== n) {
                  if (void 0 !== e) {
                    i = (e = Array.isArray(e)
                      ? e.map(Z)
                      : (e = Z(e)) in n
                      ? [e]
                      : e.match(B) || []).length;
                    for (; i--; ) delete n[e[i]];
                  }
                  (void 0 === e || k.isEmptyObject(n)) &&
                    (t.nodeType
                      ? (t[this.expando] = void 0)
                      : delete t[this.expando]);
                }
              },
              hasData: function (t) {
                var e = t[this.expando];
                return void 0 !== e && !k.isEmptyObject(e);
              },
            });
          var K = new Y(),
            J = new Y(),
            tt = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
            et = /[A-Z]/g;
          function it(t, e, i) {
            var n;
            if (void 0 === i && 1 === t.nodeType)
              if (
                ((n = "data-" + e.replace(et, "-$&").toLowerCase()),
                "string" == typeof (i = t.getAttribute(n)))
              ) {
                try {
                  i = (function (t) {
                    return (
                      "true" === t ||
                      ("false" !== t &&
                        ("null" === t
                          ? null
                          : t === +t + ""
                          ? +t
                          : tt.test(t)
                          ? JSON.parse(t)
                          : t))
                    );
                  })(i);
                } catch (t) {}
                J.set(t, e, i);
              } else i = void 0;
            return i;
          }
          k.extend({
            hasData: function (t) {
              return J.hasData(t) || K.hasData(t);
            },
            data: function (t, e, i) {
              return J.access(t, e, i);
            },
            removeData: function (t, e) {
              J.remove(t, e);
            },
            _data: function (t, e, i) {
              return K.access(t, e, i);
            },
            _removeData: function (t, e) {
              K.remove(t, e);
            },
          }),
            k.fn.extend({
              data: function (t, e) {
                var i,
                  n,
                  s,
                  o = this[0],
                  r = o && o.attributes;
                if (void 0 === t) {
                  if (
                    this.length &&
                    ((s = J.get(o)),
                    1 === o.nodeType && !K.get(o, "hasDataAttrs"))
                  ) {
                    for (i = r.length; i--; )
                      r[i] &&
                        0 === (n = r[i].name).indexOf("data-") &&
                        ((n = Z(n.slice(5))), it(o, n, s[n]));
                    K.set(o, "hasDataAttrs", !0);
                  }
                  return s;
                }
                return "object" == typeof t
                  ? this.each(function () {
                      J.set(this, t);
                    })
                  : W(
                      this,
                      function (e) {
                        var i;
                        if (o && void 0 === e)
                          return void 0 !== (i = J.get(o, t)) ||
                            void 0 !== (i = it(o, t))
                            ? i
                            : void 0;
                        this.each(function () {
                          J.set(this, t, e);
                        });
                      },
                      null,
                      e,
                      arguments.length > 1,
                      null,
                      !0
                    );
              },
              removeData: function (t) {
                return this.each(function () {
                  J.remove(this, t);
                });
              },
            }),
            k.extend({
              queue: function (t, e, i) {
                var n;
                if (t)
                  return (
                    (e = (e || "fx") + "queue"),
                    (n = K.get(t, e)),
                    i &&
                      (!n || Array.isArray(i)
                        ? (n = K.access(t, e, k.makeArray(i)))
                        : n.push(i)),
                    n || []
                  );
              },
              dequeue: function (t, e) {
                e = e || "fx";
                var i = k.queue(t, e),
                  n = i.length,
                  s = i.shift(),
                  o = k._queueHooks(t, e);
                "inprogress" === s && ((s = i.shift()), n--),
                  s &&
                    ("fx" === e && i.unshift("inprogress"),
                    delete o.stop,
                    s.call(
                      t,
                      function () {
                        k.dequeue(t, e);
                      },
                      o
                    )),
                  !n && o && o.empty.fire();
              },
              _queueHooks: function (t, e) {
                var i = e + "queueHooks";
                return (
                  K.get(t, i) ||
                  K.access(t, i, {
                    empty: k.Callbacks("once memory").add(function () {
                      K.remove(t, [e + "queue", i]);
                    }),
                  })
                );
              },
            }),
            k.fn.extend({
              queue: function (t, e) {
                var i = 2;
                return (
                  "string" != typeof t && ((e = t), (t = "fx"), i--),
                  arguments.length < i
                    ? k.queue(this[0], t)
                    : void 0 === e
                    ? this
                    : this.each(function () {
                        var i = k.queue(this, t, e);
                        k._queueHooks(this, t),
                          "fx" === t &&
                            "inprogress" !== i[0] &&
                            k.dequeue(this, t);
                      })
                );
              },
              dequeue: function (t) {
                return this.each(function () {
                  k.dequeue(this, t);
                });
              },
              clearQueue: function (t) {
                return this.queue(t || "fx", []);
              },
              promise: function (t, e) {
                var i,
                  n = 1,
                  s = k.Deferred(),
                  o = this,
                  r = this.length,
                  a = function () {
                    --n || s.resolveWith(o, [o]);
                  };
                for (
                  "string" != typeof t && ((e = t), (t = void 0)),
                    t = t || "fx";
                  r--;

                )
                  (i = K.get(o[r], t + "queueHooks")) &&
                    i.empty &&
                    (n++, i.empty.add(a));
                return a(), s.promise(e);
              },
            });
          var nt = /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source,
            st = new RegExp("^(?:([+-])=|)(" + nt + ")([a-z%]*)$", "i"),
            ot = ["Top", "Right", "Bottom", "Left"],
            rt = b.documentElement,
            at = function (t) {
              return k.contains(t.ownerDocument, t);
            },
            lt = { composed: !0 };
          rt.getRootNode &&
            (at = function (t) {
              return (
                k.contains(t.ownerDocument, t) ||
                t.getRootNode(lt) === t.ownerDocument
              );
            });
          var ct = function (t, e) {
            return (
              "none" === (t = e || t).style.display ||
              ("" === t.style.display &&
                at(t) &&
                "none" === k.css(t, "display"))
            );
          };
          function ht(t, e, i, n) {
            var s,
              o,
              r = 20,
              a = n
                ? function () {
                    return n.cur();
                  }
                : function () {
                    return k.css(t, e, "");
                  },
              l = a(),
              c = (i && i[3]) || (k.cssNumber[e] ? "" : "px"),
              h =
                t.nodeType &&
                (k.cssNumber[e] || ("px" !== c && +l)) &&
                st.exec(k.css(t, e));
            if (h && h[3] !== c) {
              for (l /= 2, c = c || h[3], h = +l || 1; r--; )
                k.style(t, e, h + c),
                  (1 - o) * (1 - (o = a() / l || 0.5)) <= 0 && (r = 0),
                  (h /= o);
              (h *= 2), k.style(t, e, h + c), (i = i || []);
            }
            return (
              i &&
                ((h = +h || +l || 0),
                (s = i[1] ? h + (i[1] + 1) * i[2] : +i[2]),
                n && ((n.unit = c), (n.start = h), (n.end = s))),
              s
            );
          }
          var dt = {};
          function ut(t) {
            var e,
              i = t.ownerDocument,
              n = t.nodeName,
              s = dt[n];
            return (
              s ||
              ((e = i.body.appendChild(i.createElement(n))),
              (s = k.css(e, "display")),
              e.parentNode.removeChild(e),
              "none" === s && (s = "block"),
              (dt[n] = s),
              s)
            );
          }
          function pt(t, e) {
            for (var i, n, s = [], o = 0, r = t.length; o < r; o++)
              (n = t[o]).style &&
                ((i = n.style.display),
                e
                  ? ("none" === i &&
                      ((s[o] = K.get(n, "display") || null),
                      s[o] || (n.style.display = "")),
                    "" === n.style.display && ct(n) && (s[o] = ut(n)))
                  : "none" !== i && ((s[o] = "none"), K.set(n, "display", i)));
            for (o = 0; o < r; o++) null != s[o] && (t[o].style.display = s[o]);
            return t;
          }
          k.fn.extend({
            show: function () {
              return pt(this, !0);
            },
            hide: function () {
              return pt(this);
            },
            toggle: function (t) {
              return "boolean" == typeof t
                ? t
                  ? this.show()
                  : this.hide()
                : this.each(function () {
                    ct(this) ? k(this).show() : k(this).hide();
                  });
            },
          });
          var ft,
            mt,
            gt = /^(?:checkbox|radio)$/i,
            vt = /<([a-z][^\/\0>\x20\t\r\n\f]*)/i,
            yt = /^$|^module$|\/(?:java|ecma)script/i;
          (ft = b.createDocumentFragment().appendChild(b.createElement("div"))),
            (mt = b.createElement("input")).setAttribute("type", "radio"),
            mt.setAttribute("checked", "checked"),
            mt.setAttribute("name", "t"),
            ft.appendChild(mt),
            (g.checkClone = ft.cloneNode(!0).cloneNode(!0).lastChild.checked),
            (ft.innerHTML = "<textarea>x</textarea>"),
            (g.noCloneChecked = !!ft.cloneNode(!0).lastChild.defaultValue),
            (ft.innerHTML = "<option></option>"),
            (g.option = !!ft.lastChild);
          var bt = {
            thead: [1, "<table>", "</table>"],
            col: [2, "<table><colgroup>", "</colgroup></table>"],
            tr: [2, "<table><tbody>", "</tbody></table>"],
            td: [3, "<table><tbody><tr>", "</tr></tbody></table>"],
            _default: [0, "", ""],
          };
          function wt(t, e) {
            var i;
            return (
              (i =
                void 0 !== t.getElementsByTagName
                  ? t.getElementsByTagName(e || "*")
                  : void 0 !== t.querySelectorAll
                  ? t.querySelectorAll(e || "*")
                  : []),
              void 0 === e || (e && D(t, e)) ? k.merge([t], i) : i
            );
          }
          function _t(t, e) {
            for (var i = 0, n = t.length; i < n; i++)
              K.set(t[i], "globalEval", !e || K.get(e[i], "globalEval"));
          }
          (bt.tbody = bt.tfoot = bt.colgroup = bt.caption = bt.thead),
            (bt.th = bt.td),
            g.option ||
              (bt.optgroup = bt.option =
                [1, "<select multiple='multiple'>", "</select>"]);
          var St = /<|&#?\w+;/;
          function Ct(t, e, i, n, s) {
            for (
              var o,
                r,
                a,
                l,
                c,
                h,
                d = e.createDocumentFragment(),
                u = [],
                p = 0,
                f = t.length;
              p < f;
              p++
            )
              if ((o = t[p]) || 0 === o)
                if ("object" === S(o)) k.merge(u, o.nodeType ? [o] : o);
                else if (St.test(o)) {
                  for (
                    r = r || d.appendChild(e.createElement("div")),
                      a = (vt.exec(o) || ["", ""])[1].toLowerCase(),
                      l = bt[a] || bt._default,
                      r.innerHTML = l[1] + k.htmlPrefilter(o) + l[2],
                      h = l[0];
                    h--;

                  )
                    r = r.lastChild;
                  k.merge(u, r.childNodes),
                    ((r = d.firstChild).textContent = "");
                } else u.push(e.createTextNode(o));
            for (d.textContent = "", p = 0; (o = u[p++]); )
              if (n && k.inArray(o, n) > -1) s && s.push(o);
              else if (
                ((c = at(o)),
                (r = wt(d.appendChild(o), "script")),
                c && _t(r),
                i)
              )
                for (h = 0; (o = r[h++]); ) yt.test(o.type || "") && i.push(o);
            return d;
          }
          var kt = /^key/,
            xt = /^(?:mouse|pointer|contextmenu|drag|drop)|click/,
            Et = /^([^.]*)(?:\.(.+)|)/;
          function At() {
            return !0;
          }
          function Tt() {
            return !1;
          }
          function Lt(t, e) {
            return (
              (t ===
                (function () {
                  try {
                    return b.activeElement;
                  } catch (t) {}
                })()) ==
              ("focus" === e)
            );
          }
          function Dt(t, e, i, n, s, o) {
            var r, a;
            if ("object" == typeof e) {
              for (a in ("string" != typeof i && ((n = n || i), (i = void 0)),
              e))
                Dt(t, a, i, n, e[a], o);
              return t;
            }
            if (
              (null == n && null == s
                ? ((s = i), (n = i = void 0))
                : null == s &&
                  ("string" == typeof i
                    ? ((s = n), (n = void 0))
                    : ((s = n), (n = i), (i = void 0))),
              !1 === s)
            )
              s = Tt;
            else if (!s) return t;
            return (
              1 === o &&
                ((r = s),
                (s = function (t) {
                  return k().off(t), r.apply(this, arguments);
                }),
                (s.guid = r.guid || (r.guid = k.guid++))),
              t.each(function () {
                k.event.add(this, e, s, n, i);
              })
            );
          }
          function It(t, e, i) {
            i
              ? (K.set(t, e, !1),
                k.event.add(t, e, {
                  namespace: !1,
                  handler: function (t) {
                    var n,
                      s,
                      o = K.get(this, e);
                    if (1 & t.isTrigger && this[e]) {
                      if (o.length)
                        (k.event.special[e] || {}).delegateType &&
                          t.stopPropagation();
                      else if (
                        ((o = a.call(arguments)),
                        K.set(this, e, o),
                        (n = i(this, e)),
                        this[e](),
                        o !== (s = K.get(this, e)) || n
                          ? K.set(this, e, !1)
                          : (s = {}),
                        o !== s)
                      )
                        return (
                          t.stopImmediatePropagation(),
                          t.preventDefault(),
                          s.value
                        );
                    } else
                      o.length &&
                        (K.set(this, e, {
                          value: k.event.trigger(
                            k.extend(o[0], k.Event.prototype),
                            o.slice(1),
                            this
                          ),
                        }),
                        t.stopImmediatePropagation());
                  },
                }))
              : void 0 === K.get(t, e) && k.event.add(t, e, At);
          }
          (k.event = {
            global: {},
            add: function (t, e, i, n, s) {
              var o,
                r,
                a,
                l,
                c,
                h,
                d,
                u,
                p,
                f,
                m,
                g = K.get(t);
              if (Q(t))
                for (
                  i.handler && ((i = (o = i).handler), (s = o.selector)),
                    s && k.find.matchesSelector(rt, s),
                    i.guid || (i.guid = k.guid++),
                    (l = g.events) || (l = g.events = Object.create(null)),
                    (r = g.handle) ||
                      (r = g.handle =
                        function (e) {
                          return void 0 !== k && k.event.triggered !== e.type
                            ? k.event.dispatch.apply(t, arguments)
                            : void 0;
                        }),
                    c = (e = (e || "").match(B) || [""]).length;
                  c--;

                )
                  (p = m = (a = Et.exec(e[c]) || [])[1]),
                    (f = (a[2] || "").split(".").sort()),
                    p &&
                      ((d = k.event.special[p] || {}),
                      (p = (s ? d.delegateType : d.bindType) || p),
                      (d = k.event.special[p] || {}),
                      (h = k.extend(
                        {
                          type: p,
                          origType: m,
                          data: n,
                          handler: i,
                          guid: i.guid,
                          selector: s,
                          needsContext: s && k.expr.match.needsContext.test(s),
                          namespace: f.join("."),
                        },
                        o
                      )),
                      (u = l[p]) ||
                        (((u = l[p] = []).delegateCount = 0),
                        (d.setup && !1 !== d.setup.call(t, n, f, r)) ||
                          (t.addEventListener && t.addEventListener(p, r))),
                      d.add &&
                        (d.add.call(t, h),
                        h.handler.guid || (h.handler.guid = i.guid)),
                      s ? u.splice(u.delegateCount++, 0, h) : u.push(h),
                      (k.event.global[p] = !0));
            },
            remove: function (t, e, i, n, s) {
              var o,
                r,
                a,
                l,
                c,
                h,
                d,
                u,
                p,
                f,
                m,
                g = K.hasData(t) && K.get(t);
              if (g && (l = g.events)) {
                for (c = (e = (e || "").match(B) || [""]).length; c--; )
                  if (
                    ((p = m = (a = Et.exec(e[c]) || [])[1]),
                    (f = (a[2] || "").split(".").sort()),
                    p)
                  ) {
                    for (
                      d = k.event.special[p] || {},
                        u =
                          l[(p = (n ? d.delegateType : d.bindType) || p)] || [],
                        a =
                          a[2] &&
                          new RegExp(
                            "(^|\\.)" + f.join("\\.(?:.*\\.|)") + "(\\.|$)"
                          ),
                        r = o = u.length;
                      o--;

                    )
                      (h = u[o]),
                        (!s && m !== h.origType) ||
                          (i && i.guid !== h.guid) ||
                          (a && !a.test(h.namespace)) ||
                          (n &&
                            n !== h.selector &&
                            ("**" !== n || !h.selector)) ||
                          (u.splice(o, 1),
                          h.selector && u.delegateCount--,
                          d.remove && d.remove.call(t, h));
                    r &&
                      !u.length &&
                      ((d.teardown && !1 !== d.teardown.call(t, f, g.handle)) ||
                        k.removeEvent(t, p, g.handle),
                      delete l[p]);
                  } else for (p in l) k.event.remove(t, p + e[c], i, n, !0);
                k.isEmptyObject(l) && K.remove(t, "handle events");
              }
            },
            dispatch: function (t) {
              var e,
                i,
                n,
                s,
                o,
                r,
                a = new Array(arguments.length),
                l = k.event.fix(t),
                c =
                  (K.get(this, "events") || Object.create(null))[l.type] || [],
                h = k.event.special[l.type] || {};
              for (a[0] = l, e = 1; e < arguments.length; e++)
                a[e] = arguments[e];
              if (
                ((l.delegateTarget = this),
                !h.preDispatch || !1 !== h.preDispatch.call(this, l))
              ) {
                for (
                  r = k.event.handlers.call(this, l, c), e = 0;
                  (s = r[e++]) && !l.isPropagationStopped();

                )
                  for (
                    l.currentTarget = s.elem, i = 0;
                    (o = s.handlers[i++]) && !l.isImmediatePropagationStopped();

                  )
                    (l.rnamespace &&
                      !1 !== o.namespace &&
                      !l.rnamespace.test(o.namespace)) ||
                      ((l.handleObj = o),
                      (l.data = o.data),
                      void 0 !==
                        (n = (
                          (k.event.special[o.origType] || {}).handle ||
                          o.handler
                        ).apply(s.elem, a)) &&
                        !1 === (l.result = n) &&
                        (l.preventDefault(), l.stopPropagation()));
                return h.postDispatch && h.postDispatch.call(this, l), l.result;
              }
            },
            handlers: function (t, e) {
              var i,
                n,
                s,
                o,
                r,
                a = [],
                l = e.delegateCount,
                c = t.target;
              if (l && c.nodeType && !("click" === t.type && t.button >= 1))
                for (; c !== this; c = c.parentNode || this)
                  if (
                    1 === c.nodeType &&
                    ("click" !== t.type || !0 !== c.disabled)
                  ) {
                    for (o = [], r = {}, i = 0; i < l; i++)
                      void 0 === r[(s = (n = e[i]).selector + " ")] &&
                        (r[s] = n.needsContext
                          ? k(s, this).index(c) > -1
                          : k.find(s, this, null, [c]).length),
                        r[s] && o.push(n);
                    o.length && a.push({ elem: c, handlers: o });
                  }
              return (
                (c = this),
                l < e.length && a.push({ elem: c, handlers: e.slice(l) }),
                a
              );
            },
            addProp: function (t, e) {
              Object.defineProperty(k.Event.prototype, t, {
                enumerable: !0,
                configurable: !0,
                get: v(e)
                  ? function () {
                      if (this.originalEvent) return e(this.originalEvent);
                    }
                  : function () {
                      if (this.originalEvent) return this.originalEvent[t];
                    },
                set: function (e) {
                  Object.defineProperty(this, t, {
                    enumerable: !0,
                    configurable: !0,
                    writable: !0,
                    value: e,
                  });
                },
              });
            },
            fix: function (t) {
              return t[k.expando] ? t : new k.Event(t);
            },
            special: {
              load: { noBubble: !0 },
              click: {
                setup: function (t) {
                  var e = this || t;
                  return (
                    gt.test(e.type) &&
                      e.click &&
                      D(e, "input") &&
                      It(e, "click", At),
                    !1
                  );
                },
                trigger: function (t) {
                  var e = this || t;
                  return (
                    gt.test(e.type) &&
                      e.click &&
                      D(e, "input") &&
                      It(e, "click"),
                    !0
                  );
                },
                _default: function (t) {
                  var e = t.target;
                  return (
                    (gt.test(e.type) &&
                      e.click &&
                      D(e, "input") &&
                      K.get(e, "click")) ||
                    D(e, "a")
                  );
                },
              },
              beforeunload: {
                postDispatch: function (t) {
                  void 0 !== t.result &&
                    t.originalEvent &&
                    (t.originalEvent.returnValue = t.result);
                },
              },
            },
          }),
            (k.removeEvent = function (t, e, i) {
              t.removeEventListener && t.removeEventListener(e, i);
            }),
            (k.Event = function (t, e) {
              if (!(this instanceof k.Event)) return new k.Event(t, e);
              t && t.type
                ? ((this.originalEvent = t),
                  (this.type = t.type),
                  (this.isDefaultPrevented =
                    t.defaultPrevented ||
                    (void 0 === t.defaultPrevented && !1 === t.returnValue)
                      ? At
                      : Tt),
                  (this.target =
                    t.target && 3 === t.target.nodeType
                      ? t.target.parentNode
                      : t.target),
                  (this.currentTarget = t.currentTarget),
                  (this.relatedTarget = t.relatedTarget))
                : (this.type = t),
                e && k.extend(this, e),
                (this.timeStamp = (t && t.timeStamp) || Date.now()),
                (this[k.expando] = !0);
            }),
            (k.Event.prototype = {
              constructor: k.Event,
              isDefaultPrevented: Tt,
              isPropagationStopped: Tt,
              isImmediatePropagationStopped: Tt,
              isSimulated: !1,
              preventDefault: function () {
                var t = this.originalEvent;
                (this.isDefaultPrevented = At),
                  t && !this.isSimulated && t.preventDefault();
              },
              stopPropagation: function () {
                var t = this.originalEvent;
                (this.isPropagationStopped = At),
                  t && !this.isSimulated && t.stopPropagation();
              },
              stopImmediatePropagation: function () {
                var t = this.originalEvent;
                (this.isImmediatePropagationStopped = At),
                  t && !this.isSimulated && t.stopImmediatePropagation(),
                  this.stopPropagation();
              },
            }),
            k.each(
              {
                altKey: !0,
                bubbles: !0,
                cancelable: !0,
                changedTouches: !0,
                ctrlKey: !0,
                detail: !0,
                eventPhase: !0,
                metaKey: !0,
                pageX: !0,
                pageY: !0,
                shiftKey: !0,
                view: !0,
                char: !0,
                code: !0,
                charCode: !0,
                key: !0,
                keyCode: !0,
                button: !0,
                buttons: !0,
                clientX: !0,
                clientY: !0,
                offsetX: !0,
                offsetY: !0,
                pointerId: !0,
                pointerType: !0,
                screenX: !0,
                screenY: !0,
                targetTouches: !0,
                toElement: !0,
                touches: !0,
                which: function (t) {
                  var e = t.button;
                  return null == t.which && kt.test(t.type)
                    ? null != t.charCode
                      ? t.charCode
                      : t.keyCode
                    : !t.which && void 0 !== e && xt.test(t.type)
                    ? 1 & e
                      ? 1
                      : 2 & e
                      ? 3
                      : 4 & e
                      ? 2
                      : 0
                    : t.which;
                },
              },
              k.event.addProp
            ),
            k.each({ focus: "focusin", blur: "focusout" }, function (t, e) {
              k.event.special[t] = {
                setup: function () {
                  return It(this, t, Lt), !1;
                },
                trigger: function () {
                  return It(this, t), !0;
                },
                delegateType: e,
              };
            }),
            k.each(
              {
                mouseenter: "mouseover",
                mouseleave: "mouseout",
                pointerenter: "pointerover",
                pointerleave: "pointerout",
              },
              function (t, e) {
                k.event.special[t] = {
                  delegateType: e,
                  bindType: e,
                  handle: function (t) {
                    var i,
                      n = t.relatedTarget,
                      s = t.handleObj;
                    return (
                      (n && (n === this || k.contains(this, n))) ||
                        ((t.type = s.origType),
                        (i = s.handler.apply(this, arguments)),
                        (t.type = e)),
                      i
                    );
                  },
                };
              }
            ),
            k.fn.extend({
              on: function (t, e, i, n) {
                return Dt(this, t, e, i, n);
              },
              one: function (t, e, i, n) {
                return Dt(this, t, e, i, n, 1);
              },
              off: function (t, e, i) {
                var n, s;
                if (t && t.preventDefault && t.handleObj)
                  return (
                    (n = t.handleObj),
                    k(t.delegateTarget).off(
                      n.namespace ? n.origType + "." + n.namespace : n.origType,
                      n.selector,
                      n.handler
                    ),
                    this
                  );
                if ("object" == typeof t) {
                  for (s in t) this.off(s, e, t[s]);
                  return this;
                }
                return (
                  (!1 !== e && "function" != typeof e) ||
                    ((i = e), (e = void 0)),
                  !1 === i && (i = Tt),
                  this.each(function () {
                    k.event.remove(this, t, i, e);
                  })
                );
              },
            });
          var Pt = /<script|<style|<link/i,
            Mt = /checked\s*(?:[^=]|=\s*.checked.)/i,
            Ot = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g;
          function Ft(t, e) {
            return (
              (D(t, "table") &&
                D(11 !== e.nodeType ? e : e.firstChild, "tr") &&
                k(t).children("tbody")[0]) ||
              t
            );
          }
          function qt(t) {
            return (
              (t.type = (null !== t.getAttribute("type")) + "/" + t.type), t
            );
          }
          function $t(t) {
            return (
              "true/" === (t.type || "").slice(0, 5)
                ? (t.type = t.type.slice(5))
                : t.removeAttribute("type"),
              t
            );
          }
          function Bt(t, e) {
            var i, n, s, o, r, a;
            if (1 === e.nodeType) {
              if (K.hasData(t) && (a = K.get(t).events))
                for (s in (K.remove(e, "handle events"), a))
                  for (i = 0, n = a[s].length; i < n; i++)
                    k.event.add(e, s, a[s][i]);
              J.hasData(t) &&
                ((o = J.access(t)), (r = k.extend({}, o)), J.set(e, r));
            }
          }
          function Nt(t, e) {
            var i = e.nodeName.toLowerCase();
            "input" === i && gt.test(t.type)
              ? (e.checked = t.checked)
              : ("input" !== i && "textarea" !== i) ||
                (e.defaultValue = t.defaultValue);
          }
          function Rt(t, e, i, n) {
            e = l(e);
            var s,
              o,
              r,
              a,
              c,
              h,
              d = 0,
              u = t.length,
              p = u - 1,
              f = e[0],
              m = v(f);
            if (
              m ||
              (u > 1 && "string" == typeof f && !g.checkClone && Mt.test(f))
            )
              return t.each(function (s) {
                var o = t.eq(s);
                m && (e[0] = f.call(this, s, o.html())), Rt(o, e, i, n);
              });
            if (
              u &&
              ((o = (s = Ct(e, t[0].ownerDocument, !1, t, n)).firstChild),
              1 === s.childNodes.length && (s = o),
              o || n)
            ) {
              for (a = (r = k.map(wt(s, "script"), qt)).length; d < u; d++)
                (c = s),
                  d !== p &&
                    ((c = k.clone(c, !0, !0)),
                    a && k.merge(r, wt(c, "script"))),
                  i.call(t[d], c, d);
              if (a)
                for (
                  h = r[r.length - 1].ownerDocument, k.map(r, $t), d = 0;
                  d < a;
                  d++
                )
                  (c = r[d]),
                    yt.test(c.type || "") &&
                      !K.access(c, "globalEval") &&
                      k.contains(h, c) &&
                      (c.src && "module" !== (c.type || "").toLowerCase()
                        ? k._evalUrl &&
                          !c.noModule &&
                          k._evalUrl(
                            c.src,
                            { nonce: c.nonce || c.getAttribute("nonce") },
                            h
                          )
                        : _(c.textContent.replace(Ot, ""), c, h));
            }
            return t;
          }
          function zt(t, e, i) {
            for (
              var n, s = e ? k.filter(e, t) : t, o = 0;
              null != (n = s[o]);
              o++
            )
              i || 1 !== n.nodeType || k.cleanData(wt(n)),
                n.parentNode &&
                  (i && at(n) && _t(wt(n, "script")),
                  n.parentNode.removeChild(n));
            return t;
          }
          k.extend({
            htmlPrefilter: function (t) {
              return t;
            },
            clone: function (t, e, i) {
              var n,
                s,
                o,
                r,
                a = t.cloneNode(!0),
                l = at(t);
              if (
                !(
                  g.noCloneChecked ||
                  (1 !== t.nodeType && 11 !== t.nodeType) ||
                  k.isXMLDoc(t)
                )
              )
                for (r = wt(a), n = 0, s = (o = wt(t)).length; n < s; n++)
                  Nt(o[n], r[n]);
              if (e)
                if (i)
                  for (
                    o = o || wt(t), r = r || wt(a), n = 0, s = o.length;
                    n < s;
                    n++
                  )
                    Bt(o[n], r[n]);
                else Bt(t, a);
              return (
                (r = wt(a, "script")).length > 0 &&
                  _t(r, !l && wt(t, "script")),
                a
              );
            },
            cleanData: function (t) {
              for (
                var e, i, n, s = k.event.special, o = 0;
                void 0 !== (i = t[o]);
                o++
              )
                if (Q(i)) {
                  if ((e = i[K.expando])) {
                    if (e.events)
                      for (n in e.events)
                        s[n]
                          ? k.event.remove(i, n)
                          : k.removeEvent(i, n, e.handle);
                    i[K.expando] = void 0;
                  }
                  i[J.expando] && (i[J.expando] = void 0);
                }
            },
          }),
            k.fn.extend({
              detach: function (t) {
                return zt(this, t, !0);
              },
              remove: function (t) {
                return zt(this, t);
              },
              text: function (t) {
                return W(
                  this,
                  function (t) {
                    return void 0 === t
                      ? k.text(this)
                      : this.empty().each(function () {
                          (1 !== this.nodeType &&
                            11 !== this.nodeType &&
                            9 !== this.nodeType) ||
                            (this.textContent = t);
                        });
                  },
                  null,
                  t,
                  arguments.length
                );
              },
              append: function () {
                return Rt(this, arguments, function (t) {
                  (1 !== this.nodeType &&
                    11 !== this.nodeType &&
                    9 !== this.nodeType) ||
                    Ft(this, t).appendChild(t);
                });
              },
              prepend: function () {
                return Rt(this, arguments, function (t) {
                  if (
                    1 === this.nodeType ||
                    11 === this.nodeType ||
                    9 === this.nodeType
                  ) {
                    var e = Ft(this, t);
                    e.insertBefore(t, e.firstChild);
                  }
                });
              },
              before: function () {
                return Rt(this, arguments, function (t) {
                  this.parentNode && this.parentNode.insertBefore(t, this);
                });
              },
              after: function () {
                return Rt(this, arguments, function (t) {
                  this.parentNode &&
                    this.parentNode.insertBefore(t, this.nextSibling);
                });
              },
              empty: function () {
                for (var t, e = 0; null != (t = this[e]); e++)
                  1 === t.nodeType &&
                    (k.cleanData(wt(t, !1)), (t.textContent = ""));
                return this;
              },
              clone: function (t, e) {
                return (
                  (t = null != t && t),
                  (e = null == e ? t : e),
                  this.map(function () {
                    return k.clone(this, t, e);
                  })
                );
              },
              html: function (t) {
                return W(
                  this,
                  function (t) {
                    var e = this[0] || {},
                      i = 0,
                      n = this.length;
                    if (void 0 === t && 1 === e.nodeType) return e.innerHTML;
                    if (
                      "string" == typeof t &&
                      !Pt.test(t) &&
                      !bt[(vt.exec(t) || ["", ""])[1].toLowerCase()]
                    ) {
                      t = k.htmlPrefilter(t);
                      try {
                        for (; i < n; i++)
                          1 === (e = this[i] || {}).nodeType &&
                            (k.cleanData(wt(e, !1)), (e.innerHTML = t));
                        e = 0;
                      } catch (t) {}
                    }
                    e && this.empty().append(t);
                  },
                  null,
                  t,
                  arguments.length
                );
              },
              replaceWith: function () {
                var t = [];
                return Rt(
                  this,
                  arguments,
                  function (e) {
                    var i = this.parentNode;
                    k.inArray(this, t) < 0 &&
                      (k.cleanData(wt(this)), i && i.replaceChild(e, this));
                  },
                  t
                );
              },
            }),
            k.each(
              {
                appendTo: "append",
                prependTo: "prepend",
                insertBefore: "before",
                insertAfter: "after",
                replaceAll: "replaceWith",
              },
              function (t, e) {
                k.fn[t] = function (t) {
                  for (
                    var i, n = [], s = k(t), o = s.length - 1, r = 0;
                    r <= o;
                    r++
                  )
                    (i = r === o ? this : this.clone(!0)),
                      k(s[r])[e](i),
                      c.apply(n, i.get());
                  return this.pushStack(n);
                };
              }
            );
          var Ht = new RegExp("^(" + nt + ")(?!px)[a-z%]+$", "i"),
            Ut = function (t) {
              var e = t.ownerDocument.defaultView;
              return (e && e.opener) || (e = n), e.getComputedStyle(t);
            },
            jt = function (t, e, i) {
              var n,
                s,
                o = {};
              for (s in e) (o[s] = t.style[s]), (t.style[s] = e[s]);
              for (s in ((n = i.call(t)), e)) t.style[s] = o[s];
              return n;
            },
            Wt = new RegExp(ot.join("|"), "i");
          function Vt(t, e, i) {
            var n,
              s,
              o,
              r,
              a = t.style;
            return (
              (i = i || Ut(t)) &&
                ("" !== (r = i.getPropertyValue(e) || i[e]) ||
                  at(t) ||
                  (r = k.style(t, e)),
                !g.pixelBoxStyles() &&
                  Ht.test(r) &&
                  Wt.test(e) &&
                  ((n = a.width),
                  (s = a.minWidth),
                  (o = a.maxWidth),
                  (a.minWidth = a.maxWidth = a.width = r),
                  (r = i.width),
                  (a.width = n),
                  (a.minWidth = s),
                  (a.maxWidth = o))),
              void 0 !== r ? r + "" : r
            );
          }
          function Gt(t, e) {
            return {
              get: function () {
                if (!t()) return (this.get = e).apply(this, arguments);
                delete this.get;
              },
            };
          }
          !(function () {
            function t() {
              if (h) {
                (c.style.cssText =
                  "position:absolute;left:-11111px;width:60px;margin-top:1px;padding:0;border:0"),
                  (h.style.cssText =
                    "position:relative;display:block;box-sizing:border-box;overflow:scroll;margin:auto;border:1px;padding:1px;width:60%;top:1%"),
                  rt.appendChild(c).appendChild(h);
                var t = n.getComputedStyle(h);
                (i = "1%" !== t.top),
                  (l = 12 === e(t.marginLeft)),
                  (h.style.right = "60%"),
                  (r = 36 === e(t.right)),
                  (s = 36 === e(t.width)),
                  (h.style.position = "absolute"),
                  (o = 12 === e(h.offsetWidth / 3)),
                  rt.removeChild(c),
                  (h = null);
              }
            }
            function e(t) {
              return Math.round(parseFloat(t));
            }
            var i,
              s,
              o,
              r,
              a,
              l,
              c = b.createElement("div"),
              h = b.createElement("div");
            h.style &&
              ((h.style.backgroundClip = "content-box"),
              (h.cloneNode(!0).style.backgroundClip = ""),
              (g.clearCloneStyle = "content-box" === h.style.backgroundClip),
              k.extend(g, {
                boxSizingReliable: function () {
                  return t(), s;
                },
                pixelBoxStyles: function () {
                  return t(), r;
                },
                pixelPosition: function () {
                  return t(), i;
                },
                reliableMarginLeft: function () {
                  return t(), l;
                },
                scrollboxSize: function () {
                  return t(), o;
                },
                reliableTrDimensions: function () {
                  var t, e, i, s;
                  return (
                    null == a &&
                      ((t = b.createElement("table")),
                      (e = b.createElement("tr")),
                      (i = b.createElement("div")),
                      (t.style.cssText = "position:absolute;left:-11111px"),
                      (e.style.height = "1px"),
                      (i.style.height = "9px"),
                      rt.appendChild(t).appendChild(e).appendChild(i),
                      (s = n.getComputedStyle(e)),
                      (a = parseInt(s.height) > 3),
                      rt.removeChild(t)),
                    a
                  );
                },
              }));
          })();
          var Xt = ["Webkit", "Moz", "ms"],
            Zt = b.createElement("div").style,
            Qt = {};
          function Yt(t) {
            var e = k.cssProps[t] || Qt[t];
            return (
              e ||
              (t in Zt
                ? t
                : (Qt[t] =
                    (function (t) {
                      for (
                        var e = t[0].toUpperCase() + t.slice(1), i = Xt.length;
                        i--;

                      )
                        if ((t = Xt[i] + e) in Zt) return t;
                    })(t) || t))
            );
          }
          var Kt = /^(none|table(?!-c[ea]).+)/,
            Jt = /^--/,
            te = {
              position: "absolute",
              visibility: "hidden",
              display: "block",
            },
            ee = { letterSpacing: "0", fontWeight: "400" };
          function ie(t, e, i) {
            var n = st.exec(e);
            return n ? Math.max(0, n[2] - (i || 0)) + (n[3] || "px") : e;
          }
          function ne(t, e, i, n, s, o) {
            var r = "width" === e ? 1 : 0,
              a = 0,
              l = 0;
            if (i === (n ? "border" : "content")) return 0;
            for (; r < 4; r += 2)
              "margin" === i && (l += k.css(t, i + ot[r], !0, s)),
                n
                  ? ("content" === i &&
                      (l -= k.css(t, "padding" + ot[r], !0, s)),
                    "margin" !== i &&
                      (l -= k.css(t, "border" + ot[r] + "Width", !0, s)))
                  : ((l += k.css(t, "padding" + ot[r], !0, s)),
                    "padding" !== i
                      ? (l += k.css(t, "border" + ot[r] + "Width", !0, s))
                      : (a += k.css(t, "border" + ot[r] + "Width", !0, s)));
            return (
              !n &&
                o >= 0 &&
                (l +=
                  Math.max(
                    0,
                    Math.ceil(
                      t["offset" + e[0].toUpperCase() + e.slice(1)] -
                        o -
                        l -
                        a -
                        0.5
                    )
                  ) || 0),
              l
            );
          }
          function se(t, e, i) {
            var n = Ut(t),
              s =
                (!g.boxSizingReliable() || i) &&
                "border-box" === k.css(t, "boxSizing", !1, n),
              o = s,
              r = Vt(t, e, n),
              a = "offset" + e[0].toUpperCase() + e.slice(1);
            if (Ht.test(r)) {
              if (!i) return r;
              r = "auto";
            }
            return (
              ((!g.boxSizingReliable() && s) ||
                (!g.reliableTrDimensions() && D(t, "tr")) ||
                "auto" === r ||
                (!parseFloat(r) && "inline" === k.css(t, "display", !1, n))) &&
                t.getClientRects().length &&
                ((s = "border-box" === k.css(t, "boxSizing", !1, n)),
                (o = a in t) && (r = t[a])),
              (r = parseFloat(r) || 0) +
                ne(t, e, i || (s ? "border" : "content"), o, n, r) +
                "px"
            );
          }
          function oe(t, e, i, n, s) {
            return new oe.prototype.init(t, e, i, n, s);
          }
          k.extend({
            cssHooks: {
              opacity: {
                get: function (t, e) {
                  if (e) {
                    var i = Vt(t, "opacity");
                    return "" === i ? "1" : i;
                  }
                },
              },
            },
            cssNumber: {
              animationIterationCount: !0,
              columnCount: !0,
              fillOpacity: !0,
              flexGrow: !0,
              flexShrink: !0,
              fontWeight: !0,
              gridArea: !0,
              gridColumn: !0,
              gridColumnEnd: !0,
              gridColumnStart: !0,
              gridRow: !0,
              gridRowEnd: !0,
              gridRowStart: !0,
              lineHeight: !0,
              opacity: !0,
              order: !0,
              orphans: !0,
              widows: !0,
              zIndex: !0,
              zoom: !0,
            },
            cssProps: {},
            style: function (t, e, i, n) {
              if (t && 3 !== t.nodeType && 8 !== t.nodeType && t.style) {
                var s,
                  o,
                  r,
                  a = Z(e),
                  l = Jt.test(e),
                  c = t.style;
                if (
                  (l || (e = Yt(a)),
                  (r = k.cssHooks[e] || k.cssHooks[a]),
                  void 0 === i)
                )
                  return r && "get" in r && void 0 !== (s = r.get(t, !1, n))
                    ? s
                    : c[e];
                "string" === (o = typeof i) &&
                  (s = st.exec(i)) &&
                  s[1] &&
                  ((i = ht(t, e, s)), (o = "number")),
                  null != i &&
                    i == i &&
                    ("number" !== o ||
                      l ||
                      (i += (s && s[3]) || (k.cssNumber[a] ? "" : "px")),
                    g.clearCloneStyle ||
                      "" !== i ||
                      0 !== e.indexOf("background") ||
                      (c[e] = "inherit"),
                    (r && "set" in r && void 0 === (i = r.set(t, i, n))) ||
                      (l ? c.setProperty(e, i) : (c[e] = i)));
              }
            },
            css: function (t, e, i, n) {
              var s,
                o,
                r,
                a = Z(e);
              return (
                Jt.test(e) || (e = Yt(a)),
                (r = k.cssHooks[e] || k.cssHooks[a]) &&
                  "get" in r &&
                  (s = r.get(t, !0, i)),
                void 0 === s && (s = Vt(t, e, n)),
                "normal" === s && e in ee && (s = ee[e]),
                "" === i || i
                  ? ((o = parseFloat(s)), !0 === i || isFinite(o) ? o || 0 : s)
                  : s
              );
            },
          }),
            k.each(["height", "width"], function (t, e) {
              k.cssHooks[e] = {
                get: function (t, i, n) {
                  if (i)
                    return !Kt.test(k.css(t, "display")) ||
                      (t.getClientRects().length &&
                        t.getBoundingClientRect().width)
                      ? se(t, e, n)
                      : jt(t, te, function () {
                          return se(t, e, n);
                        });
                },
                set: function (t, i, n) {
                  var s,
                    o = Ut(t),
                    r = !g.scrollboxSize() && "absolute" === o.position,
                    a =
                      (r || n) && "border-box" === k.css(t, "boxSizing", !1, o),
                    l = n ? ne(t, e, n, a, o) : 0;
                  return (
                    a &&
                      r &&
                      (l -= Math.ceil(
                        t["offset" + e[0].toUpperCase() + e.slice(1)] -
                          parseFloat(o[e]) -
                          ne(t, e, "border", !1, o) -
                          0.5
                      )),
                    l &&
                      (s = st.exec(i)) &&
                      "px" !== (s[3] || "px") &&
                      ((t.style[e] = i), (i = k.css(t, e))),
                    ie(0, i, l)
                  );
                },
              };
            }),
            (k.cssHooks.marginLeft = Gt(g.reliableMarginLeft, function (t, e) {
              if (e)
                return (
                  (parseFloat(Vt(t, "marginLeft")) ||
                    t.getBoundingClientRect().left -
                      jt(t, { marginLeft: 0 }, function () {
                        return t.getBoundingClientRect().left;
                      })) + "px"
                );
            })),
            k.each(
              { margin: "", padding: "", border: "Width" },
              function (t, e) {
                (k.cssHooks[t + e] = {
                  expand: function (i) {
                    for (
                      var n = 0,
                        s = {},
                        o = "string" == typeof i ? i.split(" ") : [i];
                      n < 4;
                      n++
                    )
                      s[t + ot[n] + e] = o[n] || o[n - 2] || o[0];
                    return s;
                  },
                }),
                  "margin" !== t && (k.cssHooks[t + e].set = ie);
              }
            ),
            k.fn.extend({
              css: function (t, e) {
                return W(
                  this,
                  function (t, e, i) {
                    var n,
                      s,
                      o = {},
                      r = 0;
                    if (Array.isArray(e)) {
                      for (n = Ut(t), s = e.length; r < s; r++)
                        o[e[r]] = k.css(t, e[r], !1, n);
                      return o;
                    }
                    return void 0 !== i ? k.style(t, e, i) : k.css(t, e);
                  },
                  t,
                  e,
                  arguments.length > 1
                );
              },
            }),
            (k.Tween = oe),
            (oe.prototype = {
              constructor: oe,
              init: function (t, e, i, n, s, o) {
                (this.elem = t),
                  (this.prop = i),
                  (this.easing = s || k.easing._default),
                  (this.options = e),
                  (this.start = this.now = this.cur()),
                  (this.end = n),
                  (this.unit = o || (k.cssNumber[i] ? "" : "px"));
              },
              cur: function () {
                var t = oe.propHooks[this.prop];
                return t && t.get
                  ? t.get(this)
                  : oe.propHooks._default.get(this);
              },
              run: function (t) {
                var e,
                  i = oe.propHooks[this.prop];
                return (
                  this.options.duration
                    ? (this.pos = e =
                        k.easing[this.easing](
                          t,
                          this.options.duration * t,
                          0,
                          1,
                          this.options.duration
                        ))
                    : (this.pos = e = t),
                  (this.now = (this.end - this.start) * e + this.start),
                  this.options.step &&
                    this.options.step.call(this.elem, this.now, this),
                  i && i.set ? i.set(this) : oe.propHooks._default.set(this),
                  this
                );
              },
            }),
            (oe.prototype.init.prototype = oe.prototype),
            (oe.propHooks = {
              _default: {
                get: function (t) {
                  var e;
                  return 1 !== t.elem.nodeType ||
                    (null != t.elem[t.prop] && null == t.elem.style[t.prop])
                    ? t.elem[t.prop]
                    : (e = k.css(t.elem, t.prop, "")) && "auto" !== e
                    ? e
                    : 0;
                },
                set: function (t) {
                  k.fx.step[t.prop]
                    ? k.fx.step[t.prop](t)
                    : 1 !== t.elem.nodeType ||
                      (!k.cssHooks[t.prop] && null == t.elem.style[Yt(t.prop)])
                    ? (t.elem[t.prop] = t.now)
                    : k.style(t.elem, t.prop, t.now + t.unit);
                },
              },
            }),
            (oe.propHooks.scrollTop = oe.propHooks.scrollLeft =
              {
                set: function (t) {
                  t.elem.nodeType &&
                    t.elem.parentNode &&
                    (t.elem[t.prop] = t.now);
                },
              }),
            (k.easing = {
              linear: function (t) {
                return t;
              },
              swing: function (t) {
                return 0.5 - Math.cos(t * Math.PI) / 2;
              },
              _default: "swing",
            }),
            (k.fx = oe.prototype.init),
            (k.fx.step = {});
          var re,
            ae,
            le = /^(?:toggle|show|hide)$/,
            ce = /queueHooks$/;
          function he() {
            ae &&
              (!1 === b.hidden && n.requestAnimationFrame
                ? n.requestAnimationFrame(he)
                : n.setTimeout(he, k.fx.interval),
              k.fx.tick());
          }
          function de() {
            return (
              n.setTimeout(function () {
                re = void 0;
              }),
              (re = Date.now())
            );
          }
          function ue(t, e) {
            var i,
              n = 0,
              s = { height: t };
            for (e = e ? 1 : 0; n < 4; n += 2 - e)
              s["margin" + (i = ot[n])] = s["padding" + i] = t;
            return e && (s.opacity = s.width = t), s;
          }
          function pe(t, e, i) {
            for (
              var n,
                s = (fe.tweeners[e] || []).concat(fe.tweeners["*"]),
                o = 0,
                r = s.length;
              o < r;
              o++
            )
              if ((n = s[o].call(i, e, t))) return n;
          }
          function fe(t, e, i) {
            var n,
              s,
              o = 0,
              r = fe.prefilters.length,
              a = k.Deferred().always(function () {
                delete l.elem;
              }),
              l = function () {
                if (s) return !1;
                for (
                  var e = re || de(),
                    i = Math.max(0, c.startTime + c.duration - e),
                    n = 1 - (i / c.duration || 0),
                    o = 0,
                    r = c.tweens.length;
                  o < r;
                  o++
                )
                  c.tweens[o].run(n);
                return (
                  a.notifyWith(t, [c, n, i]),
                  n < 1 && r
                    ? i
                    : (r || a.notifyWith(t, [c, 1, 0]),
                      a.resolveWith(t, [c]),
                      !1)
                );
              },
              c = a.promise({
                elem: t,
                props: k.extend({}, e),
                opts: k.extend(
                  !0,
                  { specialEasing: {}, easing: k.easing._default },
                  i
                ),
                originalProperties: e,
                originalOptions: i,
                startTime: re || de(),
                duration: i.duration,
                tweens: [],
                createTween: function (e, i) {
                  var n = k.Tween(
                    t,
                    c.opts,
                    e,
                    i,
                    c.opts.specialEasing[e] || c.opts.easing
                  );
                  return c.tweens.push(n), n;
                },
                stop: function (e) {
                  var i = 0,
                    n = e ? c.tweens.length : 0;
                  if (s) return this;
                  for (s = !0; i < n; i++) c.tweens[i].run(1);
                  return (
                    e
                      ? (a.notifyWith(t, [c, 1, 0]), a.resolveWith(t, [c, e]))
                      : a.rejectWith(t, [c, e]),
                    this
                  );
                },
              }),
              h = c.props;
            for (
              !(function (t, e) {
                var i, n, s, o, r;
                for (i in t)
                  if (
                    ((s = e[(n = Z(i))]),
                    (o = t[i]),
                    Array.isArray(o) && ((s = o[1]), (o = t[i] = o[0])),
                    i !== n && ((t[n] = o), delete t[i]),
                    (r = k.cssHooks[n]) && ("expand" in r))
                  )
                    for (i in ((o = r.expand(o)), delete t[n], o))
                      (i in t) || ((t[i] = o[i]), (e[i] = s));
                  else e[n] = s;
              })(h, c.opts.specialEasing);
              o < r;
              o++
            )
              if ((n = fe.prefilters[o].call(c, t, h, c.opts)))
                return (
                  v(n.stop) &&
                    (k._queueHooks(c.elem, c.opts.queue).stop = n.stop.bind(n)),
                  n
                );
            return (
              k.map(h, pe, c),
              v(c.opts.start) && c.opts.start.call(t, c),
              c
                .progress(c.opts.progress)
                .done(c.opts.done, c.opts.complete)
                .fail(c.opts.fail)
                .always(c.opts.always),
              k.fx.timer(
                k.extend(l, { elem: t, anim: c, queue: c.opts.queue })
              ),
              c
            );
          }
          (k.Animation = k.extend(fe, {
            tweeners: {
              "*": [
                function (t, e) {
                  var i = this.createTween(t, e);
                  return ht(i.elem, t, st.exec(e), i), i;
                },
              ],
            },
            tweener: function (t, e) {
              v(t) ? ((e = t), (t = ["*"])) : (t = t.match(B));
              for (var i, n = 0, s = t.length; n < s; n++)
                (i = t[n]),
                  (fe.tweeners[i] = fe.tweeners[i] || []),
                  fe.tweeners[i].unshift(e);
            },
            prefilters: [
              function (t, e, i) {
                var n,
                  s,
                  o,
                  r,
                  a,
                  l,
                  c,
                  h,
                  d = "width" in e || "height" in e,
                  u = this,
                  p = {},
                  f = t.style,
                  m = t.nodeType && ct(t),
                  g = K.get(t, "fxshow");
                for (n in (i.queue ||
                  (null == (r = k._queueHooks(t, "fx")).unqueued &&
                    ((r.unqueued = 0),
                    (a = r.empty.fire),
                    (r.empty.fire = function () {
                      r.unqueued || a();
                    })),
                  r.unqueued++,
                  u.always(function () {
                    u.always(function () {
                      r.unqueued--, k.queue(t, "fx").length || r.empty.fire();
                    });
                  })),
                e))
                  if (((s = e[n]), le.test(s))) {
                    if (
                      (delete e[n],
                      (o = o || "toggle" === s),
                      s === (m ? "hide" : "show"))
                    ) {
                      if ("show" !== s || !g || void 0 === g[n]) continue;
                      m = !0;
                    }
                    p[n] = (g && g[n]) || k.style(t, n);
                  }
                if ((l = !k.isEmptyObject(e)) || !k.isEmptyObject(p))
                  for (n in (d &&
                    1 === t.nodeType &&
                    ((i.overflow = [f.overflow, f.overflowX, f.overflowY]),
                    null == (c = g && g.display) && (c = K.get(t, "display")),
                    "none" === (h = k.css(t, "display")) &&
                      (c
                        ? (h = c)
                        : (pt([t], !0),
                          (c = t.style.display || c),
                          (h = k.css(t, "display")),
                          pt([t]))),
                    ("inline" === h || ("inline-block" === h && null != c)) &&
                      "none" === k.css(t, "float") &&
                      (l ||
                        (u.done(function () {
                          f.display = c;
                        }),
                        null == c &&
                          ((h = f.display), (c = "none" === h ? "" : h))),
                      (f.display = "inline-block"))),
                  i.overflow &&
                    ((f.overflow = "hidden"),
                    u.always(function () {
                      (f.overflow = i.overflow[0]),
                        (f.overflowX = i.overflow[1]),
                        (f.overflowY = i.overflow[2]);
                    })),
                  (l = !1),
                  p))
                    l ||
                      (g
                        ? "hidden" in g && (m = g.hidden)
                        : (g = K.access(t, "fxshow", { display: c })),
                      o && (g.hidden = !m),
                      m && pt([t], !0),
                      u.done(function () {
                        for (n in (m || pt([t]), K.remove(t, "fxshow"), p))
                          k.style(t, n, p[n]);
                      })),
                      (l = pe(m ? g[n] : 0, n, u)),
                      n in g ||
                        ((g[n] = l.start),
                        m && ((l.end = l.start), (l.start = 0)));
              },
            ],
            prefilter: function (t, e) {
              e ? fe.prefilters.unshift(t) : fe.prefilters.push(t);
            },
          })),
            (k.speed = function (t, e, i) {
              var n =
                t && "object" == typeof t
                  ? k.extend({}, t)
                  : {
                      complete: i || (!i && e) || (v(t) && t),
                      duration: t,
                      easing: (i && e) || (e && !v(e) && e),
                    };
              return (
                k.fx.off
                  ? (n.duration = 0)
                  : "number" != typeof n.duration &&
                    (n.duration in k.fx.speeds
                      ? (n.duration = k.fx.speeds[n.duration])
                      : (n.duration = k.fx.speeds._default)),
                (null != n.queue && !0 !== n.queue) || (n.queue = "fx"),
                (n.old = n.complete),
                (n.complete = function () {
                  v(n.old) && n.old.call(this),
                    n.queue && k.dequeue(this, n.queue);
                }),
                n
              );
            }),
            k.fn.extend({
              fadeTo: function (t, e, i, n) {
                return this.filter(ct)
                  .css("opacity", 0)
                  .show()
                  .end()
                  .animate({ opacity: e }, t, i, n);
              },
              animate: function (t, e, i, n) {
                var s = k.isEmptyObject(t),
                  o = k.speed(e, i, n),
                  r = function () {
                    var e = fe(this, k.extend({}, t), o);
                    (s || K.get(this, "finish")) && e.stop(!0);
                  };
                return (
                  (r.finish = r),
                  s || !1 === o.queue ? this.each(r) : this.queue(o.queue, r)
                );
              },
              stop: function (t, e, i) {
                var n = function (t) {
                  var e = t.stop;
                  delete t.stop, e(i);
                };
                return (
                  "string" != typeof t && ((i = e), (e = t), (t = void 0)),
                  e && this.queue(t || "fx", []),
                  this.each(function () {
                    var e = !0,
                      s = null != t && t + "queueHooks",
                      o = k.timers,
                      r = K.get(this);
                    if (s) r[s] && r[s].stop && n(r[s]);
                    else
                      for (s in r) r[s] && r[s].stop && ce.test(s) && n(r[s]);
                    for (s = o.length; s--; )
                      o[s].elem !== this ||
                        (null != t && o[s].queue !== t) ||
                        (o[s].anim.stop(i), (e = !1), o.splice(s, 1));
                    (!e && i) || k.dequeue(this, t);
                  })
                );
              },
              finish: function (t) {
                return (
                  !1 !== t && (t = t || "fx"),
                  this.each(function () {
                    var e,
                      i = K.get(this),
                      n = i[t + "queue"],
                      s = i[t + "queueHooks"],
                      o = k.timers,
                      r = n ? n.length : 0;
                    for (
                      i.finish = !0,
                        k.queue(this, t, []),
                        s && s.stop && s.stop.call(this, !0),
                        e = o.length;
                      e--;

                    )
                      o[e].elem === this &&
                        o[e].queue === t &&
                        (o[e].anim.stop(!0), o.splice(e, 1));
                    for (e = 0; e < r; e++)
                      n[e] && n[e].finish && n[e].finish.call(this);
                    delete i.finish;
                  })
                );
              },
            }),
            k.each(["toggle", "show", "hide"], function (t, e) {
              var i = k.fn[e];
              k.fn[e] = function (t, n, s) {
                return null == t || "boolean" == typeof t
                  ? i.apply(this, arguments)
                  : this.animate(ue(e, !0), t, n, s);
              };
            }),
            k.each(
              {
                slideDown: ue("show"),
                slideUp: ue("hide"),
                slideToggle: ue("toggle"),
                fadeIn: { opacity: "show" },
                fadeOut: { opacity: "hide" },
                fadeToggle: { opacity: "toggle" },
              },
              function (t, e) {
                k.fn[t] = function (t, i, n) {
                  return this.animate(e, t, i, n);
                };
              }
            ),
            (k.timers = []),
            (k.fx.tick = function () {
              var t,
                e = 0,
                i = k.timers;
              for (re = Date.now(); e < i.length; e++)
                (t = i[e])() || i[e] !== t || i.splice(e--, 1);
              i.length || k.fx.stop(), (re = void 0);
            }),
            (k.fx.timer = function (t) {
              k.timers.push(t), k.fx.start();
            }),
            (k.fx.interval = 13),
            (k.fx.start = function () {
              ae || ((ae = !0), he());
            }),
            (k.fx.stop = function () {
              ae = null;
            }),
            (k.fx.speeds = { slow: 600, fast: 200, _default: 400 }),
            (k.fn.delay = function (t, e) {
              return (
                (t = (k.fx && k.fx.speeds[t]) || t),
                (e = e || "fx"),
                this.queue(e, function (e, i) {
                  var s = n.setTimeout(e, t);
                  i.stop = function () {
                    n.clearTimeout(s);
                  };
                })
              );
            }),
            (function () {
              var t = b.createElement("input"),
                e = b
                  .createElement("select")
                  .appendChild(b.createElement("option"));
              (t.type = "checkbox"),
                (g.checkOn = "" !== t.value),
                (g.optSelected = e.selected),
                ((t = b.createElement("input")).value = "t"),
                (t.type = "radio"),
                (g.radioValue = "t" === t.value);
            })();
          var me,
            ge = k.expr.attrHandle;
          k.fn.extend({
            attr: function (t, e) {
              return W(this, k.attr, t, e, arguments.length > 1);
            },
            removeAttr: function (t) {
              return this.each(function () {
                k.removeAttr(this, t);
              });
            },
          }),
            k.extend({
              attr: function (t, e, i) {
                var n,
                  s,
                  o = t.nodeType;
                if (3 !== o && 8 !== o && 2 !== o)
                  return void 0 === t.getAttribute
                    ? k.prop(t, e, i)
                    : ((1 === o && k.isXMLDoc(t)) ||
                        (s =
                          k.attrHooks[e.toLowerCase()] ||
                          (k.expr.match.bool.test(e) ? me : void 0)),
                      void 0 !== i
                        ? null === i
                          ? void k.removeAttr(t, e)
                          : s && "set" in s && void 0 !== (n = s.set(t, i, e))
                          ? n
                          : (t.setAttribute(e, i + ""), i)
                        : s && "get" in s && null !== (n = s.get(t, e))
                        ? n
                        : null == (n = k.find.attr(t, e))
                        ? void 0
                        : n);
              },
              attrHooks: {
                type: {
                  set: function (t, e) {
                    if (!g.radioValue && "radio" === e && D(t, "input")) {
                      var i = t.value;
                      return t.setAttribute("type", e), i && (t.value = i), e;
                    }
                  },
                },
              },
              removeAttr: function (t, e) {
                var i,
                  n = 0,
                  s = e && e.match(B);
                if (s && 1 === t.nodeType)
                  for (; (i = s[n++]); ) t.removeAttribute(i);
              },
            }),
            (me = {
              set: function (t, e, i) {
                return !1 === e ? k.removeAttr(t, i) : t.setAttribute(i, i), i;
              },
            }),
            k.each(k.expr.match.bool.source.match(/\w+/g), function (t, e) {
              var i = ge[e] || k.find.attr;
              ge[e] = function (t, e, n) {
                var s,
                  o,
                  r = e.toLowerCase();
                return (
                  n ||
                    ((o = ge[r]),
                    (ge[r] = s),
                    (s = null != i(t, e, n) ? r : null),
                    (ge[r] = o)),
                  s
                );
              };
            });
          var ve = /^(?:input|select|textarea|button)$/i,
            ye = /^(?:a|area)$/i;
          function be(t) {
            return (t.match(B) || []).join(" ");
          }
          function we(t) {
            return (t.getAttribute && t.getAttribute("class")) || "";
          }
          function _e(t) {
            return Array.isArray(t)
              ? t
              : ("string" == typeof t && t.match(B)) || [];
          }
          k.fn.extend({
            prop: function (t, e) {
              return W(this, k.prop, t, e, arguments.length > 1);
            },
            removeProp: function (t) {
              return this.each(function () {
                delete this[k.propFix[t] || t];
              });
            },
          }),
            k.extend({
              prop: function (t, e, i) {
                var n,
                  s,
                  o = t.nodeType;
                if (3 !== o && 8 !== o && 2 !== o)
                  return (
                    (1 === o && k.isXMLDoc(t)) ||
                      ((e = k.propFix[e] || e), (s = k.propHooks[e])),
                    void 0 !== i
                      ? s && "set" in s && void 0 !== (n = s.set(t, i, e))
                        ? n
                        : (t[e] = i)
                      : s && "get" in s && null !== (n = s.get(t, e))
                      ? n
                      : t[e]
                  );
              },
              propHooks: {
                tabIndex: {
                  get: function (t) {
                    var e = k.find.attr(t, "tabindex");
                    return e
                      ? parseInt(e, 10)
                      : ve.test(t.nodeName) || (ye.test(t.nodeName) && t.href)
                      ? 0
                      : -1;
                  },
                },
              },
              propFix: { for: "htmlFor", class: "className" },
            }),
            g.optSelected ||
              (k.propHooks.selected = {
                get: function (t) {
                  var e = t.parentNode;
                  return e && e.parentNode && e.parentNode.selectedIndex, null;
                },
                set: function (t) {
                  var e = t.parentNode;
                  e &&
                    (e.selectedIndex,
                    e.parentNode && e.parentNode.selectedIndex);
                },
              }),
            k.each(
              [
                "tabIndex",
                "readOnly",
                "maxLength",
                "cellSpacing",
                "cellPadding",
                "rowSpan",
                "colSpan",
                "useMap",
                "frameBorder",
                "contentEditable",
              ],
              function () {
                k.propFix[this.toLowerCase()] = this;
              }
            ),
            k.fn.extend({
              addClass: function (t) {
                var e,
                  i,
                  n,
                  s,
                  o,
                  r,
                  a,
                  l = 0;
                if (v(t))
                  return this.each(function (e) {
                    k(this).addClass(t.call(this, e, we(this)));
                  });
                if ((e = _e(t)).length)
                  for (; (i = this[l++]); )
                    if (
                      ((s = we(i)), (n = 1 === i.nodeType && " " + be(s) + " "))
                    ) {
                      for (r = 0; (o = e[r++]); )
                        n.indexOf(" " + o + " ") < 0 && (n += o + " ");
                      s !== (a = be(n)) && i.setAttribute("class", a);
                    }
                return this;
              },
              removeClass: function (t) {
                var e,
                  i,
                  n,
                  s,
                  o,
                  r,
                  a,
                  l = 0;
                if (v(t))
                  return this.each(function (e) {
                    k(this).removeClass(t.call(this, e, we(this)));
                  });
                if (!arguments.length) return this.attr("class", "");
                if ((e = _e(t)).length)
                  for (; (i = this[l++]); )
                    if (
                      ((s = we(i)), (n = 1 === i.nodeType && " " + be(s) + " "))
                    ) {
                      for (r = 0; (o = e[r++]); )
                        for (; n.indexOf(" " + o + " ") > -1; )
                          n = n.replace(" " + o + " ", " ");
                      s !== (a = be(n)) && i.setAttribute("class", a);
                    }
                return this;
              },
              toggleClass: function (t, e) {
                var i = typeof t,
                  n = "string" === i || Array.isArray(t);
                return "boolean" == typeof e && n
                  ? e
                    ? this.addClass(t)
                    : this.removeClass(t)
                  : v(t)
                  ? this.each(function (i) {
                      k(this).toggleClass(t.call(this, i, we(this), e), e);
                    })
                  : this.each(function () {
                      var e, s, o, r;
                      if (n)
                        for (s = 0, o = k(this), r = _e(t); (e = r[s++]); )
                          o.hasClass(e) ? o.removeClass(e) : o.addClass(e);
                      else
                        (void 0 !== t && "boolean" !== i) ||
                          ((e = we(this)) && K.set(this, "__className__", e),
                          this.setAttribute &&
                            this.setAttribute(
                              "class",
                              e || !1 === t
                                ? ""
                                : K.get(this, "__className__") || ""
                            ));
                    });
              },
              hasClass: function (t) {
                var e,
                  i,
                  n = 0;
                for (e = " " + t + " "; (i = this[n++]); )
                  if (
                    1 === i.nodeType &&
                    (" " + be(we(i)) + " ").indexOf(e) > -1
                  )
                    return !0;
                return !1;
              },
            });
          var Se = /\r/g;
          k.fn.extend({
            val: function (t) {
              var e,
                i,
                n,
                s = this[0];
              return arguments.length
                ? ((n = v(t)),
                  this.each(function (i) {
                    var s;
                    1 === this.nodeType &&
                      (null == (s = n ? t.call(this, i, k(this).val()) : t)
                        ? (s = "")
                        : "number" == typeof s
                        ? (s += "")
                        : Array.isArray(s) &&
                          (s = k.map(s, function (t) {
                            return null == t ? "" : t + "";
                          })),
                      ((e =
                        k.valHooks[this.type] ||
                        k.valHooks[this.nodeName.toLowerCase()]) &&
                        "set" in e &&
                        void 0 !== e.set(this, s, "value")) ||
                        (this.value = s));
                  }))
                : s
                ? (e =
                    k.valHooks[s.type] ||
                    k.valHooks[s.nodeName.toLowerCase()]) &&
                  "get" in e &&
                  void 0 !== (i = e.get(s, "value"))
                  ? i
                  : "string" == typeof (i = s.value)
                  ? i.replace(Se, "")
                  : null == i
                  ? ""
                  : i
                : void 0;
            },
          }),
            k.extend({
              valHooks: {
                option: {
                  get: function (t) {
                    var e = k.find.attr(t, "value");
                    return null != e ? e : be(k.text(t));
                  },
                },
                select: {
                  get: function (t) {
                    var e,
                      i,
                      n,
                      s = t.options,
                      o = t.selectedIndex,
                      r = "select-one" === t.type,
                      a = r ? null : [],
                      l = r ? o + 1 : s.length;
                    for (n = o < 0 ? l : r ? o : 0; n < l; n++)
                      if (
                        ((i = s[n]).selected || n === o) &&
                        !i.disabled &&
                        (!i.parentNode.disabled || !D(i.parentNode, "optgroup"))
                      ) {
                        if (((e = k(i).val()), r)) return e;
                        a.push(e);
                      }
                    return a;
                  },
                  set: function (t, e) {
                    for (
                      var i, n, s = t.options, o = k.makeArray(e), r = s.length;
                      r--;

                    )
                      ((n = s[r]).selected =
                        k.inArray(k.valHooks.option.get(n), o) > -1) &&
                        (i = !0);
                    return i || (t.selectedIndex = -1), o;
                  },
                },
              },
            }),
            k.each(["radio", "checkbox"], function () {
              (k.valHooks[this] = {
                set: function (t, e) {
                  if (Array.isArray(e))
                    return (t.checked = k.inArray(k(t).val(), e) > -1);
                },
              }),
                g.checkOn ||
                  (k.valHooks[this].get = function (t) {
                    return null === t.getAttribute("value") ? "on" : t.value;
                  });
            }),
            (g.focusin = "onfocusin" in n);
          var Ce = /^(?:focusinfocus|focusoutblur)$/,
            ke = function (t) {
              t.stopPropagation();
            };
          k.extend(k.event, {
            trigger: function (t, e, i, s) {
              var o,
                r,
                a,
                l,
                c,
                h,
                d,
                u,
                f = [i || b],
                m = p.call(t, "type") ? t.type : t,
                g = p.call(t, "namespace") ? t.namespace.split(".") : [];
              if (
                ((r = u = a = i = i || b),
                3 !== i.nodeType &&
                  8 !== i.nodeType &&
                  !Ce.test(m + k.event.triggered) &&
                  (m.indexOf(".") > -1 &&
                    ((g = m.split(".")), (m = g.shift()), g.sort()),
                  (c = m.indexOf(":") < 0 && "on" + m),
                  ((t = t[k.expando]
                    ? t
                    : new k.Event(m, "object" == typeof t && t)).isTrigger = s
                    ? 2
                    : 3),
                  (t.namespace = g.join(".")),
                  (t.rnamespace = t.namespace
                    ? new RegExp(
                        "(^|\\.)" + g.join("\\.(?:.*\\.|)") + "(\\.|$)"
                      )
                    : null),
                  (t.result = void 0),
                  t.target || (t.target = i),
                  (e = null == e ? [t] : k.makeArray(e, [t])),
                  (d = k.event.special[m] || {}),
                  s || !d.trigger || !1 !== d.trigger.apply(i, e)))
              ) {
                if (!s && !d.noBubble && !y(i)) {
                  for (
                    l = d.delegateType || m,
                      Ce.test(l + m) || (r = r.parentNode);
                    r;
                    r = r.parentNode
                  )
                    f.push(r), (a = r);
                  a === (i.ownerDocument || b) &&
                    f.push(a.defaultView || a.parentWindow || n);
                }
                for (o = 0; (r = f[o++]) && !t.isPropagationStopped(); )
                  (u = r),
                    (t.type = o > 1 ? l : d.bindType || m),
                    (h =
                      (K.get(r, "events") || Object.create(null))[t.type] &&
                      K.get(r, "handle")) && h.apply(r, e),
                    (h = c && r[c]) &&
                      h.apply &&
                      Q(r) &&
                      ((t.result = h.apply(r, e)),
                      !1 === t.result && t.preventDefault());
                return (
                  (t.type = m),
                  s ||
                    t.isDefaultPrevented() ||
                    (d._default && !1 !== d._default.apply(f.pop(), e)) ||
                    !Q(i) ||
                    (c &&
                      v(i[m]) &&
                      !y(i) &&
                      ((a = i[c]) && (i[c] = null),
                      (k.event.triggered = m),
                      t.isPropagationStopped() && u.addEventListener(m, ke),
                      i[m](),
                      t.isPropagationStopped() && u.removeEventListener(m, ke),
                      (k.event.triggered = void 0),
                      a && (i[c] = a))),
                  t.result
                );
              }
            },
            simulate: function (t, e, i) {
              var n = k.extend(new k.Event(), i, { type: t, isSimulated: !0 });
              k.event.trigger(n, null, e);
            },
          }),
            k.fn.extend({
              trigger: function (t, e) {
                return this.each(function () {
                  k.event.trigger(t, e, this);
                });
              },
              triggerHandler: function (t, e) {
                var i = this[0];
                if (i) return k.event.trigger(t, e, i, !0);
              },
            }),
            g.focusin ||
              k.each({ focus: "focusin", blur: "focusout" }, function (t, e) {
                var i = function (t) {
                  k.event.simulate(e, t.target, k.event.fix(t));
                };
                k.event.special[e] = {
                  setup: function () {
                    var n = this.ownerDocument || this.document || this,
                      s = K.access(n, e);
                    s || n.addEventListener(t, i, !0),
                      K.access(n, e, (s || 0) + 1);
                  },
                  teardown: function () {
                    var n = this.ownerDocument || this.document || this,
                      s = K.access(n, e) - 1;
                    s
                      ? K.access(n, e, s)
                      : (n.removeEventListener(t, i, !0), K.remove(n, e));
                  },
                };
              });
          var xe = n.location,
            Ee = { guid: Date.now() },
            Ae = /\?/;
          k.parseXML = function (t) {
            var e;
            if (!t || "string" != typeof t) return null;
            try {
              e = new n.DOMParser().parseFromString(t, "text/xml");
            } catch (t) {
              e = void 0;
            }
            return (
              (e && !e.getElementsByTagName("parsererror").length) ||
                k.error("Invalid XML: " + t),
              e
            );
          };
          var Te = /\[\]$/,
            Le = /\r?\n/g,
            De = /^(?:submit|button|image|reset|file)$/i,
            Ie = /^(?:input|select|textarea|keygen)/i;
          function Pe(t, e, i, n) {
            var s;
            if (Array.isArray(e))
              k.each(e, function (e, s) {
                i || Te.test(t)
                  ? n(t, s)
                  : Pe(
                      t +
                        "[" +
                        ("object" == typeof s && null != s ? e : "") +
                        "]",
                      s,
                      i,
                      n
                    );
              });
            else if (i || "object" !== S(e)) n(t, e);
            else for (s in e) Pe(t + "[" + s + "]", e[s], i, n);
          }
          (k.param = function (t, e) {
            var i,
              n = [],
              s = function (t, e) {
                var i = v(e) ? e() : e;
                n[n.length] =
                  encodeURIComponent(t) +
                  "=" +
                  encodeURIComponent(null == i ? "" : i);
              };
            if (null == t) return "";
            if (Array.isArray(t) || (t.jquery && !k.isPlainObject(t)))
              k.each(t, function () {
                s(this.name, this.value);
              });
            else for (i in t) Pe(i, t[i], e, s);
            return n.join("&");
          }),
            k.fn.extend({
              serialize: function () {
                return k.param(this.serializeArray());
              },
              serializeArray: function () {
                return this.map(function () {
                  var t = k.prop(this, "elements");
                  return t ? k.makeArray(t) : this;
                })
                  .filter(function () {
                    var t = this.type;
                    return (
                      this.name &&
                      !k(this).is(":disabled") &&
                      Ie.test(this.nodeName) &&
                      !De.test(t) &&
                      (this.checked || !gt.test(t))
                    );
                  })
                  .map(function (t, e) {
                    var i = k(this).val();
                    return null == i
                      ? null
                      : Array.isArray(i)
                      ? k.map(i, function (t) {
                          return { name: e.name, value: t.replace(Le, "\r\n") };
                        })
                      : { name: e.name, value: i.replace(Le, "\r\n") };
                  })
                  .get();
              },
            });
          var Me = /%20/g,
            Oe = /#.*$/,
            Fe = /([?&])_=[^&]*/,
            qe = /^(.*?):[ \t]*([^\r\n]*)$/gm,
            $e = /^(?:GET|HEAD)$/,
            Be = /^\/\//,
            Ne = {},
            Re = {},
            ze = "*/".concat("*"),
            He = b.createElement("a");
          function Ue(t) {
            return function (e, i) {
              "string" != typeof e && ((i = e), (e = "*"));
              var n,
                s = 0,
                o = e.toLowerCase().match(B) || [];
              if (v(i))
                for (; (n = o[s++]); )
                  "+" === n[0]
                    ? ((n = n.slice(1) || "*"), (t[n] = t[n] || []).unshift(i))
                    : (t[n] = t[n] || []).push(i);
            };
          }
          function je(t, e, i, n) {
            var s = {},
              o = t === Re;
            function r(a) {
              var l;
              return (
                (s[a] = !0),
                k.each(t[a] || [], function (t, a) {
                  var c = a(e, i, n);
                  return "string" != typeof c || o || s[c]
                    ? o
                      ? !(l = c)
                      : void 0
                    : (e.dataTypes.unshift(c), r(c), !1);
                }),
                l
              );
            }
            return r(e.dataTypes[0]) || (!s["*"] && r("*"));
          }
          function We(t, e) {
            var i,
              n,
              s = k.ajaxSettings.flatOptions || {};
            for (i in e)
              void 0 !== e[i] && ((s[i] ? t : n || (n = {}))[i] = e[i]);
            return n && k.extend(!0, t, n), t;
          }
          (He.href = xe.href),
            k.extend({
              active: 0,
              lastModified: {},
              etag: {},
              ajaxSettings: {
                url: xe.href,
                type: "GET",
                isLocal:
                  /^(?:about|app|app-storage|.+-extension|file|res|widget):$/.test(
                    xe.protocol
                  ),
                global: !0,
                processData: !0,
                async: !0,
                contentType: "application/x-www-form-urlencoded; charset=UTF-8",
                accepts: {
                  "*": ze,
                  text: "text/plain",
                  html: "text/html",
                  xml: "application/xml, text/xml",
                  json: "application/json, text/javascript",
                },
                contents: { xml: /\bxml\b/, html: /\bhtml/, json: /\bjson\b/ },
                responseFields: {
                  xml: "responseXML",
                  text: "responseText",
                  json: "responseJSON",
                },
                converters: {
                  "* text": String,
                  "text html": !0,
                  "text json": JSON.parse,
                  "text xml": k.parseXML,
                },
                flatOptions: { url: !0, context: !0 },
              },
              ajaxSetup: function (t, e) {
                return e ? We(We(t, k.ajaxSettings), e) : We(k.ajaxSettings, t);
              },
              ajaxPrefilter: Ue(Ne),
              ajaxTransport: Ue(Re),
              ajax: function (t, e) {
                "object" == typeof t && ((e = t), (t = void 0)), (e = e || {});
                var i,
                  s,
                  o,
                  r,
                  a,
                  l,
                  c,
                  h,
                  d,
                  u,
                  p = k.ajaxSetup({}, e),
                  f = p.context || p,
                  m = p.context && (f.nodeType || f.jquery) ? k(f) : k.event,
                  g = k.Deferred(),
                  v = k.Callbacks("once memory"),
                  y = p.statusCode || {},
                  w = {},
                  _ = {},
                  S = "canceled",
                  C = {
                    readyState: 0,
                    getResponseHeader: function (t) {
                      var e;
                      if (c) {
                        if (!r)
                          for (r = {}; (e = qe.exec(o)); )
                            r[e[1].toLowerCase() + " "] = (
                              r[e[1].toLowerCase() + " "] || []
                            ).concat(e[2]);
                        e = r[t.toLowerCase() + " "];
                      }
                      return null == e ? null : e.join(", ");
                    },
                    getAllResponseHeaders: function () {
                      return c ? o : null;
                    },
                    setRequestHeader: function (t, e) {
                      return (
                        null == c &&
                          ((t = _[t.toLowerCase()] = _[t.toLowerCase()] || t),
                          (w[t] = e)),
                        this
                      );
                    },
                    overrideMimeType: function (t) {
                      return null == c && (p.mimeType = t), this;
                    },
                    statusCode: function (t) {
                      var e;
                      if (t)
                        if (c) C.always(t[C.status]);
                        else for (e in t) y[e] = [y[e], t[e]];
                      return this;
                    },
                    abort: function (t) {
                      var e = t || S;
                      return i && i.abort(e), x(0, e), this;
                    },
                  };
                if (
                  (g.promise(C),
                  (p.url = ((t || p.url || xe.href) + "").replace(
                    Be,
                    xe.protocol + "//"
                  )),
                  (p.type = e.method || e.type || p.method || p.type),
                  (p.dataTypes = (p.dataType || "*").toLowerCase().match(B) || [
                    "",
                  ]),
                  null == p.crossDomain)
                ) {
                  l = b.createElement("a");
                  try {
                    (l.href = p.url),
                      (l.href = l.href),
                      (p.crossDomain =
                        He.protocol + "//" + He.host !=
                        l.protocol + "//" + l.host);
                  } catch (t) {
                    p.crossDomain = !0;
                  }
                }
                if (
                  (p.data &&
                    p.processData &&
                    "string" != typeof p.data &&
                    (p.data = k.param(p.data, p.traditional)),
                  je(Ne, p, e, C),
                  c)
                )
                  return C;
                for (d in ((h = k.event && p.global) &&
                  0 == k.active++ &&
                  k.event.trigger("ajaxStart"),
                (p.type = p.type.toUpperCase()),
                (p.hasContent = !$e.test(p.type)),
                (s = p.url.replace(Oe, "")),
                p.hasContent
                  ? p.data &&
                    p.processData &&
                    0 ===
                      (p.contentType || "").indexOf(
                        "application/x-www-form-urlencoded"
                      ) &&
                    (p.data = p.data.replace(Me, "+"))
                  : ((u = p.url.slice(s.length)),
                    p.data &&
                      (p.processData || "string" == typeof p.data) &&
                      ((s += (Ae.test(s) ? "&" : "?") + p.data), delete p.data),
                    !1 === p.cache &&
                      ((s = s.replace(Fe, "$1")),
                      (u = (Ae.test(s) ? "&" : "?") + "_=" + Ee.guid++ + u)),
                    (p.url = s + u)),
                p.ifModified &&
                  (k.lastModified[s] &&
                    C.setRequestHeader("If-Modified-Since", k.lastModified[s]),
                  k.etag[s] && C.setRequestHeader("If-None-Match", k.etag[s])),
                ((p.data && p.hasContent && !1 !== p.contentType) ||
                  e.contentType) &&
                  C.setRequestHeader("Content-Type", p.contentType),
                C.setRequestHeader(
                  "Accept",
                  p.dataTypes[0] && p.accepts[p.dataTypes[0]]
                    ? p.accepts[p.dataTypes[0]] +
                        ("*" !== p.dataTypes[0] ? ", " + ze + "; q=0.01" : "")
                    : p.accepts["*"]
                ),
                p.headers))
                  C.setRequestHeader(d, p.headers[d]);
                if (p.beforeSend && (!1 === p.beforeSend.call(f, C, p) || c))
                  return C.abort();
                if (
                  ((S = "abort"),
                  v.add(p.complete),
                  C.done(p.success),
                  C.fail(p.error),
                  (i = je(Re, p, e, C)))
                ) {
                  if (
                    ((C.readyState = 1), h && m.trigger("ajaxSend", [C, p]), c)
                  )
                    return C;
                  p.async &&
                    p.timeout > 0 &&
                    (a = n.setTimeout(function () {
                      C.abort("timeout");
                    }, p.timeout));
                  try {
                    (c = !1), i.send(w, x);
                  } catch (t) {
                    if (c) throw t;
                    x(-1, t);
                  }
                } else x(-1, "No Transport");
                function x(t, e, r, l) {
                  var d,
                    u,
                    b,
                    w,
                    _,
                    S = e;
                  c ||
                    ((c = !0),
                    a && n.clearTimeout(a),
                    (i = void 0),
                    (o = l || ""),
                    (C.readyState = t > 0 ? 4 : 0),
                    (d = (t >= 200 && t < 300) || 304 === t),
                    r &&
                      (w = (function (t, e, i) {
                        for (
                          var n, s, o, r, a = t.contents, l = t.dataTypes;
                          "*" === l[0];

                        )
                          l.shift(),
                            void 0 === n &&
                              (n =
                                t.mimeType ||
                                e.getResponseHeader("Content-Type"));
                        if (n)
                          for (s in a)
                            if (a[s] && a[s].test(n)) {
                              l.unshift(s);
                              break;
                            }
                        if (l[0] in i) o = l[0];
                        else {
                          for (s in i) {
                            if (!l[0] || t.converters[s + " " + l[0]]) {
                              o = s;
                              break;
                            }
                            r || (r = s);
                          }
                          o = o || r;
                        }
                        if (o) return o !== l[0] && l.unshift(o), i[o];
                      })(p, C, r)),
                    !d &&
                      k.inArray("script", p.dataTypes) > -1 &&
                      (p.converters["text script"] = function () {}),
                    (w = (function (t, e, i, n) {
                      var s,
                        o,
                        r,
                        a,
                        l,
                        c = {},
                        h = t.dataTypes.slice();
                      if (h[1])
                        for (r in t.converters)
                          c[r.toLowerCase()] = t.converters[r];
                      for (o = h.shift(); o; )
                        if (
                          (t.responseFields[o] && (i[t.responseFields[o]] = e),
                          !l &&
                            n &&
                            t.dataFilter &&
                            (e = t.dataFilter(e, t.dataType)),
                          (l = o),
                          (o = h.shift()))
                        )
                          if ("*" === o) o = l;
                          else if ("*" !== l && l !== o) {
                            if (!(r = c[l + " " + o] || c["* " + o]))
                              for (s in c)
                                if (
                                  (a = s.split(" "))[1] === o &&
                                  (r = c[l + " " + a[0]] || c["* " + a[0]])
                                ) {
                                  !0 === r
                                    ? (r = c[s])
                                    : !0 !== c[s] &&
                                      ((o = a[0]), h.unshift(a[1]));
                                  break;
                                }
                            if (!0 !== r)
                              if (r && t.throws) e = r(e);
                              else
                                try {
                                  e = r(e);
                                } catch (t) {
                                  return {
                                    state: "parsererror",
                                    error: r
                                      ? t
                                      : "No conversion from " + l + " to " + o,
                                  };
                                }
                          }
                      return { state: "success", data: e };
                    })(p, w, C, d)),
                    d
                      ? (p.ifModified &&
                          ((_ = C.getResponseHeader("Last-Modified")) &&
                            (k.lastModified[s] = _),
                          (_ = C.getResponseHeader("etag")) && (k.etag[s] = _)),
                        204 === t || "HEAD" === p.type
                          ? (S = "nocontent")
                          : 304 === t
                          ? (S = "notmodified")
                          : ((S = w.state), (u = w.data), (d = !(b = w.error))))
                      : ((b = S),
                        (!t && S) || ((S = "error"), t < 0 && (t = 0))),
                    (C.status = t),
                    (C.statusText = (e || S) + ""),
                    d
                      ? g.resolveWith(f, [u, S, C])
                      : g.rejectWith(f, [C, S, b]),
                    C.statusCode(y),
                    (y = void 0),
                    h &&
                      m.trigger(d ? "ajaxSuccess" : "ajaxError", [
                        C,
                        p,
                        d ? u : b,
                      ]),
                    v.fireWith(f, [C, S]),
                    h &&
                      (m.trigger("ajaxComplete", [C, p]),
                      --k.active || k.event.trigger("ajaxStop")));
                }
                return C;
              },
              getJSON: function (t, e, i) {
                return k.get(t, e, i, "json");
              },
              getScript: function (t, e) {
                return k.get(t, void 0, e, "script");
              },
            }),
            k.each(["get", "post"], function (t, e) {
              k[e] = function (t, i, n, s) {
                return (
                  v(i) && ((s = s || n), (n = i), (i = void 0)),
                  k.ajax(
                    k.extend(
                      { url: t, type: e, dataType: s, data: i, success: n },
                      k.isPlainObject(t) && t
                    )
                  )
                );
              };
            }),
            k.ajaxPrefilter(function (t) {
              var e;
              for (e in t.headers)
                "content-type" === e.toLowerCase() &&
                  (t.contentType = t.headers[e] || "");
            }),
            (k._evalUrl = function (t, e, i) {
              return k.ajax({
                url: t,
                type: "GET",
                dataType: "script",
                cache: !0,
                async: !1,
                global: !1,
                converters: { "text script": function () {} },
                dataFilter: function (t) {
                  k.globalEval(t, e, i);
                },
              });
            }),
            k.fn.extend({
              wrapAll: function (t) {
                var e;
                return (
                  this[0] &&
                    (v(t) && (t = t.call(this[0])),
                    (e = k(t, this[0].ownerDocument).eq(0).clone(!0)),
                    this[0].parentNode && e.insertBefore(this[0]),
                    e
                      .map(function () {
                        for (var t = this; t.firstElementChild; )
                          t = t.firstElementChild;
                        return t;
                      })
                      .append(this)),
                  this
                );
              },
              wrapInner: function (t) {
                return v(t)
                  ? this.each(function (e) {
                      k(this).wrapInner(t.call(this, e));
                    })
                  : this.each(function () {
                      var e = k(this),
                        i = e.contents();
                      i.length ? i.wrapAll(t) : e.append(t);
                    });
              },
              wrap: function (t) {
                var e = v(t);
                return this.each(function (i) {
                  k(this).wrapAll(e ? t.call(this, i) : t);
                });
              },
              unwrap: function (t) {
                return (
                  this.parent(t)
                    .not("body")
                    .each(function () {
                      k(this).replaceWith(this.childNodes);
                    }),
                  this
                );
              },
            }),
            (k.expr.pseudos.hidden = function (t) {
              return !k.expr.pseudos.visible(t);
            }),
            (k.expr.pseudos.visible = function (t) {
              return !!(
                t.offsetWidth ||
                t.offsetHeight ||
                t.getClientRects().length
              );
            }),
            (k.ajaxSettings.xhr = function () {
              try {
                return new n.XMLHttpRequest();
              } catch (t) {}
            });
          var Ve = { 0: 200, 1223: 204 },
            Ge = k.ajaxSettings.xhr();
          (g.cors = !!Ge && "withCredentials" in Ge),
            (g.ajax = Ge = !!Ge),
            k.ajaxTransport(function (t) {
              var e, i;
              if (g.cors || (Ge && !t.crossDomain))
                return {
                  send: function (s, o) {
                    var r,
                      a = t.xhr();
                    if (
                      (a.open(t.type, t.url, t.async, t.username, t.password),
                      t.xhrFields)
                    )
                      for (r in t.xhrFields) a[r] = t.xhrFields[r];
                    for (r in (t.mimeType &&
                      a.overrideMimeType &&
                      a.overrideMimeType(t.mimeType),
                    t.crossDomain ||
                      s["X-Requested-With"] ||
                      (s["X-Requested-With"] = "XMLHttpRequest"),
                    s))
                      a.setRequestHeader(r, s[r]);
                    (e = function (t) {
                      return function () {
                        e &&
                          ((e =
                            i =
                            a.onload =
                            a.onerror =
                            a.onabort =
                            a.ontimeout =
                            a.onreadystatechange =
                              null),
                          "abort" === t
                            ? a.abort()
                            : "error" === t
                            ? "number" != typeof a.status
                              ? o(0, "error")
                              : o(a.status, a.statusText)
                            : o(
                                Ve[a.status] || a.status,
                                a.statusText,
                                "text" !== (a.responseType || "text") ||
                                  "string" != typeof a.responseText
                                  ? { binary: a.response }
                                  : { text: a.responseText },
                                a.getAllResponseHeaders()
                              ));
                      };
                    }),
                      (a.onload = e()),
                      (i = a.onerror = a.ontimeout = e("error")),
                      void 0 !== a.onabort
                        ? (a.onabort = i)
                        : (a.onreadystatechange = function () {
                            4 === a.readyState &&
                              n.setTimeout(function () {
                                e && i();
                              });
                          }),
                      (e = e("abort"));
                    try {
                      a.send((t.hasContent && t.data) || null);
                    } catch (t) {
                      if (e) throw t;
                    }
                  },
                  abort: function () {
                    e && e();
                  },
                };
            }),
            k.ajaxPrefilter(function (t) {
              t.crossDomain && (t.contents.script = !1);
            }),
            k.ajaxSetup({
              accepts: {
                script:
                  "text/javascript, application/javascript, application/ecmascript, application/x-ecmascript",
              },
              contents: { script: /\b(?:java|ecma)script\b/ },
              converters: {
                "text script": function (t) {
                  return k.globalEval(t), t;
                },
              },
            }),
            k.ajaxPrefilter("script", function (t) {
              void 0 === t.cache && (t.cache = !1),
                t.crossDomain && (t.type = "GET");
            }),
            k.ajaxTransport("script", function (t) {
              var e, i;
              if (t.crossDomain || t.scriptAttrs)
                return {
                  send: function (n, s) {
                    (e = k("<script>")
                      .attr(t.scriptAttrs || {})
                      .prop({ charset: t.scriptCharset, src: t.url })
                      .on(
                        "load error",
                        (i = function (t) {
                          e.remove(),
                            (i = null),
                            t && s("error" === t.type ? 404 : 200, t.type);
                        })
                      )),
                      b.head.appendChild(e[0]);
                  },
                  abort: function () {
                    i && i();
                  },
                };
            });
          var Xe,
            Ze = [],
            Qe = /(=)\?(?=&|$)|\?\?/;
          k.ajaxSetup({
            jsonp: "callback",
            jsonpCallback: function () {
              var t = Ze.pop() || k.expando + "_" + Ee.guid++;
              return (this[t] = !0), t;
            },
          }),
            k.ajaxPrefilter("json jsonp", function (t, e, i) {
              var s,
                o,
                r,
                a =
                  !1 !== t.jsonp &&
                  (Qe.test(t.url)
                    ? "url"
                    : "string" == typeof t.data &&
                      0 ===
                        (t.contentType || "").indexOf(
                          "application/x-www-form-urlencoded"
                        ) &&
                      Qe.test(t.data) &&
                      "data");
              if (a || "jsonp" === t.dataTypes[0])
                return (
                  (s = t.jsonpCallback =
                    v(t.jsonpCallback) ? t.jsonpCallback() : t.jsonpCallback),
                  a
                    ? (t[a] = t[a].replace(Qe, "$1" + s))
                    : !1 !== t.jsonp &&
                      (t.url +=
                        (Ae.test(t.url) ? "&" : "?") + t.jsonp + "=" + s),
                  (t.converters["script json"] = function () {
                    return r || k.error(s + " was not called"), r[0];
                  }),
                  (t.dataTypes[0] = "json"),
                  (o = n[s]),
                  (n[s] = function () {
                    r = arguments;
                  }),
                  i.always(function () {
                    void 0 === o ? k(n).removeProp(s) : (n[s] = o),
                      t[s] && ((t.jsonpCallback = e.jsonpCallback), Ze.push(s)),
                      r && v(o) && o(r[0]),
                      (r = o = void 0);
                  }),
                  "script"
                );
            }),
            (g.createHTMLDocument =
              (((Xe = b.implementation.createHTMLDocument("").body).innerHTML =
                "<form></form><form></form>"),
              2 === Xe.childNodes.length)),
            (k.parseHTML = function (t, e, i) {
              return "string" != typeof t
                ? []
                : ("boolean" == typeof e && ((i = e), (e = !1)),
                  e ||
                    (g.createHTMLDocument
                      ? (((n = (e =
                          b.implementation.createHTMLDocument(
                            ""
                          )).createElement("base")).href = b.location.href),
                        e.head.appendChild(n))
                      : (e = b)),
                  (o = !i && []),
                  (s = I.exec(t))
                    ? [e.createElement(s[1])]
                    : ((s = Ct([t], e, o)),
                      o && o.length && k(o).remove(),
                      k.merge([], s.childNodes)));
              var n, s, o;
            }),
            (k.fn.load = function (t, e, i) {
              var n,
                s,
                o,
                r = this,
                a = t.indexOf(" ");
              return (
                a > -1 && ((n = be(t.slice(a))), (t = t.slice(0, a))),
                v(e)
                  ? ((i = e), (e = void 0))
                  : e && "object" == typeof e && (s = "POST"),
                r.length > 0 &&
                  k
                    .ajax({
                      url: t,
                      type: s || "GET",
                      dataType: "html",
                      data: e,
                    })
                    .done(function (t) {
                      (o = arguments),
                        r.html(
                          n ? k("<div>").append(k.parseHTML(t)).find(n) : t
                        );
                    })
                    .always(
                      i &&
                        function (t, e) {
                          r.each(function () {
                            i.apply(this, o || [t.responseText, e, t]);
                          });
                        }
                    ),
                this
              );
            }),
            (k.expr.pseudos.animated = function (t) {
              return k.grep(k.timers, function (e) {
                return t === e.elem;
              }).length;
            }),
            (k.offset = {
              setOffset: function (t, e, i) {
                var n,
                  s,
                  o,
                  r,
                  a,
                  l,
                  c = k.css(t, "position"),
                  h = k(t),
                  d = {};
                "static" === c && (t.style.position = "relative"),
                  (a = h.offset()),
                  (o = k.css(t, "top")),
                  (l = k.css(t, "left")),
                  ("absolute" === c || "fixed" === c) &&
                  (o + l).indexOf("auto") > -1
                    ? ((r = (n = h.position()).top), (s = n.left))
                    : ((r = parseFloat(o) || 0), (s = parseFloat(l) || 0)),
                  v(e) && (e = e.call(t, i, k.extend({}, a))),
                  null != e.top && (d.top = e.top - a.top + r),
                  null != e.left && (d.left = e.left - a.left + s),
                  "using" in e
                    ? e.using.call(t, d)
                    : ("number" == typeof d.top && (d.top += "px"),
                      "number" == typeof d.left && (d.left += "px"),
                      h.css(d));
              },
            }),
            k.fn.extend({
              offset: function (t) {
                if (arguments.length)
                  return void 0 === t
                    ? this
                    : this.each(function (e) {
                        k.offset.setOffset(this, t, e);
                      });
                var e,
                  i,
                  n = this[0];
                return n
                  ? n.getClientRects().length
                    ? ((e = n.getBoundingClientRect()),
                      (i = n.ownerDocument.defaultView),
                      {
                        top: e.top + i.pageYOffset,
                        left: e.left + i.pageXOffset,
                      })
                    : { top: 0, left: 0 }
                  : void 0;
              },
              position: function () {
                if (this[0]) {
                  var t,
                    e,
                    i,
                    n = this[0],
                    s = { top: 0, left: 0 };
                  if ("fixed" === k.css(n, "position"))
                    e = n.getBoundingClientRect();
                  else {
                    for (
                      e = this.offset(),
                        i = n.ownerDocument,
                        t = n.offsetParent || i.documentElement;
                      t &&
                      (t === i.body || t === i.documentElement) &&
                      "static" === k.css(t, "position");

                    )
                      t = t.parentNode;
                    t &&
                      t !== n &&
                      1 === t.nodeType &&
                      (((s = k(t).offset()).top += k.css(
                        t,
                        "borderTopWidth",
                        !0
                      )),
                      (s.left += k.css(t, "borderLeftWidth", !0)));
                  }
                  return {
                    top: e.top - s.top - k.css(n, "marginTop", !0),
                    left: e.left - s.left - k.css(n, "marginLeft", !0),
                  };
                }
              },
              offsetParent: function () {
                return this.map(function () {
                  for (
                    var t = this.offsetParent;
                    t && "static" === k.css(t, "position");

                  )
                    t = t.offsetParent;
                  return t || rt;
                });
              },
            }),
            k.each(
              { scrollLeft: "pageXOffset", scrollTop: "pageYOffset" },
              function (t, e) {
                var i = "pageYOffset" === e;
                k.fn[t] = function (n) {
                  return W(
                    this,
                    function (t, n, s) {
                      var o;
                      if (
                        (y(t)
                          ? (o = t)
                          : 9 === t.nodeType && (o = t.defaultView),
                        void 0 === s)
                      )
                        return o ? o[e] : t[n];
                      o
                        ? o.scrollTo(
                            i ? o.pageXOffset : s,
                            i ? s : o.pageYOffset
                          )
                        : (t[n] = s);
                    },
                    t,
                    n,
                    arguments.length
                  );
                };
              }
            ),
            k.each(["top", "left"], function (t, e) {
              k.cssHooks[e] = Gt(g.pixelPosition, function (t, i) {
                if (i)
                  return (
                    (i = Vt(t, e)), Ht.test(i) ? k(t).position()[e] + "px" : i
                  );
              });
            }),
            k.each({ Height: "height", Width: "width" }, function (t, e) {
              k.each(
                { padding: "inner" + t, content: e, "": "outer" + t },
                function (i, n) {
                  k.fn[n] = function (s, o) {
                    var r = arguments.length && (i || "boolean" != typeof s),
                      a = i || (!0 === s || !0 === o ? "margin" : "border");
                    return W(
                      this,
                      function (e, i, s) {
                        var o;
                        return y(e)
                          ? 0 === n.indexOf("outer")
                            ? e["inner" + t]
                            : e.document.documentElement["client" + t]
                          : 9 === e.nodeType
                          ? ((o = e.documentElement),
                            Math.max(
                              e.body["scroll" + t],
                              o["scroll" + t],
                              e.body["offset" + t],
                              o["offset" + t],
                              o["client" + t]
                            ))
                          : void 0 === s
                          ? k.css(e, i, a)
                          : k.style(e, i, s, a);
                      },
                      e,
                      r ? s : void 0,
                      r
                    );
                  };
                }
              );
            }),
            k.each(
              [
                "ajaxStart",
                "ajaxStop",
                "ajaxComplete",
                "ajaxError",
                "ajaxSuccess",
                "ajaxSend",
              ],
              function (t, e) {
                k.fn[e] = function (t) {
                  return this.on(e, t);
                };
              }
            ),
            k.fn.extend({
              bind: function (t, e, i) {
                return this.on(t, null, e, i);
              },
              unbind: function (t, e) {
                return this.off(t, null, e);
              },
              delegate: function (t, e, i, n) {
                return this.on(e, t, i, n);
              },
              undelegate: function (t, e, i) {
                return 1 === arguments.length
                  ? this.off(t, "**")
                  : this.off(e, t || "**", i);
              },
              hover: function (t, e) {
                return this.mouseenter(t).mouseleave(e || t);
              },
            }),
            k.each(
              "blur focus focusin focusout resize scroll click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup contextmenu".split(
                " "
              ),
              function (t, e) {
                k.fn[e] = function (t, i) {
                  return arguments.length > 0
                    ? this.on(e, null, t, i)
                    : this.trigger(e);
                };
              }
            );
          var Ye = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g;
          (k.proxy = function (t, e) {
            var i, n, s;
            if (("string" == typeof e && ((i = t[e]), (e = t), (t = i)), v(t)))
              return (
                (n = a.call(arguments, 2)),
                (s = function () {
                  return t.apply(e || this, n.concat(a.call(arguments)));
                }),
                (s.guid = t.guid = t.guid || k.guid++),
                s
              );
          }),
            (k.holdReady = function (t) {
              t ? k.readyWait++ : k.ready(!0);
            }),
            (k.isArray = Array.isArray),
            (k.parseJSON = JSON.parse),
            (k.nodeName = D),
            (k.isFunction = v),
            (k.isWindow = y),
            (k.camelCase = Z),
            (k.type = S),
            (k.now = Date.now),
            (k.isNumeric = function (t) {
              var e = k.type(t);
              return (
                ("number" === e || "string" === e) && !isNaN(t - parseFloat(t))
              );
            }),
            (k.trim = function (t) {
              return null == t ? "" : (t + "").replace(Ye, "");
            }),
            void 0 ===
              (i = function () {
                return k;
              }.apply(e, [])) || (t.exports = i);
          var Ke = n.jQuery,
            Je = n.$;
          return (
            (k.noConflict = function (t) {
              return (
                n.$ === k && (n.$ = Je),
                t && n.jQuery === k && (n.jQuery = Ke),
                k
              );
            }),
            void 0 === s && (n.jQuery = n.$ = k),
            k
          );
        });
      },
      405: (t) => {
        t.exports = function (t, e, i, n) {
          var s, o, r;
          return function () {
            if (
              ((r = this),
              (o = Array.prototype.slice.call(arguments)),
              !s || (!i && !n))
            ) {
              if (!i)
                return (
                  a(),
                  (s = setTimeout(function () {
                    a(), t.apply(r, o);
                  }, e))
                );
              (s = setTimeout(a, e)), t.apply(r, o);
            }
            function a() {
              clearTimeout(s), (s = null);
            }
          };
        };
      },
      411: function (t, e, i) {
        var n, s;
        /*! PhotoSwipe Default UI - 4.1.3 - 2019-01-08
         * http://photoswipe.com
         * Copyright (c) 2019 Dmitry Semenov; */ void 0 ===
          (s =
            "function" ==
            typeof (n = function () {
              "use strict";
              return function (t, e) {
                var i,
                  n,
                  s,
                  o,
                  r,
                  a,
                  l,
                  c,
                  h,
                  d,
                  u,
                  p,
                  f,
                  m,
                  g,
                  v,
                  y,
                  b,
                  w = this,
                  _ = !1,
                  S = !0,
                  C = !0,
                  k = {
                    barsSize: { top: 44, bottom: "auto" },
                    closeElClasses: [
                      "item",
                      "caption",
                      "zoom-wrap",
                      "ui",
                      "top-bar",
                    ],
                    timeToIdle: 4e3,
                    timeToIdleOutside: 1e3,
                    loadingIndicatorDelay: 1e3,
                    addCaptionHTMLFn: function (t, e) {
                      return t.title
                        ? ((e.children[0].innerHTML = t.title), !0)
                        : ((e.children[0].innerHTML = ""), !1);
                    },
                    closeEl: !0,
                    captionEl: !0,
                    fullscreenEl: !0,
                    zoomEl: !0,
                    shareEl: !0,
                    counterEl: !0,
                    arrowEl: !0,
                    preloaderEl: !0,
                    tapToClose: !1,
                    tapToToggleControls: !0,
                    clickToCloseNonZoomable: !0,
                    shareButtons: [
                      {
                        id: "facebook",
                        label: "Share on Facebook",
                        url: "https://www.facebook.com/sharer/sharer.php?u=",
                      },
                      {
                        id: "twitter",
                        label: "Tweet",
                        url: "https://twitter.com/intent/tweet?text=&url=",
                      },
                      {
                        id: "pinterest",
                        label: "Pin it",
                        url: "http://www.pinterest.com/pin/create/button/?url=&media=&description=",
                      },
                      {
                        id: "download",
                        label: "Download image",
                        url: "",
                        download: !0,
                      },
                    ],
                    getImageURLForShare: function () {
                      return t.currItem.src || "";
                    },
                    getPageURLForShare: function () {
                      return window.location.href;
                    },
                    getTextForShare: function () {
                      return t.currItem.title || "";
                    },
                    indexIndicatorSep: " / ",
                    fitControlsWidth: 1200,
                  },
                  x = function (t) {
                    if (v) return !0;
                    (t = t || window.event),
                      g.timeToIdle && g.mouseUsed && !h && F();
                    for (
                      var i,
                        n,
                        s =
                          (t.target || t.srcElement).getAttribute("class") ||
                          "",
                        o = 0;
                      o < U.length;
                      o++
                    )
                      (i = U[o]).onTap &&
                        s.indexOf("pswp__" + i.name) > -1 &&
                        (i.onTap(), (n = !0));
                    if (n) {
                      t.stopPropagation && t.stopPropagation(), (v = !0);
                      var r = e.features.isOldAndroid ? 600 : 30;
                      setTimeout(function () {
                        v = !1;
                      }, r);
                    }
                  },
                  E = function () {
                    return (
                      !t.likelyTouchDevice ||
                      g.mouseUsed ||
                      screen.width > g.fitControlsWidth
                    );
                  },
                  A = function (t, i, n) {
                    e[(n ? "add" : "remove") + "Class"](t, "pswp__" + i);
                  },
                  T = function () {
                    var t = 1 === g.getNumItemsFn();
                    t !== m && (A(n, "ui--one-slide", t), (m = t));
                  },
                  L = function () {
                    A(l, "share-modal--hidden", C);
                  },
                  D = function () {
                    return (
                      (C = !C)
                        ? (e.removeClass(l, "pswp__share-modal--fade-in"),
                          setTimeout(function () {
                            C && L();
                          }, 300))
                        : (L(),
                          setTimeout(function () {
                            C || e.addClass(l, "pswp__share-modal--fade-in");
                          }, 30)),
                      C || P(),
                      !1
                    );
                  },
                  I = function (e) {
                    var i = (e = e || window.event).target || e.srcElement;
                    return (
                      t.shout("shareLinkClick", e, i),
                      !(
                        !i.href ||
                        (!i.hasAttribute("download") &&
                          (window.open(
                            i.href,
                            "pswp_share",
                            "scrollbars=yes,resizable=yes,toolbar=no,location=yes,width=550,height=420,top=100,left=" +
                              (window.screen
                                ? Math.round(screen.width / 2 - 275)
                                : 100)
                          ),
                          C || D(),
                          1))
                      )
                    );
                  },
                  P = function () {
                    for (
                      var t, e, i, n, s = "", o = 0;
                      o < g.shareButtons.length;
                      o++
                    )
                      (t = g.shareButtons[o]),
                        (e = g.getImageURLForShare(t)),
                        (i = g.getPageURLForShare(t)),
                        (n = g.getTextForShare(t)),
                        (s +=
                          '<a href="' +
                          t.url
                            .replace("", encodeURIComponent(i))
                            .replace("", encodeURIComponent(e))
                            .replace("", e)
                            .replace("", encodeURIComponent(n)) +
                          '" target="_blank" class="pswp__share--' +
                          t.id +
                          '"' +
                          (t.download ? "download" : "") +
                          ">" +
                          t.label +
                          "</a>"),
                        g.parseShareButtonOut &&
                          (s = g.parseShareButtonOut(t, s));
                    (l.children[0].innerHTML = s), (l.children[0].onclick = I);
                  },
                  M = function (t) {
                    for (var i = 0; i < g.closeElClasses.length; i++)
                      if (e.hasClass(t, "pswp__" + g.closeElClasses[i]))
                        return !0;
                  },
                  O = 0,
                  F = function () {
                    clearTimeout(b), (O = 0), h && w.setIdle(!1);
                  },
                  q = function (t) {
                    var e =
                      (t = t || window.event).relatedTarget || t.toElement;
                    (e && "HTML" !== e.nodeName) ||
                      (clearTimeout(b),
                      (b = setTimeout(function () {
                        w.setIdle(!0);
                      }, g.timeToIdleOutside)));
                  },
                  $ = function () {
                    g.fullscreenEl &&
                      !e.features.isOldAndroid &&
                      (i || (i = w.getFullscreenAPI()),
                      i
                        ? (e.bind(document, i.eventK, w.updateFullscreen),
                          w.updateFullscreen(),
                          e.addClass(t.template, "pswp--supports-fs"))
                        : e.removeClass(t.template, "pswp--supports-fs"));
                  },
                  B = function () {
                    g.preloaderEl &&
                      (N(!0),
                      d("beforeChange", function () {
                        clearTimeout(f),
                          (f = setTimeout(function () {
                            t.currItem && t.currItem.loading
                              ? (!t.allowProgressiveImg() ||
                                  (t.currItem.img &&
                                    !t.currItem.img.naturalWidth)) &&
                                N(!1)
                              : N(!0);
                          }, g.loadingIndicatorDelay));
                      }),
                      d("imageLoadComplete", function (e, i) {
                        t.currItem === i && N(!0);
                      }));
                  },
                  N = function (t) {
                    p !== t && (A(u, "preloader--active", !t), (p = t));
                  },
                  R = function (t) {
                    var i = t.vGap;
                    if (E()) {
                      var r = g.barsSize;
                      if (g.captionEl && "auto" === r.bottom)
                        if (
                          (o ||
                            ((o = e.createEl(
                              "pswp__caption pswp__caption--fake"
                            )).appendChild(e.createEl("pswp__caption__center")),
                            n.insertBefore(o, s),
                            e.addClass(n, "pswp__ui--fit")),
                          g.addCaptionHTMLFn(t, o, !0))
                        ) {
                          var a = o.clientHeight;
                          i.bottom = parseInt(a, 10) || 44;
                        } else i.bottom = r.top;
                      else i.bottom = "auto" === r.bottom ? 0 : r.bottom;
                      i.top = r.top;
                    } else i.top = i.bottom = 0;
                  },
                  z = function () {
                    g.timeToIdle &&
                      d("mouseUsed", function () {
                        e.bind(document, "mousemove", F),
                          e.bind(document, "mouseout", q),
                          (y = setInterval(function () {
                            2 == ++O && w.setIdle(!0);
                          }, g.timeToIdle / 2));
                      });
                  },
                  H = function () {
                    var t;
                    d("onVerticalDrag", function (t) {
                      S && t < 0.95
                        ? w.hideControls()
                        : !S && t >= 0.95 && w.showControls();
                    }),
                      d("onPinchClose", function (e) {
                        S && e < 0.9
                          ? (w.hideControls(), (t = !0))
                          : t && !S && e > 0.9 && w.showControls();
                      }),
                      d("zoomGestureEnded", function () {
                        (t = !1) && !S && w.showControls();
                      });
                  },
                  U = [
                    {
                      name: "caption",
                      option: "captionEl",
                      onInit: function (t) {
                        s = t;
                      },
                    },
                    {
                      name: "share-modal",
                      option: "shareEl",
                      onInit: function (t) {
                        l = t;
                      },
                      onTap: function () {
                        D();
                      },
                    },
                    {
                      name: "button--share",
                      option: "shareEl",
                      onInit: function (t) {
                        a = t;
                      },
                      onTap: function () {
                        D();
                      },
                    },
                    {
                      name: "button--zoom",
                      option: "zoomEl",
                      onTap: t.toggleDesktopZoom,
                    },
                    {
                      name: "counter",
                      option: "counterEl",
                      onInit: function (t) {
                        r = t;
                      },
                    },
                    {
                      name: "button--close",
                      option: "closeEl",
                      onTap: t.close,
                    },
                    {
                      name: "button--arrow--left",
                      option: "arrowEl",
                      onTap: t.prev,
                    },
                    {
                      name: "button--arrow--right",
                      option: "arrowEl",
                      onTap: t.next,
                    },
                    {
                      name: "button--fs",
                      option: "fullscreenEl",
                      onTap: function () {
                        i.isFullscreen() ? i.exit() : i.enter();
                      },
                    },
                    {
                      name: "preloader",
                      option: "preloaderEl",
                      onInit: function (t) {
                        u = t;
                      },
                    },
                  ],
                  j = function () {
                    var t,
                      i,
                      s,
                      o = function (n) {
                        if (n)
                          for (var o = n.length, r = 0; r < o; r++) {
                            (t = n[r]), (i = t.className);
                            for (var a = 0; a < U.length; a++)
                              (s = U[a]),
                                i.indexOf("pswp__" + s.name) > -1 &&
                                  (g[s.option]
                                    ? (e.removeClass(
                                        t,
                                        "pswp__element--disabled"
                                      ),
                                      s.onInit && s.onInit(t))
                                    : e.addClass(t, "pswp__element--disabled"));
                          }
                      };
                    o(n.children);
                    var r = e.getChildByClass(n, "pswp__top-bar");
                    r && o(r.children);
                  };
                (w.init = function () {
                  e.extend(t.options, k, !0),
                    (g = t.options),
                    (n = e.getChildByClass(t.scrollWrap, "pswp__ui")),
                    (d = t.listen),
                    H(),
                    d("beforeChange", w.update),
                    d("doubleTap", function (e) {
                      var i = t.currItem.initialZoomLevel;
                      t.getZoomLevel() !== i
                        ? t.zoomTo(i, e, 333)
                        : t.zoomTo(g.getDoubleTapZoom(!1, t.currItem), e, 333);
                    }),
                    d("preventDragEvent", function (t, e, i) {
                      var n = t.target || t.srcElement;
                      n &&
                        n.getAttribute("class") &&
                        t.type.indexOf("mouse") > -1 &&
                        (n.getAttribute("class").indexOf("__caption") > 0 ||
                          /(SMALL|STRONG|EM)/i.test(n.tagName)) &&
                        (i.prevent = !1);
                    }),
                    d("bindEvents", function () {
                      e.bind(n, "pswpTap click", x),
                        e.bind(t.scrollWrap, "pswpTap", w.onGlobalTap),
                        t.likelyTouchDevice ||
                          e.bind(t.scrollWrap, "mouseover", w.onMouseOver);
                    }),
                    d("unbindEvents", function () {
                      C || D(),
                        y && clearInterval(y),
                        e.unbind(document, "mouseout", q),
                        e.unbind(document, "mousemove", F),
                        e.unbind(n, "pswpTap click", x),
                        e.unbind(t.scrollWrap, "pswpTap", w.onGlobalTap),
                        e.unbind(t.scrollWrap, "mouseover", w.onMouseOver),
                        i &&
                          (e.unbind(document, i.eventK, w.updateFullscreen),
                          i.isFullscreen() &&
                            ((g.hideAnimationDuration = 0), i.exit()),
                          (i = null));
                    }),
                    d("destroy", function () {
                      g.captionEl &&
                        (o && n.removeChild(o),
                        e.removeClass(s, "pswp__caption--empty")),
                        l && (l.children[0].onclick = null),
                        e.removeClass(n, "pswp__ui--over-close"),
                        e.addClass(n, "pswp__ui--hidden"),
                        w.setIdle(!1);
                    }),
                    g.showAnimationDuration ||
                      e.removeClass(n, "pswp__ui--hidden"),
                    d("initialZoomIn", function () {
                      g.showAnimationDuration &&
                        e.removeClass(n, "pswp__ui--hidden");
                    }),
                    d("initialZoomOut", function () {
                      e.addClass(n, "pswp__ui--hidden");
                    }),
                    d("parseVerticalMargin", R),
                    j(),
                    g.shareEl && a && l && (C = !0),
                    T(),
                    z(),
                    $(),
                    B();
                }),
                  (w.setIdle = function (t) {
                    (h = t), A(n, "ui--idle", t);
                  }),
                  (w.update = function () {
                    S && t.currItem
                      ? (w.updateIndexIndicator(),
                        g.captionEl &&
                          (g.addCaptionHTMLFn(t.currItem, s),
                          A(s, "caption--empty", !t.currItem.title)),
                        (_ = !0))
                      : (_ = !1),
                      C || D(),
                      T();
                  }),
                  (w.updateFullscreen = function (n) {
                    n &&
                      setTimeout(function () {
                        t.setScrollOffset(0, e.getScrollY());
                      }, 50),
                      e[(i.isFullscreen() ? "add" : "remove") + "Class"](
                        t.template,
                        "pswp--fs"
                      );
                  }),
                  (w.updateIndexIndicator = function () {
                    g.counterEl &&
                      (r.innerHTML =
                        t.getCurrentIndex() +
                        1 +
                        g.indexIndicatorSep +
                        g.getNumItemsFn());
                  }),
                  (w.onGlobalTap = function (i) {
                    var n = (i = i || window.event).target || i.srcElement;
                    if (!v)
                      if (i.detail && "mouse" === i.detail.pointerType) {
                        if (M(n)) return void t.close();
                        e.hasClass(n, "pswp__img") &&
                          (1 === t.getZoomLevel() &&
                          t.getZoomLevel() <= t.currItem.fitRatio
                            ? g.clickToCloseNonZoomable && t.close()
                            : t.toggleDesktopZoom(i.detail.releasePoint));
                      } else if (
                        (g.tapToToggleControls &&
                          (S ? w.hideControls() : w.showControls()),
                        g.tapToClose && (e.hasClass(n, "pswp__img") || M(n)))
                      )
                        return void t.close();
                  }),
                  (w.onMouseOver = function (t) {
                    var e = (t = t || window.event).target || t.srcElement;
                    A(n, "ui--over-close", M(e));
                  }),
                  (w.hideControls = function () {
                    e.addClass(n, "pswp__ui--hidden"), (S = !1);
                  }),
                  (w.showControls = function () {
                    (S = !0),
                      _ || w.update(),
                      e.removeClass(n, "pswp__ui--hidden");
                  }),
                  (w.supportsFullscreen = function () {
                    var t = document;
                    return !!(
                      t.exitFullscreen ||
                      t.mozCancelFullScreen ||
                      t.webkitExitFullscreen ||
                      t.msExitFullscreen
                    );
                  }),
                  (w.getFullscreenAPI = function () {
                    var e,
                      i = document.documentElement,
                      n = "fullscreenchange";
                    return (
                      i.requestFullscreen
                        ? (e = {
                            enterK: "requestFullscreen",
                            exitK: "exitFullscreen",
                            elementK: "fullscreenElement",
                            eventK: n,
                          })
                        : i.mozRequestFullScreen
                        ? (e = {
                            enterK: "mozRequestFullScreen",
                            exitK: "mozCancelFullScreen",
                            elementK: "mozFullScreenElement",
                            eventK: "moz" + n,
                          })
                        : i.webkitRequestFullscreen
                        ? (e = {
                            enterK: "webkitRequestFullscreen",
                            exitK: "webkitExitFullscreen",
                            elementK: "webkitFullscreenElement",
                            eventK: "webkit" + n,
                          })
                        : i.msRequestFullscreen &&
                          (e = {
                            enterK: "msRequestFullscreen",
                            exitK: "msExitFullscreen",
                            elementK: "msFullscreenElement",
                            eventK: "MSFullscreenChange",
                          }),
                      e &&
                        ((e.enter = function () {
                          if (
                            ((c = g.closeOnScroll),
                            (g.closeOnScroll = !1),
                            "webkitRequestFullscreen" !== this.enterK)
                          )
                            return t.template[this.enterK]();
                          t.template[this.enterK](Element.ALLOW_KEYBOARD_INPUT);
                        }),
                        (e.exit = function () {
                          return (g.closeOnScroll = c), document[this.exitK]();
                        }),
                        (e.isFullscreen = function () {
                          return document[this.elementK];
                        })),
                      e
                    );
                  });
              };
            })
              ? n.call(e, i, e, t)
              : n) || (t.exports = s);
      },
      832: function (t, e, i) {
        var n, s;
        /*! PhotoSwipe - v4.1.3 - 2019-01-08
         * http://photoswipe.com
         * Copyright (c) 2019 Dmitry Semenov; */ (n = function () {
          "use strict";
          var t = function (t, e, i, n) {
            var s = {
              features: null,
              bind: function (t, e, i, n) {
                var s = (n ? "remove" : "add") + "EventListener";
                e = e.split(" ");
                for (var o = 0; o < e.length; o++) e[o] && t[s](e[o], i, !1);
              },
              isArray: function (t) {
                return t instanceof Array;
              },
              createEl: function (t, e) {
                var i = document.createElement(e || "div");
                return t && (i.className = t), i;
              },
              getScrollY: function () {
                var t = window.pageYOffset;
                return void 0 !== t ? t : document.documentElement.scrollTop;
              },
              unbind: function (t, e, i) {
                s.bind(t, e, i, !0);
              },
              removeClass: function (t, e) {
                var i = new RegExp("(\\s|^)" + e + "(\\s|$)");
                t.className = t.className
                  .replace(i, " ")
                  .replace(/^\s\s*/, "")
                  .replace(/\s\s*$/, "");
              },
              addClass: function (t, e) {
                s.hasClass(t, e) ||
                  (t.className += (t.className ? " " : "") + e);
              },
              hasClass: function (t, e) {
                return (
                  t.className &&
                  new RegExp("(^|\\s)" + e + "(\\s|$)").test(t.className)
                );
              },
              getChildByClass: function (t, e) {
                for (var i = t.firstChild; i; ) {
                  if (s.hasClass(i, e)) return i;
                  i = i.nextSibling;
                }
              },
              arraySearch: function (t, e, i) {
                for (var n = t.length; n--; ) if (t[n][i] === e) return n;
                return -1;
              },
              extend: function (t, e, i) {
                for (var n in e)
                  if (e.hasOwnProperty(n)) {
                    if (i && t.hasOwnProperty(n)) continue;
                    t[n] = e[n];
                  }
              },
              easing: {
                sine: {
                  out: function (t) {
                    return Math.sin(t * (Math.PI / 2));
                  },
                  inOut: function (t) {
                    return -(Math.cos(Math.PI * t) - 1) / 2;
                  },
                },
                cubic: {
                  out: function (t) {
                    return --t * t * t + 1;
                  },
                },
              },
              detectFeatures: function () {
                if (s.features) return s.features;
                var t = s.createEl().style,
                  e = "",
                  i = {};
                if (
                  ((i.oldIE = document.all && !document.addEventListener),
                  (i.touch = "ontouchstart" in window),
                  window.requestAnimationFrame &&
                    ((i.raf = window.requestAnimationFrame),
                    (i.caf = window.cancelAnimationFrame)),
                  (i.pointerEvent =
                    !!window.PointerEvent || navigator.msPointerEnabled),
                  !i.pointerEvent)
                ) {
                  var n = navigator.userAgent;
                  if (/iP(hone|od)/.test(navigator.platform)) {
                    var o = navigator.appVersion.match(
                      /OS (\d+)_(\d+)_?(\d+)?/
                    );
                    o &&
                      o.length > 0 &&
                      (o = parseInt(o[1], 10)) >= 1 &&
                      o < 8 &&
                      (i.isOldIOSPhone = !0);
                  }
                  var r = n.match(/Android\s([0-9\.]*)/),
                    a = r ? r[1] : 0;
                  (a = parseFloat(a)) >= 1 &&
                    (a < 4.4 && (i.isOldAndroid = !0), (i.androidVersion = a)),
                    (i.isMobileOpera = /opera mini|opera mobi/i.test(n));
                }
                for (
                  var l,
                    c,
                    h = ["transform", "perspective", "animationName"],
                    d = ["", "webkit", "Moz", "ms", "O"],
                    u = 0;
                  u < 4;
                  u++
                ) {
                  e = d[u];
                  for (var p = 0; p < 3; p++)
                    (l = h[p]),
                      (c =
                        e + (e ? l.charAt(0).toUpperCase() + l.slice(1) : l)),
                      !i[l] && c in t && (i[l] = c);
                  e &&
                    !i.raf &&
                    ((e = e.toLowerCase()),
                    (i.raf = window[e + "RequestAnimationFrame"]),
                    i.raf &&
                      (i.caf =
                        window[e + "CancelAnimationFrame"] ||
                        window[e + "CancelRequestAnimationFrame"]));
                }
                if (!i.raf) {
                  var f = 0;
                  (i.raf = function (t) {
                    var e = new Date().getTime(),
                      i = Math.max(0, 16 - (e - f)),
                      n = window.setTimeout(function () {
                        t(e + i);
                      }, i);
                    return (f = e + i), n;
                  }),
                    (i.caf = function (t) {
                      clearTimeout(t);
                    });
                }
                return (
                  (i.svg =
                    !!document.createElementNS &&
                    !!document.createElementNS(
                      "http://www.w3.org/2000/svg",
                      "svg"
                    ).createSVGRect),
                  (s.features = i),
                  i
                );
              },
            };
            s.detectFeatures(),
              s.features.oldIE &&
                (s.bind = function (t, e, i, n) {
                  e = e.split(" ");
                  for (
                    var s,
                      o = (n ? "detach" : "attach") + "Event",
                      r = function () {
                        i.handleEvent.call(i);
                      },
                      a = 0;
                    a < e.length;
                    a++
                  )
                    if ((s = e[a]))
                      if ("object" == typeof i && i.handleEvent) {
                        if (n) {
                          if (!i["oldIE" + s]) return !1;
                        } else i["oldIE" + s] = r;
                        t[o]("on" + s, i["oldIE" + s]);
                      } else t[o]("on" + s, i);
                });
            var o = this,
              r = 25,
              a = 3,
              l = {
                allowPanToNext: !0,
                spacing: 0.12,
                bgOpacity: 1,
                mouseUsed: !1,
                loop: !0,
                pinchToClose: !0,
                closeOnScroll: !0,
                closeOnVerticalDrag: !0,
                verticalDragRange: 0.75,
                hideAnimationDuration: 333,
                showAnimationDuration: 333,
                showHideOpacity: !1,
                focus: !0,
                escKey: !0,
                arrowKeys: !0,
                mainScrollEndFriction: 0.35,
                panEndFriction: 0.35,
                isClickableElement: function (t) {
                  return "A" === t.tagName;
                },
                getDoubleTapZoom: function (t, e) {
                  return t || e.initialZoomLevel < 0.7 ? 1 : 1.33;
                },
                maxSpreadZoom: 1.33,
                modal: !0,
                scaleMode: "fit",
              };
            s.extend(l, n);
            var c,
              h,
              d,
              u,
              p,
              f,
              m,
              g,
              v,
              y,
              b,
              w,
              _,
              S,
              C,
              k,
              x,
              E,
              A,
              T,
              L,
              D,
              I,
              P,
              M,
              O,
              F,
              q,
              $,
              B,
              N,
              R,
              z,
              H,
              U,
              j,
              W,
              V,
              G,
              X,
              Z,
              Q,
              Y,
              K,
              J,
              tt,
              et,
              it,
              nt,
              st,
              ot,
              rt,
              at,
              lt,
              ct,
              ht,
              dt = function () {
                return { x: 0, y: 0 };
              },
              ut = dt(),
              pt = dt(),
              ft = dt(),
              mt = {},
              gt = 0,
              vt = {},
              yt = dt(),
              bt = 0,
              wt = !0,
              _t = [],
              St = {},
              Ct = !1,
              kt = function (t, e) {
                s.extend(o, e.publicMethods), _t.push(t);
              },
              xt = function (t) {
                var e = Je();
                return t > e - 1 ? t - e : t < 0 ? e + t : t;
              },
              Et = {},
              At = function (t, e) {
                return Et[t] || (Et[t] = []), Et[t].push(e);
              },
              Tt = function (t) {
                var e = Et[t];
                if (e) {
                  var i = Array.prototype.slice.call(arguments);
                  i.shift();
                  for (var n = 0; n < e.length; n++) e[n].apply(o, i);
                }
              },
              Lt = function () {
                return new Date().getTime();
              },
              Dt = function (t) {
                (lt = t), (o.bg.style.opacity = t * l.bgOpacity);
              },
              It = function (t, e, i, n, s) {
                (!Ct || (s && s !== o.currItem)) &&
                  (n /= s ? s.fitRatio : o.currItem.fitRatio),
                  (t[D] = w + e + "px, " + i + "px" + _ + " scale(" + n + ")");
              },
              Pt = function (t) {
                nt &&
                  (t &&
                    (y > o.currItem.fitRatio
                      ? Ct || (hi(o.currItem, !1, !0), (Ct = !0))
                      : Ct && (hi(o.currItem), (Ct = !1))),
                  It(nt, ft.x, ft.y, y));
              },
              Mt = function (t) {
                t.container &&
                  It(
                    t.container.style,
                    t.initialPosition.x,
                    t.initialPosition.y,
                    t.initialZoomLevel,
                    t
                  );
              },
              Ot = function (t, e) {
                e[D] = w + t + "px, 0px" + _;
              },
              Ft = function (t, e) {
                if (!l.loop && e) {
                  var i = u + (yt.x * gt - t) / yt.x,
                    n = Math.round(t - ye.x);
                  ((i < 0 && n > 0) || (i >= Je() - 1 && n < 0)) &&
                    (t = ye.x + n * l.mainScrollEndFriction);
                }
                (ye.x = t), Ot(t, p);
              },
              qt = function (t, e) {
                var i = be[t] - vt[t];
                return pt[t] + ut[t] + i - i * (e / b);
              },
              $t = function (t, e) {
                (t.x = e.x), (t.y = e.y), e.id && (t.id = e.id);
              },
              Bt = function (t) {
                (t.x = Math.round(t.x)), (t.y = Math.round(t.y));
              },
              Nt = null,
              Rt = function () {
                Nt &&
                  (s.unbind(document, "mousemove", Rt),
                  s.addClass(t, "pswp--has_mouse"),
                  (l.mouseUsed = !0),
                  Tt("mouseUsed")),
                  (Nt = setTimeout(function () {
                    Nt = null;
                  }, 100));
              },
              zt = function () {
                s.bind(document, "keydown", o),
                  N.transform && s.bind(o.scrollWrap, "click", o),
                  l.mouseUsed || s.bind(document, "mousemove", Rt),
                  s.bind(window, "resize scroll orientationchange", o),
                  Tt("bindEvents");
              },
              Ht = function () {
                s.unbind(window, "resize scroll orientationchange", o),
                  s.unbind(window, "scroll", v.scroll),
                  s.unbind(document, "keydown", o),
                  s.unbind(document, "mousemove", Rt),
                  N.transform && s.unbind(o.scrollWrap, "click", o),
                  G && s.unbind(window, m, o),
                  clearTimeout(R),
                  Tt("unbindEvents");
              },
              Ut = function (t, e) {
                var i = ri(o.currItem, mt, t);
                return e && (it = i), i;
              },
              jt = function (t) {
                return t || (t = o.currItem), t.initialZoomLevel;
              },
              Wt = function (t) {
                return t || (t = o.currItem), t.w > 0 ? l.maxSpreadZoom : 1;
              },
              Vt = function (t, e, i, n) {
                return n === o.currItem.initialZoomLevel
                  ? ((i[t] = o.currItem.initialPosition[t]), !0)
                  : ((i[t] = qt(t, n)),
                    i[t] > e.min[t]
                      ? ((i[t] = e.min[t]), !0)
                      : i[t] < e.max[t] && ((i[t] = e.max[t]), !0));
              },
              Gt = function () {
                if (D) {
                  var e = N.perspective && !P;
                  return (
                    (w = "translate" + (e ? "3d(" : "(")),
                    void (_ = N.perspective ? ", 0px)" : ")")
                  );
                }
                (D = "left"),
                  s.addClass(t, "pswp--ie"),
                  (Ot = function (t, e) {
                    e.left = t + "px";
                  }),
                  (Mt = function (t) {
                    var e = t.fitRatio > 1 ? 1 : t.fitRatio,
                      i = t.container.style,
                      n = e * t.w,
                      s = e * t.h;
                    (i.width = n + "px"),
                      (i.height = s + "px"),
                      (i.left = t.initialPosition.x + "px"),
                      (i.top = t.initialPosition.y + "px");
                  }),
                  (Pt = function () {
                    if (nt) {
                      var t = nt,
                        e = o.currItem,
                        i = e.fitRatio > 1 ? 1 : e.fitRatio,
                        n = i * e.w,
                        s = i * e.h;
                      (t.width = n + "px"),
                        (t.height = s + "px"),
                        (t.left = ft.x + "px"),
                        (t.top = ft.y + "px");
                    }
                  });
              },
              Xt = function (t) {
                var e = "";
                l.escKey && 27 === t.keyCode
                  ? (e = "close")
                  : l.arrowKeys &&
                    (37 === t.keyCode
                      ? (e = "prev")
                      : 39 === t.keyCode && (e = "next")),
                  e &&
                    (t.ctrlKey ||
                      t.altKey ||
                      t.shiftKey ||
                      t.metaKey ||
                      (t.preventDefault
                        ? t.preventDefault()
                        : (t.returnValue = !1),
                      o[e]()));
              },
              Zt = function (t) {
                t &&
                  (Q || Z || st || W) &&
                  (t.preventDefault(), t.stopPropagation());
              },
              Qt = function () {
                o.setScrollOffset(0, s.getScrollY());
              },
              Yt = {},
              Kt = 0,
              Jt = function (t) {
                Yt[t] && (Yt[t].raf && O(Yt[t].raf), Kt--, delete Yt[t]);
              },
              te = function (t) {
                Yt[t] && Jt(t), Yt[t] || (Kt++, (Yt[t] = {}));
              },
              ee = function () {
                for (var t in Yt) Yt.hasOwnProperty(t) && Jt(t);
              },
              ie = function (t, e, i, n, s, o, r) {
                var a,
                  l = Lt();
                te(t);
                var c = function () {
                  if (Yt[t]) {
                    if ((a = Lt() - l) >= n)
                      return Jt(t), o(i), void (r && r());
                    o((i - e) * s(a / n) + e), (Yt[t].raf = M(c));
                  }
                };
                c();
              },
              ne = {
                shout: Tt,
                listen: At,
                viewportSize: mt,
                options: l,
                isMainScrollAnimating: function () {
                  return st;
                },
                getZoomLevel: function () {
                  return y;
                },
                getCurrentIndex: function () {
                  return u;
                },
                isDragging: function () {
                  return G;
                },
                isZooming: function () {
                  return tt;
                },
                setScrollOffset: function (t, e) {
                  (vt.x = t), (B = vt.y = e), Tt("updateScrollOffset", vt);
                },
                applyZoomPan: function (t, e, i, n) {
                  (ft.x = e), (ft.y = i), (y = t), Pt(n);
                },
                init: function () {
                  if (!c && !h) {
                    var i;
                    (o.framework = s),
                      (o.template = t),
                      (o.bg = s.getChildByClass(t, "pswp__bg")),
                      (F = t.className),
                      (c = !0),
                      (N = s.detectFeatures()),
                      (M = N.raf),
                      (O = N.caf),
                      (D = N.transform),
                      ($ = N.oldIE),
                      (o.scrollWrap = s.getChildByClass(
                        t,
                        "pswp__scroll-wrap"
                      )),
                      (o.container = s.getChildByClass(
                        o.scrollWrap,
                        "pswp__container"
                      )),
                      (p = o.container.style),
                      (o.itemHolders = k =
                        [
                          { el: o.container.children[0], wrap: 0, index: -1 },
                          { el: o.container.children[1], wrap: 0, index: -1 },
                          { el: o.container.children[2], wrap: 0, index: -1 },
                        ]),
                      (k[0].el.style.display = k[2].el.style.display = "none"),
                      Gt(),
                      (v = {
                        resize: o.updateSize,
                        orientationchange: function () {
                          clearTimeout(R),
                            (R = setTimeout(function () {
                              mt.x !== o.scrollWrap.clientWidth &&
                                o.updateSize();
                            }, 500));
                        },
                        scroll: Qt,
                        keydown: Xt,
                        click: Zt,
                      });
                    var n =
                      N.isOldIOSPhone || N.isOldAndroid || N.isMobileOpera;
                    for (
                      (N.animationName && N.transform && !n) ||
                        (l.showAnimationDuration = l.hideAnimationDuration = 0),
                        i = 0;
                      i < _t.length;
                      i++
                    )
                      o["init" + _t[i]]();
                    e && (o.ui = new e(o, s)).init(),
                      Tt("firstUpdate"),
                      (u = u || l.index || 0),
                      (isNaN(u) || u < 0 || u >= Je()) && (u = 0),
                      (o.currItem = Ke(u)),
                      (N.isOldIOSPhone || N.isOldAndroid) && (wt = !1),
                      t.setAttribute("aria-hidden", "false"),
                      l.modal &&
                        (wt
                          ? (t.style.position = "fixed")
                          : ((t.style.position = "absolute"),
                            (t.style.top = s.getScrollY() + "px"))),
                      void 0 === B &&
                        (Tt("initialLayout"), (B = q = s.getScrollY()));
                    var r = "pswp--open ";
                    for (
                      l.mainClass && (r += l.mainClass + " "),
                        l.showHideOpacity && (r += "pswp--animate_opacity "),
                        r += P ? "pswp--touch" : "pswp--notouch",
                        r += N.animationName ? " pswp--css_animation" : "",
                        r += N.svg ? " pswp--svg" : "",
                        s.addClass(t, r),
                        o.updateSize(),
                        f = -1,
                        bt = null,
                        i = 0;
                      i < a;
                      i++
                    )
                      Ot((i + f) * yt.x, k[i].el.style);
                    $ || s.bind(o.scrollWrap, g, o),
                      At("initialZoomInEnd", function () {
                        o.setContent(k[0], u - 1),
                          o.setContent(k[2], u + 1),
                          (k[0].el.style.display = k[2].el.style.display =
                            "block"),
                          l.focus && t.focus(),
                          zt();
                      }),
                      o.setContent(k[1], u),
                      o.updateCurrItem(),
                      Tt("afterInit"),
                      wt ||
                        (S = setInterval(function () {
                          Kt ||
                            G ||
                            tt ||
                            y !== o.currItem.initialZoomLevel ||
                            o.updateSize();
                        }, 1e3)),
                      s.addClass(t, "pswp--visible");
                  }
                },
                close: function () {
                  c &&
                    ((c = !1),
                    (h = !0),
                    Tt("close"),
                    Ht(),
                    ti(o.currItem, null, !0, o.destroy));
                },
                destroy: function () {
                  Tt("destroy"),
                    Xe && clearTimeout(Xe),
                    t.setAttribute("aria-hidden", "true"),
                    (t.className = F),
                    S && clearInterval(S),
                    s.unbind(o.scrollWrap, g, o),
                    s.unbind(window, "scroll", o),
                    ke(),
                    ee(),
                    (Et = null);
                },
                panTo: function (t, e, i) {
                  i ||
                    (t > it.min.x
                      ? (t = it.min.x)
                      : t < it.max.x && (t = it.max.x),
                    e > it.min.y
                      ? (e = it.min.y)
                      : e < it.max.y && (e = it.max.y)),
                    (ft.x = t),
                    (ft.y = e),
                    Pt();
                },
                handleEvent: function (t) {
                  (t = t || window.event), v[t.type] && v[t.type](t);
                },
                goTo: function (t) {
                  var e = (t = xt(t)) - u;
                  (bt = e),
                    (u = t),
                    (o.currItem = Ke(u)),
                    (gt -= e),
                    Ft(yt.x * gt),
                    ee(),
                    (st = !1),
                    o.updateCurrItem();
                },
                next: function () {
                  o.goTo(u + 1);
                },
                prev: function () {
                  o.goTo(u - 1);
                },
                updateCurrZoomItem: function (t) {
                  if ((t && Tt("beforeChange", 0), k[1].el.children.length)) {
                    var e = k[1].el.children[0];
                    nt = s.hasClass(e, "pswp__zoom-wrap") ? e.style : null;
                  } else nt = null;
                  (it = o.currItem.bounds),
                    (b = y = o.currItem.initialZoomLevel),
                    (ft.x = it.center.x),
                    (ft.y = it.center.y),
                    t && Tt("afterChange");
                },
                invalidateCurrItems: function () {
                  C = !0;
                  for (var t = 0; t < a; t++)
                    k[t].item && (k[t].item.needsUpdate = !0);
                },
                updateCurrItem: function (t) {
                  if (0 !== bt) {
                    var e,
                      i = Math.abs(bt);
                    if (!(t && i < 2)) {
                      (o.currItem = Ke(u)),
                        (Ct = !1),
                        Tt("beforeChange", bt),
                        i >= a && ((f += bt + (bt > 0 ? -a : a)), (i = a));
                      for (var n = 0; n < i; n++)
                        bt > 0
                          ? ((e = k.shift()),
                            (k[a - 1] = e),
                            f++,
                            Ot((f + 2) * yt.x, e.el.style),
                            o.setContent(e, u - i + n + 1 + 1))
                          : ((e = k.pop()),
                            k.unshift(e),
                            f--,
                            Ot(f * yt.x, e.el.style),
                            o.setContent(e, u + i - n - 1 - 1));
                      if (nt && 1 === Math.abs(bt)) {
                        var s = Ke(x);
                        s.initialZoomLevel !== y && (ri(s, mt), hi(s), Mt(s));
                      }
                      (bt = 0),
                        o.updateCurrZoomItem(),
                        (x = u),
                        Tt("afterChange");
                    }
                  }
                },
                updateSize: function (e) {
                  if (!wt && l.modal) {
                    var i = s.getScrollY();
                    if (
                      (B !== i && ((t.style.top = i + "px"), (B = i)),
                      !e &&
                        St.x === window.innerWidth &&
                        St.y === window.innerHeight)
                    )
                      return;
                    (St.x = window.innerWidth),
                      (St.y = window.innerHeight),
                      (t.style.height = St.y + "px");
                  }
                  if (
                    ((mt.x = o.scrollWrap.clientWidth),
                    (mt.y = o.scrollWrap.clientHeight),
                    Qt(),
                    (yt.x = mt.x + Math.round(mt.x * l.spacing)),
                    (yt.y = mt.y),
                    Ft(yt.x * gt),
                    Tt("beforeResize"),
                    void 0 !== f)
                  ) {
                    for (var n, r, c, h = 0; h < a; h++)
                      (n = k[h]),
                        Ot((h + f) * yt.x, n.el.style),
                        (c = u + h - 1),
                        l.loop && Je() > 2 && (c = xt(c)),
                        (r = Ke(c)) && (C || r.needsUpdate || !r.bounds)
                          ? (o.cleanSlide(r),
                            o.setContent(n, c),
                            1 === h &&
                              ((o.currItem = r), o.updateCurrZoomItem(!0)),
                            (r.needsUpdate = !1))
                          : -1 === n.index && c >= 0 && o.setContent(n, c),
                        r && r.container && (ri(r, mt), hi(r), Mt(r));
                    C = !1;
                  }
                  (b = y = o.currItem.initialZoomLevel),
                    (it = o.currItem.bounds) &&
                      ((ft.x = it.center.x), (ft.y = it.center.y), Pt(!0)),
                    Tt("resize");
                },
                zoomTo: function (t, e, i, n, o) {
                  e &&
                    ((b = y),
                    (be.x = Math.abs(e.x) - ft.x),
                    (be.y = Math.abs(e.y) - ft.y),
                    $t(pt, ft));
                  var r = Ut(t, !1),
                    a = {};
                  Vt("x", r, a, t), Vt("y", r, a, t);
                  var l = y,
                    c = { x: ft.x, y: ft.y };
                  Bt(a);
                  var h = function (e) {
                    1 === e
                      ? ((y = t), (ft.x = a.x), (ft.y = a.y))
                      : ((y = (t - l) * e + l),
                        (ft.x = (a.x - c.x) * e + c.x),
                        (ft.y = (a.y - c.y) * e + c.y)),
                      o && o(e),
                      Pt(1 === e);
                  };
                  i
                    ? ie("customZoomTo", 0, 1, i, n || s.easing.sine.inOut, h)
                    : h(1);
                },
              },
              se = 30,
              oe = 10,
              re = {},
              ae = {},
              le = {},
              ce = {},
              he = {},
              de = [],
              ue = {},
              pe = [],
              fe = {},
              me = 0,
              ge = dt(),
              ve = 0,
              ye = dt(),
              be = dt(),
              we = dt(),
              _e = function (t, e) {
                return t.x === e.x && t.y === e.y;
              },
              Se = function (t, e) {
                return Math.abs(t.x - e.x) < r && Math.abs(t.y - e.y) < r;
              },
              Ce = function (t, e) {
                return (
                  (fe.x = Math.abs(t.x - e.x)),
                  (fe.y = Math.abs(t.y - e.y)),
                  Math.sqrt(fe.x * fe.x + fe.y * fe.y)
                );
              },
              ke = function () {
                Y && (O(Y), (Y = null));
              },
              xe = function () {
                G && ((Y = M(xe)), ze());
              },
              Ee = function () {
                return !(
                  "fit" === l.scaleMode && y === o.currItem.initialZoomLevel
                );
              },
              Ae = function (t, e) {
                return (
                  !(!t || t === document) &&
                  !(
                    t.getAttribute("class") &&
                    t.getAttribute("class").indexOf("pswp__scroll-wrap") > -1
                  ) &&
                  (e(t) ? t : Ae(t.parentNode, e))
                );
              },
              Te = {},
              Le = function (t, e) {
                return (
                  (Te.prevent = !Ae(t.target, l.isClickableElement)),
                  Tt("preventDragEvent", t, e, Te),
                  Te.prevent
                );
              },
              De = function (t, e) {
                return (
                  (e.x = t.pageX), (e.y = t.pageY), (e.id = t.identifier), e
                );
              },
              Ie = function (t, e, i) {
                (i.x = 0.5 * (t.x + e.x)), (i.y = 0.5 * (t.y + e.y));
              },
              Pe = function (t, e, i) {
                if (t - H > 50) {
                  var n = pe.length > 2 ? pe.shift() : {};
                  (n.x = e), (n.y = i), pe.push(n), (H = t);
                }
              },
              Me = function () {
                var t = ft.y - o.currItem.initialPosition.y;
                return 1 - Math.abs(t / (mt.y / 2));
              },
              Oe = {},
              Fe = {},
              qe = [],
              $e = function (t) {
                for (; qe.length > 0; ) qe.pop();
                return (
                  I
                    ? ((ht = 0),
                      de.forEach(function (t) {
                        0 === ht ? (qe[0] = t) : 1 === ht && (qe[1] = t), ht++;
                      }))
                    : t.type.indexOf("touch") > -1
                    ? t.touches &&
                      t.touches.length > 0 &&
                      ((qe[0] = De(t.touches[0], Oe)),
                      t.touches.length > 1 && (qe[1] = De(t.touches[1], Fe)))
                    : ((Oe.x = t.pageX),
                      (Oe.y = t.pageY),
                      (Oe.id = ""),
                      (qe[0] = Oe)),
                  qe
                );
              },
              Be = function (t, e) {
                var i,
                  n,
                  s,
                  r,
                  a = ft[t] + e[t],
                  c = e[t] > 0,
                  h = ye.x + e.x,
                  d = ye.x - ue.x;
                if (
                  ((i = a > it.min[t] || a < it.max[t] ? l.panEndFriction : 1),
                  (a = ft[t] + e[t] * i),
                  (l.allowPanToNext || y === o.currItem.initialZoomLevel) &&
                    (nt
                      ? "h" !== ot ||
                        "x" !== t ||
                        Z ||
                        (c
                          ? (a > it.min[t] &&
                              ((i = l.panEndFriction),
                              it.min[t],
                              (n = it.min[t] - pt[t])),
                            (n <= 0 || d < 0) && Je() > 1
                              ? ((r = h), d < 0 && h > ue.x && (r = ue.x))
                              : it.min.x !== it.max.x && (s = a))
                          : (a < it.max[t] &&
                              ((i = l.panEndFriction),
                              it.max[t],
                              (n = pt[t] - it.max[t])),
                            (n <= 0 || d > 0) && Je() > 1
                              ? ((r = h), d > 0 && h < ue.x && (r = ue.x))
                              : it.min.x !== it.max.x && (s = a)))
                      : (r = h),
                    "x" === t))
                )
                  return (
                    void 0 !== r && (Ft(r, !0), (K = r !== ue.x)),
                    it.min.x !== it.max.x &&
                      (void 0 !== s ? (ft.x = s) : K || (ft.x += e.x * i)),
                    void 0 !== r
                  );
                st || K || (y > o.currItem.fitRatio && (ft[t] += e[t] * i));
              },
              Ne = function (t) {
                if (!("mousedown" === t.type && t.button > 0))
                  if (Ye) t.preventDefault();
                  else if (!V || "mousedown" !== t.type) {
                    if (
                      (Le(t, !0) && t.preventDefault(), Tt("pointerDown"), I)
                    ) {
                      var e = s.arraySearch(de, t.pointerId, "id");
                      e < 0 && (e = de.length),
                        (de[e] = { x: t.pageX, y: t.pageY, id: t.pointerId });
                    }
                    var i = $e(t),
                      n = i.length;
                    (J = null),
                      ee(),
                      (G && 1 !== n) ||
                        ((G = rt = !0),
                        s.bind(window, m, o),
                        (j = ct = at = W = K = Q = X = Z = !1),
                        (ot = null),
                        Tt("firstTouchStart", i),
                        $t(pt, ft),
                        (ut.x = ut.y = 0),
                        $t(ce, i[0]),
                        $t(he, ce),
                        (ue.x = yt.x * gt),
                        (pe = [{ x: ce.x, y: ce.y }]),
                        (H = z = Lt()),
                        Ut(y, !0),
                        ke(),
                        xe()),
                      !tt &&
                        n > 1 &&
                        !st &&
                        !K &&
                        ((b = y),
                        (Z = !1),
                        (tt = X = !0),
                        (ut.y = ut.x = 0),
                        $t(pt, ft),
                        $t(re, i[0]),
                        $t(ae, i[1]),
                        Ie(re, ae, we),
                        (be.x = Math.abs(we.x) - ft.x),
                        (be.y = Math.abs(we.y) - ft.y),
                        (et = Ce(re, ae)));
                  }
              },
              Re = function (t) {
                if ((t.preventDefault(), I)) {
                  var e = s.arraySearch(de, t.pointerId, "id");
                  if (e > -1) {
                    var i = de[e];
                    (i.x = t.pageX), (i.y = t.pageY);
                  }
                }
                if (G) {
                  var n = $e(t);
                  if (ot || Q || tt) J = n;
                  else if (ye.x !== yt.x * gt) ot = "h";
                  else {
                    var o = Math.abs(n[0].x - ce.x) - Math.abs(n[0].y - ce.y);
                    Math.abs(o) >= oe && ((ot = o > 0 ? "h" : "v"), (J = n));
                  }
                }
              },
              ze = function () {
                if (J) {
                  var t = J.length;
                  if (0 !== t)
                    if (
                      ($t(re, J[0]),
                      (le.x = re.x - ce.x),
                      (le.y = re.y - ce.y),
                      tt && t > 1)
                    ) {
                      if (
                        ((ce.x = re.x),
                        (ce.y = re.y),
                        !le.x && !le.y && _e(J[1], ae))
                      )
                        return;
                      $t(ae, J[1]), Z || ((Z = !0), Tt("zoomGestureStarted"));
                      var e = Ce(re, ae),
                        i = Ve(e);
                      i >
                        o.currItem.initialZoomLevel +
                          o.currItem.initialZoomLevel / 15 && (ct = !0);
                      var n = 1,
                        s = jt(),
                        r = Wt();
                      if (i < s)
                        if (
                          l.pinchToClose &&
                          !ct &&
                          b <= o.currItem.initialZoomLevel
                        ) {
                          var a = 1 - (s - i) / (s / 1.2);
                          Dt(a), Tt("onPinchClose", a), (at = !0);
                        } else
                          (n = (s - i) / s) > 1 && (n = 1),
                            (i = s - n * (s / 3));
                      else
                        i > r &&
                          ((n = (i - r) / (6 * s)) > 1 && (n = 1),
                          (i = r + n * s));
                      n < 0 && (n = 0),
                        Ie(re, ae, ge),
                        (ut.x += ge.x - we.x),
                        (ut.y += ge.y - we.y),
                        $t(we, ge),
                        (ft.x = qt("x", i)),
                        (ft.y = qt("y", i)),
                        (j = i > y),
                        (y = i),
                        Pt();
                    } else {
                      if (!ot) return;
                      if (
                        (rt &&
                          ((rt = !1),
                          Math.abs(le.x) >= oe && (le.x -= J[0].x - he.x),
                          Math.abs(le.y) >= oe && (le.y -= J[0].y - he.y)),
                        (ce.x = re.x),
                        (ce.y = re.y),
                        0 === le.x && 0 === le.y)
                      )
                        return;
                      if ("v" === ot && l.closeOnVerticalDrag && !Ee()) {
                        (ut.y += le.y), (ft.y += le.y);
                        var c = Me();
                        return (
                          (W = !0), Tt("onVerticalDrag", c), Dt(c), void Pt()
                        );
                      }
                      Pe(Lt(), re.x, re.y),
                        (Q = !0),
                        (it = o.currItem.bounds),
                        Be("x", le) || (Be("y", le), Bt(ft), Pt());
                    }
                }
              },
              He = function (t) {
                if (N.isOldAndroid) {
                  if (V && "mouseup" === t.type) return;
                  t.type.indexOf("touch") > -1 &&
                    (clearTimeout(V),
                    (V = setTimeout(function () {
                      V = 0;
                    }, 600)));
                }
                var e;
                if ((Tt("pointerUp"), Le(t, !1) && t.preventDefault(), I)) {
                  var i = s.arraySearch(de, t.pointerId, "id");
                  if (i > -1)
                    if (
                      ((e = de.splice(i, 1)[0]), navigator.msPointerEnabled)
                    ) {
                      var n = { 4: "mouse", 2: "touch", 3: "pen" };
                      (e.type = n[t.pointerType]),
                        e.type || (e.type = t.pointerType || "mouse");
                    } else e.type = t.pointerType || "mouse";
                }
                var r,
                  a = $e(t),
                  c = a.length;
                if (("mouseup" === t.type && (c = 0), 2 === c))
                  return (J = null), !0;
                1 === c && $t(he, a[0]),
                  0 !== c ||
                    ot ||
                    st ||
                    (e ||
                      ("mouseup" === t.type
                        ? (e = { x: t.pageX, y: t.pageY, type: "mouse" })
                        : t.changedTouches &&
                          t.changedTouches[0] &&
                          (e = {
                            x: t.changedTouches[0].pageX,
                            y: t.changedTouches[0].pageY,
                            type: "touch",
                          })),
                    Tt("touchRelease", t, e));
                var h = -1;
                if (
                  (0 === c &&
                    ((G = !1),
                    s.unbind(window, m, o),
                    ke(),
                    tt ? (h = 0) : -1 !== ve && (h = Lt() - ve)),
                  (ve = 1 === c ? Lt() : -1),
                  (r = -1 !== h && h < 150 ? "zoom" : "swipe"),
                  tt &&
                    c < 2 &&
                    ((tt = !1),
                    1 === c && (r = "zoomPointerUp"),
                    Tt("zoomGestureEnded")),
                  (J = null),
                  Q || Z || st || W)
                )
                  if ((ee(), U || (U = Ue()), U.calculateSwipeSpeed("x"), W))
                    if (Me() < l.verticalDragRange) o.close();
                    else {
                      var d = ft.y,
                        u = lt;
                      ie(
                        "verticalDrag",
                        0,
                        1,
                        300,
                        s.easing.cubic.out,
                        function (t) {
                          (ft.y = (o.currItem.initialPosition.y - d) * t + d),
                            Dt((1 - u) * t + u),
                            Pt();
                        }
                      ),
                        Tt("onVerticalDrag", 1);
                    }
                  else {
                    if ((K || st) && 0 === c) {
                      if (We(r, U)) return;
                      r = "zoomPointerUp";
                    }
                    st ||
                      ("swipe" === r
                        ? !K && y > o.currItem.fitRatio && je(U)
                        : Ge());
                  }
              },
              Ue = function () {
                var t,
                  e,
                  i = {
                    lastFlickOffset: {},
                    lastFlickDist: {},
                    lastFlickSpeed: {},
                    slowDownRatio: {},
                    slowDownRatioReverse: {},
                    speedDecelerationRatio: {},
                    speedDecelerationRatioAbs: {},
                    distanceOffset: {},
                    backAnimDestination: {},
                    backAnimStarted: {},
                    calculateSwipeSpeed: function (n) {
                      pe.length > 1
                        ? ((t = Lt() - H + 50), (e = pe[pe.length - 2][n]))
                        : ((t = Lt() - z), (e = he[n])),
                        (i.lastFlickOffset[n] = ce[n] - e),
                        (i.lastFlickDist[n] = Math.abs(i.lastFlickOffset[n])),
                        i.lastFlickDist[n] > 20
                          ? (i.lastFlickSpeed[n] = i.lastFlickOffset[n] / t)
                          : (i.lastFlickSpeed[n] = 0),
                        Math.abs(i.lastFlickSpeed[n]) < 0.1 &&
                          (i.lastFlickSpeed[n] = 0),
                        (i.slowDownRatio[n] = 0.95),
                        (i.slowDownRatioReverse[n] = 1 - i.slowDownRatio[n]),
                        (i.speedDecelerationRatio[n] = 1);
                    },
                    calculateOverBoundsAnimOffset: function (t, e) {
                      i.backAnimStarted[t] ||
                        (ft[t] > it.min[t]
                          ? (i.backAnimDestination[t] = it.min[t])
                          : ft[t] < it.max[t] &&
                            (i.backAnimDestination[t] = it.max[t]),
                        void 0 !== i.backAnimDestination[t] &&
                          ((i.slowDownRatio[t] = 0.7),
                          (i.slowDownRatioReverse[t] = 1 - i.slowDownRatio[t]),
                          i.speedDecelerationRatioAbs[t] < 0.05 &&
                            ((i.lastFlickSpeed[t] = 0),
                            (i.backAnimStarted[t] = !0),
                            ie(
                              "bounceZoomPan" + t,
                              ft[t],
                              i.backAnimDestination[t],
                              e || 300,
                              s.easing.sine.out,
                              function (e) {
                                (ft[t] = e), Pt();
                              }
                            ))));
                    },
                    calculateAnimOffset: function (t) {
                      i.backAnimStarted[t] ||
                        ((i.speedDecelerationRatio[t] =
                          i.speedDecelerationRatio[t] *
                          (i.slowDownRatio[t] +
                            i.slowDownRatioReverse[t] -
                            (i.slowDownRatioReverse[t] * i.timeDiff) / 10)),
                        (i.speedDecelerationRatioAbs[t] = Math.abs(
                          i.lastFlickSpeed[t] * i.speedDecelerationRatio[t]
                        )),
                        (i.distanceOffset[t] =
                          i.lastFlickSpeed[t] *
                          i.speedDecelerationRatio[t] *
                          i.timeDiff),
                        (ft[t] += i.distanceOffset[t]));
                    },
                    panAnimLoop: function () {
                      if (
                        Yt.zoomPan &&
                        ((Yt.zoomPan.raf = M(i.panAnimLoop)),
                        (i.now = Lt()),
                        (i.timeDiff = i.now - i.lastNow),
                        (i.lastNow = i.now),
                        i.calculateAnimOffset("x"),
                        i.calculateAnimOffset("y"),
                        Pt(),
                        i.calculateOverBoundsAnimOffset("x"),
                        i.calculateOverBoundsAnimOffset("y"),
                        i.speedDecelerationRatioAbs.x < 0.05 &&
                          i.speedDecelerationRatioAbs.y < 0.05)
                      )
                        return (
                          (ft.x = Math.round(ft.x)),
                          (ft.y = Math.round(ft.y)),
                          Pt(),
                          void Jt("zoomPan")
                        );
                    },
                  };
                return i;
              },
              je = function (t) {
                if (
                  (t.calculateSwipeSpeed("y"),
                  (it = o.currItem.bounds),
                  (t.backAnimDestination = {}),
                  (t.backAnimStarted = {}),
                  Math.abs(t.lastFlickSpeed.x) <= 0.05 &&
                    Math.abs(t.lastFlickSpeed.y) <= 0.05)
                )
                  return (
                    (t.speedDecelerationRatioAbs.x =
                      t.speedDecelerationRatioAbs.y =
                        0),
                    t.calculateOverBoundsAnimOffset("x"),
                    t.calculateOverBoundsAnimOffset("y"),
                    !0
                  );
                te("zoomPan"), (t.lastNow = Lt()), t.panAnimLoop();
              },
              We = function (t, e) {
                var i, n, r;
                if ((st || (me = u), "swipe" === t)) {
                  var a = ce.x - he.x,
                    c = e.lastFlickDist.x < 10;
                  a > se && (c || e.lastFlickOffset.x > 20)
                    ? (n = -1)
                    : a < -se && (c || e.lastFlickOffset.x < -20) && (n = 1);
                }
                n &&
                  ((u += n) < 0
                    ? ((u = l.loop ? Je() - 1 : 0), (r = !0))
                    : u >= Je() && ((u = l.loop ? 0 : Je() - 1), (r = !0)),
                  (r && !l.loop) || ((bt += n), (gt -= n), (i = !0)));
                var h,
                  d = yt.x * gt,
                  p = Math.abs(d - ye.x);
                return (
                  i || d > ye.x == e.lastFlickSpeed.x > 0
                    ? ((h =
                        Math.abs(e.lastFlickSpeed.x) > 0
                          ? p / Math.abs(e.lastFlickSpeed.x)
                          : 333),
                      (h = Math.min(h, 400)),
                      (h = Math.max(h, 250)))
                    : (h = 333),
                  me === u && (i = !1),
                  (st = !0),
                  Tt("mainScrollAnimStart"),
                  ie(
                    "mainScroll",
                    ye.x,
                    d,
                    h,
                    s.easing.cubic.out,
                    Ft,
                    function () {
                      ee(),
                        (st = !1),
                        (me = -1),
                        (i || me !== u) && o.updateCurrItem(),
                        Tt("mainScrollAnimComplete");
                    }
                  ),
                  i && o.updateCurrItem(!0),
                  i
                );
              },
              Ve = function (t) {
                return (1 / et) * t * b;
              },
              Ge = function () {
                var t = y,
                  e = jt(),
                  i = Wt();
                y < e ? (t = e) : y > i && (t = i);
                var n,
                  r = 1,
                  a = lt;
                return at && !j && !ct && y < e
                  ? (o.close(), !0)
                  : (at &&
                      (n = function (t) {
                        Dt((r - a) * t + a);
                      }),
                    o.zoomTo(t, 0, 200, s.easing.cubic.out, n),
                    !0);
              };
            kt("Gestures", {
              publicMethods: {
                initGestures: function () {
                  var t = function (t, e, i, n, s) {
                    (E = t + e), (A = t + i), (T = t + n), (L = s ? t + s : "");
                  };
                  (I = N.pointerEvent) && N.touch && (N.touch = !1),
                    I
                      ? navigator.msPointerEnabled
                        ? t("MSPointer", "Down", "Move", "Up", "Cancel")
                        : t("pointer", "down", "move", "up", "cancel")
                      : N.touch
                      ? (t("touch", "start", "move", "end", "cancel"), (P = !0))
                      : t("mouse", "down", "move", "up"),
                    (m = A + " " + T + " " + L),
                    (g = E),
                    I &&
                      !P &&
                      (P =
                        navigator.maxTouchPoints > 1 ||
                        navigator.msMaxTouchPoints > 1),
                    (o.likelyTouchDevice = P),
                    (v[E] = Ne),
                    (v[A] = Re),
                    (v[T] = He),
                    L && (v[L] = v[T]),
                    N.touch &&
                      ((g += " mousedown"),
                      (m += " mousemove mouseup"),
                      (v.mousedown = v[E]),
                      (v.mousemove = v[A]),
                      (v.mouseup = v[T])),
                    P || (l.allowPanToNext = !1);
                },
              },
            });
            var Xe,
              Ze,
              Qe,
              Ye,
              Ke,
              Je,
              ti = function (e, i, n, r) {
                var a;
                Xe && clearTimeout(Xe),
                  (Ye = !0),
                  (Qe = !0),
                  e.initialLayout
                    ? ((a = e.initialLayout), (e.initialLayout = null))
                    : (a = l.getThumbBoundsFn && l.getThumbBoundsFn(u));
                var c,
                  h,
                  p = n ? l.hideAnimationDuration : l.showAnimationDuration,
                  f = function () {
                    Jt("initialZoom"),
                      n
                        ? (o.template.removeAttribute("style"),
                          o.bg.removeAttribute("style"))
                        : (Dt(1),
                          i && (i.style.display = "block"),
                          s.addClass(t, "pswp--animated-in"),
                          Tt("initialZoom" + (n ? "OutEnd" : "InEnd"))),
                      r && r(),
                      (Ye = !1);
                  };
                if (!p || !a || void 0 === a.x)
                  return (
                    Tt("initialZoom" + (n ? "Out" : "In")),
                    (y = e.initialZoomLevel),
                    $t(ft, e.initialPosition),
                    Pt(),
                    (t.style.opacity = n ? 0 : 1),
                    Dt(1),
                    void (p
                      ? setTimeout(function () {
                          f();
                        }, p)
                      : f())
                  );
                (c = d),
                  (h =
                    !o.currItem.src ||
                    o.currItem.loadError ||
                    l.showHideOpacity),
                  e.miniImg &&
                    (e.miniImg.style.webkitBackfaceVisibility = "hidden"),
                  n ||
                    ((y = a.w / e.w),
                    (ft.x = a.x),
                    (ft.y = a.y - q),
                    (o[h ? "template" : "bg"].style.opacity = 0.001),
                    Pt()),
                  te("initialZoom"),
                  n && !c && s.removeClass(t, "pswp--animated-in"),
                  h &&
                    (n
                      ? s[(c ? "remove" : "add") + "Class"](
                          t,
                          "pswp--animate_opacity"
                        )
                      : setTimeout(function () {
                          s.addClass(t, "pswp--animate_opacity");
                        }, 30)),
                  (Xe = setTimeout(
                    function () {
                      if ((Tt("initialZoom" + (n ? "Out" : "In")), n)) {
                        var i = a.w / e.w,
                          o = { x: ft.x, y: ft.y },
                          r = y,
                          l = lt,
                          d = function (e) {
                            1 === e
                              ? ((y = i), (ft.x = a.x), (ft.y = a.y - B))
                              : ((y = (i - r) * e + r),
                                (ft.x = (a.x - o.x) * e + o.x),
                                (ft.y = (a.y - B - o.y) * e + o.y)),
                              Pt(),
                              h ? (t.style.opacity = 1 - e) : Dt(l - e * l);
                          };
                        c
                          ? ie("initialZoom", 0, 1, p, s.easing.cubic.out, d, f)
                          : (d(1), (Xe = setTimeout(f, p + 20)));
                      } else
                        (y = e.initialZoomLevel),
                          $t(ft, e.initialPosition),
                          Pt(),
                          Dt(1),
                          h ? (t.style.opacity = 1) : Dt(1),
                          (Xe = setTimeout(f, p + 20));
                    },
                    n ? 25 : 90
                  ));
              },
              ei = {},
              ii = [],
              ni = {
                index: 0,
                errorMsg:
                  '<div class="pswp__error-msg"><a href="%url%" target="_blank">The image</a> could not be loaded.</div>',
                forceProgressiveLoading: !1,
                preload: [1, 1],
                getNumItemsFn: function () {
                  return Ze.length;
                },
              },
              si = function () {
                return {
                  center: { x: 0, y: 0 },
                  max: { x: 0, y: 0 },
                  min: { x: 0, y: 0 },
                };
              },
              oi = function (t, e, i) {
                var n = t.bounds;
                (n.center.x = Math.round((ei.x - e) / 2)),
                  (n.center.y = Math.round((ei.y - i) / 2) + t.vGap.top),
                  (n.max.x = e > ei.x ? Math.round(ei.x - e) : n.center.x),
                  (n.max.y =
                    i > ei.y ? Math.round(ei.y - i) + t.vGap.top : n.center.y),
                  (n.min.x = e > ei.x ? 0 : n.center.x),
                  (n.min.y = i > ei.y ? t.vGap.top : n.center.y);
              },
              ri = function (t, e, i) {
                if (t.src && !t.loadError) {
                  var n = !i;
                  if (
                    (n &&
                      (t.vGap || (t.vGap = { top: 0, bottom: 0 }),
                      Tt("parseVerticalMargin", t)),
                    (ei.x = e.x),
                    (ei.y = e.y - t.vGap.top - t.vGap.bottom),
                    n)
                  ) {
                    var s = ei.x / t.w,
                      o = ei.y / t.h;
                    t.fitRatio = s < o ? s : o;
                    var r = l.scaleMode;
                    "orig" === r ? (i = 1) : "fit" === r && (i = t.fitRatio),
                      i > 1 && (i = 1),
                      (t.initialZoomLevel = i),
                      t.bounds || (t.bounds = si());
                  }
                  if (!i) return;
                  return (
                    oi(t, t.w * i, t.h * i),
                    n &&
                      i === t.initialZoomLevel &&
                      (t.initialPosition = t.bounds.center),
                    t.bounds
                  );
                }
                return (
                  (t.w = t.h = 0),
                  (t.initialZoomLevel = t.fitRatio = 1),
                  (t.bounds = si()),
                  (t.initialPosition = t.bounds.center),
                  t.bounds
                );
              },
              ai = function (t, e, i, n, s, r) {
                e.loadError ||
                  (n &&
                    ((e.imageAppended = !0),
                    hi(e, n, e === o.currItem && Ct),
                    i.appendChild(n),
                    r &&
                      setTimeout(function () {
                        e &&
                          e.loaded &&
                          e.placeholder &&
                          ((e.placeholder.style.display = "none"),
                          (e.placeholder = null));
                      }, 500)));
              },
              li = function (t) {
                (t.loading = !0), (t.loaded = !1);
                var e = (t.img = s.createEl("pswp__img", "img")),
                  i = function () {
                    (t.loading = !1),
                      (t.loaded = !0),
                      t.loadComplete ? t.loadComplete(t) : (t.img = null),
                      (e.onload = e.onerror = null),
                      (e = null);
                  };
                return (
                  (e.onload = i),
                  (e.onerror = function () {
                    (t.loadError = !0), i();
                  }),
                  (e.src = t.src),
                  e
                );
              },
              ci = function (t, e) {
                if (t.src && t.loadError && t.container)
                  return (
                    e && (t.container.innerHTML = ""),
                    (t.container.innerHTML = l.errorMsg.replace(
                      "%url%",
                      t.src
                    )),
                    !0
                  );
              },
              hi = function (t, e, i) {
                if (t.src) {
                  e || (e = t.container.lastChild);
                  var n = i ? t.w : Math.round(t.w * t.fitRatio),
                    s = i ? t.h : Math.round(t.h * t.fitRatio);
                  t.placeholder &&
                    !t.loaded &&
                    ((t.placeholder.style.width = n + "px"),
                    (t.placeholder.style.height = s + "px")),
                    (e.style.width = n + "px"),
                    (e.style.height = s + "px");
                }
              },
              di = function () {
                if (ii.length) {
                  for (var t, e = 0; e < ii.length; e++)
                    (t = ii[e]).holder.index === t.index &&
                      ai(
                        t.index,
                        t.item,
                        t.baseDiv,
                        t.img,
                        !1,
                        t.clearPlaceholder
                      );
                  ii = [];
                }
              };
            kt("Controller", {
              publicMethods: {
                lazyLoadItem: function (t) {
                  t = xt(t);
                  var e = Ke(t);
                  e &&
                    ((!e.loaded && !e.loading) || C) &&
                    (Tt("gettingData", t, e), e.src && li(e));
                },
                initController: function () {
                  s.extend(l, ni, !0),
                    (o.items = Ze = i),
                    (Ke = o.getItemAt),
                    (Je = l.getNumItemsFn),
                    l.loop,
                    Je() < 3 && (l.loop = !1),
                    At("beforeChange", function (t) {
                      var e,
                        i = l.preload,
                        n = null === t || t >= 0,
                        s = Math.min(i[0], Je()),
                        r = Math.min(i[1], Je());
                      for (e = 1; e <= (n ? r : s); e++) o.lazyLoadItem(u + e);
                      for (e = 1; e <= (n ? s : r); e++) o.lazyLoadItem(u - e);
                    }),
                    At("initialLayout", function () {
                      o.currItem.initialLayout =
                        l.getThumbBoundsFn && l.getThumbBoundsFn(u);
                    }),
                    At("mainScrollAnimComplete", di),
                    At("initialZoomInEnd", di),
                    At("destroy", function () {
                      for (var t, e = 0; e < Ze.length; e++)
                        (t = Ze[e]).container && (t.container = null),
                          t.placeholder && (t.placeholder = null),
                          t.img && (t.img = null),
                          t.preloader && (t.preloader = null),
                          t.loadError && (t.loaded = t.loadError = !1);
                      ii = null;
                    });
                },
                getItemAt: function (t) {
                  return t >= 0 && void 0 !== Ze[t] && Ze[t];
                },
                allowProgressiveImg: function () {
                  return (
                    l.forceProgressiveLoading ||
                    !P ||
                    l.mouseUsed ||
                    screen.width > 1200
                  );
                },
                setContent: function (t, e) {
                  l.loop && (e = xt(e));
                  var i = o.getItemAt(t.index);
                  i && (i.container = null);
                  var n,
                    r = o.getItemAt(e);
                  if (r) {
                    Tt("gettingData", e, r), (t.index = e), (t.item = r);
                    var a = (r.container = s.createEl("pswp__zoom-wrap"));
                    if (
                      (!r.src &&
                        r.html &&
                        (r.html.tagName
                          ? a.appendChild(r.html)
                          : (a.innerHTML = r.html)),
                      ci(r),
                      ri(r, mt),
                      !r.src || r.loadError || r.loaded)
                    )
                      r.src &&
                        !r.loadError &&
                        (((n = s.createEl(
                          "pswp__img",
                          "img"
                        )).style.opacity = 1),
                        (n.src = r.src),
                        hi(r, n),
                        ai(e, r, a, n, !0));
                    else {
                      if (
                        ((r.loadComplete = function (i) {
                          if (c) {
                            if (t && t.index === e) {
                              if (ci(i, !0))
                                return (
                                  (i.loadComplete = i.img = null),
                                  ri(i, mt),
                                  Mt(i),
                                  void (t.index === u && o.updateCurrZoomItem())
                                );
                              i.imageAppended
                                ? !Ye &&
                                  i.placeholder &&
                                  ((i.placeholder.style.display = "none"),
                                  (i.placeholder = null))
                                : N.transform && (st || Ye)
                                ? ii.push({
                                    item: i,
                                    baseDiv: a,
                                    img: i.img,
                                    index: e,
                                    holder: t,
                                    clearPlaceholder: !0,
                                  })
                                : ai(e, i, a, i.img, st || Ye, !0);
                            }
                            (i.loadComplete = null),
                              (i.img = null),
                              Tt("imageLoadComplete", e, i);
                          }
                        }),
                        s.features.transform)
                      ) {
                        var h = "pswp__img pswp__img--placeholder";
                        h += r.msrc ? "" : " pswp__img--placeholder--blank";
                        var d = s.createEl(h, r.msrc ? "img" : "");
                        r.msrc && (d.src = r.msrc),
                          hi(r, d),
                          a.appendChild(d),
                          (r.placeholder = d);
                      }
                      r.loading || li(r),
                        o.allowProgressiveImg() &&
                          (!Qe && N.transform
                            ? ii.push({
                                item: r,
                                baseDiv: a,
                                img: r.img,
                                index: e,
                                holder: t,
                              })
                            : ai(e, r, a, r.img, !0, !0));
                    }
                    Qe || e !== u ? Mt(r) : ((nt = a.style), ti(r, n || r.img)),
                      (t.el.innerHTML = ""),
                      t.el.appendChild(a);
                  } else t.el.innerHTML = "";
                },
                cleanSlide: function (t) {
                  t.img && (t.img.onload = t.img.onerror = null),
                    (t.loaded = t.loading = t.img = t.imageAppended = !1);
                },
              },
            });
            var ui,
              pi,
              fi = {},
              mi = function (t, e, i) {
                var n = document.createEvent("CustomEvent"),
                  s = {
                    origEvent: t,
                    target: t.target,
                    releasePoint: e,
                    pointerType: i || "touch",
                  };
                n.initCustomEvent("pswpTap", !0, !0, s),
                  t.target.dispatchEvent(n);
              };
            kt("Tap", {
              publicMethods: {
                initTap: function () {
                  At("firstTouchStart", o.onTapStart),
                    At("touchRelease", o.onTapRelease),
                    At("destroy", function () {
                      (fi = {}), (ui = null);
                    });
                },
                onTapStart: function (t) {
                  t.length > 1 && (clearTimeout(ui), (ui = null));
                },
                onTapRelease: function (t, e) {
                  if (e && !Q && !X && !Kt) {
                    var i = e;
                    if (ui && (clearTimeout(ui), (ui = null), Se(i, fi)))
                      return void Tt("doubleTap", i);
                    if ("mouse" === e.type) return void mi(t, e, "mouse");
                    if (
                      "BUTTON" === t.target.tagName.toUpperCase() ||
                      s.hasClass(t.target, "pswp__single-tap")
                    )
                      return void mi(t, e);
                    $t(fi, i),
                      (ui = setTimeout(function () {
                        mi(t, e), (ui = null);
                      }, 300));
                  }
                },
              },
            }),
              kt("DesktopZoom", {
                publicMethods: {
                  initDesktopZoom: function () {
                    $ ||
                      (P
                        ? At("mouseUsed", function () {
                            o.setupDesktopZoom();
                          })
                        : o.setupDesktopZoom(!0));
                  },
                  setupDesktopZoom: function (e) {
                    pi = {};
                    var i = "wheel mousewheel DOMMouseScroll";
                    At("bindEvents", function () {
                      s.bind(t, i, o.handleMouseWheel);
                    }),
                      At("unbindEvents", function () {
                        pi && s.unbind(t, i, o.handleMouseWheel);
                      }),
                      (o.mouseZoomedIn = !1);
                    var n,
                      r = function () {
                        o.mouseZoomedIn &&
                          (s.removeClass(t, "pswp--zoomed-in"),
                          (o.mouseZoomedIn = !1)),
                          y < 1
                            ? s.addClass(t, "pswp--zoom-allowed")
                            : s.removeClass(t, "pswp--zoom-allowed"),
                          a();
                      },
                      a = function () {
                        n && (s.removeClass(t, "pswp--dragging"), (n = !1));
                      };
                    At("resize", r),
                      At("afterChange", r),
                      At("pointerDown", function () {
                        o.mouseZoomedIn &&
                          ((n = !0), s.addClass(t, "pswp--dragging"));
                      }),
                      At("pointerUp", a),
                      e || r();
                  },
                  handleMouseWheel: function (t) {
                    if (y <= o.currItem.fitRatio)
                      return (
                        l.modal &&
                          (!l.closeOnScroll || Kt || G
                            ? t.preventDefault()
                            : D &&
                              Math.abs(t.deltaY) > 2 &&
                              ((d = !0), o.close())),
                        !0
                      );
                    if ((t.stopPropagation(), (pi.x = 0), "deltaX" in t))
                      1 === t.deltaMode
                        ? ((pi.x = 18 * t.deltaX), (pi.y = 18 * t.deltaY))
                        : ((pi.x = t.deltaX), (pi.y = t.deltaY));
                    else if ("wheelDelta" in t)
                      t.wheelDeltaX && (pi.x = -0.16 * t.wheelDeltaX),
                        t.wheelDeltaY
                          ? (pi.y = -0.16 * t.wheelDeltaY)
                          : (pi.y = -0.16 * t.wheelDelta);
                    else {
                      if (!("detail" in t)) return;
                      pi.y = t.detail;
                    }
                    Ut(y, !0);
                    var e = ft.x - pi.x,
                      i = ft.y - pi.y;
                    (l.modal ||
                      (e <= it.min.x &&
                        e >= it.max.x &&
                        i <= it.min.y &&
                        i >= it.max.y)) &&
                      t.preventDefault(),
                      o.panTo(e, i);
                  },
                  toggleDesktopZoom: function (e) {
                    e = e || { x: mt.x / 2 + vt.x, y: mt.y / 2 + vt.y };
                    var i = l.getDoubleTapZoom(!0, o.currItem),
                      n = y === i;
                    (o.mouseZoomedIn = !n),
                      o.zoomTo(n ? o.currItem.initialZoomLevel : i, e, 333),
                      s[(n ? "remove" : "add") + "Class"](t, "pswp--zoomed-in");
                  },
                },
              });
            var gi,
              vi,
              yi,
              bi,
              wi,
              _i,
              Si,
              Ci,
              ki,
              xi,
              Ei,
              Ai,
              Ti = { history: !0, galleryUID: 1 },
              Li = function () {
                return Ei.hash.substring(1);
              },
              Di = function () {
                gi && clearTimeout(gi), yi && clearTimeout(yi);
              },
              Ii = function () {
                var t = Li(),
                  e = {};
                if (t.length < 5) return e;
                var i,
                  n = t.split("&");
                for (i = 0; i < n.length; i++)
                  if (n[i]) {
                    var s = n[i].split("=");
                    s.length < 2 || (e[s[0]] = s[1]);
                  }
                if (l.galleryPIDs) {
                  var o = e.pid;
                  for (e.pid = 0, i = 0; i < Ze.length; i++)
                    if (Ze[i].pid === o) {
                      e.pid = i;
                      break;
                    }
                } else e.pid = parseInt(e.pid, 10) - 1;
                return e.pid < 0 && (e.pid = 0), e;
              },
              Pi = function () {
                if ((yi && clearTimeout(yi), Kt || G)) yi = setTimeout(Pi, 500);
                else {
                  bi ? clearTimeout(vi) : (bi = !0);
                  var t = u + 1,
                    e = Ke(u);
                  e.hasOwnProperty("pid") && (t = e.pid);
                  var i = Si + "&gid=" + l.galleryUID + "&pid=" + t;
                  Ci || (-1 === Ei.hash.indexOf(i) && (xi = !0));
                  var n = Ei.href.split("#")[0] + "#" + i;
                  Ai
                    ? "#" + i !== window.location.hash &&
                      history[Ci ? "replaceState" : "pushState"](
                        "",
                        document.title,
                        n
                      )
                    : Ci
                    ? Ei.replace(n)
                    : (Ei.hash = i),
                    (Ci = !0),
                    (vi = setTimeout(function () {
                      bi = !1;
                    }, 60));
                }
              };
            kt("History", {
              publicMethods: {
                initHistory: function () {
                  if ((s.extend(l, Ti, !0), l.history)) {
                    (Ei = window.location),
                      (xi = !1),
                      (ki = !1),
                      (Ci = !1),
                      (Si = Li()),
                      (Ai = "pushState" in history),
                      Si.indexOf("gid=") > -1 &&
                        (Si = (Si = Si.split("&gid=")[0]).split("?gid=")[0]),
                      At("afterChange", o.updateURL),
                      At("unbindEvents", function () {
                        s.unbind(window, "hashchange", o.onHashChange);
                      });
                    var t = function () {
                      (_i = !0),
                        ki ||
                          (xi
                            ? history.back()
                            : Si
                            ? (Ei.hash = Si)
                            : Ai
                            ? history.pushState(
                                "",
                                document.title,
                                Ei.pathname + Ei.search
                              )
                            : (Ei.hash = "")),
                        Di();
                    };
                    At("unbindEvents", function () {
                      d && t();
                    }),
                      At("destroy", function () {
                        _i || t();
                      }),
                      At("firstUpdate", function () {
                        u = Ii().pid;
                      });
                    var e = Si.indexOf("pid=");
                    e > -1 &&
                      "&" === (Si = Si.substring(0, e)).slice(-1) &&
                      (Si = Si.slice(0, -1)),
                      setTimeout(function () {
                        c && s.bind(window, "hashchange", o.onHashChange);
                      }, 40);
                  }
                },
                onHashChange: function () {
                  if (Li() === Si) return (ki = !0), void o.close();
                  bi || ((wi = !0), o.goTo(Ii().pid), (wi = !1));
                },
                updateURL: function () {
                  Di(), wi || (Ci ? (gi = setTimeout(Pi, 800)) : Pi());
                },
              },
            }),
              s.extend(o, ne);
          };
          return t;
        }),
          void 0 === (s = "function" == typeof n ? n.call(e, i, e, t) : n) ||
            (t.exports = s);
      },
      277: (t, e, i) => {
        var n, s, o;
        /*!
         * $script.js JS loader & dependency manager
         * https://github.com/ded/script.js
         * (c) Dustin Diaz 2014 | License MIT
         */ (o = function () {
          var t,
            e,
            i = document,
            n = i.getElementsByTagName("head")[0],
            s = !1,
            o = "push",
            r = "readyState",
            a = "onreadystatechange",
            l = {},
            c = {},
            h = {},
            d = {};
          function u(t, e) {
            for (var i = 0, n = t.length; i < n; ++i) if (!e(t[i])) return s;
            return 1;
          }
          function p(t, e) {
            u(t, function (t) {
              return e(t), 1;
            });
          }
          function f(e, i, n) {
            e = e[o] ? e : [e];
            var s = i && i.call,
              r = s ? i : n,
              a = s ? e.join("") : i,
              g = e.length;
            function v(t) {
              return t.call ? t() : l[t];
            }
            function y() {
              if (!--g)
                for (var t in ((l[a] = 1), r && r(), h))
                  u(t.split("|"), v) && !p(h[t], v) && (h[t] = []);
            }
            return (
              setTimeout(function () {
                p(e, function e(i, n) {
                  return null === i
                    ? y()
                    : (n ||
                        /^https?:\/\//.test(i) ||
                        !t ||
                        (i = -1 === i.indexOf(".js") ? t + i + ".js" : t + i),
                      d[i]
                        ? (a && (c[a] = 1),
                          2 == d[i]
                            ? y()
                            : setTimeout(function () {
                                e(i, !0);
                              }, 0))
                        : ((d[i] = 1), a && (c[a] = 1), void m(i, y)));
                });
              }, 0),
              f
            );
          }
          function m(t, s) {
            var o,
              l = i.createElement("script");
            (l.onload =
              l.onerror =
              l[a] =
                function () {
                  (l[r] && !/^c|loade/.test(l[r])) ||
                    o ||
                    ((l.onload = l[a] = null), (o = 1), (d[t] = 2), s());
                }),
              (l.async = 1),
              (l.src = e ? t + (-1 === t.indexOf("?") ? "?" : "&") + e : t),
              n.insertBefore(l, n.lastChild);
          }
          return (
            (f.get = m),
            (f.order = function (t, e, i) {
              !(function n(s) {
                (s = t.shift()), t.length ? f(s, n) : f(s, e, i);
              })();
            }),
            (f.path = function (e) {
              t = e;
            }),
            (f.urlArgs = function (t) {
              e = t;
            }),
            (f.ready = function (t, e, i) {
              t = t[o] ? t : [t];
              var n,
                s = [];
              return (
                !p(t, function (t) {
                  l[t] || s[o](t);
                }) &&
                u(t, function (t) {
                  return l[t];
                })
                  ? e()
                  : ((n = t.join("|")),
                    (h[n] = h[n] || []),
                    h[n][o](e),
                    i && i(s)),
                f
              );
            }),
            (f.done = function (t) {
              f([null], t);
            }),
            f
          );
        }),
          t.exports
            ? (t.exports = o())
            : void 0 ===
                (s = "function" == typeof (n = o) ? n.call(e, i, e, t) : n) ||
              (t.exports = s);
      },
      265: function (t) {
        var e;
        (e = function () {
          return (function (t) {
            var e = {};
            function i(n) {
              if (e[n]) return e[n].exports;
              var s = (e[n] = { i: n, l: !1, exports: {} });
              return (
                t[n].call(s.exports, s, s.exports, i), (s.l = !0), s.exports
              );
            }
            return (
              (i.m = t),
              (i.c = e),
              (i.d = function (t, e, n) {
                i.o(t, e) ||
                  Object.defineProperty(t, e, { enumerable: !0, get: n });
              }),
              (i.r = function (t) {
                "undefined" != typeof Symbol &&
                  Symbol.toStringTag &&
                  Object.defineProperty(t, Symbol.toStringTag, {
                    value: "Module",
                  }),
                  Object.defineProperty(t, "__esModule", { value: !0 });
              }),
              (i.t = function (t, e) {
                if ((1 & e && (t = i(t)), 8 & e)) return t;
                if (4 & e && "object" == typeof t && t && t.__esModule)
                  return t;
                var n = Object.create(null);
                if (
                  (i.r(n),
                  Object.defineProperty(n, "default", {
                    enumerable: !0,
                    value: t,
                  }),
                  2 & e && "string" != typeof t)
                )
                  for (var s in t)
                    i.d(
                      n,
                      s,
                      function (e) {
                        return t[e];
                      }.bind(null, s)
                    );
                return n;
              }),
              (i.n = function (t) {
                var e =
                  t && t.__esModule
                    ? function () {
                        return t.default;
                      }
                    : function () {
                        return t;
                      };
                return i.d(e, "a", e), e;
              }),
              (i.o = function (t, e) {
                return Object.prototype.hasOwnProperty.call(t, e);
              }),
              (i.p = ""),
              i((i.s = 0))
            );
          })([
            function (t, e, i) {
              "use strict";
              i.r(e);
              var n = function (t) {
                  return Array.isArray(t) ? t : [t];
                },
                s = function (t) {
                  return t instanceof Node;
                },
                o = function (t, e) {
                  if (t && e) {
                    t = (function (t) {
                      return t instanceof NodeList;
                    })(t)
                      ? t
                      : [t];
                    for (
                      var i = 0;
                      i < t.length && !0 !== e(t[i], i, t.length);
                      i++
                    );
                  }
                },
                r = function (t) {
                  return console.error("[scroll-lock] ".concat(t));
                },
                a = function (t) {
                  if (Array.isArray(t)) return t.join(", ");
                },
                l = function (t) {
                  var e = [];
                  return (
                    o(t, function (t) {
                      return e.push(t);
                    }),
                    e
                  );
                },
                c = function (t, e) {
                  var i =
                    arguments.length > 3 && void 0 !== arguments[3]
                      ? arguments[3]
                      : document;
                  if (
                    (!(arguments.length > 2 && void 0 !== arguments[2]) ||
                      arguments[2]) &&
                    -1 !== l(i.querySelectorAll(e)).indexOf(t)
                  )
                    return t;
                  for (
                    ;
                    (t = t.parentElement) &&
                    -1 === l(i.querySelectorAll(e)).indexOf(t);

                  );
                  return t;
                },
                h = function (t, e) {
                  var i =
                    arguments.length > 2 && void 0 !== arguments[2]
                      ? arguments[2]
                      : document;
                  return -1 !== l(i.querySelectorAll(e)).indexOf(t);
                },
                d = function (t) {
                  if (t) return "hidden" === getComputedStyle(t).overflow;
                },
                u = function (t) {
                  if (t) return !!d(t) || t.scrollTop <= 0;
                },
                p = function (t) {
                  if (t) {
                    if (d(t)) return !0;
                    var e = t.scrollTop,
                      i = t.scrollHeight;
                    return e + t.offsetHeight >= i;
                  }
                },
                f = function (t) {
                  if (t) return !!d(t) || t.scrollLeft <= 0;
                },
                m = function (t) {
                  if (t) {
                    if (d(t)) return !0;
                    var e = t.scrollLeft,
                      i = t.scrollWidth;
                    return e + t.offsetWidth >= i;
                  }
                };
              function g(t, e, i) {
                return (
                  e in t
                    ? Object.defineProperty(t, e, {
                        value: i,
                        enumerable: !0,
                        configurable: !0,
                        writable: !0,
                      })
                    : (t[e] = i),
                  t
                );
              }
              i.d(e, "disablePageScroll", function () {
                return b;
              }),
                i.d(e, "enablePageScroll", function () {
                  return w;
                }),
                i.d(e, "getScrollState", function () {
                  return _;
                }),
                i.d(e, "clearQueueScrollLocks", function () {
                  return S;
                }),
                i.d(e, "getTargetScrollBarWidth", function () {
                  return C;
                }),
                i.d(e, "getCurrentTargetScrollBarWidth", function () {
                  return k;
                }),
                i.d(e, "getPageScrollBarWidth", function () {
                  return x;
                }),
                i.d(e, "getCurrentPageScrollBarWidth", function () {
                  return E;
                }),
                i.d(e, "addScrollableTarget", function () {
                  return A;
                }),
                i.d(e, "removeScrollableTarget", function () {
                  return T;
                }),
                i.d(e, "addScrollableSelector", function () {
                  return L;
                }),
                i.d(e, "removeScrollableSelector", function () {
                  return D;
                }),
                i.d(e, "addLockableTarget", function () {
                  return I;
                }),
                i.d(e, "addLockableSelector", function () {
                  return P;
                }),
                i.d(e, "setFillGapMethod", function () {
                  return M;
                }),
                i.d(e, "addFillGapTarget", function () {
                  return O;
                }),
                i.d(e, "removeFillGapTarget", function () {
                  return F;
                }),
                i.d(e, "addFillGapSelector", function () {
                  return q;
                }),
                i.d(e, "removeFillGapSelector", function () {
                  return $;
                }),
                i.d(e, "refillGaps", function () {
                  return B;
                });
              var v = ["padding", "margin", "width", "max-width", "none"],
                y = {
                  scroll: !0,
                  queue: 0,
                  scrollableSelectors: ["[data-scroll-lock-scrollable]"],
                  lockableSelectors: ["body", "[data-scroll-lock-lockable]"],
                  fillGapSelectors: [
                    "body",
                    "[data-scroll-lock-fill-gap]",
                    "[data-scroll-lock-lockable]",
                  ],
                  fillGapMethod: v[0],
                  startTouchY: 0,
                  startTouchX: 0,
                },
                b = function (t) {
                  y.queue <= 0 && ((y.scroll = !1), N(), W()), A(t), y.queue++;
                },
                w = function (t) {
                  y.queue > 0 && y.queue--,
                    y.queue <= 0 && ((y.scroll = !0), R(), V()),
                    T(t);
                },
                _ = function () {
                  return y.scroll;
                },
                S = function () {
                  y.queue = 0;
                },
                C = function (t) {
                  var e =
                    arguments.length > 1 &&
                    void 0 !== arguments[1] &&
                    arguments[1];
                  if (s(t)) {
                    var i = t.style.overflowY;
                    e
                      ? _() ||
                        (t.style.overflowY = t.getAttribute(
                          "data-scroll-lock-saved-overflow-y-property"
                        ))
                      : (t.style.overflowY = "scroll");
                    var n = k(t);
                    return (t.style.overflowY = i), n;
                  }
                  return 0;
                },
                k = function (t) {
                  if (s(t)) {
                    if (t === document.body) {
                      var e = document.documentElement.clientWidth;
                      return window.innerWidth - e;
                    }
                    var i = t.style.borderLeftWidth,
                      n = t.style.borderRightWidth;
                    (t.style.borderLeftWidth = "0px"),
                      (t.style.borderRightWidth = "0px");
                    var o = t.offsetWidth - t.clientWidth;
                    return (
                      (t.style.borderLeftWidth = i),
                      (t.style.borderRightWidth = n),
                      o
                    );
                  }
                  return 0;
                },
                x = function () {
                  var t =
                    arguments.length > 0 &&
                    void 0 !== arguments[0] &&
                    arguments[0];
                  return C(document.body, t);
                },
                E = function () {
                  return k(document.body);
                },
                A = function (t) {
                  t &&
                    n(t).map(function (t) {
                      o(t, function (t) {
                        s(t)
                          ? t.setAttribute("data-scroll-lock-scrollable", "")
                          : r('"'.concat(t, '" is not a Element.'));
                      });
                    });
                },
                T = function (t) {
                  t &&
                    n(t).map(function (t) {
                      o(t, function (t) {
                        s(t)
                          ? t.removeAttribute("data-scroll-lock-scrollable")
                          : r('"'.concat(t, '" is not a Element.'));
                      });
                    });
                },
                L = function (t) {
                  t &&
                    n(t).map(function (t) {
                      y.scrollableSelectors.push(t);
                    });
                },
                D = function (t) {
                  t &&
                    n(t).map(function (t) {
                      y.scrollableSelectors = y.scrollableSelectors.filter(
                        function (e) {
                          return e !== t;
                        }
                      );
                    });
                },
                I = function (t) {
                  t &&
                    (n(t).map(function (t) {
                      o(t, function (t) {
                        s(t)
                          ? t.setAttribute("data-scroll-lock-lockable", "")
                          : r('"'.concat(t, '" is not a Element.'));
                      });
                    }),
                    _() || N());
                },
                P = function (t) {
                  t &&
                    (n(t).map(function (t) {
                      y.lockableSelectors.push(t);
                    }),
                    _() || N(),
                    q(t));
                },
                M = function (t) {
                  if (t)
                    if (-1 !== v.indexOf(t)) (y.fillGapMethod = t), B();
                    else {
                      var e = v.join(", ");
                      r(
                        '"'
                          .concat(
                            t,
                            '" method is not available!\nAvailable fill gap methods: '
                          )
                          .concat(e, ".")
                      );
                    }
                },
                O = function (t) {
                  t &&
                    n(t).map(function (t) {
                      o(t, function (t) {
                        s(t)
                          ? (t.setAttribute("data-scroll-lock-fill-gap", ""),
                            y.scroll || X(t))
                          : r('"'.concat(t, '" is not a Element.'));
                      });
                    });
                },
                F = function (t) {
                  t &&
                    n(t).map(function (t) {
                      o(t, function (t) {
                        s(t)
                          ? (t.removeAttribute("data-scroll-lock-fill-gap"),
                            y.scroll || Q(t))
                          : r('"'.concat(t, '" is not a Element.'));
                      });
                    });
                },
                q = function (t) {
                  t &&
                    n(t).map(function (t) {
                      -1 === y.fillGapSelectors.indexOf(t) &&
                        (y.fillGapSelectors.push(t), y.scroll || G(t));
                    });
                },
                $ = function (t) {
                  t &&
                    n(t).map(function (t) {
                      (y.fillGapSelectors = y.fillGapSelectors.filter(function (
                        e
                      ) {
                        return e !== t;
                      })),
                        y.scroll || Z(t);
                    });
                },
                B = function () {
                  y.scroll || W();
                },
                N = function () {
                  var t = a(y.lockableSelectors);
                  z(t);
                },
                R = function () {
                  var t = a(y.lockableSelectors);
                  H(t);
                },
                z = function (t) {
                  var e = document.querySelectorAll(t);
                  o(e, function (t) {
                    U(t);
                  });
                },
                H = function (t) {
                  var e = document.querySelectorAll(t);
                  o(e, function (t) {
                    j(t);
                  });
                },
                U = function (t) {
                  if (
                    s(t) &&
                    "true" !== t.getAttribute("data-scroll-lock-locked")
                  ) {
                    var e = window.getComputedStyle(t);
                    t.setAttribute(
                      "data-scroll-lock-saved-overflow-y-property",
                      e.overflowY
                    ),
                      t.setAttribute(
                        "data-scroll-lock-saved-inline-overflow-property",
                        t.style.overflow
                      ),
                      t.setAttribute(
                        "data-scroll-lock-saved-inline-overflow-y-property",
                        t.style.overflowY
                      ),
                      (t.style.overflow = "hidden"),
                      t.setAttribute("data-scroll-lock-locked", "true");
                  }
                },
                j = function (t) {
                  s(t) &&
                    "true" === t.getAttribute("data-scroll-lock-locked") &&
                    ((t.style.overflow = t.getAttribute(
                      "data-scroll-lock-saved-inline-overflow-property"
                    )),
                    (t.style.overflowY = t.getAttribute(
                      "data-scroll-lock-saved-inline-overflow-y-property"
                    )),
                    t.removeAttribute(
                      "data-scroll-lock-saved-overflow-property"
                    ),
                    t.removeAttribute(
                      "data-scroll-lock-saved-inline-overflow-property"
                    ),
                    t.removeAttribute(
                      "data-scroll-lock-saved-inline-overflow-y-property"
                    ),
                    t.removeAttribute("data-scroll-lock-locked"));
                },
                W = function () {
                  y.fillGapSelectors.map(function (t) {
                    G(t);
                  });
                },
                V = function () {
                  y.fillGapSelectors.map(function (t) {
                    Z(t);
                  });
                },
                G = function (t) {
                  var e = document.querySelectorAll(t),
                    i = -1 !== y.lockableSelectors.indexOf(t);
                  o(e, function (t) {
                    X(t, i);
                  });
                },
                X = function (t) {
                  var e =
                    arguments.length > 1 &&
                    void 0 !== arguments[1] &&
                    arguments[1];
                  if (s(t)) {
                    var i;
                    if ("" === t.getAttribute("data-scroll-lock-lockable") || e)
                      i = C(t, !0);
                    else {
                      var n = c(t, a(y.lockableSelectors));
                      i = C(n, !0);
                    }
                    "true" === t.getAttribute("data-scroll-lock-filled-gap") &&
                      Q(t);
                    var o = window.getComputedStyle(t);
                    if (
                      (t.setAttribute("data-scroll-lock-filled-gap", "true"),
                      t.setAttribute(
                        "data-scroll-lock-current-fill-gap-method",
                        y.fillGapMethod
                      ),
                      "margin" === y.fillGapMethod)
                    ) {
                      var r = parseFloat(o.marginRight);
                      t.style.marginRight = "".concat(r + i, "px");
                    } else if ("width" === y.fillGapMethod)
                      t.style.width = "calc(100% - ".concat(i, "px)");
                    else if ("max-width" === y.fillGapMethod)
                      t.style.maxWidth = "calc(100% - ".concat(i, "px)");
                    else if ("padding" === y.fillGapMethod) {
                      var l = parseFloat(o.paddingRight);
                      t.style.paddingRight = "".concat(l + i, "px");
                    }
                  }
                },
                Z = function (t) {
                  var e = document.querySelectorAll(t);
                  o(e, function (t) {
                    Q(t);
                  });
                },
                Q = function (t) {
                  if (
                    s(t) &&
                    "true" === t.getAttribute("data-scroll-lock-filled-gap")
                  ) {
                    var e = t.getAttribute(
                      "data-scroll-lock-current-fill-gap-method"
                    );
                    t.removeAttribute("data-scroll-lock-filled-gap"),
                      t.removeAttribute(
                        "data-scroll-lock-current-fill-gap-method"
                      ),
                      "margin" === e
                        ? (t.style.marginRight = "")
                        : "width" === e
                        ? (t.style.width = "")
                        : "max-width" === e
                        ? (t.style.maxWidth = "")
                        : "padding" === e && (t.style.paddingRight = "");
                  }
                };
              "undefined" != typeof window &&
                window.addEventListener("resize", function (t) {
                  B();
                }),
                "undefined" != typeof document &&
                  (document.addEventListener("touchstart", function (t) {
                    y.scroll ||
                      ((y.startTouchY = t.touches[0].clientY),
                      (y.startTouchX = t.touches[0].clientX));
                  }),
                  document.addEventListener(
                    "touchmove",
                    function (t) {
                      if (!y.scroll) {
                        var e = y.startTouchY,
                          i = y.startTouchX,
                          n = t.touches[0].clientY,
                          s = t.touches[0].clientX;
                        if (t.touches.length < 2) {
                          var o = a(y.scrollableSelectors),
                            r = {
                              up: e < n,
                              down: e > n,
                              left: i < s,
                              right: i > s,
                            },
                            l = {
                              up: e + 3 < n,
                              down: e - 3 > n,
                              left: i + 3 < s,
                              right: i - 3 > s,
                            };
                          !(function e(i) {
                            var n =
                              arguments.length > 1 &&
                              void 0 !== arguments[1] &&
                              arguments[1];
                            if (i) {
                              var s = c(i, o, !1);
                              if (
                                (function (t) {
                                  return h(t, 'input[type="range"]');
                                })(i)
                              )
                                return !1;
                              if (
                                n ||
                                ((function (t) {
                                  return h(
                                    t,
                                    'textarea, [contenteditable="true"]'
                                  );
                                })(i) &&
                                  c(i, o)) ||
                                h(i, o)
                              ) {
                                var a = !1;
                                f(i) && m(i)
                                  ? ((r.up && u(i)) || (r.down && p(i))) &&
                                    (a = !0)
                                  : u(i) && p(i)
                                  ? ((r.left && f(i)) || (r.right && m(i))) &&
                                    (a = !0)
                                  : ((l.up && u(i)) ||
                                      (l.down && p(i)) ||
                                      (l.left && f(i)) ||
                                      (l.right && m(i))) &&
                                    (a = !0),
                                  a &&
                                    (s
                                      ? e(s, !0)
                                      : t.cancelable && t.preventDefault());
                              } else e(s);
                            } else t.cancelable && t.preventDefault();
                          })(t.target);
                        }
                      }
                    },
                    { passive: !1 }
                  ),
                  document.addEventListener("touchend", function (t) {
                    y.scroll || ((y.startTouchY = 0), (y.startTouchX = 0));
                  }));
              var Y = {
                  hide: function (t) {
                    r(
                      '"hide" is deprecated! Use "disablePageScroll" instead. \n https://github.com/FL3NKEY/scroll-lock#disablepagescrollscrollabletarget'
                    ),
                      b(t);
                  },
                  show: function (t) {
                    r(
                      '"show" is deprecated! Use "enablePageScroll" instead. \n https://github.com/FL3NKEY/scroll-lock#enablepagescrollscrollabletarget'
                    ),
                      w(t);
                  },
                  toggle: function (t) {
                    r('"toggle" is deprecated! Do not use it.'),
                      _() ? b() : w(t);
                  },
                  getState: function () {
                    return (
                      r(
                        '"getState" is deprecated! Use "getScrollState" instead. \n https://github.com/FL3NKEY/scroll-lock#getscrollstate'
                      ),
                      _()
                    );
                  },
                  getWidth: function () {
                    return (
                      r(
                        '"getWidth" is deprecated! Use "getPageScrollBarWidth" instead. \n https://github.com/FL3NKEY/scroll-lock#getpagescrollbarwidth'
                      ),
                      x()
                    );
                  },
                  getCurrentWidth: function () {
                    return (
                      r(
                        '"getCurrentWidth" is deprecated! Use "getCurrentPageScrollBarWidth" instead. \n https://github.com/FL3NKEY/scroll-lock#getcurrentpagescrollbarwidth'
                      ),
                      E()
                    );
                  },
                  setScrollableTargets: function (t) {
                    r(
                      '"setScrollableTargets" is deprecated! Use "addScrollableTarget" instead. \n https://github.com/FL3NKEY/scroll-lock#addscrollabletargetscrollabletarget'
                    ),
                      A(t);
                  },
                  setFillGapSelectors: function (t) {
                    r(
                      '"setFillGapSelectors" is deprecated! Use "addFillGapSelector" instead. \n https://github.com/FL3NKEY/scroll-lock#addfillgapselectorfillgapselector'
                    ),
                      q(t);
                  },
                  setFillGapTargets: function (t) {
                    r(
                      '"setFillGapTargets" is deprecated! Use "addFillGapTarget" instead. \n https://github.com/FL3NKEY/scroll-lock#addfillgaptargetfillgaptarget'
                    ),
                      O(t);
                  },
                  clearQueue: function () {
                    r(
                      '"clearQueue" is deprecated! Use "clearQueueScrollLocks" instead. \n https://github.com/FL3NKEY/scroll-lock#clearqueuescrolllocks'
                    ),
                      S();
                  },
                },
                K = (function (t) {
                  for (var e = 1; e < arguments.length; e++) {
                    var i = null != arguments[e] ? arguments[e] : {},
                      n = Object.keys(i);
                    "function" == typeof Object.getOwnPropertySymbols &&
                      (n = n.concat(
                        Object.getOwnPropertySymbols(i).filter(function (t) {
                          return Object.getOwnPropertyDescriptor(
                            i,
                            t
                          ).enumerable;
                        })
                      )),
                      n.forEach(function (e) {
                        g(t, e, i[e]);
                      });
                  }
                  return t;
                })(
                  {
                    disablePageScroll: b,
                    enablePageScroll: w,
                    getScrollState: _,
                    clearQueueScrollLocks: S,
                    getTargetScrollBarWidth: C,
                    getCurrentTargetScrollBarWidth: k,
                    getPageScrollBarWidth: x,
                    getCurrentPageScrollBarWidth: E,
                    addScrollableSelector: L,
                    removeScrollableSelector: D,
                    addScrollableTarget: A,
                    removeScrollableTarget: T,
                    addLockableSelector: P,
                    addLockableTarget: I,
                    addFillGapSelector: q,
                    removeFillGapSelector: $,
                    addFillGapTarget: O,
                    removeFillGapTarget: F,
                    setFillGapMethod: M,
                    refillGaps: B,
                    _state: y,
                  },
                  Y
                );
              e.default = K;
            },
          ]).default;
        }),
          (t.exports = e());
      },
      637: (t, e) => {
        var i, n, s;
        (n = []),
          void 0 ===
            (s =
              "function" ==
              typeof (i = function () {
                var t = "",
                  e = 20,
                  i = !0,
                  n = [],
                  s = !1,
                  o = !0,
                  r = !0,
                  a = null,
                  l = !0,
                  c = !0,
                  h = null,
                  d = !0,
                  u = !1,
                  p = !1,
                  f = !0,
                  m = "en",
                  g = !0,
                  v = !1,
                  y = null;
                function b(t) {
                  return t
                    .replace(/<b[^>]*>(.*?)<\/b>/gi, function (t, e) {
                      return e;
                    })
                    .replace(
                      /class="(?!(tco-hidden|tco-display|tco-ellipsis))+.*?"|data-query-source=".*?"|dir=".*?"|rel=".*?"/gi,
                      ""
                    );
                }
                function w(t) {
                  for (
                    var e = t.getElementsByTagName("a"), i = e.length - 1;
                    i >= 0;
                    i--
                  )
                    e[i].setAttribute("target", "_blank");
                }
                function _(t, e) {
                  for (
                    var i = [],
                      n = new RegExp("(^| )" + e + "( |$)"),
                      s = t.getElementsByTagName("*"),
                      o = 0,
                      r = s.length;
                    o < r;
                    o++
                  )
                    n.test(s[o].className) && i.push(s[o]);
                  return i;
                }
                function S(t) {
                  if (void 0 !== t && t.innerHTML.indexOf("data-image") >= 0) {
                    var e = t.innerHTML.split('data-image="')[1].split('"')[0];
                    return decodeURIComponent(e) + ".jpg";
                  }
                }
                var C = {
                  fetch: function (l) {
                    if (
                      (void 0 === l.maxTweets && (l.maxTweets = 20),
                      void 0 === l.enableLinks && (l.enableLinks = !0),
                      void 0 === l.showUser && (l.showUser = !0),
                      void 0 === l.showTime && (l.showTime = !0),
                      void 0 === l.dateFunction && (l.dateFunction = "default"),
                      void 0 === l.showRetweet && (l.showRetweet = !0),
                      void 0 === l.customCallback && (l.customCallback = null),
                      void 0 === l.showInteraction && (l.showInteraction = !0),
                      void 0 === l.showImages && (l.showImages = !1),
                      void 0 === l.useEmoji && (l.useEmoji = !1),
                      void 0 === l.linksInNewWindow &&
                        (l.linksInNewWindow = !0),
                      void 0 === l.showPermalinks && (l.showPermalinks = !0),
                      void 0 === l.dataOnly && (l.dataOnly = !1),
                      s)
                    )
                      n.push(l);
                    else {
                      (s = !0),
                        (t = l.domId),
                        (e = l.maxTweets),
                        (i = l.enableLinks),
                        (r = l.showUser),
                        (o = l.showTime),
                        (c = l.showRetweet),
                        (a = l.dateFunction),
                        (h = l.customCallback),
                        (d = l.showInteraction),
                        (u = l.showImages),
                        (p = l.useEmoji),
                        (f = l.linksInNewWindow),
                        (g = l.showPermalinks),
                        (v = l.dataOnly);
                      var b = document.getElementsByTagName("head")[0];
                      null !== y && b.removeChild(y),
                        ((y = document.createElement("script")).type =
                          "text/javascript"),
                        void 0 !== l.list
                          ? (y.src =
                              "https://syndication.twitter.com/timeline/list?callback=__twttrf.callback&dnt=false&list_slug=" +
                              l.list.listSlug +
                              "&screen_name=" +
                              l.list.screenName +
                              "&suppress_response_codes=true&lang=" +
                              (l.lang || m) +
                              "&rnd=" +
                              Math.random())
                          : void 0 !== l.profile
                          ? (y.src =
                              "https://syndication.twitter.com/timeline/profile?callback=__twttrf.callback&dnt=false&screen_name=" +
                              l.profile.screenName +
                              "&suppress_response_codes=true&lang=" +
                              (l.lang || m) +
                              "&rnd=" +
                              Math.random())
                          : void 0 !== l.likes
                          ? (y.src =
                              "https://syndication.twitter.com/timeline/likes?callback=__twttrf.callback&dnt=false&screen_name=" +
                              l.likes.screenName +
                              "&suppress_response_codes=true&lang=" +
                              (l.lang || m) +
                              "&rnd=" +
                              Math.random())
                          : (y.src =
                              "https://cdn.syndication.twimg.com/widgets/timelines/" +
                              l.id +
                              "?&lang=" +
                              (l.lang || m) +
                              "&callback=__twttrf.callback&suppress_response_codes=true&rnd=" +
                              Math.random()),
                        b.appendChild(y);
                    }
                  },
                  callback: function (m) {
                    if (void 0 === m || void 0 === m.body)
                      return (
                        (s = !1),
                        void (n.length > 0 && (C.fetch(n[0]), n.splice(0, 1)))
                      );
                    p ||
                      (m.body = m.body.replace(
                        /(<img[^c]*class="Emoji[^>]*>)|(<img[^c]*class="u-block[^>]*>)/g,
                        ""
                      )),
                      u ||
                        (m.body = m.body.replace(
                          /(<img[^c]*class="NaturalImage-image[^>]*>|(<img[^c]*class="CroppedImage-image[^>]*>))/g,
                          ""
                        )),
                      r ||
                        (m.body = m.body.replace(
                          /(<img[^c]*class="Avatar"[^>]*>)/g,
                          ""
                        ));
                    var y = document.createElement("div");
                    function k(t) {
                      var e = t.getElementsByTagName("img")[0];
                      return (
                        e &&
                          e.length &&
                          (e.src = e.getAttribute("data-src-2x")),
                        t
                      );
                    }
                    (y.innerHTML = m.body),
                      void 0 === y.getElementsByClassName && (l = !1);
                    var x = [],
                      E = [],
                      A = [],
                      T = [],
                      L = [],
                      D = [],
                      I = [],
                      P = 0;
                    if (l)
                      for (
                        var M = y.getElementsByClassName("timeline-Tweet");
                        P < M.length;

                      )
                        M[P].getElementsByClassName(
                          "timeline-Tweet-retweetCredit"
                        ).length > 0
                          ? L.push(!0)
                          : L.push(!1),
                          (!L[P] || (L[P] && c)) &&
                            (x.push(
                              M[P].getElementsByClassName(
                                "timeline-Tweet-text"
                              )[0]
                            ),
                            D.push(M[P].getAttribute("data-tweet-id")),
                            r &&
                              E.push(
                                k(
                                  M[P].getElementsByClassName(
                                    "timeline-Tweet-author"
                                  )[0]
                                )
                              ),
                            A.push(
                              M[P].getElementsByClassName("dt-updated")[0]
                            ),
                            I.push(
                              M[P].getElementsByClassName(
                                "timeline-Tweet-timestamp"
                              )[0]
                            ),
                            void 0 !==
                            M[P].getElementsByClassName(
                              "timeline-Tweet-media"
                            )[0]
                              ? T.push(
                                  M[P].getElementsByClassName(
                                    "timeline-Tweet-media"
                                  )[0]
                                )
                              : T.push(void 0)),
                          P++;
                    else
                      for (M = _(y, "timeline-Tweet"); P < M.length; )
                        _(M[P], "timeline-Tweet-retweetCredit").length > 0
                          ? L.push(!0)
                          : L.push(!1),
                          (!L[P] || (L[P] && c)) &&
                            (x.push(_(M[P], "timeline-Tweet-text")[0]),
                            D.push(M[P].getAttribute("data-tweet-id")),
                            r && E.push(k(_(M[P], "timeline-Tweet-author")[0])),
                            A.push(_(M[P], "dt-updated")[0]),
                            I.push(_(M[P], "timeline-Tweet-timestamp")[0]),
                            void 0 !== _(M[P], "timeline-Tweet-media")[0]
                              ? T.push(_(M[P], "timeline-Tweet-media")[0])
                              : T.push(void 0)),
                          P++;
                    x.length > e &&
                      (x.splice(e, x.length - e),
                      E.splice(e, E.length - e),
                      A.splice(e, A.length - e),
                      L.splice(e, L.length - e),
                      T.splice(e, T.length - e),
                      I.splice(e, I.length - e));
                    var O = [],
                      F = ((P = x.length), 0);
                    if (v)
                      for (; F < P; )
                        O.push({
                          tweet: x[F].innerHTML,
                          author: E[F] ? E[F].innerHTML : "Unknown Author",
                          author_data: {
                            profile_url: E[F]
                              ? E[F].querySelector(
                                  '[data-scribe="element:user_link"]'
                                ).href
                              : null,
                            profile_image: E[F]
                              ? E[F].querySelector(
                                  '[data-scribe="element:avatar"]'
                                ).getAttribute("data-src-1x")
                              : null,
                            profile_image_2x: E[F]
                              ? E[F].querySelector(
                                  '[data-scribe="element:avatar"]'
                                ).getAttribute("data-src-2x")
                              : null,
                            screen_name: E[F]
                              ? E[F].querySelector(
                                  '[data-scribe="element:screen_name"]'
                                ).title
                              : null,
                            name: E[F]
                              ? E[F].querySelector(
                                  '[data-scribe="element:name"]'
                                ).title
                              : null,
                          },
                          time: A[F].textContent,
                          timestamp: A[F].getAttribute("datetime")
                            .replace("+0000", "Z")
                            .replace(/([\+\-])(\d\d)(\d\d)/, "$1$2:$3"),
                          image: S(T[F]),
                          rt: L[F],
                          tid: D[F],
                          permalinkURL: void 0 === I[F] ? "" : I[F].href,
                        }),
                          F++;
                    else
                      for (; F < P; ) {
                        if ("string" != typeof a) {
                          var q = A[F].getAttribute("datetime"),
                            $ = new Date(
                              A[F].getAttribute("datetime")
                                .replace(/-/g, "/")
                                .replace("T", " ")
                                .split("+")[0]
                            ),
                            B = a($, q);
                          if (
                            (A[F].setAttribute("aria-label", B),
                            x[F].textContent)
                          )
                            if (l) A[F].textContent = B;
                            else {
                              var N = document.createElement("p"),
                                R = document.createTextNode(B);
                              N.appendChild(R),
                                N.setAttribute("aria-label", B),
                                (A[F] = N);
                            }
                          else A[F].textContent = B;
                        }
                        var z = "";
                        i
                          ? (f && (w(x[F]), r && w(E[F])),
                            r &&
                              (z +=
                                '<div class="user">' +
                                b(E[F].innerHTML) +
                                "</div>"),
                            (z +=
                              '<p class="tweet">' + b(x[F].innerHTML) + "</p>"),
                            o &&
                              (z += g
                                ? '<p class="timePosted"><a href="' +
                                  I[F] +
                                  '">' +
                                  A[F].getAttribute("aria-label") +
                                  "</a></p>"
                                : '<p class="timePosted">' +
                                  A[F].getAttribute("aria-label") +
                                  "</p>"))
                          : (x[F].textContent,
                            r &&
                              (z +=
                                '<p class="user">' + E[F].textContent + "</p>"),
                            (z +=
                              '<p class="tweet">' + x[F].textContent + "</p>"),
                            o &&
                              (z +=
                                '<p class="timePosted">' +
                                A[F].textContent +
                                "</p>")),
                          d &&
                            (z +=
                              '<p class="interact"><a href="https://twitter.com/intent/tweet?in_reply_to=' +
                              D[F] +
                              '" class="twitter_reply_icon"' +
                              (f ? ' target="_blank">' : ">") +
                              'Reply</a><a href="https://twitter.com/intent/retweet?tweet_id=' +
                              D[F] +
                              '" class="twitter_retweet_icon"' +
                              (f ? ' target="_blank">' : ">") +
                              'Retweet</a><a href="https://twitter.com/intent/favorite?tweet_id=' +
                              D[F] +
                              '" class="twitter_fav_icon"' +
                              (f ? ' target="_blank">' : ">") +
                              "Favorite</a></p>"),
                          u &&
                            void 0 !== T[F] &&
                            void 0 !== S(T[F]) &&
                            (z +=
                              '<div class="media"><img src="' +
                              S(T[F]) +
                              '" alt="Image from tweet" /></div>'),
                          (u || (!u && x[F].textContent.length)) && O.push(z),
                          F++;
                      }
                    !(function (e) {
                      if (null === h) {
                        for (
                          var i = e.length,
                            n = 0,
                            s = document.getElementById(t),
                            o = "<ul>";
                          n < i;

                        )
                          (o += "<li>" + e[n] + "</li>"), n++;
                        (o += "</ul>"), (s.innerHTML = o);
                      } else h(e);
                    })(O),
                      (s = !1),
                      n.length > 0 && (C.fetch(n[0]), n.splice(0, 1));
                  },
                };
                return (window.__twttrf = C), (window.twitterFetcher = C), C;
              })
                ? i.apply(e, n)
                : i) || (t.exports = s);
      },
      842: (t, e, i) => {
        var n, s;
        /*!
         * Unidragger v2.3.0
         * Draggable base class
         * MIT license
         */ !(function (o, r) {
          (n = [i(704)]),
            (s = function (t) {
              return (function (t, e) {
                "use strict";
                function i() {}
                var n = (i.prototype = Object.create(e.prototype));
                (n.bindHandles = function () {
                  this._bindHandles(!0);
                }),
                  (n.unbindHandles = function () {
                    this._bindHandles(!1);
                  }),
                  (n._bindHandles = function (e) {
                    for (
                      var i = (e = void 0 === e || e)
                          ? "addEventListener"
                          : "removeEventListener",
                        n = e ? this._touchActionValue : "",
                        s = 0;
                      s < this.handles.length;
                      s++
                    ) {
                      var o = this.handles[s];
                      this._bindStartEvent(o, e),
                        o[i]("click", this),
                        t.PointerEvent && (o.style.touchAction = n);
                    }
                  }),
                  (n._touchActionValue = "none"),
                  (n.pointerDown = function (t, e) {
                    this.okayPointerDown(t) &&
                      ((this.pointerDownPointer = e),
                      t.preventDefault(),
                      this.pointerDownBlur(),
                      this._bindPostStartEvents(t),
                      this.emitEvent("pointerDown", [t, e]));
                  });
                var s = { TEXTAREA: !0, INPUT: !0, SELECT: !0, OPTION: !0 },
                  o = {
                    radio: !0,
                    checkbox: !0,
                    button: !0,
                    submit: !0,
                    image: !0,
                    file: !0,
                  };
                return (
                  (n.okayPointerDown = function (t) {
                    var e = s[t.target.nodeName],
                      i = o[t.target.type],
                      n = !e || i;
                    return n || this._pointerReset(), n;
                  }),
                  (n.pointerDownBlur = function () {
                    var t = document.activeElement;
                    t && t.blur && t != document.body && t.blur();
                  }),
                  (n.pointerMove = function (t, e) {
                    var i = this._dragPointerMove(t, e);
                    this.emitEvent("pointerMove", [t, e, i]),
                      this._dragMove(t, e, i);
                  }),
                  (n._dragPointerMove = function (t, e) {
                    var i = {
                      x: e.pageX - this.pointerDownPointer.pageX,
                      y: e.pageY - this.pointerDownPointer.pageY,
                    };
                    return (
                      !this.isDragging &&
                        this.hasDragStarted(i) &&
                        this._dragStart(t, e),
                      i
                    );
                  }),
                  (n.hasDragStarted = function (t) {
                    return Math.abs(t.x) > 3 || Math.abs(t.y) > 3;
                  }),
                  (n.pointerUp = function (t, e) {
                    this.emitEvent("pointerUp", [t, e]),
                      this._dragPointerUp(t, e);
                  }),
                  (n._dragPointerUp = function (t, e) {
                    this.isDragging
                      ? this._dragEnd(t, e)
                      : this._staticClick(t, e);
                  }),
                  (n._dragStart = function (t, e) {
                    (this.isDragging = !0),
                      (this.isPreventingClicks = !0),
                      this.dragStart(t, e);
                  }),
                  (n.dragStart = function (t, e) {
                    this.emitEvent("dragStart", [t, e]);
                  }),
                  (n._dragMove = function (t, e, i) {
                    this.isDragging && this.dragMove(t, e, i);
                  }),
                  (n.dragMove = function (t, e, i) {
                    t.preventDefault(), this.emitEvent("dragMove", [t, e, i]);
                  }),
                  (n._dragEnd = function (t, e) {
                    (this.isDragging = !1),
                      setTimeout(
                        function () {
                          delete this.isPreventingClicks;
                        }.bind(this)
                      ),
                      this.dragEnd(t, e);
                  }),
                  (n.dragEnd = function (t, e) {
                    this.emitEvent("dragEnd", [t, e]);
                  }),
                  (n.onclick = function (t) {
                    this.isPreventingClicks && t.preventDefault();
                  }),
                  (n._staticClick = function (t, e) {
                    (this.isIgnoringMouseUp && "mouseup" == t.type) ||
                      (this.staticClick(t, e),
                      "mouseup" != t.type &&
                        ((this.isIgnoringMouseUp = !0),
                        setTimeout(
                          function () {
                            delete this.isIgnoringMouseUp;
                          }.bind(this),
                          400
                        )));
                  }),
                  (n.staticClick = function (t, e) {
                    this.emitEvent("staticClick", [t, e]);
                  }),
                  (i.getPointerPoint = e.getPointerPoint),
                  i
                );
              })(o, t);
            }.apply(e, n)),
            void 0 === s || (t.exports = s);
        })(window);
      },
      704: (t, e, i) => {
        var n, s;
        /*!
         * Unipointer v2.3.0
         * base class for doing one thing with pointer event
         * MIT license
         */ !(function (o, r) {
          (n = [i(158)]),
            (s = function (t) {
              return (function (t, e) {
                "use strict";
                function i() {}
                function n() {}
                var s = (n.prototype = Object.create(e.prototype));
                (s.bindStartEvent = function (t) {
                  this._bindStartEvent(t, !0);
                }),
                  (s.unbindStartEvent = function (t) {
                    this._bindStartEvent(t, !1);
                  }),
                  (s._bindStartEvent = function (e, i) {
                    var n = (i = void 0 === i || i)
                        ? "addEventListener"
                        : "removeEventListener",
                      s = "mousedown";
                    t.PointerEvent
                      ? (s = "pointerdown")
                      : "ontouchstart" in t && (s = "touchstart"),
                      e[n](s, this);
                  }),
                  (s.handleEvent = function (t) {
                    var e = "on" + t.type;
                    this[e] && this[e](t);
                  }),
                  (s.getTouch = function (t) {
                    for (var e = 0; e < t.length; e++) {
                      var i = t[e];
                      if (i.identifier == this.pointerIdentifier) return i;
                    }
                  }),
                  (s.onmousedown = function (t) {
                    var e = t.button;
                    (e && 0 !== e && 1 !== e) || this._pointerDown(t, t);
                  }),
                  (s.ontouchstart = function (t) {
                    this._pointerDown(t, t.changedTouches[0]);
                  }),
                  (s.onpointerdown = function (t) {
                    this._pointerDown(t, t);
                  }),
                  (s._pointerDown = function (t, e) {
                    t.button ||
                      this.isPointerDown ||
                      ((this.isPointerDown = !0),
                      (this.pointerIdentifier =
                        void 0 !== e.pointerId ? e.pointerId : e.identifier),
                      this.pointerDown(t, e));
                  }),
                  (s.pointerDown = function (t, e) {
                    this._bindPostStartEvents(t),
                      this.emitEvent("pointerDown", [t, e]);
                  });
                var o = {
                  mousedown: ["mousemove", "mouseup"],
                  touchstart: ["touchmove", "touchend", "touchcancel"],
                  pointerdown: ["pointermove", "pointerup", "pointercancel"],
                };
                return (
                  (s._bindPostStartEvents = function (e) {
                    if (e) {
                      var i = o[e.type];
                      i.forEach(function (e) {
                        t.addEventListener(e, this);
                      }, this),
                        (this._boundPointerEvents = i);
                    }
                  }),
                  (s._unbindPostStartEvents = function () {
                    this._boundPointerEvents &&
                      (this._boundPointerEvents.forEach(function (e) {
                        t.removeEventListener(e, this);
                      }, this),
                      delete this._boundPointerEvents);
                  }),
                  (s.onmousemove = function (t) {
                    this._pointerMove(t, t);
                  }),
                  (s.onpointermove = function (t) {
                    t.pointerId == this.pointerIdentifier &&
                      this._pointerMove(t, t);
                  }),
                  (s.ontouchmove = function (t) {
                    var e = this.getTouch(t.changedTouches);
                    e && this._pointerMove(t, e);
                  }),
                  (s._pointerMove = function (t, e) {
                    this.pointerMove(t, e);
                  }),
                  (s.pointerMove = function (t, e) {
                    this.emitEvent("pointerMove", [t, e]);
                  }),
                  (s.onmouseup = function (t) {
                    this._pointerUp(t, t);
                  }),
                  (s.onpointerup = function (t) {
                    t.pointerId == this.pointerIdentifier &&
                      this._pointerUp(t, t);
                  }),
                  (s.ontouchend = function (t) {
                    var e = this.getTouch(t.changedTouches);
                    e && this._pointerUp(t, e);
                  }),
                  (s._pointerUp = function (t, e) {
                    this._pointerDone(), this.pointerUp(t, e);
                  }),
                  (s.pointerUp = function (t, e) {
                    this.emitEvent("pointerUp", [t, e]);
                  }),
                  (s._pointerDone = function () {
                    this._pointerReset(),
                      this._unbindPostStartEvents(),
                      this.pointerDone();
                  }),
                  (s._pointerReset = function () {
                    (this.isPointerDown = !1), delete this.pointerIdentifier;
                  }),
                  (s.pointerDone = i),
                  (s.onpointercancel = function (t) {
                    t.pointerId == this.pointerIdentifier &&
                      this._pointerCancel(t, t);
                  }),
                  (s.ontouchcancel = function (t) {
                    var e = this.getTouch(t.changedTouches);
                    e && this._pointerCancel(t, e);
                  }),
                  (s._pointerCancel = function (t, e) {
                    this._pointerDone(), this.pointerCancel(t, e);
                  }),
                  (s.pointerCancel = function (t, e) {
                    this.emitEvent("pointerCancel", [t, e]);
                  }),
                  (n.getPointerPoint = function (t) {
                    return { x: t.pageX, y: t.pageY };
                  }),
                  n
                );
              })(o, t);
            }.apply(e, n)),
            void 0 === s || (t.exports = s);
        })(window);
      },
      529: function (t, e) {
        var i, n, s;
        (n = [e]),
          (i = function (t) {
            "use strict";
            function e(t, e) {
              if (!(t instanceof e))
                throw new TypeError("Cannot call a class as a function");
            }
            Object.defineProperty(t, "__esModule", { value: !0 });
            var i = (function () {
                function t(t, e) {
                  for (var i = 0; i < e.length; i++) {
                    var n = e[i];
                    (n.enumerable = n.enumerable || !1),
                      (n.configurable = !0),
                      "value" in n && (n.writable = !0),
                      Object.defineProperty(t, n.key, n);
                  }
                }
                return function (e, i, n) {
                  return i && t(e.prototype, i), n && t(e, n), e;
                };
              })(),
              n =
                Object.assign ||
                function (t) {
                  for (var e = 1; e < arguments.length; e++) {
                    var i = arguments[e];
                    for (var n in i)
                      Object.prototype.hasOwnProperty.call(i, n) &&
                        (t[n] = i[n]);
                  }
                  return t;
                },
              s = {
                modal: ".modal",
                modalInner: ".modal-inner",
                modalContent: ".modal-content",
                open: "[data-modal-open]",
                close: "[data-modal-close]",
                page: "body",
                class: "modal-visible",
                loadClass: "vanilla-modal",
                clickOutside: !0,
                closeKeys: [27],
                transitions: !0,
                transitionEnd: null,
                onBeforeOpen: null,
                onBeforeClose: null,
                onOpen: null,
                onClose: null,
              };
            function o(t) {
              console.error("VanillaModal: " + t);
            }
            function r(t, e) {
              return function (i) {
                var n = t.filter(e);
                return n[0] ? n[0][i] : void 0;
              };
            }
            function a() {
              var t = document.createElement("div");
              return r(
                [
                  { key: "transition", value: "transitionend" },
                  { key: "OTransition", value: "otransitionend" },
                  { key: "MozTransition", value: "transitionend" },
                  { key: "WebkitTransition", value: "webkitTransitionEnd" },
                ],
                function (e) {
                  var i = e.key;
                  return void 0 !== t.style[i];
                }
              )("value");
            }
            function l(t) {
              return (
                "[object Array]" === Object.prototype.toString.call(t) &&
                t.length
              );
            }
            function c(t, e) {
              var i = (e || document).querySelector(t);
              return i || o(t + " not found in document."), i;
            }
            function h(t, e) {
              t instanceof HTMLElement || o("Not a valid HTML element."),
                t.setAttribute(
                  "class",
                  t.className
                    .split(" ")
                    .filter(function (t) {
                      return t !== e;
                    })
                    .concat(e)
                    .join(" ")
                );
            }
            function d(t, e) {
              t instanceof HTMLElement || o("Not a valid HTML element."),
                t.setAttribute(
                  "class",
                  t.className
                    .split(" ")
                    .filter(function (t) {
                      return t !== e;
                    })
                    .join(" ")
                );
            }
            function u(t) {
              return t && "string" == typeof t.hash
                ? document.querySelector(t.hash)
                : "string" == typeof t
                ? document.querySelector(t)
                : (o("No selector supplied to open()"), null);
            }
            function p(t) {
              return n({}, s, t, { transitionEnd: a() });
            }
            function f(t, e) {
              for (
                var i = (
                    t.target.document || t.target.ownerDocument
                  ).querySelectorAll(e),
                  n = 0;
                n < i.length;
                n += 1
              )
                for (var s = t.target; s && s !== document.body; ) {
                  if (s === i[n]) return s;
                  s = s.parentNode;
                }
              return null;
            }
            var m = (function () {
              function t(i) {
                e(this, t),
                  (this.isOpen = !1),
                  (this.current = null),
                  (this.isListening = !1),
                  (this.settings = p(i)),
                  (this.dom = this.getDomNodes()),
                  (this.open = this.open.bind(this)),
                  (this.close = this.close.bind(this)),
                  (this.closeKeyHandler = this.closeKeyHandler.bind(this)),
                  (this.outsideClickHandler =
                    this.outsideClickHandler.bind(this)),
                  (this.delegateOpen = this.delegateOpen.bind(this)),
                  (this.delegateClose = this.delegateClose.bind(this)),
                  (this.listen = this.listen.bind(this)),
                  (this.destroy = this.destroy.bind(this)),
                  this.addLoadedCssClass(),
                  this.listen();
              }
              return (
                i(t, [
                  {
                    key: "getDomNodes",
                    value: function () {
                      var t = this.settings,
                        e = t.modal,
                        i = t.page,
                        n = t.modalInner,
                        s = t.modalContent;
                      return {
                        modal: c(e),
                        page: c(i),
                        modalInner: c(n, c(e)),
                        modalContent: c(s, c(e)),
                      };
                    },
                  },
                  {
                    key: "addLoadedCssClass",
                    value: function () {
                      h(this.dom.page, this.settings.loadClass);
                    },
                  },
                  {
                    key: "setOpenId",
                    value: function (t) {
                      this.dom.page.setAttribute(
                        "data-current-modal",
                        t || "anonymous"
                      );
                    },
                  },
                  {
                    key: "removeOpenId",
                    value: function () {
                      this.dom.page.removeAttribute("data-current-modal");
                    },
                  },
                  {
                    key: "open",
                    value: function (t, e) {
                      var i = this.dom.page,
                        n = this.settings,
                        s = n.onBeforeOpen,
                        r = n.onOpen;
                      this.current instanceof HTMLElement == 0
                        ? (this.releaseNode(this.current),
                          (this.current = u(t)),
                          "function" == typeof s && s.call(this, e),
                          this.captureNode(this.current),
                          h(i, this.settings.class),
                          this.setOpenId(this.current.id),
                          (this.isOpen = !0),
                          "function" == typeof r && r.call(this, e))
                        : o("VanillaModal target must exist on page.");
                    },
                  },
                  {
                    key: "detectTransition",
                    value: function () {
                      var t = this.dom.modal,
                        e = window.getComputedStyle(t, null);
                      return Boolean(
                        [
                          "transitionDuration",
                          "oTransitionDuration",
                          "MozTransitionDuration",
                          "webkitTransitionDuration",
                        ].filter(function (t) {
                          return (
                            "string" == typeof e[t] && parseFloat(e[t]) > 0
                          );
                        }).length
                      );
                    },
                  },
                  {
                    key: "close",
                    value: function (t) {
                      var e = this.settings,
                        i = e.transitions,
                        n = e.transitionEnd,
                        s = e.onBeforeClose,
                        o = this.detectTransition();
                      this.isOpen &&
                        ((this.isOpen = !1),
                        "function" == typeof s && s.call(this, t),
                        d(this.dom.page, this.settings.class),
                        i && n && o
                          ? this.closeModalWithTransition(t)
                          : this.closeModal(t));
                    },
                  },
                  {
                    key: "closeModal",
                    value: function (t) {
                      var e = this.settings.onClose;
                      this.removeOpenId(this.dom.page),
                        this.releaseNode(this.current),
                        (this.isOpen = !1),
                        (this.current = null),
                        "function" == typeof e && e.call(this, t);
                    },
                  },
                  {
                    key: "closeModalWithTransition",
                    value: function (t) {
                      var e = this,
                        i = this.dom.modal,
                        n = this.settings.transitionEnd,
                        s = function s() {
                          i.removeEventListener(n, s), e.closeModal(t);
                        };
                      i.addEventListener(n, s);
                    },
                  },
                  {
                    key: "captureNode",
                    value: function (t) {
                      for (var e = this.dom.modalContent; t.childNodes.length; )
                        e.appendChild(t.childNodes[0]);
                    },
                  },
                  {
                    key: "releaseNode",
                    value: function (t) {
                      for (var e = this.dom.modalContent; e.childNodes.length; )
                        t.appendChild(e.childNodes[0]);
                    },
                  },
                  {
                    key: "closeKeyHandler",
                    value: function (t) {
                      var e = this.settings.closeKeys;
                      l(e) &&
                        e.indexOf(t.which) > -1 &&
                        !0 === this.isOpen &&
                        (t.preventDefault(), this.close(t));
                    },
                  },
                  {
                    key: "outsideClickHandler",
                    value: function (t) {
                      var e = this.settings.clickOutside,
                        i = this.dom.modalInner;
                      if (e) {
                        for (var n = t.target; n && n !== document.body; ) {
                          if (n === i) return;
                          n = n.parentNode;
                        }
                        this.close(t);
                      }
                    },
                  },
                  {
                    key: "delegateOpen",
                    value: function (t) {
                      var e = f(t, this.settings.open);
                      e && (t.preventDefault(), this.open(e, t));
                    },
                  },
                  {
                    key: "delegateClose",
                    value: function (t) {
                      f(t, this.settings.close) &&
                        (t.preventDefault(), this.close(t));
                    },
                  },
                  {
                    key: "listen",
                    value: function () {
                      var t = this.dom.modal;
                      this.isListening
                        ? o("Event listeners already applied.")
                        : (t.addEventListener(
                            "click",
                            this.outsideClickHandler,
                            !1
                          ),
                          document.addEventListener(
                            "keydown",
                            this.closeKeyHandler,
                            !1
                          ),
                          document.addEventListener(
                            "click",
                            this.delegateOpen,
                            !1
                          ),
                          document.addEventListener(
                            "click",
                            this.delegateClose,
                            !1
                          ),
                          (this.isListening = !0));
                    },
                  },
                  {
                    key: "destroy",
                    value: function () {
                      var t = this.dom.modal;
                      this.isListening
                        ? (this.close(),
                          t.removeEventListener(
                            "click",
                            this.outsideClickHandler
                          ),
                          document.removeEventListener(
                            "keydown",
                            this.closeKeyHandler
                          ),
                          document.removeEventListener(
                            "click",
                            this.delegateOpen
                          ),
                          document.removeEventListener(
                            "click",
                            this.delegateClose
                          ),
                          (this.isListening = !1))
                        : o("Event listeners already removed.");
                    },
                  },
                ]),
                t
              );
            })();
            t.default = m;
          }),
          void 0 === (s = "function" == typeof i ? i.apply(e, n) : i) ||
            (t.exports = s);
      },
    },
    e = {};
  function i(n) {
    if (e[n]) return e[n].exports;
    var s = (e[n] = { exports: {} });
    return t[n].call(s.exports, s, s.exports, i), s.exports;
  }
  (i.n = (t) => {
    var e = t && t.__esModule ? () => t.default : () => t;
    return i.d(e, { a: e }), e;
  }),
    (i.d = (t, e) => {
      for (var n in e)
        i.o(e, n) &&
          !i.o(t, n) &&
          Object.defineProperty(t, n, { enumerable: !0, get: e[n] });
    }),
    (i.g = (function () {
      if ("object" == typeof globalThis) return globalThis;
      try {
        return this || new Function("return this")();
      } catch (t) {
        if ("object" == typeof window) return window;
      }
    })()),
    (i.o = (t, e) => Object.prototype.hasOwnProperty.call(t, e)),
    (function (t, e) {
      if (
        window.Shopify &&
        window.Shopify.theme &&
        navigator &&
        navigator.sendBeacon &&
        window.Shopify.designMode
      ) {
        if (sessionStorage.getItem("oots_beacon")) return;
        navigator.sendBeacon(
          "https://app.outofthesandbox.com/beacon",
          new URLSearchParams({
            shop_domain: window.Shopify.shop,
            shop_id: window.Store.id,
            theme_name: "empire",
            theme_version: "9.1.1",
            theme_store_id: window.Shopify.theme.theme_store_id,
            theme_id: window.Shopify.theme.id,
            theme_role: window.Shopify.theme.role,
          })
        ),
          sessionStorage.setItem("oots_beacon", "");
      }
    })(),
    (() => {
      "use strict";
      var t = i(755),
        e = i.n(t);
      (window.jQuery = e()), (window.$ = e());
      i(72), i(220);
      var n = i(277),
        s = i.n(n);
      function o(t) {
        return (
          (function (t) {
            if (Array.isArray(t)) return r(t);
          })(t) ||
          (function (t) {
            if ("undefined" != typeof Symbol && Symbol.iterator in Object(t))
              return Array.from(t);
          })(t) ||
          (function (t, e) {
            if (!t) return;
            if ("string" == typeof t) return r(t, e);
            var i = Object.prototype.toString.call(t).slice(8, -1);
            "Object" === i && t.constructor && (i = t.constructor.name);
            if ("Map" === i || "Set" === i) return Array.from(i);
            if (
              "Arguments" === i ||
              /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(i)
            )
              return r(t, e);
          })(t) ||
          (function () {
            throw new TypeError(
              "Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."
            );
          })()
        );
      }
      function r(t, e) {
        (null == e || e > t.length) && (e = t.length);
        for (var i = 0, n = new Array(e); i < e; i++) n[i] = t[i];
        return n;
      }
      function a() {
        for (
          var t = { N: 1, E: 1, S: -1, W: -1 },
            e = 0,
            i = [
              arguments.length > 0 && void 0 !== arguments[0]
                ? arguments[0]
                : 0,
              arguments.length > 1 && void 0 !== arguments[1]
                ? arguments[1]
                : 0,
              arguments.length > 2 && void 0 !== arguments[2]
                ? arguments[2]
                : 0,
              arguments.length > 3 && void 0 !== arguments[3]
                ? arguments[3]
                : 0,
            ],
            n = 0;
          n < i.length;
          n++
        ) {
          var s = i[n];
          s &&
            (Number.isNaN(parseFloat(s))
              ? (e *= t[s])
              : (e += parseFloat(s) / Math.pow(60, n)));
        }
        return e;
      }
      function l(t) {
        return t
          ? [
              { elementType: "geometry", stylers: [{ color: t.e }] },
              { elementType: "labels.icon", stylers: [{ visibility: "off" }] },
              { elementType: "labels.text.fill", stylers: [{ color: t.a }] },
              { elementType: "labels.text.stroke", stylers: [{ color: t.e }] },
              {
                featureType: "administrative",
                elementType: "geometry",
                stylers: [{ visibility: "off" }],
              },
              {
                featureType: "administrative.country",
                stylers: [{ visibility: "off" }],
              },
              {
                featureType: "administrative.land_parcel",
                stylers: [{ visibility: "off" }],
              },
              {
                featureType: "administrative.neighborhood",
                stylers: [{ visibility: "off" }],
              },
              {
                featureType: "administrative.locality",
                stylers: [{ visibility: "off" }],
              },
              { featureType: "poi", stylers: [{ visibility: "off" }] },
              {
                featureType: "road",
                elementType: "geometry.fill",
                stylers: [{ color: t.d }],
              },
              {
                featureType: "road",
                elementType: "labels.icon",
                stylers: [{ visibility: "off" }],
              },
              {
                featureType: "road.arterial",
                elementType: "geometry",
                stylers: [{ color: t.c }],
              },
              {
                featureType: "road.highway",
                elementType: "geometry",
                stylers: [{ color: t.b }],
              },
              {
                featureType: "road.highway.controlled_access",
                stylers: [{ visibility: "off" }],
              },
              {
                featureType: "road.local",
                elementType: "labels.text.fill",
                stylers: [{ color: t.b }],
              },
              {
                featureType: "road.local",
                elementType: "labels.text.stroke",
                stylers: [{ color: t.e }],
              },
              { featureType: "transit", stylers: [{ visibility: "off" }] },
              {
                featureType: "water",
                elementType: "geometry",
                stylers: [{ color: t.f }],
              },
            ]
          : [];
      }
      function c(t) {
        var e = t.container,
          i = t.address,
          n = t.zoom,
          s = t.colors;
        return (function (t) {
          var e = [
              /^([0-9]{1,3})(?:°[ ]?| )([0-9]{1,2})(?:'[ ]?| )([0-9]{1,2}(?:\.[0-9]+)?)(?:"[ ]?| )?(N|E|S|W) ?([0-9]{1,3})(?:°[ ]?| )([0-9]{1,2})(?:'[ ]?| )([0-9]{1,2}(?:\.[0-9]+)?)(?:"[ ]?| )?(N|E|S|W)$/g,
              /^([0-9]{1,3})(?:°[ ]?| )([0-9]{1,2}(?:\.[0-9]+)?)(?:'[ ]?| )?(N|E|S|W) ?([0-9]{1,3})(?:°[ ]?| )([0-9]{1,2}(?:\.[0-9]+)?)(?:'[ ]?| )?(N|E|S|W)$/g,
              /^([-|+]?[0-9]{1,3}(?:\.[0-9]+)?)(?:°[ ]?| )?(N|E|S|W)?,? ?([-|+]?[0-9]{1,3}(?:\.[0-9]+)?)(?:°[ ]?| )?(N|E|S|W)?$/g,
            ],
            i = e
              .map(function (e) {
                return t.match(e);
              })
              .reduce(function (i, n, s) {
                if (!i && n) {
                  var o = e[s].exec(t);
                  return {
                    lat: o.slice(1, o.length / 2 + 1),
                    lng: o.slice(o.length / 2 + 1, o.length),
                  };
                }
                return i;
              }, null);
          return new Promise(function (e, n) {
            if (i) {
              var s = a.apply(void 0, o(i.lat)),
                r = a.apply(void 0, o(i.lng));
              e({ lat: s, lng: r });
            } else
              new google.maps.Geocoder().geocode(
                { address: t },
                function (t, i) {
                  i === google.maps.GeocoderStatus.OK && t[0]
                    ? e(t[0].geometry.location)
                    : n(i);
                }
              );
          });
        })(i)
          .then(function (t) {
            var i = new google.maps.Map(e, {
              center: t,
              clickableIcons: !1,
              disableDefaultUI: !0,
              disableDoubleClickZoom: !0,
              gestureHandling: "none",
              keyboardShortcuts: !1,
              maxZoom: n,
              minZoom: n,
              scrollWheel: !1,
              styles: l(s),
              zoom: n,
              zoomControl: !1,
            });
            new google.maps.Marker({
              clickable: !1,
              map: i,
              position: i.getCenter(),
            }),
              i.panBy(0, 0);
          })
          .catch(function (t) {
            var e,
              n = "https://developers.google.com/maps/faq#usagelimits";
            switch (t) {
              case "ZERO_RESULTS":
                e = "<p>Unable to find the address:</p> ".concat(i);
                break;
              case "OVER_QUERY_LIMIT":
                e =
                  '\n            <p>Unable to load Google Maps, you have reached your usage limit.</p>\n            <p>\n              Please visit\n              <a href="'
                    .concat(n, '" target="_blank">')
                    .concat(
                      n,
                      "</a>\n              for more details.\n            </p>\n          "
                    );
                break;
              default:
                e = "Unable to load Google Maps.";
            }
            throw e;
          });
      }
      function h(t, e) {
        window.Shopify &&
          window.Shopify.designMode &&
          (t.innerHTML = '<div class="map-error-message">'.concat(e, "</div>"));
      }
      const d = function t(e) {
        var i = this;
        !(
          /*!
           * @pixelunion/pxs-map v3.1.0
           * (c) 2023 Pixel Union
           */
          (function (t, e) {
            if (!(t instanceof e))
              throw new TypeError("Cannot call a class as a function");
          })(this, t)
        ),
          (this.map = null);
        var n = e.el
            .querySelector("[data-map]")
            .querySelector("[data-map-container]"),
          o = e.data,
          r = o.address,
          a = o.colors,
          l = o.api_key,
          d = Number.isNaN(o.zoom) ? 13 : 11 + parseInt(o.zoom, 10);
        l &&
          (void 0 === window.googleMaps
            ? s()(
                "https://maps.googleapis.com/maps/api/js?key=".concat(l),
                function () {
                  (window.googleMaps = !0),
                    c({ container: n, address: r, zoom: d, colors: a })
                      .then(function (t) {
                        i.map = t;
                      })
                      .catch(function (t) {
                        return h(n, t);
                      });
                }
              )
            : c({ container: n, address: r, zoom: d, colors: a })
                .then(function (t) {
                  i.map = t;
                })
                .catch(function (t) {
                  return h(n, t);
                }));
      };
      /*!
       * @pixelunion/age-gate v1.1.0
       * (c) 2023 Pixel Union
       */
      function u(t, e) {
        if (!(t instanceof e))
          throw new TypeError("Cannot call a class as a function");
      }
      function p(t, e) {
        for (var i = 0; i < e.length; i++) {
          var n = e[i];
          (n.enumerable = n.enumerable || !1),
            (n.configurable = !0),
            "value" in n && (n.writable = !0),
            Object.defineProperty(t, n.key, n);
        }
      }
      function f(t, e, i) {
        return (
          e && p(t.prototype, e),
          i && p(t, i),
          Object.defineProperty(t, "prototype", { writable: !1 }),
          t
        );
      }
      var m = i(265),
        g = i(458);
      var v = (function () {
          function t(e) {
            u(this, t),
              (this._el = e),
              (this._ageGateForm = e.querySelector("[data-age-gate]")),
              (this._ageGateErrorEl = this._ageGateForm.querySelector(
                "[data-age-gate-error]"
              )),
              (this._requiredAge = this._ageGateForm.dataset.requiredAge),
              this._el.addEventListener("age-gate:open", this._open.bind(this)),
              this._el.addEventListener(
                "age-gate:close",
                this._close.bind(this)
              ),
              this._ageGateForm.addEventListener(
                "submit",
                this._onFormSubmit.bind(this)
              ),
              g(navigator.userAgent)
                ? this._close()
                : "" === this._el.style.display && this._open();
          }
          return (
            f(t, [
              {
                key: "_open",
                value: function () {
                  m.disablePageScroll(), (this._el.style.display = "");
                },
              },
              {
                key: "_close",
                value: function () {
                  m.enablePageScroll(), (this._el.style.display = "none");
                },
              },
              {
                key: "_onFormSubmit",
                value: function (t) {
                  t.preventDefault(), t.stopPropagation();
                  var e = new FormData(t.target),
                    i = e.get("day"),
                    n = e.get("month"),
                    s = e.get("year");
                  if ("" !== i && "" !== n && "" !== s) {
                    var o = (function (t) {
                      var e = new Date(),
                        i = e.getFullYear() - t.getFullYear(),
                        n = e.getMonth() - t.getMonth();
                      return (
                        (n < 0 || (0 === n && e.getDate() < t.getDate())) &&
                          i--,
                        i
                      );
                    })(new Date(s, n, i));
                    o >= this._requiredAge
                      ? (this._close(), sessionStorage.setItem("age-gate", o))
                      : (this._ageGateErrorEl.style.display = "");
                  }
                },
              },
            ]),
            t
          );
        })(),
        y = (function () {
          function t() {
            u(this, t),
              (this._ageGateEl = document.getElementById("age-gate-page"));
          }
          return (
            f(t, [
              {
                key: "onSectionLoad",
                value: function () {
                  var t = new CustomEvent("age-gate:open");
                  this._ageGateEl.dispatchEvent(t);
                },
              },
              {
                key: "onSectionSelect",
                value: function () {
                  var t = new CustomEvent("age-gate:open");
                  this._ageGateEl.dispatchEvent(t);
                },
              },
              {
                key: "onSectionDeselect",
                value: function () {
                  var t = new CustomEvent("age-gate:close");
                  this._ageGateEl.dispatchEvent(t);
                },
              },
            ]),
            t
          );
        })();
      var b = {
        scale: 1,
        template: !1,
        templateRender:
          /*!
           * @pixelunion/rimg-shopify v2.7.1
           * (c) 2023 Pixel Union
           */
          /*!
           * @pixelunion/rimg v2.2.2
           * (c) 2022 Pixel Union
           */
          function (t, e) {
            return t.replace(
              "{size}",
              "".concat(e.width, "x").concat(e.height)
            );
          },
        max: { width: 1 / 0, height: 1 / 0 },
        round: 32,
        placeholder: !1,
        crop: null,
      };
      function w(t, e, i, n) {
        var s = "data-rimg-".concat(e);
        if (!t.hasAttribute(s)) return i[e] || b[e];
        var o = t.getAttribute(s);
        return n ? n(o) : o;
      }
      function _(t) {
        return (
          (t = t.split("x")),
          { width: parseInt(t[0], 10), height: parseInt(t[1], 10) }
        );
      }
      function S(t) {
        switch (t) {
          case "top":
          case "center":
          case "bottom":
          case "left":
          case "right":
            return t;
          default:
            return null;
        }
      }
      function C(t) {
        var e =
            arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
          i = t.hasAttribute("data-rimg-template");
        return {
          el: t,
          isImage: i,
          isBackgroundImage: i && "IMG" !== t.tagName,
          scale: parseInt(w(t, "scale", e)),
          density: window.devicePixelRatio || 1,
          template: w(t, "template", e),
          templateRender: e.templateRender || b.templateRender,
          max: w(t, "max", e, _),
          round: w(t, "round", e),
          placeholder: w(t, "placeholder", e, _),
          crop: w(t, "crop", e, S),
        };
      }
      function k(t) {
        var e =
            arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 32,
          i =
            arguments.length > 2 && void 0 !== arguments[2]
              ? arguments[2]
              : 1 / 0;
        return 0 === t ? e : Math.min(Math.ceil(t / e) * e, i);
      }
      function x(t, e) {
        var i = document.createEvent("Event");
        return i.initEvent(e, !0, !0), !t.dispatchEvent(i);
      }
      function E(t, e, i, n) {
        var s,
          o = t.templateRender,
          r = i
            ? 1
            : (function (t, e) {
                return Math.min(
                  Math.min(Math.max(t.max.width / e.width, 1), t.density),
                  Math.min(Math.max(t.max.height / e.height, 1), t.density)
                ).toFixed(2);
              })(t, e),
          a = i ? 1 : t.round,
          l = e.width * r,
          c = e.height * r;
        if (t.crop)
          s = { width: k(l, a, t.max.width), height: k(c, a, t.max.height) };
        else {
          var h = e.width / e.height,
            d = t.max.width / t.max.height;
          s =
            h > d
              ? {
                  width: k(l, a, t.max.width),
                  height: k(l / d, a, t.max.height),
                }
              : {
                  width: k(c * d, a, t.max.width),
                  height: k(c, a, t.max.height),
                };
        }
        var u = o(t.template, s),
          p = new Image();
        (p.onload = n),
          (p.src = u),
          t.isBackgroundImage
            ? (t.el.style.backgroundImage = "url('".concat(u, "')"))
            : t.el.setAttribute("srcset", "".concat(u, " ").concat(r, "x"));
      }
      function A(t, e) {
        var i = t.el;
        E(t, e, !1, function (t) {
          "load" === t.type
            ? i.setAttribute("data-rimg", "loaded")
            : (i.setAttribute("data-rimg", "error"), x(i, "rimg:error")),
            x(i, "rimg:load");
        });
      }
      function T(t) {
        var e = t.el,
          i = e.getAttribute("data-rimg");
        if ("loading" !== i && "loaded" !== i)
          if (t.isBackgroundImage || (0 !== e.naturalWidth && e.complete)) {
            if (!x(e, "rimg:loading")) {
              e.setAttribute("data-rimg", "loading");
              var n = (function (t) {
                for (
                  var e = { width: 0, height: 0 };
                  t &&
                  ((e.width = t.offsetWidth),
                  (e.height = t.offsetHeight),
                  !(e.width > 20 && e.height > 20));

                )
                  t = t.parentNode;
                return e;
              })(t.el);
              (n.width *= t.scale),
                (n.height *= t.scale),
                t.placeholder
                  ? (t.isBackgroundImage ||
                      (e.setAttribute(
                        "width",
                        Math.min(Math.floor(t.max.width / t.density), n.width)
                      ),
                      e.setAttribute(
                        "height",
                        Math.min(Math.floor(t.max.height / t.density), n.height)
                      )),
                    E(t, t.placeholder, !0, function () {
                      return A(t, n);
                    }))
                  : A(t, n);
            }
          } else
            e.addEventListener("load", function i() {
              e.removeEventListener("load", i), T(t);
            });
      }
      function L(t, e) {
        if (t) {
          x(t, "rimg:enter");
          var i = C(t, e);
          i.isImage &&
            (i.isBackgroundImage ||
              t.setAttribute(
                "data-rimg-template-svg",
                t.getAttribute("srcset")
              ),
            T(i));
        }
      }
      function D(t, e) {
        if (t) {
          x(t, "rimg:update");
          var i = C(t, e);
          i.isImage &&
            (i.isBackgroundImage ||
              (t.setAttribute("data-rimg", "lazy"),
              t.setAttribute(
                "srcset",
                t.getAttribute("data-rimg-template-svg")
              )),
            T(i));
        }
      }
      function I(t) {
        if (!t.offsetWidth || !t.offsetHeight || !t.getClientRects().length)
          return !1;
        var e = document.documentElement,
          i = Math.min(e.clientWidth, window.innerWidth),
          n = Math.min(e.clientHeight, window.innerHeight),
          s = t.getBoundingClientRect();
        return s.bottom >= 0 && s.right >= 0 && s.top <= n && s.left <= i;
      }
      function P() {
        var t =
            arguments.length > 0 && void 0 !== arguments[0]
              ? arguments[0]
              : '[data-rimg="lazy"]',
          e =
            arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
          i = new IntersectionObserver(
            function (t) {
              t.forEach(function (t) {
                (t.isIntersecting || t.intersectionRatio > 0) &&
                  (i.unobserve(t.target), L(t.target, e));
              });
            },
            { rootMargin: "20% 0px" }
          ),
          n = {
            track: function () {
              for (
                var t = M(
                    arguments.length > 0 && void 0 !== arguments[0]
                      ? arguments[0]
                      : '[data-rimg="lazy"]'
                  ),
                  n = 0;
                n < t.length;
                n++
              )
                I(t[n]) ? L(t[n], e) : i.observe(t[n]);
            },
            update: function () {
              for (
                var t = M(
                    arguments.length > 0 && void 0 !== arguments[0]
                      ? arguments[0]
                      : '[data-rimg="loaded"]'
                  ),
                  i = 0;
                i < t.length;
                i++
              )
                D(t[i], e);
            },
            untrack: function () {
              for (
                var t = M(
                    arguments.length > 0 && void 0 !== arguments[0]
                      ? arguments[0]
                      : "[data-rimg]"
                  ),
                  e = 0;
                e < t.length;
                e++
              )
                i.unobserve(t[e]);
            },
            load: function () {
              for (
                var t = M(
                    arguments.length > 0 && void 0 !== arguments[0]
                      ? arguments[0]
                      : "[data-rimg]"
                  ),
                  i = 0;
                i < t.length;
                i++
              )
                L(t[i], e);
            },
            unload: function () {
              i.disconnect();
            },
          };
        return n.track(t), n;
      }
      function M(t) {
        return "string" == typeof t
          ? document.querySelectorAll(t)
          : t instanceof HTMLElement
          ? [t]
          : t instanceof NodeList
          ? t
          : [];
      }
      Element.prototype.matches ||
        (Element.prototype.matches =
          Element.prototype.matchesSelector ||
          Element.prototype.mozMatchesSelector ||
          Element.prototype.msMatchesSelector ||
          Element.prototype.oMatchesSelector ||
          Element.prototype.webkitMatchesSelector ||
          function (t) {
            for (
              var e = (this.document || this.ownerDocument).querySelectorAll(t),
                i = e.length;
              --i >= 0 && e.item(i) !== this;

            );
            return i > -1;
          });
      var O = {
        init: function () {
          var t =
              arguments.length > 0 && void 0 !== arguments[0]
                ? arguments[0]
                : '[data-rimg="lazy"]',
            e =
              arguments.length > 1 && void 0 !== arguments[1]
                ? arguments[1]
                : {};
          (O.selector = t),
            (O.instance = P(t, e)),
            (O.loadedWidth = Math.max(
              document.documentElement.clientWidth,
              window.innerWidth || 0
            )),
            document.addEventListener("shopify:section:load", function (t) {
              return F(t.target);
            }),
            window.addEventListener("resize", function () {
              return (function () {
                var t = Math.max(
                  document.documentElement.clientWidth,
                  window.innerWidth || 0
                );
                if (t / O.loadedWidth > 0.5 && t / O.loadedWidth < 2) return;
                (O.loadedWidth = t), O.instance.update();
              })();
            }),
            document.addEventListener("shopify:section:unload", function (t) {
              return q(t.target);
            }),
            document.addEventListener("theme:rimg:watch", function (t) {
              return F(t.target);
            }),
            document.addEventListener("theme:rimg:unwatch", function (t) {
              return q(t.target);
            }),
            window.jQuery &&
              jQuery(document).on({
                "theme:rimg:watch": function (t) {
                  return F(t.target);
                },
                "theme:rimg:unwatch": function (t) {
                  return q(t.target);
                },
              });
        },
        watch: F,
        unwatch: q,
        load: function (t) {
          "function" == typeof t.matches &&
            t.matches(O.selector) &&
            O.instance.load(t);
          O.instance.load(t.querySelectorAll(O.selector));
        },
      };
      function F(t) {
        "function" == typeof t.matches &&
          t.matches(O.selector) &&
          O.instance.track(t),
          O.instance.track(t.querySelectorAll(O.selector));
      }
      function q(t) {
        O.instance.untrack(t.querySelectorAll(O.selector)),
          "function" == typeof t.matches &&
            t.matches(O.selector) &&
            O.instance.untrack(t);
      }
      const B = O;
      class N {
        constructor(t) {
          (this.callbacks = new WeakMap()),
            (this._observerCallback = this._observerCallback.bind(this)),
            (this.observer = new IntersectionObserver(this._observerCallback, {
              rootMargin: "30%",
              threshold: 0,
              ...t,
            }));
        }
        add(t, e) {
          this.callbacks.set(t, e), this.observer.observe(t);
        }
        remove(t) {
          this.observer.unobserve(t), this.callbacks.delete(t);
        }
        unload() {
          this.observer.disconnect();
        }
        _observerCallback(t, e) {
          t.forEach((t) => {
            let { isIntersecting: i, target: n } = t;
            if (!0 === i) {
              e.unobserve(n);
              const t = this.callbacks.get(n);
              "function" == typeof t && t(), this.callbacks.delete(n);
            }
          });
        }
      }
      class R {
        constructor() {
          (this.handlers = {}),
            (this.instances = {}),
            (this.options = {}),
            (this.imports = {}),
            (this.lazyLoader = null),
            (this._onSectionEvent = this._onSectionEvent.bind(this)),
            document.addEventListener(
              "shopify:section:load",
              this._onSectionEvent
            ),
            document.addEventListener(
              "shopify:section:unload",
              this._onSectionEvent
            ),
            document.addEventListener(
              "shopify:section:select",
              this._onSectionEvent
            ),
            document.addEventListener(
              "shopify:section:deselect",
              this._onSectionEvent
            ),
            document.addEventListener(
              "shopify:block:select",
              this._onSectionEvent
            ),
            document.addEventListener(
              "shopify:block:deselect",
              this._onSectionEvent
            );
        }
        unbind() {
          document.removeEventListener(
            "shopify:section:load",
            this._onSectionEvent
          ),
            document.removeEventListener(
              "shopify:section:unload",
              this._onSectionEvent
            ),
            document.removeEventListener(
              "shopify:section:select",
              this._onSectionEvent
            ),
            document.removeEventListener(
              "shopify:section:deselect",
              this._onSectionEvent
            ),
            document.removeEventListener(
              "shopify:block:select",
              this._onSectionEvent
            ),
            document.removeEventListener(
              "shopify:block:deselect",
              this._onSectionEvent
            );
          for (let t = 0; t < this.instances.length; t++)
            this._triggerInstanceEvent(this.instances[t], "onSectionUnload");
          (this.handlers = {}),
            (this.options = {}),
            this.lazyLoader.unload(),
            (this.lazyLoader = null),
            (this.instances = {});
        }
        register(t, e) {
          let i =
            arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
          this.handlers[t] &&
            console.warn(
              `Sections: section handler already exists of type '${t}'.`
            ),
            (this.handlers[t] = e),
            (this.options[t] = i),
            this._initSections(t);
        }
        _initSections(t) {
          const e = document.querySelectorAll(`[data-section-type="${t}"]`);
          if (e)
            for (let i = 0; i < e.length; i++) {
              const n = e[i].parentNode,
                s = n.querySelector("[data-section-id]");
              if (!s) {
                console.warn(
                  `Sections: unable to find section id for '${t}'.`,
                  n
                );
                continue;
              }
              const o = s.getAttribute("data-section-id");
              o
                ? this.options[t] && this.options[t].lazy
                  ? (null === this.lazyLoader && (this.lazyLoader = new N()),
                    this.lazyLoader.add(n, () => this._createInstance(o, n)))
                  : this._createInstance(o, n)
                : console.warn(
                    `Sections: unable to find section id for '${t}'.`,
                    n
                  );
            }
        }
        _onSectionEvent(t) {
          const e = t.target,
            { sectionId: i, blockId: n } = t.detail;
          let s = this.instances[i];
          switch (t.type) {
            case "shopify:section:load":
              (s = this._createInstance(i, e)),
                this._triggerInstanceEvent(s, "onSectionLoad", {
                  el: e,
                  id: i,
                });
              break;
            case "shopify:section:unload":
              this._triggerInstanceEvent(s, "onSectionUnload", {
                el: e,
                id: i,
              }),
                this.lazyLoader && this.lazyLoader.remove(e),
                delete this.instances[i];
              break;
            case "shopify:section:select":
              this._triggerInstanceEvent(s, "onSectionSelect", {
                el: e,
                id: i,
              });
              break;
            case "shopify:section:deselect":
              this._triggerInstanceEvent(s, "onSectionDeselect", {
                el: e,
                id: i,
              });
              break;
            case "shopify:block:select":
              this._triggerInstanceEvent(s, "onSectionBlockSelect", {
                el: e,
                id: n,
              });
              break;
            case "shopify:block:deselect":
              this._triggerInstanceEvent(s, "onSectionBlockDeselect", {
                el: e,
                id: n,
              });
          }
        }
        _triggerInstanceEvent(t, e) {
          if (t && t[e]) {
            for (
              var i = arguments.length, n = new Array(i > 2 ? i - 2 : 0), s = 2;
              s < i;
              s++
            )
              n[s - 2] = arguments[s];
            t[e](...n);
          }
        }
        _postMessage(t, e) {
          Object.keys(this.instances).forEach((i) => {
            this._triggerInstanceEvent(
              this.instances[i],
              "onSectionMessage",
              t,
              e
            );
          });
        }
        _createInstance(t, e) {
          const i = e.querySelector("[data-section-type]");
          if (!i) return;
          const n = i.getAttribute("data-section-type");
          if (!n) return;
          const s = this.handlers[n];
          if (!s)
            return void console.warn(
              `Sections: unable to find section handler for type '${n}'.`
            );
          const o = this._loadData(e),
            r = this._postMessage.bind(this),
            a = { id: t, type: n, el: e, data: o, postMessage: r };
          if (this.imports[n]) this.instances[t] = this.imports[n](a);
          else {
            const e = s(a);
            e instanceof Promise
              ? e.then((e) => {
                  let { default: i } = e;
                  (this.imports[n] = () => new i(a)),
                    (this.instances[t] = new i(a));
                })
              : ((this.imports[n] = s), (this.instances[t] = e));
          }
          return this.instances[t];
        }
        _loadData(t) {
          const e = t.querySelector("[data-section-data]");
          if (!e) return {};
          const i = e.getAttribute("data-section-data") || e.innerHTML;
          try {
            return JSON.parse(i);
          } catch (t) {
            return (
              console.warn(
                `Sections: invalid section data found. ${t.message}`
              ),
              {}
            );
          }
        }
      }
      const z = [];
      ("IntersectionObserver" in window &&
        "IntersectionObserverEntry" in window &&
        "intersectionRatio" in window.IntersectionObserverEntry.prototype) ||
        z.push(document.querySelector("[data-scripts]").dataset.pxuPolyfills),
        window.NodeList &&
          !NodeList.prototype.forEach &&
          (NodeList.prototype.forEach = Array.prototype.forEach),
        Element.prototype.closest ||
          (Element.prototype.closest = function (t) {
            var e = this;
            do {
              if (Element.prototype.matches.call(e, t)) return e;
              e = e.parentElement || e.parentNode;
            } while (null !== e && 1 === e.nodeType);
            return null;
          });
      const H = z;
      class U {
        constructor(t) {
          window.Shopify &&
            window.Shopify.designMode &&
            t.postMessage("announcement:load");
        }
      }
      var j = i(729),
        W = i.n(j),
        V = i(414),
        G = i.n(V);
      class X {
        constructor(t) {
          (this.$el = $(t)),
            this._initExternalLinks(),
            (this.groupedContent = null),
            this.$el.length &&
              ((this.groupedContent = new (G())(this.$el.get(0), {
                layout: "tabs",
                intelliparse: !1,
              })),
              W()(".rte"));
        }
        unload() {
          this.groupedContent && this.groupedContent.unload();
        }
        _initExternalLinks() {
          const t = this.$el
            .find('a[href^="http"]')
            .filter((t, e) => -1 === e.href.indexOf(location.hostname));
          t.attr("target", "_blank");
        }
      }
      class Z {
        constructor(t) {
          let i =
            arguments.length > 1 && void 0 !== arguments[1]
              ? arguments[1]
              : ".form-field-input";
          (this.$el = e()(t)),
            (this.filledClass = "form-field-filled"),
            (this.fieldSelector = i),
            (this._toggleFilled = this._toggleFilled.bind(this)),
            this.$el.on("focus.forms", this.fieldSelector, this._toggleFilled),
            this.$el.on("blur.forms", this.fieldSelector, this._toggleFilled),
            this._checkFilled();
        }
        unload() {
          this.$el.off(".forms");
        }
        _checkFilled() {
          this.$el.find(this.fieldSelector).each((t, i) => {
            e()(i).hasClass(this.filledClass) || this._toggleFilled(null, i);
          });
        }
        _toggleFilled() {
          let t =
              arguments.length > 0 && void 0 !== arguments[0]
                ? arguments[0]
                : null,
            i = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
          const n = t ? t.currentTarget : i,
            s = e()(n),
            { value: o } = n;
          let r = o.length > 0;
          try {
            (r = r || s.is(":-webkit-autofill")),
              s.toggleClass(this.filledClass, r);
          } catch (t) {
            s.toggleClass(this.filledClass, r);
          }
        }
      }
      class Q {
        constructor(t) {
          (this.$el = e()(t.el)),
            (this.$commentForm = this.$el.find("[data-articlecomments-form]")),
            (this.richText = new X(this.$el)),
            this.$commentForm.length &&
              (this.commentForm = new Z(this.$commentForm));
        }
        onSectionUnload() {
          this.richText.unload(), this.commentForm && this.commentForm.unload();
        }
      }
      class Y {
        constructor(t) {
          (this.$el = e()(t.el)), (this.richText = new X(this.$el));
        }
        onSectionUnload() {
          this.richText.unload();
        }
      }
      var K,
        J = i(405),
        tt = i.n(J);
      var et = "http://www.w3.org/1999/xhtml",
        it = "undefined" == typeof document ? void 0 : document,
        nt = !!it && "content" in it.createElement("template"),
        st =
          !!it &&
          it.createRange &&
          "createContextualFragment" in it.createRange();
      function ot(t) {
        return (
          (t = t.trim()),
          nt
            ? (function (t) {
                var e = it.createElement("template");
                return (e.innerHTML = t), e.content.childNodes[0];
              })(t)
            : st
            ? (function (t) {
                return (
                  K || (K = it.createRange()).selectNode(it.body),
                  K.createContextualFragment(t).childNodes[0]
                );
              })(t)
            : (function (t) {
                var e = it.createElement("body");
                return (e.innerHTML = t), e.childNodes[0];
              })(t)
        );
      }
      function rt(t, e) {
        var i,
          n,
          s = t.nodeName,
          o = e.nodeName;
        return (
          s === o ||
          ((i = s.charCodeAt(0)),
          (n = o.charCodeAt(0)),
          i <= 90 && n >= 97
            ? s === o.toUpperCase()
            : n <= 90 && i >= 97 && o === s.toUpperCase())
        );
      }
      function at(t, e, i) {
        t[i] !== e[i] &&
          ((t[i] = e[i]), t[i] ? t.setAttribute(i, "") : t.removeAttribute(i));
      }
      var lt = {
        OPTION: function (t, e) {
          var i = t.parentNode;
          if (i) {
            var n = i.nodeName.toUpperCase();
            "OPTGROUP" === n &&
              (n = (i = i.parentNode) && i.nodeName.toUpperCase()),
              "SELECT" !== n ||
                i.hasAttribute("multiple") ||
                (t.hasAttribute("selected") &&
                  !e.selected &&
                  (t.setAttribute("selected", "selected"),
                  t.removeAttribute("selected")),
                (i.selectedIndex = -1));
          }
          at(t, e, "selected");
        },
        INPUT: function (t, e) {
          at(t, e, "checked"),
            at(t, e, "disabled"),
            t.value !== e.value && (t.value = e.value),
            e.hasAttribute("value") || t.removeAttribute("value");
        },
        TEXTAREA: function (t, e) {
          var i = e.value;
          t.value !== i && (t.value = i);
          var n = t.firstChild;
          if (n) {
            var s = n.nodeValue;
            if (s == i || (!i && s == t.placeholder)) return;
            n.nodeValue = i;
          }
        },
        SELECT: function (t, e) {
          if (!e.hasAttribute("multiple")) {
            for (var i, n, s = -1, o = 0, r = t.firstChild; r; )
              if ("OPTGROUP" === (n = r.nodeName && r.nodeName.toUpperCase()))
                r = (i = r).firstChild;
              else {
                if ("OPTION" === n) {
                  if (r.hasAttribute("selected")) {
                    s = o;
                    break;
                  }
                  o++;
                }
                !(r = r.nextSibling) && i && ((r = i.nextSibling), (i = null));
              }
            t.selectedIndex = s;
          }
        },
      };
      function ct() {}
      function ht(t) {
        if (t) return (t.getAttribute && t.getAttribute("id")) || t.id;
      }
      var dt = (function (t) {
        return function (e, i, n) {
          if ((n || (n = {}), "string" == typeof i))
            if (
              "#document" === e.nodeName ||
              "HTML" === e.nodeName ||
              "BODY" === e.nodeName
            ) {
              var s = i;
              (i = it.createElement("html")).innerHTML = s;
            } else i = ot(i);
          var o = n.getNodeKey || ht,
            r = n.onBeforeNodeAdded || ct,
            a = n.onNodeAdded || ct,
            l = n.onBeforeElUpdated || ct,
            c = n.onElUpdated || ct,
            h = n.onBeforeNodeDiscarded || ct,
            d = n.onNodeDiscarded || ct,
            u = n.onBeforeElChildrenUpdated || ct,
            p = !0 === n.childrenOnly,
            f = Object.create(null),
            m = [];
          function g(t) {
            m.push(t);
          }
          function v(t, e) {
            if (1 === t.nodeType)
              for (var i = t.firstChild; i; ) {
                var n = void 0;
                e && (n = o(i)) ? g(n) : (d(i), i.firstChild && v(i, e)),
                  (i = i.nextSibling);
              }
          }
          function y(t, e, i) {
            !1 !== h(t) && (e && e.removeChild(t), d(t), v(t, i));
          }
          function b(t) {
            a(t);
            for (var e = t.firstChild; e; ) {
              var i = e.nextSibling,
                n = o(e);
              if (n) {
                var s = f[n];
                s && rt(e, s)
                  ? (e.parentNode.replaceChild(s, e), w(s, e))
                  : b(e);
              } else b(e);
              e = i;
            }
          }
          function w(e, i, n) {
            var s = o(i);
            if ((s && delete f[s], !n)) {
              if (!1 === l(e, i)) return;
              if ((t(e, i), c(e), !1 === u(e, i))) return;
            }
            "TEXTAREA" !== e.nodeName
              ? (function (t, e) {
                  var i,
                    n,
                    s,
                    a,
                    l,
                    c = e.firstChild,
                    h = t.firstChild;
                  t: for (; c; ) {
                    for (a = c.nextSibling, i = o(c); h; ) {
                      if (
                        ((s = h.nextSibling), c.isSameNode && c.isSameNode(h))
                      ) {
                        (c = a), (h = s);
                        continue t;
                      }
                      n = o(h);
                      var d = h.nodeType,
                        u = void 0;
                      if (
                        (d === c.nodeType &&
                          (1 === d
                            ? (i
                                ? i !== n &&
                                  ((l = f[i])
                                    ? s === l
                                      ? (u = !1)
                                      : (t.insertBefore(l, h),
                                        n ? g(n) : y(h, t, !0),
                                        (h = l))
                                    : (u = !1))
                                : n && (u = !1),
                              (u = !1 !== u && rt(h, c)) && w(h, c))
                            : (3 !== d && 8 != d) ||
                              ((u = !0),
                              h.nodeValue !== c.nodeValue &&
                                (h.nodeValue = c.nodeValue))),
                        u)
                      ) {
                        (c = a), (h = s);
                        continue t;
                      }
                      n ? g(n) : y(h, t, !0), (h = s);
                    }
                    if (i && (l = f[i]) && rt(l, c)) t.appendChild(l), w(l, c);
                    else {
                      var p = r(c);
                      !1 !== p &&
                        (p && (c = p),
                        c.actualize && (c = c.actualize(t.ownerDocument || it)),
                        t.appendChild(c),
                        b(c));
                    }
                    (c = a), (h = s);
                  }
                  !(function (t, e, i) {
                    for (; e; ) {
                      var n = e.nextSibling;
                      (i = o(e)) ? g(i) : y(e, t, !0), (e = n);
                    }
                  })(t, h, n);
                  var m = lt[t.nodeName];
                  m && m(t, e);
                })(e, i)
              : lt.TEXTAREA(e, i);
          }
          !(function t(e) {
            if (1 === e.nodeType || 11 === e.nodeType)
              for (var i = e.firstChild; i; ) {
                var n = o(i);
                n && (f[n] = i), t(i), (i = i.nextSibling);
              }
          })(e);
          var _,
            S,
            C = e,
            k = C.nodeType,
            x = i.nodeType;
          if (!p)
            if (1 === k)
              1 === x
                ? rt(e, i) ||
                  (d(e),
                  (C = (function (t, e) {
                    for (var i = t.firstChild; i; ) {
                      var n = i.nextSibling;
                      e.appendChild(i), (i = n);
                    }
                    return e;
                  })(
                    e,
                    ((_ = i.nodeName),
                    (S = i.namespaceURI) && S !== et
                      ? it.createElementNS(S, _)
                      : it.createElement(_))
                  )))
                : (C = i);
            else if (3 === k || 8 === k) {
              if (x === k)
                return (
                  C.nodeValue !== i.nodeValue && (C.nodeValue = i.nodeValue), C
                );
              C = i;
            }
          if (C === i) d(e);
          else {
            if (i.isSameNode && i.isSameNode(C)) return;
            if ((w(C, i, p), m))
              for (var E = 0, A = m.length; E < A; E++) {
                var T = f[m[E]];
                T && y(T, T.parentNode, !1);
              }
          }
          return (
            !p &&
              C !== e &&
              e.parentNode &&
              (C.actualize && (C = C.actualize(e.ownerDocument || it)),
              e.parentNode.replaceChild(C, e)),
            C
          );
        };
      })(function (t, e) {
        var i,
          n,
          s,
          o,
          r = e.attributes;
        if (11 !== e.nodeType && 11 !== t.nodeType) {
          for (var a = r.length - 1; a >= 0; a--)
            (n = (i = r[a]).name),
              (s = i.namespaceURI),
              (o = i.value),
              s
                ? ((n = i.localName || n),
                  t.getAttributeNS(s, n) !== o &&
                    ("xmlns" === i.prefix && (n = i.name),
                    t.setAttributeNS(s, n, o)))
                : t.getAttribute(n) !== o && t.setAttribute(n, o);
          for (var l = t.attributes, c = l.length - 1; c >= 0; c--)
            (n = (i = l[c]).name),
              (s = i.namespaceURI)
                ? ((n = i.localName || n),
                  e.hasAttributeNS(s, n) || t.removeAttributeNS(s, n))
                : e.hasAttribute(n) || t.removeAttribute(n);
        }
      });
      const ut = dt;
      function pt(t) {
        if ("string" != typeof t) throw new TypeError(t + " is not a string.");
        this.countryOptions = t;
      }
      function ft(t, e) {
        return t.querySelector('option[value="' + e + '"]');
      }
      function mt(t, e, i) {
        var n = ft(t, i),
          s = JSON.parse(n.getAttribute("data-provinces"));
        return (
          (e.options.length = 0),
          s.length &&
            (function (t, e) {
              var i = t.getAttribute("data-default");
              e.forEach(function (e) {
                var i = document.createElement("option");
                (i.value = e[0]), (i.textContent = e[1]), t.appendChild(i);
              }),
                i && ft(t, i) && (t.value = i);
            })(e, s),
          s
        );
      }
      function gt(t, e) {
        for (var i = 0; i < e.length; i++) {
          var n = e[i];
          (n.enumerable = n.enumerable || !1),
            (n.configurable = !0),
            "value" in n && (n.writable = !0),
            Object.defineProperty(t, n.key, n);
        }
      }
      function vt(t, e, i) {
        return (
          e in t
            ? Object.defineProperty(t, e, {
                value: i,
                enumerable: !0,
                configurable: !0,
                writable: !0,
              })
            : (t[e] = i),
          t
        );
      }
      function yt(t, e) {
        var i = Object.keys(t);
        if (Object.getOwnPropertySymbols) {
          var n = Object.getOwnPropertySymbols(t);
          e &&
            (n = n.filter(function (e) {
              return Object.getOwnPropertyDescriptor(t, e).enumerable;
            })),
            i.push.apply(i, n);
        }
        return i;
      }
      function bt(t) {
        for (var e = 1; e < arguments.length; e++) {
          var i = null != arguments[e] ? arguments[e] : {};
          e % 2
            ? yt(Object(i), !0).forEach(function (e) {
                vt(t, e, i[e]);
              })
            : Object.getOwnPropertyDescriptors
            ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(i))
            : yt(Object(i)).forEach(function (e) {
                Object.defineProperty(
                  t,
                  e,
                  Object.getOwnPropertyDescriptor(i, e)
                );
              });
        }
        return t;
      }
      function wt(t, e) {
        return (
          (function (t) {
            if (Array.isArray(t)) return t;
          })(t) ||
          (function (t, e) {
            if ("undefined" == typeof Symbol || !(Symbol.iterator in Object(t)))
              return;
            var i = [],
              n = !0,
              s = !1,
              o = void 0;
            try {
              for (
                var r, a = t[Symbol.iterator]();
                !(n = (r = a.next()).done) &&
                (i.push(r.value), !e || i.length !== e);
                n = !0
              );
            } catch (t) {
              (s = !0), (o = t);
            } finally {
              try {
                n || null == a.return || a.return();
              } finally {
                if (s) throw o;
              }
            }
            return i;
          })(t, e) ||
          (function (t, e) {
            if (!t) return;
            if ("string" == typeof t) return _t(t, e);
            var i = Object.prototype.toString.call(t).slice(8, -1);
            "Object" === i && t.constructor && (i = t.constructor.name);
            if ("Map" === i || "Set" === i) return Array.from(i);
            if (
              "Arguments" === i ||
              /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(i)
            )
              return _t(t, e);
          })(t, e) ||
          (function () {
            throw new TypeError(
              "Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."
            );
          })()
        );
      }
      function _t(t, e) {
        (null == e || e > t.length) && (e = t.length);
        for (var i = 0, n = new Array(e); i < e; i++) n[i] = t[i];
        return n;
      }
      pt.prototype.build = function (t, e, i) {
        if ("object" != typeof t) throw new TypeError(t + " is not a object.");
        if ("object" != typeof e) throw new TypeError(e + " is not a object.");
        var n = t.getAttribute("data-default");
        if (
          ((i = i || {}),
          (t.innerHTML = this.countryOptions),
          (t.value = n),
          n && ft(t, n))
        ) {
          var s = mt(t, e, n);
          i.onCountryChange && i.onCountryChange(s, e, t);
        }
        t.addEventListener("change", function (n) {
          var s = n.target,
            o = s.value,
            r = mt(s, e, o);
          i.onCountryChange && i.onCountryChange(r, e, t);
        }),
          i.onProvinceChange &&
            e.addEventListener("change", i.onProvinceChange);
      };
      var St = {},
        Ct = (function () {
          function t() {
            !(
              /*!
               * @pixelunion/shopify-asyncview v3.0.0
               * (c) 2020 Pixel Union
               */
              (function (t, e) {
                if (!(t instanceof e))
                  throw new TypeError("Cannot call a class as a function");
              })(this, t)
            );
          }
          var e, i, n;
          return (
            (e = t),
            (n = [
              {
                key: "load",
                value: function (t, e) {
                  var i =
                      arguments.length > 2 && void 0 !== arguments[2]
                        ? arguments[2]
                        : {},
                    n = t.replace(/\?[^#]+/, ""),
                    s = new RegExp(/.+\?([^#]+)/).exec(t),
                    o = { section_id: e };
                  "query" in i && (o = bt({}, o, {}, i.query)),
                    s &&
                      s.length >= 2 &&
                      s[1].split("&").forEach(function (t) {
                        var e = wt(t.split("="), 2),
                          i = e[0],
                          n = e[1];
                        o[i] = n;
                      });
                  var r = bt({}, o, { _: new Date().getTime() }),
                    a = n.replace(/([^#]+)(.*)/, function (t, e, i) {
                      return ""
                        .concat(e, "?")
                        .concat(
                          Object.keys(o)
                            .sort()
                            .map(function (t) {
                              return ""
                                .concat(t, "=")
                                .concat(encodeURIComponent(o[t]));
                            })
                            .join("&")
                        )
                        .concat(i);
                    }),
                    l = n.replace(/([^#]+)(.*)/, function (t, e, i) {
                      return ""
                        .concat(e, "?")
                        .concat(
                          Object.keys(r)
                            .sort()
                            .map(function (t) {
                              return ""
                                .concat(t, "=")
                                .concat(encodeURIComponent(r[t]));
                            })
                            .join("&")
                        )
                        .concat(i);
                    }),
                    c = new Promise(function (t, e) {
                      var n;
                      if (a in St) t(St[a]);
                      else {
                        if (
                          ((St[a] = c),
                          i.hash && (n = sessionStorage.getItem(a)))
                        ) {
                          var s = JSON.parse(n);
                          if (i.hash === s.options.hash)
                            return delete St[a], void t(s);
                        }
                        var o = new XMLHttpRequest();
                        o.open("GET", l, !0),
                          (o.onload = function () {
                            var e = o.response,
                              n = {},
                              s = e.querySelector("[data-options]");
                            s &&
                              s.innerHTML &&
                              (n = JSON.parse(
                                e.querySelector("[data-options]").innerHTML
                              ));
                            var r = e.querySelectorAll("[data-html]"),
                              l = {};
                            if (
                              1 === r.length &&
                              "" === r[0].getAttribute("data-html")
                            )
                              l = r[0].innerHTML;
                            else
                              for (var c = 0; c < r.length; c++)
                                l[r[c].getAttribute("data-html")] =
                                  r[c].innerHTML;
                            var h = e.querySelectorAll("[data-data]"),
                              d = {};
                            if (
                              1 === h.length &&
                              "" === h[0].getAttribute("data-data")
                            )
                              d = JSON.parse(h[0].innerHTML);
                            else
                              for (var u = 0; u < h.length; u++)
                                d[h[u].getAttribute("data-data")] = JSON.parse(
                                  h[u].innerHTML
                                );
                            if (i.hash)
                              try {
                                sessionStorage.setItem(
                                  a,
                                  JSON.stringify({
                                    options: n,
                                    data: d,
                                    html: l,
                                  })
                                );
                              } catch (t) {
                                console.error(t);
                              }
                            delete St[a], t({ data: d, html: l });
                          }),
                          (o.onerror = function () {
                            delete St[a], e();
                          }),
                          (o.responseType = "document"),
                          o.send();
                      }
                    });
                  return c;
                },
              },
            ]),
            (i = null) && gt(e.prototype, i),
            n && gt(e, n),
            t
          );
        })();
      const kt = Ct;
      var xt = i(766);
      class Et {
        constructor(t) {
          let { quantityField: e, onChange: i } = t;
          (this.events = new xt.Z()),
            (this.field = e),
            (this.input = this.field.querySelector("[data-quantity-input]")),
            (this.plus = this.field.querySelector("[data-quantity-plus]")),
            (this.minus = this.field.querySelector("[data-quantity-minus]")),
            (this.minusButtonWrapper = this.field.querySelector(
              "[data-button-wrapper-minus]"
            )),
            (this.incrementValue = parseInt(
              this.input.dataset.incrementValue,
              10
            )),
            (this.increaseAmount = this.increaseAmount.bind(this)),
            (this.decreaseAmount = this.decreaseAmount.bind(this)),
            (this.onChange = i ? tt()(i, 50) : () => {}),
            this.registerEvents();
        }
        registerEvents() {
          (this.increaseAmountClickEvent = this.events.register(
            this.plus,
            "click",
            (t) => this.increaseAmount(t)
          )),
            (this.decreaseAmountClickEvent = this.events.register(
              this.minus,
              "click",
              (t) => this.decreaseAmount(t)
            )),
            (this.setAmountChangeEvent = this.events.register(
              this.input,
              "change",
              (t) => this.setAmount(t)
            )),
            (this.quantityKeyUpEvent = this.events.register(
              this.input,
              "keyup",
              (t) => this.quantityKeyUp(t)
            )),
            (this.quantityKeyDownEvent = this.events.register(
              this.input,
              "keydown",
              (t) => this.quantityKeyDown(t)
            )),
            this._updateMinusButton();
        }
        setAmount(t) {
          t.preventDefault();
          this._getCount() || (this.input.value = this.incrementValue),
            this._updateMinusButton(),
            this.onChange(t.currentTarget);
        }
        _getCount() {
          return this.input.valueAsNumber;
        }
        increaseAmount(t) {
          t.preventDefault();
          const e = this._getCount();
          (this.input.value = e + this.incrementValue),
            this._updateMinusButton(),
            this.onChange(t.currentTarget);
        }
        decreaseAmount(t) {
          t.preventDefault();
          const e = this._getCount();
          (this.input.value = e - this.incrementValue),
            this._updateMinusButton(),
            this.onChange(t.currentTarget);
        }
        quantityKeyUp(t) {
          "Backspace" !== t.key &&
            (this._updateMinusButton(), this.onChange(t.currentTarget));
        }
        quantityKeyDown(t) {
          "Enter" === t.key && t.preventDefault();
        }
        _updateMinusButton() {
          this._getCount() <= this.incrementValue
            ? this.minusButtonWrapper.classList.add(
                "quantity-selector__button-wrapper--disabled"
              )
            : this.minusButtonWrapper.classList.remove(
                "quantity-selector__button-wrapper--disabled"
              );
        }
        unload() {
          this.events.unregisterAll();
        }
      }
      class At {
        constructor(t) {
          (this.settings = t.data.settings),
            (this.shipping = t.data.shipping),
            (this.updateTimeout = null),
            (this.$window = e()(window)),
            (this.$el = e()(t.el)),
            (this.el = t.el),
            (this.events = new xt.Z()),
            (this.totals = this.el.querySelectorAll("[data-cart-total]")),
            (this.$shipping = this.$el.find("[data-cartshipping]")),
            (this.$cartSidebar = this.$el.find("[data-cart-sidebar]")),
            (this.quantitySelectors = []),
            (this.inputFields = this.el.querySelectorAll(
              "[data-quantity-input]"
            )),
            (this.$titleTotalSmall = this.$el.find(".cart-title-total--small")),
            (this.$titleTotalLarge = this.$el.find(".cart-title-total--large")),
            (this.$titleTotalContents = this.$el.find(
              "[data-cart-title-total]"
            )),
            (this.cartItemList = this.$el[0].querySelector(
              "[data-cart-item-list]"
            )),
            (this.cartDiscounts = this.$el[0].querySelector(
              "[data-cart-discounts]"
            )),
            (this.$shippingToggle = this.$el.find(
              "[data-cartshipping-toggle]"
            )),
            (this.$shippingResponse = this.$shipping.find(
              "[data-cartshipping-response]"
            )),
            (this.$shippingResponseMessage = this.$shippingResponse.find(
              "[data-cartshipping-message]"
            )),
            (this.$shippingResponseRates = this.$shippingResponse.find(
              "[data-cartshipping-rates]"
            )),
            (this.$shippingSubmit = this.$shipping.find(
              "[data-cartshipping-submit]"
            )),
            this._moveTitleTotal();
          const i = e()("[data-scripts]");
          (this._editItemQuantity = this._editItemQuantity.bind(this)),
            this.inputFields.forEach((t) => {
              this.quantitySelectors.push(
                new Et({
                  quantityField: t.parentNode,
                  onChange: this._editItemQuantity,
                })
              );
            }),
            s()(i.data("shopify-api-url"), () => {
              this._bindEvents(),
                (window.Shopify.onError = this._handleErrors.bind(this));
            }),
            (this.forms = new Z(this.$el)),
            this.settings.shipping &&
              this.$shipping.length &&
              s()(i.data("shopify-countries"), () => {
                s()(i.data("shopify-common"), () => {
                  this._initShippingCalc();
                });
              }),
            this.$cartSidebar.length && new X(this.$cartSidebar);
        }
        onSectionUnload() {
          this.$el.off(".cart-page"),
            this.$window.off(".cart-page"),
            this.forms.unload();
        }
        _bindEvents() {
          this.$el.on("click.cart-page", "[data-cartitem-remove]", (t) => {
            t.preventDefault(), this._editItemQuantity(t.currentTarget, !0);
          }),
            this.$window.on(
              "resize.cart-page",
              tt()(() => this._moveTitleTotal(), 20)
            );
        }
        _getItemQuantity(t) {
          return parseInt(
            this.el.querySelector(
              `[data-cartitem-key="${t}"] [data-quantity-input]`
            ).value,
            10
          );
        }
        _moveTitleTotal() {
          if (this.$titleTotalContents.length)
            if (this.$window.outerWidth() >= 480) {
              if (
                !e().contains(
                  this.$titleTotalLarge[0],
                  this.$titleTotalContents[0]
                )
              ) {
                const t = this.$titleTotalContents.detach();
                this.$titleTotalLarge.append(t);
              }
            } else if (
              !e().contains(
                this.$titleTotalSmall[0],
                this.$titleTotalContents[0]
              )
            ) {
              const t = this.$titleTotalContents.detach();
              this.$titleTotalSmall.append(t);
            }
        }
        _editItemQuantity(t) {
          let i =
            arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
          const n = e()(t).closest("[data-cartitem-id]")[0];
          i && n.classList.add("removing");
          const s = i
              ? 0
              : parseInt(n.querySelector("[data-quantity-input]").value, 10),
            o = n.getAttribute("data-cartitem-key");
          this._updateCart(o, s);
        }
        _updateCart(t, e) {
          null !== this.updateTimeout && clearTimeout(this.updateTimeout),
            (this.updateTimeout = setTimeout(() => {
              if (e > 0 && this._getItemQuantity(t) !== e)
                return void (this.updateTimeout = null);
              const i = this.updateTimeout;
              window.Shopify.changeItem(t, e, (t) => {
                this.updateTimeout === i && this._didUpdate(t, i);
              });
            }, 300));
        }
        _didUpdate(t, e) {
          t.items.length
            ? kt
                .load(window.Theme.routes.cart_url, "cart-ajax", {
                  view: "_ajax",
                })
                .then((i) => {
                  let { html: n } = i;
                  if (this.updateTimeout !== e) return;
                  const s = new CustomEvent("cartcount:update", { detail: t });
                  window.dispatchEvent(s),
                    this.quantitySelectors.forEach((t) => {
                      t.unload();
                    });
                  const o = document.createElement("div");
                  (o.innerHTML = n.list),
                    ut(this.cartItemList, o.querySelector("ul"), {
                      onBeforeElUpdated: (t, e) =>
                        "IMG" !== t.tagName || t.src !== e.src,
                    }),
                    this.totals.forEach((t) => {
                      const e = t;
                      (e.innerHTML = n.cart_total),
                        ut(t, e, { childrenOnly: !0 });
                    }),
                    B.watch(this.cartItemList),
                    this.forms.unload(),
                    (this.forms = new Z(this.$el)),
                    this.inputFields.forEach((t) => {
                      this.quantitySelectors.push(
                        new Et({
                          quantityField: t.parentNode,
                          onChange: this._editItemQuantity,
                        })
                      );
                    }),
                    this.$el.off("click.cart-page", "[data-cartitem-remove]"),
                    this.$el.on(
                      "click.cart-page",
                      "[data-cartitem-remove]",
                      (t) => {
                        t.preventDefault(),
                          this._editItemQuantity(t.currentTarget, !0);
                      }
                    ),
                    (this.cartDiscounts.innerHTML = n.discounts);
                })
                .catch(() => window.location.reload())
            : (window.location = window.Theme.routes.cart_url);
        }
        _handleErrors() {
          let t =
            arguments.length > 0 && void 0 !== arguments[0]
              ? arguments[0]
              : null;
          if (!t) return;
          const e = { message: this.shipping.error_general };
          t.zip &&
            t.zip.length > 0 &&
            ((-1 === t.zip[0].indexOf("is not valid") &&
              -1 === t.zip[0].indexOf("can't be blank")) ||
              (e.message = `${this.shipping.zip} ${t.zip}`)),
            t.error &&
              t.error.length > 0 &&
              -1 !== t.error[0].indexOf("shipment_too_heavy") &&
              (e.message = this.shipping.shipment_too_heavy),
            this._handleShippingResponse(e);
        }
        _initShippingCalc() {
          this._bindShippingCalcEvents();
          const t = document.getElementById("address_country"),
            e = document.getElementById("address_province"),
            i = document.getElementById("address_province_container");
          (this.shippingCountryProvinceSelector = new pt(t.innerHTML)),
            this.shippingCountryProvinceSelector.build(t, e, {
              onCountryChange: (e) => {
                e.length
                  ? (i.style.display = "block")
                  : (i.style.display = "none");
                const { label: n, zip_label: s } = window.Countries[t.value];
                (i.querySelector('label[for="address_province"]').innerHTML =
                  n),
                  (this.el.querySelector(
                    '#address_zip ~ label[for="address_zip"]'
                  ).innerHTML = s);
              },
            });
        }
        _bindShippingCalcEvents() {
          this.$el.on("click.cart-page", "[data-cartshipping-toggle]", () => {
            this._toggleShippingCalc();
          }),
            this.$el.on("click.cart-page", "[data-cartshipping-submit]", () => {
              this._getShippingRates();
            }),
            this.$el.on("keypress.cart-page", "#address_zip", (t) => {
              (10 !== t.keyCode && 13 !== t.keyCode) ||
                (t.preventDefault(), this.$shippingSubmit.trigger("click"));
            });
        }
        _toggleShippingCalc() {
          const t = this.$shippingToggle.text(),
            e = this.$shippingToggle.data("cartshipping-toggle");
          this.$shippingToggle.html(e).data("cartshipping-toggle", t),
            this.$shipping.toggleClass("open");
        }
        _getShippingRates() {
          this._disableShippingButton();
          const t = {};
          (t.country = e()("#address_country").val() || ""),
            (t.province = e()("#address_province").val() || ""),
            (t.zip = e()("#address_zip").val() || "");
          const i = Object.keys(t)
            .map(
              (e) =>
                `${encodeURIComponent(
                  `shipping_address[${e}]`
                )}=${encodeURIComponent(t[e])}`
            )
            .join("&");
          e()
            .ajax(`${window.Theme.routes.cart_url}/shipping_rates.json?${i}`, {
              dataType: "json",
            })
            .fail((t) => this._handleErrors(t.responseJSON || {}))
            .done((e) => {
              const i = e.shipping_rates,
                n = [];
              t.zip.length && n.push(t.zip.trim()),
                t.province.length && n.push(t.province),
                t.country.length && n.push(t.country);
              const s = n.join(", ");
              let o = "";
              if (i.length > 1) {
                const t = window.Shopify.formatMoney(
                  i[0].price,
                  this.settings.money_format
                );
                o = this.shipping.multiple_rates
                  .replace("*address*", s)
                  .replace("*number_of_rates*", i.length)
                  .replace("*rate*", `<span class="money">${t}</span>`);
              } else
                o =
                  1 === i.length
                    ? this.shipping.one_rate.replace("*address*", s)
                    : this.shipping.no_rates;
              const r = i.map((t) => {
                const e = window.Shopify.formatMoney(
                  t.price,
                  this.settings.money_format
                );
                return `<li>${this.shipping.rate_value
                  .replace("*rate_title*", t.name)
                  .replace("*rate*", `<span class="money">${e}</span>`)}</li>`;
              });
              this._handleShippingResponse({ message: o, rates: r });
            });
        }
        _enableShippingButton() {
          this.$shippingSubmit
            .html(this.shipping.calculate_shipping)
            .attr("disabled", !1);
        }
        _disableShippingButton() {
          this.$shippingSubmit
            .html(this.shipping.calculating)
            .attr("disabled", !0);
        }
        _showShippingResponse() {
          this.$shippingResponse.addClass("visible");
        }
        _hideShippingResponse() {
          this.$shippingResponse.removeClass("visible");
        }
        _handleShippingResponse() {
          let t =
            arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
          this._hideShippingResponse();
          const e = t.message || null,
            i = t.rates || null;
          this.$shippingResponseMessage.empty(),
            this.$shippingResponseRates.empty(),
            e && this.$shippingResponseMessage.html(e),
            i && this.$shippingResponseRates.html(i),
            this._enableShippingButton(),
            (e || i) && this._showShippingResponse();
        }
      }
      /*!
       * @pixelunion/animations v0.1.0
       * (c) 2019 Pixel Union
       * Released under the UNLICENSED license.
       */
      function Tt(t, e) {
        if (!(t instanceof e))
          throw new TypeError("Cannot call a class as a function");
      }
      function Lt(t, e) {
        for (var i = 0; i < e.length; i++) {
          var n = e[i];
          (n.enumerable = n.enumerable || !1),
            (n.configurable = !0),
            "value" in n && (n.writable = !0),
            Object.defineProperty(t, n.key, n);
        }
      }
      function Dt(t, e, i) {
        return e && Lt(t.prototype, e), i && Lt(t, i), t;
      }
      function It() {
        return new Promise(function (t) {
          window.requestAnimationFrame(t);
        });
      }
      var Pt = (function () {
        function t(e) {
          Tt(this, t),
            (this._el = e.el),
            (this.cancelRunning = null),
            (this._state = e.state || "initial"),
            (this.initialState = this._state),
            (this.stateAttribute = e.stateAttribute || "data-animation-state"),
            (this.stateChangeAttribute =
              e.stateChangeAttribute || "data-animation"),
            (this.endEvent = e.endEvent || "transitionend"),
            (this.hold = !!e.hold),
            (this.onStart = e.onStart || function () {}),
            (this.activeEventHandler = null);
        }
        return (
          Dt(t, [
            {
              key: "isState",
              value: function (t) {
                return t === this._state;
              },
            },
            {
              key: "animateTo",
              value: function (t) {
                var e = this,
                  i =
                    arguments.length > 1 && void 0 !== arguments[1]
                      ? arguments[1]
                      : {},
                  n = this._el.dataset[this.stateAttribute] || this._state,
                  s = t || this.initialState,
                  o = i.force,
                  r = "hold" in i ? i.hold : this.hold;
                return new Promise(function (t) {
                  if ((e.cancelRunning && e.cancelRunning(), n === s))
                    return (
                      e._el.removeAttribute(e.stateChangeAttribute),
                      void t(n, null)
                    );
                  var a = !0;
                  if (
                    ((e.cancelRunning = function () {
                      (a = !1), t(null, null);
                    }),
                    e._el.removeEventListener(e.endEvent, e.activeEventHandler),
                    (e.activeEventHandler = null),
                    o)
                  )
                    return (
                      e._el.setAttribute(
                        e.stateChangeAttribute,
                        "".concat(n, "=>").concat(s)
                      ),
                      e.onStart({ el: e._el, from: n, to: s }),
                      "function" == typeof i.onStart &&
                        i.onStart({ el: e._el, from: n, to: s }),
                      e._el.setAttribute(e.stateAttribute, s),
                      (e._state = s),
                      r || e._el.removeAttribute(e.stateChangeAttribute),
                      void t(s, null)
                    );
                  It()
                    .then(function () {
                      if (!a) throw new Error("cancelled");
                      return (
                        e._el.setAttribute(
                          e.stateChangeAttribute,
                          "".concat(n, "=>").concat(s)
                        ),
                        e.onStart({ el: e._el, from: n, to: s }),
                        "function" == typeof i.onStart &&
                          i.onStart({ el: e._el, from: n, to: s }),
                        It()
                      );
                    })
                    .then(function () {
                      if (!a) throw new Error("cancelled");
                      e._el.removeEventListener(
                        e.endEvent,
                        e.activeEventHandler
                      ),
                        (e.activeEventHandler = function (i) {
                          i.target === e._el &&
                            a &&
                            (e._el.removeEventListener(
                              e.endEvent,
                              e.activeEventHandler
                            ),
                            r || e._el.removeAttribute(e.stateChangeAttribute),
                            t(s, i));
                        }),
                        e._el.addEventListener(
                          e.endEvent,
                          e.activeEventHandler
                        ),
                        e._el.setAttribute(e.stateAttribute, s),
                        (e._state = s);
                    })
                    .catch(function (t) {
                      if ("cancelled" !== t.message) throw t;
                    });
                });
              },
            },
            {
              key: "unload",
              value: function () {
                this._el.removeEventListener(
                  this.endEvent,
                  this.activeEventHandler
                ),
                  (this.activeEventHandler = null);
              },
            },
            {
              key: "el",
              get: function () {
                return this._el;
              },
            },
            {
              key: "state",
              get: function () {
                return this._state;
              },
            },
          ]),
          t
        );
      })();
      function Mt(t) {
        return new Pt(t);
      }
      var Ot = i(646),
        Ft = i(442),
        qt = i.n(Ft);
      const $t = [];
      let Bt = null;
      function Nt() {
        return window
          .getComputedStyle(document.documentElement, ":before")
          .getPropertyValue("content")
          .replace(/"/g, "")
          .split(",");
      }
      function Rt() {
        return window
          .getComputedStyle(document.documentElement, ":after")
          .getPropertyValue("content")
          .replace(/"/g, "");
      }
      e()(window).on("resize", (t) => {
        const e = Rt();
        Bt !== e &&
          $t.forEach((i) => {
            i(t, { previous: Bt, current: e });
          }),
          (Bt = e);
      });
      const zt = {
        isLessThanBreakpoint: function (t) {
          let e =
            arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
          const i = Nt(),
            n = Rt(),
            s = i.indexOf(n) - i.indexOf(t);
          return e ? s <= 0 : s < 0;
        },
        isGreaterThanBreakpoint: function (t) {
          let e =
            arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
          const i = Nt(),
            n = Rt(),
            s = i.indexOf(n) - i.indexOf(t);
          return e ? s >= 0 : s > 0;
        },
        isBreakpoint: function () {
          const t = Rt();
          for (var e = arguments.length, i = new Array(e), n = 0; n < e; n++)
            i[n] = arguments[n];
          return i.some((e) => e === t);
        },
        onBreakpointChange: function (t) {
          -1 === $t.indexOf(t) && $t.push(t);
        },
        offBreakpointChange: function (t) {
          const e = $t.indexOf(t);
          -1 !== e && $t.splice(e, 1);
        },
      };
      class Ht {
        constructor(t, e, i) {
          (this.callback = e),
            (this._runCallback = this._runCallback.bind(this)),
            (this.observer = new IntersectionObserver(this._runCallback, {
              rootMargin: "30%",
              threshold: 0,
              ...i,
            })),
            this.observer.observe(t);
        }
        _runCallback(t) {
          !0 === t[0].isIntersecting && (this.unload(), this.callback());
        }
        unload() {
          this.observer.disconnect();
        }
      }
      var Ut = i(529),
        jt = i.n(Ut);
      function Wt(t, e) {
        e = e || {};
        var i = t.tabIndex;
        (t.tabIndex = -1),
          (t.dataset.tabIndex = i),
          t.focus(),
          void 0 !== e.className && t.classList.add(e.className),
          t.addEventListener("blur", function n(s) {
            s.target.removeEventListener(s.type, n),
              (t.tabIndex = i),
              delete t.dataset.tabIndex,
              void 0 !== e.className && t.classList.remove(e.className);
          });
      }
      var Vt = {};
      function Gt(t, e) {
        e = e || {};
        var i = (function (t) {
            return Array.prototype.slice
              .call(
                t.querySelectorAll(
                  "[tabindex],[draggable],a[href],area,button:enabled,input:not([type=hidden]):enabled,object,select:enabled,textarea:enabled"
                )
              )
              .filter(function (t) {
                return !!(
                  t.offsetWidth ||
                  t.offsetHeight ||
                  t.getClientRects().length
                );
              });
          })(t),
          n = e.elementToFocus || t,
          s = i[0],
          o = i[i.length - 1];
        Xt(),
          (Vt.focusin = function (e) {
            t === e.target || t.contains(e.target) || s.focus(),
              (e.target !== t && e.target !== o && e.target !== s) ||
                document.addEventListener("keydown", Vt.keydown);
          }),
          (Vt.focusout = function () {
            document.removeEventListener("keydown", Vt.keydown);
          }),
          (Vt.keydown = function (e) {
            9 === e.keyCode &&
              (e.target !== o || e.shiftKey || (e.preventDefault(), s.focus()),
              (e.target !== t && e.target !== s) ||
                !e.shiftKey ||
                (e.preventDefault(), o.focus()));
          }),
          document.addEventListener("focusout", Vt.focusout),
          document.addEventListener("focusin", Vt.focusin),
          Wt(n, e);
      }
      function Xt() {
        document.removeEventListener("focusin", Vt.focusin),
          document.removeEventListener("focusout", Vt.focusout),
          document.removeEventListener("keydown", Vt.keydown);
      }
      const { body: Zt } = document,
        Qt = document.querySelector("html");
      function Yt(t) {
        t.target.closest(".allow-scroll-while-locked") ||
          (t.preventDefault(), t.stopPropagation());
      }
      class Kt {
        static lock(t) {
          t &&
            (t.classList.add("allow-scroll-while-locked"),
            t.classList.contains("mobile-nav-panel") ||
              t.classList.add("modal-2")),
            Qt.classList.add("scroll-locked"),
            (Zt.style.top = -1 * window.pageYOffset),
            Zt.addEventListener("scroll", Yt, !1),
            Zt.addEventListener("touchmove", Yt, { passive: !1 });
        }
        static unlock() {
          document
            .querySelectorAll(".allow-scroll-while-locked")
            .forEach((t) => t.classList.remove("allow-scroll-while-locked")),
            Qt.classList.remove("scroll-locked"),
            (Zt.style.top = ""),
            Zt.removeEventListener("scroll", Yt, !1),
            Zt.removeEventListener("touchmove", Yt, { passive: !1 });
        }
        static get isLocked() {
          return Qt.classList.contains("scroll-locked");
        }
      }
      let Jt = [];
      const te = () => {
        0 === Jt.length && Kt.unlock();
      };
      class ee {
        constructor() {
          let t =
            arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
          (this.$body = e()(document.body)), (this.$window = e()(window));
          this.options = {
            onOpen: () => {},
            onClose: () => {},
            onBeforeOpen: () => {},
            onBeforeClose: () => {},
            modalId: null,
            ...t,
          };
          const i = this.options.modalId
              ? `[data-modal-container-${this.options.modalId}]`
              : "[data-modal-container]",
            n = this.options.modalId
              ? `[data-modal-${this.options.modalId}-close`
              : "[data-modal-close]";
          (this.loadedClass = this.options.modalId
            ? `modal-${this.options.modalId}-loaded`
            : "modal-loaded"),
            (this.visibleClass = this.options.modalId
              ? `modal-${this.options.modalId}-visible`
              : "modal-visible"),
            (this.modal = null),
            (this.$modal = e()(i)),
            (this.$modalInner = this.$modal.find("[data-modal-inner]")),
            (this.finishedLoading = this.finishedLoading.bind(this)),
            (this._onOpen = this._onOpen.bind(this)),
            (this._onBeforeOpen = this._onBeforeOpen.bind(this)),
            (this._onClose = this._onClose.bind(this)),
            (this._onBeforeClose = this._onBeforeClose.bind(this)),
            (this._closeEsc = this._closeEsc.bind(this)),
            (this.position = this.position.bind(this)),
            (this.modalOptions = {
              modal: i,
              loadClass: "",
              class: this.loadedClass,
              close: n,
              onOpen: this._onOpen,
              onClose: this._onClose,
              onBeforeOpen: this._onBeforeOpen,
              onBeforeClose: this._onBeforeClose,
              transitions: !1,
              closeKeys: [],
            });
        }
        unload() {
          this.modal &&
            (this.modal.destroy(), (Jt = Jt.filter((t) => t !== this)), te());
        }
        open(t) {
          let e =
            arguments.length > 1 && void 0 !== arguments[1]
              ? arguments[1]
              : "general";
          this._addModalClass(e),
            (this.modal = new (jt())(this.modalOptions)),
            this.modal.open(t),
            Jt.push(this),
            window.addEventListener("keydown", this._closeEsc);
        }
        close() {
          this.modal.close(),
            window.removeEventListener("keydown", this._closeEsc);
        }
        finishedLoading() {
          Gt(this.$modal[0]);
        }
        _closeEsc(t) {
          "Escape" === t.key && Jt[Jt.length - 1] === this && this.close();
        }
        isOpen() {
          return this.modal && this.modal.isOpen;
        }
        position() {
          const t = window.innerHeight,
            e = this.$modalInner.outerHeight(),
            i = (t - 2 * parseInt(this.$modal.css("padding-top"), 10) - e) / 2,
            n = i > 0 ? i : 0;
          this.$modalInner.css({ marginTop: n });
        }
        _addModalClass(t) {
          this.$modal.addClass(`modal--${t}`);
        }
        _removeModalClass() {
          const t = this.$modal.attr("class").match(/modal--[\w-]*\b/);
          t && this.$modal.removeClass(t[0]);
        }
        _onClose() {
          if (
            (this._removeModalClass(),
            this.$body.removeClass(this.visibleClass),
            this.$window.off("resize.modal"),
            this.$modalInner.css({ marginTop: "" }),
            this.options.onClose(),
            Xt(this.$modal[0]),
            this.activeElement)
          ) {
            const t = this.activeElement.closest("[data-trap-focus]");
            t && Gt(t), this.activeElement.focus();
          }
          (Jt = Jt.filter((t) => t !== this)), te();
        }
        _onOpen() {
          (this.activeElement = document.activeElement),
            this.position(),
            Kt.lock(this.$modal[0]),
            this.$body.addClass(this.visibleClass),
            this.$window.on(
              "resize.modal",
              tt()(() => this.position(), 16, !0, !0)
            ),
            this.options.onOpen(),
            Gt(this.$modal[0]);
        }
        _onBeforeClose() {
          this.options.onBeforeClose();
        }
        _onBeforeOpen() {
          this.options.onBeforeOpen();
        }
      }
      i(722);
      const ie = "pxu-shopify-surface-pick-up",
        ne = "surface-pick-up--loading";
      async function se(t = !1) {
        const e = JSON.parse(localStorage.getItem(ie));
        return e && e.timestamp + 36e5 >= Date.now()
          ? e
          : t
          ? (async function () {
              return new Promise((t, e) => {
                const i = { maximumAge: 36e5, timeout: 5e3 };
                navigator.geolocation
                  ? navigator.geolocation.getCurrentPosition(
                      ({ coords: e }) => t(e),
                      e,
                      i
                    )
                  : e();
              });
            })().then(
              (t) => (
                (async function ({ latitude: t, longitude: e }) {
                  const i = {
                    latitude: t,
                    longitude: e,
                    timestamp: Date.now(),
                  };
                  localStorage.setItem(ie, JSON.stringify(i)),
                    fetch("/localization.json", {
                      method: "PUT",
                      headers: { "Content-Type": "application/json" },
                      body: JSON.stringify({ latitude: t, longitude: e }),
                    }).then(() => ({ latitude: t, longitude: e }));
                })(t),
                t
              )
            )
          : null;
      }
      const oe = class {
        constructor(t, e) {
          (this.el = t),
            (this.options = {
              root_url:
                (window.Theme &&
                  window.Theme.routes &&
                  window.Theme.routes.root_url) ||
                "",
              ...e,
            }),
            (this.options.root_url = this.options.root_url.replace(
              /(.*)\/$/,
              "$1"
            )),
            (this.callbacks = []),
            (this.onBtnPress = null),
            (this.latestVariantId = null);
        }
        load(t) {
          return t
            ? ((this.latestVariantId = t),
              this.el.classList.add(ne),
              this._getData(t).then((t) => this._injectData(t)))
            : ((this.el.innerHTML = ""), Promise.resolve(!0));
        }
        onModalRequest(t) {
          this.callbacks.indexOf(t) >= 0 || this.callbacks.push(t);
        }
        offModalRequest(t) {
          this.callbacks.splice(this.callbacks.indexOf(t));
        }
        unload() {
          (this.callbacks = []), (this.el.innerHTML = "");
        }
        _getData(t) {
          return new Promise((e) => {
            const i = new XMLHttpRequest(),
              n = `${this.options.root_url}/variants/${t}/?section_id=surface-pick-up`;
            i.open("GET", n, !0),
              (i.onload = () => {
                const n = i.response,
                  s = n.querySelector('[data-html="surface-pick-up-embed"]'),
                  o = n.querySelector('[data-html="surface-pick-up-items"]'),
                  r = o.content.querySelectorAll("[data-surface-pick-up-item]");
                e({ embed: s, itemsContainer: o, items: r, variantId: t });
              }),
              (i.onerror = () => {
                e({
                  embed: { innerHTML: "" },
                  itemsContainer: { innerHTML: "" },
                  items: [],
                  variantId: t,
                });
              }),
              (i.responseType = "document"),
              i.send();
          });
        }
        _injectData({ embed: t, itemsContainer: e, items: i, variantId: n }) {
          if (n !== this.latestVariantId || 0 === i.length)
            return (this.el.innerHTML = ""), void this.el.classList.remove(ne);
          (this.el.innerHTML = t.innerHTML), this.el.classList.remove(ne);
          let s = !1;
          const o = () =>
            s
              ? Promise.resolve()
              : se(!0)
                  .then((t) => {
                    i.forEach((e) => {
                      const i = e.querySelector("[data-distance]"),
                        n = e.querySelector("[data-distance-unit]"),
                        s = n.dataset.distanceUnit,
                        o = parseFloat(i.dataset.latitude),
                        r = parseFloat(i.dataset.longitude);
                      if (t && isFinite(o) && isFinite(r)) {
                        const e = (function (t, e, i, n, s) {
                          const o = Math.PI / 180,
                            r = "metric" === s ? 6378.14 : 3959,
                            a = t * o,
                            l = i * o,
                            c = e * o - n * o,
                            h = a - l,
                            d =
                              Math.sin(h / 2) ** 2 +
                              Math.cos(a) * Math.cos(l) * Math.sin(c / 2) ** 2;
                          return (
                            r * (2 * Math.atan2(Math.sqrt(d), Math.sqrt(1 - d)))
                          );
                        })(t.latitude, t.longitude, o, r, s);
                        i.innerHTML = e.toFixed(1);
                      } else i.remove(), n.remove();
                    });
                  })
                  .catch((t) => {
                    console.log(t),
                      i.forEach((t) => {
                        const e = t.querySelector("[data-distance]"),
                          i = t.querySelector("[data-distance-unit]");
                        e.remove(), i.remove();
                      });
                  })
                  .finally(() => {
                    s = !0;
                  });
          this.el
            .querySelector("[data-surface-pick-up-embed-modal-btn]")
            .addEventListener("click", () => {
              o().then(() => this.callbacks.forEach((t) => t(e.innerHTML)));
            });
        }
      };
      var re,
        ae,
        le,
        ce =
          ((re = function (t, e) {
            e.__esModule = !0;
            var i = (function () {
              function t() {
                this.events = [];
              }
              return (
                (t.prototype.register = function (t, e, i) {
                  return t && e && i
                    ? (this.events.push({ el: t, event: e, listener: i }),
                      t.addEventListener(e, i),
                      { el: t, event: e, listener: i })
                    : null;
                }),
                (t.prototype.unregister = function (t) {
                  var e = t.el,
                    i = t.event,
                    n = t.listener;
                  return e && i && n
                    ? ((this.events = this.events.filter(function (t) {
                        return e !== t.el || i !== t.event || n !== t.listener;
                      })),
                      e.removeEventListener(i, n),
                      { el: e, event: i, listener: n })
                    : null;
                }),
                (t.prototype.unregisterAll = function () {
                  this.events.forEach(function (t) {
                    var e = t.el,
                      i = t.event,
                      n = t.listener;
                    return e.removeEventListener(i, n);
                  }),
                    (this.events = []);
                }),
                t
              );
            })();
            e.default = i;
          }),
          re((ae = { exports: {} }), ae.exports),
          ae.exports),
        he =
          (le = ce) &&
          le.__esModule &&
          Object.prototype.hasOwnProperty.call(le, "default")
            ? le.default
            : le;
      function de(t, e) {
        for (var i = 0; i < e.length; i++) {
          var n = e[i];
          (n.enumerable = n.enumerable || !1),
            (n.configurable = !0),
            "value" in n && (n.writable = !0),
            Object.defineProperty(t, n.key, n);
        }
      }
      function ue() {
        return new Promise(function (t) {
          window.requestAnimationFrame(t);
        });
      }
      var pe = (function () {
        function t(e) {
          !(
            /*!
             * @pixelunion/animations v0.1.0
             * (c) 2019 Pixel Union
             * Released under the UNLICENSED license.
             */
            (function (t, e) {
              if (!(t instanceof e))
                throw new TypeError("Cannot call a class as a function");
            })(this, t)
          ),
            (this._el = e.el),
            (this.cancelRunning = null),
            (this._state = e.state || "initial"),
            (this.initialState = this._state),
            (this.stateAttribute = e.stateAttribute || "data-animation-state"),
            (this.stateChangeAttribute =
              e.stateChangeAttribute || "data-animation"),
            (this.endEvent = e.endEvent || "transitionend"),
            (this.hold = !!e.hold),
            (this.onStart = e.onStart || function () {}),
            (this.activeEventHandler = null);
        }
        var e, i, n;
        return (
          (e = t),
          (i = [
            {
              key: "isState",
              value: function (t) {
                return t === this._state;
              },
            },
            {
              key: "animateTo",
              value: function (t) {
                var e = this,
                  i =
                    arguments.length > 1 && void 0 !== arguments[1]
                      ? arguments[1]
                      : {},
                  n = this._el.dataset[this.stateAttribute] || this._state,
                  s = t || this.initialState,
                  o = i.force,
                  r = "hold" in i ? i.hold : this.hold;
                return new Promise(function (t) {
                  if ((e.cancelRunning && e.cancelRunning(), n === s))
                    return (
                      e._el.removeAttribute(e.stateChangeAttribute),
                      void t(n, null)
                    );
                  var a = !0;
                  if (
                    ((e.cancelRunning = function () {
                      (a = !1), t(null, null);
                    }),
                    e._el.removeEventListener(e.endEvent, e.activeEventHandler),
                    (e.activeEventHandler = null),
                    o)
                  )
                    return (
                      e._el.setAttribute(
                        e.stateChangeAttribute,
                        "".concat(n, "=>").concat(s)
                      ),
                      e.onStart({ el: e._el, from: n, to: s }),
                      "function" == typeof i.onStart &&
                        i.onStart({ el: e._el, from: n, to: s }),
                      e._el.setAttribute(e.stateAttribute, s),
                      (e._state = s),
                      r || e._el.removeAttribute(e.stateChangeAttribute),
                      void t(s, null)
                    );
                  ue()
                    .then(function () {
                      if (!a) throw new Error("cancelled");
                      return (
                        e._el.setAttribute(
                          e.stateChangeAttribute,
                          "".concat(n, "=>").concat(s)
                        ),
                        e.onStart({ el: e._el, from: n, to: s }),
                        "function" == typeof i.onStart &&
                          i.onStart({ el: e._el, from: n, to: s }),
                        ue()
                      );
                    })
                    .then(function () {
                      if (!a) throw new Error("cancelled");
                      e._el.removeEventListener(
                        e.endEvent,
                        e.activeEventHandler
                      ),
                        (e.activeEventHandler = function (i) {
                          i.target === e._el &&
                            a &&
                            (e._el.removeEventListener(
                              e.endEvent,
                              e.activeEventHandler
                            ),
                            r || e._el.removeAttribute(e.stateChangeAttribute),
                            t(s, i));
                        }),
                        e._el.addEventListener(
                          e.endEvent,
                          e.activeEventHandler
                        ),
                        e._el.setAttribute(e.stateAttribute, s),
                        (e._state = s);
                    })
                    .catch(function (t) {
                      if ("cancelled" !== t.message) throw t;
                    });
                });
              },
            },
            {
              key: "unload",
              value: function () {
                this._el.removeEventListener(
                  this.endEvent,
                  this.activeEventHandler
                ),
                  (this.activeEventHandler = null);
              },
            },
            {
              key: "el",
              get: function () {
                return this._el;
              },
            },
            {
              key: "state",
              get: function () {
                return this._state;
              },
            },
          ]),
          i && de(e.prototype, i),
          n && de(e, n),
          t
        );
      })();
      function fe(t) {
        return new pe(t);
      }
      const me = class {
        constructor(t) {
          (this.el = t),
            (this.events = new he()),
            (this.recipientForm = this.el.querySelector(
              "[data-recipient-form]"
            )),
            (this.recipientFormInputs = this.el.querySelectorAll(
              "[data-recipient-form-input]"
            )),
            (this.recipientFormEmailInput = this.el.querySelector(
              "[data-recipient-form-email-input]"
            )),
            (this.disclosure = this.el.querySelector(
              "[data-recipient-disclosure]"
            )),
            (this.disclosureCheckbox = this.el.querySelector(
              "[data-recipient-disclosure-checkbox]"
            )),
            (this.checkmark = this.disclosure.querySelector(".checkmark")),
            (this.checkmarkCheck =
              this.disclosure.querySelector(".checkmark__check")),
            (this.fillAnimation = fe({ el: this.checkmark })),
            (this.checkAnimation = fe({ el: this.checkmarkCheck })),
            this.events.register(this.recipientForm, "keydown", (t) =>
              this._onKeydown(t)
            ),
            this.events.register(this.disclosure, "toggle", () =>
              this._onToggle()
            ),
            this.events.register(this.disclosureCheckbox, "change", () =>
              this._onChange()
            );
        }
        _onChange() {
          this.disclosure.open = this.disclosureCheckbox.checked;
        }
        _onKeydown(t) {
          "Enter" === t.key &&
            t.target.matches("[data-recipient-form-input]") &&
            t.preventDefault();
        }
        _onToggle() {
          this.disclosure.open
            ? this._showRecipientForm()
            : this._hideRecipientForm();
        }
        _showRecipientForm() {
          this.checkmark &&
            this.checkmarkCheck &&
            (this.fillAnimation.animateTo("checked"),
            this.checkAnimation.animateTo("checked")),
            (this.disclosureCheckbox.checked = !0),
            (this.recipientFormEmailInput.required = !0);
        }
        _hideRecipientForm() {
          this.checkmark &&
            this.checkmarkCheck &&
            (this.fillAnimation.animateTo("unchecked"),
            this.checkAnimation.animateTo("unchecked")),
            (this.disclosureCheckbox.checked = !1),
            (this.recipientFormEmailInput.required = !1),
            this._resetRecipientForm();
        }
        _resetRecipientForm() {
          this.recipientFormInputs.forEach((t) => {
            (t.value = ""),
              t.classList.contains("form-field-filled") &&
                t.classList.remove("form-field-filled");
          }),
            this.recipientForm.classList.contains(
              "recipient-form--has-errors"
            ) &&
              this.recipientForm.classList.remove("recipient-form--has-errors");
        }
      };
      class ge {
        constructor(t, e) {
          const i = document.querySelector(
            "[data-templates] [data-message-banner]"
          );
          this.banner = i.cloneNode(!0);
          (this.banner.querySelector(
            "[data-message-banner-content]"
          ).innerHTML = t),
            this.banner.classList.add(`message--${e}`);
          (
            document.querySelector(".modal-loaded .modal-inner") ||
            document.querySelector("[data-site-header]")
          ).appendChild(this.banner),
            (this.closeButton = this.banner.querySelector(
              "[data-message-banner-close]"
            )),
            (this.bannerAnimation = Mt({ el: this.banner, state: "closed" })),
            this.bannerAnimation.animateTo("open"),
            (this.events = new xt.Z()),
            this.events.register(this.closeButton, "click", () =>
              this._close()
            ),
            this.events.register(document, "click", (t) =>
              this._handleDocumentClick(t.target)
            ),
            this.events.register(document, "touchStart", (t) =>
              this._handleDocumentClick(t.target)
            ),
            this.events.register(window, "keydown", (t) => this._closeEsc(t));
        }
        unload() {
          this.banner && this._close();
        }
        _closeEsc(t) {
          "Escape" === t.key && this._close();
        }
        _close() {
          this.bannerAnimation.animateTo("closed").then(() => {
            this.banner?.remove(),
              (this.banner = null),
              this.events.unregisterAll(),
              this.bannerAnimation.unload();
          });
        }
        _handleDocumentClick(t) {
          e()(t).parents("[data-message-banner]").length || this._close();
        }
      }
      class ve {
        preload(t, e) {
          let i = t;
          "string" == typeof t && (i = [t]);
          for (let t = 0; t < i.length; t++)
            this.loadImage(this.getSizedImageUrl(i[t], e));
        }
        loadImage(t) {
          const e = new Image();
          return (e.src = t), e;
        }
        getSizedImageUrl() {
          let t =
              arguments.length > 0 && void 0 !== arguments[0]
                ? arguments[0]
                : null,
            e = arguments.length > 1 ? arguments[1] : void 0;
          if (!e) return null;
          if ("master" === e) return this.removeProtocol(t);
          const i = t.match(
            /\.(jpg|jpeg|gif|png|webp|avif|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i
          );
          if (i) {
            const n = t.split(i[0]),
              s = i[0];
            return this.removeProtocol(`${n[0]}_${e}${s}`);
          }
          return console.warn(`No ${e} found for '${t}`), null;
        }
        removeProtocol(t) {
          return t.replace(/http(s)?:/, "");
        }
      }
      /*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
      var ye = function (t, e) {
        return (
          (ye =
            Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array &&
              function (t, e) {
                t.__proto__ = e;
              }) ||
            function (t, e) {
              for (var i in e) e.hasOwnProperty(i) && (t[i] = e[i]);
            }),
          ye(t, e)
        );
      };
      function be(t, e) {
        function i() {
          this.constructor = t;
        }
        ye(t, e),
          (t.prototype =
            null === e
              ? Object.create(e)
              : ((i.prototype = e.prototype), new i()));
      }
      var we = function () {
        return (
          (we =
            Object.assign ||
            function (t) {
              for (var e, i = 1, n = arguments.length; i < n; i++)
                for (var s in (e = arguments[i]))
                  Object.prototype.hasOwnProperty.call(e, s) && (t[s] = e[s]);
              return t;
            }),
          we.apply(this, arguments)
        );
      };
      function _e(t, e) {
        var i = "function" == typeof Symbol && t[Symbol.iterator];
        if (!i) return t;
        var n,
          s,
          o = i.call(t),
          r = [];
        try {
          for (; (void 0 === e || e-- > 0) && !(n = o.next()).done; )
            r.push(n.value);
        } catch (t) {
          s = { error: t };
        } finally {
          try {
            n && !n.done && (i = o.return) && i.call(o);
          } finally {
            if (s) throw s.error;
          }
        }
        return r;
      }
      /**
       * @license
       * Copyright 2016 Google Inc.
       *
       * Permission is hereby granted, free of charge, to any person obtaining a copy
       * of this software and associated documentation files (the "Software"), to deal
       * in the Software without restriction, including without limitation the rights
       * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
       * copies of the Software, and to permit persons to whom the Software is
       * furnished to do so, subject to the following conditions:
       *
       * The above copyright notice and this permission notice shall be included in
       * all copies or substantial portions of the Software.
       *
       * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
       * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
       * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
       * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
       * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
       * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
       * THE SOFTWARE.
       */
      var Se = (function () {
        function t(t) {
          void 0 === t && (t = {}), (this.adapter_ = t);
        }
        return (
          Object.defineProperty(t, "cssClasses", {
            get: function () {
              return {};
            },
            enumerable: !0,
            configurable: !0,
          }),
          Object.defineProperty(t, "strings", {
            get: function () {
              return {};
            },
            enumerable: !0,
            configurable: !0,
          }),
          Object.defineProperty(t, "numbers", {
            get: function () {
              return {};
            },
            enumerable: !0,
            configurable: !0,
          }),
          Object.defineProperty(t, "defaultAdapter", {
            get: function () {
              return {};
            },
            enumerable: !0,
            configurable: !0,
          }),
          (t.prototype.init = function () {}),
          (t.prototype.destroy = function () {}),
          t
        );
      })();
      /**
       * @license
       * Copyright 2016 Google Inc.
       *
       * Permission is hereby granted, free of charge, to any person obtaining a copy
       * of this software and associated documentation files (the "Software"), to deal
       * in the Software without restriction, including without limitation the rights
       * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
       * copies of the Software, and to permit persons to whom the Software is
       * furnished to do so, subject to the following conditions:
       *
       * The above copyright notice and this permission notice shall be included in
       * all copies or substantial portions of the Software.
       *
       * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
       * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
       * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
       * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
       * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
       * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
       * THE SOFTWARE.
       */
      var Ce = (function () {
        function t(t, e) {
          for (var i = [], n = 2; n < arguments.length; n++)
            i[n - 2] = arguments[n];
          (this.root_ = t),
            this.initialize.apply(
              this,
              (function () {
                for (var t = [], e = 0; e < arguments.length; e++)
                  t = t.concat(_e(arguments[e]));
                return t;
              })(i)
            ),
            (this.foundation_ = void 0 === e ? this.getDefaultFoundation() : e),
            this.foundation_.init(),
            this.initialSyncWithDOM();
        }
        return (
          (t.attachTo = function (e) {
            return new t(e, new Se({}));
          }),
          (t.prototype.initialize = function () {
            for (var t = [], e = 0; e < arguments.length; e++)
              t[e] = arguments[e];
          }),
          (t.prototype.getDefaultFoundation = function () {
            throw new Error(
              "Subclasses must override getDefaultFoundation to return a properly configured foundation class"
            );
          }),
          (t.prototype.initialSyncWithDOM = function () {}),
          (t.prototype.destroy = function () {
            this.foundation_.destroy();
          }),
          (t.prototype.listen = function (t, e, i) {
            this.root_.addEventListener(t, e, i);
          }),
          (t.prototype.unlisten = function (t, e, i) {
            this.root_.removeEventListener(t, e, i);
          }),
          (t.prototype.emit = function (t, e, i) {
            var n;
            void 0 === i && (i = !1),
              "function" == typeof CustomEvent
                ? (n = new CustomEvent(t, { bubbles: i, detail: e }))
                : (n = document.createEvent("CustomEvent")).initCustomEvent(
                    t,
                    i,
                    !1,
                    e
                  ),
              this.root_.dispatchEvent(n);
          }),
          t
        );
      })();
      /**
       * @license
       * Copyright 2019 Google Inc.
       *
       * Permission is hereby granted, free of charge, to any person obtaining a copy
       * of this software and associated documentation files (the "Software"), to deal
       * in the Software without restriction, including without limitation the rights
       * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
       * copies of the Software, and to permit persons to whom the Software is
       * furnished to do so, subject to the following conditions:
       *
       * The above copyright notice and this permission notice shall be included in
       * all copies or substantial portions of the Software.
       *
       * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
       * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
       * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
       * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
       * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
       * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
       * THE SOFTWARE.
       */
      function ke(t) {
        return (
          void 0 === t && (t = window),
          !!(function (t) {
            void 0 === t && (t = window);
            var e = !1;
            try {
              var i = {
                  get passive() {
                    return (e = !0), !1;
                  },
                },
                n = function () {};
              t.document.addEventListener("test", n, i),
                t.document.removeEventListener("test", n, i);
            } catch (t) {
              e = !1;
            }
            return e;
          })(t) && { passive: !0 }
        );
      }
      function xe(t, e) {
        return (
          t.matches ||
          t.webkitMatchesSelector ||
          t.msMatchesSelector
        ).call(t, e);
      }
      /**
       * @license
       * Copyright 2016 Google Inc.
       *
       * Permission is hereby granted, free of charge, to any person obtaining a copy
       * of this software and associated documentation files (the "Software"), to deal
       * in the Software without restriction, including without limitation the rights
       * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
       * copies of the Software, and to permit persons to whom the Software is
       * furnished to do so, subject to the following conditions:
       *
       * The above copyright notice and this permission notice shall be included in
       * all copies or substantial portions of the Software.
       *
       * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
       * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
       * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
       * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
       * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
       * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
       * THE SOFTWARE.
       */
      var Ee,
        Ae = {
          BG_FOCUSED: "mdc-ripple-upgraded--background-focused",
          FG_ACTIVATION: "mdc-ripple-upgraded--foreground-activation",
          FG_DEACTIVATION: "mdc-ripple-upgraded--foreground-deactivation",
          ROOT: "mdc-ripple-upgraded",
          UNBOUNDED: "mdc-ripple-upgraded--unbounded",
        },
        Te = {
          VAR_FG_SCALE: "--mdc-ripple-fg-scale",
          VAR_FG_SIZE: "--mdc-ripple-fg-size",
          VAR_FG_TRANSLATE_END: "--mdc-ripple-fg-translate-end",
          VAR_FG_TRANSLATE_START: "--mdc-ripple-fg-translate-start",
          VAR_LEFT: "--mdc-ripple-left",
          VAR_TOP: "--mdc-ripple-top",
        },
        Le = {
          DEACTIVATION_TIMEOUT_MS: 225,
          FG_DEACTIVATION_MS: 150,
          INITIAL_ORIGIN_SCALE: 0.6,
          PADDING: 10,
          TAP_DELAY_MS: 300,
        };
      /**
       * @license
       * Copyright 2016 Google Inc.
       *
       * Permission is hereby granted, free of charge, to any person obtaining a copy
       * of this software and associated documentation files (the "Software"), to deal
       * in the Software without restriction, including without limitation the rights
       * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
       * copies of the Software, and to permit persons to whom the Software is
       * furnished to do so, subject to the following conditions:
       *
       * The above copyright notice and this permission notice shall be included in
       * all copies or substantial portions of the Software.
       *
       * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
       * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
       * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
       * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
       * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
       * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
       * THE SOFTWARE.
       */
      var De = ["touchstart", "pointerdown", "mousedown", "keydown"],
        Ie = ["touchend", "pointerup", "mouseup", "contextmenu"],
        Pe = [],
        Me = (function (t) {
          function e(i) {
            var n = t.call(this, we(we({}, e.defaultAdapter), i)) || this;
            return (
              (n.activationAnimationHasEnded_ = !1),
              (n.activationTimer_ = 0),
              (n.fgDeactivationRemovalTimer_ = 0),
              (n.fgScale_ = "0"),
              (n.frame_ = { width: 0, height: 0 }),
              (n.initialSize_ = 0),
              (n.layoutFrame_ = 0),
              (n.maxRadius_ = 0),
              (n.unboundedCoords_ = { left: 0, top: 0 }),
              (n.activationState_ = n.defaultActivationState_()),
              (n.activationTimerCallback_ = function () {
                (n.activationAnimationHasEnded_ = !0),
                  n.runDeactivationUXLogicIfReady_();
              }),
              (n.activateHandler_ = function (t) {
                return n.activate_(t);
              }),
              (n.deactivateHandler_ = function () {
                return n.deactivate_();
              }),
              (n.focusHandler_ = function () {
                return n.handleFocus();
              }),
              (n.blurHandler_ = function () {
                return n.handleBlur();
              }),
              (n.resizeHandler_ = function () {
                return n.layout();
              }),
              n
            );
          }
          return (
            be(e, t),
            Object.defineProperty(e, "cssClasses", {
              get: function () {
                return Ae;
              },
              enumerable: !0,
              configurable: !0,
            }),
            Object.defineProperty(e, "strings", {
              get: function () {
                return Te;
              },
              enumerable: !0,
              configurable: !0,
            }),
            Object.defineProperty(e, "numbers", {
              get: function () {
                return Le;
              },
              enumerable: !0,
              configurable: !0,
            }),
            Object.defineProperty(e, "defaultAdapter", {
              get: function () {
                return {
                  addClass: function () {},
                  browserSupportsCssVars: function () {
                    return !0;
                  },
                  computeBoundingRect: function () {
                    return {
                      top: 0,
                      right: 0,
                      bottom: 0,
                      left: 0,
                      width: 0,
                      height: 0,
                    };
                  },
                  containsEventTarget: function () {
                    return !0;
                  },
                  deregisterDocumentInteractionHandler: function () {},
                  deregisterInteractionHandler: function () {},
                  deregisterResizeHandler: function () {},
                  getWindowPageOffset: function () {
                    return { x: 0, y: 0 };
                  },
                  isSurfaceActive: function () {
                    return !0;
                  },
                  isSurfaceDisabled: function () {
                    return !0;
                  },
                  isUnbounded: function () {
                    return !0;
                  },
                  registerDocumentInteractionHandler: function () {},
                  registerInteractionHandler: function () {},
                  registerResizeHandler: function () {},
                  removeClass: function () {},
                  updateCssVariable: function () {},
                };
              },
              enumerable: !0,
              configurable: !0,
            }),
            (e.prototype.init = function () {
              var t = this,
                i = this.supportsPressRipple_();
              if ((this.registerRootHandlers_(i), i)) {
                var n = e.cssClasses,
                  s = n.ROOT,
                  o = n.UNBOUNDED;
                requestAnimationFrame(function () {
                  t.adapter_.addClass(s),
                    t.adapter_.isUnbounded() &&
                      (t.adapter_.addClass(o), t.layoutInternal_());
                });
              }
            }),
            (e.prototype.destroy = function () {
              var t = this;
              if (this.supportsPressRipple_()) {
                this.activationTimer_ &&
                  (clearTimeout(this.activationTimer_),
                  (this.activationTimer_ = 0),
                  this.adapter_.removeClass(e.cssClasses.FG_ACTIVATION)),
                  this.fgDeactivationRemovalTimer_ &&
                    (clearTimeout(this.fgDeactivationRemovalTimer_),
                    (this.fgDeactivationRemovalTimer_ = 0),
                    this.adapter_.removeClass(e.cssClasses.FG_DEACTIVATION));
                var i = e.cssClasses,
                  n = i.ROOT,
                  s = i.UNBOUNDED;
                requestAnimationFrame(function () {
                  t.adapter_.removeClass(n),
                    t.adapter_.removeClass(s),
                    t.removeCssVars_();
                });
              }
              this.deregisterRootHandlers_(),
                this.deregisterDeactivationHandlers_();
            }),
            (e.prototype.activate = function (t) {
              this.activate_(t);
            }),
            (e.prototype.deactivate = function () {
              this.deactivate_();
            }),
            (e.prototype.layout = function () {
              var t = this;
              this.layoutFrame_ && cancelAnimationFrame(this.layoutFrame_),
                (this.layoutFrame_ = requestAnimationFrame(function () {
                  t.layoutInternal_(), (t.layoutFrame_ = 0);
                }));
            }),
            (e.prototype.setUnbounded = function (t) {
              var i = e.cssClasses.UNBOUNDED;
              t ? this.adapter_.addClass(i) : this.adapter_.removeClass(i);
            }),
            (e.prototype.handleFocus = function () {
              var t = this;
              requestAnimationFrame(function () {
                return t.adapter_.addClass(e.cssClasses.BG_FOCUSED);
              });
            }),
            (e.prototype.handleBlur = function () {
              var t = this;
              requestAnimationFrame(function () {
                return t.adapter_.removeClass(e.cssClasses.BG_FOCUSED);
              });
            }),
            (e.prototype.supportsPressRipple_ = function () {
              return this.adapter_.browserSupportsCssVars();
            }),
            (e.prototype.defaultActivationState_ = function () {
              return {
                activationEvent: void 0,
                hasDeactivationUXRun: !1,
                isActivated: !1,
                isProgrammatic: !1,
                wasActivatedByPointer: !1,
                wasElementMadeActive: !1,
              };
            }),
            (e.prototype.registerRootHandlers_ = function (t) {
              var e = this;
              t &&
                (De.forEach(function (t) {
                  e.adapter_.registerInteractionHandler(t, e.activateHandler_);
                }),
                this.adapter_.isUnbounded() &&
                  this.adapter_.registerResizeHandler(this.resizeHandler_)),
                this.adapter_.registerInteractionHandler(
                  "focus",
                  this.focusHandler_
                ),
                this.adapter_.registerInteractionHandler(
                  "blur",
                  this.blurHandler_
                );
            }),
            (e.prototype.registerDeactivationHandlers_ = function (t) {
              var e = this;
              "keydown" === t.type
                ? this.adapter_.registerInteractionHandler(
                    "keyup",
                    this.deactivateHandler_
                  )
                : Ie.forEach(function (t) {
                    e.adapter_.registerDocumentInteractionHandler(
                      t,
                      e.deactivateHandler_
                    );
                  });
            }),
            (e.prototype.deregisterRootHandlers_ = function () {
              var t = this;
              De.forEach(function (e) {
                t.adapter_.deregisterInteractionHandler(e, t.activateHandler_);
              }),
                this.adapter_.deregisterInteractionHandler(
                  "focus",
                  this.focusHandler_
                ),
                this.adapter_.deregisterInteractionHandler(
                  "blur",
                  this.blurHandler_
                ),
                this.adapter_.isUnbounded() &&
                  this.adapter_.deregisterResizeHandler(this.resizeHandler_);
            }),
            (e.prototype.deregisterDeactivationHandlers_ = function () {
              var t = this;
              this.adapter_.deregisterInteractionHandler(
                "keyup",
                this.deactivateHandler_
              ),
                Ie.forEach(function (e) {
                  t.adapter_.deregisterDocumentInteractionHandler(
                    e,
                    t.deactivateHandler_
                  );
                });
            }),
            (e.prototype.removeCssVars_ = function () {
              var t = this,
                i = e.strings;
              Object.keys(i).forEach(function (e) {
                0 === e.indexOf("VAR_") &&
                  t.adapter_.updateCssVariable(i[e], null);
              });
            }),
            (e.prototype.activate_ = function (t) {
              var e = this;
              if (!this.adapter_.isSurfaceDisabled()) {
                var i = this.activationState_;
                if (!i.isActivated) {
                  var n = this.previousActivationEvent_;
                  if (!(n && void 0 !== t && n.type !== t.type))
                    (i.isActivated = !0),
                      (i.isProgrammatic = void 0 === t),
                      (i.activationEvent = t),
                      (i.wasActivatedByPointer =
                        !i.isProgrammatic &&
                        void 0 !== t &&
                        ("mousedown" === t.type ||
                          "touchstart" === t.type ||
                          "pointerdown" === t.type)),
                      void 0 !== t &&
                      Pe.length > 0 &&
                      Pe.some(function (t) {
                        return e.adapter_.containsEventTarget(t);
                      })
                        ? this.resetActivationState_()
                        : (void 0 !== t &&
                            (Pe.push(t.target),
                            this.registerDeactivationHandlers_(t)),
                          (i.wasElementMadeActive =
                            this.checkElementMadeActive_(t)),
                          i.wasElementMadeActive && this.animateActivation_(),
                          requestAnimationFrame(function () {
                            (Pe = []),
                              i.wasElementMadeActive ||
                                void 0 === t ||
                                (" " !== t.key && 32 !== t.keyCode) ||
                                ((i.wasElementMadeActive =
                                  e.checkElementMadeActive_(t)),
                                i.wasElementMadeActive &&
                                  e.animateActivation_()),
                              i.wasElementMadeActive ||
                                (e.activationState_ =
                                  e.defaultActivationState_());
                          }));
                }
              }
            }),
            (e.prototype.checkElementMadeActive_ = function (t) {
              return (
                void 0 === t ||
                "keydown" !== t.type ||
                this.adapter_.isSurfaceActive()
              );
            }),
            (e.prototype.animateActivation_ = function () {
              var t = this,
                i = e.strings,
                n = i.VAR_FG_TRANSLATE_START,
                s = i.VAR_FG_TRANSLATE_END,
                o = e.cssClasses,
                r = o.FG_DEACTIVATION,
                a = o.FG_ACTIVATION,
                l = e.numbers.DEACTIVATION_TIMEOUT_MS;
              this.layoutInternal_();
              var c = "",
                h = "";
              if (!this.adapter_.isUnbounded()) {
                var d = this.getFgTranslationCoordinates_(),
                  u = d.startPoint,
                  p = d.endPoint;
                (c = u.x + "px, " + u.y + "px"),
                  (h = p.x + "px, " + p.y + "px");
              }
              this.adapter_.updateCssVariable(n, c),
                this.adapter_.updateCssVariable(s, h),
                clearTimeout(this.activationTimer_),
                clearTimeout(this.fgDeactivationRemovalTimer_),
                this.rmBoundedActivationClasses_(),
                this.adapter_.removeClass(r),
                this.adapter_.computeBoundingRect(),
                this.adapter_.addClass(a),
                (this.activationTimer_ = setTimeout(function () {
                  return t.activationTimerCallback_();
                }, l));
            }),
            (e.prototype.getFgTranslationCoordinates_ = function () {
              var t,
                e = this.activationState_,
                i = e.activationEvent;
              return (
                (t = e.wasActivatedByPointer
                  ? (function (t, e, i) {
                      if (!t) return { x: 0, y: 0 };
                      var n,
                        s,
                        o = e.x,
                        r = e.y,
                        a = o + i.left,
                        l = r + i.top;
                      if ("touchstart" === t.type) {
                        var c = t;
                        (n = c.changedTouches[0].pageX - a),
                          (s = c.changedTouches[0].pageY - l);
                      } else {
                        var h = t;
                        (n = h.pageX - a), (s = h.pageY - l);
                      }
                      return { x: n, y: s };
                    })(
                      i,
                      this.adapter_.getWindowPageOffset(),
                      this.adapter_.computeBoundingRect()
                    )
                  : { x: this.frame_.width / 2, y: this.frame_.height / 2 }),
                {
                  startPoint: (t = {
                    x: t.x - this.initialSize_ / 2,
                    y: t.y - this.initialSize_ / 2,
                  }),
                  endPoint: {
                    x: this.frame_.width / 2 - this.initialSize_ / 2,
                    y: this.frame_.height / 2 - this.initialSize_ / 2,
                  },
                }
              );
            }),
            (e.prototype.runDeactivationUXLogicIfReady_ = function () {
              var t = this,
                i = e.cssClasses.FG_DEACTIVATION,
                n = this.activationState_,
                s = n.hasDeactivationUXRun,
                o = n.isActivated;
              (s || !o) &&
                this.activationAnimationHasEnded_ &&
                (this.rmBoundedActivationClasses_(),
                this.adapter_.addClass(i),
                (this.fgDeactivationRemovalTimer_ = setTimeout(function () {
                  t.adapter_.removeClass(i);
                }, Le.FG_DEACTIVATION_MS)));
            }),
            (e.prototype.rmBoundedActivationClasses_ = function () {
              var t = e.cssClasses.FG_ACTIVATION;
              this.adapter_.removeClass(t),
                (this.activationAnimationHasEnded_ = !1),
                this.adapter_.computeBoundingRect();
            }),
            (e.prototype.resetActivationState_ = function () {
              var t = this;
              (this.previousActivationEvent_ =
                this.activationState_.activationEvent),
                (this.activationState_ = this.defaultActivationState_()),
                setTimeout(function () {
                  return (t.previousActivationEvent_ = void 0);
                }, e.numbers.TAP_DELAY_MS);
            }),
            (e.prototype.deactivate_ = function () {
              var t = this,
                e = this.activationState_;
              if (e.isActivated) {
                var i = we({}, e);
                e.isProgrammatic
                  ? (requestAnimationFrame(function () {
                      return t.animateDeactivation_(i);
                    }),
                    this.resetActivationState_())
                  : (this.deregisterDeactivationHandlers_(),
                    requestAnimationFrame(function () {
                      (t.activationState_.hasDeactivationUXRun = !0),
                        t.animateDeactivation_(i),
                        t.resetActivationState_();
                    }));
              }
            }),
            (e.prototype.animateDeactivation_ = function (t) {
              var e = t.wasActivatedByPointer,
                i = t.wasElementMadeActive;
              (e || i) && this.runDeactivationUXLogicIfReady_();
            }),
            (e.prototype.layoutInternal_ = function () {
              var t = this;
              this.frame_ = this.adapter_.computeBoundingRect();
              var i = Math.max(this.frame_.height, this.frame_.width);
              this.maxRadius_ = this.adapter_.isUnbounded()
                ? i
                : Math.sqrt(
                    Math.pow(t.frame_.width, 2) + Math.pow(t.frame_.height, 2)
                  ) + e.numbers.PADDING;
              var n = Math.floor(i * e.numbers.INITIAL_ORIGIN_SCALE);
              this.adapter_.isUnbounded() && n % 2 != 0
                ? (this.initialSize_ = n - 1)
                : (this.initialSize_ = n),
                (this.fgScale_ = "" + this.maxRadius_ / this.initialSize_),
                this.updateLayoutCssVars_();
            }),
            (e.prototype.updateLayoutCssVars_ = function () {
              var t = e.strings,
                i = t.VAR_FG_SIZE,
                n = t.VAR_LEFT,
                s = t.VAR_TOP,
                o = t.VAR_FG_SCALE;
              this.adapter_.updateCssVariable(i, this.initialSize_ + "px"),
                this.adapter_.updateCssVariable(o, this.fgScale_),
                this.adapter_.isUnbounded() &&
                  ((this.unboundedCoords_ = {
                    left: Math.round(
                      this.frame_.width / 2 - this.initialSize_ / 2
                    ),
                    top: Math.round(
                      this.frame_.height / 2 - this.initialSize_ / 2
                    ),
                  }),
                  this.adapter_.updateCssVariable(
                    n,
                    this.unboundedCoords_.left + "px"
                  ),
                  this.adapter_.updateCssVariable(
                    s,
                    this.unboundedCoords_.top + "px"
                  ));
            }),
            e
          );
        })(Se);
      /**
       * @license
       * Copyright 2016 Google Inc.
       *
       * Permission is hereby granted, free of charge, to any person obtaining a copy
       * of this software and associated documentation files (the "Software"), to deal
       * in the Software without restriction, including without limitation the rights
       * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
       * copies of the Software, and to permit persons to whom the Software is
       * furnished to do so, subject to the following conditions:
       *
       * The above copyright notice and this permission notice shall be included in
       * all copies or substantial portions of the Software.
       *
       * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
       * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
       * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
       * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
       * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
       * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
       * THE SOFTWARE.
       */
      var Oe = (function (t) {
        function e() {
          var e = (null !== t && t.apply(this, arguments)) || this;
          return (e.disabled = !1), e;
        }
        return (
          be(e, t),
          (e.attachTo = function (t, i) {
            void 0 === i && (i = { isUnbounded: void 0 });
            var n = new e(t);
            return void 0 !== i.isUnbounded && (n.unbounded = i.isUnbounded), n;
          }),
          (e.createAdapter = function (t) {
            return {
              addClass: function (e) {
                return t.root_.classList.add(e);
              },
              browserSupportsCssVars: function () {
                return (function (t, e) {
                  void 0 === e && (e = !1);
                  var i,
                    n = t.CSS;
                  if ("boolean" == typeof Ee && !e) return Ee;
                  if (!n || "function" != typeof n.supports) return !1;
                  var s = n.supports("--css-vars", "yes"),
                    o =
                      n.supports("(--css-vars: yes)") &&
                      n.supports("color", "#00000000");
                  return (i = s || o), e || (Ee = i), i;
                })(window);
              },
              computeBoundingRect: function () {
                return t.root_.getBoundingClientRect();
              },
              containsEventTarget: function (e) {
                return t.root_.contains(e);
              },
              deregisterDocumentInteractionHandler: function (t, e) {
                return document.documentElement.removeEventListener(t, e, ke());
              },
              deregisterInteractionHandler: function (e, i) {
                return t.root_.removeEventListener(e, i, ke());
              },
              deregisterResizeHandler: function (t) {
                return window.removeEventListener("resize", t);
              },
              getWindowPageOffset: function () {
                return { x: window.pageXOffset, y: window.pageYOffset };
              },
              isSurfaceActive: function () {
                return xe(t.root_, ":active");
              },
              isSurfaceDisabled: function () {
                return Boolean(t.disabled);
              },
              isUnbounded: function () {
                return Boolean(t.unbounded);
              },
              registerDocumentInteractionHandler: function (t, e) {
                return document.documentElement.addEventListener(t, e, ke());
              },
              registerInteractionHandler: function (e, i) {
                return t.root_.addEventListener(e, i, ke());
              },
              registerResizeHandler: function (t) {
                return window.addEventListener("resize", t);
              },
              removeClass: function (e) {
                return t.root_.classList.remove(e);
              },
              updateCssVariable: function (e, i) {
                return t.root_.style.setProperty(e, i);
              },
            };
          }),
          Object.defineProperty(e.prototype, "unbounded", {
            get: function () {
              return Boolean(this.unbounded_);
            },
            set: function (t) {
              (this.unbounded_ = Boolean(t)), this.setUnbounded_();
            },
            enumerable: !0,
            configurable: !0,
          }),
          (e.prototype.activate = function () {
            this.foundation_.activate();
          }),
          (e.prototype.deactivate = function () {
            this.foundation_.deactivate();
          }),
          (e.prototype.layout = function () {
            this.foundation_.layout();
          }),
          (e.prototype.getDefaultFoundation = function () {
            return new Me(e.createAdapter(this));
          }),
          (e.prototype.initialSyncWithDOM = function () {
            var t = this.root_;
            this.unbounded = "mdcRippleIsUnbounded" in t.dataset;
          }),
          (e.prototype.setUnbounded_ = function () {
            this.foundation_.setUnbounded(Boolean(this.unbounded_));
          }),
          e
        );
      })(Ce);
      const Fe = (t) => {
        if ("reduceAnimations" in document.body.dataset) return;
        t.querySelectorAll(
          [
            ".button-primary",
            ".button-secondary",
            ".slideshow-slide__button",
            ".product-form--atc-button",
            ".mobile-nav-content .navmenu-link",
            ".mobile-nav-content .navmenu-button",
            ".mobile-nav-primary-content .navmenu-link",
            ".mobile-nav-primary-content .navmenu-button",
            ".live-search-button",
            ".options-selection__radios .options-selection__option-value-name",
            ".countdown-timer__caption-button",
            ".order-page__atc-button",
          ].join(",")
        ).forEach((t) => {
          t.classList.contains("disabled") ||
            t.hasAttribute("disabled") ||
            (t.classList.add("mdc-ripple-surface"), Oe.attachTo(t));
        });
      };
      class qe {
        constructor(t, e) {
          let i =
            arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
          (this.formData = t),
            (this.settings = {
              moneyFormat: null,
              cartRedirection: !1,
              ...e.settings,
            }),
            (this.atcButton = e.atcButton),
            (this.header = document.querySelector("[data-site-header]")),
            (this.announcementBar = document.querySelector(
              "[data-announcement-bar]"
            )),
            (this.utilityBar = document.querySelector("[data-utility-bar]")),
            (this.flyOutSelector = "[data-atc-banner]"),
            (this.atcTemplate = document.querySelector(
              `[data-templates] ${this.flyOutSelector}`
            )),
            (this.recipientForm = document.querySelector(
              "[data-recipient-form]"
            )),
            (this.activeElement = document.activeElement),
            (this.itemId = null),
            (this.flyOut = null),
            (this._onInit = this._onInit.bind(this)),
            (this._onError = this._onError.bind(this)),
            (this._onSuccess = this._onSuccess.bind(this)),
            (this._onCloseAll = this._onCloseAll.bind(this)),
            (this.callbacks = {
              onInit: this._onInit,
              onError: this._onError,
              onSuccess: this._onSuccess,
              onClose: this._onCloseAll,
              ...i,
            }),
            (this._handleDocumentClick = this._handleDocumentClick.bind(this)),
            (this._closeFlyOut = this._closeFlyOut.bind(this)),
            (this._closeEsc = this._closeEsc.bind(this)),
            (this.events = new xt.Z()),
            (this.Images = new ve()),
            (this.messageBanner = null),
            this.callbacks.onInit(),
            this._disableAtcButton(),
            this._updateCart();
        }
        unload() {
          this.messageBanner && this.messageBanner.unload(),
            this._closeFlyOut();
        }
        _updateCart() {
          const t = this.atcTemplate.cloneNode(!0),
            i = this.formData.filter((t) => "quantity" === t.name)[0].value;
          e()
            .ajax({
              type: "POST",
              url: `${window.Theme.routes.cart_add_url}.js`,
              data: e().param(this.formData),
              dataType: "json",
            })
            .done((n) => {
              if (((this.itemId = n.id), n.image)) {
                const e = this.Images.getSizedImageUrl(n.image, "200x");
                this.Images.loadImage(e);
                t.querySelector(
                  "[data-atc-banner-product-image]"
                ).innerHTML = `<img src="${e}" alt="${n.product_title}">`;
              }
              if (
                ((t.querySelector("[data-atc-banner-product-title]").innerHTML =
                  n.product_title),
                "Title" !== n.variant_options[0] &&
                  "Default Title" !== n.variant_options[0])
              ) {
                t.querySelector("[data-atc-banner-product-options]").innerHTML =
                  n.variant_options.join(", ");
              }
              if (n.selling_plan_allocation) {
                t.querySelector(
                  "[data-atc-banner-product-subscription-title]"
                ).innerHTML = n.selling_plan_allocation.selling_plan.name;
              }
              (t.querySelector(
                "[data-atc-banner-product-price-quantity]"
              ).innerHTML = `${i} × `),
                e()
                  .ajax({
                    type: "GET",
                    url: `${window.Theme.routes.cart_url}.js`,
                    dataType: "json",
                  })
                  .done((e) => {
                    this._enableAtcButton();
                    if (
                      this.settings.cartRedirection ||
                      document.body.classList.contains("template-cart")
                    ) {
                      location.href = window.Theme.routes.cart_url;
                      return;
                    }

                    this.callbacks.onSuccess();
                    this.formData = {};
                    let i = null;
                    e.items.forEach((t) => {
                      t.id === this.itemId &&
                        (i
                          ? ((i.line_level_discount_allocations =
                              i.line_level_discount_allocations.concat(
                                t.line_level_discount_allocations
                              )),
                            (i.final_price =
                              i.final_price > t.final_price
                                ? i.final_price
                                : t.final_price),
                            (i.quantity += t.quantity))
                          : (i = t));
                    });
                    const n = t.querySelector(
                      "[data-atc-banner-product-price-value]"
                    );
                    n.innerHTML = Shopify.formatMoney(
                      i.original_price,
                      this.settings.moneyFormat
                    );
                    const s = t.querySelector(
                      "[data-atc-banner-product-price-discounted]"
                    );
                    i.final_price < i.original_price
                      ? ((s.innerHTML = Shopify.formatMoney(
                          i.final_price,
                          this.settings.moneyFormat
                        )),
                        s.classList.remove("hidden"),
                        n.classList.add("original-price"))
                      : (s.classList.add("hidden"),
                        n.classList.remove("original-price"));
                    const o = t.querySelector(
                        "[data-atc-banner-product-discounts]"
                      ),
                      r = t.querySelector("[data-atc-banner-unit-price]");
                    let a = r.innerHTML;
                    if (
                      (r &&
                        i.unit_price_measurement &&
                        ((a = a.replace(
                          "** total_quantity **",
                          `${i.unit_price_measurement.quantity_value}${i.unit_price_measurement.quantity_unit}`
                        )),
                        (a = a.replace(
                          "** unit_price **",
                          Shopify.formatMoney(
                            i.unit_price,
                            this.settings.moneyFormat
                          )
                        )),
                        (a =
                          1 === i.unit_price_measurement.reference_value
                            ? a.replace(
                                "** unit_measure **",
                                i.unit_price_measurement.reference_unit
                              )
                            : a.replace(
                                "** unit_measure **",
                                `${i.unit_price_measurement.reference_value}${i.unit_price_measurement.reference_unit}`
                              )),
                        (r.innerHTML = a),
                        r.classList.remove("hidden")),
                      i.line_level_discount_allocations.length > 0)
                    ) {
                      const t = o.firstElementChild.cloneNode(!0);
                      (o.innerHTML = ""),
                        i.line_level_discount_allocations.forEach((e) => {
                          const i = t.cloneNode(!0),
                            n = i.querySelector(".discount-title"),
                            s = i.querySelector(".discount-amount");
                          (n.innerHTML = e.discount_application.title),
                            (s.innerHTML = Shopify.formatMoney(
                              e.amount,
                              this.settings.moneyFormat
                            )),
                            o.appendChild(i);
                        }),
                        o.classList.remove("hidden");
                    } else o.classList.add("hidden");
                    t.querySelector(
                      "[data-atc-banner-cart-subtotal]"
                    ).innerHTML = Shopify.formatMoney(
                      e.total_price,
                      this.settings.moneyFormat
                    );
                    (t.querySelector(
                      "[data-atc-banner-cart-button] span"
                    ).innerHTML = e.item_count),
                      this.header.appendChild(t),
                      (this.flyOut = t),
                      Fe(this.flyOut);
                    const l = new CustomEvent("cartcount:update", {
                      detail: e,
                    });
                    window.dispatchEvent(l),
                      document.dispatchEvent(new Event("closeFlyouts"));
                    const c = t.querySelector("[data-atc-banner-close]");
                    this.events.register(c, "click", (t) =>
                      this._closeFlyOut(t)
                    ),
                      this.events.register(document, "click", (t) =>
                        this._handleDocumentClick(t)
                      ),
                      this.events.register(document, "touchstart", (t) =>
                        this._handleDocumentClick(t)
                      ),
                      this.events.register(document, "closeFlyouts", (t) =>
                        this._closeFlyOut(t)
                      ),
                      this.events.register(window, "keydown", (t) =>
                        this._closeEsc(t)
                      ),
                      this._enableAtcButton(),
                      (this.atcAnimation = Mt({
                        el: this.flyOut,
                        state: "closed",
                      })),
                      this.atcAnimation.animateTo("open").then(() => {
                        Gt(this.flyOut);
                      });
                  });
            })
            .fail((t) => {
              let e;
              try {
                e = JSON.parse(t.responseText).description;
              } catch (i) {
                (e = `${t.status} ${t.statusText}`),
                  401 === t.status &&
                    (e = `${e}. Try refreshing and logging in.`);
              }
              this._enableAtcButton(),
                e.email
                  ? this.recipientForm.classList.add(
                      "recipient-form--has-errors"
                    )
                  : this.callbacks.onError(e);
            });
        }
        _onError(t) {
          this.messageBanner = new ge(t, "error");
        }
        _onInit() {
          this.messageBanner && this.messageBanner.unload(),
            this.announcementBar &&
              this.announcementBar.style.setProperty(
                "--index-announcement-bar",
                "1100"
              ),
            this.utilityBar &&
              this.utilityBar.style.setProperty("--index-utility-bar", "1100");
        }
        _onSuccess() {}
        _onCloseAll() {}
        _closeEsc(t) {
          "Escape" === t.key && this._closeFlyOut(t);
        }
        _closeFlyOut() {
          this.flyOut &&
            (Xt(this.flyOut),
            this.documentClickEventTarget &&
            "liveSearchInput" in this.documentClickEventTarget.dataset
              ? this.documentClickEventTarget.focus()
              : this.activeElement && this.activeElement.focus(),
            this.atcAnimation.animateTo("closed").then(() => {
              this.announcementBar &&
                this.announcementBar.style.setProperty(
                  "--index-announcement-bar",
                  ""
                ),
                this.utilityBar &&
                  this.utilityBar.style.setProperty("--index-utility-bar", ""),
                this.callbacks.onClose(),
                this.flyOut.remove(),
                (this.flyOut = null),
                this.events.unregisterAll(),
                this.atcAnimation.unload(),
                delete this.Images;
            }));
        }
        _disableAtcButton() {
          this.atcButton.classList.add("processing"),
            this.atcButton.setAttribute("disabled", "disabled");
        }
        _enableAtcButton() {
          this.atcButton.removeAttribute("disabled"),
            this.atcButton.classList.remove("processing");
        }
        _handleDocumentClick(t) {
          const { target: i } = t;
          e()(i).parents("[data-atc-banner]").length ||
            ((this.documentClickEventTarget = i), this._closeFlyOut(t));
        }
      }
      function $e(t) {
        return (
          ($e =
            "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
              ? function (t) {
                  return typeof t;
                }
              : function (t) {
                  return t &&
                    "function" == typeof Symbol &&
                    t.constructor === Symbol &&
                    t !== Symbol.prototype
                    ? "symbol"
                    : typeof t;
                }),
          $e(t)
        );
      }
      var Be =
        "object" ===
        ("undefined" == typeof HTMLElement ? "undefined" : $e(HTMLElement));
      function Ne(t) {
        return Be
          ? t instanceof HTMLElement
          : t &&
              "object" === $e(t) &&
              null !== t &&
              1 === t.nodeType &&
              "string" == typeof t.nodeName;
      }
      function Re(t, e) {
        e.forEach(function (e) {
          t.classList.add(e);
        });
      }
      function ze(t, e) {
        e.forEach(function (e) {
          t.classList.remove(e);
        });
      }
      function He() {
        throw new Error("Missing parameter");
      }
      function Ue(t, e) {
        for (var i = 0; i < e.length; i++) {
          var n = e[i];
          (n.enumerable = n.enumerable || !1),
            (n.configurable = !0),
            "value" in n && (n.writable = !0),
            Object.defineProperty(t, n.key, n);
        }
      }
      var je = (function () {
        function t(e) {
          !(function (t, e) {
            if (!(t instanceof e))
              throw new TypeError("Cannot call a class as a function");
          })(this, t),
            (this.isShowing = !1);
          var i = e.namespace,
            n = void 0 === i ? null : i,
            s = e.zoomFactor,
            o = void 0 === s ? He() : s,
            r = e.containerEl,
            a = void 0 === r ? He() : r;
          (this.settings = { namespace: n, zoomFactor: o, containerEl: a }),
            (this.openClasses = this._buildClasses("open")),
            this._buildElement();
        }
        var e, i, n;
        return (
          (e = t),
          (i = [
            {
              key: "_buildClasses",
              value: function (t) {
                var e = ["drift-".concat(t)],
                  i = this.settings.namespace;
                return i && e.push("".concat(i, "-").concat(t)), e;
              },
            },
            {
              key: "_buildElement",
              value: function () {
                (this.el = document.createElement("div")),
                  Re(this.el, this._buildClasses("bounding-box"));
              },
            },
            {
              key: "show",
              value: function (t, e) {
                (this.isShowing = !0),
                  this.settings.containerEl.appendChild(this.el);
                var i = this.el.style;
                (i.width = "".concat(
                  Math.round(t / this.settings.zoomFactor),
                  "px"
                )),
                  (i.height = "".concat(
                    Math.round(e / this.settings.zoomFactor),
                    "px"
                  )),
                  Re(this.el, this.openClasses);
              },
            },
            {
              key: "hide",
              value: function () {
                this.isShowing &&
                  this.settings.containerEl.removeChild(this.el),
                  (this.isShowing = !1),
                  ze(this.el, this.openClasses);
              },
            },
            {
              key: "setPosition",
              value: function (t, e, i) {
                var n = window.pageXOffset,
                  s = window.pageYOffset,
                  o = i.left + t * i.width - this.el.clientWidth / 2 + n,
                  r = i.top + e * i.height - this.el.clientHeight / 2 + s;
                o < i.left + n
                  ? (o = i.left + n)
                  : o + this.el.clientWidth > i.left + i.width + n &&
                    (o = i.left + i.width - this.el.clientWidth + n),
                  r < i.top + s
                    ? (r = i.top + s)
                    : r + this.el.clientHeight > i.top + i.height + s &&
                      (r = i.top + i.height - this.el.clientHeight + s),
                  (this.el.style.left = "".concat(o, "px")),
                  (this.el.style.top = "".concat(r, "px"));
              },
            },
          ]),
          i && Ue(e.prototype, i),
          n && Ue(e, n),
          t
        );
      })();
      function We(t, e) {
        for (var i = 0; i < e.length; i++) {
          var n = e[i];
          (n.enumerable = n.enumerable || !1),
            (n.configurable = !0),
            "value" in n && (n.writable = !0),
            Object.defineProperty(t, n.key, n);
        }
      }
      var Ve = (function () {
        function t() {
          var e =
            arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
          !(function (t, e) {
            if (!(t instanceof e))
              throw new TypeError("Cannot call a class as a function");
          })(this, t),
            (this._show = this._show.bind(this)),
            (this._hide = this._hide.bind(this)),
            (this._handleEntry = this._handleEntry.bind(this)),
            (this._handleMovement = this._handleMovement.bind(this));
          var i = e.el,
            n = void 0 === i ? He() : i,
            s = e.zoomPane,
            o = void 0 === s ? He() : s,
            r = e.sourceAttribute,
            a = void 0 === r ? He() : r,
            l = e.handleTouch,
            c = void 0 === l ? He() : l,
            h = e.onShow,
            d = void 0 === h ? null : h,
            u = e.onHide,
            p = void 0 === u ? null : u,
            f = e.hoverDelay,
            m = void 0 === f ? 0 : f,
            g = e.touchDelay,
            v = void 0 === g ? 0 : g,
            y = e.hoverBoundingBox,
            b = void 0 === y ? He() : y,
            w = e.touchBoundingBox,
            _ = void 0 === w ? He() : w,
            S = e.namespace,
            C = void 0 === S ? null : S,
            k = e.zoomFactor,
            x = void 0 === k ? He() : k,
            E = e.boundingBoxContainer,
            A = void 0 === E ? He() : E;
          (this.settings = {
            el: n,
            zoomPane: o,
            sourceAttribute: a,
            handleTouch: c,
            onShow: d,
            onHide: p,
            hoverDelay: m,
            touchDelay: v,
            hoverBoundingBox: b,
            touchBoundingBox: _,
            namespace: C,
            zoomFactor: x,
            boundingBoxContainer: A,
          }),
            (this.settings.hoverBoundingBox ||
              this.settings.touchBoundingBox) &&
              (this.boundingBox = new je({
                namespace: this.settings.namespace,
                zoomFactor: this.settings.zoomFactor,
                containerEl: this.settings.boundingBoxContainer,
              })),
            (this.enabled = !0),
            this._bindEvents();
        }
        var e, i, n;
        return (
          (e = t),
          (i = [
            {
              key: "_preventDefault",
              value: function (t) {
                t.preventDefault();
              },
            },
            {
              key: "_preventDefaultAllowTouchScroll",
              value: function (t) {
                (this.settings.touchDelay &&
                  this._isTouchEvent(t) &&
                  !this.isShowing) ||
                  t.preventDefault();
              },
            },
            {
              key: "_isTouchEvent",
              value: function (t) {
                return !!t.touches;
              },
            },
            {
              key: "_bindEvents",
              value: function () {
                this.settings.el.addEventListener(
                  "mouseenter",
                  this._handleEntry,
                  !1
                ),
                  this.settings.el.addEventListener(
                    "mouseleave",
                    this._hide,
                    !1
                  ),
                  this.settings.el.addEventListener(
                    "mousemove",
                    this._handleMovement,
                    !1
                  ),
                  this.settings.handleTouch
                    ? (this.settings.el.addEventListener(
                        "touchstart",
                        this._handleEntry,
                        !1
                      ),
                      this.settings.el.addEventListener(
                        "touchend",
                        this._hide,
                        !1
                      ),
                      this.settings.el.addEventListener(
                        "touchmove",
                        this._handleMovement,
                        !1
                      ))
                    : (this.settings.el.addEventListener(
                        "touchstart",
                        this._preventDefault,
                        !1
                      ),
                      this.settings.el.addEventListener(
                        "touchend",
                        this._preventDefault,
                        !1
                      ),
                      this.settings.el.addEventListener(
                        "touchmove",
                        this._preventDefault,
                        !1
                      ));
              },
            },
            {
              key: "_unbindEvents",
              value: function () {
                this.settings.el.removeEventListener(
                  "mouseenter",
                  this._handleEntry,
                  !1
                ),
                  this.settings.el.removeEventListener(
                    "mouseleave",
                    this._hide,
                    !1
                  ),
                  this.settings.el.removeEventListener(
                    "mousemove",
                    this._handleMovement,
                    !1
                  ),
                  this.settings.handleTouch
                    ? (this.settings.el.removeEventListener(
                        "touchstart",
                        this._handleEntry,
                        !1
                      ),
                      this.settings.el.removeEventListener(
                        "touchend",
                        this._hide,
                        !1
                      ),
                      this.settings.el.removeEventListener(
                        "touchmove",
                        this._handleMovement,
                        !1
                      ))
                    : (this.settings.el.removeEventListener(
                        "touchstart",
                        this._preventDefault,
                        !1
                      ),
                      this.settings.el.removeEventListener(
                        "touchend",
                        this._preventDefault,
                        !1
                      ),
                      this.settings.el.removeEventListener(
                        "touchmove",
                        this._preventDefault,
                        !1
                      ));
              },
            },
            {
              key: "_handleEntry",
              value: function (t) {
                this._preventDefaultAllowTouchScroll(t),
                  (this._lastMovement = t),
                  "mouseenter" == t.type && this.settings.hoverDelay
                    ? (this.entryTimeout = setTimeout(
                        this._show,
                        this.settings.hoverDelay
                      ))
                    : this.settings.touchDelay
                    ? (this.entryTimeout = setTimeout(
                        this._show,
                        this.settings.touchDelay
                      ))
                    : this._show();
              },
            },
            {
              key: "_show",
              value: function () {
                if (this.enabled) {
                  var t = this.settings.onShow;
                  if (
                    (t && "function" == typeof t && t(),
                    this.settings.zoomPane.show(
                      this.settings.el.getAttribute(
                        this.settings.sourceAttribute
                      ),
                      this.settings.el.clientWidth,
                      this.settings.el.clientHeight
                    ),
                    this._lastMovement)
                  ) {
                    var e = this._lastMovement.touches;
                    ((e && this.settings.touchBoundingBox) ||
                      (!e && this.settings.hoverBoundingBox)) &&
                      this.boundingBox.show(
                        this.settings.zoomPane.el.clientWidth,
                        this.settings.zoomPane.el.clientHeight
                      );
                  }
                  this._handleMovement();
                }
              },
            },
            {
              key: "_hide",
              value: function (t) {
                t && this._preventDefaultAllowTouchScroll(t),
                  (this._lastMovement = null),
                  this.entryTimeout && clearTimeout(this.entryTimeout),
                  this.boundingBox && this.boundingBox.hide();
                var e = this.settings.onHide;
                e && "function" == typeof e && e(),
                  this.settings.zoomPane.hide();
              },
            },
            {
              key: "_handleMovement",
              value: function (t) {
                if (t)
                  this._preventDefaultAllowTouchScroll(t),
                    (this._lastMovement = t);
                else {
                  if (!this._lastMovement) return;
                  t = this._lastMovement;
                }
                var e, i;
                if (t.touches) {
                  var n = t.touches[0];
                  (e = n.clientX), (i = n.clientY);
                } else (e = t.clientX), (i = t.clientY);
                var s = this.settings.el.getBoundingClientRect(),
                  o = e - s.left,
                  r = i - s.top,
                  a = o / this.settings.el.clientWidth,
                  l = r / this.settings.el.clientHeight;
                this.boundingBox && this.boundingBox.setPosition(a, l, s),
                  this.settings.zoomPane.setPosition(a, l, s);
              },
            },
            {
              key: "isShowing",
              get: function () {
                return this.settings.zoomPane.isShowing;
              },
            },
          ]) && We(e.prototype, i),
          n && We(e, n),
          t
        );
      })();
      function Ge(t, e) {
        for (var i = 0; i < e.length; i++) {
          var n = e[i];
          (n.enumerable = n.enumerable || !1),
            (n.configurable = !0),
            "value" in n && (n.writable = !0),
            Object.defineProperty(t, n.key, n);
        }
      }
      var Xe = document.createElement("div").style,
        Ze =
          "undefined" != typeof document &&
          ("animation" in Xe || "webkitAnimation" in Xe),
        Qe = (function () {
          function t() {
            var e =
              arguments.length > 0 && void 0 !== arguments[0]
                ? arguments[0]
                : {};
            !(function (t, e) {
              if (!(t instanceof e))
                throw new TypeError("Cannot call a class as a function");
            })(this, t),
              (this._completeShow = this._completeShow.bind(this)),
              (this._completeHide = this._completeHide.bind(this)),
              (this._handleLoad = this._handleLoad.bind(this)),
              (this.isShowing = !1);
            var i = e.container,
              n = void 0 === i ? null : i,
              s = e.zoomFactor,
              o = void 0 === s ? He() : s,
              r = e.inline,
              a = void 0 === r ? He() : r,
              l = e.namespace,
              c = void 0 === l ? null : l,
              h = e.showWhitespaceAtEdges,
              d = void 0 === h ? He() : h,
              u = e.containInline,
              p = void 0 === u ? He() : u,
              f = e.inlineOffsetX,
              m = void 0 === f ? 0 : f,
              g = e.inlineOffsetY,
              v = void 0 === g ? 0 : g,
              y = e.inlineContainer,
              b = void 0 === y ? document.body : y;
            (this.settings = {
              container: n,
              zoomFactor: o,
              inline: a,
              namespace: c,
              showWhitespaceAtEdges: d,
              containInline: p,
              inlineOffsetX: m,
              inlineOffsetY: v,
              inlineContainer: b,
            }),
              (this.openClasses = this._buildClasses("open")),
              (this.openingClasses = this._buildClasses("opening")),
              (this.closingClasses = this._buildClasses("closing")),
              (this.inlineClasses = this._buildClasses("inline")),
              (this.loadingClasses = this._buildClasses("loading")),
              this._buildElement();
          }
          var e, i, n;
          return (
            (e = t),
            (i = [
              {
                key: "_buildClasses",
                value: function (t) {
                  var e = ["drift-".concat(t)],
                    i = this.settings.namespace;
                  return i && e.push("".concat(i, "-").concat(t)), e;
                },
              },
              {
                key: "_buildElement",
                value: function () {
                  (this.el = document.createElement("div")),
                    Re(this.el, this._buildClasses("zoom-pane"));
                  var t = document.createElement("div");
                  Re(t, this._buildClasses("zoom-pane-loader")),
                    this.el.appendChild(t),
                    (this.imgEl = document.createElement("img")),
                    this.el.appendChild(this.imgEl);
                },
              },
              {
                key: "_setImageURL",
                value: function (t) {
                  this.imgEl.setAttribute("src", t);
                },
              },
              {
                key: "_setImageSize",
                value: function (t, e) {
                  (this.imgEl.style.width = "".concat(
                    t * this.settings.zoomFactor,
                    "px"
                  )),
                    (this.imgEl.style.height = "".concat(
                      e * this.settings.zoomFactor,
                      "px"
                    ));
                },
              },
              {
                key: "setPosition",
                value: function (t, e, i) {
                  var n = this.imgEl.offsetWidth,
                    s = this.imgEl.offsetHeight,
                    o = this.el.offsetWidth,
                    r = this.el.offsetHeight,
                    a = o / 2 - n * t,
                    l = r / 2 - s * e,
                    c = o - n,
                    h = r - s,
                    d = c > 0,
                    u = h > 0,
                    p = d ? c / 2 : 0,
                    f = u ? h / 2 : 0,
                    m = d ? c / 2 : c,
                    g = u ? h / 2 : h;
                  if (this.el.parentElement === this.settings.inlineContainer) {
                    var v = window.pageXOffset,
                      y = window.pageYOffset,
                      b =
                        i.left +
                        t * i.width -
                        o / 2 +
                        this.settings.inlineOffsetX +
                        v,
                      w =
                        i.top +
                        e * i.height -
                        r / 2 +
                        this.settings.inlineOffsetY +
                        y;
                    this.settings.containInline &&
                      (b < i.left + v
                        ? (b = i.left + v)
                        : b + o > i.left + i.width + v &&
                          (b = i.left + i.width - o + v),
                      w < i.top + y
                        ? (w = i.top + y)
                        : w + r > i.top + i.height + y &&
                          (w = i.top + i.height - r + y)),
                      (this.el.style.left = "".concat(b, "px")),
                      (this.el.style.top = "".concat(w, "px"));
                  }
                  this.settings.showWhitespaceAtEdges ||
                    (a > p ? (a = p) : a < m && (a = m),
                    l > f ? (l = f) : l < g && (l = g)),
                    (this.imgEl.style.transform = "translate("
                      .concat(a, "px, ")
                      .concat(l, "px)")),
                    (this.imgEl.style.webkitTransform = "translate("
                      .concat(a, "px, ")
                      .concat(l, "px)"));
                },
              },
              {
                key: "_removeListenersAndResetClasses",
                value: function () {
                  this.el.removeEventListener(
                    "animationend",
                    this._completeShow,
                    !1
                  ),
                    this.el.removeEventListener(
                      "animationend",
                      this._completeHide,
                      !1
                    ),
                    this.el.removeEventListener(
                      "webkitAnimationEnd",
                      this._completeShow,
                      !1
                    ),
                    this.el.removeEventListener(
                      "webkitAnimationEnd",
                      this._completeHide,
                      !1
                    ),
                    ze(this.el, this.openClasses),
                    ze(this.el, this.closingClasses);
                },
              },
              {
                key: "show",
                value: function (t, e, i) {
                  this._removeListenersAndResetClasses(),
                    (this.isShowing = !0),
                    Re(this.el, this.openClasses),
                    this.imgEl.getAttribute("src") != t &&
                      (Re(this.el, this.loadingClasses),
                      this.imgEl.addEventListener("load", this._handleLoad, !1),
                      this._setImageURL(t)),
                    this._setImageSize(e, i),
                    this._isInline
                      ? this._showInline()
                      : this._showInContainer(),
                    Ze &&
                      (this.el.addEventListener(
                        "animationend",
                        this._completeShow,
                        !1
                      ),
                      this.el.addEventListener(
                        "webkitAnimationEnd",
                        this._completeShow,
                        !1
                      ),
                      Re(this.el, this.openingClasses));
                },
              },
              {
                key: "_showInline",
                value: function () {
                  this.settings.inlineContainer.appendChild(this.el),
                    Re(this.el, this.inlineClasses);
                },
              },
              {
                key: "_showInContainer",
                value: function () {
                  this.settings.container.appendChild(this.el);
                },
              },
              {
                key: "hide",
                value: function () {
                  this._removeListenersAndResetClasses(),
                    (this.isShowing = !1),
                    Ze
                      ? (this.el.addEventListener(
                          "animationend",
                          this._completeHide,
                          !1
                        ),
                        this.el.addEventListener(
                          "webkitAnimationEnd",
                          this._completeHide,
                          !1
                        ),
                        Re(this.el, this.closingClasses))
                      : (ze(this.el, this.openClasses),
                        ze(this.el, this.inlineClasses));
                },
              },
              {
                key: "_completeShow",
                value: function () {
                  this.el.removeEventListener(
                    "animationend",
                    this._completeShow,
                    !1
                  ),
                    this.el.removeEventListener(
                      "webkitAnimationEnd",
                      this._completeShow,
                      !1
                    ),
                    ze(this.el, this.openingClasses);
                },
              },
              {
                key: "_completeHide",
                value: function () {
                  this.el.removeEventListener(
                    "animationend",
                    this._completeHide,
                    !1
                  ),
                    this.el.removeEventListener(
                      "webkitAnimationEnd",
                      this._completeHide,
                      !1
                    ),
                    ze(this.el, this.openClasses),
                    ze(this.el, this.closingClasses),
                    ze(this.el, this.inlineClasses),
                    this.el.setAttribute("style", ""),
                    this.el.parentElement === this.settings.container
                      ? this.settings.container.removeChild(this.el)
                      : this.el.parentElement ===
                          this.settings.inlineContainer &&
                        this.settings.inlineContainer.removeChild(this.el);
                },
              },
              {
                key: "_handleLoad",
                value: function () {
                  this.imgEl.removeEventListener("load", this._handleLoad, !1),
                    ze(this.el, this.loadingClasses);
                },
              },
              {
                key: "_isInline",
                get: function () {
                  var t = this.settings.inline;
                  return (
                    !0 === t || ("number" == typeof t && window.innerWidth <= t)
                  );
                },
              },
            ]),
            i && Ge(e.prototype, i),
            n && Ge(e, n),
            t
          );
        })();
      function Ye(t, e) {
        for (var i = 0; i < e.length; i++) {
          var n = e[i];
          (n.enumerable = n.enumerable || !1),
            (n.configurable = !0),
            "value" in n && (n.writable = !0),
            Object.defineProperty(t, n.key, n);
        }
      }
      var Ke = (function () {
        function t(e) {
          var i =
            arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
          if (
            ((function (t, e) {
              if (!(t instanceof e))
                throw new TypeError("Cannot call a class as a function");
            })(this, t),
            (this.VERSION = "1.4.1"),
            (this.triggerEl = e),
            (this.destroy = this.destroy.bind(this)),
            !Ne(this.triggerEl))
          )
            throw new TypeError(
              "`new Drift` requires a DOM element as its first argument."
            );
          var n = i.namespace || null,
            s = i.showWhitespaceAtEdges || !1,
            o = i.containInline || !1,
            r = i.inlineOffsetX || 0,
            a = i.inlineOffsetY || 0,
            l = i.inlineContainer || document.body,
            c = i.sourceAttribute || "data-zoom",
            h = i.zoomFactor || 3,
            d = void 0 === i.paneContainer ? document.body : i.paneContainer,
            u = i.inlinePane || 375,
            p = !("handleTouch" in i) || !!i.handleTouch,
            f = i.onShow || null,
            m = i.onHide || null,
            g = !("injectBaseStyles" in i) || !!i.injectBaseStyles,
            v = i.hoverDelay || 0,
            y = i.touchDelay || 0,
            b = i.hoverBoundingBox || !1,
            w = i.touchBoundingBox || !1,
            _ = i.boundingBoxContainer || document.body;
          if (!0 !== u && !Ne(d))
            throw new TypeError(
              "`paneContainer` must be a DOM element when `inlinePane !== true`"
            );
          if (!Ne(l))
            throw new TypeError("`inlineContainer` must be a DOM element");
          (this.settings = {
            namespace: n,
            showWhitespaceAtEdges: s,
            containInline: o,
            inlineOffsetX: r,
            inlineOffsetY: a,
            inlineContainer: l,
            sourceAttribute: c,
            zoomFactor: h,
            paneContainer: d,
            inlinePane: u,
            handleTouch: p,
            onShow: f,
            onHide: m,
            injectBaseStyles: g,
            hoverDelay: v,
            touchDelay: y,
            hoverBoundingBox: b,
            touchBoundingBox: w,
            boundingBoxContainer: _,
          }),
            this.settings.injectBaseStyles &&
              (function () {
                if (!document.querySelector(".drift-base-styles")) {
                  var t = document.createElement("style");
                  (t.type = "text/css"),
                    t.classList.add("drift-base-styles"),
                    t.appendChild(
                      document.createTextNode(
                        ".drift-bounding-box,.drift-zoom-pane{position:absolute;pointer-events:none}@keyframes noop{0%{zoom:1}}@-webkit-keyframes noop{0%{zoom:1}}.drift-zoom-pane.drift-open{display:block}.drift-zoom-pane.drift-closing,.drift-zoom-pane.drift-opening{animation:noop 1ms;-webkit-animation:noop 1ms}.drift-zoom-pane{overflow:hidden;width:100%;height:100%;top:0;left:0}.drift-zoom-pane-loader{display:none}.drift-zoom-pane img{position:absolute;display:block;max-width:none;max-height:none}"
                      )
                    );
                  var e = document.head;
                  e.insertBefore(t, e.firstChild);
                }
              })(),
            this._buildZoomPane(),
            this._buildTrigger();
        }
        var e, i, n;
        return (
          (e = t),
          (i = [
            {
              key: "_buildZoomPane",
              value: function () {
                this.zoomPane = new Qe({
                  container: this.settings.paneContainer,
                  zoomFactor: this.settings.zoomFactor,
                  showWhitespaceAtEdges: this.settings.showWhitespaceAtEdges,
                  containInline: this.settings.containInline,
                  inline: this.settings.inlinePane,
                  namespace: this.settings.namespace,
                  inlineOffsetX: this.settings.inlineOffsetX,
                  inlineOffsetY: this.settings.inlineOffsetY,
                  inlineContainer: this.settings.inlineContainer,
                });
              },
            },
            {
              key: "_buildTrigger",
              value: function () {
                this.trigger = new Ve({
                  el: this.triggerEl,
                  zoomPane: this.zoomPane,
                  handleTouch: this.settings.handleTouch,
                  onShow: this.settings.onShow,
                  onHide: this.settings.onHide,
                  sourceAttribute: this.settings.sourceAttribute,
                  hoverDelay: this.settings.hoverDelay,
                  touchDelay: this.settings.touchDelay,
                  hoverBoundingBox: this.settings.hoverBoundingBox,
                  touchBoundingBox: this.settings.touchBoundingBox,
                  namespace: this.settings.namespace,
                  zoomFactor: this.settings.zoomFactor,
                  boundingBoxContainer: this.settings.boundingBoxContainer,
                });
              },
            },
            {
              key: "setZoomImageURL",
              value: function (t) {
                this.zoomPane._setImageURL(t);
              },
            },
            {
              key: "disable",
              value: function () {
                this.trigger.enabled = !1;
              },
            },
            {
              key: "enable",
              value: function () {
                this.trigger.enabled = !0;
              },
            },
            {
              key: "destroy",
              value: function () {
                this.trigger._hide(), this.trigger._unbindEvents();
              },
            },
            {
              key: "isShowing",
              get: function () {
                return this.zoomPane.isShowing;
              },
            },
            {
              key: "zoomFactor",
              get: function () {
                return this.settings.zoomFactor;
              },
              set: function (t) {
                (this.settings.zoomFactor = t),
                  (this.zoomPane.settings.zoomFactor = t),
                  (this.trigger.settings.zoomFactor = t),
                  (this.boundingBox.settings.zoomFactor = t);
              },
            },
          ]) && Ye(e.prototype, i),
          n && Ye(e, n),
          t
        );
      })();
      Object.defineProperty(Ke.prototype, "isShowing", {
        get: function () {
          return this.isShowing;
        },
      }),
        Object.defineProperty(Ke.prototype, "zoomFactor", {
          get: function () {
            return this.zoomFactor;
          },
          set: function (t) {
            this.zoomFactor = t;
          },
        }),
        (Ke.prototype.setZoomImageURL = Ke.prototype.setZoomImageURL),
        (Ke.prototype.disable = Ke.prototype.disable),
        (Ke.prototype.enable = Ke.prototype.enable),
        (Ke.prototype.destroy = Ke.prototype.destroy);
      let Je = [],
        ti = !1;
      window.onYouTubeIframeAPIReady = () => {
        Je.forEach((t) => t()), (Je = []), (ti = !0);
      };
      class ei {
        constructor(t) {
          let { el: e, videoUrl: i, loop: n } = t;
          (this.el = e),
            (this.id =
              i.match(
                /(?:youtube\.com\/(?:[^\/]+\/.+\/|(?:v|e(?:mbed)?)\/|.*[?&]v=)|youtu\.be\/)([^"&?\/ ]{11})/i
              )[1] || null),
            (this.onApiLoaded = this._onApiLoaded.bind(this)),
            (this.isReady = !1),
            (this.onReady = this._onReady.bind(this)),
            (this.onReadyCallback = null),
            (this.loop = n ? 1 : 0),
            (this.onStateChange = this._onStateChange.bind(this)),
            (this.onPlayCallback = null),
            ti
              ? this._onApiLoaded()
              : (Je.push(this.onApiLoaded),
                s()("https://www.youtube.com/iframe_api"));
        }
        play() {
          return new Promise((t) => {
            (this.onPlayCallback = t),
              this.isReady
                ? this.player.playVideo()
                : (this.onReadyCallback = () => {
                    this.player.playVideo();
                  });
          });
        }
        pause() {
          return new Promise((t) => {
            (this.onPlayCallback = t),
              this.isReady
                ? this.player.pauseVideo()
                : (this.onReadyCallback = () => {
                    this.player.pauseVideo();
                  });
          });
        }
        autoplay() {
          return new Promise((t) => {
            (this.onPlayCallback = t),
              this.isReady
                ? (this.player.playVideo(), this.player.mute())
                : (this.onReadyCallback = () => {
                    this.player.playVideo(), this.player.mute();
                  });
          });
        }
        unload() {
          this.player.destroy();
        }
        _onApiLoaded() {
          const t = {
            modestbranding: !0,
            showinfo: !1,
            controls: !1,
            loop: this.loop,
            rel: 0,
          };
          this.loop && (t.playlist = this.id),
            (this.player = new YT.Player(this.el, {
              videoId: this.id,
              playerVars: t,
              events: {
                onReady: this.onReady,
                onStateChange: this.onStateChange,
              },
            }));
        }
        _onReady() {
          (this.isReady = !0), this.onReadyCallback && this.onReadyCallback();
        }
        _onStateChange(t) {
          const e = t.data;
          this.onPlayCallback &&
            e === YT.PlayerState.BUFFERING &&
            (this.onPlayCallback(), (this.onPlayCallback = null));
        }
      }
      let ii = !1;
      class ni {
        constructor(t) {
          let { el: e, videoUrl: i } = t;
          this.el = e;
          const n = i.split("/");
          (this.id = n[n.length - 1].split("?")[0]),
            (this.onReadyCallback = null),
            (this.onApiLoaded = this._onApiLoaded.bind(this)),
            (this.onProgress = this._onProgress.bind(this)),
            (this.onProgressCallback = null),
            ii
              ? this._onApiLoaded()
              : s()("https://player.vimeo.com/api/player.js", this.onApiLoaded);
        }
        play() {
          return new Promise((t) => {
            (this.onProgressCallback = t),
              ii
                ? (this.player.on("play", this.onProgress), this.player.play())
                : (this.onReadyCallback = () => {
                    this.player.on("play", this.onProgress), this.player.play();
                  });
          });
        }
        pause() {
          return new Promise((t) => {
            (this.onProgressCallback = t),
              ii
                ? (this.player.on("pause", this.onProgress),
                  this.player.pause())
                : (this.onReadyCallback = () => {
                    this.player.on("pause", this.onProgress),
                      this.player.pause();
                  });
          });
        }
        autoplay() {
          return new Promise((t) => {
            (this.onProgressCallback = t),
              ii
                ? (this.player.on("play", this.onProgress),
                  this.player.setVolume(0),
                  this.player.play())
                : (this.onReadyCallback = () => {
                    this.player.on("play", this.onProgress),
                      this.player.setVolume(0),
                      this.player.play();
                  });
          });
        }
        unload() {
          this.player.unload().catch();
        }
        _onApiLoaded() {
          (this.player = new window.Vimeo.Player(this.el, { id: this.id })),
            this.player.ready().then().catch(),
            (ii = !0),
            this.onReadyCallback && this.onReadyCallback();
        }
        _onProgress() {
          this.player.off("play", this.onProgress),
            this.player.off("pause", this.onProgress),
            this.onProgressCallback &&
              (this.onProgressCallback(), (this.onProgressCallback = null));
        }
      }
      class si {
        constructor(t, e) {
          switch (
            ((this.el = t),
            (this.options = e),
            (this.platform = t.getAttribute("data-video").trim()),
            (this.playButton = t.querySelector("[data-video-play-button]")),
            (this.videoEl = t.querySelector("[data-video-element]")),
            (this.onPlayClick = this._onPlayClick.bind(this)),
            (this.onPauseClick = this._onPauseClick.bind(this)),
            (this.autoplay = this._autoplay.bind(this)),
            (this.video = null),
            (this.videoData = {
              el: this.videoEl.childNodes[0],
              videoUrl: this.videoEl.getAttribute("data-video-url"),
              loop: this.options && this.options.loop,
            }),
            this.platform)
          ) {
            case "youtube":
              this.video = new ei(this.videoData);
              break;
            case "vimeo":
              this.video = new ni(this.videoData);
              break;
            default:
              this.video = null;
          }
          this.el.addEventListener("click", this.onPlayClick),
            this.playButton &&
              (this.options && this.options.autoplay && this.autoplay(),
              this.playButton.addEventListener("click", this.onPlayClick));
        }
        _onPlayClick() {
          this.el.classList.add("video-loading"),
            this.video.play().then(() => {
              this.el.classList.add("video-transitioning"),
                setTimeout(() => {
                  this.el.classList.remove("video-loading"),
                    this.el.classList.remove("video-transitioning"),
                    this.el.classList.add("video-playing");
                }, 200);
            });
        }
        _onPauseClick() {
          this.video.pause();
        }
        _autoplay() {
          this.el.classList.add("video-loading"),
            this.video.autoplay().then(() => {
              this.el.classList.add("video-transitioning"),
                setTimeout(() => {
                  this.el.classList.remove("video-loading"),
                    this.el.classList.remove("video-transitioning"),
                    this.el.classList.add("video-playing");
                }, 200);
            });
        }
        play() {
          this._onPlayClick();
        }
        pause() {
          this._onPauseClick();
        }
        unload() {
          this.el.removeEventListener("click", this.onPlayClick),
            this.playButton &&
              this.playButton.removeEventListener("click", this.onPlayClick),
            this.video && this.video.unload();
        }
        destroy() {
          this.unload();
        }
      }
      var oi = i(832),
        ri = i.n(oi),
        ai = i(411),
        li = i.n(ai);
      class ci {
        constructor(t) {
          let {
            settings: e,
            slides: i,
            originalThumbnails: n,
            startIndex: s,
            selectGalleryIndex: o,
          } = t;
          (this.settings = e),
            (this.photoswipeDialog =
              document.querySelector("[data-photoswipe]")),
            (this.thumbContainer = this.photoswipeDialog.querySelector(
              "[data-photoswipe-thumbs]"
            )),
            (this.thumbScroller = this.photoswipeDialog.querySelector(
              "[data-photoswipe-thumb-scroller]"
            )),
            (this.thumbScrollerButtons = this.photoswipeDialog.querySelectorAll(
              "[data-gallery-scroll-button]"
            )),
            (this.closeButton = this.photoswipeDialog.querySelector(
              ".pswp__button--close"
            )),
            (this.selectedSlide = i[s]),
            (this.thumbScroller.innerHTML = ""),
            (this.thumbnails = []);
          let r = s;
          n.forEach((t, e) => {
            if ("image" !== t.dataset.mediaType) return void (s > e && r--);
            const i = t.cloneNode(!0);
            this.thumbScroller.appendChild(i), this.thumbnails.push(i);
          }),
            B.watch(this.thumbContainer),
            (this.selectedThumb = this.thumbContainer.querySelector(
              '[data-gallery-selected="true"]'
            )),
            (this.events = new xt.Z());
          const a = [];
          i.forEach((t) => {
            ["video", "external_video", "model"].indexOf(t.dataset.mediaType) >
              -1 ||
              a.push({
                src: t.dataset.zoom,
                msrc: t.dataset.zoom,
                h: t.dataset.imageHeight,
                w: t.dataset.imageWidth,
              });
          });
          const l = zt.isGreaterThanBreakpoint("L", !0) ? 0 : 75,
            c = {
              index: r,
              barsSize: { top: 0, bottom: l },
              fullscreenEl: !1,
              zoomEl: !1,
              shareEl: !1,
              counterEl: !1,
              arrowEl: !1,
              preloaderEl: !1,
              closeOnScroll: !1,
              showHideOpacity: !0,
              history: !1,
              loop: !0,
              clickToCloseNonZoomable: !1,
              timeToIdle: !1,
              timeToIdleOutside: !1,
            };
          ("always" === this.settings.gallery_click_to_zoom ||
            (zt.isGreaterThanBreakpoint("S", !0) &&
              "desktop" === this.settings.gallery_click_to_zoom) ||
            (zt.isLessThanBreakpoint("S") &&
              "mobile" === this.settings.gallery_click_to_zoom)) &&
            (c.getThumbBoundsFn = () => {
              const t =
                  window.pageYOffset || document.documentElement.scrollTop,
                e = this.selectedSlide
                  .querySelector("[data-rimg]")
                  .getBoundingClientRect();
              return { x: e.left, y: e.top + t, w: e.width };
            }),
            (this.photoswipe = new (ri())(this.photoswipeDialog, li(), a, c)),
            this.events.register(this.closeButton, "click", () =>
              this.photoswipe.close()
            ),
            this.events.register(this.closeButton, "touchstart", () =>
              this.photoswipe.close()
            ),
            this.thumbnails.forEach((t, e) => {
              this.events.register(t, "click", () => {
                this.photoswipe.goTo(e);
              });
            }),
            this.events.register(this.thumbScroller, "scroll", () =>
              this._handleScrollButtonVisibility()
            ),
            this.events.register(this.thumbScrollerButtons[0], "click", () =>
              this._onScrollButtonClick(!0)
            ),
            this.events.register(this.thumbScrollerButtons[1], "click", () =>
              this._onScrollButtonClick(!1)
            ),
            this.photoswipe.options.mouseUsed
              ? (this.photoswipe.options.closeOnVerticalDrag = !1)
              : this.photoswipe.listen("mouseUsed", () => {
                  this.photoswipe.options.closeOnVerticalDrag = !1;
                }),
            this.photoswipe.listen("afterChange", () => {
              const t = this.photoswipe.getCurrentIndex();
              this.selectedThumb &&
                (this.selectedThumb.dataset.gallerySelected = !1),
                (this.selectedThumb = this.thumbnails[t]),
                (this.selectedThumb.dataset.gallerySelected = !0);
              const e = this.selectedThumb.getAttribute("data-gallery-index"),
                n = i[e];
              this._adjustMobileThumbPosition(),
                this._handleScrollButtonVisibility(),
                o(e),
                (this.selectedSlide = n);
            }),
            this.photoswipe.listen("close", () => {
              Xt(this.photoswipeDialog),
                this.selectedSlide.focus(),
                (this.photoswipe = null);
            }),
            this.photoswipe.listen("destroy", () => {
              this.events.unregisterAll(), (this.photoswipe = null);
            }),
            this.events.register(this.thumbContainer, "mouseenter", () => {
              zt.isLessThanBreakpoint("S") &&
                (this.photoswipe.options.closeOnScroll = !0);
            }),
            this.events.register(this.thumbContainer, "mouseleave", () => {
              zt.isLessThanBreakpoint("S") &&
                (this.photoswipe.options.closeOnScroll = !1);
            });
          this.events.register(window, "keydown", (t) =>
            ((t) => {
              "Escape" === t.key &&
                i[0].parentNode.querySelector("[data-gallery-expand]").focus();
            })(t)
          ),
            this.photoswipe.init(),
            Gt(this.photoswipeDialog);
        }
        _adjustMobileThumbPosition() {
          if (zt.isLessThanBreakpoint("S")) {
            const t = this.selectedThumb.getBoundingClientRect(),
              e = this.thumbScroller.getBoundingClientRect();
            t.left + t.width + 30 > e.width
              ? (this.thumbScroller.scrollLeft =
                  this.selectedThumb.offsetLeft + t.width - e.width + 35)
              : this.selectedThumb.offsetLeft < this.thumbScroller.scrollLeft &&
                (this.thumbScroller.scrollLeft =
                  this.selectedThumb.offsetLeft - 35);
          }
        }
        _handleScrollButtonVisibility() {
          zt.isLessThanBreakpoint("S")
            ? (this.thumbScroller.scrollLeft > 4
                ? this.thumbScrollerButtons[0].classList.add("visible")
                : this.thumbScrollerButtons[0].classList.remove("visible"),
              this.thumbScroller.scrollLeft <
              this.thumbScroller.scrollWidth - this.thumbScroller.clientWidth
                ? this.thumbScrollerButtons[1].classList.add("visible")
                : this.thumbScrollerButtons[1].classList.remove("visible"))
            : (this.thumbScrollerButtons[0].classList.remove("visible"),
              this.thumbScrollerButtons[1].classList.remove("visible"));
        }
        _onScrollButtonClick(t) {
          this.thumbScroller.scrollLeft = t
            ? this.thumbScroller.scrollLeft - 100
            : this.thumbScroller.scrollLeft + 100;
        }
        unload() {
          this.photoswipe &&
            (this.photoswipe.destroy(), (this.photoswipe = null));
        }
      }
      let hi = null;
      class di {
        constructor(t) {
          let { el: e, settings: i, isQuickshop: n, sectionContext: s } = t;
          (this.el = e),
            (this.settings = i),
            (this.isQuickshop = n || !1),
            (this.sectionContext = s || "default"),
            (this.events = new xt.Z()),
            (this.viewer = this.el.querySelector("[data-gallery-viewer]")),
            (this.navigation = this.el.querySelector(
              "[data-gallery-navigation]"
            )),
            (this.navScroller = this.el.querySelector(
              "[data-gallery-scroller]"
            )),
            (this.navScrollerButtons = this.el.querySelectorAll(
              "[data-gallery-scroll-button]"
            )),
            (this.figures = this.viewer.querySelectorAll(
              "[data-gallery-figure]"
            )),
            (this.thumbnails = this.navigation.querySelectorAll(
              "[data-gallery-thumbnail]"
            )),
            (this.zoomButton = this.viewer.querySelector(
              "[data-gallery-expand]"
            )),
            (this.selected = {
              figure: this.viewer.querySelector(
                '[data-gallery-selected="true"]'
              ),
              thumbnail: this.navigation.querySelector(
                '[data-gallery-selected="true"]'
              ),
            }),
            (this.models = {}),
            (this.videos = {}),
            (this.selectedVideo = null),
            (this.selectedModel = null),
            (this.showingInitialSlide = !0),
            (this._setupSelectedVideo = this._setupSelectedVideo.bind(this));
          const o = [];
          if (
            (this.el.querySelector('[data-media-type="video"]') &&
              (hi instanceof Promise ||
                (hi = new Promise((t) => {
                  const e = document.createElement("link");
                  e.setAttribute("rel", "stylesheet"),
                    (e.href =
                      "https://cdn.shopify.com/shopifycloud/shopify-plyr/v1.0/shopify-plyr.css"),
                    (e.onload = t),
                    document.body.appendChild(e);
                })),
              o.push({
                name: "video-ui",
                version: "1.0",
                onLoad: () => hi.then(() => this._setupSelectedVideo()),
              })),
            this.el.querySelector('[data-media-type="model"]') &&
              ((this.viewInYourSpaceEl =
                this.el.querySelector("[data-shopify-xr]")),
              this.events.register(this.viewInYourSpaceEl, "click", () =>
                this._onViewInYourSpaceClick()
              ),
              o.push({
                name: "model-viewer-ui",
                version: "1.0",
                onLoad: this._onModelLibraryLoad.bind(this),
              }),
              o.push({ name: "shopify-xr", version: "1.0" })),
            o.length && window.Shopify.loadFeatures(o),
            this.isQuickshop &&
              (B.watch(this.el),
              "video" === this.figures[0].dataset.mediaType &&
                setTimeout(() => this._setSlideHeight(), 800)),
            this.events.register(this.navScroller, "click", (t) =>
              this._onThumbnailClick(t)
            ),
            this.events.register(this.navScroller, "scroll", () =>
              this._handleScrollButtonVisibility()
            ),
            this.events.register(this.navScrollerButtons[0], "click", () =>
              this._onScrollButtonClick(!0)
            ),
            this.events.register(this.navScrollerButtons[1], "click", () =>
              this._onScrollButtonClick(!1)
            ),
            "disabled" !== this.settings.gallery_click_to_zoom)
          ) {
            const t = (t) => {
              t.stopPropagation(), this._openImageZoom();
            };
            this.events.register(this.zoomButton, "click", (e) => t(e)),
              this.events.register(this.viewer, "click", (e) => t(e));
          }
          (this._onResize = this._onResize.bind(this)),
            this.events.register(window, "resize", () => this._onResize()),
            zt.isLessThanBreakpoint("S") &&
              (this._setupFlickity(), this._handleScrollButtonVisibility()),
            this._selectMediaByEl(this.selected.figure);
        }
        selectMediaByVariant(t) {
          if (!t.featured_media) return;
          const e = this.viewer.querySelector(
            `[data-media="${t.featured_media.id}"]`
          );
          this._selectMediaByEl(e);
        }
        unload() {
          this.events.unregisterAll();
          for (let t; t < this.figures.length; t++)
            this.models[t] && this.models[t].destroy(),
              this.videos[t] && this.videos[t].destroy();
          this.isQuickshop && B.unwatch(this.el),
            this._closeImageZoom(),
            this._disableHoverZoom(),
            this._disableFlickity();
        }
        _onModelLibraryLoad() {
          const t = () => {
              this.flickity && this.flickity.unbindDrag();
            },
            e = () => {
              this.flickity && this.flickity.bindDrag();
            };
          this.el.querySelectorAll(".product-gallery--model").forEach((i) => {
            const n = i.querySelector("model-viewer"),
              { galleryIndex: s } = i.dataset,
              o = ["zoom-in", "zoom-out"];
            document.fullscreenEnabled && o.push("fullscreen"),
              (this.models[s] = new Shopify.ModelViewerUI(n, { controls: o })),
              this.events.register(n, "shopify_model_viewer_ui_toggle_play", t),
              this.events.register(
                n,
                "shopify_model_viewer_ui_toggle_pause",
                e
              );
          });
        }
        _onResize() {
          document.fullscreenElement ||
            (zt.isGreaterThanBreakpoint("S", !0)
              ? this._disableFlickity()
              : this._setupFlickity(),
            zt.isGreaterThanBreakpoint("L", !0) && !this.drift
              ? this._setupHoverZoom()
              : zt.isLessThanBreakpoint("L") && this._disableHoverZoom(),
            this._adjustGalleryPositioning(),
            this._handleScrollButtonVisibility());
        }
        _onThumbnailClick(t) {
          let e;
          if (
            ((this.showingInitialSlide = !1),
            t.target.classList.contains("product-gallery--media-thumbnail"))
          )
            e = t.target;
          else {
            if (
              !t.target.parentNode.parentNode.classList.contains(
                "product-gallery--media-thumbnail"
              )
            )
              return;
            e = t.target.parentNode.parentNode;
          }
          const i = parseInt(e.dataset.galleryIndex, 10);
          this.flickity ? this.flickity.select(i) : this._selectMediaByIndex(i);
        }
        _onViewInYourSpaceClick(t) {
          const { currentTarget: e } = t,
            i = this.viewer.querySelector(
              `[data-media="${e.dataset.shopifyModel3dId}"]`
            );
          this._selectMediaByEl(i);
        }
        _selectMediaByEl(t) {
          this._selectMediaByIndex(parseInt(t.dataset.galleryIndex, 10));
        }
        _selectMediaByIndex(t) {
          const e = this.figures[t];
          (this.selected.figure.dataset.gallerySelected = !1),
            this.selected.figure.setAttribute("aria-hidden", !0),
            (this.selected.figure = e),
            (this.selected.figure.dataset.gallerySelected = !0),
            this.selected.figure.setAttribute("aria-hidden", !1);
          const i = parseInt(this.selected.figure.dataset.galleryIndex, 10);
          (this.selected.thumbnail.dataset.gallerySelected = !1),
            (this.selected.thumbnail = this.thumbnails[i]),
            (this.selected.thumbnail.dataset.gallerySelected = !0);
          const { media: n, mediaType: s } = this.selected.figure.dataset;
          switch (
            ((this.viewer.dataset.selectedMediaType = s),
            this._disableHoverZoom(),
            this.selectedModel && this.selectedModel.pause(),
            this.models[e.dataset.galleryIndex] &&
              ((this.selectedModel = this.models[e.dataset.galleryIndex]),
              document.documentElement.classList.contains("has-touch") ||
                this.showingInitialSlide ||
                this.selectedModel.play()),
            this.selectedVideo && this.selectedVideo.pause(),
            this.viewInYourSpaceEl &&
              (this.viewInYourSpaceEl.dataset.shopifyModel3dId =
                this.viewInYourSpaceEl.dataset.defaultModelId),
            s)
          ) {
            case "model":
              this.viewInYourSpaceEl.dataset.shopifyModel3dId = n;
              break;
            case "video":
            case "external_video":
              this._setupSelectedVideo();
              break;
            case "image":
              this._setupHoverZoom();
          }
          this.flickity && (this.flickity.bindDrag(), this.flickity.select(t)),
            this._adjustGalleryPositioning();
        }
        _setupSelectedVideo() {
          this.selectedVideo && this.selectedVideo.pause();
          const { mediaType: t, galleryIndex: e } =
              this.selected.figure.dataset,
            i =
              zt.isGreaterThanBreakpoint("L", !0) &&
              this.settings.gallery_video_autoplay &&
              !this.showingInitialSlide;
          if ("video" === t || "external_video" === t) {
            let n;
            if (this.videos[e])
              (this.selectedVideo = this.videos[e]),
                i && this.selectedVideo.play();
            else {
              if ("video" === t) {
                if (!Shopify.Plyr) return;
                (n = this.selected.figure.querySelector("video")),
                  (this.selectedVideo = new Shopify.Plyr(n, {
                    loop: { active: this.settings.gallery_video_looping },
                  })),
                  i && this.selectedVideo.play();
              } else
                (n = this.selected.figure.querySelector("[data-video]")),
                  (this.selectedVideo = new si(n, {
                    loop: this.settings.gallery_video_looping,
                  })),
                  i && this.selectedVideo.play();
              this.videos[e] = this.selectedVideo;
            }
            this.selected.figure.focus();
          }
        }
        _setupHoverZoom() {
          if (
            "disabled" === this.settings.gallery_hover_zoom ||
            !zt.isGreaterThanBreakpoint("L", !0) ||
            "image" !== this.selected.figure.dataset.mediaType ||
            document.documentElement.classList.contains("has-touch")
          )
            return;
          const t = this.selected.figure.querySelector(
            '[data-rimg]:not([data-rimg="noscript"])'
          );
          t.setAttribute(
            "data-zoom",
            this.selected.figure.getAttribute("data-zoom")
          ),
            (this.drift = new Ke(t, {
              paneContainer:
                "separate" === this.settings.gallery_hover_zoom
                  ? this.el.querySelector("[data-zoomed-image]")
                  : this.selected.figure,
              inlinePane: !1,
              hoverBoundingBox: "separate" === this.settings.gallery_hover_zoom,
              handleTouch: !1,
              onShow: () => {
                if ("separate" === this.settings.gallery_hover_zoom) {
                  const t = document.querySelector(".product-main"),
                    e = document.querySelector(".product-form--alt");
                  t.classList.add("product-gallery--fade"),
                    e && e.classList.add("product-gallery--fade");
                }
              },
              onHide: () => {
                if ("separate" === this.settings.gallery_hover_zoom) {
                  const t = document.querySelector(".product-main"),
                    e = document.querySelector(".product-form--alt");
                  t.classList.remove("product-gallery--fade"),
                    e && e.classList.remove("product-gallery--fade");
                }
              },
            }));
        }
        _disableHoverZoom() {
          this.drift && (this.drift.disable(), (this.drift = null));
        }
        _setupFlickity() {
          !this.flickity &&
            zt.isLessThanBreakpoint("S") &&
            ((this.flickity = new (qt())(this.viewer, {
              accessibility: !1,
              adaptiveHeight: !0,
              cellSelector: ".product-gallery--media",
              contain: !0,
              friction: 0.5,
              freeScroll: !1,
              initialIndex: parseInt(
                this.selected.figure.dataset.galleryIndex,
                10
              ),
              lazyLoad: !1,
              percentPosition: !1,
              prevNextButtons: !1,
              pageDots: !1,
              selectedAttraction: 0.1,
              setGallerySize: !1,
              wrapAround: !0,
            })),
            (this.flickityEvent = this.events.register(
              this.viewer,
              "rimg:load",
              () => {
                this._setSlideHeight();
              }
            )),
            this.flickity.on("change", (t) => {
              (this.showingInitialSlide = !1),
                this._selectMediaByEl(this.figures[t]);
            }),
            this.flickity.on("staticClick", (t, e, i) => {
              const n = i.querySelector(".product-gallery--model");
              if (n && this.models[n.dataset.galleryIndex]) {
                this.models[n.dataset.galleryIndex].play();
              }
            }),
            this.flickity.on("pointerDown", () => {
              this.viewer.blur();
            }),
            "disabled" !== this.settings.gallery_click_to_zoom &&
              document.documentElement.classList.contains("no-touch") &&
              this.flickity.on("dragEnd", () => {
                this.swiped = !0;
              }),
            this._setSlideHeight());
        }
        _disableFlickity() {
          this.flickity &&
            (this.flickity.destroy(),
            (this.flickity = null),
            this.events.unregister(this.flickityEvent));
        }
        _setSlideHeight() {
          this.navigation.classList.remove("loading");
          const t =
            this.storedImageHeight ||
            this.selected.figure.getBoundingClientRect().height;
          (this.storedImageHeight = null),
            0 !== t && (this.viewer.style.height = `${t}px`);
        }
        _adjustGalleryPositioning() {
          if ("left" === this.settings.gallery_thumbnail_position) {
            if (
              (this.isQuickshop &&
                (zt.isGreaterThanBreakpoint("L", !0) &&
                "default" === this.sectionContext
                  ? (this.el.dataset.productGalleryThumbnails = "left")
                  : ((this.storedImageHeight =
                      this.selected.figure.getBoundingClientRect().height),
                    (this.el.dataset.productGalleryThumbnails = "center"))),
              "default" === this.sectionContext &&
                (zt.isGreaterThanBreakpoint("L", !0) ||
                  (zt.isGreaterThanBreakpoint("S", !0) && !this.isQuickshop)))
            ) {
              if (this.el.firstChild !== this.navigation) {
                const t = document.activeElement;
                this.el.insertBefore(this.navigation, this.viewer), t.focus();
              }
              setTimeout(
                () => {
                  const t = this.thumbnails[0].getBoundingClientRect(),
                    e =
                      this.thumbnails[0].currentStyle ||
                      window.getComputedStyle(this.thumbnails[0]),
                    i = 2 * parseInt(e.marginLeft, 10);
                  Array.prototype.some.call(
                    this.thumbnails,
                    (e) => e.getBoundingClientRect().left > t.left
                  ) &&
                    ((this.navigation.style.width = 2 * (t.width + i) + "px"),
                    (this.navigation.style.maxWidth =
                      2 * (t.width + i) + "px")),
                    this._setSlideHeight();
                },
                this.isQuickshop ? 500 : 100
              );
            } else
              this.el.firstElementChild === this.navigation &&
                this.el.appendChild(this.navigation),
                (this.navigation.style.width = ""),
                (this.navigation.style.maxWidth = ""),
                this._setSlideHeight();
            zt.isLessThanBreakpoint("S") &&
              this._adjustMobileThumbnailPosition();
          } else this._setSlideHeight(), this._adjustMobileThumbnailPosition();
        }
        _adjustMobileThumbnailPosition() {
          if (zt.isLessThanBreakpoint("S")) {
            const t = this.selected.thumbnail.getBoundingClientRect(),
              e = this.navScroller.getBoundingClientRect();
            this.selected.thumbnail.offsetLeft +
              t.width +
              30 -
              this.navScroller.scrollLeft >
            e.width
              ? (this.navScroller.scrollLeft =
                  this.selected.thumbnail.offsetLeft + t.width - e.width + 35)
              : this.selected.thumbnail.offsetLeft <
                  this.navScroller.scrollLeft &&
                (this.navScroller.scrollLeft =
                  this.selected.thumbnail.offsetLeft - 35);
          }
        }
        _handleScrollButtonVisibility() {
          zt.isLessThanBreakpoint("S")
            ? (this.navScroller.scrollLeft > 4
                ? this.navScrollerButtons[0].classList.add("visible")
                : this.navScrollerButtons[0].classList.remove("visible"),
              this.navScroller.scrollLeft <
              this.navScroller.scrollWidth - this.navScroller.clientWidth
                ? this.navScrollerButtons[1].classList.add("visible")
                : this.navScrollerButtons[1].classList.remove("visible"))
            : (this.navScrollerButtons[0].classList.remove("visible"),
              this.navScrollerButtons[1].classList.remove("visible"));
        }
        _onScrollButtonClick(t) {
          this.navScroller.scrollLeft = t
            ? this.navScroller.scrollLeft - 100
            : this.navScroller.scrollLeft + 100;
        }
        _closeImageZoom() {
          this.imageZoom && (this.imageZoom.unload(), (this.imageZoom = null));
        }
        _openImageZoom() {
          "image" !== this.selected.figure.dataset.mediaType ||
            (zt.isGreaterThanBreakpoint("L") &&
              "mobile" === this.settings.gallery_click_to_zoom) ||
            (zt.isLessThanBreakpoint("L") &&
              "desktop" === this.settings.gallery_click_to_zoom) ||
            (this.swiped
              ? (this.swiped = !1)
              : (this._closeImageZoom(),
                (this.imageZoom = new ci({
                  settings: this.settings,
                  slides: this.figures,
                  originalThumbnails: this.thumbnails,
                  startIndex: parseInt(
                    this.selected.figure.dataset.galleryIndex,
                    10
                  ),
                  selectGalleryIndex: (t) => this._selectMediaByIndex(t),
                }))));
        }
      }
      class ui {
        constructor(t) {
          (this._el = t),
            (this._reference = this._el.querySelector(
              "[data-payment-terms-reference] shopify-payment-terms"
            )),
            (this._target = this._el.querySelector(
              "[data-payment-terms-target]"
            )),
            this._reference &&
              this._target &&
              ((this._input = document.createElement("input")),
              (this._input.name = "id"),
              (this._input.type = "hidden"),
              this._target.appendChild(this._input),
              this._target.appendChild(this._reference),
              (this._target.style.display = null));
        }
        update(t) {
          this._reference &&
            this._target &&
            ((this._input.value = t),
            this._input.dispatchEvent(new Event("change", { bubbles: !0 })));
        }
      }
      class pi {
        constructor(t) {
          (this.$window = e()(window)),
            (this.$formArea = t.$formArea),
            (this.$details = t.$details),
            (this.context = t.context),
            (this.settings = t.settings),
            (this.product = t.product),
            (this.useHistory = t.useHistory),
            (this.sectionId = t.sectionId),
            (this.el = t.productEl),
            (this.events = new xt.Z()),
            (this.url = window.location.search),
            (this.urlParams = new URLSearchParams(this.url)),
            (this.paymentTerms = new ui(this.el)),
            (this.variantSelection = this.el.querySelector(
              "[data-variant-selection]"
            )),
            (this.select_first_available_variant =
              this.settings.select_first_available_variant),
            (this.recipientFormEl = this.el.querySelector(
              "[data-recipient-form]"
            )),
            (this.surfacePickUpEl = this.el.querySelector(
              "[data-surface-pick-up]"
            )),
            (this.requestFormEl = this.el.querySelector(
              "[data-product-request-form]"
            )),
            this.recipientFormEl && (this.recipientForm = new me(this.el)),
            this.surfacePickUpEl &&
              (this.surfacePickUp = new oe(this.surfacePickUpEl)),
            this.requestFormEl &&
              ((this.requestFormSKU = this.requestFormEl.querySelector(
                "[data-request-form-sku]"
              )),
              (this.requestFormVariant = this.requestFormEl.querySelector(
                "[data-request-form-variant]"
              )),
              (this.requestFormVariantID = this.requestFormEl.querySelector(
                "[data-request-form-variant-id]"
              )),
              new Z(this.requestFormEl),
              !this.select_first_available_variant &&
                this.requestFormVariant &&
                this.requestFormVariantID &&
                (this.requestFormVariant.removeAttribute("name"),
                this.requestFormVariantID.removeAttribute("name")),
              this.events.register(this.requestFormEl, "submit", () => {
                const t = this.requestFormEl.querySelector(
                  "[data-product-request-form-message]"
                );
                "" === t.value &&
                  (t.classList.add("form-field-filled"),
                  (t.innerHTML = this.context.request_message_empty));
              }),
              this.events.register(window, "load", () => {
                this.urlParams.get("contact_posted") &&
                  this.requestFormEl.scrollIntoView({
                    behavior: "smooth",
                    block: "start",
                  });
              })),
            this.product &&
              "media" in this.product &&
              (this.gallery = new di({
                el: t.gallery,
                sectionContext: t.sectionContext,
                settings: this.settings,
                isQuickshop: t.isQuickshop,
              })),
            e()(this.$formArea).length &&
              (this.variantSelection &&
                ((this.isDefaultVariant = !!this.variantSelection.querySelector(
                  "[data-variants].variant-selection__variants--default"
                )),
                this.variantSelection.getVariant().then((t) => {
                  this.surfacePickUp &&
                    this.surfacePickUp.load(t ? t.id : null),
                    this._updateBadge(t),
                    this._updatePrice(t),
                    t || (this._showPriceRange(), this._updateSKU()),
                    this.events.register(
                      this.variantSelection,
                      "variant-change",
                      (t) => this._switchVariant(t.detail)
                    );
                })),
              (this.modal = new ee({
                onClose: () => this.modal.unload(),
                modalId: 1,
              })),
              this.surfacePickUp &&
                this.surfacePickUp.onModalRequest((t) => {
                  let e = this.$formArea[0].querySelector(
                    "[data-surface-pick-up-modal-contents]"
                  );
                  this.variantSelection.getVariant().then((i) => {
                    const n = this.isDefaultVariant
                        ? ""
                        : `<div class="surface-pick-up-modal__variant">${i.title}</div>`,
                      s = `\n            <div class="surface-pick-up-modal__header">\n              <h2 class="surface-pick-up-modal__title">${this.product.title}</h2>\n              ${n}\n            </div>\n            ${t}\n            `;
                    e
                      ? (e.innerHTML = s)
                      : ((e = document.createElement("div")),
                        e.setAttribute(
                          "data-surface-pick-up-modal-contents",
                          ""
                        ),
                        (e.style.display = "none"),
                        (e.innerHTML = s),
                        this.$formArea[0].appendChild(e)),
                      this.modal.open(
                        "[data-surface-pick-up-modal-contents]",
                        "surface-pick-up"
                      );
                  });
                }),
              (this.addToCartFlyout = null),
              (this.atcCallbacks = t.atcCallbacks),
              (this.$form = this.$formArea.find("[data-product-form]")),
              (this.$productAtcButton =
                this.$formArea.find("[data-product-atc]")),
              (this.$productVariants = this.$form.find("[data-variants]")),
              (this.$productOptions = this.$form.find("[data-product-option]")),
              (this.productPricing = this.$details[0].querySelector(
                "[data-product-pricing]"
              )),
              (this.detailsLink = this.$formArea[0].querySelector(
                "[data-product-details-link]"
              )),
              (this.quantitySelector = this.el.querySelector(
                "[data-quantity-selector]"
              )),
              this.detailsLink &&
                (this.detailsBaseHref = this.detailsLink.getAttribute("href")),
              (this.variantFields = {
                $priceContainer: this.$details.find("[data-price-container]"),
                $priceMoney: this.$details.find(
                  "[data-price-container] [data-price]"
                ),
                $compareAtPrice: this.$details.find(
                  "[data-price-compare-container]"
                ),
                $compareAtPriceMoney: this.$details.find(
                  "[data-price-compare-container] [data-price-compare]"
                ),
                $badge: this.$details.find("[data-badge-sales]"),
                $badgeRange: this.$details.find("[data-badge-sales-range]"),
                $badgeSingle: this.$details.find("[data-badge-sales-single]"),
                $sku: this.$details.find("[data-product-sku]"),
                stockLevels:
                  this.$details[0].querySelectorAll("[data-stock-level]"),
                unitPrice: this.$details[0].querySelector("[data-unit-price]"),
                totalQuantity: this.$details[0].querySelector(
                  "[data-total-quantity]"
                ),
                unitPriceAmount: this.$details[0].querySelector(
                  "[data-unit-price-amount]"
                ),
                unitPriceMeasure: this.$details[0].querySelector(
                  "[data-unit-price-measure]"
                ),
                taxLine: this.$details[0].querySelector("[data-tax-line]"),
                hiddenComparePrice: this.$details[0].querySelector(
                  "[data-compare-price-hidden]"
                ),
                hiddenCurrentPrice: this.$details[0].querySelector(
                  "[data-current-price-hidden]"
                ),
                hiddenComparePriceRange: this.$details[0].querySelector(
                  "[data-compare-price-range-hidden]"
                ),
                hiddenCurrentPriceRange: this.$details[0].querySelector(
                  "[data-current-price-range-hidden]"
                ),
              }),
              this.quantitySelector &&
                (this.productQuantityBox = new Et({
                  quantityField: this.quantitySelector,
                })),
              (this.forms = new Z(this.$form)),
              this.product && this._bindEvents());
        }
        unload() {
          this.$form && this.$form.off(`.product-details-${this.sectionId}`),
            this.forms && this.forms.unload(),
            this.gallery && this.gallery.unload(),
            this.messageBanner && this.messageBanner.unload(),
            this.events.unregisterAll();
        }
        _bindEvents() {
          this.$form.on(`submit.product-details-${this.sectionId}`, (t) =>
            this._addToCartFlyout(t)
          );
        }
        _switchVariant(t) {
          const { variant: i } = t;
          if (
            (this.productPricing &&
              (this.productPricing.style.visibility = i ? "visible" : "hidden"),
            this.$productVariants.val(i.id),
            this.gallery && this.gallery.selectMediaByVariant(i),
            this.surfacePickUp && this.surfacePickUp.load(i.id),
            this._updatePrice(i),
            this._updateSKU(i),
            this._updateBadge(i),
            this._updateButton(i),
            this._updateSwatchLabel(i),
            this._updateFullDetailsLink(i),
            this._updateUnitPrice(i),
            this._updateStockLevels(i),
            this.paymentTerms.update(i.id),
            Shopify.PaymentButton && Shopify.PaymentButton.init(),
            this.useHistory)
          ) {
            const t = `${this.product.handle}?${e().param({ variant: i.id })}`;
            history.replaceState({}, "variant", t);
          }
          this.requestFormEl &&
            !this.urlParams.get("contact_posted") &&
            ((this.requestFormVariant.value = i.title),
            (this.requestFormVariantID.value = i.id),
            "" === this.requestFormSKU.value
              ? this.requestFormSKU.removeAttribute("name")
              : this.requestFormSKU.setAttribute("name", "contact[sku]"),
            this.select_first_available_variant ||
              (this.requestFormVariant.setAttribute("name", "contact[variant]"),
              this.requestFormVariantID.setAttribute("name", "contact[id]")));
        }
        _updateStockLevels(t) {
          this.variantFields.stockLevels.forEach((e) => {
            const i = Number(e.dataset.stockVariantId);
            t.id === i
              ? e.setAttribute("data-stock-variant-selected", "true")
              : e.setAttribute("data-stock-variant-selected", "false");
          });
        }
        _updatePrice(t) {
          if (!this.productPricing) return;
          const e = this.variantFields.hiddenComparePrice.innerHTML,
            i = this.variantFields.hiddenCurrentPrice.innerHTML;
          (this.variantFields.$compareAtPrice[0].innerHTML = e),
            (this.variantFields.$priceContainer[0].innerHTML = i),
            (this.variantFields.$priceMoney = this.$details.find(
              "[data-price-container] [data-price]"
            )),
            (this.variantFields.$compareAtPriceMoney = this.$details.find(
              "[data-price-compare-container] [data-price-compare]"
            ));
          const n = !!t.compare_at_price && t.compare_at_price > t.price;
          this.variantFields.$compareAtPrice.toggleClass("visible", n),
            this.variantFields.$compareAtPriceMoney.text(
              Shopify.formatMoney(
                t.compare_at_price,
                this.settings.money_format
              )
            ),
            this.variantFields.$priceMoney.text(
              Shopify.formatMoney(t.price, this.settings.money_format)
            );
        }
        _showPriceRange() {
          this._updateBadge(!1);
          const t = this.product.price_varies,
            e = this.product.variants.some(
              (t) =>
                (t.compare_at_price || t.price) !==
                this.product.compare_at_price
            ),
            i = t
              ? this.variantFields.hiddenCurrentPriceRange.innerHTML
              : this.variantFields.hiddenCurrentPrice.innerHTML,
            n = e
              ? this.variantFields.hiddenComparePriceRange.innerHTML
              : this.variantFields.hiddenComparePrice.innerHTML,
            s = this.product.compare_at_price_max > this.product.price_min;
          this.variantFields.$compareAtPrice.toggleClass("visible", s),
            (this.variantFields.$compareAtPrice[0].innerHTML = n),
            (this.variantFields.$priceContainer[0].innerHTML = i);
        }
        _updateSKU() {
          let t =
            arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
          t
            ? ("" === t.sku
                ? this.variantFields.$sku
                    .parent()
                    .addClass("product-sku--empty")
                : (this.variantFields.$sku
                    .parent()
                    .removeClass("product-sku--empty"),
                  this.variantFields.$sku.parent().show()),
              this.variantFields.$sku.text(t.sku),
              this.requestFormEl &&
                !this.urlParams.get("contact_posted") &&
                (this.requestFormSKU.value = t.sku))
            : this.variantFields.$sku.parent().hide();
        }
        _updateBadge() {
          let t =
            arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
          if (t) {
            const e = t.compare_at_price ? t.compare_at_price - t.price : 0;
            if (e <= 0) this.variantFields.$badge.toggle(!1);
            else {
              this.variantFields.$badgeRange.toggle(!1),
                this.variantFields.$badgeSingle.toggle(!!e),
                this.variantFields.$badge.toggle(!!e);
              const i = this.variantFields.$badgeSingle.find(
                  "[data-price-money-saved]"
                ),
                n = this.variantFields.$badgeSingle.find(
                  "[data-price-percent-saved]"
                );
              if (
                (i.length &&
                  i.text(Shopify.formatMoney(e, this.settings.money_format)),
                n.length)
              ) {
                const i = Math.round((100 * e) / t.compare_at_price);
                n.text(i);
              }
            }
          } else {
            const t = this.product.compare_at_price
              ? this.product.compare_at_price_max - this.product.price_min
              : 0;
            t <= 0
              ? this.variantFields.$badge.toggle(!1)
              : (this.variantFields.$badgeSingle.toggle(!1),
                this.variantFields.$badgeRange.toggle(!!t),
                this.variantFields.$badge.toggle(!!t));
          }
        }
        _updateButton(t) {
          t
            ? t.available
              ? (this.$productAtcButton[0].hasAttribute(
                  "data-product-atc-preorder"
                )
                  ? this.$productAtcButton.text(this.context.product_preorder)
                  : this.$productAtcButton.text(this.context.product_available),
                this.$productAtcButton
                  .removeClass("disabled")
                  .prop("disabled", !1))
              : (this.$productAtcButton.text(this.context.product_sold_out),
                this.$productAtcButton
                  .addClass("disabled")
                  .prop("disabled", !0))
            : (this.$productAtcButton.text(this.context.product_unavailable),
              this.$productAtcButton.addClass("disabled").prop("disabled", !0));
        }
        _updateSwatchLabel(t) {
          if (this.settings.swatches_enable) {
            const e = this.$form[0].querySelector("[data-option-swatch-value]");
            e &&
              (e.innerText =
                t.options[parseInt(e.dataset.optionSwatchValue, 10)]);
          }
        }
        _updateFullDetailsLink(t) {
          this.detailsLink &&
            this.detailsLink.setAttribute(
              "href",
              `${this.detailsBaseHref}?variant=${t.id}`
            );
        }
        _updateUnitPrice(t) {
          this.variantFields.unitPrice && t.unit_price_measurement
            ? ((this.variantFields.totalQuantity.innerHTML = `${t.unit_price_measurement.quantity_value}${t.unit_price_measurement.quantity_unit}`),
              (this.variantFields.unitPriceAmount.innerHTML =
                Shopify.formatMoney(t.unit_price, this.settings.money_format)),
              1 === t.unit_price_measurement.reference_value
                ? (this.variantFields.unitPriceMeasure.innerHTML =
                    t.unit_price_measurement.reference_unit)
                : (this.variantFields.unitPriceMeasure.innerHTML = `${t.unit_price_measurement.reference_value}${t.unit_price_measurement.reference_unit}`),
              this.variantFields.unitPrice.classList.remove("hidden"))
            : this.variantFields.unitPrice &&
              this.variantFields.unitPrice.classList.add("hidden"),
            this.variantFields.taxLine &&
              (t.taxable
                ? this.variantFields.taxLine.classList.remove("hidden")
                : this.variantFields.taxLine.classList.add("hidden"));
        }
        _addToCartFlyout(t) {
          t.preventDefault(),
            this.recipientFormEl &&
              this.recipientFormEl.classList.remove(
                "recipient-form--has-errors"
              ),
            this.variantSelection.getVariant().then((t) => {
              if (!t)
                return (
                  (this.messageBanner = new ge(
                    this.context.select_variant,
                    "error"
                  )),
                  void this.$form
                    .get(0)
                    .classList.add("product-form--error-option-unselected")
                );
              this.addToCartFlyout && this.addToCartFlyout.unload();
              const e = this.$form.serializeArray(),
                i = {
                  atcButton: this.$productAtcButton[0],
                  settings: {
                    moneyFormat: this.settings.money_format,
                    cartRedirection: this.settings.cart_redirection,
                  },
                };
              this.addToCartFlyout = new qe(e, i, this.atcCallbacks);
            });
        }
      }
      const fi = () => {
        window.SPR &&
          (window.SPR.registerCallbacks(),
          window.SPR.initRatingHandler(),
          window.SPR.initDomEls(),
          window.SPR.loadProducts(),
          window.SPR.loadBadges());
      };
      class mi {
        constructor(t) {
          (this.$el = t.$el),
            (this.id = t.id),
            (this.sectionContext = t.sectionContext),
            (this.initialVariant = t.initialVariant || null),
            (this.quickShopSelector = t.quickShopSelector
              ? t.quickShopSelector
              : `#shopify-section-${this.id} [data-product-quickshop]`),
            (this.$quickShop = e()(this.quickShopSelector)),
            (this.quickshopSpinner =
              this.$quickShop[0].querySelector(".quickshop-spinner")),
            (this.modalClass = t.modalClass),
            (this.loaded = !1),
            (this.richText = null),
            (this.productDetails = null),
            (this.trigger = t.trigger),
            (this.isOpen = !1),
            (this.openingAddToCart = !1),
            (this.modal = t.modal ? t.modal : null),
            (this.quickshopContainer = t.quickshopContainer
              ? t.quickshopContainer
              : null),
            (this.view = t.view ? t.view : "product-quickshop"),
            (this.url = t.productUrl
              ? t.productUrl
              : this.$el.data("product-quickshop-url")),
            (this.modalCallbacks = {
              onOpen: this._open.bind(this),
              onClose: this._close.bind(this),
            }),
            (this.atcCallbacks = {
              onInit: this._onATCInit.bind(this),
              onError: this._onATCError.bind(this),
              onSuccess: this._onATCSuccess.bind(this),
              onClose: this._onATCClose.bind(this),
            }),
            this._initialize();
        }
        _initialize() {
          null == this.modal &&
            ((this.modal = new ee(this.modalCallbacks)),
            this.modal.open(this.quickShopSelector, this.modalClass)),
            (this.isOpen = !0);
          let t = this.modal.$modalInner.find("[data-modal-content]");
          this.quickshopContainer && (t = e()(this.quickshopContainer)),
            fetch(
              this.url.indexOf("?") >= 0
                ? `${this.url}&view=quickshop`
                : `${this.url}?view=quickshop`
            )
              .then((t) => t.text())
              .then((e) => {
                const i = new DOMParser().parseFromString(e, "text/html"),
                  n = i.querySelector("[data-product-wrapper]"),
                  s = i.querySelector('[data-section-type="static-product"]');
                (this.productSettings = JSON.parse(s.innerHTML)),
                  this.isOpen &&
                    (t.html(n.innerHTML),
                    fi(),
                    Fe(t[0]),
                    window.Shopify &&
                      Shopify.PaymentButton &&
                      Shopify.PaymentButton.init(),
                    (this.$message = t.find(
                      "[data-product-quickshop-message]"
                    )),
                    (this.$formArea = t.find("[data-product-form-area]")),
                    (this.gallery = t[0].querySelector(
                      "[data-product-gallery]"
                    )),
                    (this.$details = t.find("[data-product-details]")),
                    (this.$description = t.find("[data-product-description]")),
                    (this.productEl = t[0]),
                    (this.context = this.productSettings.context),
                    (this.settings = this.productSettings.settings),
                    (this.product = this.productSettings.product),
                    this._onQuickshopLoaded());
              })
              .catch();
        }
        _onQuickshopLoaded() {
          if (this.loaded) return;
          this.$description &&
            this.$description.length &&
            (this.richText = new X(this.$description));
          const t = {
            $formArea: this.$formArea,
            gallery: this.gallery,
            $details: this.$details,
            atcCallbacks: this.atcCallbacks,
            context: this.productSettings.context,
            sectionContext: this.sectionContext,
            settings: this.productSettings.settings,
            product: this.productSettings.product,
            useHistory: !1,
            isQuickshop: !0,
            initialVariant: this.initialVariant,
            productEl: this.productEl,
          };
          this.modal.position(),
            this.modal.finishedLoading(),
            (this.loaded = !0),
            window.requestAnimationFrame(() => {
              this.productDetails = new pi(t);
            });
        }
        _open() {}
        _close() {
          this.openingAddToCart || this.trigger.focus(),
            (this.loaded = !1),
            (this.isOpen = !1),
            this.$quickShop.empty(),
            this.$quickShop.html(this.quickshopSpinner),
            this._toggleMessage("", !1),
            this.modal.unload();
        }
        _toggleMessage(t, e) {
          this.$message && this.$message.html(t).toggleClass("visible", e);
        }
        _onATCInit() {
          (this.openingAddToCart = !0), this.$message.removeClass("visible");
        }
        _onATCError(t) {
          const i = e()(
            `<div class="product-message--error" tabindex="-1">${t}</div>`
          );
          this._toggleMessage(i, !0), i.focus();
        }
        _onATCSuccess() {
          this._close();
        }
        _onATCClose() {}
        unload() {
          return this.isLoaded
            ? this._close().then(() => {
                this.productDetails && this.productDetails.unload(),
                  this.richText && this.richText.unload();
              })
            : Promise.resolve();
        }
      }
      let gi = null;
      class vi {
        constructor(t) {
          (this.el = t.el),
            (this.setInitialVariant = t.setInitialVariant),
            (this.expanded = !1),
            (this.swatchImages = {}),
            (this.swatchVariantIds = {}),
            (this.selectedImage = null),
            (this.state = {}),
            (this.events = new xt.Z()),
            (this.data = JSON.parse(
              this.el.querySelector("[data-swatch-data]").innerHTML
            )),
            (this.variants = this.data.variants),
            (this.swatchesContainer = this.el.querySelector(
              "[data-swatches-container]"
            )),
            (this.cardLinks = this.el.querySelectorAll(
              "[data-product-page-link]"
            )),
            (this.cardLinkHref = this.cardLinks[0].getAttribute("href")),
            (this.activeControlTime = 0),
            (this.activeControl =
              this.swatchesContainer.querySelector("[checked]")),
            (this.isPreselected = !!this.activeControl),
            (this.swatches =
              this.swatchesContainer.querySelectorAll("[data-swatch]")),
            (this.swatchCount = this.swatches.length),
            (this.swatchCountWrapper = this.el.querySelector(
              "[data-swatch-count-wrapper]"
            )),
            (this.swatchCount = this.swatchCountWrapper.querySelector(
              "[data-swatch-count]"
            )),
            (this.swatchWidths = Array.prototype.map.call(
              this.swatches,
              (t) => t.getBoundingClientRect().width
            )),
            this.resize(),
            this.el.querySelector("[data-swatches]").classList.add("processed"),
            (this.originalImages = {
              primary: this.el.querySelector(".productitem--image-primary"),
              alternate: this.el.querySelector(".productitem--image-alternate"),
            }),
            this.disableUnavailable(),
            this.events.register(
              window,
              "resize",
              tt()(() => this.resize(), 50)
            ),
            this.events.register(this.swatchCountWrapper, "click", () =>
              this._toggleExpanded()
            ),
            (this.injectImagesMouseoverEvent = this.events.register(
              this.el,
              "mouseover",
              () => this._injectImages()
            )),
            (this.injectImagesFocusinEvent = this.events.register(
              this.el,
              "focusin",
              () => this._injectImages()
            )),
            this.events.register(this.swatchesContainer, "mouseover", (t) =>
              this._handleMouseOver(t)
            ),
            this.events.register(this.swatchesContainer, "mouseleave", (t) =>
              this._handleMouseLeave(t)
            ),
            this.events.register(this.swatchesContainer, "click", (t) =>
              this._handleClick(t)
            ),
            this.events.register(this.swatchesContainer, "change", (t) =>
              this._handleChange(t)
            ),
            this.events.register(this.swatchesContainer, "focusin", (t) =>
              this._handleSwatchFocus(t)
            );
        }
        disableUnavailable() {
          if (!this.variants) return;
          const t = {};
          this.variants.forEach((e) => {
            e.available && (t[e[this.data.swatchOptionKey]] = !0);
          });
          this.swatchesContainer
            .querySelectorAll('input[name="swatch"]')
            .forEach((e) => {
              e.value in t ||
                (e.classList.add("swatch-disabled"),
                e.classList.contains("sold_out_option--selectable") ||
                  (e.disabled = !0));
            });
        }
        resize() {
          this.expanded && this._toggleExpanded();
          const t =
            this.swatchesContainer.getBoundingClientRect().width -
            parseInt(
              window.getComputedStyle(this.swatchesContainer).paddingRight,
              10
            );
          let e = this.swatches.length,
            i = 0;
          for (let n = 0; n < this.swatches.length; n++) {
            if (!(i + this.getSwatchGap() + this.swatchWidths[n] < t)) {
              e = n;
              break;
            }
            i += gi + this.swatchWidths[n];
          }
          e !== this.showSwatchCount &&
            ((this.showSwatchCount = e),
            this.swatches.forEach((t, e) => {
              e < this.showSwatchCount
                ? (t.classList.add("productitem--swatches-swatch-visible"),
                  t.classList.remove("productitem--swatches-swatch-hidden"))
                : (t.classList.remove("productitem--swatches-swatch-visible"),
                  t.classList.add("productitem--swatches-swatch-hidden"));
            }),
            (this.swatchCountWrapper.style.left = `${i}px`),
            this.swatches.length > this.showSwatchCount
              ? ((this.swatchCountWrapper.style.display = "flex"),
                (this.swatchCount.innerText =
                  "+" + (this.swatches.length - this.showSwatchCount)))
              : (this.swatchCountWrapper.style.display = "none"));
        }
        _injectImages() {
          this.events.unregister(this.injectImagesFocusinEvent),
            this.events.unregister(this.injectImagesMouseoverEvent),
            kt.load(this.cardLinkHref, "product-swatch-data").then((t) => {
              let { data: e } = t;
              if (this.imagesInjected) return;
              this.imagesInjected = !0;
              const i = document.createDocumentFragment();
              if (e.featuredImage) {
                const t = document.createElement("div");
                t.innerHTML = e.featuredImage;
                const n = t.querySelector("img");
                i.appendChild(n), (this.featuredImage = n);
              }
              e.swatches.forEach((t) => {
                let { swatchValue: e, imageString: n, variantId: s } = t;
                if (((this.swatchVariantIds[e] = s), n)) {
                  const t = document.createElement("div");
                  t.innerHTML = n;
                  const s = t.querySelector("img");
                  i.appendChild(s), (this.swatchImages[e] = s);
                }
              });
              const n = this.el.querySelector("[data-product-item-image]"),
                s = n.querySelector("[data-badge-sales]");
              n.insertBefore(i, s),
                B.watch(n),
                this._setState({
                  swatchName: this.activeControl
                    ? this.activeControl.value
                    : null,
                  primaryImage: this.originalImages.primary,
                  hideAlternateImage: !!this.activeControl,
                });
            });
        }
        _setState(t) {
          let { swatchName: e, primaryImage: i, hideAlternateImage: n } = t;
          const s = this.state.primaryImage,
            o = e
              ? `${this.cardLinkHref}?variant=${this.swatchVariantIds[e]}`
              : this.cardLinkHref;
          this.cardLinks.forEach((t) => t.setAttribute("href", o)),
            this.setInitialVariant(
              this.swatchVariantIds[e] || this.variants[0].id
            ),
            s &&
              (s.classList.remove("productitem--image-primary"),
              (s.style.visibility = "")),
            i &&
              (i.classList.add("productitem--image-primary"),
              (i.style.visibility = n ? "visible" : "")),
            this.originalImages.alternate &&
              (this.originalImages.alternate.style.visibility = n
                ? "hidden"
                : ""),
            (this.state = {
              swatchName: e,
              primaryImage: i,
              hideAlternateImage: n,
            });
        }
        _handleChange(t) {
          let { target: e } = t;
          (this.activeControlTime = Date.now()), (this.activeControl = e);
          const i = e.value;
          (this.selectedImage =
            this.swatchImages[i] || this.originalImages.primary),
            this._setState({
              swatchName: i,
              primaryImage: this.selectedImage,
              hideAlternateImage: !0,
            });
        }
        _handleClick(t) {
          let { target: e } = t;
          e === this.activeControl &&
            this.activeControlTime + 150 < Date.now() &&
            ((e.checked = !1),
            (this.activeControl = null),
            (this.selectedImage = null),
            this.isPreselected &&
              this.featuredImage &&
              ((this.originalImages.primary = this.featuredImage),
              (this.isPreselected = !1)),
            this._setState({
              swatchName: null,
              primaryImage: this.state.primaryImage,
              hideAlternateImage: !0,
            }));
        }
        _handleMouseOver(t) {
          t.target.hasAttribute("data-swatch-tooltip") &&
            this._setState({
              swatchName: this.state.swatchName,
              primaryImage:
                this.swatchImages[t.target.dataset.swatchTooltip] ||
                this.originalImages.primary,
              hideAlternateImage: !0,
            });
        }
        _handleMouseLeave(t) {
          let { target: e } = t;
          e.hasAttribute("data-swatches-container") &&
            this._setState({
              swatchName: this.state.swatchName,
              primaryImage: this.selectedImage || this.originalImages.primary,
              hideAlternateImage: !!this.selectedImage,
            });
        }
        _handleSwatchFocus(t) {
          let { target: e } = t;
          !1 === this.expanded &&
            e.nextElementSibling.classList.contains(
              "productitem--swatches-swatch-hidden"
            ) &&
            this._toggleExpanded();
        }
        _toggleExpanded() {
          const t = this.el.querySelector("[data-swatches]");
          this.expanded
            ? ((this.expanded = !1),
              t.classList.remove("productitem--swatches-expanded"),
              (this.swatchCount.innerText =
                "+" + (this.swatches.length - this.showSwatchCount)))
            : ((this.expanded = !0),
              t.classList.add("productitem--swatches-expanded"));
        }
        getSwatchGap() {
          return (
            null === gi &&
              (gi = parseInt(
                window
                  .getComputedStyle(this.swatches[0])
                  .getPropertyValue("margin-right"),
                10
              )),
            gi
          );
        }
        unload() {
          this.events.unregisterAll();
        }
      }
      const yi = "pxuProductCompareV3";
      const bi = new (class {
        constructor() {
          (this._hasToggle = !!document.querySelector("[data-compare-toggle]")),
            (this.breadCrumb = document.querySelector(
              "[data-product-compare-breadcrumb-data]"
            )),
            this.breadCrumb &&
              (this.breadCrumbData = JSON.parse(this.breadCrumb.innerHTML)),
            (this._state = this._getState()),
            (this._onUpdateCallbacks = []),
            (this._onEnableChangeCallbacks = []),
            document.addEventListener("visibilitychange", () => {
              "hidden" === document.visibilityState &&
                ((this._state.returnBreadcrumb = this._getReturnBreadcrumb()),
                this._save());
            });
        }
        add(t) {
          let { handle: e, data: i } = t;
          this._state.products.push({ handle: e, data: i }),
            this._runUpdateCallbacks(),
            this._save();
        }
        remove(t) {
          (this._state.products = this._state.products.filter(
            (e) => e.handle !== t
          )),
            this._runUpdateCallbacks(),
            this._state.products.length || this._onRemoveLastProduct(),
            this._save();
        }
        removeAll() {
          (this._state.products = []),
            this._runUpdateCallbacks(),
            this._onRemoveLastProduct(),
            this._save();
        }
        includes(t) {
          return this._state.products.some((e) => e.handle === t);
        }
        runOnUpdate(t) {
          this._onUpdateCallbacks.push(t);
        }
        removeRunOnUpdate(t) {
          this._onUpdateCallbacks = this._onUpdateCallbacks.filter(
            (e) => e !== t
          );
        }
        get enabled() {
          return this._state.enabled;
        }
        enable() {
          this._state.enabled ||
            ((this._state.enabled = !0),
            this._runEnableChangeCallbacks(),
            this._save());
        }
        disable() {
          this._state.enabled &&
            ((this._state.enabled = !1),
            this._runEnableChangeCallbacks(),
            this._state.products.length && this.removeAll(),
            this._save());
        }
        addRunOnEnableChange(t) {
          this._onEnableChangeCallbacks.push(t);
        }
        removeRunOnEnableChange(t) {
          this._onEnableChangeCallbacks = this._onEnableChangeCallbacks.filter(
            (e) => e !== t
          );
        }
        get products() {
          return this._state.products;
        }
        get atProductLimit() {
          return this._state.products.length >= 3;
        }
        get returnBreadcrumb() {
          return this._state.returnBreadcrumb;
        }
        _runUpdateCallbacks() {
          const t = {
            products: this._state.products,
            atProductLimit: this.atProductLimit,
          };
          this._onUpdateCallbacks.forEach((e) => e(t));
        }
        _runEnableChangeCallbacks() {
          this._onEnableChangeCallbacks.forEach((t) => t(this.enabled));
        }
        _onRemoveLastProduct() {
          this._hasToggle || this.disable();
        }
        _getReturnBreadcrumb() {
          return this.breadCrumbData && this.breadCrumbData.update
            ? { url: window.location.href, title: this.breadCrumbData.title }
            : this._state.returnBreadcrumb;
        }
        _getState() {
          const t = this._load();
          if (t) {
            const e = !(!this._hasToggle && !t.products.length) && t.enabled;
            return { ...t, enabled: e };
          }
          return { products: [], returnBreadcrumb: null, enabled: !1 };
        }
        _load() {
          try {
            return JSON.parse(sessionStorage.getItem(yi));
          } catch (t) {
            return null;
          }
        }
        _save() {
          sessionStorage.setItem(yi, JSON.stringify(this._state));
        }
      })();
      class wi {
        constructor(t) {
          (this.checkmark = t.querySelector(".checkmark")),
            (this.checkmarkCheck = t.querySelector(".checkmark__check")),
            (this.checkmarkIndeterminate = t.querySelector(
              ".checkmark__indeterminate"
            ));
          const e = "unchecked";
          (this.fillAnimation = Mt({ el: this.checkmark, state: e })),
            (this.checkAnimation = Mt({ el: this.checkmarkCheck, state: e })),
            (this.indeterminateCheckAnimation = Mt({
              el: this.checkmarkIndeterminate,
              state: e,
            }));
        }
        check() {
          this.fillAnimation.animateTo("checked"),
            this.checkAnimation.animateTo("checked");
        }
        uncheck() {
          this.fillAnimation.animateTo("unchecked"),
            this.checkAnimation.animateTo("unchecked");
        }
        setIndeterminate() {
          this.fillAnimation.animateTo("indeterminate"),
            this.indeterminateCheckAnimation.animateTo("indeterminate");
        }
        unsetIndeterminate() {
          this.fillAnimation.animateTo("unchecked"),
            this.indeterminateCheckAnimation.animateTo("unchecked");
        }
        set disabled(t) {
          this.checkmark.classList.toggle("checkmark--disabled", t);
        }
        unload() {
          this.fillAnimation.unload(),
            this.checkAnimation.unload(),
            this.indeterminateCheckAnimation.unload();
        }
      }
      class _i {
        constructor(t) {
          (this.el = t.el),
            (this.$el = e()(t.el)),
            (this.id = t.id),
            (this.disableActionsToggle =
              "disableActionsToggle" in t && t.disableActionsToggle),
            (this.productQuickshop = null),
            (this.quickshopInitialVariant = null),
            (this.quickBuySettings = null),
            (this.actionsOpen = !1),
            (this.defaultView = t.grid_list),
            (this.events = new xt.Z()),
            t.lazy
              ? (this.lazyLoader = new Ht(this.$el[0], () => this._init()))
              : this._init();
        }
        _init() {
          if (
            ((this.$window = e()(window)),
            (this.$html = e()("html")),
            (this.content = this.el.querySelector(
              "[data-product-item-content]"
            )),
            (this.actions = this.el.querySelector("[data-product-actions]")),
            (this.swatchesEl = this.el.querySelector("[data-swatches]")),
            (this.quickBuyEl = this.el.querySelector("[data-quick-buy]")),
            (this.quickshopSlimEl = this.el.querySelector(
              "[data-quickshop-slim]"
            )),
            (this.quickshopFullEl = this.el.querySelector(
              "[data-quickshop-full]"
            )),
            (this.compareCheckbox = this.el.querySelector(
              "[data-compare-checkbox]"
            )),
            (this.compareItem = this.el.querySelector("[data-compare-item]")),
            (this.compareItemWrapper = this.el.querySelector(
              "[data-compare-item-wrapper]"
            )),
            (this.hasProductActions = null !== this.actions),
            (this._addToCart = this._addToCart.bind(this)),
            (this._actionsToggle = this._actionsToggle.bind(this)),
            (this._openQuickShop = this._openQuickShop.bind(this)),
            this.hasProductActions &&
              (this._setSortByQueryParameters(),
              !this.disableActionsToggle &&
                this.$html.hasClass("no-touch") &&
                "list-view" !== this.defaultView &&
                (this.events.register(this.el, "mouseenter", (t) =>
                  this._actionsToggle(t)
                ),
                this.events.register(this.el, "mouseleave", (t) =>
                  this._actionsToggle(t)
                ),
                this.events.register(this.el, "focusin", (t) =>
                  this._actionsToggle(t)
                )),
              s()(e()("[data-scripts]").data("shopify-api-url"), () => {
                this.events.register(this.quickBuyEl, "click", (t) =>
                  this._addToCart(t)
                ),
                  this.events.register(this.quickshopSlimEl, "click", (t) =>
                    this._openQuickShop(t)
                  ),
                  this.events.register(this.quickshopFullEl, "click", (t) =>
                    this._openQuickShop(t)
                  );
              })),
            (this.expandAnimation = Mt({ el: this.content, state: "closed" })),
            this.compareCheckbox)
          ) {
            (this.compareData = JSON.parse(
              this.el.querySelector("[data-product-compare-data]").innerHTML
            )),
              (this.expandCheckboxAnimation = Mt({
                el: this.compareItemWrapper,
                state: "closed",
              })),
              (this.compareItemCheckbox = new wi(this.compareItem)),
              this.events.register(this.compareCheckbox, "change", () =>
                this._updateProductCompare(this.compareCheckbox.checked)
              );
            const t = (t) => {
              let { atProductLimit: e } = t;
              bi.includes(this.compareData.handle)
                ? ((this.compareCheckbox.disabled = !1),
                  (this.compareItemCheckbox.disabled = !1),
                  this.compareItem.classList.add(
                    "productitem__compare--enabled"
                  ),
                  this.compareItem.classList.remove(
                    "productitem__compare--disabled"
                  ),
                  (this.compareCheckbox.checked = !0),
                  this.compareItemCheckbox.check())
                : ((this.compareCheckbox.checked = !1),
                  this.compareItemCheckbox.uncheck(),
                  (this.compareCheckbox.disabled = e),
                  (this.compareItemCheckbox.disabled = e),
                  this.compareItem.classList.toggle(
                    "productitem__compare--enabled",
                    !e
                  ),
                  this.compareItem.classList.toggle(
                    "productitem__compare--disabled",
                    e
                  ));
            };
            t({ atProductLimit: bi.atProductLimit }), bi.runOnUpdate(t);
            const e = (t) => {
              t
                ? this._showCompareCheckbox()
                : this.actionsOpen || this._hideCompareCheckbox();
            };
            e(bi.enabled), bi.addRunOnEnableChange(e);
          }
          null !== this.quickbuyEl && this._initQuickBuy(),
            this._objectFitPolyfill(),
            this.swatchesEl &&
              (this.swatches = new vi({
                el: this.$el[0],
                setInitialVariant: (t) => {
                  this.quickshopInitialVariant = t;
                },
                product: this.product,
              }));
        }
        _updateProductCompare(t) {
          const {
            handle: e,
            title: i,
            image: n,
            imageAspectRatio: s,
            url: o,
          } = this.compareData;
          e &&
            (t
              ? (bi.enable(),
                bi.add({
                  handle: e,
                  data: { title: i, image: n, imageAspectRatio: s, url: o },
                }))
              : bi.remove(e));
        }
        _setSortByQueryParameters() {
          if (((Shopify.queryParams = {}), location.search.length))
            for (
              let t = 0, e = location.search.substr(1).split("&");
              t < e.length;
              t++
            ) {
              const i = e[t].split("=");
              i.length > 1 &&
                "page" !== i[0] &&
                (Shopify.queryParams[decodeURIComponent(i[0])] = i[1]);
            }
        }
        _initQuickBuy() {
          try {
            this.quickBuySettings = JSON.parse(
              this.$el.find("[data-quick-buy-settings]").text()
            );
          } catch (t) {
            console.warn(
              `Quick buy: invalid QuickBuy data found. ${t.message}`
            );
          }
        }
        _openQuickShop(t) {
          t.preventDefault();
          const e = t.currentTarget.hasAttribute("data-thumbs-left")
              ? " quickshop-thumbs-left"
              : "",
            i = t.currentTarget.hasAttribute("data-quickshop-full")
              ? `quickshop-full${e}`
              : "quickshop-slim";
          this.productQuickshop && this.productQuickshop.unload(),
            (this.productQuickshop = new mi({
              $el: this.$el,
              id: this.id,
              modalClass: i,
              trigger: this.$el.find(".productitem--title a"),
              initialVariant: this.quickshopInitialVariant,
            }));
        }
        _isObjectFitAvailable() {
          return "objectFit" in document.documentElement.style;
        }
        _objectFitPolyfill() {
          if (this._isObjectFitAvailable()) return;
          const t = e()("[data-product-item-image]", this.$el),
            i = e()("img:not(.productitem--image-alternate)", t).attr("src"),
            n = e()(".productitem--image-alternate", t).attr("src");
          t.addClass("product-item-image-no-objectfit"),
            t.css("background-image", `url("${i}")`),
            n &&
              (this.events.register(this.el, "mouseover", () => {
                t.css("background-image", `url("${n}")`);
              }),
              this.events.register(this.el, "mouseleave", () => {
                t.css("background-image", `url("${i}")`);
              }));
        }
        _getHeights() {
          const { height: t } = this.el.getBoundingClientRect();
          return {
            heightBase: t,
            heightExpanded: t + this.actions.getBoundingClientRect().height,
          };
        }
        _actionsToggle(t) {
          if (!zt.isGreaterThanBreakpoint("M")) return;
          const i = e()(t.currentTarget),
            n = e()(t.target);
          let s = !1;
          const o =
            this.$el.is(i) ||
            this.$el.is(n) ||
            this.$el.is(n.parents(".productgrid--item").first()) ||
            ("focusin" === t.type && n[0].contains(this.$el[0]));
          "mouseenter" === t.type || "mouseleave" === t.type
            ? (s = "mouseenter" === t.type)
            : o && (s = !0),
            s ? this._showActions() : this._hideActions();
        }
        _showActions() {
          if (this.actionsOpen) return;
          const { heightBase: t, heightExpanded: e } = this._getHeights();
          this._showCompareCheckbox().then((i) => {
            this.el.style.setProperty("--base-height", `${t}px`),
              this.expandAnimation.animateTo("open"),
              (this.focusinEvent = this.events.register(
                document,
                "focusin",
                (t) => this._actionsToggle(t)
              )),
              (this.actionsOpen = !0);
          });
        }
        _hideActions() {
          this.expandAnimation.animateTo("closed").then(() => {
            this.el.style.removeProperty("--base-height"),
              this.el.removeAttribute("data-open");
          }),
            this._hideCompareCheckbox(),
            this.focusinEvent && this.events.unregister(this.focusinEvent),
            (this.actionsOpen = !1);
        }
        _showCompareCheckbox() {
          return this.expandCheckboxAnimation &&
            "open" !== this.expandCheckboxAnimation.state
            ? new Promise((t) => {
                this.expandCheckboxAnimation.animateTo("open", {
                  onStart: (e) => {
                    let { el: i } = e;
                    const { scrollHeight: n } = i.querySelector(
                      "[data-compare-item]"
                    );
                    this.el.style.setProperty("--compare-height", `${n}px`),
                      t(n);
                  },
                });
              })
            : Promise.resolve(0);
        }
        _hideCompareCheckbox() {
          this.expandCheckboxAnimation &&
            (bi.enabled ||
              this.expandCheckboxAnimation.animateTo("closed").then(() => {
                this.el.style.setProperty("--compare-height", "0px");
              }));
        }
        _addToCart(t) {
          t.preventDefault(),
            this.addToCartFlyout && this.addToCartFlyout.unload();
          const e = t.currentTarget,
            i = [
              { name: "id", value: e.getAttribute("data-variant-id") },
              { name: "quantity", value: 1 },
            ],
            n = {
              atcButton: e,
              settings: {
                moneyFormat: this.quickBuySettings.money_format,
                cartRedirection: this.quickBuySettings.cart_redirection,
              },
            };
          this.addToCartFlyout = new qe(i, n);
        }
        unload() {
          this.events.unregisterAll(),
            this.productQuickshop && this.productQuickshop.unload(),
            document.removeEventListener("focusin", this._actionsToggle),
            this.swatches && this.swatches.unload(),
            this.lazyLoader && this.lazyLoader.unload();
        }
      }
      const Si = (t) => {
        t.style.setProperty("--menu-open-height", `${t.scrollHeight}px`);
      };
      class Ci {
        constructor(t) {
          let e =
            arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
          (this.el = t),
            (this.options = {
              content: "[data-accordion-content]",
              animate: !0,
              onStart: () => {},
              ...e,
            }),
            (this.blocks = new Map());
        }
        closeAll() {
          let t =
            arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
          this.el
            .querySelectorAll(this.options.content)
            .forEach((e) => this.close(e, t));
        }
        openAll() {
          let t =
            arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
          this.el
            .querySelectorAll(this.options.content)
            .forEach((e) => this.open(e, t));
        }
        open(t) {
          let e =
            arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
          this._open(t, e);
        }
        close(t) {
          let e =
            arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
          this._close(t, e);
        }
        toggle(t) {
          let e =
            arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
          const { isOpen: i } = this._getBlock(t);
          i ? this._close(t, e) : this._open(t, e);
        }
        unload() {
          this.blocks.forEach((t) => {
            let { animation: e } = t;
            return e.unload();
          });
        }
        _getBlock(t) {
          const e = t.matches(this.options.content)
            ? t
            : t.querySelector(this.options.content);
          return (
            this.blocks.has(e) ||
              this.blocks.set(
                e,
                ((t) => ({
                  animation: Mt({
                    el: t,
                    state: "open",
                    stateAttribute: "data-accordion-state",
                    stateChangeAttribute: "data-accordion-animation",
                  }),
                  isOpen: !0,
                }))(e)
              ),
            this.blocks.get(e)
          );
        }
        _open(t, e) {
          let { onComplete: i = () => {}, force: n = !this.options.animate } =
            e;
          const s = this._getBlock(t);
          s.isOpen ||
            ((s.isOpen = !0),
            this.options.onStart({ el: s.animation.el, state: "open" }),
            s.animation
              .animateTo("open", {
                force: n,
                onStart: (t) => {
                  let { el: e } = t;
                  return Si(e);
                },
              })
              .then((t) => {
                "open" === t && i();
              }));
        }
        _close(t, e) {
          let { onComplete: i = () => {}, force: n = !this.options.animate } =
            e;
          const s = this._getBlock(t);
          s.isOpen &&
            ((s.isOpen = !1),
            this.options.onStart({ el: s.animation.el, state: "closed" }),
            Si(s.animation.el),
            s.animation.animateTo("closed", { force: n }).then((t) => {
              "closed" === t && i();
            }));
        }
      }
      class ki {
        constructor(t, e) {
          (this.el = t),
            (this.filterGroupsSetting = e.groups),
            (this.filterStyleSetting = e.style),
            (this.Accordion = new Ci(t)),
            this._closeAllGroups(),
            (this.activeMenuClass = "filter-group-active"),
            (this.activeButtonClass = "productgrid--sidebar-button-active"),
            (this.buttonSelector = "[data-filter-group-trigger]"),
            (this.listSelector = "[data-accordion-content]"),
            (this.buttonTriggers = this.el.querySelectorAll(
              this.buttonSelector
            )),
            (this.events = new xt.Z()),
            this.buttonTriggers.forEach((t) =>
              this.events.register(t, "click", (t) => this._toggleGroup(t))
            ),
            this._init();
        }
        _init() {
          if (this.el.querySelector(this.listSelector))
            if ("tags" === this.filterStyleSetting && Ot.max("S"))
              this._openFirst();
            else
              switch (this.filterGroupsSetting) {
                case "expand_all":
                  this._openAllGroups();
                  break;
                case "expand_first":
                  this._openFirst();
                  break;
                default:
                  this._closeAllGroups();
              }
        }
        _openFirst() {
          const t = this.el.querySelector(this.buttonSelector),
            e = t.parentElement.querySelector(this.listSelector);
          this.openGroup(t, e, !0);
        }
        _openAllGroups() {
          this.buttonTriggers.forEach((t) => {
            const e = t.parentElement.querySelector(this.listSelector);
            this.openGroup(t, e, !0);
          });
        }
        _closeAllGroups() {
          this.Accordion.closeAll({ force: !0 });
        }
        _toggleGroup(t) {
          const e = t.target,
            i = e.parentElement.querySelector(this.listSelector);
          i.classList.contains(this.activeMenuClass)
            ? this._closeGroup(e, i)
            : this.openGroup(e, i);
        }
        openGroup(t, e) {
          let i =
            arguments.length > 2 && void 0 !== arguments[2] && arguments[2];
          e.classList.add(this.activeMenuClass),
            t.classList.add(this.activeButtonClass);
          this.Accordion.open(e, {
            onComplete: () => {
              t.setAttribute("aria-expanded", !0);
            },
            force: i,
          });
        }
        _closeGroup(t, e) {
          e.classList.remove(this.activeMenuClass),
            t.classList.remove(this.activeButtonClass);
          this.Accordion.close(e, {
            onComplete: () => {
              t.setAttribute("aria-expanded", !1);
            },
          });
        }
        unload() {
          this.events.unregisterAll();
        }
      }
      class xi {
        constructor(t) {
          if (
            ((this.section = t),
            (this.$el = e()(t.el)),
            (this.el = t.el),
            (this.view = null),
            (this.flickity = null),
            (this.handleEvents = new xt.Z()),
            (this.subcollectionSlideshow = this.el.querySelector(
              '[data-subcollections-layout="slideshow"]'
            )),
            (this.slides = this.el.querySelectorAll(
              "[data-subcollections-grid-item]"
            )),
            this._shouldInitFlickity(Ot)
              ? this._initFlickity()
              : this._destroyFlickity(),
            (this.context = t.data.context),
            (this.showFilterProductCount = t.data.show_filter_product_count),
            (this.productCount = t.data.product_count),
            (this.filterGroups = t.data.filter_groups),
            (this.filterStyle = t.data.filter_style),
            (this.noMatchedProductsText = t.data.no_matched_products_text),
            (this.collectionUrl = this.context.collectionUrl),
            (this.currentTags = this.context.current_tags),
            (this.$focusItem = null),
            (this.defaultView = this.context.grid_list),
            (this.postMessage = t.postMessage),
            (this.filterType = t.data.filter_type),
            (this.filtersContentSelector =
              "[data-productgrid-filters-content]"),
            (this.filterGroupSelector = "[data-productgrid-sidebar-group]"),
            (this.sortContent = "[data-productgrid-sort-content]"),
            (this.$sortTrigger = this.$el.find(
              "[data-productgrid-trigger-sort]"
            )),
            (this.$sortTriggerButton = this.$el.find(
              "[data-productgrid-trigger-sort-button]"
            )),
            (this.$sortTriggerModal = this.$el.find(
              "[data-productgrid-modal-sort]"
            )),
            (this.$filtersTrigger = this.$el.find(
              "[data-productgrid-trigger-filters]"
            )),
            (this.$filtersContent = this.$el.find(this.filtersContentSelector)),
            (this.$allTags = this.$filtersContent.find(
              ".filter-item a:not([data-filter-toggle])"
            )),
            (this.$advancedTags = this.$el.find("[data-tag-advanced] a")),
            (this.$additionalTags = this.$el.find("[data-filter-toggle]")),
            (this.$viewToggle = this.$el.find("[data-collection-view]")),
            (this.gridContainer = this.el.querySelector(".productgrid--outer")),
            (this.$description = this.$el.find(
              "[data-collection-description]"
            )),
            (this.filterCheckboxes = this.el.querySelectorAll(
              ".filter-icon--checkbox"
            )),
            (this.stickyUtils = this.el.querySelector("[data-sticky-utils]")),
            (this.stickyUtilsIntersectionTarget = this.el.querySelector(
              "[data-utils-intersection-target]"
            )),
            (this.header = document.querySelector("[data-site-header]")),
            (this.stickyHeaderClass = "site-header-sticky"),
            (this.compareToggle = this.el.querySelector(
              "[data-compare-toggle]"
            )),
            (this._changeSorting = this._changeSorting.bind(this)),
            (this._changeSortingButton = this._changeSortingButton.bind(this)),
            (this._showSortModal = this._showSortModal.bind(this)),
            (this._showFiltersModal = this._showFiltersModal.bind(this)),
            (this._activateTag = this._activateTag.bind(this)),
            (this._advancedTags = this._advancedTags.bind(this)),
            (this._toggleTags = this._toggleTags.bind(this)),
            (this._toggleView = this._toggleView.bind(this)),
            (this._checkListView = this._checkListView.bind(this)),
            (this.events = [
              this.$sortTrigger.on("change.collection", this._changeSorting),
              this.$sortTriggerButton.on(
                "click.collection",
                this._changeSortingButton
              ),
              this.$sortTriggerModal.on(
                "click.collection",
                this._showSortModal
              ),
              this.$filtersTrigger.on(
                "click.collection",
                this._showFiltersModal
              ),
              this.$allTags.on("click.collection", (t) =>
                this._activateTag(t.currentTarget)
              ),
              this.$additionalTags.on("click.collection", this._toggleTags),
              this.$viewToggle.on("click.collection", this._toggleView),
            ]),
            this.$description.length &&
              (this.richText = new X(this.$description)),
            (this.productItems = []),
            (this.fillAnimations = {}),
            (this.checkAnimations = {}),
            this._initAnimations(),
            this._setSortByQueryParameters(),
            this._checkListView(),
            this.section.data.enable_product_compare &&
              this._initProductCompare(),
            Ot.max("S") && this._initProductGridUtils(),
            (this.handleEls = t.el.querySelectorAll("[data-handle]")),
            (this.handles = []),
            this.handleEls.forEach((t) => {
              this.handles.push(t.dataset.handle);
            }),
            (this.modal = new ee()),
            this.$filtersContent.length > 0)
          ) {
            const t = { groups: this.filterGroups, style: this.filterStyle };
            (this.filterGroupAccordions = new ki(this.$filtersContent[0], t)),
              this._initTags();
          }
          (this.handleBreakpointChange = (t) => this.onBreakpointChange(t)),
            Ot.onChange(this.handleBreakpointChange);
        }
        _initProductCompare() {
          const t = (t) => {
            this.compareToggle.checked = t;
          };
          t(bi.enabled),
            bi.addRunOnEnableChange(t),
            this.handleEvents.register(this.compareToggle, "change", () => {
              this.compareToggle.checked ? bi.enable() : bi.disable();
            });
        }
        _initAnimations() {
          this.filterCheckboxes.forEach((t) => {
            const e = t.dataset.handle,
              i = t.querySelector(".checkmark"),
              n = t.querySelector(".checkmark__check");
            let s = "unchecked";
            "true" === t.closest(".filter-item").dataset.filterActive &&
              (s = "checked");
            const o = Mt({ el: i, state: s }),
              r = Mt({ el: n, state: s });
            (this.fillAnimations[e] = o), (this.checkAnimations[e] = r);
          });
        }
        onSectionUnload() {
          this._destroyFlickity(),
            Ot.offChange(this.handleBreakpointChange),
            this.handleEvents.unregisterAll(),
            this.events.forEach((t) => t.off(".collection")),
            this.modal.unload(),
            Object.keys(this.fillAnimations).forEach((t) => {
              this.fillAnimations[t].unload(), this.checkAnimations[t].unload();
            }),
            this.productItems.forEach((t) => {
              t.unload();
            }),
            this.$filtersContent.length > 0 &&
              this.filterGroupAccordions.unload(),
            this.observer && this.observer.disconnect();
        }
        _initFlickity() {
          if (this.flickity) return;
          this.flickity = new (qt())(this.subcollectionSlideshow, {
            autoPlay: 0,
            accessibility: !0,
            cellAlign: "left",
            cellSelector: "[data-subcollections-grid-item]",
            groupCells: !0,
            contain: !0,
            pageDots: !1,
            arrowShape:
              "M65.29 11.99L27.28 50L65.3 87.99L70.25 83.06L37.19 50L70.26 16.94L65.29 11.99Z",
          });
          const t =
              this.subcollectionSlideshow.querySelector(".flickity-viewport"),
            e = this.subcollectionSlideshow.querySelector(".flickity-slider"),
            i = document.createElement("div");
          i.classList.add("flickity-slider--wrapper"),
            t.appendChild(i),
            i.appendChild(e),
            this.handleEvents.register(
              this.subcollectionSlideshow,
              "rimg:load",
              () => {
                this.flickity && this.flickity.resize();
              }
            );
        }
        _destroyFlickity() {
          this.flickity && (this.flickity.destroy(), (this.flickity = null));
        }
        _initProductItems() {
          let t =
            arguments.length > 0 && void 0 !== arguments[0]
              ? arguments[0]
              : "grid-view";
          this.$el.find("[data-product-item]").each((e, i) => {
            this.productItems.push(
              new _i({ el: i, id: this.section.id, lazy: !0, grid_list: t })
            );
          });
        }
        _shouldInitFlickity(t) {
          return (
            !!(
              (t.max("XXXS") && this.slides.length > 3) ||
              (t.max("M") && this.slides.length >= 5) ||
              (t.min("L") && this.slides.length > 7)
            ) ||
            (!this.subcollectionSlideshow && void 0)
          );
        }
        _showFiltersModal(t) {
          t.preventDefault(),
            (this.$focusItem = e()(t.currentTarget)),
            this.modal.open(this.filtersContentSelector, "productgrid-filters");
        }
        _showSortModal(t) {
          t.preventDefault(),
            (this.$focusItem = e()(t.currentTarget)),
            this.modal.open(this.sortContent, "productgrid-sort");
        }
        _deactivateTags(t) {
          const e = t.closest("[data-filter-group]");
          e.querySelectorAll('[data-filter-active="true"]').forEach((t) => {
            const i = t.dataset.handle;
            (e.querySelector(
              `.filter-item[data-handle='${i}']`
            ).dataset.filterActive = !1),
              this.fillAnimations[i] &&
                this.checkAnimations[i] &&
                (this.fillAnimations[i].animateTo("unchecked"),
                this.checkAnimations[i].animateTo("unchecked"));
          });
        }
        _activateTag(t) {
          event.preventDefault();
          const i = t.getAttribute("href"),
            n = t.closest(".filter-item"),
            s = n.dataset.handle;
          if (n.classList.contains("filter-item--disabled")) return;
          let o = "checked";
          "true" === n.dataset.filterActive && (o = "unchecked"),
            this._deactivateTags(n),
            (n.dataset.filterActive = "checked" === o),
            this.fillAnimations[s] && this.checkAnimations[s]
              ? (this.fillAnimations[s].animateTo(o),
                this.checkAnimations[s].animateTo(o).then(() => {
                  0 === this.$advancedTags.length
                    ? (location.href = i)
                    : this._advancedTags(e()(t));
                }))
              : this._advancedTags(e()(t));
        }
        _advancedTags(t) {
          const i = t.parent().closest("nav").find("[data-filter-group]"),
            n = [];
          i.each((t, i) => {
            const s = i.querySelectorAll('[data-filter-active="true"]');
            s.length && n.push(e()(s).data("handle"));
          }),
            this.currentTags.length &&
              this.currentTags.forEach((t) => {
                this.handles.includes(t) || n.push(t);
              }),
            this._updateLocation(n.join("+"));
        }
        _updateLocation(t) {
          this.collectionUrl.indexOf("vendors") > -1
            ? (location.href = `${this.collectionUrl}&constraint=${t}`)
            : (location.href = `${this.collectionUrl}/${t}`);
        }
        _toggleTags(t) {
          t.preventDefault();
          const i = e()(t.currentTarget),
            n = i.parent().siblings("[data-hidden-default]"),
            s = i.data("filter-toggle");
          n.toggleClass("filter-item--hidden", s),
            i
              .data("filter-toggle", !s)
              .text(s ? this.context.see_more : this.context.see_less),
            this.modal.isOpen() && this.modal.position();
        }
        _setSortByQueryParameters() {
          if (((Shopify.queryParams = {}), location.search.length))
            for (
              let t = 0, e = location.search.substr(1).split("&");
              t < e.length;
              t++
            ) {
              const i = e[t].split("=");
              i.length > 1 &&
                "page" !== i[0] &&
                (Shopify.queryParams[decodeURIComponent(i[0])] =
                  decodeURIComponent(i[1]));
            }
        }
        _changeSortingButton(t) {
          const i = "utils-sortby--modal-button--active";
          e()(t.currentTarget)
            .addClass(i)
            .parent()
            .siblings()
            .find(`.${i}`)
            .removeClass(i),
            this._changeSorting(t);
        }
        _changeSorting(t) {
          t.preventDefault();
          const i = e()(t.currentTarget);
          (Shopify.queryParams.sort_by = i.val()),
            (location.search = jQuery
              .param(Shopify.queryParams)
              .replace(/\+/g, "%20"));
        }
        _toggleView(t) {
          const i = e()(t.currentTarget);
          (Shopify.queryParams.grid_list = i.data("collection-view")),
            (location.search = jQuery
              .param(Shopify.queryParams)
              .replace(/\+/g, "%20"));
        }
        _checkListView() {
          const t = Shopify.queryParams.grid_list
            ? Shopify.queryParams.grid_list
            : this.defaultView;
          this.$el.find('[href*="&grid_list"]').attr("href", (e, i) => {
            let n = i;
            if (i.indexOf("?") < 0) {
              const t = i.indexOf("&"),
                e = i.substr(0, t),
                s = i.substr(t + 1);
              n = e.concat("?", s);
            }
            return (n = n.replace("grid_list", `grid_list=${t}`)), n;
          }),
            this.$el.find(".utils-viewtoggle-button").removeClass("active"),
            e()(`[data-collection-view=${t}]`).addClass("active");
          const i = t.replace("-", "");
          this.gridContainer.classList.add(`productgrid-${i}`),
            "listview" === i
              ? this.gridContainer.classList.remove("productgrid-gridview")
              : this.gridContainer.classList.remove("productgrid-listview"),
            (this.view = t),
            this._initProductItems(t);
        }
        _initTags() {
          const t = this.$filtersContent[0].querySelectorAll(
            '[data-filter-active="false"]'
          );
          this.$filtersContent[0]
            .querySelectorAll('[data-filter-active="true"]')
            .forEach((t) => {
              null === t.querySelector(".filter-item--swatch-wrapper") &&
                this._addProductCount(t, !0),
                this._openActiveGroup(t);
            }),
            t.forEach((t) => {
              this._addProductCount(t, !1);
            });
        }
        _addProductCount(t, e) {
          if (
            "faceted" === this.filterType ||
            (!1 === this.showFilterProductCount &&
              "groups" !== this.filterStyle)
          )
            return;
          const i = t.querySelector("[data-filtered-product-count]");
          if (!this.collectionUrl.includes("/collections/vendors"))
            if (e) i.innerHTML = `(${this.productCount})`;
            else {
              const e = t.querySelector("a");
              let n = e.getAttribute("href");
              (n = n.split("?")[0]),
                kt.load(n, "ajax-product-count").then((n) => {
                  if (!n) return;
                  const { data: s } = n,
                    o = s.product_count;
                  if (((i.innerHTML = `(${o})`), 0 === o)) {
                    const i = this.noMatchedProductsText.replace(
                      "*tag*",
                      t.dataset.tagTitle
                    );
                    t.classList.add("filter-item--disabled"),
                      (e.ariaDisabled = !0),
                      (e.title = i);
                  }
                });
            }
        }
        _openActiveGroup(t) {
          const e =
              "tags" === this.filterStyle
                ? this.el.querySelector(this.filtersContentSelector)
                : t
                    .closest(this.filterGroupSelector)
                    .querySelector("[data-filter-group-trigger]"),
            i = t.closest("[data-accordion-content]");
          this.filterGroupAccordions.openGroup(e, i, !0);
          if ("hiddenDefault" in t.dataset) {
            t.parentElement
              .querySelector('[data-filter-toggle="false"]')
              .click();
          }
        }
        _initProductGridUtils() {
          const t = document.querySelector("[data-site-header-main]"),
            e = document.querySelector("body"),
            i = `${t.offsetHeight}px`;
          e.classList.contains(this.stickyHeaderClass)
            ? ((this.stickyUtils.style.top = i),
              (this.stickyUtilsIntersectionTarget.style.top = `-${i}`))
            : ((this.stickyUtils.style.top = "0"),
              (this.stickyUtilsIntersectionTarget.style.top = "0")),
            this._observeHeaders(this.el);
        }
        _observeHeaders() {
          (this.observer = new IntersectionObserver((t, e) => {
            t.forEach((t) => {
              const e = t.boundingClientRect,
                i = t.target.parentElement.querySelector("[data-sticky-utils]"),
                n = t.rootBounds;
              e.bottom < n.top &&
                (this.postMessage(
                  "collection-page:collection-utils-sticky-change",
                  { stuck: !0, target: i }
                ),
                this._handleStickyChange({ stuck: !0, target: i })),
                e.bottom >= n.top &&
                  e.bottom < n.bottom &&
                  (this.postMessage(
                    "collection-page:collection-utils-sticky-change",
                    { stuck: !1, target: i }
                  ),
                  this._handleStickyChange({ stuck: !1, target: i }));
            });
          })),
            this.observer.observe(
              document.querySelector("[data-utils-intersection-target]")
            );
        }
        _fireEvent(t, e) {
          this.postMessage("collection-page:collection-utils-sticky-change", {
            stuck: t,
            target: e,
          });
        }
        _handleStickyChange(t) {
          const { stuck: e, target: i } = t;
          i.classList.toggle("productgrid--utils-box-shadow", e);
        }
        onBreakpointChange(t) {
          this.observer && this.observer.disconnect(),
            t.current.max("S") &&
              ((this.headerTransitionEnd = () => {
                this._initProductGridUtils(),
                  this.header.removeEventListener(
                    "transitionend",
                    this.headerTransitionEnd
                  );
              }),
              this.header.addEventListener(
                "transitionend",
                this.headerTransitionEnd
              )),
            this._shouldInitFlickity(Ot)
              ? this._initFlickity()
              : this._destroyFlickity();
        }
      }
      function Ei(t, e) {
        for (var i = 0; i < e.length; i++) {
          var n = e[i];
          (n.enumerable = n.enumerable || !1),
            (n.configurable = !0),
            "value" in n && (n.writable = !0),
            Object.defineProperty(t, n.key, n);
        }
      }
      function Ai(t) {
        return t &&
          t.__esModule &&
          Object.prototype.hasOwnProperty.call(t, "default")
          ? t.default
          : t;
      }
      var Ti = (function (t) {
          var e = { exports: {} };
          return t(e, e.exports), e.exports;
        })(function (t, e) {
          e.__esModule = !0;
          var i = (function () {
            function t() {
              this.events = [];
            }
            return (
              (t.prototype.register = function (t, e, i) {
                return t && e && i
                  ? (this.events.push({ el: t, event: e, listener: i }),
                    t.addEventListener(e, i),
                    { el: t, event: e, listener: i })
                  : null;
              }),
              (t.prototype.unregister = function (t) {
                var e = t.el,
                  i = t.event,
                  n = t.listener;
                return e && i && n
                  ? ((this.events = this.events.filter(function (t) {
                      return e !== t.el || i !== t.event || n !== t.listener;
                    })),
                    e.removeEventListener(i, n),
                    { el: e, event: i, listener: n })
                  : null;
              }),
              (t.prototype.unregisterAll = function () {
                this.events.forEach(function (t) {
                  var e = t.el,
                    i = t.event,
                    n = t.listener;
                  return e.removeEventListener(i, n);
                }),
                  (this.events = []);
              }),
              t
            );
          })();
          e.default = i;
        }),
        Li = Ai(Ti),
        Di = "[data-disclosure-list]",
        Ii = "[data-disclosure-toggle]",
        Pi = "[data-disclosure-input]",
        Mi = "[data-disclosure-option]",
        Oi = "disclosure-list--visible",
        Fi = "disclosure-list--alternate-drop",
        qi = (function () {
          function t(e) {
            !(function (t, e) {
              if (!(t instanceof e))
                throw new TypeError("Cannot call a class as a function");
            })(this, t),
              (this.el = e),
              (this.events = new Li()),
              (this.cache = {}),
              this._cacheSelectors(),
              this._connectOptions(),
              this._connectToggle(),
              this._onFocusOut();
          }
          var e, i, n;
          return (
            (e = t),
            (i = [
              {
                key: "_cacheSelectors",
                value: function () {
                  this.cache = {
                    disclosureList: this.el.querySelector(Di),
                    disclosureToggle: this.el.querySelector(Ii),
                    disclosureInput: this.el.querySelector(Pi),
                    disclosureOptions: this.el.querySelectorAll(Mi),
                  };
                },
              },
              {
                key: "_connectToggle",
                value: function () {
                  var t = this;
                  this.events.register(
                    this.cache.disclosureToggle,
                    "click",
                    function (e) {
                      var i =
                        "true" ===
                        e.currentTarget.getAttribute("aria-expanded");
                      e.currentTarget.setAttribute("aria-expanded", !i),
                        t.cache.disclosureList.classList.remove(Fi),
                        t.cache.disclosureList.classList.toggle(Oi),
                        window.requestAnimationFrame(function () {
                          var e =
                            t.cache.disclosureList.getBoundingClientRect();
                          e.left + e.width + 30 > window.innerWidth &&
                            t.cache.disclosureList.classList.add(Fi);
                        });
                    }
                  );
                },
              },
              {
                key: "_connectOptions",
                value: function () {
                  for (
                    var t = this, e = this.cache.disclosureOptions, i = 0;
                    i < e.length;
                    i++
                  ) {
                    var n = e[i];
                    this.events.register(n, "click", function (e) {
                      return t._submitForm(e.currentTarget.dataset.value);
                    });
                  }
                },
              },
              {
                key: "_onFocusOut",
                value: function () {
                  var t = this;
                  this.events.register(
                    this.cache.disclosureToggle,
                    "focusout",
                    function (e) {
                      !t.el.contains(e.relatedTarget) && t._hideList();
                    }
                  ),
                    this.events.register(
                      this.cache.disclosureList,
                      "focusout",
                      function (e) {
                        var i = e.currentTarget.contains(e.relatedTarget);
                        t.cache.disclosureList.classList.contains(Oi) &&
                          !i &&
                          t._hideList();
                      }
                    ),
                    this.events.register(this.el, "keyup", function (e) {
                      e.defaultPrevented ||
                        ("Escape" === e.key &&
                          "Esc" === e.key &&
                          (t._hideList(), t.cache.disclosureToggle.focus()));
                    }),
                    this.events.register(document.body, "click", function (e) {
                      var i = t.el.contains(e.target);
                      t.cache.disclosureList.classList.contains(Oi) &&
                        !i &&
                        t._hideList();
                    });
                },
              },
              {
                key: "_submitForm",
                value: function (t) {
                  (this.cache.disclosureInput.value = t),
                    this.el.closest("form").submit();
                },
              },
              {
                key: "_hideList",
                value: function () {
                  this.cache.disclosureList.classList.remove(Oi),
                    this.cache.disclosureToggle.setAttribute(
                      "aria-expanded",
                      !1
                    );
                },
              },
              {
                key: "unload",
                value: function () {
                  this.events.unregisterAll();
                },
              },
            ]) && Ei(e.prototype, i),
            n && Ei(e, n),
            t
          );
        })();
      Element.prototype.matches ||
        (Element.prototype.matches =
          Element.prototype.msMatchesSelector ||
          Element.prototype.webkitMatchesSelector),
        Element.prototype.closest ||
          (Element.prototype.closest = function (t) {
            var e = this;
            do {
              if (e.matches(t)) return e;
              e = e.parentElement || e.parentNode;
            } while (null !== e && 1 === e.nodeType);
            return null;
          });
      const $i = qi;
      class Bi {
        constructor(t) {
          (this.$el = e()(t.el)),
            (this.el = t.el),
            (this.countryDisclosureEls = this.el.querySelectorAll(
              "[data-disclosure-country]"
            )),
            (this.localeDisclosureEls = this.el.querySelectorAll(
              "[data-disclosure-locale]"
            )),
            (this.accordionTrigger = "[data-accordion-trigger]"),
            (this.disclosures = []),
            (this.Accordion = new Ci(this.el, {
              onStart: (t) => {
                let { el: e, state: i } = t;
                e.parentNode.parentNode.querySelector(
                  this.accordionTrigger
                ).dataset.accordionTrigger = i;
              },
            })),
            Ot.max("M") && this.Accordion.closeAll({ force: !0 }),
            (this.forms = new Z(this.$el)),
            this.countryDisclosureEls.length > 0 &&
              this.countryDisclosureEls.forEach((t) => {
                this.disclosures.push(new $i(t));
              }),
            this.localeDisclosureEls.length > 0 &&
              this.localeDisclosureEls.forEach((t) => {
                this.disclosures.push(new $i(t));
              }),
            Ot.onChange((t) => this.onBreakpointChange(t)),
            this._bindEvents();
        }
        _bindEvents() {
          this.$el.on("click.footer", this.accordionTrigger, (t) => {
            t.preventDefault(),
              this._toggleAccordion(e()(t.currentTarget).parent()[0]);
          });
        }
        onSectionUnload() {
          this.$el.off(".footer"),
            this.forms.unload(),
            this.disclosures.forEach((t) => t.unload()),
            this.Accordion.unload();
        }
        onSectionBlockSelect(t) {
          t.el.classList.contains("has-accordion") && this._toggleAccordion(t);
        }
        onSectionBlockDeselect(t) {
          t.el.classList.contains("has-accordion") && this._toggleAccordion(t);
        }
        _toggleAccordion(t) {
          Ot.min("L") || this.Accordion.toggle(t);
        }
        onBreakpointChange(t) {
          t.current.min("L")
            ? this.Accordion.openAll({ force: !0 })
            : t.previous.min("L") &&
              t.current.max("M") &&
              this.Accordion.closeAll({ force: !0 });
        }
      }
      class Ni {
        constructor(t, e) {
          (this.body = document.querySelector("body")),
            (this.header = document.querySelector("[data-site-header]")),
            (this.menu = this.header.querySelector("[data-site-navigation]")),
            (this.menuToggle = t.menuToggle),
            (this.postMessage = t.postMessage),
            (this.settings = e),
            (this.transitioning = !1),
            (this.lastToggle = Date.now() - 1e3),
            (this.stickyClass = "site-header-sticky"),
            (this.scrolledClass = "site-header-sticky--scrolled"),
            (this.navOpenClass = "site-header-nav--open"),
            (this.events = new xt.Z()),
            (this._toggleStickyHeader = this._toggleStickyHeader.bind(this)),
            (this._toggleMenu = this._toggleMenu.bind(this)),
            this.settings.sticky_header &&
              (this.body.classList.add(this.stickyClass),
              window.requestAnimationFrame(() => {
                window
                  .getComputedStyle(this.header)
                  .position.indexOf("sticky") > -1 &&
                  ((this.observer = new IntersectionObserver((t) =>
                    this._toggleStickyHeader(t)
                  )),
                  this.observer.observe(
                    document.querySelector("[data-header-intersection-target]")
                  ),
                  (this.toggleClick = (t) => {
                    t.preventDefault(),
                      zt.isGreaterThanBreakpoint("M") && this._toggleMenu();
                  }),
                  this.menuToggle.addEventListener("click", this.toggleClick));
              }));
        }
        closeNavigation() {
          this.transitioning ||
            (this.menuToggle.classList.remove("active"),
            (this.navTransitionOutEvent = () => {
              this.header.classList.remove(this.navOpenClass),
                (this.transitioning = !1),
                this.menu.removeEventListener(
                  "transitionend",
                  this.navTransitionOutEvent
                );
            }),
            this.menu.addEventListener(
              "transitionend",
              this.navTransitionOutEvent
            ),
            (this.transitioning = !0),
            this.menu.setAttribute(
              "style",
              `margin-top: -${this.menu.getBoundingClientRect().height}px;`
            ),
            this.postMessage("nav:close-all"));
        }
        openNavigation() {
          let t =
            arguments.length > 0 && void 0 !== arguments[0]
              ? arguments[0]
              : () => {};
          this.transitioning ||
          this.header.classList.contains(this.navOpenClass)
            ? t()
            : (this.menuToggle.classList.add("active"),
              (this.navTransitionInEvent = () => {
                (this.transitioning = !1),
                  this.menu.removeEventListener(
                    "transitionend",
                    this.navTransitionInEvent
                  ),
                  t();
              }),
              this.menu.addEventListener(
                "transitionend",
                this.navTransitionInEvent
              ),
              (this.transitioning = !0),
              window.requestAnimationFrame(() => {
                this.header.classList.add(this.navOpenClass),
                  window.requestAnimationFrame(() => {
                    this.menu.setAttribute("style", "margin-top: 0;");
                  });
              }));
        }
        _toggleMenu() {
          this.header.classList.contains(this.navOpenClass)
            ? this.closeNavigation()
            : this.openNavigation();
        }
        _toggleStickyHeader(t) {
          if (Kt.isLocked || !zt.isGreaterThanBreakpoint("M")) return;
          const e = !t[0].isIntersecting;
          (e && this.header.classList.contains(this.scrolledClass)) ||
            this.lastToggle + 250 > Date.now() ||
            ((this.lastToggle = Date.now()),
            e ? this._shrink() : this._expand());
        }
        _shrink() {
          this.closeNavigation(), this.header.classList.add(this.scrolledClass);
        }
        _expand() {
          this.openNavigation(),
            this.header.classList.remove(this.scrolledClass),
            this.menuToggle.classList.remove("active");
        }
        unload() {
          this.body.classList.remove(this.stickyClass),
            this.body.classList.remove(this.scrolledClass),
            this.observer && this.observer.disconnect(),
            this.menuToggle.removeEventListener("click", this.toggleClick),
            this.events.unregisterAll();
        }
      }
      class Ri {
        constructor(t) {
          (this.$el = e()(t)),
            (this.Accordion = new Ci(t)),
            this.closeAllSubmenus(),
            (this.activeMenuClass = "navmenu-link-parent-active"),
            (this.activeMenu = `.${this.activeMenuClass}`),
            (this.linkClass = "navmenu-link-parent"),
            (this.linkSelector = `.${this.linkClass}`),
            (this.navTrigger = "[data-navmenu-parent]"),
            (this.subMenu = "[data-navmenu-submenu]"),
            (this.buttonClass = "navmenu-button"),
            (this.buttonSelector = `.${this.buttonClass}`),
            this._bindEvents();
        }
        unload() {
          this.$el.off(".mobile-nav"), this.Accordion.unload();
        }
        closeSubMenus(t) {
          e()(t)
            .find(this.activeMenu)
            .each((t, i) => {
              this._closeSubmenu(e()(i));
            });
        }
        closeAllSubmenus() {
          this.Accordion.closeAll({ force: !0 });
        }
        _bindEvents() {
          this.$el.on("mousedown.mobile-nav", ".navmenu-link", (t) => {
            t.preventDefault();
          }),
            this.$el.on(
              "click.mobile-nav",
              `${this.navTrigger} > .navmenu-link-parent`,
              this._linkClicked.bind(this)
            ),
            this.$el.on(
              "click.mobile-nav",
              `${this.navTrigger} > .navmenu-button`,
              (t) => {
                t.preventDefault(), this._toggleSubmenu(t);
              }
            );
        }
        _linkClicked(t) {
          const i = e()(t.currentTarget);
          i.hasClass(this.activeMenuClass) ||
            (t.preventDefault(), this._openSubmenu(i));
        }
        _toggleSubmenu(t) {
          const i = e()(t.currentTarget);
          (i.hasClass(this.linkClass)
            ? i
            : i.siblings(this.linkSelector).first()
          ).hasClass(this.activeMenuClass)
            ? this._closeSubmenu(i)
            : this._openSubmenu(i);
        }
        _openSubmenu(t) {
          const e = t.siblings(this.subMenu).first(),
            i = t.hasClass(this.linkClass)
              ? t
              : t.siblings(this.linkSelector).first(),
            n = t.hasClass(this.buttonClass)
              ? t
              : t.siblings(this.buttonSelector).first();
          i.addClass(this.activeMenuClass);
          this.Accordion.open(e[0], {
            onComplete: () => {
              i.attr("aria-expanded", !0), n.attr("aria-expanded", !0);
            },
          });
        }
        _closeSubmenu(t) {
          const e = t.siblings(this.subMenu).first(),
            i = t.hasClass(this.linkClass)
              ? t
              : t.siblings(this.linkSelector).first(),
            n = t.hasClass(this.buttonClass)
              ? t
              : t.siblings(this.buttonSelector).first();
          i.removeClass(this.activeMenuClass);
          this.Accordion.close(e[0], {
            onComplete: () => {
              i.attr("aria-expanded", !1), n.attr("aria-expanded", !1);
            },
          }),
            this.closeSubMenus(e);
        }
      }
      class zi {
        constructor(t) {
          (this.el = t.el),
            (this.toggleOpen = t.toggleOpen),
            (this.mobileNav = this.el.querySelector("[data-mobile-nav]")),
            (this.navPanel = this.el.querySelector("[data-mobile-nav-panel]")),
            (this.navOverlay = this.el.querySelector(
              "[data-mobile-nav-overlay]"
            )),
            (this.toggleClose = this.el.querySelector(
              "[data-mobile-nav-close]"
            )),
            (this.announcementBar = document.querySelector(
              "[data-announcement-bar]"
            )),
            (this.isOpen = !1),
            (this.subMenus = null),
            (this.events = new xt.Z()),
            (this.breakpointHandler = this.onBreakpointChange.bind(this)),
            Ot.onChange(this.breakpointHandler),
            (this.navPanelAnimation = Mt({
              el: this.navPanel,
              state: "closed",
            })),
            (this.navOverlayAnimation = Mt({
              el: this.navOverlay,
              state: "closed",
            })),
            this.events.register(this.toggleOpen, "click", (t) =>
              this._open(t)
            );
        }
        unload() {
          this.events.unregisterAll(),
            Ot.offChange(this.breakpointHandler),
            Kt.unlock();
        }
        onBreakpointChange() {
          Ot.min("L") && this.isOpen && this._close();
        }
        _open(t) {
          t.preventDefault(),
            Ot.min("L") ||
              (Kt.lock(this.navPanel),
              this.announcementBar &&
                this.announcementBar.style.setProperty(
                  "--index-announcement-bar",
                  "1100"
                ),
              (this.isOpen = !0),
              (this.subMenus = new Ri(this.navPanel)),
              (this.mobileNav.dataset.open = "true"),
              this.navPanelAnimation.animateTo("open"),
              this.navOverlayAnimation.animateTo("open"),
              this.mobileNav.focus(),
              Gt(this.mobileNav),
              (this.overlayClickEvent = this.events.register(
                this.navOverlay,
                "click",
                (t) => this._close(t)
              )),
              (this.toggleCloseEvent = this.events.register(
                this.toggleClose,
                "click",
                (t) => this._close(t)
              )),
              (this.overlayTouchEvent = this.events.register(
                this.navOverlay,
                "touchmove",
                (t) => t.preventDefault()
              )),
              (this.closeEsc = this.events.register(window, "keydown", (t) => {
                "Escape" === t.key && this._close(t);
              })));
        }
        _close(t) {
          t && t.preventDefault(),
            this.navPanelAnimation.animateTo("closed"),
            this.navOverlayAnimation.animateTo("closed").then(() => {
              (this.mobileNav.dataset.open = "false"),
                Xt(this.mobileNav),
                this.toggleOpen.focus(),
                this.announcementBar &&
                  this.announcementBar.style.setProperty(
                    "--index-announcement-bar",
                    ""
                  );
            }),
            Kt.unlock(),
            (this.isOpen = !1),
            this.subMenus &&
              (this.subMenus.closeSubMenus(this.navPanel),
              this.subMenus.closeAllSubmenus(),
              this.subMenus.unload()),
            this.events.unregister(this.overlayClickEvent),
            this.events.unregister(this.overlayTouchEvent),
            this.events.unregister(this.toggleCloseEvent),
            this.events.unregister(this.closeEsc);
        }
      }
      const Hi = Mt({
          el: document.querySelector("[data-site-main-dimmer]"),
          state: "closed",
        }),
        Ui = new Set(),
        ji = "reduceAnimations" in document.body.dataset;
      function Wi(t) {
        ji || Ui.has(t) || (Ui.add(t), Hi.animateTo("open"));
      }
      function Vi(t) {
        Ui.delete(t), Ui.size || Hi.animateTo("closed", { force: ji });
      }
      class Gi {
        constructor(t, e) {
          (this.listitem = t),
            (this.link = null),
            (this.submenu = null),
            (this._isOpen = !1),
            (this.menu = null),
            (this.parentMenu = e.parentMenu),
            (this.closeSiblings = this.parentMenu.closeSiblings),
            (this.details = t.querySelector("[data-navmenu-details]"));
          const { children: i } = this.details;
          for (let t = 0; t < i.length; t++)
            i[t].classList.contains("navmenu-link")
              ? (this.link = i[t])
              : i[t].classList.contains("navmenu-submenu") &&
                (this.submenu = i[t]);
          (this.animation = Mt({ el: this.submenu, state: "closed" })),
            (this.open = () => {
              this._open();
            }),
            (this.close = () => {
              this._close();
            }),
            (this.closeEsc = (t) => {
              "Escape" === t.key && (this.link.focus(), this.close());
            }),
            (this.closeTimer = null),
            (this.openTimer = null),
            (this.mouseover = () => {
              clearTimeout(this.closeTimer),
                this.submenu.classList.contains("navmenu-depth-3")
                  ? this.open()
                  : (this.openTimer = setTimeout(this.open, 200));
            }),
            (this.mouseout = () => {
              clearTimeout(this.openTimer),
                (this.closeTimer = setTimeout(this.close, 400));
            }),
            (this.click = (t) => {
              t.stopPropagation();
              const e = t.target.closest(".navmenu-link-parent");
              if (e && e.dataset.href) {
                if ((t.preventDefault(), this._isOpen))
                  return void (window.location = e.dataset.href);
                this.open();
              }
            }),
            (this.focusin = (t) => {
              t.stopPropagation(),
                t.target.classList.contains("navmenu-link-parent") &&
                  this.closeSiblings(this);
            }),
            (this.touchend = (t) => {
              t.target.focus(), this.click(t);
            }),
            this.listitem.addEventListener("mouseover", this.mouseover),
            this.listitem.addEventListener("mouseout", this.mouseout),
            this.details.addEventListener("touchend", this.touchend),
            this.details.addEventListener("click", this.click),
            this.listitem.addEventListener("focusin", this.focusin),
            document.body.addEventListener("click", this.close),
            document.body.addEventListener("focusin", this.close);
        }
        get isOpen() {
          return this._isOpen;
        }
        forceOpen() {
          return this._open(!0);
        }
        forceClose() {
          return this._close(!0);
        }
        _open() {
          this._isOpen ||
            ((this._isOpen = !0),
            this.details.setAttribute("open", "open"),
            Wi(this),
            this.closeSiblings(this),
            window.addEventListener("keydown", this.closeEsc),
            this.menu || (this.menu = new Zi(this.submenu)),
            this.animation
              .animateTo("open", {
                hold: !0,
                onStart: (t) => {
                  let { el: e } = t,
                    i = 0;
                  for (let t = 0; t < e.children.length; t++)
                    i += e.children[t].offsetHeight;
                  this.listitem.style.setProperty(
                    "--menu-open-height",
                    `${i}px`
                  );
                  const n = this.listitem.closest(
                    "[data-navmenu-meganav-type]"
                  );
                  this.submenu.getBoundingClientRect().right >
                    document.documentElement.clientWidth &&
                    !n &&
                    this.listitem.classList.add("alternate-drop");
                },
              })
              .then((t) => {
                "open" === t && this.link.setAttribute("aria-expanded", !0);
              }));
        }
        _close() {
          let t =
            arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
          this._isOpen &&
            (this.menu && (this.menu.unload(), (this.menu = null)),
            (this._isOpen = !1),
            window.removeEventListener("keydown", this.closeEsc),
            Vi(this),
            this.listitem.classList.remove("navmenu-item--preselected"),
            this.animation.animateTo("closed", { force: t }).then((t) => {
              "closed" === t &&
                (this.listitem.classList.remove("alternate-drop"),
                this.link.setAttribute("aria-expanded", !1),
                this.parentMenu.openSelectedBlock(),
                this.details.removeAttribute("open"));
            }));
        }
        unload() {
          this.forceClose(),
            this.listitem.removeEventListener("mouseover", this.mouseover),
            this.listitem.removeEventListener("mouseout", this.mouseout),
            this.listitem.removeEventListener("touchend", this.touchend),
            this.listitem.removeEventListener("click", this.click),
            this.listitem.removeEventListener("focusin", this.focusin),
            window.removeEventListener("keydown", this.closeEsc),
            document.body.removeEventListener("click", this.bodyClose),
            document.body.removeEventListener("focusin", this.focusInClose),
            this.animation.unload();
        }
      }
      class Xi extends Gi {
        constructor(t, e) {
          super(t, e),
            (this.enableSubmenu =
              "meganav-sidenav" === this.listitem.dataset.navmenuMeganavType);
        }
        get content() {
          return this.submenu.querySelector(".navmenu-meganav-wrapper");
        }
        get openHeight() {
          return this._openHeight;
        }
        get blockId() {
          return this.submenu.dataset.meganavId;
        }
        mouseout() {
          this.parentMenu.shouldBlockClose(this) &&
            (this.timer = setTimeout(this.close, 400));
        }
        _open() {
          let t =
            arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
          if (this._isOpen) return;
          (this._isOpen = !0),
            this.details.setAttribute("open", "open"),
            window.addEventListener("keydown", this.closeEsc),
            this.enableSubmenu &&
              !this.menu &&
              ((this.menu = new Zi(
                this.listitem.querySelector("[data-navmenu]")
              )),
              this.menu.preselectFirstItem());
          new Promise((t) => {
            const { openMeganav: e } = this.parentMenu;
            if (e) {
              this.listitem.style.setProperty(
                "--menu-closed-height",
                `${e.openHeight}px`
              );
              const i = e.content.cloneNode(!0),
                { width: n, left: s } = e.content.getBoundingClientRect();
              i.classList.add("meganav-ghost"),
                (i.style.left = `${s}px`),
                (i.style.width = `${n}px`),
                this.submenu.appendChild(i),
                Wi(this),
                this.animation
                  .animateTo("ghost", { force: !0 })
                  .then(() => this.parentMenu.openMeganav.forceClose())
                  .then(t);
            } else
              this.listitem.style.setProperty("--menu-closed-height", 0),
                Wi(this),
                t();
          })
            .then(() => this.closeSiblings(this))
            .then(() =>
              this.animation.animateTo("open", {
                force: t,
                hold: !t,
                onStart: (t) => {
                  let { el: e } = t;
                  const i = e.querySelector(".navmenu-meganav-wrapper"),
                    n = parseInt(window.getComputedStyle(i).maxHeight, 10),
                    s = isFinite(n)
                      ? Math.min(i.scrollHeight, n)
                      : i.scrollHeight;
                  this.listitem.style.setProperty(
                    "--menu-open-height",
                    `${s}px`
                  ),
                    (this._openHeight = s);
                },
              })
            )
            .then(() => {
              this.link.setAttribute("aria-expanded", !0),
                (this.parentMenu.openMeganav = this),
                this.submenu.querySelectorAll(".meganav-ghost").forEach((t) => {
                  t.parentNode.removeChild(t);
                });
            });
        }
        _close() {
          let t =
            arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
          return (
            this.menu && (this.menu.unload(), (this.menu = null)),
            this.parentMenu.openMeganav === this &&
              (this.parentMenu.openMeganav = null),
            (this._isOpen = !1),
            window.removeEventListener("keydown", this.closeEsc),
            this.listitem.style.setProperty("--menu-closed-height", 0),
            Vi(this),
            this.animation.animateTo("closed", { force: t }).then(() => {
              this.link.setAttribute("aria-expanded", !1),
                this.parentMenu.openSelectedBlock();
            })
          );
        }
      }
      class Zi {
        constructor(t) {
          let { children: e } = t;
          (this.parents = []),
            (this.children = e),
            (this._openMeganav = null),
            (this._selectedBlock = null),
            (this._megaNavs = null),
            (this.closeSiblings = (t) => {
              this.parents.forEach((e) => {
                e !== t && e.close();
              });
            });
          for (let t = 0; t < this.children.length; t++) {
            const e = this.children[t];
            void 0 !== e.dataset.navmenuMeganavTrigger
              ? this.parents.push(new Xi(e, { parentMenu: this }))
              : void 0 !== e.dataset.navmenuParent
              ? this.parents.push(new Gi(e, { parentMenu: this }))
              : e.classList.contains("navmenu-item") &&
                e.addEventListener("focusin", this.closeSiblings);
          }
        }
        get openMeganav() {
          return this._openMeganav;
        }
        set openMeganav(t) {
          this._openMeganav = t;
        }
        selectBlock(t) {
          this._megaNavs ||
            ((this._megaNavs = {}),
            this.parents
              .filter((t) => t instanceof Xi)
              .forEach((t) => {
                this._megaNavs[t.blockId] = t;
              }));
          const e = this._megaNavs[t];
          this._selectedBlock !== e &&
            (this._selectedBlock && this._selectedBlock.close(),
            (this._selectedBlock = this._megaNavs[t]),
            this._selectedBlock.forceOpen());
        }
        openSelectedBlock() {
          this._selectedBlock &&
            0 === this.parents.filter((t) => t.isOpen).length &&
            this._selectedBlock.open();
        }
        shouldBlockClose(t) {
          return (
            t !== this._selectedBlock ||
            1 !== this.parents.filter((t) => t.isOpen).length
          );
        }
        preselectFirstItem() {
          const t = this.parents[0];
          t &&
            t.listitem === this.children[0] &&
            (t.listitem.classList.add("navmenu-item--preselected"), t.open());
        }
        closeAllMenus() {
          (this._selectedBlock = null), this.parents.forEach((t) => t.close());
        }
        unload() {
          this.parents.forEach((t) => {
            t.unload();
          });
          for (let t = 0; t < this.children.length; t++)
            this.children[t].removeEventListener("focusin", this.closeSiblings);
        }
      }
      class Qi {
        constructor(t) {
          let e =
            arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
          if (
            ((this.container = t),
            (this.form = this.container.querySelector(
              "[data-live-search-form]"
            )),
            (this.filter = this.container.querySelector(
              "[data-live-search-filter]"
            )),
            (this.isLiveSearch = !!e.liveSearch && e.liveSearch),
            (this.setCategory = e.setCategory || (() => {})),
            (this.events = new xt.Z()),
            this.events.register(this.form, "submit", (t) =>
              this.submitHandler(t)
            ),
            this.filter)
          ) {
            (this.filterLabel = this.container.querySelector(
              "[data-live-search-filter-label]"
            )),
              this.filterLabel &&
                (this.setCategory(this.filterLabel.value),
                this.events.register(this.filter, "change", (t) => {
                  const { value: e } = t.target;
                  if (e) {
                    const t = (function (t) {
                      return t.replace(
                        /(tag|product_type):(searchfilter_)?/,
                        ""
                      );
                    })(e);
                    (this.filterLabel.innerHTML = t),
                      this.setCategory(t),
                      this.form.classList.add("live-search-filter-active");
                  } else
                    (this.filterLabel.innerHTML = t.target.dataset.filterAll),
                      this.form.classList.remove("live-search-filter-active"),
                      this.setCategory("");
                }));
            const t = () => {
              zt.isLessThanBreakpoint("S") &&
                ((this.filter.value = ""),
                this.form.classList.remove("live-search-filter-active"),
                this.filterLabel &&
                  (this.filterLabel.innerHTML = this.filter.dataset.filterAll));
            };
            t(), zt.onBreakpointChange(() => t());
          }
        }
        unload() {
          this.events.unregisterAll();
        }
        submitHandler(t) {
          t.preventDefault();
          const e = t.currentTarget.cloneNode(!0),
            i = e.querySelector("[name=q]");
          (e.style.position = "absolute"),
            (e.style.left = "-1000px"),
            (e.style.bottom = "-1000px"),
            (e.style.visibility = "hidden");
          let n = i.value;
          (this.isLiveSearch && !n) ||
            ((n =
              this.filter && this.filter.value
                ? `${this.filter.value} AND ${n}`
                : n),
            (i.value = n),
            window.document.body.appendChild(e),
            e.submit());
        }
      }
      class Yi {
        constructor(t, i) {
          (this.$el = e()(t.el)),
            (this.$header = e()(t.header)),
            (this.closeEvents = new xt.Z()),
            (this.closeEventRequestors = new Set()),
            (this.settings = i),
            (this.enableImages = this.settings.enable_images),
            (this.mobileSearchBar = this.settings.show_mobile_search_bar),
            (this.category = ""),
            (this.$input = this.$el.find("[data-live-search-input]")),
            (this.$button = this.$el.find("[data-live-search-submit]")),
            (this.$takeOverButton = this.$el.find(
              "[data-live-search-takeover-cancel]"
            )),
            (this.$filter = this.$el.find("[data-live-search-filter]")),
            (this.$flyDown = this.$el.find("[data-live-search-flydown]")),
            (this.$searchResults = this.$flyDown.find(
              "[data-live-search-results]"
            )),
            (this.$searchPlaceholder = this.$flyDown.find(
              "[data-live-search-placeholder]"
            )),
            (this.$quickLinks = this.$flyDown.find(
              "[data-live-search-quick-links]"
            )),
            (this._onClose = () => {}),
            (this.disableAnimations =
              "reduceAnimations" in document.body.dataset),
            (this.animationFlyDown = Mt({
              el: this.$flyDown.get(0),
              state: "closed",
            })),
            (this.animationSearchResults = Mt({
              el: this.$searchResults.get(0),
              state: "closed",
            })),
            (this.animationTakeover = Mt({ el: this.$el[0], state: "closed" })),
            this.$quickLinks.length &&
              (this.animationQuickLinks = Mt({
                el: this.$quickLinks.get(0),
                state: "closed",
              })),
            (this.staticSearch = new Qi(this.$el[0], {
              liveSearch: !0,
              setCategory: (t) => {
                this.category = t;
              },
            })),
            (this._search = this._search.bind(this)),
            (this._documentFocus = this._documentFocus.bind(this)),
            (this._closeEsc = (t) => {
              "Escape" === t.key &&
                (t.stopPropagation(),
                this._closeFlyDown(!0),
                this._closeTakeOver());
            }),
            (this.events = [
              this.$input.on("keyup.live-search", tt()(this._search, 250)),
              this.$input.on("focus.live-search", (t) => {
                t.stopPropagation(), this._onSearchFocus(t);
              }),
              this.$takeOverButton.on("click.live-search", (t) => {
                t.preventDefault(),
                  this._closeFlyDown(!0),
                  this._closeTakeOver();
              }),
              this.$filter.on("change.live-search", (t) => {
                this.$input.val().length > 0 && this._search(t);
              }),
              e()(window).on(
                "resize",
                tt()(() => {
                  this._isFlydownOpen && this._openFlyDown();
                }, 250)
              ),
            ]);
        }
        open() {
          zt.isLessThanBreakpoint("S") && this._openTakeOver(),
            this._openFlyDown(),
            this.$input.focus();
        }
        set onClose(t) {
          this._onClose = t;
        }
        unload() {
          this.events.forEach((t) => t.off(".live-search")),
            this.closeEvents.unregisterAll(),
            this.closeEventRequestors.clear(),
            this.settings.use_dimmer && Vi(this),
            this.staticSearch.unload(),
            Kt.unlock();
        }
        get _terms() {
          return this.$input.val();
        }
        get _hasTerms() {
          return this._terms.trim().length > 0;
        }
        get _isFlydownOpen() {
          return "open" === this.$flyDown.attr("data-animation-state");
        }
        _onSearchFocus(t) {
          if (
            (this.$el.addClass("live-search--focused"),
            zt.isLessThanBreakpoint("S"))
          ) {
            if (!this._hasTerms) return;
            this._openTakeOver();
          }
          this._search(t);
        }
        _search(t) {
          if (
            t.key &&
            -1 !==
              [
                "Alt",
                "ArrowRight",
                "ArrowLeft",
                "ArrowUp",
                "ArrowDown",
                "Capslock",
                "Control",
                "Escape",
                "Meta",
                "Shift",
                "Tab",
                "Enter",
              ].indexOf(t.key)
          )
            return;
          let e = this._terms;
          if (
            (zt.isLessThanBreakpoint("S") && this._openTakeOver(),
            this._toggleButton(this._hasTerms),
            this._hasTerms)
          ) {
            this.$searchResults.html(""), this._openFlyDown(!0);
            const t = this.$filter[0];
            (e = t && t.value ? `${t.value} AND ${e}` : e),
              fetch(
                `${
                  window.Theme.routes.predictive_search_url
                }?q=${encodeURIComponent(e)}&section_id=predictive-search`
              )
                .then((t) => {
                  if (!t.ok) throw new Error(t.status);
                  return t.text();
                })
                .then((t) => {
                  this.$searchResults.html(t),
                    B.watch(this.$searchResults[0]),
                    this._openFlyDown(),
                    this._toggleButton(!1);
                })
                .catch((t) => {
                  throw t;
                });
          } else
            this.$quickLinks.length
              ? this._openFlyDown()
              : this._closeFlyDown(!0);
        }
        _searchError(t) {
          console.warn("Search had error"),
            console.log(t.message, t.error, t.event),
            this._toggleButton(!1);
        }
        _toggleButton(t) {
          t
            ? this.$button.addClass("search-icon--processing").attr("disabled")
            : this.$button
                .removeClass("search-icon--processing")
                .removeAttr("disabled");
        }
        _shouldOpenFlyDown() {
          if (arguments.length > 0 && void 0 !== arguments[0] && arguments[0])
            return !0;
          const t = this.$input.val().length > 0,
            e =
              this.$searchResults.find("[data-live-search-no-products]")
                .length > 0,
            i = this.$searchResults.children().length > 0,
            n = this.$quickLinks.length;
          return (t && (i || e)) || (!t && n);
        }
        _registerCloseEvents(t) {
          0 === this.closeEventRequestors.size &&
            (this.closeEvents.register(window, "keydown", this._closeEsc),
            this.closeEvents.register(document, "focusin", this._documentFocus),
            this.closeEvents.register(
              document,
              "touchstart",
              this._documentFocus
            ),
            this.closeEvents.register(document, "click", this._documentFocus)),
            this.closeEventRequestors.add(t);
        }
        _unregisterCloseEvents(t) {
          this.closeEventRequestors.delete(t),
            this.closeEventRequestors.size ||
              (this.closeEvents.unregisterAll(), this._onClose());
        }
        _openFlyDown() {
          let t =
            arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
          if (!this._shouldOpenFlyDown(t)) return;
          const e = (t) => {
            let { el: e } = t;
            const i = e.querySelector(":scope > .visible"),
              n = i ? i.scrollHeight : 0;
            e.style.setProperty("--open-height", `${n}px`);
            const s =
              (e.closest("[data-site-header]")
                ? document.documentElement.clientHeight
                : document.documentElement.scrollHeight) -
              (i.getBoundingClientRect().top +
                (e.closest("[data-site-header]") ? 0 : window.scrollY)) -
              30;
            e.style.setProperty("--flydown-max-height", `${s}px`);
          };
          this._updateFlyDown(t),
            this.$flyDown.data("is-open")
              ? e({ el: this.$flyDown.get(0) })
              : (this._registerCloseEvents("flydown"),
                this.settings.use_dimmer && Wi(this),
                this.$flyDown.data("is-open", !0),
                this.animationFlyDown
                  .animateTo("open", {
                    force: this.disableAnimations,
                    onStart: e,
                  })
                  .then(() => this.$el.addClass("live-search--active")));
        }
        _updateFlyDown() {
          let t =
            arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
          const e = this.$input.val().length > 0,
            i =
              this.$searchResults.find("[data-live-search-no-products]")
                .length > 0,
            n = this.$searchResults.children().length > 0,
            s = this.$quickLinks.length;
          t
            ? (this.$searchResults.removeClass("visible"),
              this.$quickLinks.removeClass("visible"),
              this.$searchPlaceholder.addClass("visible"),
              this.animationQuickLinks &&
                this.animationQuickLinks.animateTo("hidden", {
                  force: this.disableAnimations,
                }),
              this.animationSearchResults.animateTo("hidden", {
                force: this.disableAnimations,
              }))
            : e && (i || n)
            ? (this.$searchPlaceholder.removeClass("visible"),
              this.$quickLinks.removeClass("visible"),
              this.$searchResults.addClass("visible"),
              this.animationQuickLinks &&
                this.animationQuickLinks.animateTo("hidden", {
                  force: this.disableAnimations,
                }),
              this.animationSearchResults.animateTo("visible", {
                force: this.disableAnimations,
              }))
            : s &&
              (this.$searchPlaceholder.removeClass("visible"),
              this.$searchResults.removeClass("visible"),
              this.$quickLinks.addClass("visible"),
              this.animationSearchResults.animateTo("hidden", {
                force: this.disableAnimations,
              }),
              this.animationQuickLinks.animateTo("visible", {
                force: this.disableAnimations,
              }));
        }
        _closeFlyDown() {
          let t =
            arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
          this.$flyDown.data("is-open") &&
            (this._unregisterCloseEvents("flydown"),
            Vi(this),
            this.$flyDown.data("is-open", !1),
            this.$searchPlaceholder.removeClass("visible"),
            this.$quickLinks.removeClass("visible"),
            this.$searchResults.removeClass("visible"),
            this.animationQuickLinks &&
              this.animationQuickLinks.animateTo("closed", {
                force: this.disableAnimations,
              }),
            this.animationSearchResults.animateTo("closed", {
              force: this.disableAnimations,
            }),
            this.animationFlyDown
              .animateTo("closed", {
                force: this.disableAnimations,
                onStart: (t) => {
                  let { el: e } = t;
                  return e.style.setProperty("--open-height", "0");
                },
              })
              .then(() => {
                this.$el.removeClass("live-search--active"),
                  t || this.$el.removeClass("live-search--focused");
              }));
        }
        _openTakeOver() {
          if ("open" !== this.animationTakeover.state)
            if (
              (this.$header.hasClass("search--section") &&
                document.body.classList.add("search-takeover-active"),
              Kt.lock(this.$el[0]),
              this.$el.addClass("live-search--takeover"),
              document.body.classList.add("mobile-search-takeover-active"),
              this._registerCloseEvents("takeover"),
              this.settings.use_dimmer && Wi(this),
              this.mobileSearchBar)
            ) {
              const t = this.$el[0],
                {
                  top: e,
                  right: i,
                  left: n,
                  width: s,
                } = t.getBoundingClientRect();
              t.style.setProperty(
                "--live-search-takeover-initial-top",
                `${e}px`
              ),
                t.style.setProperty(
                  "--live-search-takeover-initial-right",
                  window.innerWidth - i + "px"
                ),
                t.style.setProperty(
                  "--live-search-takeover-initial-left",
                  `${n}px`
                ),
                t.style.setProperty(
                  "--live-search-takeover-initial-width",
                  `${s}px`
                ),
                (t.parentNode.style.height = `${
                  t.parentNode.getBoundingClientRect().height
                }px`),
                this.animationTakeover.animateTo("open", {
                  force: this.disableAnimations,
                });
            } else
              this.animationTakeover.animateTo("open", {
                force: this.disableAnimations,
                hold: !0,
              });
        }
        _closeTakeOver() {
          "closed" !== this.animationTakeover.state &&
            (this._unregisterCloseEvents("takeover"),
            this.settings.use_dimmer && Vi(this),
            this.animationTakeover
              .animateTo("closed", { force: this.disableAnimations })
              .then(() => {
                Kt.unlock(),
                  document.body.classList.remove("search-takeover-active"),
                  document.body.classList.remove(
                    "mobile-search-takeover-active"
                  ),
                  this.$el.removeClass("live-search--takeover"),
                  this.mobileSearchBar &&
                    (this.$el[0].parentNode.style.height = "");
              }));
        }
        _documentFocus(t) {
          e()(t.target).closest("[data-live-search]")[0] !== this.$el[0] &&
            (this._closeFlyDown(), this._closeTakeOver());
        }
      }
      class Ki {
        constructor(t) {
          (this.el = t.el),
            (this.settings = t.data.settings),
            (this.postMessage = t.postMessage),
            (this.headerSearch = null),
            (this.scripts = document.querySelector("[data-scripts]")),
            (this.menuToggle = this.el.querySelector("[data-menu-toggle]")),
            (this.cartCount = this.el.querySelector(
              "[data-header-cart-count]"
            )),
            (this.searchField = this.el.querySelector("[data-live-search]")),
            (this.siteNavigation = this.el.querySelector(
              "[data-site-navigation]"
            )),
            (this.desktopNavigation =
              this.siteNavigation.querySelector("ul.navmenu-depth-1")),
            (this.headerTools = this.siteNavigation.querySelector(
              "[data-header-actions]"
            )),
            (this.stickyHeader = new Ni(
              {
                header: this.el,
                menuToggle: this.menuToggle,
                postMessage: this.postMessage,
              },
              this.settings
            )),
            (this.navMobile = new zi({
              el: this.el,
              toggleOpen: this.menuToggle,
            })),
            (this.navDesktop = new Zi(
              document.querySelector(".site-navigation > [data-navmenu]")
            )),
            (this.forms = new Z(this.el)),
            (this.events = new xt.Z()),
            this.settings.live_search.enable
              ? s()(this.scripts.dataset.shopifyApiUrl, () => {
                  if (
                    ((this.headerSearch = new Yi(
                      { el: this.searchField, header: this.el },
                      { ...this.settings.live_search, use_dimmer: !0 }
                    )),
                    (this.mobileSearchButtonEl = t.el.querySelector(
                      "[data-mobile-search-button]"
                    )),
                    this.mobileSearchButtonEl)
                  ) {
                    const t = "reduceAnimations" in document.body.dataset;
                    (this.mobileSearchButtonAnimation = Mt({
                      el: this.mobileSearchButtonEl,
                      state: "visible",
                    })),
                      this.events.register(
                        this.mobileSearchButtonEl,
                        "click",
                        (e) => {
                          e.stopPropagation(),
                            this.headerSearch.open(),
                            this.mobileSearchButtonAnimation.animateTo(
                              "hidden",
                              { force: t }
                            );
                        }
                      ),
                      (this.headerSearch.onClose = () => {
                        this.mobileSearchButtonAnimation.animateTo("visible", {
                          force: t,
                        }),
                          this.mobileSearchButtonEl.focus();
                      });
                  }
                })
              : (this.headerSearch = new Qi(this.searchField)),
            this.events.register(window, "cartcount:update", (t) => {
              (this.cartCount.dataset.headerCartCount = t.detail.item_count),
                t.detail.item_count > 0
                  ? this.cartCount.classList.add("visible")
                  : this.cartCount.classList.remove("visible");
            });
        }
        onSectionSelect() {
          this.stickyHeader.openNavigation();
        }
        onSectionDeselect() {
          this._closeAllNavigation();
        }
        onSectionUnload() {
          this.stickyHeader.unload(),
            this.navMobile.unload(),
            this.navDesktop.unload(),
            this.forms.unload(),
            this.headerSearch.unload(),
            this.events.unregisterAll();
        }
        onSectionMessage(t, e) {
          "nav:close-all" === t &&
            zt.isGreaterThanBreakpoint("M") &&
            this._closeAllNavigation(),
            "collection-page:collection-utils-sticky-change" === t &&
              this._handleStickyChange(e);
        }
        onSectionBlockSelect(t) {
          zt.isGreaterThanBreakpoint("M") &&
            this.stickyHeader.openNavigation(() => {
              this.navDesktop.selectBlock(t.id);
            });
        }
        onSectionBlockDeselect() {
          this._closeAllNavigation();
        }
        _closeAllNavigation() {
          this.navDesktop.closeAllMenus();
        }
        _handleStickyChange(t) {
          if (!this.settings.sticky_header || !this.settings.has_box_shadow)
            return;
          const { stuck: e, target: i } = t;
          this.el.classList.toggle("site-header-wrapper--no-shadow", e);
        }
      }
      class Ji {
        constructor(t) {
          (this.$el = e()(t.el)),
            (this.modalForms = null),
            (this.newsletterForm = null),
            (this.modalContents = "[data-passwordentry]"),
            (this.$newsletterForm = this.$el.find(
              "[data-password-newsletter]"
            )),
            (this.modalOpen = this.onModalOpen.bind(this)),
            (this.modalClose = this.onModalClose.bind(this)),
            (this._openModal = this._openModal.bind(this)),
            (this.modal = new ee({
              onOpen: this.modalOpen,
              onClose: this.modalClose,
            })),
            this.$newsletterForm &&
              (this.newsletterForm = new Z(this.$newsletterForm)),
            this._checkForPasswordAttempt(),
            this._bindEvents();
        }
        onSectionUnload() {
          this.$el.off(".static-password"),
            this.newsletterForm && this.newsletterForm.unload(),
            this.modalForms && this.modalForms.unload();
        }
        onModalOpen() {
          const t = e()("[data-passwordentry-contents]");
          this.modalForms = new Z(t);
        }
        onModalClose() {
          this.modalForms.unload(), (this.modalForms = null);
        }
        _bindEvents() {
          this.$el.on(
            "click.static-password",
            "[data-passwordentry-toggle]",
            this._openModal
          );
        }
        _openModal() {
          this.modal.open(this.modalContents, "passwordentry");
        }
        _checkForPasswordAttempt() {
          e()("[data-passwordentry-errors]").length && this._openModal();
        }
      }
      /*!
       * @pixelunion/pxs-complementary-products v3.5.3
       * (c) 2022 Pixel Union
       */
      function tn(t) {
        return (
          (tn =
            "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
              ? function (t) {
                  return typeof t;
                }
              : function (t) {
                  return t &&
                    "function" == typeof Symbol &&
                    t.constructor === Symbol &&
                    t !== Symbol.prototype
                    ? "symbol"
                    : typeof t;
                }),
          tn(t)
        );
      }
      function en(t, e) {
        for (var i = 0; i < e.length; i++) {
          var n = e[i];
          (n.enumerable = n.enumerable || !1),
            (n.configurable = !0),
            "value" in n && (n.writable = !0),
            Object.defineProperty(t, n.key, n);
        }
      }
      var nn =
        "undefined" != typeof globalThis
          ? globalThis
          : "undefined" != typeof window
          ? window
          : void 0 !== i.g
          ? i.g
          : "undefined" != typeof self
          ? self
          : {};
      function sn(t, e) {
        return t((e = { exports: {} }), e.exports), e.exports;
      }
      var on = sn(function (t, e) {
          e.__esModule = !0;
          var i = (function () {
            function t() {
              this.events = [];
            }
            return (
              (t.prototype.register = function (t, e, i) {
                return t && e && i
                  ? (this.events.push({ el: t, event: e, listener: i }),
                    t.addEventListener(e, i),
                    { el: t, event: e, listener: i })
                  : null;
              }),
              (t.prototype.unregister = function (t) {
                var e = t.el,
                  i = t.event,
                  n = t.listener;
                return e && i && n
                  ? ((this.events = this.events.filter(function (t) {
                      return e !== t.el || i !== t.event || n !== t.listener;
                    })),
                    e.removeEventListener(i, n),
                    { el: e, event: i, listener: n })
                  : null;
              }),
              (t.prototype.unregisterAll = function () {
                this.events.forEach(function (t) {
                  var e = t.el,
                    i = t.event,
                    n = t.listener;
                  return e.removeEventListener(i, n);
                }),
                  (this.events = []);
              }),
              t
            );
          })();
          e.default = i;
        }),
        rn = (function (t) {
          return t &&
            t.__esModule &&
            Object.prototype.hasOwnProperty.call(t, "default")
            ? t.default
            : t;
        })(on);
      function an(t, e) {
        for (var i = 0; i < e.length; i++) {
          var n = e[i];
          (n.enumerable = n.enumerable || !1),
            (n.configurable = !0),
            "value" in n && (n.writable = !0),
            Object.defineProperty(t, n.key, n);
        }
      }
      function ln(t, e, i) {
        return (
          e in t
            ? Object.defineProperty(t, e, {
                value: i,
                enumerable: !0,
                configurable: !0,
                writable: !0,
              })
            : (t[e] = i),
          t
        );
      }
      function cn(t, e) {
        var i = Object.keys(t);
        if (Object.getOwnPropertySymbols) {
          var n = Object.getOwnPropertySymbols(t);
          e &&
            (n = n.filter(function (e) {
              return Object.getOwnPropertyDescriptor(t, e).enumerable;
            })),
            i.push.apply(i, n);
        }
        return i;
      }
      function hn(t, e) {
        return (
          (function (t) {
            if (Array.isArray(t)) return t;
          })(t) ||
          (function (t, e) {
            if ("undefined" == typeof Symbol || !(Symbol.iterator in Object(t)))
              return;
            var i = [],
              n = !0,
              s = !1,
              o = void 0;
            try {
              for (
                var r, a = t[Symbol.iterator]();
                !(n = (r = a.next()).done) &&
                (i.push(r.value), !e || i.length !== e);
                n = !0
              );
            } catch (t) {
              (s = !0), (o = t);
            } finally {
              try {
                n || null == a.return || a.return();
              } finally {
                if (s) throw o;
              }
            }
            return i;
          })(t, e) ||
          (function (t, e) {
            if (!t) return;
            if ("string" == typeof t) return dn(t, e);
            var i = Object.prototype.toString.call(t).slice(8, -1);
            "Object" === i && t.constructor && (i = t.constructor.name);
            if ("Map" === i || "Set" === i) return Array.from(i);
            if (
              "Arguments" === i ||
              /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(i)
            )
              return dn(t, e);
          })(t, e) ||
          (function () {
            throw new TypeError(
              "Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."
            );
          })()
        );
      }
      function dn(t, e) {
        (null == e || e > t.length) && (e = t.length);
        for (var i = 0, n = new Array(e); i < e; i++) n[i] = t[i];
        return n;
      }
      var un = {},
        pn = (function () {
          function t() {
            !(
              /*!
               * @pixelunion/shopify-asyncview v2.0.5
               * (c) 2020 Pixel Union
               */
              (function (t, e) {
                if (!(t instanceof e))
                  throw new TypeError("Cannot call a class as a function");
              })(this, t)
            );
          }
          var e, i, n;
          return (
            (e = t),
            (n = [
              {
                key: "load",
                value: function (t) {
                  var e =
                      arguments.length > 1 && void 0 !== arguments[1]
                        ? arguments[1]
                        : {},
                    i =
                      arguments.length > 2 && void 0 !== arguments[2]
                        ? arguments[2]
                        : {};
                  if (!("view" in e))
                    return Promise.reject(
                      new Error("'view' not found in 'query' parameter")
                    );
                  var n = t.replace(/\?[^#]+/, ""),
                    s = new RegExp(/.+\?([^#]+)/).exec(t),
                    o = e;
                  s &&
                    s.length >= 2 &&
                    s[1].split("&").forEach(function (t) {
                      var e = hn(t.split("="), 2),
                        i = e[0],
                        n = e[1];
                      o[i] = n;
                    });
                  var r = (function (t) {
                      for (var e = 1; e < arguments.length; e++) {
                        var i = null != arguments[e] ? arguments[e] : {};
                        e % 2
                          ? cn(Object(i), !0).forEach(function (e) {
                              ln(t, e, i[e]);
                            })
                          : Object.getOwnPropertyDescriptors
                          ? Object.defineProperties(
                              t,
                              Object.getOwnPropertyDescriptors(i)
                            )
                          : cn(Object(i)).forEach(function (e) {
                              Object.defineProperty(
                                t,
                                e,
                                Object.getOwnPropertyDescriptor(i, e)
                              );
                            });
                      }
                      return t;
                    })({}, o, { _: new Date().getTime() }),
                    a = n.replace(/([^#]+)(.*)/, function (t, e, i) {
                      return ""
                        .concat(e, "?")
                        .concat(
                          Object.keys(o)
                            .sort()
                            .map(function (t) {
                              return ""
                                .concat(t, "=")
                                .concat(encodeURIComponent(o[t]));
                            })
                            .join("&")
                        )
                        .concat(i);
                    }),
                    l = n.replace(/([^#]+)(.*)/, function (t, e, i) {
                      return ""
                        .concat(e, "?")
                        .concat(
                          Object.keys(r)
                            .sort()
                            .map(function (t) {
                              return ""
                                .concat(t, "=")
                                .concat(encodeURIComponent(r[t]));
                            })
                            .join("&")
                        )
                        .concat(i);
                    }),
                    c = new Promise(function (t, e) {
                      var n;
                      if (a in un) t(un[a]);
                      else {
                        if (
                          ((un[a] = c),
                          i.hash && (n = sessionStorage.getItem(a)))
                        ) {
                          var s = JSON.parse(n);
                          if (i.hash === s.options.hash)
                            return delete un[a], void t(s);
                        }
                        var o = new XMLHttpRequest();
                        o.open("GET", l, !0),
                          (o.onload = function () {
                            var e = o.response,
                              n = {},
                              s = e.querySelector("[data-options]");
                            s &&
                              s.innerHTML &&
                              (n = JSON.parse(
                                e.querySelector("[data-options]").innerHTML
                              ));
                            var r = e.querySelectorAll("[data-html]"),
                              l = {};
                            if (
                              1 === r.length &&
                              "" === r[0].getAttribute("data-html")
                            )
                              l = r[0].innerHTML;
                            else
                              for (var c = 0; c < r.length; c++)
                                l[r[c].getAttribute("data-html")] =
                                  r[c].innerHTML;
                            var h = e.querySelectorAll("[data-data]"),
                              d = {};
                            if (
                              1 === h.length &&
                              "" === h[0].getAttribute("data-data")
                            )
                              d = JSON.parse(h[0].innerHTML);
                            else
                              for (var u = 0; u < h.length; u++)
                                d[h[u].getAttribute("data-data")] = JSON.parse(
                                  h[u].innerHTML
                                );
                            if (i.hash)
                              try {
                                sessionStorage.setItem(
                                  a,
                                  JSON.stringify({
                                    options: n,
                                    data: d,
                                    html: l,
                                  })
                                );
                              } catch (t) {
                                console.error(t);
                              }
                            delete un[a], t({ data: d, html: l });
                          }),
                          (o.onerror = function () {
                            delete un[a], e();
                          }),
                          (o.responseType = "document"),
                          o.send();
                      }
                    });
                  return c;
                },
              },
            ]),
            (i = null) && an(e.prototype, i),
            n && an(e, n),
            t
          );
        })(),
        fn = sn(function (t) {
          var e, i;
          (e = "undefined" != typeof window ? window : nn),
            (i = function () {
              function t() {}
              var e = t.prototype;
              return (
                (e.on = function (t, e) {
                  if (t && e) {
                    var i = (this._events = this._events || {}),
                      n = (i[t] = i[t] || []);
                    return -1 == n.indexOf(e) && n.push(e), this;
                  }
                }),
                (e.once = function (t, e) {
                  if (t && e) {
                    this.on(t, e);
                    var i = (this._onceEvents = this._onceEvents || {});
                    return ((i[t] = i[t] || {})[e] = !0), this;
                  }
                }),
                (e.off = function (t, e) {
                  var i = this._events && this._events[t];
                  if (i && i.length) {
                    var n = i.indexOf(e);
                    return -1 != n && i.splice(n, 1), this;
                  }
                }),
                (e.emitEvent = function (t, e) {
                  var i = this._events && this._events[t];
                  if (i && i.length) {
                    (i = i.slice(0)), (e = e || []);
                    for (
                      var n = this._onceEvents && this._onceEvents[t], s = 0;
                      s < i.length;
                      s++
                    ) {
                      var o = i[s];
                      n && n[o] && (this.off(t, o), delete n[o]),
                        o.apply(this, e);
                    }
                    return this;
                  }
                }),
                (e.allOff = function () {
                  delete this._events, delete this._onceEvents;
                }),
                t
              );
            }),
            t.exports ? (t.exports = i()) : (e.EvEmitter = i());
        }),
        mn = sn(function (t) {
          /*!
           * getSize v2.0.3
           * measure size of elements
           * MIT license
           */
          !(function (e, i) {
            t.exports ? (t.exports = i()) : (e.getSize = i());
          })(window, function () {
            function t(t) {
              var e = parseFloat(t);
              return -1 == t.indexOf("%") && !isNaN(e) && e;
            }
            var e =
                "undefined" == typeof console
                  ? function () {}
                  : function (t) {
                      console.error(t);
                    },
              i = [
                "paddingLeft",
                "paddingRight",
                "paddingTop",
                "paddingBottom",
                "marginLeft",
                "marginRight",
                "marginTop",
                "marginBottom",
                "borderLeftWidth",
                "borderRightWidth",
                "borderTopWidth",
                "borderBottomWidth",
              ],
              n = i.length;
            function s(t) {
              var i = getComputedStyle(t);
              return (
                i ||
                  e(
                    "Style returned " +
                      i +
                      ". Are you running this code in a hidden iframe on Firefox? See https://bit.ly/getsizebug1"
                  ),
                i
              );
            }
            var o,
              r = !1;
            function a(e) {
              if (
                ((function () {
                  if (!r) {
                    r = !0;
                    var e = document.createElement("div");
                    (e.style.width = "200px"),
                      (e.style.padding = "1px 2px 3px 4px"),
                      (e.style.borderStyle = "solid"),
                      (e.style.borderWidth = "1px 2px 3px 4px"),
                      (e.style.boxSizing = "border-box");
                    var i = document.body || document.documentElement;
                    i.appendChild(e);
                    var n = s(e);
                    (o = 200 == Math.round(t(n.width))),
                      (a.isBoxSizeOuter = o),
                      i.removeChild(e);
                  }
                })(),
                "string" == typeof e && (e = document.querySelector(e)),
                e && "object" == typeof e && e.nodeType)
              ) {
                var l = s(e);
                if ("none" == l.display)
                  return (function () {
                    for (
                      var t = {
                          width: 0,
                          height: 0,
                          innerWidth: 0,
                          innerHeight: 0,
                          outerWidth: 0,
                          outerHeight: 0,
                        },
                        e = 0;
                      e < n;
                      e++
                    )
                      t[i[e]] = 0;
                    return t;
                  })();
                var c = {};
                (c.width = e.offsetWidth), (c.height = e.offsetHeight);
                for (
                  var h = (c.isBorderBox = "border-box" == l.boxSizing), d = 0;
                  d < n;
                  d++
                ) {
                  var u = i[d],
                    p = l[u],
                    f = parseFloat(p);
                  c[u] = isNaN(f) ? 0 : f;
                }
                var m = c.paddingLeft + c.paddingRight,
                  g = c.paddingTop + c.paddingBottom,
                  v = c.marginLeft + c.marginRight,
                  y = c.marginTop + c.marginBottom,
                  b = c.borderLeftWidth + c.borderRightWidth,
                  w = c.borderTopWidth + c.borderBottomWidth,
                  _ = h && o,
                  S = t(l.width);
                !1 !== S && (c.width = S + (_ ? 0 : m + b));
                var C = t(l.height);
                return (
                  !1 !== C && (c.height = C + (_ ? 0 : g + w)),
                  (c.innerWidth = c.width - (m + b)),
                  (c.innerHeight = c.height - (g + w)),
                  (c.outerWidth = c.width + v),
                  (c.outerHeight = c.height + y),
                  c
                );
              }
            }
            return a;
          });
        }),
        gn = sn(function (t) {
          !(function (e, i) {
            t.exports ? (t.exports = i()) : (e.matchesSelector = i());
          })(window, function () {
            var t = (function () {
              var t = window.Element.prototype;
              if (t.matches) return "matches";
              if (t.matchesSelector) return "matchesSelector";
              for (
                var e = ["webkit", "moz", "ms", "o"], i = 0;
                i < e.length;
                i++
              ) {
                var n = e[i] + "MatchesSelector";
                if (t[n]) return n;
              }
            })();
            return function (e, i) {
              return e[t](i);
            };
          });
        }),
        vn = sn(function (t) {
          !(function (e, i) {
            t.exports
              ? (t.exports = i(e, gn))
              : (e.fizzyUIUtils = i(e, e.matchesSelector));
          })(window, function (t, e) {
            var i = {
                extend: function (t, e) {
                  for (var i in e) t[i] = e[i];
                  return t;
                },
                modulo: function (t, e) {
                  return ((t % e) + e) % e;
                },
              },
              n = Array.prototype.slice;
            (i.makeArray = function (t) {
              return Array.isArray(t)
                ? t
                : null == t
                ? []
                : "object" == typeof t && "number" == typeof t.length
                ? n.call(t)
                : [t];
            }),
              (i.removeFrom = function (t, e) {
                var i = t.indexOf(e);
                -1 != i && t.splice(i, 1);
              }),
              (i.getParent = function (t, i) {
                for (; t.parentNode && t != document.body; )
                  if (((t = t.parentNode), e(t, i))) return t;
              }),
              (i.getQueryElement = function (t) {
                return "string" == typeof t ? document.querySelector(t) : t;
              }),
              (i.handleEvent = function (t) {
                var e = "on" + t.type;
                this[e] && this[e](t);
              }),
              (i.filterFindElements = function (t, n) {
                t = i.makeArray(t);
                var s = [];
                return (
                  t.forEach(function (t) {
                    if (t instanceof HTMLElement)
                      if (n) {
                        e(t, n) && s.push(t);
                        for (
                          var i = t.querySelectorAll(n), o = 0;
                          o < i.length;
                          o++
                        )
                          s.push(i[o]);
                      } else s.push(t);
                  }),
                  s
                );
              }),
              (i.debounceMethod = function (t, e, i) {
                i = i || 100;
                var n = t.prototype[e],
                  s = e + "Timeout";
                t.prototype[e] = function () {
                  var t = this[s];
                  clearTimeout(t);
                  var e = arguments,
                    o = this;
                  this[s] = setTimeout(function () {
                    n.apply(o, e), delete o[s];
                  }, i);
                };
              }),
              (i.docReady = function (t) {
                var e = document.readyState;
                "complete" == e || "interactive" == e
                  ? setTimeout(t)
                  : document.addEventListener("DOMContentLoaded", t);
              }),
              (i.toDashed = function (t) {
                return t
                  .replace(/(.)([A-Z])/g, function (t, e, i) {
                    return e + "-" + i;
                  })
                  .toLowerCase();
              });
            var s = t.console;
            return (
              (i.htmlInit = function (e, n) {
                i.docReady(function () {
                  var o = i.toDashed(n),
                    r = "data-" + o,
                    a = document.querySelectorAll("[" + r + "]"),
                    l = document.querySelectorAll(".js-" + o),
                    c = i.makeArray(a).concat(i.makeArray(l)),
                    h = r + "-options",
                    d = t.jQuery;
                  c.forEach(function (t) {
                    var i,
                      o = t.getAttribute(r) || t.getAttribute(h);
                    try {
                      i = o && JSON.parse(o);
                    } catch (e) {
                      return void (
                        s &&
                        s.error(
                          "Error parsing " + r + " on " + t.className + ": " + e
                        )
                      );
                    }
                    var a = new e(t, i);
                    d && d.data(t, n, a);
                  });
                });
              }),
              i
            );
          });
        }),
        yn = sn(function (t) {
          !(function (e, i) {
            t.exports
              ? (t.exports = i(e, mn))
              : ((e.Flickity = e.Flickity || {}),
                (e.Flickity.Cell = i(e, e.getSize)));
          })(window, function (t, e) {
            function i(t, e) {
              (this.element = t), (this.parent = e), this.create();
            }
            var n = i.prototype;
            return (
              (n.create = function () {
                (this.element.style.position = "absolute"),
                  this.element.setAttribute("aria-hidden", "true"),
                  (this.x = 0),
                  (this.shift = 0),
                  (this.element.style[this.parent.originSide] = 0);
              }),
              (n.destroy = function () {
                this.unselect(), (this.element.style.position = "");
                var t = this.parent.originSide;
                (this.element.style[t] = ""),
                  (this.element.style.transform = ""),
                  this.element.removeAttribute("aria-hidden");
              }),
              (n.getSize = function () {
                this.size = e(this.element);
              }),
              (n.setPosition = function (t) {
                (this.x = t), this.updateTarget(), this.renderPosition(t);
              }),
              (n.updateTarget = n.setDefaultTarget =
                function () {
                  var t =
                    "left" == this.parent.originSide
                      ? "marginLeft"
                      : "marginRight";
                  this.target =
                    this.x +
                    this.size[t] +
                    this.size.width * this.parent.cellAlign;
                }),
              (n.renderPosition = function (t) {
                var e = "left" === this.parent.originSide ? 1 : -1,
                  i = this.parent.options.percentPosition
                    ? t * e * (this.parent.size.innerWidth / this.size.width)
                    : t * e;
                this.element.style.transform =
                  "translateX(" + this.parent.getPositionValue(i) + ")";
              }),
              (n.select = function () {
                this.element.classList.add("is-selected"),
                  this.element.removeAttribute("aria-hidden");
              }),
              (n.unselect = function () {
                this.element.classList.remove("is-selected"),
                  this.element.setAttribute("aria-hidden", "true");
              }),
              (n.wrapShift = function (t) {
                (this.shift = t),
                  this.renderPosition(this.x + this.parent.slideableWidth * t);
              }),
              (n.remove = function () {
                this.element.parentNode.removeChild(this.element);
              }),
              i
            );
          });
        }),
        bn = sn(function (t) {
          !(function (e, i) {
            t.exports
              ? (t.exports = i())
              : ((e.Flickity = e.Flickity || {}), (e.Flickity.Slide = i()));
          })(window, function () {
            function t(t) {
              (this.parent = t),
                (this.isOriginLeft = "left" == t.originSide),
                (this.cells = []),
                (this.outerWidth = 0),
                (this.height = 0);
            }
            var e = t.prototype;
            return (
              (e.addCell = function (t) {
                if (
                  (this.cells.push(t),
                  (this.outerWidth += t.size.outerWidth),
                  (this.height = Math.max(t.size.outerHeight, this.height)),
                  1 == this.cells.length)
                ) {
                  this.x = t.x;
                  var e = this.isOriginLeft ? "marginLeft" : "marginRight";
                  this.firstMargin = t.size[e];
                }
              }),
              (e.updateTarget = function () {
                var t = this.isOriginLeft ? "marginRight" : "marginLeft",
                  e = this.getLastCell(),
                  i = e ? e.size[t] : 0,
                  n = this.outerWidth - (this.firstMargin + i);
                this.target =
                  this.x + this.firstMargin + n * this.parent.cellAlign;
              }),
              (e.getLastCell = function () {
                return this.cells[this.cells.length - 1];
              }),
              (e.select = function () {
                this.cells.forEach(function (t) {
                  t.select();
                });
              }),
              (e.unselect = function () {
                this.cells.forEach(function (t) {
                  t.unselect();
                });
              }),
              (e.getCellElements = function () {
                return this.cells.map(function (t) {
                  return t.element;
                });
              }),
              t
            );
          });
        }),
        wn = sn(function (t) {
          !(function (e, i) {
            t.exports
              ? (t.exports = i(e, vn))
              : ((e.Flickity = e.Flickity || {}),
                (e.Flickity.animatePrototype = i(e, e.fizzyUIUtils)));
          })(window, function (t, e) {
            var i = {
              startAnimation: function () {
                this.isAnimating ||
                  ((this.isAnimating = !0),
                  (this.restingFrames = 0),
                  this.animate());
              },
              animate: function () {
                this.applyDragForce(), this.applySelectedAttraction();
                var t = this.x;
                if (
                  (this.integratePhysics(),
                  this.positionSlider(),
                  this.settle(t),
                  this.isAnimating)
                ) {
                  var e = this;
                  requestAnimationFrame(function () {
                    e.animate();
                  });
                }
              },
              positionSlider: function () {
                var t = this.x;
                this.options.wrapAround &&
                  this.cells.length > 1 &&
                  ((t = e.modulo(t, this.slideableWidth)),
                  (t -= this.slideableWidth),
                  this.shiftWrapCells(t)),
                  this.setTranslateX(t, this.isAnimating),
                  this.dispatchScrollEvent();
              },
              setTranslateX: function (t, e) {
                (t += this.cursorPosition),
                  (t = this.options.rightToLeft ? -t : t);
                var i = this.getPositionValue(t);
                this.slider.style.transform = e
                  ? "translate3d(" + i + ",0,0)"
                  : "translateX(" + i + ")";
              },
              dispatchScrollEvent: function () {
                var t = this.slides[0];
                if (t) {
                  var e = -this.x - t.target,
                    i = e / this.slidesWidth;
                  this.dispatchEvent("scroll", null, [i, e]);
                }
              },
              positionSliderAtSelected: function () {
                this.cells.length &&
                  ((this.x = -this.selectedSlide.target),
                  (this.velocity = 0),
                  this.positionSlider());
              },
              getPositionValue: function (t) {
                return this.options.percentPosition
                  ? 0.01 * Math.round((t / this.size.innerWidth) * 1e4) + "%"
                  : Math.round(t) + "px";
              },
              settle: function (t) {
                !this.isPointerDown &&
                  Math.round(100 * this.x) == Math.round(100 * t) &&
                  this.restingFrames++,
                  this.restingFrames > 2 &&
                    ((this.isAnimating = !1),
                    delete this.isFreeScrolling,
                    this.positionSlider(),
                    this.dispatchEvent("settle", null, [this.selectedIndex]));
              },
              shiftWrapCells: function (t) {
                var e = this.cursorPosition + t;
                this._shiftCells(this.beforeShiftCells, e, -1);
                var i =
                  this.size.innerWidth -
                  (t + this.slideableWidth + this.cursorPosition);
                this._shiftCells(this.afterShiftCells, i, 1);
              },
              _shiftCells: function (t, e, i) {
                for (var n = 0; n < t.length; n++) {
                  var s = t[n],
                    o = e > 0 ? i : 0;
                  s.wrapShift(o), (e -= s.size.outerWidth);
                }
              },
              _unshiftCells: function (t) {
                if (t && t.length)
                  for (var e = 0; e < t.length; e++) t[e].wrapShift(0);
              },
              integratePhysics: function () {
                (this.x += this.velocity),
                  (this.velocity *= this.getFrictionFactor());
              },
              applyForce: function (t) {
                this.velocity += t;
              },
              getFrictionFactor: function () {
                return (
                  1 -
                  this.options[
                    this.isFreeScrolling ? "freeScrollFriction" : "friction"
                  ]
                );
              },
              getRestingPosition: function () {
                return this.x + this.velocity / (1 - this.getFrictionFactor());
              },
              applyDragForce: function () {
                if (this.isDraggable && this.isPointerDown) {
                  var t = this.dragX - this.x - this.velocity;
                  this.applyForce(t);
                }
              },
              applySelectedAttraction: function () {
                if (
                  !(this.isDraggable && this.isPointerDown) &&
                  !this.isFreeScrolling &&
                  this.slides.length
                ) {
                  var t =
                    (-1 * this.selectedSlide.target - this.x) *
                    this.options.selectedAttraction;
                  this.applyForce(t);
                }
              },
            };
            return i;
          });
        }),
        _n = sn(function (t) {
          !(function (e, i) {
            if (t.exports) t.exports = i(e, fn, mn, vn, yn, bn, wn);
            else {
              var n = e.Flickity;
              e.Flickity = i(
                e,
                e.EvEmitter,
                e.getSize,
                e.fizzyUIUtils,
                n.Cell,
                n.Slide,
                n.animatePrototype
              );
            }
          })(window, function (t, e, i, n, s, o, r) {
            var a = t.jQuery,
              l = t.getComputedStyle,
              c = t.console;
            function h(t, e) {
              for (t = n.makeArray(t); t.length; ) e.appendChild(t.shift());
            }
            var d = 0,
              u = {};
            function p(t, e) {
              var i = n.getQueryElement(t);
              if (i) {
                if (((this.element = i), this.element.flickityGUID)) {
                  var s = u[this.element.flickityGUID];
                  return s && s.option(e), s;
                }
                a && (this.$element = a(this.element)),
                  (this.options = n.extend({}, this.constructor.defaults)),
                  this.option(e),
                  this._create();
              } else c && c.error("Bad element for Flickity: " + (i || t));
            }
            (p.defaults = {
              accessibility: !0,
              cellAlign: "center",
              freeScrollFriction: 0.075,
              friction: 0.28,
              namespaceJQueryEvents: !0,
              percentPosition: !0,
              resize: !0,
              selectedAttraction: 0.025,
              setGallerySize: !0,
            }),
              (p.createMethods = []);
            var f = p.prototype;
            n.extend(f, e.prototype),
              (f._create = function () {
                var e = (this.guid = ++d);
                for (var i in ((this.element.flickityGUID = e),
                (u[e] = this),
                (this.selectedIndex = 0),
                (this.restingFrames = 0),
                (this.x = 0),
                (this.velocity = 0),
                (this.originSide = this.options.rightToLeft ? "right" : "left"),
                (this.viewport = document.createElement("div")),
                (this.viewport.className = "flickity-viewport"),
                this._createSlider(),
                (this.options.resize || this.options.watchCSS) &&
                  t.addEventListener("resize", this),
                this.options.on)) {
                  var n = this.options.on[i];
                  this.on(i, n);
                }
                p.createMethods.forEach(function (t) {
                  this[t]();
                }, this),
                  this.options.watchCSS ? this.watchCSS() : this.activate();
              }),
              (f.option = function (t) {
                n.extend(this.options, t);
              }),
              (f.activate = function () {
                this.isActive ||
                  ((this.isActive = !0),
                  this.element.classList.add("flickity-enabled"),
                  this.options.rightToLeft &&
                    this.element.classList.add("flickity-rtl"),
                  this.getSize(),
                  h(
                    this._filterFindCellElements(this.element.children),
                    this.slider
                  ),
                  this.viewport.appendChild(this.slider),
                  this.element.appendChild(this.viewport),
                  this.reloadCells(),
                  this.options.accessibility &&
                    ((this.element.tabIndex = 0),
                    this.element.addEventListener("keydown", this)),
                  this.emitEvent("activate"),
                  this.selectInitialIndex(),
                  (this.isInitActivated = !0),
                  this.dispatchEvent("ready"));
              }),
              (f._createSlider = function () {
                var t = document.createElement("div");
                (t.className = "flickity-slider"),
                  (t.style[this.originSide] = 0),
                  (this.slider = t);
              }),
              (f._filterFindCellElements = function (t) {
                return n.filterFindElements(t, this.options.cellSelector);
              }),
              (f.reloadCells = function () {
                (this.cells = this._makeCells(this.slider.children)),
                  this.positionCells(),
                  this._getWrapShiftCells(),
                  this.setGallerySize();
              }),
              (f._makeCells = function (t) {
                return this._filterFindCellElements(t).map(function (t) {
                  return new s(t, this);
                }, this);
              }),
              (f.getLastCell = function () {
                return this.cells[this.cells.length - 1];
              }),
              (f.getLastSlide = function () {
                return this.slides[this.slides.length - 1];
              }),
              (f.positionCells = function () {
                this._sizeCells(this.cells), this._positionCells(0);
              }),
              (f._positionCells = function (t) {
                (t = t || 0),
                  (this.maxCellHeight = (t && this.maxCellHeight) || 0);
                var e = 0;
                if (t > 0) {
                  var i = this.cells[t - 1];
                  e = i.x + i.size.outerWidth;
                }
                for (var n = this.cells.length, s = t; s < n; s++) {
                  var o = this.cells[s];
                  o.setPosition(e),
                    (e += o.size.outerWidth),
                    (this.maxCellHeight = Math.max(
                      o.size.outerHeight,
                      this.maxCellHeight
                    ));
                }
                (this.slideableWidth = e),
                  this.updateSlides(),
                  this._containSlides(),
                  (this.slidesWidth = n
                    ? this.getLastSlide().target - this.slides[0].target
                    : 0);
              }),
              (f._sizeCells = function (t) {
                t.forEach(function (t) {
                  t.getSize();
                });
              }),
              (f.updateSlides = function () {
                if (((this.slides = []), this.cells.length)) {
                  var t = new o(this);
                  this.slides.push(t);
                  var e =
                      "left" == this.originSide ? "marginRight" : "marginLeft",
                    i = this._getCanCellFit();
                  this.cells.forEach(function (n, s) {
                    if (t.cells.length) {
                      var r =
                        t.outerWidth -
                        t.firstMargin +
                        (n.size.outerWidth - n.size[e]);
                      i.call(this, s, r) ||
                        (t.updateTarget(),
                        (t = new o(this)),
                        this.slides.push(t)),
                        t.addCell(n);
                    } else t.addCell(n);
                  }, this),
                    t.updateTarget(),
                    this.updateSelectedSlide();
                }
              }),
              (f._getCanCellFit = function () {
                var t = this.options.groupCells;
                if (!t)
                  return function () {
                    return !1;
                  };
                if ("number" == typeof t) {
                  var e = parseInt(t, 10);
                  return function (t) {
                    return t % e != 0;
                  };
                }
                var i = "string" == typeof t && t.match(/^(\d+)%$/),
                  n = i ? parseInt(i[1], 10) / 100 : 1;
                return function (t, e) {
                  return e <= (this.size.innerWidth + 1) * n;
                };
              }),
              (f._init = f.reposition =
                function () {
                  this.positionCells(), this.positionSliderAtSelected();
                }),
              (f.getSize = function () {
                (this.size = i(this.element)),
                  this.setCellAlign(),
                  (this.cursorPosition = this.size.innerWidth * this.cellAlign);
              });
            var m = {
              center: { left: 0.5, right: 0.5 },
              left: { left: 0, right: 1 },
              right: { right: 0, left: 1 },
            };
            return (
              (f.setCellAlign = function () {
                var t = m[this.options.cellAlign];
                this.cellAlign = t
                  ? t[this.originSide]
                  : this.options.cellAlign;
              }),
              (f.setGallerySize = function () {
                if (this.options.setGallerySize) {
                  var t =
                    this.options.adaptiveHeight && this.selectedSlide
                      ? this.selectedSlide.height
                      : this.maxCellHeight;
                  this.viewport.style.height = t + "px";
                }
              }),
              (f._getWrapShiftCells = function () {
                if (this.options.wrapAround) {
                  this._unshiftCells(this.beforeShiftCells),
                    this._unshiftCells(this.afterShiftCells);
                  var t = this.cursorPosition,
                    e = this.cells.length - 1;
                  (this.beforeShiftCells = this._getGapCells(t, e, -1)),
                    (t = this.size.innerWidth - this.cursorPosition),
                    (this.afterShiftCells = this._getGapCells(t, 0, 1));
                }
              }),
              (f._getGapCells = function (t, e, i) {
                for (var n = []; t > 0; ) {
                  var s = this.cells[e];
                  if (!s) break;
                  n.push(s), (e += i), (t -= s.size.outerWidth);
                }
                return n;
              }),
              (f._containSlides = function () {
                if (
                  this.options.contain &&
                  !this.options.wrapAround &&
                  this.cells.length
                ) {
                  var t = this.options.rightToLeft,
                    e = t ? "marginRight" : "marginLeft",
                    i = t ? "marginLeft" : "marginRight",
                    n = this.slideableWidth - this.getLastCell().size[i],
                    s = n < this.size.innerWidth,
                    o = this.cursorPosition + this.cells[0].size[e],
                    r = n - this.size.innerWidth * (1 - this.cellAlign);
                  this.slides.forEach(function (t) {
                    s
                      ? (t.target = n * this.cellAlign)
                      : ((t.target = Math.max(t.target, o)),
                        (t.target = Math.min(t.target, r)));
                  }, this);
                }
              }),
              (f.dispatchEvent = function (t, e, i) {
                var n = e ? [e].concat(i) : i;
                if ((this.emitEvent(t, n), a && this.$element)) {
                  var s = (t += this.options.namespaceJQueryEvents
                    ? ".flickity"
                    : "");
                  if (e) {
                    var o = new a.Event(e);
                    (o.type = t), (s = o);
                  }
                  this.$element.trigger(s, i);
                }
              }),
              (f.select = function (t, e, i) {
                if (
                  this.isActive &&
                  ((t = parseInt(t, 10)),
                  this._wrapSelect(t),
                  (this.options.wrapAround || e) &&
                    (t = n.modulo(t, this.slides.length)),
                  this.slides[t])
                ) {
                  var s = this.selectedIndex;
                  (this.selectedIndex = t),
                    this.updateSelectedSlide(),
                    i ? this.positionSliderAtSelected() : this.startAnimation(),
                    this.options.adaptiveHeight && this.setGallerySize(),
                    this.dispatchEvent("select", null, [t]),
                    t != s && this.dispatchEvent("change", null, [t]),
                    this.dispatchEvent("cellSelect");
                }
              }),
              (f._wrapSelect = function (t) {
                var e = this.slides.length;
                if (!(this.options.wrapAround && e > 1)) return t;
                var i = n.modulo(t, e),
                  s = Math.abs(i - this.selectedIndex),
                  o = Math.abs(i + e - this.selectedIndex),
                  r = Math.abs(i - e - this.selectedIndex);
                !this.isDragSelect && o < s
                  ? (t += e)
                  : !this.isDragSelect && r < s && (t -= e),
                  t < 0
                    ? (this.x -= this.slideableWidth)
                    : t >= e && (this.x += this.slideableWidth);
              }),
              (f.previous = function (t, e) {
                this.select(this.selectedIndex - 1, t, e);
              }),
              (f.next = function (t, e) {
                this.select(this.selectedIndex + 1, t, e);
              }),
              (f.updateSelectedSlide = function () {
                var t = this.slides[this.selectedIndex];
                t &&
                  (this.unselectSelectedSlide(),
                  (this.selectedSlide = t),
                  t.select(),
                  (this.selectedCells = t.cells),
                  (this.selectedElements = t.getCellElements()),
                  (this.selectedCell = t.cells[0]),
                  (this.selectedElement = this.selectedElements[0]));
              }),
              (f.unselectSelectedSlide = function () {
                this.selectedSlide && this.selectedSlide.unselect();
              }),
              (f.selectInitialIndex = function () {
                var t = this.options.initialIndex;
                if (this.isInitActivated)
                  this.select(this.selectedIndex, !1, !0);
                else {
                  if (t && "string" == typeof t)
                    if (this.queryCell(t))
                      return void this.selectCell(t, !1, !0);
                  var e = 0;
                  t && this.slides[t] && (e = t), this.select(e, !1, !0);
                }
              }),
              (f.selectCell = function (t, e, i) {
                var n = this.queryCell(t);
                if (n) {
                  var s = this.getCellSlideIndex(n);
                  this.select(s, e, i);
                }
              }),
              (f.getCellSlideIndex = function (t) {
                for (var e = 0; e < this.slides.length; e++) {
                  if (-1 != this.slides[e].cells.indexOf(t)) return e;
                }
              }),
              (f.getCell = function (t) {
                for (var e = 0; e < this.cells.length; e++) {
                  var i = this.cells[e];
                  if (i.element == t) return i;
                }
              }),
              (f.getCells = function (t) {
                t = n.makeArray(t);
                var e = [];
                return (
                  t.forEach(function (t) {
                    var i = this.getCell(t);
                    i && e.push(i);
                  }, this),
                  e
                );
              }),
              (f.getCellElements = function () {
                return this.cells.map(function (t) {
                  return t.element;
                });
              }),
              (f.getParentCell = function (t) {
                var e = this.getCell(t);
                return (
                  e ||
                  ((t = n.getParent(t, ".flickity-slider > *")),
                  this.getCell(t))
                );
              }),
              (f.getAdjacentCellElements = function (t, e) {
                if (!t) return this.selectedSlide.getCellElements();
                e = void 0 === e ? this.selectedIndex : e;
                var i = this.slides.length;
                if (1 + 2 * t >= i) return this.getCellElements();
                for (var s = [], o = e - t; o <= e + t; o++) {
                  var r = this.options.wrapAround ? n.modulo(o, i) : o,
                    a = this.slides[r];
                  a && (s = s.concat(a.getCellElements()));
                }
                return s;
              }),
              (f.queryCell = function (t) {
                if ("number" == typeof t) return this.cells[t];
                if ("string" == typeof t) {
                  if (t.match(/^[#.]?[\d/]/)) return;
                  t = this.element.querySelector(t);
                }
                return this.getCell(t);
              }),
              (f.uiChange = function () {
                this.emitEvent("uiChange");
              }),
              (f.childUIPointerDown = function (t) {
                "touchstart" != t.type && t.preventDefault(), this.focus();
              }),
              (f.onresize = function () {
                this.watchCSS(), this.resize();
              }),
              n.debounceMethod(p, "onresize", 150),
              (f.resize = function () {
                if (this.isActive && !this.isAnimating && !this.isDragging) {
                  this.getSize(),
                    this.options.wrapAround &&
                      (this.x = n.modulo(this.x, this.slideableWidth)),
                    this.positionCells(),
                    this._getWrapShiftCells(),
                    this.setGallerySize(),
                    this.emitEvent("resize");
                  var t = this.selectedElements && this.selectedElements[0];
                  this.selectCell(t, !1, !0);
                }
              }),
              (f.watchCSS = function () {
                this.options.watchCSS &&
                  (-1 != l(this.element, ":after").content.indexOf("flickity")
                    ? this.activate()
                    : this.deactivate());
              }),
              (f.onkeydown = function (t) {
                var e =
                  document.activeElement &&
                  document.activeElement != this.element;
                if (this.options.accessibility && !e) {
                  var i = p.keyboardHandlers[t.keyCode];
                  i && i.call(this);
                }
              }),
              (p.keyboardHandlers = {
                37: function () {
                  var t = this.options.rightToLeft ? "next" : "previous";
                  this.uiChange(), this[t]();
                },
                39: function () {
                  var t = this.options.rightToLeft ? "previous" : "next";
                  this.uiChange(), this[t]();
                },
              }),
              (f.focus = function () {
                var e = t.pageYOffset;
                this.element.focus({ preventScroll: !0 }),
                  t.pageYOffset != e && t.scrollTo(t.pageXOffset, e);
              }),
              (f.deactivate = function () {
                this.isActive &&
                  (this.element.classList.remove("flickity-enabled"),
                  this.element.classList.remove("flickity-rtl"),
                  this.unselectSelectedSlide(),
                  this.cells.forEach(function (t) {
                    t.destroy();
                  }),
                  this.element.removeChild(this.viewport),
                  h(this.slider.children, this.element),
                  this.options.accessibility &&
                    (this.element.removeAttribute("tabIndex"),
                    this.element.removeEventListener("keydown", this)),
                  (this.isActive = !1),
                  this.emitEvent("deactivate"));
              }),
              (f.destroy = function () {
                this.deactivate(),
                  t.removeEventListener("resize", this),
                  this.allOff(),
                  this.emitEvent("destroy"),
                  a && this.$element && a.removeData(this.element, "flickity"),
                  delete this.element.flickityGUID,
                  delete u[this.guid];
              }),
              n.extend(f, r),
              (p.data = function (t) {
                var e = (t = n.getQueryElement(t)) && t.flickityGUID;
                return e && u[e];
              }),
              n.htmlInit(p, "flickity"),
              a && a.bridget && a.bridget("flickity", p),
              (p.setJQuery = function (t) {
                a = t;
              }),
              (p.Cell = s),
              (p.Slide = o),
              p
            );
          });
        }),
        Sn = sn(function (t) {
          /*!
           * Unipointer v2.4.0
           * base class for doing one thing with pointer event
           * MIT license
           */
          !(function (e, i) {
            t.exports
              ? (t.exports = i(e, fn))
              : (e.Unipointer = i(e, e.EvEmitter));
          })(window, function (t, e) {
            function i() {}
            var n = (i.prototype = Object.create(e.prototype));
            (n.bindStartEvent = function (t) {
              this._bindStartEvent(t, !0);
            }),
              (n.unbindStartEvent = function (t) {
                this._bindStartEvent(t, !1);
              }),
              (n._bindStartEvent = function (e, i) {
                var n = (i = void 0 === i || i)
                    ? "addEventListener"
                    : "removeEventListener",
                  s = "mousedown";
                "ontouchstart" in t
                  ? (s = "touchstart")
                  : t.PointerEvent && (s = "pointerdown"),
                  e[n](s, this);
              }),
              (n.handleEvent = function (t) {
                var e = "on" + t.type;
                this[e] && this[e](t);
              }),
              (n.getTouch = function (t) {
                for (var e = 0; e < t.length; e++) {
                  var i = t[e];
                  if (i.identifier == this.pointerIdentifier) return i;
                }
              }),
              (n.onmousedown = function (t) {
                var e = t.button;
                (e && 0 !== e && 1 !== e) || this._pointerDown(t, t);
              }),
              (n.ontouchstart = function (t) {
                this._pointerDown(t, t.changedTouches[0]);
              }),
              (n.onpointerdown = function (t) {
                this._pointerDown(t, t);
              }),
              (n._pointerDown = function (t, e) {
                t.button ||
                  this.isPointerDown ||
                  ((this.isPointerDown = !0),
                  (this.pointerIdentifier =
                    void 0 !== e.pointerId ? e.pointerId : e.identifier),
                  this.pointerDown(t, e));
              }),
              (n.pointerDown = function (t, e) {
                this._bindPostStartEvents(t),
                  this.emitEvent("pointerDown", [t, e]);
              });
            var s = {
              mousedown: ["mousemove", "mouseup"],
              touchstart: ["touchmove", "touchend", "touchcancel"],
              pointerdown: ["pointermove", "pointerup", "pointercancel"],
            };
            return (
              (n._bindPostStartEvents = function (e) {
                if (e) {
                  var i = s[e.type];
                  i.forEach(function (e) {
                    t.addEventListener(e, this);
                  }, this),
                    (this._boundPointerEvents = i);
                }
              }),
              (n._unbindPostStartEvents = function () {
                this._boundPointerEvents &&
                  (this._boundPointerEvents.forEach(function (e) {
                    t.removeEventListener(e, this);
                  }, this),
                  delete this._boundPointerEvents);
              }),
              (n.onmousemove = function (t) {
                this._pointerMove(t, t);
              }),
              (n.onpointermove = function (t) {
                t.pointerId == this.pointerIdentifier &&
                  this._pointerMove(t, t);
              }),
              (n.ontouchmove = function (t) {
                var e = this.getTouch(t.changedTouches);
                e && this._pointerMove(t, e);
              }),
              (n._pointerMove = function (t, e) {
                this.pointerMove(t, e);
              }),
              (n.pointerMove = function (t, e) {
                this.emitEvent("pointerMove", [t, e]);
              }),
              (n.onmouseup = function (t) {
                this._pointerUp(t, t);
              }),
              (n.onpointerup = function (t) {
                t.pointerId == this.pointerIdentifier && this._pointerUp(t, t);
              }),
              (n.ontouchend = function (t) {
                var e = this.getTouch(t.changedTouches);
                e && this._pointerUp(t, e);
              }),
              (n._pointerUp = function (t, e) {
                this._pointerDone(), this.pointerUp(t, e);
              }),
              (n.pointerUp = function (t, e) {
                this.emitEvent("pointerUp", [t, e]);
              }),
              (n._pointerDone = function () {
                this._pointerReset(),
                  this._unbindPostStartEvents(),
                  this.pointerDone();
              }),
              (n._pointerReset = function () {
                (this.isPointerDown = !1), delete this.pointerIdentifier;
              }),
              (n.pointerDone = function () {}),
              (n.onpointercancel = function (t) {
                t.pointerId == this.pointerIdentifier &&
                  this._pointerCancel(t, t);
              }),
              (n.ontouchcancel = function (t) {
                var e = this.getTouch(t.changedTouches);
                e && this._pointerCancel(t, e);
              }),
              (n._pointerCancel = function (t, e) {
                this._pointerDone(), this.pointerCancel(t, e);
              }),
              (n.pointerCancel = function (t, e) {
                this.emitEvent("pointerCancel", [t, e]);
              }),
              (i.getPointerPoint = function (t) {
                return { x: t.pageX, y: t.pageY };
              }),
              i
            );
          });
        }),
        Cn = sn(function (t) {
          /*!
           * Unidragger v2.4.0
           * Draggable base class
           * MIT license
           */
          !(function (e, i) {
            t.exports
              ? (t.exports = i(e, Sn))
              : (e.Unidragger = i(e, e.Unipointer));
          })(window, function (t, e) {
            function i() {}
            var n = (i.prototype = Object.create(e.prototype));
            (n.bindHandles = function () {
              this._bindHandles(!0);
            }),
              (n.unbindHandles = function () {
                this._bindHandles(!1);
              }),
              (n._bindHandles = function (e) {
                for (
                  var i = (e = void 0 === e || e)
                      ? "addEventListener"
                      : "removeEventListener",
                    n = e ? this._touchActionValue : "",
                    s = 0;
                  s < this.handles.length;
                  s++
                ) {
                  var o = this.handles[s];
                  this._bindStartEvent(o, e),
                    o[i]("click", this),
                    t.PointerEvent && (o.style.touchAction = n);
                }
              }),
              (n._touchActionValue = "none"),
              (n.pointerDown = function (t, e) {
                this.okayPointerDown(t) &&
                  ((this.pointerDownPointer = {
                    pageX: e.pageX,
                    pageY: e.pageY,
                  }),
                  t.preventDefault(),
                  this.pointerDownBlur(),
                  this._bindPostStartEvents(t),
                  this.emitEvent("pointerDown", [t, e]));
              });
            var s = { TEXTAREA: !0, INPUT: !0, SELECT: !0, OPTION: !0 },
              o = {
                radio: !0,
                checkbox: !0,
                button: !0,
                submit: !0,
                image: !0,
                file: !0,
              };
            return (
              (n.okayPointerDown = function (t) {
                var e = s[t.target.nodeName],
                  i = o[t.target.type],
                  n = !e || i;
                return n || this._pointerReset(), n;
              }),
              (n.pointerDownBlur = function () {
                var t = document.activeElement;
                t && t.blur && t != document.body && t.blur();
              }),
              (n.pointerMove = function (t, e) {
                var i = this._dragPointerMove(t, e);
                this.emitEvent("pointerMove", [t, e, i]),
                  this._dragMove(t, e, i);
              }),
              (n._dragPointerMove = function (t, e) {
                var i = {
                  x: e.pageX - this.pointerDownPointer.pageX,
                  y: e.pageY - this.pointerDownPointer.pageY,
                };
                return (
                  !this.isDragging &&
                    this.hasDragStarted(i) &&
                    this._dragStart(t, e),
                  i
                );
              }),
              (n.hasDragStarted = function (t) {
                return Math.abs(t.x) > 3 || Math.abs(t.y) > 3;
              }),
              (n.pointerUp = function (t, e) {
                this.emitEvent("pointerUp", [t, e]), this._dragPointerUp(t, e);
              }),
              (n._dragPointerUp = function (t, e) {
                this.isDragging ? this._dragEnd(t, e) : this._staticClick(t, e);
              }),
              (n._dragStart = function (t, e) {
                (this.isDragging = !0),
                  (this.isPreventingClicks = !0),
                  this.dragStart(t, e);
              }),
              (n.dragStart = function (t, e) {
                this.emitEvent("dragStart", [t, e]);
              }),
              (n._dragMove = function (t, e, i) {
                this.isDragging && this.dragMove(t, e, i);
              }),
              (n.dragMove = function (t, e, i) {
                t.preventDefault(), this.emitEvent("dragMove", [t, e, i]);
              }),
              (n._dragEnd = function (t, e) {
                (this.isDragging = !1),
                  setTimeout(
                    function () {
                      delete this.isPreventingClicks;
                    }.bind(this)
                  ),
                  this.dragEnd(t, e);
              }),
              (n.dragEnd = function (t, e) {
                this.emitEvent("dragEnd", [t, e]);
              }),
              (n.onclick = function (t) {
                this.isPreventingClicks && t.preventDefault();
              }),
              (n._staticClick = function (t, e) {
                (this.isIgnoringMouseUp && "mouseup" == t.type) ||
                  (this.staticClick(t, e),
                  "mouseup" != t.type &&
                    ((this.isIgnoringMouseUp = !0),
                    setTimeout(
                      function () {
                        delete this.isIgnoringMouseUp;
                      }.bind(this),
                      400
                    )));
              }),
              (n.staticClick = function (t, e) {
                this.emitEvent("staticClick", [t, e]);
              }),
              (i.getPointerPoint = e.getPointerPoint),
              i
            );
          });
        }),
        kn =
          (sn(function (t) {
            !(function (e, i) {
              t.exports
                ? (t.exports = i(e, _n, Cn, vn))
                : (e.Flickity = i(e, e.Flickity, e.Unidragger, e.fizzyUIUtils));
            })(window, function (t, e, i, n) {
              n.extend(e.defaults, { draggable: ">1", dragThreshold: 3 }),
                e.createMethods.push("_createDrag");
              var s = e.prototype;
              n.extend(s, i.prototype),
                (s._touchActionValue = "pan-y"),
                (s._createDrag = function () {
                  this.on("activate", this.onActivateDrag),
                    this.on("uiChange", this._uiChangeDrag),
                    this.on("deactivate", this.onDeactivateDrag),
                    this.on("cellChange", this.updateDraggable);
                }),
                (s.onActivateDrag = function () {
                  (this.handles = [this.viewport]),
                    this.bindHandles(),
                    this.updateDraggable();
                }),
                (s.onDeactivateDrag = function () {
                  this.unbindHandles(),
                    this.element.classList.remove("is-draggable");
                }),
                (s.updateDraggable = function () {
                  ">1" == this.options.draggable
                    ? (this.isDraggable = this.slides.length > 1)
                    : (this.isDraggable = this.options.draggable),
                    this.isDraggable
                      ? this.element.classList.add("is-draggable")
                      : this.element.classList.remove("is-draggable");
                }),
                (s.bindDrag = function () {
                  (this.options.draggable = !0), this.updateDraggable();
                }),
                (s.unbindDrag = function () {
                  (this.options.draggable = !1), this.updateDraggable();
                }),
                (s._uiChangeDrag = function () {
                  delete this.isFreeScrolling;
                }),
                (s.pointerDown = function (e, i) {
                  this.isDraggable
                    ? this.okayPointerDown(e) &&
                      (this._pointerDownPreventDefault(e),
                      this.pointerDownFocus(e),
                      document.activeElement != this.element &&
                        this.pointerDownBlur(),
                      (this.dragX = this.x),
                      this.viewport.classList.add("is-pointer-down"),
                      (this.pointerDownScroll = r()),
                      t.addEventListener("scroll", this),
                      this._pointerDownDefault(e, i))
                    : this._pointerDownDefault(e, i);
                }),
                (s._pointerDownDefault = function (t, e) {
                  (this.pointerDownPointer = {
                    pageX: e.pageX,
                    pageY: e.pageY,
                  }),
                    this._bindPostStartEvents(t),
                    this.dispatchEvent("pointerDown", t, [e]);
                });
              var o = { INPUT: !0, TEXTAREA: !0, SELECT: !0 };
              function r() {
                return { x: t.pageXOffset, y: t.pageYOffset };
              }
              return (
                (s.pointerDownFocus = function (t) {
                  o[t.target.nodeName] || this.focus();
                }),
                (s._pointerDownPreventDefault = function (t) {
                  var e = "touchstart" == t.type,
                    i = "touch" == t.pointerType,
                    n = o[t.target.nodeName];
                  e || i || n || t.preventDefault();
                }),
                (s.hasDragStarted = function (t) {
                  return Math.abs(t.x) > this.options.dragThreshold;
                }),
                (s.pointerUp = function (t, e) {
                  delete this.isTouchScrolling,
                    this.viewport.classList.remove("is-pointer-down"),
                    this.dispatchEvent("pointerUp", t, [e]),
                    this._dragPointerUp(t, e);
                }),
                (s.pointerDone = function () {
                  t.removeEventListener("scroll", this),
                    delete this.pointerDownScroll;
                }),
                (s.dragStart = function (e, i) {
                  this.isDraggable &&
                    ((this.dragStartPosition = this.x),
                    this.startAnimation(),
                    t.removeEventListener("scroll", this),
                    this.dispatchEvent("dragStart", e, [i]));
                }),
                (s.pointerMove = function (t, e) {
                  var i = this._dragPointerMove(t, e);
                  this.dispatchEvent("pointerMove", t, [e, i]),
                    this._dragMove(t, e, i);
                }),
                (s.dragMove = function (t, e, i) {
                  if (this.isDraggable) {
                    t.preventDefault(), (this.previousDragX = this.dragX);
                    var n = this.options.rightToLeft ? -1 : 1;
                    this.options.wrapAround && (i.x %= this.slideableWidth);
                    var s = this.dragStartPosition + i.x * n;
                    if (!this.options.wrapAround && this.slides.length) {
                      var o = Math.max(
                        -this.slides[0].target,
                        this.dragStartPosition
                      );
                      s = s > o ? 0.5 * (s + o) : s;
                      var r = Math.min(
                        -this.getLastSlide().target,
                        this.dragStartPosition
                      );
                      s = s < r ? 0.5 * (s + r) : s;
                    }
                    (this.dragX = s),
                      (this.dragMoveTime = new Date()),
                      this.dispatchEvent("dragMove", t, [e, i]);
                  }
                }),
                (s.dragEnd = function (t, e) {
                  if (this.isDraggable) {
                    this.options.freeScroll && (this.isFreeScrolling = !0);
                    var i = this.dragEndRestingSelect();
                    if (this.options.freeScroll && !this.options.wrapAround) {
                      var n = this.getRestingPosition();
                      this.isFreeScrolling =
                        -n > this.slides[0].target &&
                        -n < this.getLastSlide().target;
                    } else
                      this.options.freeScroll ||
                        i != this.selectedIndex ||
                        (i += this.dragEndBoostSelect());
                    delete this.previousDragX,
                      (this.isDragSelect = this.options.wrapAround),
                      this.select(i),
                      delete this.isDragSelect,
                      this.dispatchEvent("dragEnd", t, [e]);
                  }
                }),
                (s.dragEndRestingSelect = function () {
                  var t = this.getRestingPosition(),
                    e = Math.abs(this.getSlideDistance(-t, this.selectedIndex)),
                    i = this._getClosestResting(t, e, 1),
                    n = this._getClosestResting(t, e, -1);
                  return i.distance < n.distance ? i.index : n.index;
                }),
                (s._getClosestResting = function (t, e, i) {
                  for (
                    var n = this.selectedIndex,
                      s = 1 / 0,
                      o =
                        this.options.contain && !this.options.wrapAround
                          ? function (t, e) {
                              return t <= e;
                            }
                          : function (t, e) {
                              return t < e;
                            };
                    o(e, s) &&
                    ((n += i),
                    (s = e),
                    null !== (e = this.getSlideDistance(-t, n)));

                  )
                    e = Math.abs(e);
                  return { distance: s, index: n - i };
                }),
                (s.getSlideDistance = function (t, e) {
                  var i = this.slides.length,
                    s = this.options.wrapAround && i > 1,
                    o = s ? n.modulo(e, i) : e,
                    r = this.slides[o];
                  if (!r) return null;
                  var a = s ? this.slideableWidth * Math.floor(e / i) : 0;
                  return t - (r.target + a);
                }),
                (s.dragEndBoostSelect = function () {
                  if (
                    void 0 === this.previousDragX ||
                    !this.dragMoveTime ||
                    new Date() - this.dragMoveTime > 100
                  )
                    return 0;
                  var t = this.getSlideDistance(
                      -this.dragX,
                      this.selectedIndex
                    ),
                    e = this.previousDragX - this.dragX;
                  return t > 0 && e > 0 ? 1 : t < 0 && e < 0 ? -1 : 0;
                }),
                (s.staticClick = function (t, e) {
                  var i = this.getParentCell(t.target),
                    n = i && i.element,
                    s = i && this.cells.indexOf(i);
                  this.dispatchEvent("staticClick", t, [e, n, s]);
                }),
                (s.onscroll = function () {
                  var t = r(),
                    e = this.pointerDownScroll.x - t.x,
                    i = this.pointerDownScroll.y - t.y;
                  (Math.abs(e) > 3 || Math.abs(i) > 3) && this._pointerDone();
                }),
                e
              );
            });
          }),
          sn(function (t) {
            !(function (e, i) {
              t.exports
                ? (t.exports = i(e, _n, Sn, vn))
                : i(e, e.Flickity, e.Unipointer, e.fizzyUIUtils);
            })(window, function (t, e, i, n) {
              var s = "http://www.w3.org/2000/svg";
              function o(t, e) {
                (this.direction = t), (this.parent = e), this._create();
              }
              (o.prototype = Object.create(i.prototype)),
                (o.prototype._create = function () {
                  (this.isEnabled = !0),
                    (this.isPrevious = -1 == this.direction);
                  var t = this.parent.options.rightToLeft ? 1 : -1;
                  this.isLeft = this.direction == t;
                  var e = (this.element = document.createElement("button"));
                  (e.className = "flickity-button flickity-prev-next-button"),
                    (e.className += this.isPrevious ? " previous" : " next"),
                    e.setAttribute("type", "button"),
                    this.disable(),
                    e.setAttribute(
                      "aria-label",
                      this.isPrevious ? "Previous" : "Next"
                    );
                  var i = this.createSVG();
                  e.appendChild(i),
                    this.parent.on("select", this.update.bind(this)),
                    this.on(
                      "pointerDown",
                      this.parent.childUIPointerDown.bind(this.parent)
                    );
                }),
                (o.prototype.activate = function () {
                  this.bindStartEvent(this.element),
                    this.element.addEventListener("click", this),
                    this.parent.element.appendChild(this.element);
                }),
                (o.prototype.deactivate = function () {
                  this.parent.element.removeChild(this.element),
                    this.unbindStartEvent(this.element),
                    this.element.removeEventListener("click", this);
                }),
                (o.prototype.createSVG = function () {
                  var t = document.createElementNS(s, "svg");
                  t.setAttribute("class", "flickity-button-icon"),
                    t.setAttribute("viewBox", "0 0 100 100");
                  var e = document.createElementNS(s, "path"),
                    i = (function (t) {
                      if ("string" == typeof t) return t;
                      return (
                        "M " +
                        t.x0 +
                        ",50 L " +
                        t.x1 +
                        "," +
                        (t.y1 + 50) +
                        " L " +
                        t.x2 +
                        "," +
                        (t.y2 + 50) +
                        " L " +
                        t.x3 +
                        ",50  L " +
                        t.x2 +
                        "," +
                        (50 - t.y2) +
                        " L " +
                        t.x1 +
                        "," +
                        (50 - t.y1) +
                        " Z"
                      );
                    })(this.parent.options.arrowShape);
                  return (
                    e.setAttribute("d", i),
                    e.setAttribute("class", "arrow"),
                    this.isLeft ||
                      e.setAttribute(
                        "transform",
                        "translate(100, 100) rotate(180) "
                      ),
                    t.appendChild(e),
                    t
                  );
                }),
                (o.prototype.handleEvent = n.handleEvent),
                (o.prototype.onclick = function () {
                  if (this.isEnabled) {
                    this.parent.uiChange();
                    var t = this.isPrevious ? "previous" : "next";
                    this.parent[t]();
                  }
                }),
                (o.prototype.enable = function () {
                  this.isEnabled ||
                    ((this.element.disabled = !1), (this.isEnabled = !0));
                }),
                (o.prototype.disable = function () {
                  this.isEnabled &&
                    ((this.element.disabled = !0), (this.isEnabled = !1));
                }),
                (o.prototype.update = function () {
                  var t = this.parent.slides;
                  if (this.parent.options.wrapAround && t.length > 1)
                    this.enable();
                  else {
                    var e = t.length ? t.length - 1 : 0,
                      i = this.isPrevious ? 0 : e;
                    this[
                      this.parent.selectedIndex == i ? "disable" : "enable"
                    ]();
                  }
                }),
                (o.prototype.destroy = function () {
                  this.deactivate(), this.allOff();
                }),
                n.extend(e.defaults, {
                  prevNextButtons: !0,
                  arrowShape: {
                    x0: 10,
                    x1: 60,
                    y1: 50,
                    x2: 70,
                    y2: 40,
                    x3: 30,
                  },
                }),
                e.createMethods.push("_createPrevNextButtons");
              var r = e.prototype;
              return (
                (r._createPrevNextButtons = function () {
                  this.options.prevNextButtons &&
                    ((this.prevButton = new o(-1, this)),
                    (this.nextButton = new o(1, this)),
                    this.on("activate", this.activatePrevNextButtons));
                }),
                (r.activatePrevNextButtons = function () {
                  this.prevButton.activate(),
                    this.nextButton.activate(),
                    this.on("deactivate", this.deactivatePrevNextButtons);
                }),
                (r.deactivatePrevNextButtons = function () {
                  this.prevButton.deactivate(),
                    this.nextButton.deactivate(),
                    this.off("deactivate", this.deactivatePrevNextButtons);
                }),
                (e.PrevNextButton = o),
                e
              );
            });
          }),
          sn(function (t) {
            !(function (e, i) {
              t.exports
                ? (t.exports = i(e, _n, Sn, vn))
                : i(e, e.Flickity, e.Unipointer, e.fizzyUIUtils);
            })(window, function (t, e, i, n) {
              function s(t) {
                (this.parent = t), this._create();
              }
              (s.prototype = Object.create(i.prototype)),
                (s.prototype._create = function () {
                  (this.holder = document.createElement("ol")),
                    (this.holder.className = "flickity-page-dots"),
                    (this.dots = []),
                    (this.handleClick = this.onClick.bind(this)),
                    this.on(
                      "pointerDown",
                      this.parent.childUIPointerDown.bind(this.parent)
                    );
                }),
                (s.prototype.activate = function () {
                  this.setDots(),
                    this.holder.addEventListener("click", this.handleClick),
                    this.bindStartEvent(this.holder),
                    this.parent.element.appendChild(this.holder);
                }),
                (s.prototype.deactivate = function () {
                  this.holder.removeEventListener("click", this.handleClick),
                    this.unbindStartEvent(this.holder),
                    this.parent.element.removeChild(this.holder);
                }),
                (s.prototype.setDots = function () {
                  var t = this.parent.slides.length - this.dots.length;
                  t > 0 ? this.addDots(t) : t < 0 && this.removeDots(-t);
                }),
                (s.prototype.addDots = function (t) {
                  for (
                    var e = document.createDocumentFragment(),
                      i = [],
                      n = this.dots.length,
                      s = n + t,
                      o = n;
                    o < s;
                    o++
                  ) {
                    var r = document.createElement("li");
                    (r.className = "dot"),
                      r.setAttribute("aria-label", "Page dot " + (o + 1)),
                      e.appendChild(r),
                      i.push(r);
                  }
                  this.holder.appendChild(e), (this.dots = this.dots.concat(i));
                }),
                (s.prototype.removeDots = function (t) {
                  this.dots
                    .splice(this.dots.length - t, t)
                    .forEach(function (t) {
                      this.holder.removeChild(t);
                    }, this);
                }),
                (s.prototype.updateSelected = function () {
                  this.selectedDot &&
                    ((this.selectedDot.className = "dot"),
                    this.selectedDot.removeAttribute("aria-current")),
                    this.dots.length &&
                      ((this.selectedDot =
                        this.dots[this.parent.selectedIndex]),
                      (this.selectedDot.className = "dot is-selected"),
                      this.selectedDot.setAttribute("aria-current", "step"));
                }),
                (s.prototype.onTap = s.prototype.onClick =
                  function (t) {
                    var e = t.target;
                    if ("LI" == e.nodeName) {
                      this.parent.uiChange();
                      var i = this.dots.indexOf(e);
                      this.parent.select(i);
                    }
                  }),
                (s.prototype.destroy = function () {
                  this.deactivate(), this.allOff();
                }),
                (e.PageDots = s),
                n.extend(e.defaults, { pageDots: !0 }),
                e.createMethods.push("_createPageDots");
              var o = e.prototype;
              return (
                (o._createPageDots = function () {
                  this.options.pageDots &&
                    ((this.pageDots = new s(this)),
                    this.on("activate", this.activatePageDots),
                    this.on("select", this.updateSelectedPageDots),
                    this.on("cellChange", this.updatePageDots),
                    this.on("resize", this.updatePageDots),
                    this.on("deactivate", this.deactivatePageDots));
                }),
                (o.activatePageDots = function () {
                  this.pageDots.activate();
                }),
                (o.updateSelectedPageDots = function () {
                  this.pageDots.updateSelected();
                }),
                (o.updatePageDots = function () {
                  this.pageDots.setDots();
                }),
                (o.deactivatePageDots = function () {
                  this.pageDots.deactivate();
                }),
                (e.PageDots = s),
                e
              );
            });
          }),
          sn(function (t) {
            !(function (e, i) {
              t.exports
                ? (t.exports = i(fn, vn, _n))
                : i(e.EvEmitter, e.fizzyUIUtils, e.Flickity);
            })(window, function (t, e, i) {
              function n(t) {
                (this.parent = t),
                  (this.state = "stopped"),
                  (this.onVisibilityChange = this.visibilityChange.bind(this)),
                  (this.onVisibilityPlay = this.visibilityPlay.bind(this));
              }
              (n.prototype = Object.create(t.prototype)),
                (n.prototype.play = function () {
                  "playing" != this.state &&
                    (document.hidden
                      ? document.addEventListener(
                          "visibilitychange",
                          this.onVisibilityPlay
                        )
                      : ((this.state = "playing"),
                        document.addEventListener(
                          "visibilitychange",
                          this.onVisibilityChange
                        ),
                        this.tick()));
                }),
                (n.prototype.tick = function () {
                  if ("playing" == this.state) {
                    var t = this.parent.options.autoPlay;
                    t = "number" == typeof t ? t : 3e3;
                    var e = this;
                    this.clear(),
                      (this.timeout = setTimeout(function () {
                        e.parent.next(!0), e.tick();
                      }, t));
                  }
                }),
                (n.prototype.stop = function () {
                  (this.state = "stopped"),
                    this.clear(),
                    document.removeEventListener(
                      "visibilitychange",
                      this.onVisibilityChange
                    );
                }),
                (n.prototype.clear = function () {
                  clearTimeout(this.timeout);
                }),
                (n.prototype.pause = function () {
                  "playing" == this.state &&
                    ((this.state = "paused"), this.clear());
                }),
                (n.prototype.unpause = function () {
                  "paused" == this.state && this.play();
                }),
                (n.prototype.visibilityChange = function () {
                  this[document.hidden ? "pause" : "unpause"]();
                }),
                (n.prototype.visibilityPlay = function () {
                  this.play(),
                    document.removeEventListener(
                      "visibilitychange",
                      this.onVisibilityPlay
                    );
                }),
                e.extend(i.defaults, { pauseAutoPlayOnHover: !0 }),
                i.createMethods.push("_createPlayer");
              var s = i.prototype;
              return (
                (s._createPlayer = function () {
                  (this.player = new n(this)),
                    this.on("activate", this.activatePlayer),
                    this.on("uiChange", this.stopPlayer),
                    this.on("pointerDown", this.stopPlayer),
                    this.on("deactivate", this.deactivatePlayer);
                }),
                (s.activatePlayer = function () {
                  this.options.autoPlay &&
                    (this.player.play(),
                    this.element.addEventListener("mouseenter", this));
                }),
                (s.playPlayer = function () {
                  this.player.play();
                }),
                (s.stopPlayer = function () {
                  this.player.stop();
                }),
                (s.pausePlayer = function () {
                  this.player.pause();
                }),
                (s.unpausePlayer = function () {
                  this.player.unpause();
                }),
                (s.deactivatePlayer = function () {
                  this.player.stop(),
                    this.element.removeEventListener("mouseenter", this);
                }),
                (s.onmouseenter = function () {
                  this.options.pauseAutoPlayOnHover &&
                    (this.player.pause(),
                    this.element.addEventListener("mouseleave", this));
                }),
                (s.onmouseleave = function () {
                  this.player.unpause(),
                    this.element.removeEventListener("mouseleave", this);
                }),
                (i.Player = n),
                i
              );
            });
          }),
          sn(function (t) {
            !(function (e, i) {
              t.exports
                ? (t.exports = i(e, _n, vn))
                : i(e, e.Flickity, e.fizzyUIUtils);
            })(window, function (t, e, i) {
              var n = e.prototype;
              return (
                (n.insert = function (t, e) {
                  var i = this._makeCells(t);
                  if (i && i.length) {
                    var n = this.cells.length;
                    e = void 0 === e ? n : e;
                    var s = (function (t) {
                        var e = document.createDocumentFragment();
                        return (
                          t.forEach(function (t) {
                            e.appendChild(t.element);
                          }),
                          e
                        );
                      })(i),
                      o = e == n;
                    if (o) this.slider.appendChild(s);
                    else {
                      var r = this.cells[e].element;
                      this.slider.insertBefore(s, r);
                    }
                    if (0 === e) this.cells = i.concat(this.cells);
                    else if (o) this.cells = this.cells.concat(i);
                    else {
                      var a = this.cells.splice(e, n - e);
                      this.cells = this.cells.concat(i).concat(a);
                    }
                    this._sizeCells(i), this.cellChange(e, !0);
                  }
                }),
                (n.append = function (t) {
                  this.insert(t, this.cells.length);
                }),
                (n.prepend = function (t) {
                  this.insert(t, 0);
                }),
                (n.remove = function (t) {
                  var e = this.getCells(t);
                  if (e && e.length) {
                    var n = this.cells.length - 1;
                    e.forEach(function (t) {
                      t.remove();
                      var e = this.cells.indexOf(t);
                      (n = Math.min(e, n)), i.removeFrom(this.cells, t);
                    }, this),
                      this.cellChange(n, !0);
                  }
                }),
                (n.cellSizeChange = function (t) {
                  var e = this.getCell(t);
                  if (e) {
                    e.getSize();
                    var i = this.cells.indexOf(e);
                    this.cellChange(i);
                  }
                }),
                (n.cellChange = function (t, e) {
                  var i = this.selectedElement;
                  this._positionCells(t),
                    this._getWrapShiftCells(),
                    this.setGallerySize();
                  var n = this.getCell(i);
                  n && (this.selectedIndex = this.getCellSlideIndex(n)),
                    (this.selectedIndex = Math.min(
                      this.slides.length - 1,
                      this.selectedIndex
                    )),
                    this.emitEvent("cellChange", [t]),
                    this.select(this.selectedIndex),
                    e && this.positionSliderAtSelected();
                }),
                e
              );
            });
          }),
          sn(function (t) {
            !(function (e, i) {
              t.exports
                ? (t.exports = i(e, _n, vn))
                : i(e, e.Flickity, e.fizzyUIUtils);
            })(window, function (t, e, i) {
              e.createMethods.push("_createLazyload");
              var n = e.prototype;
              function s(t, e) {
                (this.img = t), (this.flickity = e), this.load();
              }
              return (
                (n._createLazyload = function () {
                  this.on("select", this.lazyLoad);
                }),
                (n.lazyLoad = function () {
                  var t = this.options.lazyLoad;
                  if (t) {
                    var e = "number" == typeof t ? t : 0,
                      n = this.getAdjacentCellElements(e),
                      o = [];
                    n.forEach(function (t) {
                      var e = (function (t) {
                        if ("IMG" == t.nodeName) {
                          var e = t.getAttribute("data-flickity-lazyload"),
                            n = t.getAttribute("data-flickity-lazyload-src"),
                            s = t.getAttribute("data-flickity-lazyload-srcset");
                          if (e || n || s) return [t];
                        }
                        var o =
                            "img[data-flickity-lazyload], img[data-flickity-lazyload-src], img[data-flickity-lazyload-srcset]",
                          r = t.querySelectorAll(o);
                        return i.makeArray(r);
                      })(t);
                      o = o.concat(e);
                    }),
                      o.forEach(function (t) {
                        new s(t, this);
                      }, this);
                  }
                }),
                (s.prototype.handleEvent = i.handleEvent),
                (s.prototype.load = function () {
                  this.img.addEventListener("load", this),
                    this.img.addEventListener("error", this);
                  var t =
                      this.img.getAttribute("data-flickity-lazyload") ||
                      this.img.getAttribute("data-flickity-lazyload-src"),
                    e = this.img.getAttribute("data-flickity-lazyload-srcset");
                  (this.img.src = t),
                    e && this.img.setAttribute("srcset", e),
                    this.img.removeAttribute("data-flickity-lazyload"),
                    this.img.removeAttribute("data-flickity-lazyload-src"),
                    this.img.removeAttribute("data-flickity-lazyload-srcset");
                }),
                (s.prototype.onload = function (t) {
                  this.complete(t, "flickity-lazyloaded");
                }),
                (s.prototype.onerror = function (t) {
                  this.complete(t, "flickity-lazyerror");
                }),
                (s.prototype.complete = function (t, e) {
                  this.img.removeEventListener("load", this),
                    this.img.removeEventListener("error", this);
                  var i = this.flickity.getParentCell(this.img),
                    n = i && i.element;
                  this.flickity.cellSizeChange(n),
                    this.img.classList.add(e),
                    this.flickity.dispatchEvent("lazyLoad", t, n);
                }),
                (e.LazyLoader = s),
                e
              );
            });
          }),
          sn(function (t) {
            /*!
             * Flickity v2.3.0
             * Touch, responsive, flickable carousels
             *
             * Licensed GPLv3 for open source use
             * or Flickity Commercial License for commercial use
             *
             * https://flickity.metafizzy.co
             * Copyright 2015-2021 Metafizzy
             */
            window, t.exports && (t.exports = _n);
          })),
        xn = (function () {
          function t(e) {
            !(function (t, e) {
              if (!(t instanceof e))
                throw new TypeError("Cannot call a class as a function");
            })(this, t),
              (this.sectionEl = e.sectionEl),
              (this.sectionId = e.sectionId),
              (this.events = new rn()),
              (this.productId = e.productId),
              (this.includeIndicatorDots = e.includeIndicatorDots || !1),
              (this.recommendationsRoute = e.productRecommendationsRoute),
              (this.limit = e.limit);
            (this.arrowShape = e.arrowShape || {
              x0: 10,
              x1: 60,
              y1: 50,
              x2: 65,
              y2: 45,
              x3: 20,
            }),
              (this.recommendationsEl = this.sectionEl.querySelector(
                "[data-complementary-products]"
              )),
              this.loadRecommendations();
          }
          var e, i, n;
          return (
            (e = t),
            (i = [
              {
                key: "loadRecommendations",
                value: function () {
                  var t = this,
                    e = ""
                      .concat(this.recommendationsRoute, "?section_id=")
                      .concat(this.sectionId, "&limit=")
                      .concat(this.limit, "&product_id=")
                      .concat(this.productId, "&intent=complementary");
                  pn.load(e, { view: "" }).then(function (e) {
                    var i = e.html;
                    if ("object" !== tn(i) || 0 !== Object.keys(i).length)
                      if (0 !== i.trim().length) {
                        (t.recommendationsEl.innerHTML = i),
                          B.instance || B.init(),
                          B.watch(t.recommendationsEl);
                        var n =
                          t.recommendationsEl.querySelector("[data-slider]");
                        t.recommendationsEl.querySelectorAll("[data-slide]")
                          .length > 1 &&
                          ((t.slider = new kn(n, {
                            cellSelector: "[data-slide]",
                            accessibility: !1,
                            adaptiveHeight: !1,
                            autoPlay: !1,
                            cellAlign: "left",
                            contain: !0,
                            imagesLoaded: !0,
                            pageDots: t.includeIndicatorDots,
                            wrapAround: !0,
                            arrowShape: t.arrowShape,
                          })),
                          t.events.register(n, "rimg:load", function () {
                            t.slider.resize();
                          }));
                      } else
                        t.recommendationsEl.classList.add(
                          "complementary-products--no-recommendations"
                        );
                  });
                },
              },
              {
                key: "unload",
                value: function () {
                  this.slider.destroy();
                },
              },
            ]),
            i && en(e.prototype, i),
            n && en(e, n),
            Object.defineProperty(e, "prototype", { writable: !1 }),
            t
          );
        })();
      const En = xn;
      class An {
        constructor(t) {
          let i =
            arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
          (this.section = t),
            (this.sectionId = t.id),
            (this.el = this.section.el),
            (this.$el = e()(this.section.el)),
            (this.context = t.data.context),
            (this.settings = t.data.settings),
            (this.product = t.data.product),
            (this.productRecommendationLimit =
              t.data.product_recommendation_limit),
            (this.richText = null),
            (this.readmoreText = null),
            (this.reviewForm = null),
            (this.isThemeEditor = window.Shopify && window.Shopify.designMode),
            (this.useHistory =
              "useHistory" in i
                ? i.useHistory
                : !(this.isThemeEditor || !history.replaceState));
          this.el.querySelector("[data-complementary-products]") &&
            (this.complementaryProducts = new En({
              sectionEl: this.el,
              sectionId: this.sectionId,
              productId: this.product.id,
              productRecommendationsRoute:
                window.Theme.routes.product_recommendations_url,
              includeIndicatorDots: !0,
              limit: this.productRecommendationLimit,
              arrowShape:
                "M 65.29,11.99 L 27.28,50 L 65.3,87.99 L 70.25,83.06 L 37.19,50 L 70.26,16.94 L 65.29,11.99 Z",
            }));
          const n = this.$el.find("[data-product-gallery]")[0],
            o = this.$el.find("[data-product-wrapper]");
          (this.$details = this.$el.find("[data-product-details]")),
            (this.$description = this.$el.find("[data-product-description]")),
            (this.$readmore = this.$el.find("[data-product-readmore]")),
            (this.$formRegular = this.$el.find("[data-product-form-regular]")),
            (this.$formAlt = this.$el.find("[data-product-form-alt]")),
            (this.$formArea = this.$el.find("[data-product-form-area]")),
            (this.layoutHandler = this.onBreakpointChange.bind(this)),
            zt.onBreakpointChange(this.layoutHandler),
            o.hasClass("product__container--three-columns") && this._moveForm(),
            this.$description.length &&
              (this.richText = new X(this.$description)),
            this.$readmore.length &&
              (this.readmoreText = new X(this.$readmore)),
            s()(e()("[data-scripts]").data("shopify-api-url"), () => {
              this.productDetails = new pi({
                $formArea: this.$formArea,
                $details: this.$details,
                gallery: n,
                context: this.context,
                settings: this.settings,
                product: this.product,
                useHistory: this.useHistory,
                sectionId: t.id,
                productEl: this.$el[0],
              });
            });
        }
        onSectionUnload() {
          zt.offBreakpointChange(this.layoutHandler),
            this.productDetails && this.productDetails.unload(),
            this.richText && this.richText.unload(),
            this.readmoreText && this.readmoreText.unload(),
            this.reviewForm && this.reviewForm.unload();
        }
        onBreakpointChange() {
          this.$formAlt.length && this._moveForm();
        }
        _moveForm() {
          if (zt.isGreaterThanBreakpoint("M")) {
            if (!e().contains(this.$formAlt[0], this.$formArea[0])) {
              const t = this.$formArea.detach();
              this.$formAlt.append(t);
            }
          } else if (!e().contains(this.$formRegular[0], this.$formArea[0])) {
            const t = this.$formArea.detach();
            this.$formRegular.append(t);
          }
        }
      }
      class Tn extends An {}
      class Ln {
        constructor() {
          (this.events = new xt.Z()),
            (this.els = []),
            (this.lastTop = 0),
            (this.lastLeft = 0),
            (this.ticking = !1),
            (this.driver = null),
            (this.settledTimeout = null);
        }
        add(t) {
          this.els.includes(t) ||
            (this.els.push(t),
            this.events.register(t, "scroll", (t) => {
              null === this.driver &&
                ((this.driver = t.target), this._unsetScrollSnapTypes()),
                this.driver && t.target !== this.driver
                  ? t.preventDefault()
                  : ((this.lastTop = t.target.scrollTop),
                    (this.lastLeft = t.target.scrollLeft),
                    clearTimeout(this.settledTimeout),
                    this.ticking ||
                      window.requestAnimationFrame(() => {
                        this._updateScroll(),
                          (this.ticking = !1),
                          (this.settledTimeout = setTimeout(() => {
                            (this.driver = null), this._resetScrollSnapTypes();
                          }, 50));
                      }),
                    (this.ticking = !0));
            }));
        }
        unload() {
          this.events.unregisterAll();
        }
        syncAll() {
          this._updateScroll();
        }
        _updateScroll() {
          this.els.forEach((t) => {
            t !== this.driver &&
              ((t.scrollTop = this.lastTop), (t.scrollLeft = this.lastLeft));
          });
        }
        _unsetScrollSnapTypes() {
          this.els.forEach((t) => {
            t !== this.driver && (t.style.scrollSnapType = "none");
          });
        }
        _resetScrollSnapTypes() {
          this.els.forEach((t) => {
            t.style.scrollSnapType = null;
          });
        }
      }
      const Dn = "show-more__content-wrapper--no-overflow";
      class In {
        constructor(t) {
          let { el: e, context: i } = t;
          (this.context = i),
            (this.wrapper = e.querySelector(
              "[data-show-more-content-wrapper]"
            )),
            (this.toggle = e.querySelector("[data-show-more-toggle]")),
            this.wrapper &&
              this.toggle &&
              ((this.events = new xt.Z()),
              (this.menuIsOpen = !1),
              (this.menuTransition = Mt({
                el: this.wrapper,
                state: "closed",
                stateAttribute: "data-show-more-state",
                stateChangeAttribute: "data-show-more-animation",
              })),
              this.events.register(this.toggle, "click", () => {
                this.menuIsOpen ? this._closeMenu() : this._openMenu();
              }),
              (this.onBreakpointChange = () => this._closeMenu()),
              Ot.onChange(this.onBreakpointChange),
              this.checkOverflow());
        }
        unload() {
          this.events && this.events.unregisterAll(),
            Ot.offChange(this.onBreakpointChange);
        }
        checkOverflow() {
          this._closeMenu(!0);
        }
        _checkOverflow() {
          const { height: t } = this.wrapper.getBoundingClientRect(),
            { scrollHeight: e } = this.wrapper,
            i = Math.ceil(e) <= Math.ceil(t);
          this.wrapper.classList.toggle(Dn, i);
        }
        _openMenu() {
          (this.menuIsOpen = !0),
            (this.toggle.innerHTML = this.context.see_less);
          const { height: t } = this.wrapper.getBoundingClientRect();
          this.wrapper.style.setProperty("--closed-height", `${t}px`),
            (this.wrapper.style.maxHeight = "none"),
            this.menuTransition.animateTo("open", {
              onStart: () => {
                const { height: t } = this.toggle.getBoundingClientRect(),
                  e = this.wrapper.scrollHeight + t;
                this.wrapper.style.setProperty("--open-height", `${e}px`);
              },
            });
        }
        _closeMenu(t) {
          (this.menuIsOpen = !1),
            (this.toggle.innerHTML = this.context.see_more),
            this.wrapper.classList.remove(Dn),
            this.menuTransition.animateTo("closed", { force: t }).then(() => {
              this.wrapper.style.removeProperty("--closed-height"),
                (this.wrapper.style.maxHeight = null),
                this._checkOverflow();
            });
        }
      }
      const Pn = "product-compare__table-row--last";
      class Mn {
        constructor(t) {
          var e;
          (this.sectionId = t.id),
            (this.el = t.el),
            (this.data = t.data),
            (this.baseUrl = `${(e = t.data.root_url)}${
              /\/$/.test(e) ? "" : "/"
            }products`),
            (this.templateCells = {}),
            (this.productItems = []),
            (this.showMoreToggles = []),
            (this.descriptionItems = []),
            (this.filterLabels = {}),
            (this.filterGroups = t.data.filter_groups),
            (this.activeFilterIds = new Map()),
            (this.filterCheckboxes = new Map()),
            (this.events = new xt.Z()),
            (this.filtersModal = new ee({
              onBeforeOpen: () => this._onBeforeFiltersModalOpen(),
              onClose: () => this._onFiltersModalClose(),
            })),
            (this.allRows = this.el.querySelectorAll(
              '[data-compare-row-type="info"], [data-compare-row-type="heading"]'
            )),
            (this.infoRows = this.el.querySelectorAll(
              '[data-compare-row-type="info"]'
            )),
            (this.headingRows = this.el.querySelectorAll(
              '[data-compare-row-type="heading"]'
            )),
            this._initCell(this.el),
            (this.table = this.el.querySelector("[data-compare-table]"));
          const i = this.infoRows[0],
            n = this.allRows[1],
            s = this.el.querySelector("[data-compare-empty]");
          if (
            ([
              { target: i, newTarget: this.table },
              { target: n, newTarget: this.table },
            ].forEach((t) => {
              let { target: e, newTarget: i } = t;
              this.events.register(e, "transitionend", (t) => {
                t.target === e && i.dispatchEvent(new Event("transitionend"));
              });
            }),
            (this.clearAllFadeAnimation = Mt({
              el: this.table,
              state: "visible",
              stateAttribute: "data-fade-animation-state",
              stateChangeAttribute: "data-fade-animation",
            })),
            (this.emptyMessageAnimation = Mt({
              el: s,
              state: "hidden",
              stateAttribute: "data-animation-state",
              stateChangeAttribute: "data-animation",
            })),
            (this.animateToEmptyState = () => {
              this._removeAllFilters(),
                this._disableFilters(),
                this.stickyObserver.disconnect(),
                this.stickyBarAnimation.animateTo("up"),
                this.clearAllFadeAnimation
                  .animateTo("only-cards", { force: this.allRows.length < 2 })
                  .then(() => this.clearAllFadeAnimation.animateTo("hidden"))
                  .then(() =>
                    this.emptyMessageAnimation.animateTo("visible", {
                      onStart: () => {
                        document.documentElement.scroll(0, 0);
                      },
                    })
                  );
            }),
            this._registerProductRemoveEvents(this.el),
            (this.scrollLink = new Ln()),
            this.scrollLink.add(
              this.el.querySelector("[data-compare-table-scroll-wrapper]")
            ),
            (this.filtersEl = this.el.querySelector("[data-compare-filters]")),
            this.filtersEl)
          ) {
            const t = { groups: this.filterGroups };
            (this.filterGroupAccordions = new ki(this.filtersEl, t)),
              this.filtersEl
                .querySelectorAll("[data-filter-checkbox-for]")
                .forEach((t) => {
                  this.filterCheckboxes.set(
                    t.dataset.filterCheckboxFor,
                    new wi(t)
                  );
                }),
              (this.filtersModalButton = this.el.querySelector(
                "[data-compare-open-filter-modal-button]"
              )),
              this.events.register(this.filtersModalButton, "click", () =>
                this.filtersModal.open(
                  "[data-compare-filters-modal-target]",
                  "productgrid-filters"
                )
              ),
              (this.mobileActiveFiltersTarget = this.el.querySelector(
                "[data-compare-mobile-active-filters-target]"
              )),
              (this.activeFiltersContainer = this.el.querySelector(
                "[data-compare-active-filters-container]"
              )),
              (this.activeFiltersEl = this.activeFiltersContainer.querySelector(
                "[data-compare-active-filters]"
              )),
              (this.removeFilterTemplate =
                this.activeFiltersContainer.querySelector(
                  "[data-compare-filter-remove-template]"
                )),
              (this.clearAllFiltersTemplate =
                this.activeFiltersContainer.querySelector(
                  "[data-compare-filter-clear-all-template]"
                )),
              this.events.register(this.activeFiltersEl, "click", (t) => {
                const e = t.target.closest(
                  "[data-product-compare-filter-remove]"
                );
                if (!e) return;
                t.stopPropagation();
                const i = e.dataset.productCompareFilterRemove;
                "" !== i
                  ? ((document.getElementById(i).checked = !1),
                    this._updateFilter({ checked: !1, id: i }))
                  : this._removeAllFilters();
              });
          }
          this.events.register(this.filtersEl, "change", (t) => {
            const e = t.target.value;
            (this.filterLabels[e] = t.target.labels[0].innerText),
              this._updateFilter({ checked: t.target.checked, id: e });
          });
          const o = (() => {
            const { searchParams: t } = new URL(window.location),
              e = t.get("compare");
            return "string" == typeof e && "" !== e ? e.split(",") : [];
          })();
          (this.allHandles = [t.data.handle, ...o]),
            this._updateBreadcrumbs(),
            o.length
              ? (this._addBlankColumns(o.length),
                this._setProductCountVar(this.allHandles.length),
                Promise.all(this._fetchCompareProducts(o)).then(() =>
                  this._injectStickyBar()
                ))
              : this._injectStickyBar();
        }
        onSectionUnload() {
          this.productItems.forEach((t) => {
            t.unload();
          }),
            this.events.unregisterAll(),
            this.filterGroups && this.filterGroupAccordions.unload(),
            this.filterCheckboxes.forEach((t) => t.unload()),
            this.stickyBarAnimation.unload(),
            this.clearAllFadeAnimation.unload(),
            this.scrollLink.unload(),
            this.stickyBar.remove(),
            this.tableObserver && this.tableObserver.disconnect(),
            this.stickyObserver && this.stickyObserver.disconnect();
        }
        _registerProductRemoveEvents(t) {
          this.events.register(
            t.querySelector("[data-compare-clear-all]"),
            "click",
            () => {
              this.animateToEmptyState(), bi.removeAll();
            }
          ),
            this.events.register(t, "click", (t) => {
              const e = t.target.closest("[data-compare-remove]");
              e && this._removeHandle(e.dataset.compareRemove);
            });
        }
        _injectStickyBar() {
          const t = this.el.querySelector(
            "[data-compare-sticky-bar-template]"
          ).content;
          t
            .querySelector("[data-compare-table]")
            .appendChild(this.infoRows[0].cloneNode(!0)),
            this._addScrollStops(t, this.allHandles.length - 2),
            document.querySelector("[data-site-header]").append(t),
            (this.stickyBar = document.querySelector(
              "[data-compare-sticky-bar]"
            )),
            (this.stickyBarRow = this.stickyBar.querySelector(
              '[data-compare-row-type="info"]'
            )),
            this._initProductItems(this.stickyBar),
            Fe(this.stickyBar),
            this._registerProductRemoveEvents(this.stickyBar),
            this.scrollLink.add(
              this.stickyBar.querySelector(
                "[data-compare-table-scroll-wrapper]"
              )
            );
          const e = this.infoRows[0];
          this.stickyBarAnimation = Mt({
            el: document.querySelector("[data-compare-sticky-bar]"),
            state: "up",
            stateAttribute: "data-sticky-animation-state",
            stateChangeAttribute: "data-sticky-animation",
          });
          const i = () =>
            this.stickyBarAnimation.animateTo("down", {
              onStart: () => this.scrollLink.syncAll(),
            });
          this.tableObserver = null;
          const n = () => {
              const { top: t, height: e } =
                this.stickyBar.getBoundingClientRect();
              (this.tableObserver = new IntersectionObserver(
                (t) => {
                  let [e] = t;
                  e.isIntersecting
                    ? i()
                    : this.stickyBarAnimation.animateTo("up");
                },
                { rootMargin: `-${t + e}px 0px 0px 0px`, threshold: 0 }
              )),
                this.tableObserver.observe(this.table);
            },
            s = document.body.classList.contains("site-header-sticky");
          (this.stickyObserver = new IntersectionObserver(
            (t) => {
              let [e] = t;
              e.isIntersecting
                ? (this.tableObserver &&
                    (this.tableObserver.disconnect(),
                    (this.tableObserver = null)),
                  this.stickyBarAnimation.animateTo("up"))
                : i().then(n);
            },
            { rootMargin: (s ? "-100" : "0") + "px 0px 0px 0px", threshold: 0 }
          )),
            this.stickyObserver.observe(e);
        }
        _setProductCountVar(t) {
          document.body.style.setProperty(
            "--compare-products-count",
            Math.max(t, 2)
          );
        }
        _addBlankColumns(t) {
          this.infoRows.forEach((e) => {
            const i = e.querySelector("[data-compare-cell-placeholder]");
            this.templateCells[e.dataset.compareRowId] =
              i.parentNode.removeChild(i);
            for (let n = 0; n < t; n++) e.appendChild(i.cloneNode(!0));
          }),
            this.headingRows.forEach((e) => {
              e.querySelector("[data-compare-heading]").colSpan += t - 1;
            }),
            this._addScrollStops(this.el, t - 1);
        }
        _addScrollStops(t, e) {
          const i = t.querySelector("[data-compare-scroll-stop]");
          for (let t = 0; t < e; t++) i.after(i.cloneNode(!0));
        }
        _removeHandle(t) {
          if (1 === this.allHandles.length)
            return (
              this.animateToEmptyState(),
              bi.remove(t),
              void this._setProductCountVar(this.allHandles.length)
            );
          this._removeColumn(t),
            (this.allHandles = this.allHandles.filter((e) => e !== t)),
            this._setProductCountVar(this.allHandles.length),
            ((t) => {
              if (window.Shopify && window.Shopify.designMode) return;
              const [e, ...i] = t,
                n = new URL(window.location);
              n.searchParams.set("compare", i.join(",")),
                e && (n.pathname = n.pathname.replace(/\/[^/]+$/, `/${e}`)),
                history.replaceState({}, "", n);
            })(this.allHandles),
            bi.remove(t);
        }
        _removeColumn(t) {
          const e = this.allHandles.length <= 2;
          [this.stickyBarRow, ...this.infoRows].forEach((i) => {
            const n = i.querySelectorAll("[data-compare-cell]")[
              this.allHandles.indexOf(t)
            ];
            e &&
              n.parentNode.append(
                this.templateCells[i.dataset.compareRowId].cloneNode(!0)
              ),
              n.remove();
          }),
            e ||
              (this.headingRows.forEach((t) => {
                t.querySelector("[data-compare-heading]").colSpan--;
              }),
              [this.stickyBar, this.el].forEach((t) => {
                t.querySelector("[data-compare-scroll-stop]").remove();
              }),
              this.showMoreToggles.forEach((t) => t.checkOverflow()));
          const i = this.el.querySelectorAll("[data-product-item-image] img");
          B.instance.update(i);
        }
        _fetchCompareProducts(t) {
          return t.map((t, e) =>
            kt
              .load(`${this.baseUrl}/${t}`, this.sectionId, { view: "compare" })
              .then((t) => {
                let { html: i } = t;
                const n = new DOMParser().parseFromString(i, "text/html");
                this._populateContent(n, e + 1);
              })
          );
        }
        _populateContent(t, e) {
          t.querySelectorAll('[data-compare-row-type="info"]').forEach((t) => {
            const { compareRowId: i } = t.dataset,
              n = t.querySelector("[data-compare-cell]").innerHTML,
              s = this.el
                .querySelector(`[data-compare-row-id="${i}"]`)
                .querySelectorAll("[data-compare-cell]")[e];
            (s.innerHTML = n),
              s
                .querySelectorAll("[data-compare-remove-on-populate")
                .forEach((t) => t.remove()),
              this._initCell(s);
          }),
            this.showMoreToggles.forEach((t) => t.checkOverflow());
        }
        _updateBreadcrumbs() {
          const t = this.el.querySelector("[data-compare-breadcrumb]");
          if (!bi.returnBreadcrumb) return void t.remove();
          const { url: e, title: i } = bi.returnBreadcrumb;
          if (((t.href = e), i)) {
            t.querySelector("[data-compare-breadcrumb-text]").innerHTML =
              this.data.breadcrumb.replace("** location **", i);
          }
          this.el
            .querySelectorAll("[data-compare-placeholder-link]")
            .forEach((t) => {
              t.href = e;
            });
        }
        _removeAllFilters() {
          this.activeFilterIds.forEach((t, e) => {
            (document.getElementById(e).checked = !1),
              this._updateFilter({ checked: !1, id: e });
          });
        }
        _disableFilters() {
          (this.filtersDisabled = !0),
            this.filtersEl
              .querySelectorAll("[data-compare-filter-checkbox]")
              .forEach((t) => {
                t.disabled = !0;
              });
        }
        _updateFilter(t) {
          let { checked: e, id: i } = t;
          if (this.filtersDisabled) return;
          e
            ? (this.activeFilterIds.set(i, !0),
              this.filterCheckboxes.get(i).check())
            : (this.activeFilterIds.delete(i),
              this.filterCheckboxes.get(i).uncheck()),
            this._updateAppliedFilters(),
            this._updateActiveFilterCount();
          0 !== this.activeFilterIds.size
            ? (this.infoRows.forEach((t) => {
                "compareIgnoreFilter" in t.dataset ||
                  (t.style.display = this.activeFilterIds.has(
                    t.dataset.compareRowId
                  )
                    ? ""
                    : "none");
              }),
              this._updateHeadersDisplay())
            : this.allRows.forEach((t) => {
                (t.style.display = ""), t.classList.remove(Pn);
              });
        }
        _updateAppliedFilters() {
          (this.activeFiltersEl.innerHTML = ""),
            this.activeFilterIds.forEach((t, e) => {
              const i = this.removeFilterTemplate.cloneNode(!0).content;
              (i.firstElementChild.dataset.productCompareFilterRemove = e),
                (i.querySelector(
                  "[data-compare-filter-remove-text]"
                ).innerHTML = this.filterLabels[e]),
                this.activeFiltersEl.append(i);
            }),
            this.activeFilterIds.size
              ? ((this.activeFiltersContainer.style.display = ""),
                this.activeFiltersEl.append(
                  this.clearAllFiltersTemplate.cloneNode(!0).content
                ))
              : (this.activeFiltersContainer.style.display = "none");
        }
        _updateActiveFilterCount() {
          const t = this.el.querySelector("[data-compare-filter-text]");
          if (this.activeFilterIds.size > 0) {
            const e = this.data.filter_count.replace(
              "** count **",
              this.activeFilterIds.size
            );
            t.innerHTML = e;
          } else t.innerHTML = this.data.filter_count_zero;
        }
        _updateHeadersDisplay() {
          let t = null,
            e = !1,
            i = null;
          const n = () => {
              t && (t.style.display = e ? "" : "none");
            },
            s = () => {
              i && i.classList.add(Pn);
            };
          this.allRows.forEach((o) => {
            o.classList.remove(Pn),
              "heading" === o.dataset.compareRowType
                ? (n(), s(), (t = o), (e = !1), (i = null))
                : (this.activeFilterIds.has(o.dataset.compareRowId) ||
                    "compareIgnoreFilter" in o.dataset) &&
                  ((i = o), (e = !0));
          }),
            n(),
            s();
        }
        _onBeforeFiltersModalOpen() {
          this.mobileActiveFiltersTarget.before(this.activeFiltersEl);
        }
        _onFiltersModalClose() {
          this.activeFiltersContainer.append(this.activeFiltersEl);
        }
        _initCell(t) {
          const e = t.querySelector("[data-compare-description]");
          e &&
            (this.descriptionItems.push(new X(e)),
            this.showMoreToggles.push(
              new In({ el: t, context: this.data.context })
            )),
            this._initProductItems(t),
            Fe(t);
        }
        _initProductItems(t) {
          const e = t.querySelectorAll("[data-product-item]");
          e.forEach((e) => {
            B.watch(t),
              this.productItems.push(
                new _i({
                  el: e,
                  id: this.sectionId,
                  disableActionsToggle: !0,
                  lazy: !1,
                })
              );
          }),
            e.length &&
              window.Shopify &&
              Shopify.PaymentButton &&
              Shopify.PaymentButton.init();
        }
      }
      class On {
        constructor(t) {
          (this.$window = $(window)),
            (this.flickity = null),
            (this.productRow = t),
            (this.$productRow = $(this.productRow)),
            (this._mobileSlider = this._mobileSlider.bind(this)),
            zt.onBreakpointChange(this._mobileSlider),
            this._mobileSlider();
        }
        unload() {
          zt.offBreakpointChange(this._mobileSlider), this._destroyFlickity();
        }
        _initFlickity() {
          (this.flickity = new (qt())(this.productRow, {
            cellSelector: ".productgrid--item",
            contain: !0,
            freeScroll: !0,
            percentPosition: !1,
            prevNextButtons: !1,
            pageDots: !1,
            setGallerySize: !1,
          })),
            this._bindSlider();
        }
        _destroyFlickity() {
          this.flickity &&
            (this.$window.off(".product-row"),
            this.$productRow.off(".product-row"),
            this.flickity.destroy(),
            (this.flickity = null));
        }
        _mobileSlider() {
          zt.isGreaterThanBreakpoint("M")
            ? this._destroyFlickity()
            : this.flickity || this._initFlickity();
        }
        _bindSlider() {
          const t = this.$productRow.find(".flickity-slider");
          this.$window.on(
            "resize.product-row",
            tt()(() => {
              this.$productRow.trigger("heightUpdate.product-row");
            })
          ),
            this.flickity.on("cellSelect", () => {
              this.$productRow.trigger("heightUpdate.product-row");
            }),
            this.$productRow.on("heightUpdate.product-row", () => {
              this.flickity && t.height(Math.ceil(this.flickity.maxCellHeight));
            }),
            this.$productRow.trigger("heightUpdate.product-row");
        }
      }
      class Fn {
        constructor(t) {
          (this.section = t),
            (this.productId = t.data.productId),
            (this.limit = t.data.settings.limit),
            (this.recommendedProducts = []),
            (this.productsScroller = null),
            (this.sectionId = t.data.sectionId),
            (this.recommendationContainer = document.querySelector(
              "[data-product-recommendations]"
            )),
            (this.recommendUrl = `${window.Theme.routes.product_recommendations_url}?section_id=${this.sectionId}&limit=${this.limit}&product_id=${this.productId}`),
            (this._loadRecommendations = this._loadRecommendations.bind(this)),
            (this._resizeRowScroller = this._resizeRowScroller.bind(this)),
            this._loadRecommendations();
        }
        _loadRecommendations() {
          kt.load(this.recommendUrl, { view: "" }).then((t) => {
            let { html: e } = t;
            (this.recommendationContainer.innerHTML = e),
              B.watch(this.recommendationContainer);
            const i = this.recommendationContainer.querySelectorAll(
                "[data-product-item]"
              ),
              n = zt.isGreaterThanBreakpoint("L", !0);
            i.length &&
              (i.forEach((t) => {
                this.recommendedProducts.push(
                  new _i({ el: t, id: this.section.id, lazy: n })
                );
              }),
              fi(),
              window.Shopify &&
                Shopify.PaymentButton &&
                Shopify.PaymentButton.init(),
              this.recommendationContainer.addEventListener(
                "rimg:load",
                this._resizeRowScroller
              ),
              (this.productsScroller = new On(
                this.section.el.querySelector("[data-product-row]")
              )));
          });
        }
        _resizeRowScroller() {
          this.productsScroller &&
            this.productsScroller.flickity &&
            this.productsScroller.flickity.resize();
        }
        onSectionUnload() {
          this.productsScroller && this.productsScroller.unload(),
            this.recommendedProducts.forEach((t) => {
              t.unload();
            }),
            this.recommendationContainer.removeEventListener(
              "rimg:load",
              this._resizeRowScroller
            );
        }
      }
      class qn {
        constructor(t) {
          (this.namespace = "pxu"),
            (this.maxRecentlyViewed = 30),
            (this.maxStorageTime = 2592e3),
            (this.version = `${t.data.currency}-${window.Theme.routes.root_url}`),
            (this.storageKey = `${this.namespace}-recentlyViewed-${this.version}`),
            (this.$el = e()(t.el)),
            (this.time = t.data.time),
            (this.flickity = null),
            (this.recentlyViewed = t.data.recently_viewed_info),
            (this.cardSettings = t.data.product_card_settings),
            this.recentlyViewed &&
              this.time &&
              (this.recentlyViewed.timestamp = Math.round(
                new Date().getTime() / 1e3
              )),
            (this.slideImageLoaded = this._onSlideImageLoaded.bind(this));
          let i = [];
          if (this.time) {
            (i = this._getRecentlyViewed()),
              this.recentlyViewed &&
                (this.removeRecentlyViewed(this.recentlyViewed.handle, i),
                i.push(this.recentlyViewed));
            const t = this._setRecentlyViewed(i);
            e()
              .when(...t)
              .done(() => {
                if (i.length) {
                  const t = this._getRecentlyViewedCards(),
                    i = this._getRecentlyViewed();
                  this.$el.find("[data-recently-viewed-container]").append(t),
                    i.forEach((t) => {
                      const i = this.timeSince(t.timestamp);
                      e()(`[data-product-handle=${t.handle}]`).prepend(i);
                    }),
                    B.watch(this.$el[0]),
                    (this.$carousel = this.$el.find(
                      ".product-recently-viewed__content"
                    )),
                    (this.slides = ".product-recently-viewed-card"),
                    this.$carousel.find(this.slides).length > 1 &&
                      this._initSlider();
                } else
                  this.$el
                    .find(".product-recently-viewed--section")
                    .addClass("hide");
              });
          } else
            this.recentlyViewed &&
              (i.push(this.recentlyViewed), this._setRecentlyViewed(i)),
              this.$el
                .find(".product-recently-viewed--section")
                .addClass("hide");
          this.bindEvents();
        }
        bindEvents() {
          this.$el.on("click", "[data-remove-recently-viewed]", (t) => {
            const i = e()(t.currentTarget),
              n = i.closest("[data-product-handle]").data("product-handle"),
              s = this._getRecentlyViewed();
            this.removeRecentlyViewed(n, s),
              this._setRecentlyViewed(s),
              i.parents("[data-recently-viewed-card]").addClass("hide-card"),
              i
                .parents("[data-recently-viewed-card]")
                .nextAll()
                .addClass("move-card"),
              setTimeout(() => {
                let t = i.parents("[data-recently-viewed-card]").index();
                0 !== t && t--,
                  i
                    .parents("[data-recently-viewed-card]")
                    .nextAll()
                    .removeClass("move-card"),
                  i.parents("[data-recently-viewed-card]").length &&
                    this.flickity.remove(
                      i.parents("[data-recently-viewed-card]")
                    ),
                  this.flickity.selectCell(t);
              }, 500);
          }),
            this.$el.on("click", "[data-clear-recently-viewed]", () => {
              this.clearRecentlyViewed();
            });
        }
        timeSince(t) {
          const e = Math.round(new Date().getTime() / 1e3),
            i = e - t,
            { lang: n } = document.documentElement;
          if (i < 60) {
            const t = parseInt(i, 10);
            return 1 === t
              ? `${t} ${this.time.second} ${this.time.ago}`
              : `${t} ${this.time.seconds} ${this.time.ago}`;
          }
          if (i < 3600) {
            const t = parseInt(i / 60, 10);
            return 1 === t
              ? `${t} ${this.time.minute} ${this.time.ago}`
              : `${t} ${this.time.minutes} ${this.time.ago}`;
          }
          if (i <= 86400) {
            const t = parseInt(i / 3600, 10);
            return 1 === t
              ? `${t} ${this.time.hour} ${this.time.ago}`
              : `${t} ${this.time.hours} ${this.time.ago}`;
          }
          const s = new Date(1e3 * t),
            o = new Date(1e3 * e),
            r = s.getDate();
          return `${s.toLocaleDateString(n, { month: "long" })} ${r} ${
            s.getFullYear() === o.getFullYear() ? "" : `, ${s.getFullYear()}`
          }`;
        }
        removeRecentlyViewed(t, e) {
          for (let i = 0; i < e.length; i++)
            e[i].handle === t && e.splice(i, 1);
          this._setRecentlyViewed(e);
          const i = sessionStorage.getItem(this.storageKey)
            ? JSON.parse(sessionStorage.getItem(this.storageKey))
            : {};
          delete i[t],
            sessionStorage.setItem(this.storageKey, JSON.stringify(i)),
            0 === e.length &&
              this.$el
                .find(".product-recently-viewed--section")
                .addClass("hide"),
            this.$carousel &&
              this.$carousel[0].removeEventListener(
                "rimg:load",
                this.slideImageLoaded
              );
        }
        clearRecentlyViewed() {
          localStorage.removeItem(this.storageKey),
            sessionStorage.removeItem(this.storageKey),
            this.$el.find("[data-recently-viewed-card]").remove(),
            this.$el.find(".product-recently-viewed--section").addClass("hide");
        }
        _onSlideImageLoaded() {
          this.flickity.resize();
        }
        _initSlider() {
          (this.flickityOptions = {
            autoPlay: 0,
            accessibility: !0,
            cellAlign: "left",
            cellSelector: this.slides,
            groupCells: !0,
            pageDots: !1,
            contain: !0,
            arrowShape: { x0: 10, x1: 60, y1: 50, x2: 65, y2: 45, x3: 20 },
          }),
            (this.flickity = new (qt())(
              this.$carousel[0],
              this.flickityOptions
            )),
            this.$carousel[0].addEventListener(
              "rimg:load",
              this.slideImageLoaded
            );
        }
        _setRecentlyViewed(t) {
          const i = Math.floor(Date.now() / 1e3) - this.maxStorageTime,
            n = t.filter((t) => t.timestamp > i);
          if (n.length > this.maxRecentlyViewed) {
            const t = n.length - this.maxRecentlyViewed;
            n.splice(0, t);
          }
          try {
            localStorage.setItem(this.storageKey, JSON.stringify(n));
          } catch (t) {
            console.warn(t);
          }
          try {
            const t = n ? n.map((t) => t.handle) : [];
            let i = sessionStorage.getItem(this.storageKey)
              ? JSON.parse(sessionStorage.getItem(this.storageKey))
              : {};
            i.cardSettings &&
              Object.keys(i.cardSettings).forEach((t) => {
                i.cardSettings[t] !== this.cardSettings[t] &&
                  ((i = {}), sessionStorage.removeItem(this.storageKey));
              }),
              (i.cardSettings = this.cardSettings);
            return t.map((t) => {
              if (i[t]) return null;
              const n = `${window.Theme.routes.all_products_collection_url}/products/${t}?view=recently-viewed`;
              return e()
                .get(n)
                .then((e) => {
                  if (e) {
                    i[t] = e;
                    try {
                      sessionStorage.setItem(
                        this.storageKey,
                        JSON.stringify(i)
                      );
                    } catch (t) {
                      console.warn(t);
                    }
                  }
                })
                .catch((t) => console.error("Error:", t));
            });
          } catch (t) {
            return console.warn(t), !1;
          }
        }
        _getRecentlyViewed() {
          try {
            return localStorage.getItem(this.storageKey)
              ? JSON.parse(localStorage.getItem(this.storageKey))
              : [];
          } catch (t) {
            return console.warn(t), [];
          }
        }
        _getRecentlyViewedCards() {
          const t = sessionStorage.getItem(this.storageKey)
              ? JSON.parse(sessionStorage.getItem(this.storageKey))
              : {},
            e = localStorage.getItem(this.storageKey)
              ? JSON.parse(localStorage.getItem(this.storageKey))
              : {},
            i = [];
          for (let n = e.length - 1; n >= 0; n--) {
            const s = e[n].handle;
            new DOMParser()
              .parseFromString(t[s], "text/html")
              .querySelector(".productgrid--item") && i.push(t[s]);
          }
          return i.join("");
        }
      }
      class $n {
        constructor(t) {
          (this.section = t),
            (this.el = t.el),
            (this.searchField = this.el.querySelector("[data-live-search]")),
            (this.productItems = []);
          this.el.querySelectorAll("[data-product-item]").forEach((t) => {
            this.productItems.push(
              new _i({ el: t, id: this.section.id, lazy: !0 })
            );
          }),
            (this.searchForm = new Qi(this.searchField));
        }
        onSectionUnload() {
          this.searchForm.unload(),
            this.productItems.forEach((t) => {
              t.unload();
            });
        }
      }
      class Bn {
        constructor(t) {
          (this.el = t.el),
            (this.mobileUtilityMenuEl = t.el.querySelector(
              "[data-utility-menu-mobile]"
            )),
            (this.mobileNavContentEl = null),
            (this.mobileElChildren = []),
            (this.documentFragmentMenu = document.createDocumentFragment()),
            (this.mobileLayout = t.data.settings.mobile_layout),
            (this._loadMobileNavItems = this._loadMobileNavItems.bind(this)),
            (this.mobileUtilityBarEl = t.el.querySelector(
              "[data-utility-bar-mobile]"
            )),
            (this.mobileUtilityContentEl = null),
            (this.mobileUtilityChildren = []),
            (this.mobileUtilityPlacement = document.querySelector(
              "[data-utility-mobile]"
            )),
            (this.documentFragmentDisclosure =
              document.createDocumentFragment()),
            (this._loadMobileUtilityItems =
              this._loadMobileUtilityItems.bind(this)),
            (this.mobileScrollHeight = document.querySelector(
              "[data-mobile-nav-content]"
            )),
            (this.mobileUtilitySocial = document.querySelector(
              "[data-utility-social-mobile]"
            )),
            (this.countryDisclosureEl = this.el.querySelector(
              "[data-disclosure-country]"
            )),
            (this.localeDisclosureEl = this.el.querySelector(
              "[data-disclosure-locale]"
            )),
            (this.disclosures = []),
            this.mobileUtilityMenuEl &&
              (this._loadMobileNavItems(),
              window.addEventListener(
                "shopify:section:load",
                this._loadMobileNavItems
              )),
            this.mobileUtilityBarEl &&
              (this._loadMobileUtilityItems(),
              window.addEventListener(
                "shopify:section:load",
                this._loadMobileUtilityItems
              )),
            this.countryDisclosureEl &&
              this.disclosures.push(new $i(this.countryDisclosureEl)),
            this.localeDisclosureEl &&
              this.disclosures.push(new $i(this.localeDisclosureEl)),
            this.mobileUtilitySocial &&
              this.mobileScrollHeight.classList.add("utility-social-enabled");
        }
        onSectionUnload() {
          window.removeEventListener(
            "shopify:section:load",
            this._loadMobileNavItems
          ),
            window.removeEventListener(
              "shopify:section:load",
              this._loadMobileUtilityItems
            ),
            this.mobileNavContentEl &&
              this.mobileElChildren.forEach((t) =>
                this.mobileNavContentEl.removeChild(t)
              ),
            this.mobileUtilityContentEl &&
              this.mobileUtilityChildren.forEach((t) =>
                this.mobileUtilityPlacement.removeChild(t)
              ),
            this.disclosures.forEach((t) => t.unload());
        }
        _loadMobileNavItems() {
          if (
            !this.mobileElChildren.some((t) => document.body.contains(t)) &&
            ((this.mobileNavContentEl = document.querySelector(
              "[data-mobile-nav-content]"
            )),
            (this.mobileElChildren = []),
            this.mobileNavContentEl)
          ) {
            const { children: t } = this.mobileUtilityMenuEl;
            for (let e = 0; e < t.length; e++) {
              const i = t[e].cloneNode(!0);
              this.mobileElChildren.push(i),
                this.documentFragmentMenu.appendChild(i);
            }
            "below" === this.mobileLayout
              ? (this.mobileNavContentEl.appendChild(this.documentFragmentMenu),
                this.mobileNavContentEl.classList.add("utility-nav-below"))
              : this.mobileNavContentEl.insertBefore(
                  this.documentFragmentMenu,
                  this.mobileNavContentEl.firstElementChild
                );
          }
        }
        _loadMobileUtilityItems() {
          if (
            !this.mobileUtilityChildren.some((t) =>
              document.body.contains(t)
            ) &&
            ((this.mobileUtilityContentEl = document.querySelector(
              "[data-utility-bar-mobile]"
            )),
            (this.mobileUtilityChildren = []),
            this.mobileUtilityContentEl)
          ) {
            const { children: t } = this.mobileUtilityContentEl;
            for (let e = 0; e < t.length; e++) {
              const i = t[e].cloneNode(!0);
              this.mobileUtilityChildren.push(i),
                this.documentFragmentDisclosure.appendChild(i);
            }
            this.mobileUtilityPlacement.appendChild(
              this.documentFragmentDisclosure
            );
            const e = this.mobileUtilityPlacement.querySelector(
                "[data-disclosure-country]"
              ),
              i = this.mobileUtilityPlacement.querySelector(
                "[data-disclosure-locale]"
              );
            e && this.disclosures.push(new $i(e)),
              i && this.disclosures.push(new $i(i));
          }
        }
      }
      class Nn {
        constructor(t) {
          (this.el = t.el),
            (this.context = t.data.context),
            (this.handleEvents = new xt.Z()),
            (this.accordionTrigger = "[data-accordion-trigger]"),
            (this.mobileAccordionOpen = this.el.querySelector(
              ".mobile-accordion__open--true"
            )),
            (this.Accordion = new Ci(this.el, {
              content: "[data-accordion-content]",
              onStart: (t) => {
                let { el: e, state: i } = t;
                e.parentNode.querySelector(
                  this.accordionTrigger
                ).dataset.accordionTrigger = i;
              },
            })),
            this.mobileAccordionOpen
              ? this.Accordion.openAll({ force: !0 })
              : Ot.max("XS") &&
                (this.Accordion.closeAll({ force: !0 }),
                this._addAccordionClickEvent()),
            Ot.onChange((t) => this.onBreakpointChange(t));
        }
        onSectionUnload() {
          this.Accordion.unload(), this.handleEvents.unregisterAll();
        }
        onSectionBlockSelect(t) {
          this._toggleAccordion(t.el);
        }
        onSectionBlockDeselect(t) {
          this._toggleAccordion(t.el);
        }
        _addAccordionClickEvent() {
          this.el.querySelectorAll(this.accordionTrigger).forEach((t) => {
            this.handleEvents.register(t, "click", (t) => {
              t.preventDefault(),
                this._toggleAccordion(t.currentTarget.parentNode);
            });
          });
        }
        _toggleAccordion(t) {
          Ot.min("S") || this.Accordion.toggle(t);
        }
        onBreakpointChange(t) {
          t.current.min("S") || this.mobileAccordionOpen
            ? (this.Accordion.openAll({ force: !0 }),
              this.handleEvents.unregisterAll())
            : t.previous.min("S") &&
              t.current.max("XS") &&
              (this.Accordion.closeAll({ force: !0 }),
              this._addAccordionClickEvent());
        }
      }
      class Rn {
        constructor(t) {
          let { el: e, sectionId: i } = t;
          (this.el = e),
            (this.contentWrapperEl = e.querySelector("[data-content-wrapper]")),
            (this.contentEl = e.querySelector("[data-content]")),
            (this.events = new xt.Z()),
            (this._resizeObserver = new ResizeObserver(() => {
              let t = !1;
              this.events.register(this.el, "transitionend", () => {
                t = !0;
              }),
                setTimeout(() => {
                  t ||
                    (this.flickity &&
                      "resize" in this.flickity &&
                      this.flickity.resize());
                }, 500);
            })),
            (this.initialLayout = this.contentEl.dataset.layout),
            (this.productItems = []);
          this.el.querySelectorAll("[data-product-item]").forEach((t) => {
            this._resizeObserver.observe(
              t.querySelector(".productitem__container")
            ),
              this.productItems.push(new _i({ el: t, id: i, lazy: !1 }));
          }),
            "slideshow" === this.initialLayout
              ? window.requestAnimationFrame(() => this._initializeFlickity())
              : ((this.onBreakpointChange = () => {
                  zt.isLessThanBreakpoint("XL")
                    ? this._initializeFlickity()
                    : this._destroyFlickity();
                }),
                zt.onBreakpointChange(this.onBreakpointChange),
                zt.isLessThanBreakpoint("XL") &&
                  window.requestAnimationFrame(() =>
                    this._initializeFlickity()
                  ));
        }
        unload() {
          this.productItems.forEach((t) => t.unload()),
            zt.offBreakpointChange(this.onBreakpointChange),
            this.events.unregisterAll(),
            this._destroyFlickity();
        }
        _initializeFlickity() {
          if (this.flickity) return;
          (this.contentEl.dataset.layout = "slideshow"),
            (this.flickity = new (qt())(this.contentEl, {
              autoPlay: 0,
              accessibility: !0,
              cellAlign: "left",
              cellSelector: ".productgrid--item",
              groupCells: !0,
              pageDots: !1,
              contain: !0,
              arrowShape:
                "M65.29 11.99L27.28 50L65.3 87.99L70.25 83.06L37.19 50L70.26 16.94L65.29 11.99Z",
            }));
          const { resize: t } = qt().prototype,
            e = this.contentEl.querySelector(".flickity-viewport"),
            i = this.contentEl.querySelector(".flickity-slider"),
            n = document.createElement("div");
          n.classList.add("flickity-slider--wrapper"),
            e.appendChild(n),
            n.appendChild(i),
            (this.flickity.resize = function () {
              (e.style.height = ""), t.call(this);
            }),
            this.events.register(this.el, "transitionend", () =>
              this.flickity.resize()
            );
        }
        _destroyFlickity() {
          if (!this.flickity) return;
          this.contentEl.dataset.layout = this.initialLayout;
          const t = this.contentEl.querySelector(".flickity-viewport"),
            e = this.contentEl.querySelector(".flickity-slider"),
            i = this.contentEl.querySelector(".flickity-slider--wrapper");
          t.appendChild(e),
            t.removeChild(i),
            this.flickity.destroy(),
            (this.flickity = null);
        }
      }
      class zn {
        constructor(t) {
          const e = t.el.querySelectorAll("[data-featured-collection]");
          (this.collections = Array.prototype.map.call(
            e,
            (e) => new Rn({ el: e, sectionId: t.id })
          )),
            (this.showMoreToggle = new In({
              el: t.el,
              context: t.data.context,
            }));
        }
        onSectionUnload() {
          this.collections.forEach((t) => t.unload()),
            this.showMoreToggle.unload();
        }
      }
      class Hn extends xi {
        constructor(t) {
          if (
            (super(t),
            (this.el = t.el),
            (this.filterInputs = null),
            (this.filterEvents = new xt.Z()),
            (this.updateTimeout = null),
            (this._initFilterEvents = this._initFilterEvents.bind(this)),
            (this._updatePrice = this._updatePrice.bind(this)),
            (this._buildFilterQuery = this._buildFilterQuery.bind(this)),
            (this.filterGroups = t.data.filter_groups),
            (this.filterStyle = t.data.filter_style),
            (this.filtersContentSelector = "[data-productgrid-sidebar]"),
            (this.filtersContent = this.el.querySelector(
              this.filtersContentSelector
            )),
            (this.filterRange = this.el.querySelectorAll(
              "[data-filter-range]"
            )),
            (this.rangeNames = []),
            this.filterRange.forEach((t) => {
              this.rangeNames.push(t.name);
            }),
            (this.allowedQueryParams = ["view", "sort_by", "grid_list"]),
            this.filtersContent)
          ) {
            const t = { groups: this.filterGroups, style: this.filterStyle };
            (this.filterGroupAccordions = new ki(this.filtersContent, t)),
              this._initFilters();
          }
          (this.forms = new Z(this.el)), this._initFilterEvents();
        }
        _initFilterEvents() {
          (this.filterInputs = this.el.querySelectorAll("[data-filter-input]")),
            this.filterInputs.forEach((t) => {
              this.filterEvents.register(t, "click", (t) => {
                t.preventDefault();
                const e = t.currentTarget;
                if (e.dataset.hasOwnProperty("disabled")) return;
                const i = e.getAttribute("data-handle");
                let n = "checked";
                e.getAttribute("data-filter-active")
                  ? ((n = "unchecked"), e.removeAttribute("data-filter-active"))
                  : e.setAttribute("data-filter-active", ""),
                  this.fillAnimations[i] &&
                    this.checkAnimations[i] &&
                    (this.fillAnimations[i].animateTo(n),
                    this.checkAnimations[i].animateTo(n)),
                  this.getFilteredResults(t.currentTarget);
              });
            }),
            this.filterRange.forEach((t) => {
              this.filterEvents.register(t, "keyup", (t) =>
                this._updatePrice(t.currentTarget)
              ),
                this.filterEvents.register(t, "change", (t) =>
                  this._updatePrice(t.currentTarget)
                );
            }),
            (this.filterAccordionButton = this.el.querySelectorAll(
              "[data-filter-group-trigger]"
            )),
            this.filterAccordionButton.forEach((t) => {
              this.filterEvents.register(t, "click", (t) => {
                t.preventDefault();
              });
            });
        }
        _initAnimations() {
          this.filterCheckboxes.forEach((t) => {
            const e = t.dataset.handle,
              i = t.querySelector(".checkmark"),
              n = t.querySelector(".checkmark__check");
            let s = "unchecked";
            t
              .closest("[data-filter-input]")
              .getAttribute("data-filter-active") && (s = "checked");
            const o = Mt({ el: i, state: s }),
              r = Mt({ el: n, state: s });
            (this.fillAnimations[e] = o), (this.checkAnimations[e] = r);
          });
        }
        _initFilters() {
          const t = this.el.querySelector("[data-filter-group-range]");
          this.filterRange.forEach((e) => {
            e.value.length > 0 && t.setAttribute("data-filter-open", "true");
          });
          this.el.querySelectorAll('[data-filter-open="true"]').forEach((t) => {
            this._openActiveGroup(t);
          });
        }
        _openActiveGroup(t) {
          const e = t
              .closest("[data-filter-group]")
              .querySelector("[data-filter-group-trigger]"),
            i = t.closest("[data-accordion-content]");
          this.filterGroupAccordions.openGroup(e, i, !0);
        }
        _buildFilterQuery(t) {
          let e;
          if (t.classList.contains("collection-filters__filter-range-input")) {
            const i = window.location.search.replace("?", ""),
              n = new FormData(t.closest("form")),
              s = new URLSearchParams(n).toString();
            let o = i
              .split("&")
              .filter(
                (t) =>
                  !t.includes(this.rangeNames[0]) &&
                  !t.includes(this.rangeNames[1])
              );
            (o = o.join("&")), (e = o.length > 0 ? `${o}&${s}` : `${s}`);
          } else {
            const i = t.dataset.url;
            let n = null;
            "/" === i[0]
              ? (e = i.split("?")[1])
              : ((n = decodeURIComponent(i)), (e = n.split("?")[1])),
              e || (e = "");
          }
          const i = Object.entries(Shopify.queryParams);
          let n = [];
          i.forEach((t) => {
            !e.includes(t[0]) &&
              this.allowedQueryParams.includes(t[0]) &&
              n.push(t.join("="));
          }),
            (n = n.join("&"));
          let s = "";
          return (s = n && e ? `?${e}&${n}` : e && !n ? `?${e}` : `?${n}`), s;
        }
        _updatePrice(t) {
          null !== this.updateTimeout && clearTimeout(this.updateTimeout),
            (this.updateTimeout = setTimeout(() => {
              this.getFilteredResults(t);
            }, 2e3));
        }
        _changeSorting(t) {
          t.preventDefault();
          const e = t.currentTarget,
            i = new URL(window.location);
          i.searchParams.set("sort_by", e.value),
            (window.location.search = i.search);
        }
        _toggleView(t) {
          const e = t.currentTarget,
            i = new URL(window.location);
          i.searchParams.set("grid_list", e.dataset.collectionView),
            (window.location.search = i.search);
        }
        _setSortByQueryParameters() {
          Shopify.queryParams = {};
          const t = ["view", "sort_by", "grid_list"],
            e = location.search.substr(1).split("&");
          location.search.length &&
            e.forEach((e) => {
              const i = e.split("=");
              i.length > 1 &&
                t.includes(i[0]) &&
                (Shopify.queryParams[decodeURIComponent(i[0])] =
                  decodeURIComponent(i[1]));
            });
        }
        _stringifyShopifyQueries() {
          const t = Object.entries(Shopify.queryParams);
          let e = [];
          return (
            t.forEach((t) => {
              e.push(t.join("="));
            }),
            (e = e.join("&")),
            e
          );
        }
        getFilteredResults(t) {
          const e = this._buildFilterQuery(t);
          window.location.search = e;
        }
        onSectionUnload() {
          super.onSectionUnload(),
            this.filterEvents.unregisterAll(),
            this.forms.unload();
        }
      }
      class Un extends $n {
        constructor(t) {
          if (
            (super(t),
            (this.el = t.el),
            (this.filterInputs = null),
            (this.filterEvents = new xt.Z()),
            (this.updateTimeout = null),
            (this._initFilterEvents = this._initFilterEvents.bind(this)),
            (this._updatePrice = this._updatePrice.bind(this)),
            (this._buildFilterQuery = this._buildFilterQuery.bind(this)),
            (this.filterGroups = t.data.filter_groups),
            (this.filterStyle = "faceted"),
            (this.filtersContentSelector = "[data-productgrid-sidebar]"),
            (this.filtersContent = this.el.querySelector(
              this.filtersContentSelector
            )),
            (this.filtersTrigger = this.el.querySelector(
              "[data-productgrid-trigger-filters]"
            )),
            (this.filterRange = this.el.querySelectorAll(
              "[data-filter-range]"
            )),
            (this.filterCheckboxes = this.el.querySelectorAll(
              ".filter-icon--checkbox"
            )),
            (this.rangeNames = []),
            (this.fillAnimations = {}),
            (this.checkAnimations = {}),
            (this.modal = new ee()),
            this.filterEvents.register(this.filtersTrigger, "click", (t) => {
              this._showFiltersModal(t);
            }),
            this._initAnimations(),
            this.filterRange.forEach((t) => {
              this.rangeNames.push(t.name);
            }),
            this.filtersContent)
          ) {
            const t = { groups: this.filterGroups, style: this.filterStyle };
            (this.filterGroupAccordions = new ki(this.filtersContent, t)),
              this._initFilters();
          }
          (this.forms = new Z(this.el)), this._initFilterEvents();
        }
        _initFilterEvents() {
          (this.filterInputs = this.el.querySelectorAll("[data-filter-input]")),
            this.filterInputs.forEach((t) => {
              this.filterEvents.register(t, "click", (t) => {
                t.preventDefault();
                const e = t.currentTarget;
                if (e.dataset.hasOwnProperty("disabled")) return;
                const i = e.getAttribute("data-handle");
                let n = "checked";
                e.getAttribute("data-filter-active")
                  ? ((n = "unchecked"), e.removeAttribute("data-filter-active"))
                  : e.setAttribute("data-filter-active", ""),
                  this.fillAnimations[i] &&
                    this.checkAnimations[i] &&
                    (this.fillAnimations[i].animateTo(n),
                    this.checkAnimations[i].animateTo(n)),
                  this.getFilteredResults(t.currentTarget);
              });
            }),
            this.filterRange.forEach((t) => {
              this.filterEvents.register(t, "keyup", (t) =>
                this._updatePrice(t.currentTarget)
              ),
                this.filterEvents.register(t, "change", (t) =>
                  this._updatePrice(t.currentTarget)
                );
            }),
            (this.filterAccordionButton = this.el.querySelectorAll(
              "[data-filter-group-trigger]"
            )),
            this.filterAccordionButton.forEach((t) => {
              this.filterEvents.register(t, "click", (t) => {
                t.preventDefault();
              });
            });
        }
        _initAnimations() {
          this.filterCheckboxes.forEach((t) => {
            const e = t.dataset.handle,
              i = t.querySelector(".checkmark"),
              n = t.querySelector(".checkmark__check");
            let s = "unchecked";
            t
              .closest("[data-filter-input]")
              .getAttribute("data-filter-active") && (s = "checked");
            const o = Mt({ el: i, state: s }),
              r = Mt({ el: n, state: s });
            (this.fillAnimations[e] = o), (this.checkAnimations[e] = r);
          });
        }
        _initFilters() {
          const t = this.el.querySelector("[data-filter-group-range]");
          this.filterRange.forEach((e) => {
            e.value.length > 0 && t.setAttribute("data-filter-open", "true");
          });
          this.el.querySelectorAll('[data-filter-open="true"]').forEach((t) => {
            this._openActiveGroup(t);
          });
        }
        _showFiltersModal(t) {
          t.preventDefault(),
            (this.focusItem = t.currentTarget),
            this.modal.open(this.filtersContentSelector, "productgrid-filters");
        }
        _openActiveGroup(t) {
          const e = t
              .closest("[data-filter-group]")
              .querySelector("[data-filter-group-trigger]"),
            i = t.closest("[data-accordion-content]");
          this.filterGroupAccordions.openGroup(e, i, !0);
        }
        _buildFilterQuery(t) {
          let e;
          if (t.classList.contains("collection-filters__filter-range-input")) {
            const i = window.location.search.replace("?", ""),
              n = new FormData(t.closest("form")),
              s = new URLSearchParams(n).toString();
            let o = i
              .split("&")
              .filter(
                (t) =>
                  !t.includes(this.rangeNames[0]) &&
                  !t.includes(this.rangeNames[1])
              );
            (o = o.join("&")), (e = o.length > 0 ? `${o}&${s}` : `${s}`);
          } else {
            const i = t.dataset.url;
            (e = decodeURIComponent(i).split("?")[1]), e || (e = "");
          }
          let i = "";
          return e && (i = `?${e}`), i;
        }
        _updatePrice(t) {
          null !== this.updateTimeout && clearTimeout(this.updateTimeout),
            (this.updateTimeout = setTimeout(() => {
              this.getFilteredResults(t);
            }, 2e3));
        }
        getFilteredResults(t) {
          const e = this._buildFilterQuery(t);
          window.location.search = e;
        }
        onSectionUnload() {
          super.onSectionUnload(),
            this.filterEvents.unregisterAll(),
            this.forms.unload();
        }
      }
      class jn {
        constructor(t) {
          (this.$el = e()(t.el)),
            (this.$window = e()(window)),
            (this.flickity = null),
            (this.$blogPosts = this.$el.find("[data-blog-posts]")),
            (this._mobileSlider = this._mobileSlider.bind(this)),
            zt.onBreakpointChange(this._mobileSlider),
            this._mobileSlider();
        }
        onSectionUnload() {
          zt.offBreakpointChange(this._mobileSlider), this._destroyFlickity();
        }
        _initFlickity() {
          (this.flickity = new (qt())(this.$blogPosts[0], {
            cellSelector: ".article--excerpt-wrapper",
            contain: !0,
            freeScroll: !0,
            percentPosition: !1,
            prevNextButtons: !1,
            pageDots: !1,
            setGallerySize: !1,
          })),
            this._bindSlider();
        }
        _destroyFlickity() {
          this.flickity &&
            (this.$window.off(".blog-posts"),
            this.$blogPosts.off(".blog-posts"),
            this.flickity.destroy(),
            (this.flickity = null));
        }
        _mobileSlider() {
          zt.isGreaterThanBreakpoint("M")
            ? this._destroyFlickity()
            : this.flickity || this._initFlickity();
        }
        _bindSlider() {
          const t = this.$blogPosts.find(".flickity-slider");
          this.$window.on(
            "resize.blog-posts",
            tt()(() => {
              this.$blogPosts.trigger("heightUpdate.blog-posts");
            })
          ),
            this.flickity.on("cellSelect", () => {
              this.$blogPosts.trigger("heightUpdate.blog-posts");
            }),
            this.$blogPosts.on("heightUpdate.blog-posts", () => {
              this.flickity && t.height(Math.ceil(this.flickity.maxCellHeight));
            }),
            this.$blogPosts.trigger("heightUpdate.blog-posts");
        }
      }
      const Wn = (t) => {
          const i = e()(t),
            n = i.find(".promo-block--content-wrapper"),
            s = window
              .getComputedStyle(i[0], null)
              .getPropertyValue("padding-top")
              .replace("px", "");
          i.innerHeight() - 2 * s < n.innerHeight() &&
            (i.css({ height: `${n.innerHeight() + 2 * s}px` }),
            n.css({ transform: "none", top: "auto" }));
        },
        Vn = (t) => {
          const i = e()(t),
            n = i.find(".promo-block--content-wrapper");
          i.css({ height: "" }), n.css({ transform: "", top: "" });
        };
      class Gn {
        constructor(t) {
          (this.$el = e()(t.el)),
            (this.content = "[data-promo-block-content]"),
            (this.expandedClass = "promo-block--expanded"),
            (this.compressBlocks = t.data.compress_blocks),
            (this.layoutHandler = this.onBreakpointChange.bind(this)),
            zt.onBreakpointChange(this.layoutHandler),
            (this._blockInteraction = this._blockInteraction.bind(this)),
            this.$el.on(
              "click.promo-block",
              this.content,
              this._blockInteraction
            ),
            !this.compressBlocks &&
              zt.isLessThanBreakpoint("S") &&
              this.$el.find(this.content).each((t, e) => {
                Wn(e);
              }),
            this.compressBlocks ||
              e()(window).on("resize", () => {
                this.$el.find(this.content).each((t, e) => {
                  zt.isLessThanBreakpoint("S") ? Wn(e) : Vn(e);
                });
              });
        }
        onBreakpointChange() {
          zt.isLessThanBreakpoint("S")
            ? this.compressBlocks ||
              this.$el.find(this.content).each((t, e) => {
                Wn(e);
              })
            : (this.$el.find(`.${this.expandedClass}`).each((t, e) => {
                this._collapse(e);
              }),
              this.$el.find(this.content).each((t, e) => {
                Vn(e);
              }));
        }
        onSectionUnload() {
          this.$el.off(".promo-block"),
            zt.offBreakpointChange(this.layoutHandler);
        }
        onSectionBlockSelect(t) {
          zt.isLessThanBreakpoint("S") &&
            this._expand(t.el.querySelector(this.content));
        }
        onSectionBlockDeselect(t) {
          zt.isLessThanBreakpoint("S") &&
            this._collapse(t.el.querySelector(this.content));
        }
        _blockInteraction(t) {
          const e = t.currentTarget;
          !e.getAttribute("data-clicked") &&
            zt.isLessThanBreakpoint("S") &&
            this.compressBlocks &&
            (t.preventDefault(),
            e.setAttribute("data-clicked", "clicked"),
            this._expand(e));
        }
        _expand(t) {
          if (!this.compressBlocks) return;
          const i = e()(t);
          i.addClass("animating animating-in").one("trend", () => {
            i
              .removeClass("animating animating-in")
              .addClass(this.expandedClass)
              .off("trend"),
              Wn(i);
          });
        }
        _collapse(t) {
          if (!this.compressBlocks) return;
          const i = e()(t);
          i.addClass("animating animating-out").one("trend", () => {
            i
              .removeClass(`animating animating-out ${this.expandedClass}`)
              .off("trend"),
              t.removeAttribute("data-clicked"),
              Vn(i);
          });
        }
      }
      class Xn {
        constructor(t) {
          const e = t.el.querySelector("[data-featured-collection]");
          this.featuredCollection = new Rn({ el: e, sectionId: t.id });
        }
        onSectionUnload() {
          this.featuredCollection.unload();
        }
      }
      class Zn {
        constructor(t) {
          (this.$el = e()(t.el)),
            (this.context = t.data.context),
            (this.accordionTrigger = "[data-accordion-trigger]"),
            (this.seeMoreTrigger = "[data-menulist-toggle]"),
            (this.Accordion = new Ci(this.$el[0], {
              content: ".menulist-menu--initial[data-accordion-content]",
              onStart: (t) => {
                let { el: e, state: i } = t;
                e.parentNode.querySelector(
                  this.accordionTrigger
                ).dataset.accordionTrigger = i;
              },
            })),
            (this.seeMore = new Ci(this.$el[0], {
              content: ".menulist-menu--show-more[data-accordion-content]",
              onStart: (t) => {
                let { el: e, state: i } = t;
                e.parentNode.querySelector(this.seeMoreTrigger).innerHTML =
                  "open" === i ? this.context.see_less : this.context.see_more;
              },
            })),
            Ot.max("XS") && this.Accordion.closeAll({ force: !0 }),
            this.seeMore.closeAll({ force: !0 }),
            Ot.onChange((t) => this.onBreakpointChange(t)),
            this._bindEvents();
        }
        _bindEvents() {
          this.$el.on("click.menu-list", this.accordionTrigger, (t) => {
            t.preventDefault(),
              this._toggleAccordion(t.currentTarget.parentNode);
          }),
            this.$el.on("click.menu-list", this.seeMoreTrigger, (t) => {
              t.preventDefault(),
                this.seeMore.toggle(t.currentTarget.parentNode);
            });
        }
        onSectionUnload() {
          this.$el.off(".menu-list"),
            this.Accordion.unload(),
            this.seeMore.unload();
        }
        onSectionBlockSelect(t) {
          this._toggleAccordion(t.el);
        }
        onSectionBlockDeselect(t) {
          this._toggleAccordion(t.el);
        }
        _toggleAccordion(t) {
          Ot.min("S") || this.Accordion.toggle(t);
        }
        onBreakpointChange(t) {
          t.current.min("S")
            ? this.Accordion.openAll({ force: !0 })
            : t.previous.min("S") &&
              t.current.max("XS") &&
              this.Accordion.closeAll({ force: !0 });
        }
      }
      var Qn = i(637),
        Yn = i.n(Qn);
      class Kn {
        constructor(t) {
          (this.$el = e()(t.el)), (this.settings = t.data), this._load();
        }
        _load() {
          (this.$window = e()(window)),
            (this.flickity = null),
            (this.$content = this.$el.find("[data-twitter-content]")),
            (this.$wrapper = this.$el.find("[data-twitter-wrapper]")),
            (this.$tweets = this.$el.find("[data-tweet-content]")),
            (this.$template = e()(this.settings.template));
          const {
              onboarding: t,
              username: i,
              retweets: n,
              images: s,
            } = this.settings,
            o = this.settings.locale || "en";
          (this._mobileSlider = this._mobileSlider.bind(this)),
            zt.onBreakpointChange(this._mobileSlider),
            this._mobileSlider(),
            !t &&
              i &&
              Yn().fetch({
                profile: { screenName: i },
                maxTweets: 3,
                enableLinks: !0,
                showUser: !0,
                showTime: !0,
                dataOnly: !1,
                useEmoji: !0,
                showImages: s,
                showRetweet: n,
                lang: o,
                customCallback: (t) => this._renderTweets(t),
                showInteraction: !1,
              });
        }
        onSectionUnload() {
          this.$window.off(".twitter"),
            this.$content.off(".twitter"),
            zt.offBreakpointChange(this._mobileSlider),
            this._destroyFlickity();
        }
        _initFlickity() {
          (this.flickity = new (qt())(this.$content[0], {
            cellSelector: "[data-tweet-content]",
            contain: !0,
            freeScroll: !0,
            percentPosition: !1,
            prevNextButtons: !1,
            pageDots: !1,
            setGallerySize: !1,
          })),
            this._bindSlider();
        }
        _destroyFlickity() {
          this.flickity && (this.flickity.destroy(), (this.flickity = null));
        }
        _mobileSlider() {
          zt.isGreaterThanBreakpoint("S")
            ? this._destroyFlickity()
            : this.flickity || this._initFlickity();
        }
        _bindSlider() {
          const t = this.$content.find(".flickity-slider");
          this.$window.on(
            "resize.twitter",
            tt()(() => {
              this.$content.trigger("heightUpdate.twitter");
            })
          ),
            this.flickity.on("cellSelect", () => {
              this.$content.trigger("heightUpdate.twitter");
            }),
            this.$content.on("heightUpdate.twitter", () => {
              this.flickity && t.height(Math.ceil(this.flickity.maxCellHeight));
            }),
            this.$content.trigger("heightUpdate.twitter");
        }
        _extractAuthor(t) {
          const i = e()(t),
            n = i.find("a").attr("href"),
            s = i.find('[data-scribe="element:name"]').text(),
            o = i.find('[data-scribe="element:screen_name"]').text();
          return { $avatar: i.find("img"), link: n, name: s, screenName: o };
        }
        _extractMeta(t) {
          const i = e()(t);
          return { link: i.find("a").attr("href"), postedAt: i.text() };
        }
        _extractWrapperClass() {
          const t = this.$wrapper.attr("class").match(/tweet--count-\d+$/);
          return t ? t[0] : "";
        }
        _renderTweets(t) {
          const i = t.length;
          if (!t || !i) return;
          const n = [],
            s = `tweet--count-${i}`;
          t.forEach((t) => {
            const i = e()(t),
              s = this.$template.clone(),
              o = this._extractAuthor(i[0]),
              r = this._extractMeta(i[2]),
              a = i[1];
            s.find(".tweet--header").attr("href", o.link),
              s.find(".tweet--header-image").html(o.$avatar),
              s.find(".tweet--header-name").text(o.name),
              s.find(".tweet--header-screenname").text(o.screenName),
              s
                .find(".tweet--content")
                .append(i[3] ? i[3] : null)
                .append(a),
              s
                .find(".tweet--footer")
                .attr("href", r.link)
                .find(".tweet--footer--posted")
                .text(r.postedAt),
              n.push(s);
          }),
            this.$wrapper.css("min-height", this.$wrapper.height()),
            this.$tweets
              .fadeOut()
              .promise()
              .then(() => {
                this._destroyFlickity(),
                  this.$tweets.remove(),
                  this.$content.append(n),
                  this.$wrapper
                    .removeClass(this._extractWrapperClass())
                    .addClass(s)
                    .css("min-height", ""),
                  (this.$tweets = this.$el.find("[data-tweet-content]")),
                  this._mobileSlider();
              });
        }
      }
      class Jn {
        constructor(t) {
          this.el = t.el;
          const e = this.el.querySelectorAll("[data-collection-image]");
          Ot.onChange((t) => {
            if (t.previous.max("L") && "S" === t.current.value)
              for (let t = 0; t < e.length; t++) B.instance.update(e[t]);
          });
        }
      }
      function ts(t, e) {
        for (var i = 0; i < e.length; i++) {
          var n = e[i];
          (n.enumerable = n.enumerable || !1),
            (n.configurable = !0),
            "value" in n && (n.writable = !0),
            Object.defineProperty(t, n.key, n);
        }
      }
      const es = (function () {
        function t(e) {
          !(
            /*!
             * @pixelunion/pxs-countdown-timer v3.0.0
             * (c) 2023 Pixel Union
             */
            (function (t, e) {
              if (!(t instanceof e))
                throw new TypeError("Cannot call a class as a function");
            })(this, t)
          ),
            (this.container = e),
            (this.previousSiblingSection =
              this.container.previousElementSibling),
            (this.nextSiblingSection = this.container.nextElementSibling),
            (this.countDownTimerEl = this.container.querySelector(
              "[data-countdown-timer]"
            )),
            (this.countDownEl =
              this.countDownTimerEl.querySelector("[data-countdown]")),
            (this.daysEl = this.countDownTimerEl.querySelector("[data-days]")),
            (this.hoursEl =
              this.countDownTimerEl.querySelector("[data-hours]")),
            (this.minutesEl =
              this.countDownTimerEl.querySelector("[data-minutes]")),
            (this.secondsEl =
              this.countDownTimerEl.querySelector("[data-seconds]")),
            (this.dateTimeEl =
              this.countDownTimerEl.querySelector("[data-time]")),
            (this.targetDate = Date.parse(this.dateTimeEl.dateTime)),
            (this.daysInMs = 864e5),
            (this.hoursInMs = this.daysInMs / 24),
            (this.minutesInMs = this.hoursInMs / 60),
            (this.secondsInMs = this.minutesInMs / 60),
            (this.timeoutId = null),
            (this.isLoading = !0),
            this.startTimer();
        }
        var e, i, n;
        return (
          (e = t),
          (i = [
            {
              key: "updateLoadingState",
              value: function () {
                this.countDownTimerEl.classList.remove(
                  "countdown-timer--loading"
                );
              },
            },
            {
              key: "startTimer",
              value: function () {
                var t = this,
                  e = 1e3,
                  i = Date.now() + e;
                if (this.targetDate <= Date.now())
                  return (
                    this.updateLoadingState(),
                    void this.handleCountDownComplete()
                  );
                this.timeoutId = setTimeout(function n() {
                  var s = Date.now(),
                    o = t.targetDate - s;
                  if (o <= 0)
                    return t.stopTimer(), void t.handleCountDownComplete();
                  var r = t.convertTime(o),
                    a = s - i;
                  (i += e),
                    t.isLoading && t.updateLoadingState(),
                    t.updateDom(r),
                    (t.timeoutId = setTimeout(n, Math.max(0, e - a)));
                }, e);
              },
            },
            {
              key: "stopTimer",
              value: function () {
                clearTimeout(this.timeoutId);
              },
            },
            {
              key: "convertTime",
              value: function (t) {
                var e = parseInt(t / this.daysInMs, 10);
                t -= e * this.daysInMs;
                var i = parseInt(t / this.hoursInMs, 10);
                t -= i * this.hoursInMs;
                var n = parseInt(t / this.minutesInMs, 10);
                return (
                  (t -= n * this.minutesInMs),
                  {
                    days: e,
                    hours: i,
                    minutes: n,
                    seconds: parseInt(t / this.secondsInMs, 10),
                  }
                );
              },
            },
            {
              key: "updateDom",
              value: function (t) {
                var e = t.days,
                  i = t.hours,
                  n = t.minutes,
                  s = t.seconds;
                (this.daysEl.textContent = e),
                  (this.hoursEl.textContent = i),
                  (this.minutesEl.textContent = n),
                  (this.secondsEl.textContent = s);
              },
            },
            {
              key: "handleCountDownComplete",
              value: function () {
                this.updateDom({ days: 0, hours: 0, minutes: 0, seconds: 0 }),
                  this.countDownTimerEl.classList.add(
                    "countdown-timer--complete"
                  );
              },
            },
          ]) && ts(e.prototype, i),
          n && ts(e, n),
          Object.defineProperty(e, "prototype", { writable: !1 }),
          t
        );
      })();
      class is {
        constructor(t) {
          (this.el = t.el),
            (this.product = this.el.querySelector("[data-product-item]")),
            new es(this.el),
            Fe(this.el),
            this.product &&
              (this.productItems = new _i({ el: this.product, id: t.id }));
        }
        onSectionUnload() {
          this.product && this.productItems.unload();
        }
      }
      class ns extends An {
        constructor(t) {
          super(t, { useHistory: !1 });
        }
      }
      class ss {
        constructor(t) {
          (this.$el = e()(t.el)),
            (this.rte = []),
            this.$el.find("[data-rte]").each((t, i) => {
              this.rte.push(new X(e()(i)));
            });
        }
        onSectionUnload() {
          this.rte.forEach((t) => {
            t.unload();
          });
        }
      }
      class os {
        constructor(t) {
          (this.el = t.el),
            (this.settings = t.data.settings),
            (this.search = null),
            (this.scripts = document.querySelector("[data-scripts]")),
            (this.searchField = this.el.querySelector("[data-live-search]")),
            (this.forms = new Z(this.el)),
            this.settings.live_search.enable
              ? s()(this.scripts.dataset.shopifyApiUrl, () => {
                  this.search = new Yi(
                    { el: this.searchField, header: this.el },
                    { ...this.settings.live_search, use_dimmer: !1 }
                  );
                })
              : (this.search = new Qi(this.searchField));
        }
        onSectionUnload() {
          this.search.unload(), this.forms.unload();
        }
      }
      function rs(t, e) {
        for (var i = 0; i < e.length; i++) {
          var n = e[i];
          (n.enumerable = n.enumerable || !1),
            (n.configurable = !0),
            "value" in n && (n.writable = !0),
            Object.defineProperty(t, n.key, n);
        }
      }
      var as =
        "undefined" != typeof globalThis
          ? globalThis
          : "undefined" != typeof window
          ? window
          : void 0 !== i.g
          ? i.g
          : "undefined" != typeof self
          ? self
          : {};
      function ls(t, e) {
        return t((e = { exports: {} }), e.exports), e.exports;
      }
      var cs = ls(function (t) {
          var e, i;
          (e = "undefined" != typeof window ? window : as),
            (i = function () {
              function t() {}
              var e = t.prototype;
              return (
                (e.on = function (t, e) {
                  if (t && e) {
                    var i = (this._events = this._events || {}),
                      n = (i[t] = i[t] || []);
                    return -1 == n.indexOf(e) && n.push(e), this;
                  }
                }),
                (e.once = function (t, e) {
                  if (t && e) {
                    this.on(t, e);
                    var i = (this._onceEvents = this._onceEvents || {});
                    return ((i[t] = i[t] || {})[e] = !0), this;
                  }
                }),
                (e.off = function (t, e) {
                  var i = this._events && this._events[t];
                  if (i && i.length) {
                    var n = i.indexOf(e);
                    return -1 != n && i.splice(n, 1), this;
                  }
                }),
                (e.emitEvent = function (t, e) {
                  var i = this._events && this._events[t];
                  if (i && i.length) {
                    (i = i.slice(0)), (e = e || []);
                    for (
                      var n = this._onceEvents && this._onceEvents[t], s = 0;
                      s < i.length;
                      s++
                    ) {
                      var o = i[s];
                      n && n[o] && (this.off(t, o), delete n[o]),
                        o.apply(this, e);
                    }
                    return this;
                  }
                }),
                (e.allOff = function () {
                  delete this._events, delete this._onceEvents;
                }),
                t
              );
            }),
            t.exports ? (t.exports = i()) : (e.EvEmitter = i());
        }),
        hs = ls(function (t) {
          /*!
           * getSize v2.0.3
           * measure size of elements
           * MIT license
           */
          !(function (e, i) {
            t.exports ? (t.exports = i()) : (e.getSize = i());
          })(window, function () {
            function t(t) {
              var e = parseFloat(t);
              return -1 == t.indexOf("%") && !isNaN(e) && e;
            }
            var e =
                "undefined" == typeof console
                  ? function () {}
                  : function (t) {
                      console.error(t);
                    },
              i = [
                "paddingLeft",
                "paddingRight",
                "paddingTop",
                "paddingBottom",
                "marginLeft",
                "marginRight",
                "marginTop",
                "marginBottom",
                "borderLeftWidth",
                "borderRightWidth",
                "borderTopWidth",
                "borderBottomWidth",
              ],
              n = i.length;
            function s(t) {
              var i = getComputedStyle(t);
              return (
                i ||
                  e(
                    "Style returned " +
                      i +
                      ". Are you running this code in a hidden iframe on Firefox? See https://bit.ly/getsizebug1"
                  ),
                i
              );
            }
            var o,
              r = !1;
            function a(e) {
              if (
                ((function () {
                  if (!r) {
                    r = !0;
                    var e = document.createElement("div");
                    (e.style.width = "200px"),
                      (e.style.padding = "1px 2px 3px 4px"),
                      (e.style.borderStyle = "solid"),
                      (e.style.borderWidth = "1px 2px 3px 4px"),
                      (e.style.boxSizing = "border-box");
                    var i = document.body || document.documentElement;
                    i.appendChild(e);
                    var n = s(e);
                    (o = 200 == Math.round(t(n.width))),
                      (a.isBoxSizeOuter = o),
                      i.removeChild(e);
                  }
                })(),
                "string" == typeof e && (e = document.querySelector(e)),
                e && "object" == typeof e && e.nodeType)
              ) {
                var l = s(e);
                if ("none" == l.display)
                  return (function () {
                    for (
                      var t = {
                          width: 0,
                          height: 0,
                          innerWidth: 0,
                          innerHeight: 0,
                          outerWidth: 0,
                          outerHeight: 0,
                        },
                        e = 0;
                      e < n;
                      e++
                    )
                      t[i[e]] = 0;
                    return t;
                  })();
                var c = {};
                (c.width = e.offsetWidth), (c.height = e.offsetHeight);
                for (
                  var h = (c.isBorderBox = "border-box" == l.boxSizing), d = 0;
                  d < n;
                  d++
                ) {
                  var u = i[d],
                    p = l[u],
                    f = parseFloat(p);
                  c[u] = isNaN(f) ? 0 : f;
                }
                var m = c.paddingLeft + c.paddingRight,
                  g = c.paddingTop + c.paddingBottom,
                  v = c.marginLeft + c.marginRight,
                  y = c.marginTop + c.marginBottom,
                  b = c.borderLeftWidth + c.borderRightWidth,
                  w = c.borderTopWidth + c.borderBottomWidth,
                  _ = h && o,
                  S = t(l.width);
                !1 !== S && (c.width = S + (_ ? 0 : m + b));
                var C = t(l.height);
                return (
                  !1 !== C && (c.height = C + (_ ? 0 : g + w)),
                  (c.innerWidth = c.width - (m + b)),
                  (c.innerHeight = c.height - (g + w)),
                  (c.outerWidth = c.width + v),
                  (c.outerHeight = c.height + y),
                  c
                );
              }
            }
            return a;
          });
        }),
        ds = ls(function (t) {
          !(function (e, i) {
            t.exports ? (t.exports = i()) : (e.matchesSelector = i());
          })(window, function () {
            var t = (function () {
              var t = window.Element.prototype;
              if (t.matches) return "matches";
              if (t.matchesSelector) return "matchesSelector";
              for (
                var e = ["webkit", "moz", "ms", "o"], i = 0;
                i < e.length;
                i++
              ) {
                var n = e[i] + "MatchesSelector";
                if (t[n]) return n;
              }
            })();
            return function (e, i) {
              return e[t](i);
            };
          });
        }),
        us = ls(function (t) {
          !(function (e, i) {
            t.exports
              ? (t.exports = i(e, ds))
              : (e.fizzyUIUtils = i(e, e.matchesSelector));
          })(window, function (t, e) {
            var i = {
                extend: function (t, e) {
                  for (var i in e) t[i] = e[i];
                  return t;
                },
                modulo: function (t, e) {
                  return ((t % e) + e) % e;
                },
              },
              n = Array.prototype.slice;
            (i.makeArray = function (t) {
              return Array.isArray(t)
                ? t
                : null == t
                ? []
                : "object" == typeof t && "number" == typeof t.length
                ? n.call(t)
                : [t];
            }),
              (i.removeFrom = function (t, e) {
                var i = t.indexOf(e);
                -1 != i && t.splice(i, 1);
              }),
              (i.getParent = function (t, i) {
                for (; t.parentNode && t != document.body; )
                  if (((t = t.parentNode), e(t, i))) return t;
              }),
              (i.getQueryElement = function (t) {
                return "string" == typeof t ? document.querySelector(t) : t;
              }),
              (i.handleEvent = function (t) {
                var e = "on" + t.type;
                this[e] && this[e](t);
              }),
              (i.filterFindElements = function (t, n) {
                t = i.makeArray(t);
                var s = [];
                return (
                  t.forEach(function (t) {
                    if (t instanceof HTMLElement)
                      if (n) {
                        e(t, n) && s.push(t);
                        for (
                          var i = t.querySelectorAll(n), o = 0;
                          o < i.length;
                          o++
                        )
                          s.push(i[o]);
                      } else s.push(t);
                  }),
                  s
                );
              }),
              (i.debounceMethod = function (t, e, i) {
                i = i || 100;
                var n = t.prototype[e],
                  s = e + "Timeout";
                t.prototype[e] = function () {
                  var t = this[s];
                  clearTimeout(t);
                  var e = arguments,
                    o = this;
                  this[s] = setTimeout(function () {
                    n.apply(o, e), delete o[s];
                  }, i);
                };
              }),
              (i.docReady = function (t) {
                var e = document.readyState;
                "complete" == e || "interactive" == e
                  ? setTimeout(t)
                  : document.addEventListener("DOMContentLoaded", t);
              }),
              (i.toDashed = function (t) {
                return t
                  .replace(/(.)([A-Z])/g, function (t, e, i) {
                    return e + "-" + i;
                  })
                  .toLowerCase();
              });
            var s = t.console;
            return (
              (i.htmlInit = function (e, n) {
                i.docReady(function () {
                  var o = i.toDashed(n),
                    r = "data-" + o,
                    a = document.querySelectorAll("[" + r + "]"),
                    l = document.querySelectorAll(".js-" + o),
                    c = i.makeArray(a).concat(i.makeArray(l)),
                    h = r + "-options",
                    d = t.jQuery;
                  c.forEach(function (t) {
                    var i,
                      o = t.getAttribute(r) || t.getAttribute(h);
                    try {
                      i = o && JSON.parse(o);
                    } catch (e) {
                      return void (
                        s &&
                        s.error(
                          "Error parsing " + r + " on " + t.className + ": " + e
                        )
                      );
                    }
                    var a = new e(t, i);
                    d && d.data(t, n, a);
                  });
                });
              }),
              i
            );
          });
        }),
        ps = ls(function (t) {
          !(function (e, i) {
            t.exports
              ? (t.exports = i(e, hs))
              : ((e.Flickity = e.Flickity || {}),
                (e.Flickity.Cell = i(e, e.getSize)));
          })(window, function (t, e) {
            function i(t, e) {
              (this.element = t), (this.parent = e), this.create();
            }
            var n = i.prototype;
            return (
              (n.create = function () {
                (this.element.style.position = "absolute"),
                  this.element.setAttribute("aria-hidden", "true"),
                  (this.x = 0),
                  (this.shift = 0);
              }),
              (n.destroy = function () {
                this.unselect(), (this.element.style.position = "");
                var t = this.parent.originSide;
                this.element.style[t] = "";
              }),
              (n.getSize = function () {
                this.size = e(this.element);
              }),
              (n.setPosition = function (t) {
                (this.x = t), this.updateTarget(), this.renderPosition(t);
              }),
              (n.updateTarget = n.setDefaultTarget =
                function () {
                  var t =
                    "left" == this.parent.originSide
                      ? "marginLeft"
                      : "marginRight";
                  this.target =
                    this.x +
                    this.size[t] +
                    this.size.width * this.parent.cellAlign;
                }),
              (n.renderPosition = function (t) {
                var e = this.parent.originSide;
                this.element.style[e] = this.parent.getPositionValue(t);
              }),
              (n.select = function () {
                this.element.classList.add("is-selected"),
                  this.element.removeAttribute("aria-hidden");
              }),
              (n.unselect = function () {
                this.element.classList.remove("is-selected"),
                  this.element.setAttribute("aria-hidden", "true");
              }),
              (n.wrapShift = function (t) {
                (this.shift = t),
                  this.renderPosition(this.x + this.parent.slideableWidth * t);
              }),
              (n.remove = function () {
                this.element.parentNode.removeChild(this.element);
              }),
              i
            );
          });
        }),
        fs = ls(function (t) {
          !(function (e, i) {
            t.exports
              ? (t.exports = i())
              : ((e.Flickity = e.Flickity || {}), (e.Flickity.Slide = i()));
          })(window, function () {
            function t(t) {
              (this.parent = t),
                (this.isOriginLeft = "left" == t.originSide),
                (this.cells = []),
                (this.outerWidth = 0),
                (this.height = 0);
            }
            var e = t.prototype;
            return (
              (e.addCell = function (t) {
                if (
                  (this.cells.push(t),
                  (this.outerWidth += t.size.outerWidth),
                  (this.height = Math.max(t.size.outerHeight, this.height)),
                  1 == this.cells.length)
                ) {
                  this.x = t.x;
                  var e = this.isOriginLeft ? "marginLeft" : "marginRight";
                  this.firstMargin = t.size[e];
                }
              }),
              (e.updateTarget = function () {
                var t = this.isOriginLeft ? "marginRight" : "marginLeft",
                  e = this.getLastCell(),
                  i = e ? e.size[t] : 0,
                  n = this.outerWidth - (this.firstMargin + i);
                this.target =
                  this.x + this.firstMargin + n * this.parent.cellAlign;
              }),
              (e.getLastCell = function () {
                return this.cells[this.cells.length - 1];
              }),
              (e.select = function () {
                this.cells.forEach(function (t) {
                  t.select();
                });
              }),
              (e.unselect = function () {
                this.cells.forEach(function (t) {
                  t.unselect();
                });
              }),
              (e.getCellElements = function () {
                return this.cells.map(function (t) {
                  return t.element;
                });
              }),
              t
            );
          });
        }),
        ms = ls(function (t) {
          !(function (e, i) {
            t.exports
              ? (t.exports = i(e, us))
              : ((e.Flickity = e.Flickity || {}),
                (e.Flickity.animatePrototype = i(e, e.fizzyUIUtils)));
          })(window, function (t, e) {
            var i = {
              startAnimation: function () {
                this.isAnimating ||
                  ((this.isAnimating = !0),
                  (this.restingFrames = 0),
                  this.animate());
              },
              animate: function () {
                this.applyDragForce(), this.applySelectedAttraction();
                var t = this.x;
                if (
                  (this.integratePhysics(),
                  this.positionSlider(),
                  this.settle(t),
                  this.isAnimating)
                ) {
                  var e = this;
                  requestAnimationFrame(function () {
                    e.animate();
                  });
                }
              },
              positionSlider: function () {
                var t = this.x;
                this.options.wrapAround &&
                  this.cells.length > 1 &&
                  ((t = e.modulo(t, this.slideableWidth)),
                  (t -= this.slideableWidth),
                  this.shiftWrapCells(t)),
                  this.setTranslateX(t, this.isAnimating),
                  this.dispatchScrollEvent();
              },
              setTranslateX: function (t, e) {
                (t += this.cursorPosition),
                  (t = this.options.rightToLeft ? -t : t);
                var i = this.getPositionValue(t);
                this.slider.style.transform = e
                  ? "translate3d(" + i + ",0,0)"
                  : "translateX(" + i + ")";
              },
              dispatchScrollEvent: function () {
                var t = this.slides[0];
                if (t) {
                  var e = -this.x - t.target,
                    i = e / this.slidesWidth;
                  this.dispatchEvent("scroll", null, [i, e]);
                }
              },
              positionSliderAtSelected: function () {
                this.cells.length &&
                  ((this.x = -this.selectedSlide.target),
                  (this.velocity = 0),
                  this.positionSlider());
              },
              getPositionValue: function (t) {
                return this.options.percentPosition
                  ? 0.01 * Math.round((t / this.size.innerWidth) * 1e4) + "%"
                  : Math.round(t) + "px";
              },
              settle: function (t) {
                this.isPointerDown ||
                  Math.round(100 * this.x) != Math.round(100 * t) ||
                  this.restingFrames++,
                  this.restingFrames > 2 &&
                    ((this.isAnimating = !1),
                    delete this.isFreeScrolling,
                    this.positionSlider(),
                    this.dispatchEvent("settle", null, [this.selectedIndex]));
              },
              shiftWrapCells: function (t) {
                var e = this.cursorPosition + t;
                this._shiftCells(this.beforeShiftCells, e, -1);
                var i =
                  this.size.innerWidth -
                  (t + this.slideableWidth + this.cursorPosition);
                this._shiftCells(this.afterShiftCells, i, 1);
              },
              _shiftCells: function (t, e, i) {
                for (var n = 0; n < t.length; n++) {
                  var s = t[n],
                    o = e > 0 ? i : 0;
                  s.wrapShift(o), (e -= s.size.outerWidth);
                }
              },
              _unshiftCells: function (t) {
                if (t && t.length)
                  for (var e = 0; e < t.length; e++) t[e].wrapShift(0);
              },
              integratePhysics: function () {
                (this.x += this.velocity),
                  (this.velocity *= this.getFrictionFactor());
              },
              applyForce: function (t) {
                this.velocity += t;
              },
              getFrictionFactor: function () {
                return (
                  1 -
                  this.options[
                    this.isFreeScrolling ? "freeScrollFriction" : "friction"
                  ]
                );
              },
              getRestingPosition: function () {
                return this.x + this.velocity / (1 - this.getFrictionFactor());
              },
              applyDragForce: function () {
                if (this.isDraggable && this.isPointerDown) {
                  var t = this.dragX - this.x - this.velocity;
                  this.applyForce(t);
                }
              },
              applySelectedAttraction: function () {
                if (
                  !(this.isDraggable && this.isPointerDown) &&
                  !this.isFreeScrolling &&
                  this.slides.length
                ) {
                  var t =
                    (-1 * this.selectedSlide.target - this.x) *
                    this.options.selectedAttraction;
                  this.applyForce(t);
                }
              },
            };
            return i;
          });
        }),
        gs = ls(function (t) {
          !(function (e, i) {
            if (t.exports) t.exports = i(e, cs, hs, us, ps, fs, ms);
            else {
              var n = e.Flickity;
              e.Flickity = i(
                e,
                e.EvEmitter,
                e.getSize,
                e.fizzyUIUtils,
                n.Cell,
                n.Slide,
                n.animatePrototype
              );
            }
          })(window, function (t, e, i, n, s, o, r) {
            var a = t.jQuery,
              l = t.getComputedStyle,
              c = t.console;
            function h(t, e) {
              for (t = n.makeArray(t); t.length; ) e.appendChild(t.shift());
            }
            var d = 0,
              u = {};
            function p(t, e) {
              var i = n.getQueryElement(t);
              if (i) {
                if (((this.element = i), this.element.flickityGUID)) {
                  var s = u[this.element.flickityGUID];
                  return s.option(e), s;
                }
                a && (this.$element = a(this.element)),
                  (this.options = n.extend({}, this.constructor.defaults)),
                  this.option(e),
                  this._create();
              } else c && c.error("Bad element for Flickity: " + (i || t));
            }
            (p.defaults = {
              accessibility: !0,
              cellAlign: "center",
              freeScrollFriction: 0.075,
              friction: 0.28,
              namespaceJQueryEvents: !0,
              percentPosition: !0,
              resize: !0,
              selectedAttraction: 0.025,
              setGallerySize: !0,
            }),
              (p.createMethods = []);
            var f = p.prototype;
            n.extend(f, e.prototype),
              (f._create = function () {
                var e = (this.guid = ++d);
                for (var i in ((this.element.flickityGUID = e),
                (u[e] = this),
                (this.selectedIndex = 0),
                (this.restingFrames = 0),
                (this.x = 0),
                (this.velocity = 0),
                (this.originSide = this.options.rightToLeft ? "right" : "left"),
                (this.viewport = document.createElement("div")),
                (this.viewport.className = "flickity-viewport"),
                this._createSlider(),
                (this.options.resize || this.options.watchCSS) &&
                  t.addEventListener("resize", this),
                this.options.on)) {
                  var n = this.options.on[i];
                  this.on(i, n);
                }
                p.createMethods.forEach(function (t) {
                  this[t]();
                }, this),
                  this.options.watchCSS ? this.watchCSS() : this.activate();
              }),
              (f.option = function (t) {
                n.extend(this.options, t);
              }),
              (f.activate = function () {
                this.isActive ||
                  ((this.isActive = !0),
                  this.element.classList.add("flickity-enabled"),
                  this.options.rightToLeft &&
                    this.element.classList.add("flickity-rtl"),
                  this.getSize(),
                  h(
                    this._filterFindCellElements(this.element.children),
                    this.slider
                  ),
                  this.viewport.appendChild(this.slider),
                  this.element.appendChild(this.viewport),
                  this.reloadCells(),
                  this.options.accessibility &&
                    ((this.element.tabIndex = 0),
                    this.element.addEventListener("keydown", this)),
                  this.emitEvent("activate"),
                  this.selectInitialIndex(),
                  (this.isInitActivated = !0),
                  this.dispatchEvent("ready"));
              }),
              (f._createSlider = function () {
                var t = document.createElement("div");
                (t.className = "flickity-slider"),
                  (t.style[this.originSide] = 0),
                  (this.slider = t);
              }),
              (f._filterFindCellElements = function (t) {
                return n.filterFindElements(t, this.options.cellSelector);
              }),
              (f.reloadCells = function () {
                (this.cells = this._makeCells(this.slider.children)),
                  this.positionCells(),
                  this._getWrapShiftCells(),
                  this.setGallerySize();
              }),
              (f._makeCells = function (t) {
                return this._filterFindCellElements(t).map(function (t) {
                  return new s(t, this);
                }, this);
              }),
              (f.getLastCell = function () {
                return this.cells[this.cells.length - 1];
              }),
              (f.getLastSlide = function () {
                return this.slides[this.slides.length - 1];
              }),
              (f.positionCells = function () {
                this._sizeCells(this.cells), this._positionCells(0);
              }),
              (f._positionCells = function (t) {
                (t = t || 0),
                  (this.maxCellHeight = (t && this.maxCellHeight) || 0);
                var e = 0;
                if (t > 0) {
                  var i = this.cells[t - 1];
                  e = i.x + i.size.outerWidth;
                }
                for (var n = this.cells.length, s = t; s < n; s++) {
                  var o = this.cells[s];
                  o.setPosition(e),
                    (e += o.size.outerWidth),
                    (this.maxCellHeight = Math.max(
                      o.size.outerHeight,
                      this.maxCellHeight
                    ));
                }
                (this.slideableWidth = e),
                  this.updateSlides(),
                  this._containSlides(),
                  (this.slidesWidth = n
                    ? this.getLastSlide().target - this.slides[0].target
                    : 0);
              }),
              (f._sizeCells = function (t) {
                t.forEach(function (t) {
                  t.getSize();
                });
              }),
              (f.updateSlides = function () {
                if (((this.slides = []), this.cells.length)) {
                  var t = new o(this);
                  this.slides.push(t);
                  var e =
                      "left" == this.originSide ? "marginRight" : "marginLeft",
                    i = this._getCanCellFit();
                  this.cells.forEach(function (n, s) {
                    if (t.cells.length) {
                      var r =
                        t.outerWidth -
                        t.firstMargin +
                        (n.size.outerWidth - n.size[e]);
                      i.call(this, s, r) ||
                        (t.updateTarget(),
                        (t = new o(this)),
                        this.slides.push(t)),
                        t.addCell(n);
                    } else t.addCell(n);
                  }, this),
                    t.updateTarget(),
                    this.updateSelectedSlide();
                }
              }),
              (f._getCanCellFit = function () {
                var t = this.options.groupCells;
                if (!t)
                  return function () {
                    return !1;
                  };
                if ("number" == typeof t) {
                  var e = parseInt(t, 10);
                  return function (t) {
                    return t % e != 0;
                  };
                }
                var i = "string" == typeof t && t.match(/^(\d+)%$/),
                  n = i ? parseInt(i[1], 10) / 100 : 1;
                return function (t, e) {
                  return e <= (this.size.innerWidth + 1) * n;
                };
              }),
              (f._init = f.reposition =
                function () {
                  this.positionCells(), this.positionSliderAtSelected();
                }),
              (f.getSize = function () {
                (this.size = i(this.element)),
                  this.setCellAlign(),
                  (this.cursorPosition = this.size.innerWidth * this.cellAlign);
              });
            var m = {
              center: { left: 0.5, right: 0.5 },
              left: { left: 0, right: 1 },
              right: { right: 0, left: 1 },
            };
            return (
              (f.setCellAlign = function () {
                var t = m[this.options.cellAlign];
                this.cellAlign = t
                  ? t[this.originSide]
                  : this.options.cellAlign;
              }),
              (f.setGallerySize = function () {
                if (this.options.setGallerySize) {
                  var t =
                    this.options.adaptiveHeight && this.selectedSlide
                      ? this.selectedSlide.height
                      : this.maxCellHeight;
                  this.viewport.style.height = t + "px";
                }
              }),
              (f._getWrapShiftCells = function () {
                if (this.options.wrapAround) {
                  this._unshiftCells(this.beforeShiftCells),
                    this._unshiftCells(this.afterShiftCells);
                  var t = this.cursorPosition,
                    e = this.cells.length - 1;
                  (this.beforeShiftCells = this._getGapCells(t, e, -1)),
                    (t = this.size.innerWidth - this.cursorPosition),
                    (this.afterShiftCells = this._getGapCells(t, 0, 1));
                }
              }),
              (f._getGapCells = function (t, e, i) {
                for (var n = []; t > 0; ) {
                  var s = this.cells[e];
                  if (!s) break;
                  n.push(s), (e += i), (t -= s.size.outerWidth);
                }
                return n;
              }),
              (f._containSlides = function () {
                if (
                  this.options.contain &&
                  !this.options.wrapAround &&
                  this.cells.length
                ) {
                  var t = this.options.rightToLeft,
                    e = t ? "marginRight" : "marginLeft",
                    i = t ? "marginLeft" : "marginRight",
                    n = this.slideableWidth - this.getLastCell().size[i],
                    s = n < this.size.innerWidth,
                    o = this.cursorPosition + this.cells[0].size[e],
                    r = n - this.size.innerWidth * (1 - this.cellAlign);
                  this.slides.forEach(function (t) {
                    s
                      ? (t.target = n * this.cellAlign)
                      : ((t.target = Math.max(t.target, o)),
                        (t.target = Math.min(t.target, r)));
                  }, this);
                }
              }),
              (f.dispatchEvent = function (t, e, i) {
                var n = e ? [e].concat(i) : i;
                if ((this.emitEvent(t, n), a && this.$element)) {
                  var s = (t += this.options.namespaceJQueryEvents
                    ? ".flickity"
                    : "");
                  if (e) {
                    var o = a.Event(e);
                    (o.type = t), (s = o);
                  }
                  this.$element.trigger(s, i);
                }
              }),
              (f.select = function (t, e, i) {
                if (
                  this.isActive &&
                  ((t = parseInt(t, 10)),
                  this._wrapSelect(t),
                  (this.options.wrapAround || e) &&
                    (t = n.modulo(t, this.slides.length)),
                  this.slides[t])
                ) {
                  var s = this.selectedIndex;
                  (this.selectedIndex = t),
                    this.updateSelectedSlide(),
                    i ? this.positionSliderAtSelected() : this.startAnimation(),
                    this.options.adaptiveHeight && this.setGallerySize(),
                    this.dispatchEvent("select", null, [t]),
                    t != s && this.dispatchEvent("change", null, [t]),
                    this.dispatchEvent("cellSelect");
                }
              }),
              (f._wrapSelect = function (t) {
                var e = this.slides.length;
                if (!(this.options.wrapAround && e > 1)) return t;
                var i = n.modulo(t, e),
                  s = Math.abs(i - this.selectedIndex),
                  o = Math.abs(i + e - this.selectedIndex),
                  r = Math.abs(i - e - this.selectedIndex);
                !this.isDragSelect && o < s
                  ? (t += e)
                  : !this.isDragSelect && r < s && (t -= e),
                  t < 0
                    ? (this.x -= this.slideableWidth)
                    : t >= e && (this.x += this.slideableWidth);
              }),
              (f.previous = function (t, e) {
                this.select(this.selectedIndex - 1, t, e);
              }),
              (f.next = function (t, e) {
                this.select(this.selectedIndex + 1, t, e);
              }),
              (f.updateSelectedSlide = function () {
                var t = this.slides[this.selectedIndex];
                t &&
                  (this.unselectSelectedSlide(),
                  (this.selectedSlide = t),
                  t.select(),
                  (this.selectedCells = t.cells),
                  (this.selectedElements = t.getCellElements()),
                  (this.selectedCell = t.cells[0]),
                  (this.selectedElement = this.selectedElements[0]));
              }),
              (f.unselectSelectedSlide = function () {
                this.selectedSlide && this.selectedSlide.unselect();
              }),
              (f.selectInitialIndex = function () {
                var t = this.options.initialIndex;
                if (this.isInitActivated)
                  this.select(this.selectedIndex, !1, !0);
                else {
                  if (t && "string" == typeof t)
                    if (this.queryCell(t))
                      return void this.selectCell(t, !1, !0);
                  var e = 0;
                  t && this.slides[t] && (e = t), this.select(e, !1, !0);
                }
              }),
              (f.selectCell = function (t, e, i) {
                var n = this.queryCell(t);
                if (n) {
                  var s = this.getCellSlideIndex(n);
                  this.select(s, e, i);
                }
              }),
              (f.getCellSlideIndex = function (t) {
                for (var e = 0; e < this.slides.length; e++) {
                  if (-1 != this.slides[e].cells.indexOf(t)) return e;
                }
              }),
              (f.getCell = function (t) {
                for (var e = 0; e < this.cells.length; e++) {
                  var i = this.cells[e];
                  if (i.element == t) return i;
                }
              }),
              (f.getCells = function (t) {
                t = n.makeArray(t);
                var e = [];
                return (
                  t.forEach(function (t) {
                    var i = this.getCell(t);
                    i && e.push(i);
                  }, this),
                  e
                );
              }),
              (f.getCellElements = function () {
                return this.cells.map(function (t) {
                  return t.element;
                });
              }),
              (f.getParentCell = function (t) {
                var e = this.getCell(t);
                return (
                  e ||
                  ((t = n.getParent(t, ".flickity-slider > *")),
                  this.getCell(t))
                );
              }),
              (f.getAdjacentCellElements = function (t, e) {
                if (!t) return this.selectedSlide.getCellElements();
                e = void 0 === e ? this.selectedIndex : e;
                var i = this.slides.length;
                if (1 + 2 * t >= i) return this.getCellElements();
                for (var s = [], o = e - t; o <= e + t; o++) {
                  var r = this.options.wrapAround ? n.modulo(o, i) : o,
                    a = this.slides[r];
                  a && (s = s.concat(a.getCellElements()));
                }
                return s;
              }),
              (f.queryCell = function (t) {
                if ("number" == typeof t) return this.cells[t];
                if ("string" == typeof t) {
                  if (t.match(/^[#\.]?[\d\/]/)) return;
                  t = this.element.querySelector(t);
                }
                return this.getCell(t);
              }),
              (f.uiChange = function () {
                this.emitEvent("uiChange");
              }),
              (f.childUIPointerDown = function (t) {
                "touchstart" != t.type && t.preventDefault(), this.focus();
              }),
              (f.onresize = function () {
                this.watchCSS(), this.resize();
              }),
              n.debounceMethod(p, "onresize", 150),
              (f.resize = function () {
                if (this.isActive) {
                  this.getSize(),
                    this.options.wrapAround &&
                      (this.x = n.modulo(this.x, this.slideableWidth)),
                    this.positionCells(),
                    this._getWrapShiftCells(),
                    this.setGallerySize(),
                    this.emitEvent("resize");
                  var t = this.selectedElements && this.selectedElements[0];
                  this.selectCell(t, !1, !0);
                }
              }),
              (f.watchCSS = function () {
                this.options.watchCSS &&
                  (-1 != l(this.element, ":after").content.indexOf("flickity")
                    ? this.activate()
                    : this.deactivate());
              }),
              (f.onkeydown = function (t) {
                var e =
                  document.activeElement &&
                  document.activeElement != this.element;
                if (this.options.accessibility && !e) {
                  var i = p.keyboardHandlers[t.keyCode];
                  i && i.call(this);
                }
              }),
              (p.keyboardHandlers = {
                37: function () {
                  var t = this.options.rightToLeft ? "next" : "previous";
                  this.uiChange(), this[t]();
                },
                39: function () {
                  var t = this.options.rightToLeft ? "previous" : "next";
                  this.uiChange(), this[t]();
                },
              }),
              (f.focus = function () {
                var e = t.pageYOffset;
                this.element.focus({ preventScroll: !0 }),
                  t.pageYOffset != e && t.scrollTo(t.pageXOffset, e);
              }),
              (f.deactivate = function () {
                this.isActive &&
                  (this.element.classList.remove("flickity-enabled"),
                  this.element.classList.remove("flickity-rtl"),
                  this.unselectSelectedSlide(),
                  this.cells.forEach(function (t) {
                    t.destroy();
                  }),
                  this.element.removeChild(this.viewport),
                  h(this.slider.children, this.element),
                  this.options.accessibility &&
                    (this.element.removeAttribute("tabIndex"),
                    this.element.removeEventListener("keydown", this)),
                  (this.isActive = !1),
                  this.emitEvent("deactivate"));
              }),
              (f.destroy = function () {
                this.deactivate(),
                  t.removeEventListener("resize", this),
                  this.allOff(),
                  this.emitEvent("destroy"),
                  a && this.$element && a.removeData(this.element, "flickity"),
                  delete this.element.flickityGUID,
                  delete u[this.guid];
              }),
              n.extend(f, r),
              (p.data = function (t) {
                var e = (t = n.getQueryElement(t)) && t.flickityGUID;
                return e && u[e];
              }),
              n.htmlInit(p, "flickity"),
              a && a.bridget && a.bridget("flickity", p),
              (p.setJQuery = function (t) {
                a = t;
              }),
              (p.Cell = s),
              (p.Slide = o),
              p
            );
          });
        }),
        vs = ls(function (t) {
          /*!
           * Unipointer v2.3.0
           * base class for doing one thing with pointer event
           * MIT license
           */
          !(function (e, i) {
            t.exports
              ? (t.exports = i(e, cs))
              : (e.Unipointer = i(e, e.EvEmitter));
          })(window, function (t, e) {
            function i() {}
            var n = (i.prototype = Object.create(e.prototype));
            (n.bindStartEvent = function (t) {
              this._bindStartEvent(t, !0);
            }),
              (n.unbindStartEvent = function (t) {
                this._bindStartEvent(t, !1);
              }),
              (n._bindStartEvent = function (e, i) {
                var n = (i = void 0 === i || i)
                    ? "addEventListener"
                    : "removeEventListener",
                  s = "mousedown";
                t.PointerEvent
                  ? (s = "pointerdown")
                  : "ontouchstart" in t && (s = "touchstart"),
                  e[n](s, this);
              }),
              (n.handleEvent = function (t) {
                var e = "on" + t.type;
                this[e] && this[e](t);
              }),
              (n.getTouch = function (t) {
                for (var e = 0; e < t.length; e++) {
                  var i = t[e];
                  if (i.identifier == this.pointerIdentifier) return i;
                }
              }),
              (n.onmousedown = function (t) {
                var e = t.button;
                (e && 0 !== e && 1 !== e) || this._pointerDown(t, t);
              }),
              (n.ontouchstart = function (t) {
                this._pointerDown(t, t.changedTouches[0]);
              }),
              (n.onpointerdown = function (t) {
                this._pointerDown(t, t);
              }),
              (n._pointerDown = function (t, e) {
                t.button ||
                  this.isPointerDown ||
                  ((this.isPointerDown = !0),
                  (this.pointerIdentifier =
                    void 0 !== e.pointerId ? e.pointerId : e.identifier),
                  this.pointerDown(t, e));
              }),
              (n.pointerDown = function (t, e) {
                this._bindPostStartEvents(t),
                  this.emitEvent("pointerDown", [t, e]);
              });
            var s = {
              mousedown: ["mousemove", "mouseup"],
              touchstart: ["touchmove", "touchend", "touchcancel"],
              pointerdown: ["pointermove", "pointerup", "pointercancel"],
            };
            return (
              (n._bindPostStartEvents = function (e) {
                if (e) {
                  var i = s[e.type];
                  i.forEach(function (e) {
                    t.addEventListener(e, this);
                  }, this),
                    (this._boundPointerEvents = i);
                }
              }),
              (n._unbindPostStartEvents = function () {
                this._boundPointerEvents &&
                  (this._boundPointerEvents.forEach(function (e) {
                    t.removeEventListener(e, this);
                  }, this),
                  delete this._boundPointerEvents);
              }),
              (n.onmousemove = function (t) {
                this._pointerMove(t, t);
              }),
              (n.onpointermove = function (t) {
                t.pointerId == this.pointerIdentifier &&
                  this._pointerMove(t, t);
              }),
              (n.ontouchmove = function (t) {
                var e = this.getTouch(t.changedTouches);
                e && this._pointerMove(t, e);
              }),
              (n._pointerMove = function (t, e) {
                this.pointerMove(t, e);
              }),
              (n.pointerMove = function (t, e) {
                this.emitEvent("pointerMove", [t, e]);
              }),
              (n.onmouseup = function (t) {
                this._pointerUp(t, t);
              }),
              (n.onpointerup = function (t) {
                t.pointerId == this.pointerIdentifier && this._pointerUp(t, t);
              }),
              (n.ontouchend = function (t) {
                var e = this.getTouch(t.changedTouches);
                e && this._pointerUp(t, e);
              }),
              (n._pointerUp = function (t, e) {
                this._pointerDone(), this.pointerUp(t, e);
              }),
              (n.pointerUp = function (t, e) {
                this.emitEvent("pointerUp", [t, e]);
              }),
              (n._pointerDone = function () {
                this._pointerReset(),
                  this._unbindPostStartEvents(),
                  this.pointerDone();
              }),
              (n._pointerReset = function () {
                (this.isPointerDown = !1), delete this.pointerIdentifier;
              }),
              (n.pointerDone = function () {}),
              (n.onpointercancel = function (t) {
                t.pointerId == this.pointerIdentifier &&
                  this._pointerCancel(t, t);
              }),
              (n.ontouchcancel = function (t) {
                var e = this.getTouch(t.changedTouches);
                e && this._pointerCancel(t, e);
              }),
              (n._pointerCancel = function (t, e) {
                this._pointerDone(), this.pointerCancel(t, e);
              }),
              (n.pointerCancel = function (t, e) {
                this.emitEvent("pointerCancel", [t, e]);
              }),
              (i.getPointerPoint = function (t) {
                return { x: t.pageX, y: t.pageY };
              }),
              i
            );
          });
        }),
        ys = ls(function (t) {
          /*!
           * Unidragger v2.3.0
           * Draggable base class
           * MIT license
           */
          !(function (e, i) {
            t.exports
              ? (t.exports = i(e, vs))
              : (e.Unidragger = i(e, e.Unipointer));
          })(window, function (t, e) {
            function i() {}
            var n = (i.prototype = Object.create(e.prototype));
            (n.bindHandles = function () {
              this._bindHandles(!0);
            }),
              (n.unbindHandles = function () {
                this._bindHandles(!1);
              }),
              (n._bindHandles = function (e) {
                for (
                  var i = (e = void 0 === e || e)
                      ? "addEventListener"
                      : "removeEventListener",
                    n = e ? this._touchActionValue : "",
                    s = 0;
                  s < this.handles.length;
                  s++
                ) {
                  var o = this.handles[s];
                  this._bindStartEvent(o, e),
                    o[i]("click", this),
                    t.PointerEvent && (o.style.touchAction = n);
                }
              }),
              (n._touchActionValue = "none"),
              (n.pointerDown = function (t, e) {
                this.okayPointerDown(t) &&
                  ((this.pointerDownPointer = e),
                  t.preventDefault(),
                  this.pointerDownBlur(),
                  this._bindPostStartEvents(t),
                  this.emitEvent("pointerDown", [t, e]));
              });
            var s = { TEXTAREA: !0, INPUT: !0, SELECT: !0, OPTION: !0 },
              o = {
                radio: !0,
                checkbox: !0,
                button: !0,
                submit: !0,
                image: !0,
                file: !0,
              };
            return (
              (n.okayPointerDown = function (t) {
                var e = s[t.target.nodeName],
                  i = o[t.target.type],
                  n = !e || i;
                return n || this._pointerReset(), n;
              }),
              (n.pointerDownBlur = function () {
                var t = document.activeElement;
                t && t.blur && t != document.body && t.blur();
              }),
              (n.pointerMove = function (t, e) {
                var i = this._dragPointerMove(t, e);
                this.emitEvent("pointerMove", [t, e, i]),
                  this._dragMove(t, e, i);
              }),
              (n._dragPointerMove = function (t, e) {
                var i = {
                  x: e.pageX - this.pointerDownPointer.pageX,
                  y: e.pageY - this.pointerDownPointer.pageY,
                };
                return (
                  !this.isDragging &&
                    this.hasDragStarted(i) &&
                    this._dragStart(t, e),
                  i
                );
              }),
              (n.hasDragStarted = function (t) {
                return Math.abs(t.x) > 3 || Math.abs(t.y) > 3;
              }),
              (n.pointerUp = function (t, e) {
                this.emitEvent("pointerUp", [t, e]), this._dragPointerUp(t, e);
              }),
              (n._dragPointerUp = function (t, e) {
                this.isDragging ? this._dragEnd(t, e) : this._staticClick(t, e);
              }),
              (n._dragStart = function (t, e) {
                (this.isDragging = !0),
                  (this.isPreventingClicks = !0),
                  this.dragStart(t, e);
              }),
              (n.dragStart = function (t, e) {
                this.emitEvent("dragStart", [t, e]);
              }),
              (n._dragMove = function (t, e, i) {
                this.isDragging && this.dragMove(t, e, i);
              }),
              (n.dragMove = function (t, e, i) {
                t.preventDefault(), this.emitEvent("dragMove", [t, e, i]);
              }),
              (n._dragEnd = function (t, e) {
                (this.isDragging = !1),
                  setTimeout(
                    function () {
                      delete this.isPreventingClicks;
                    }.bind(this)
                  ),
                  this.dragEnd(t, e);
              }),
              (n.dragEnd = function (t, e) {
                this.emitEvent("dragEnd", [t, e]);
              }),
              (n.onclick = function (t) {
                this.isPreventingClicks && t.preventDefault();
              }),
              (n._staticClick = function (t, e) {
                (this.isIgnoringMouseUp && "mouseup" == t.type) ||
                  (this.staticClick(t, e),
                  "mouseup" != t.type &&
                    ((this.isIgnoringMouseUp = !0),
                    setTimeout(
                      function () {
                        delete this.isIgnoringMouseUp;
                      }.bind(this),
                      400
                    )));
              }),
              (n.staticClick = function (t, e) {
                this.emitEvent("staticClick", [t, e]);
              }),
              (i.getPointerPoint = e.getPointerPoint),
              i
            );
          });
        }),
        bs =
          (ls(function (t) {
            !(function (e, i) {
              t.exports
                ? (t.exports = i(e, gs, ys, us))
                : (e.Flickity = i(e, e.Flickity, e.Unidragger, e.fizzyUIUtils));
            })(window, function (t, e, i, n) {
              n.extend(e.defaults, { draggable: ">1", dragThreshold: 3 }),
                e.createMethods.push("_createDrag");
              var s = e.prototype;
              n.extend(s, i.prototype), (s._touchActionValue = "pan-y");
              var o = "createTouch" in document,
                r = !1;
              (s._createDrag = function () {
                this.on("activate", this.onActivateDrag),
                  this.on("uiChange", this._uiChangeDrag),
                  this.on("deactivate", this.onDeactivateDrag),
                  this.on("cellChange", this.updateDraggable),
                  o &&
                    !r &&
                    (t.addEventListener("touchmove", function () {}), (r = !0));
              }),
                (s.onActivateDrag = function () {
                  (this.handles = [this.viewport]),
                    this.bindHandles(),
                    this.updateDraggable();
                }),
                (s.onDeactivateDrag = function () {
                  this.unbindHandles(),
                    this.element.classList.remove("is-draggable");
                }),
                (s.updateDraggable = function () {
                  ">1" == this.options.draggable
                    ? (this.isDraggable = this.slides.length > 1)
                    : (this.isDraggable = this.options.draggable),
                    this.isDraggable
                      ? this.element.classList.add("is-draggable")
                      : this.element.classList.remove("is-draggable");
                }),
                (s.bindDrag = function () {
                  (this.options.draggable = !0), this.updateDraggable();
                }),
                (s.unbindDrag = function () {
                  (this.options.draggable = !1), this.updateDraggable();
                }),
                (s._uiChangeDrag = function () {
                  delete this.isFreeScrolling;
                }),
                (s.pointerDown = function (e, i) {
                  this.isDraggable
                    ? this.okayPointerDown(e) &&
                      (this._pointerDownPreventDefault(e),
                      this.pointerDownFocus(e),
                      document.activeElement != this.element &&
                        this.pointerDownBlur(),
                      (this.dragX = this.x),
                      this.viewport.classList.add("is-pointer-down"),
                      (this.pointerDownScroll = l()),
                      t.addEventListener("scroll", this),
                      this._pointerDownDefault(e, i))
                    : this._pointerDownDefault(e, i);
                }),
                (s._pointerDownDefault = function (t, e) {
                  (this.pointerDownPointer = {
                    pageX: e.pageX,
                    pageY: e.pageY,
                  }),
                    this._bindPostStartEvents(t),
                    this.dispatchEvent("pointerDown", t, [e]);
                });
              var a = { INPUT: !0, TEXTAREA: !0, SELECT: !0 };
              function l() {
                return { x: t.pageXOffset, y: t.pageYOffset };
              }
              return (
                (s.pointerDownFocus = function (t) {
                  a[t.target.nodeName] || this.focus();
                }),
                (s._pointerDownPreventDefault = function (t) {
                  var e = "touchstart" == t.type,
                    i = "touch" == t.pointerType,
                    n = a[t.target.nodeName];
                  e || i || n || t.preventDefault();
                }),
                (s.hasDragStarted = function (t) {
                  return Math.abs(t.x) > this.options.dragThreshold;
                }),
                (s.pointerUp = function (t, e) {
                  delete this.isTouchScrolling,
                    this.viewport.classList.remove("is-pointer-down"),
                    this.dispatchEvent("pointerUp", t, [e]),
                    this._dragPointerUp(t, e);
                }),
                (s.pointerDone = function () {
                  t.removeEventListener("scroll", this),
                    delete this.pointerDownScroll;
                }),
                (s.dragStart = function (e, i) {
                  this.isDraggable &&
                    ((this.dragStartPosition = this.x),
                    this.startAnimation(),
                    t.removeEventListener("scroll", this),
                    this.dispatchEvent("dragStart", e, [i]));
                }),
                (s.pointerMove = function (t, e) {
                  var i = this._dragPointerMove(t, e);
                  this.dispatchEvent("pointerMove", t, [e, i]),
                    this._dragMove(t, e, i);
                }),
                (s.dragMove = function (t, e, i) {
                  if (this.isDraggable) {
                    t.preventDefault(), (this.previousDragX = this.dragX);
                    var n = this.options.rightToLeft ? -1 : 1;
                    this.options.wrapAround &&
                      (i.x = i.x % this.slideableWidth);
                    var s = this.dragStartPosition + i.x * n;
                    if (!this.options.wrapAround && this.slides.length) {
                      var o = Math.max(
                        -this.slides[0].target,
                        this.dragStartPosition
                      );
                      s = s > o ? 0.5 * (s + o) : s;
                      var r = Math.min(
                        -this.getLastSlide().target,
                        this.dragStartPosition
                      );
                      s = s < r ? 0.5 * (s + r) : s;
                    }
                    (this.dragX = s),
                      (this.dragMoveTime = new Date()),
                      this.dispatchEvent("dragMove", t, [e, i]);
                  }
                }),
                (s.dragEnd = function (t, e) {
                  if (this.isDraggable) {
                    this.options.freeScroll && (this.isFreeScrolling = !0);
                    var i = this.dragEndRestingSelect();
                    if (this.options.freeScroll && !this.options.wrapAround) {
                      var n = this.getRestingPosition();
                      this.isFreeScrolling =
                        -n > this.slides[0].target &&
                        -n < this.getLastSlide().target;
                    } else
                      this.options.freeScroll ||
                        i != this.selectedIndex ||
                        (i += this.dragEndBoostSelect());
                    delete this.previousDragX,
                      (this.isDragSelect = this.options.wrapAround),
                      this.select(i),
                      delete this.isDragSelect,
                      this.dispatchEvent("dragEnd", t, [e]);
                  }
                }),
                (s.dragEndRestingSelect = function () {
                  var t = this.getRestingPosition(),
                    e = Math.abs(this.getSlideDistance(-t, this.selectedIndex)),
                    i = this._getClosestResting(t, e, 1),
                    n = this._getClosestResting(t, e, -1);
                  return i.distance < n.distance ? i.index : n.index;
                }),
                (s._getClosestResting = function (t, e, i) {
                  for (
                    var n = this.selectedIndex,
                      s = 1 / 0,
                      o =
                        this.options.contain && !this.options.wrapAround
                          ? function (t, e) {
                              return t <= e;
                            }
                          : function (t, e) {
                              return t < e;
                            };
                    o(e, s) &&
                    ((n += i),
                    (s = e),
                    null !== (e = this.getSlideDistance(-t, n)));

                  )
                    e = Math.abs(e);
                  return { distance: s, index: n - i };
                }),
                (s.getSlideDistance = function (t, e) {
                  var i = this.slides.length,
                    s = this.options.wrapAround && i > 1,
                    o = s ? n.modulo(e, i) : e,
                    r = this.slides[o];
                  if (!r) return null;
                  var a = s ? this.slideableWidth * Math.floor(e / i) : 0;
                  return t - (r.target + a);
                }),
                (s.dragEndBoostSelect = function () {
                  if (
                    void 0 === this.previousDragX ||
                    !this.dragMoveTime ||
                    new Date() - this.dragMoveTime > 100
                  )
                    return 0;
                  var t = this.getSlideDistance(
                      -this.dragX,
                      this.selectedIndex
                    ),
                    e = this.previousDragX - this.dragX;
                  return t > 0 && e > 0 ? 1 : t < 0 && e < 0 ? -1 : 0;
                }),
                (s.staticClick = function (t, e) {
                  var i = this.getParentCell(t.target),
                    n = i && i.element,
                    s = i && this.cells.indexOf(i);
                  this.dispatchEvent("staticClick", t, [e, n, s]);
                }),
                (s.onscroll = function () {
                  var t = l(),
                    e = this.pointerDownScroll.x - t.x,
                    i = this.pointerDownScroll.y - t.y;
                  (Math.abs(e) > 3 || Math.abs(i) > 3) && this._pointerDone();
                }),
                e
              );
            });
          }),
          ls(function (t) {
            !(function (e, i) {
              t.exports
                ? (t.exports = i(e, gs, vs, us))
                : i(e, e.Flickity, e.Unipointer, e.fizzyUIUtils);
            })(window, function (t, e, i, n) {
              var s = "http://www.w3.org/2000/svg";
              function o(t, e) {
                (this.direction = t), (this.parent = e), this._create();
              }
              (o.prototype = Object.create(i.prototype)),
                (o.prototype._create = function () {
                  (this.isEnabled = !0),
                    (this.isPrevious = -1 == this.direction);
                  var t = this.parent.options.rightToLeft ? 1 : -1;
                  this.isLeft = this.direction == t;
                  var e = (this.element = document.createElement("button"));
                  (e.className = "flickity-button flickity-prev-next-button"),
                    (e.className += this.isPrevious ? " previous" : " next"),
                    e.setAttribute("type", "button"),
                    this.disable(),
                    e.setAttribute(
                      "aria-label",
                      this.isPrevious ? "Previous" : "Next"
                    );
                  var i = this.createSVG();
                  e.appendChild(i),
                    this.parent.on("select", this.update.bind(this)),
                    this.on(
                      "pointerDown",
                      this.parent.childUIPointerDown.bind(this.parent)
                    );
                }),
                (o.prototype.activate = function () {
                  this.bindStartEvent(this.element),
                    this.element.addEventListener("click", this),
                    this.parent.element.appendChild(this.element);
                }),
                (o.prototype.deactivate = function () {
                  this.parent.element.removeChild(this.element),
                    this.unbindStartEvent(this.element),
                    this.element.removeEventListener("click", this);
                }),
                (o.prototype.createSVG = function () {
                  var t = document.createElementNS(s, "svg");
                  t.setAttribute("class", "flickity-button-icon"),
                    t.setAttribute("viewBox", "0 0 100 100");
                  var e = document.createElementNS(s, "path"),
                    i = (function (t) {
                      if ("string" == typeof t) return t;
                      return (
                        "M " +
                        t.x0 +
                        ",50 L " +
                        t.x1 +
                        "," +
                        (t.y1 + 50) +
                        " L " +
                        t.x2 +
                        "," +
                        (t.y2 + 50) +
                        " L " +
                        t.x3 +
                        ",50  L " +
                        t.x2 +
                        "," +
                        (50 - t.y2) +
                        " L " +
                        t.x1 +
                        "," +
                        (50 - t.y1) +
                        " Z"
                      );
                    })(this.parent.options.arrowShape);
                  return (
                    e.setAttribute("d", i),
                    e.setAttribute("class", "arrow"),
                    this.isLeft ||
                      e.setAttribute(
                        "transform",
                        "translate(100, 100) rotate(180) "
                      ),
                    t.appendChild(e),
                    t
                  );
                }),
                (o.prototype.handleEvent = n.handleEvent),
                (o.prototype.onclick = function () {
                  if (this.isEnabled) {
                    this.parent.uiChange();
                    var t = this.isPrevious ? "previous" : "next";
                    this.parent[t]();
                  }
                }),
                (o.prototype.enable = function () {
                  this.isEnabled ||
                    ((this.element.disabled = !1), (this.isEnabled = !0));
                }),
                (o.prototype.disable = function () {
                  this.isEnabled &&
                    ((this.element.disabled = !0), (this.isEnabled = !1));
                }),
                (o.prototype.update = function () {
                  var t = this.parent.slides;
                  if (this.parent.options.wrapAround && t.length > 1)
                    this.enable();
                  else {
                    var e = t.length ? t.length - 1 : 0,
                      i = this.isPrevious ? 0 : e;
                    this[
                      this.parent.selectedIndex == i ? "disable" : "enable"
                    ]();
                  }
                }),
                (o.prototype.destroy = function () {
                  this.deactivate(), this.allOff();
                }),
                n.extend(e.defaults, {
                  prevNextButtons: !0,
                  arrowShape: {
                    x0: 10,
                    x1: 60,
                    y1: 50,
                    x2: 70,
                    y2: 40,
                    x3: 30,
                  },
                }),
                e.createMethods.push("_createPrevNextButtons");
              var r = e.prototype;
              return (
                (r._createPrevNextButtons = function () {
                  this.options.prevNextButtons &&
                    ((this.prevButton = new o(-1, this)),
                    (this.nextButton = new o(1, this)),
                    this.on("activate", this.activatePrevNextButtons));
                }),
                (r.activatePrevNextButtons = function () {
                  this.prevButton.activate(),
                    this.nextButton.activate(),
                    this.on("deactivate", this.deactivatePrevNextButtons);
                }),
                (r.deactivatePrevNextButtons = function () {
                  this.prevButton.deactivate(),
                    this.nextButton.deactivate(),
                    this.off("deactivate", this.deactivatePrevNextButtons);
                }),
                (e.PrevNextButton = o),
                e
              );
            });
          }),
          ls(function (t) {
            !(function (e, i) {
              t.exports
                ? (t.exports = i(e, gs, vs, us))
                : i(e, e.Flickity, e.Unipointer, e.fizzyUIUtils);
            })(window, function (t, e, i, n) {
              function s(t) {
                (this.parent = t), this._create();
              }
              (s.prototype = Object.create(i.prototype)),
                (s.prototype._create = function () {
                  (this.holder = document.createElement("ol")),
                    (this.holder.className = "flickity-page-dots"),
                    (this.dots = []),
                    (this.handleClick = this.onClick.bind(this)),
                    this.on(
                      "pointerDown",
                      this.parent.childUIPointerDown.bind(this.parent)
                    );
                }),
                (s.prototype.activate = function () {
                  this.setDots(),
                    this.holder.addEventListener("click", this.handleClick),
                    this.bindStartEvent(this.holder),
                    this.parent.element.appendChild(this.holder);
                }),
                (s.prototype.deactivate = function () {
                  this.holder.removeEventListener("click", this.handleClick),
                    this.unbindStartEvent(this.holder),
                    this.parent.element.removeChild(this.holder);
                }),
                (s.prototype.setDots = function () {
                  var t = this.parent.slides.length - this.dots.length;
                  t > 0 ? this.addDots(t) : t < 0 && this.removeDots(-t);
                }),
                (s.prototype.addDots = function (t) {
                  for (
                    var e = document.createDocumentFragment(),
                      i = [],
                      n = this.dots.length,
                      s = n + t,
                      o = n;
                    o < s;
                    o++
                  ) {
                    var r = document.createElement("li");
                    (r.className = "dot"),
                      r.setAttribute("aria-label", "Page dot " + (o + 1)),
                      e.appendChild(r),
                      i.push(r);
                  }
                  this.holder.appendChild(e), (this.dots = this.dots.concat(i));
                }),
                (s.prototype.removeDots = function (t) {
                  this.dots
                    .splice(this.dots.length - t, t)
                    .forEach(function (t) {
                      this.holder.removeChild(t);
                    }, this);
                }),
                (s.prototype.updateSelected = function () {
                  this.selectedDot &&
                    ((this.selectedDot.className = "dot"),
                    this.selectedDot.removeAttribute("aria-current")),
                    this.dots.length &&
                      ((this.selectedDot =
                        this.dots[this.parent.selectedIndex]),
                      (this.selectedDot.className = "dot is-selected"),
                      this.selectedDot.setAttribute("aria-current", "step"));
                }),
                (s.prototype.onTap = s.prototype.onClick =
                  function (t) {
                    var e = t.target;
                    if ("LI" == e.nodeName) {
                      this.parent.uiChange();
                      var i = this.dots.indexOf(e);
                      this.parent.select(i);
                    }
                  }),
                (s.prototype.destroy = function () {
                  this.deactivate(), this.allOff();
                }),
                (e.PageDots = s),
                n.extend(e.defaults, { pageDots: !0 }),
                e.createMethods.push("_createPageDots");
              var o = e.prototype;
              return (
                (o._createPageDots = function () {
                  this.options.pageDots &&
                    ((this.pageDots = new s(this)),
                    this.on("activate", this.activatePageDots),
                    this.on("select", this.updateSelectedPageDots),
                    this.on("cellChange", this.updatePageDots),
                    this.on("resize", this.updatePageDots),
                    this.on("deactivate", this.deactivatePageDots));
                }),
                (o.activatePageDots = function () {
                  this.pageDots.activate();
                }),
                (o.updateSelectedPageDots = function () {
                  this.pageDots.updateSelected();
                }),
                (o.updatePageDots = function () {
                  this.pageDots.setDots();
                }),
                (o.deactivatePageDots = function () {
                  this.pageDots.deactivate();
                }),
                (e.PageDots = s),
                e
              );
            });
          }),
          ls(function (t) {
            !(function (e, i) {
              t.exports
                ? (t.exports = i(cs, us, gs))
                : i(e.EvEmitter, e.fizzyUIUtils, e.Flickity);
            })(window, function (t, e, i) {
              function n(t) {
                (this.parent = t),
                  (this.state = "stopped"),
                  (this.onVisibilityChange = this.visibilityChange.bind(this)),
                  (this.onVisibilityPlay = this.visibilityPlay.bind(this));
              }
              (n.prototype = Object.create(t.prototype)),
                (n.prototype.play = function () {
                  "playing" != this.state &&
                    (document.hidden
                      ? document.addEventListener(
                          "visibilitychange",
                          this.onVisibilityPlay
                        )
                      : ((this.state = "playing"),
                        document.addEventListener(
                          "visibilitychange",
                          this.onVisibilityChange
                        ),
                        this.tick()));
                }),
                (n.prototype.tick = function () {
                  if ("playing" == this.state) {
                    var t = this.parent.options.autoPlay;
                    t = "number" == typeof t ? t : 3e3;
                    var e = this;
                    this.clear(),
                      (this.timeout = setTimeout(function () {
                        e.parent.next(!0), e.tick();
                      }, t));
                  }
                }),
                (n.prototype.stop = function () {
                  (this.state = "stopped"),
                    this.clear(),
                    document.removeEventListener(
                      "visibilitychange",
                      this.onVisibilityChange
                    );
                }),
                (n.prototype.clear = function () {
                  clearTimeout(this.timeout);
                }),
                (n.prototype.pause = function () {
                  "playing" == this.state &&
                    ((this.state = "paused"), this.clear());
                }),
                (n.prototype.unpause = function () {
                  "paused" == this.state && this.play();
                }),
                (n.prototype.visibilityChange = function () {
                  this[document.hidden ? "pause" : "unpause"]();
                }),
                (n.prototype.visibilityPlay = function () {
                  this.play(),
                    document.removeEventListener(
                      "visibilitychange",
                      this.onVisibilityPlay
                    );
                }),
                e.extend(i.defaults, { pauseAutoPlayOnHover: !0 }),
                i.createMethods.push("_createPlayer");
              var s = i.prototype;
              return (
                (s._createPlayer = function () {
                  (this.player = new n(this)),
                    this.on("activate", this.activatePlayer),
                    this.on("uiChange", this.stopPlayer),
                    this.on("pointerDown", this.stopPlayer),
                    this.on("deactivate", this.deactivatePlayer);
                }),
                (s.activatePlayer = function () {
                  this.options.autoPlay &&
                    (this.player.play(),
                    this.element.addEventListener("mouseenter", this));
                }),
                (s.playPlayer = function () {
                  this.player.play();
                }),
                (s.stopPlayer = function () {
                  this.player.stop();
                }),
                (s.pausePlayer = function () {
                  this.player.pause();
                }),
                (s.unpausePlayer = function () {
                  this.player.unpause();
                }),
                (s.deactivatePlayer = function () {
                  this.player.stop(),
                    this.element.removeEventListener("mouseenter", this);
                }),
                (s.onmouseenter = function () {
                  this.options.pauseAutoPlayOnHover &&
                    (this.player.pause(),
                    this.element.addEventListener("mouseleave", this));
                }),
                (s.onmouseleave = function () {
                  this.player.unpause(),
                    this.element.removeEventListener("mouseleave", this);
                }),
                (i.Player = n),
                i
              );
            });
          }),
          ls(function (t) {
            !(function (e, i) {
              t.exports
                ? (t.exports = i(e, gs, us))
                : i(e, e.Flickity, e.fizzyUIUtils);
            })(window, function (t, e, i) {
              var n = e.prototype;
              return (
                (n.insert = function (t, e) {
                  var i = this._makeCells(t);
                  if (i && i.length) {
                    var n = this.cells.length;
                    e = void 0 === e ? n : e;
                    var s = (function (t) {
                        var e = document.createDocumentFragment();
                        return (
                          t.forEach(function (t) {
                            e.appendChild(t.element);
                          }),
                          e
                        );
                      })(i),
                      o = e == n;
                    if (o) this.slider.appendChild(s);
                    else {
                      var r = this.cells[e].element;
                      this.slider.insertBefore(s, r);
                    }
                    if (0 === e) this.cells = i.concat(this.cells);
                    else if (o) this.cells = this.cells.concat(i);
                    else {
                      var a = this.cells.splice(e, n - e);
                      this.cells = this.cells.concat(i).concat(a);
                    }
                    this._sizeCells(i), this.cellChange(e, !0);
                  }
                }),
                (n.append = function (t) {
                  this.insert(t, this.cells.length);
                }),
                (n.prepend = function (t) {
                  this.insert(t, 0);
                }),
                (n.remove = function (t) {
                  var e = this.getCells(t);
                  if (e && e.length) {
                    var n = this.cells.length - 1;
                    e.forEach(function (t) {
                      t.remove();
                      var e = this.cells.indexOf(t);
                      (n = Math.min(e, n)), i.removeFrom(this.cells, t);
                    }, this),
                      this.cellChange(n, !0);
                  }
                }),
                (n.cellSizeChange = function (t) {
                  var e = this.getCell(t);
                  if (e) {
                    e.getSize();
                    var i = this.cells.indexOf(e);
                    this.cellChange(i);
                  }
                }),
                (n.cellChange = function (t, e) {
                  var i = this.selectedElement;
                  this._positionCells(t),
                    this._getWrapShiftCells(),
                    this.setGallerySize();
                  var n = this.getCell(i);
                  n && (this.selectedIndex = this.getCellSlideIndex(n)),
                    (this.selectedIndex = Math.min(
                      this.slides.length - 1,
                      this.selectedIndex
                    )),
                    this.emitEvent("cellChange", [t]),
                    this.select(this.selectedIndex),
                    e && this.positionSliderAtSelected();
                }),
                e
              );
            });
          }),
          ls(function (t) {
            !(function (e, i) {
              t.exports
                ? (t.exports = i(e, gs, us))
                : i(e, e.Flickity, e.fizzyUIUtils);
            })(window, function (t, e, i) {
              e.createMethods.push("_createLazyload");
              var n = e.prototype;
              function s(t, e) {
                (this.img = t), (this.flickity = e), this.load();
              }
              return (
                (n._createLazyload = function () {
                  this.on("select", this.lazyLoad);
                }),
                (n.lazyLoad = function () {
                  var t = this.options.lazyLoad;
                  if (t) {
                    var e = "number" == typeof t ? t : 0,
                      n = this.getAdjacentCellElements(e),
                      o = [];
                    n.forEach(function (t) {
                      var e = (function (t) {
                        if ("IMG" == t.nodeName) {
                          var e = t.getAttribute("data-flickity-lazyload"),
                            n = t.getAttribute("data-flickity-lazyload-src"),
                            s = t.getAttribute("data-flickity-lazyload-srcset");
                          if (e || n || s) return [t];
                        }
                        var o =
                            "img[data-flickity-lazyload], img[data-flickity-lazyload-src], img[data-flickity-lazyload-srcset]",
                          r = t.querySelectorAll(o);
                        return i.makeArray(r);
                      })(t);
                      o = o.concat(e);
                    }),
                      o.forEach(function (t) {
                        new s(t, this);
                      }, this);
                  }
                }),
                (s.prototype.handleEvent = i.handleEvent),
                (s.prototype.load = function () {
                  this.img.addEventListener("load", this),
                    this.img.addEventListener("error", this);
                  var t =
                      this.img.getAttribute("data-flickity-lazyload") ||
                      this.img.getAttribute("data-flickity-lazyload-src"),
                    e = this.img.getAttribute("data-flickity-lazyload-srcset");
                  (this.img.src = t),
                    e && this.img.setAttribute("srcset", e),
                    this.img.removeAttribute("data-flickity-lazyload"),
                    this.img.removeAttribute("data-flickity-lazyload-src"),
                    this.img.removeAttribute("data-flickity-lazyload-srcset");
                }),
                (s.prototype.onload = function (t) {
                  this.complete(t, "flickity-lazyloaded");
                }),
                (s.prototype.onerror = function (t) {
                  this.complete(t, "flickity-lazyerror");
                }),
                (s.prototype.complete = function (t, e) {
                  this.img.removeEventListener("load", this),
                    this.img.removeEventListener("error", this);
                  var i = this.flickity.getParentCell(this.img),
                    n = i && i.element;
                  this.flickity.cellSizeChange(n),
                    this.img.classList.add(e),
                    this.flickity.dispatchEvent("lazyLoad", t, n);
                }),
                (e.LazyLoader = s),
                e
              );
            });
          }),
          ls(function (t) {
            /*!
             * Flickity v2.2.1
             * Touch, responsive, flickable carousels
             *
             * Licensed GPLv3 for open source use
             * or Flickity Commercial License for commercial use
             *
             * https://flickity.metafizzy.co
             * Copyright 2015-2019 Metafizzy
             */
            window, t.exports && (t.exports = gs);
          })),
        ws = ls(function (t) {
          !(function (e, i) {
            t.exports ? (t.exports = i(bs, us)) : i(e.Flickity, e.fizzyUIUtils);
          })(as, function (t, e) {
            var i = t.Slide,
              n = i.prototype.updateTarget;
            (i.prototype.updateTarget = function () {
              if ((n.apply(this, arguments), this.parent.options.fade)) {
                var t = this.target - this.x,
                  e = this.cells[0].x;
                this.cells.forEach(function (i) {
                  var n = i.x - e - t;
                  i.renderPosition(n);
                });
              }
            }),
              (i.prototype.setOpacity = function (t) {
                this.cells.forEach(function (e) {
                  e.element.style.opacity = t;
                });
              });
            var s = t.prototype;
            t.createMethods.push("_createFade"),
              (s._createFade = function () {
                (this.fadeIndex = this.selectedIndex),
                  (this.prevSelectedIndex = this.selectedIndex),
                  this.on("select", this.onSelectFade),
                  this.on("dragEnd", this.onDragEndFade),
                  this.on("settle", this.onSettleFade),
                  this.on("activate", this.onActivateFade),
                  this.on("deactivate", this.onDeactivateFade);
              });
            var o = s.updateSlides;
            (s.updateSlides = function () {
              o.apply(this, arguments),
                this.options.fade &&
                  this.slides.forEach(function (t, e) {
                    var i = e == this.selectedIndex ? 1 : 0;
                    t.setOpacity(i);
                  }, this);
            }),
              (s.onSelectFade = function () {
                (this.fadeIndex = Math.min(
                  this.prevSelectedIndex,
                  this.slides.length - 1
                )),
                  (this.prevSelectedIndex = this.selectedIndex);
              }),
              (s.onSettleFade = function () {
                (delete this.didDragEnd, this.options.fade) &&
                  (this.selectedSlide.setOpacity(1),
                  this.slides[this.fadeIndex] &&
                    this.fadeIndex != this.selectedIndex &&
                    this.slides[this.fadeIndex].setOpacity(0));
              }),
              (s.onDragEndFade = function () {
                this.didDragEnd = !0;
              }),
              (s.onActivateFade = function () {
                this.options.fade && this.element.classList.add("is-fade");
              }),
              (s.onDeactivateFade = function () {
                this.options.fade &&
                  (this.element.classList.remove("is-fade"),
                  this.slides.forEach(function (t) {
                    t.setOpacity("");
                  }));
              });
            var r = s.positionSlider;
            s.positionSlider = function () {
              this.options.fade
                ? (this.fadeSlides(), this.dispatchScrollEvent())
                : r.apply(this, arguments);
            };
            var a = s.positionSliderAtSelected;
            (s.positionSliderAtSelected = function () {
              this.options.fade && this.setTranslateX(0),
                a.apply(this, arguments);
            }),
              (s.fadeSlides = function () {
                if (!(this.slides.length < 2)) {
                  var t = this.getFadeIndexes(),
                    e = this.slides[t.a],
                    i = this.slides[t.b],
                    n = this.wrapDifference(e.target, i.target),
                    s = this.wrapDifference(e.target, -this.x);
                  (s /= n), e.setOpacity(1 - s), i.setOpacity(s);
                  var o = t.a;
                  this.isDragging && (o = s > 0.5 ? t.a : t.b),
                    null != this.fadeHideIndex &&
                      this.fadeHideIndex != o &&
                      this.fadeHideIndex != t.a &&
                      this.fadeHideIndex != t.b &&
                      this.slides[this.fadeHideIndex].setOpacity(0),
                    (this.fadeHideIndex = o);
                }
              }),
              (s.getFadeIndexes = function () {
                return this.isDragging || this.didDragEnd
                  ? this.options.wrapAround
                    ? this.getFadeDragWrapIndexes()
                    : this.getFadeDragLimitIndexes()
                  : { a: this.fadeIndex, b: this.selectedIndex };
              }),
              (s.getFadeDragWrapIndexes = function () {
                var t = this.slides.map(function (t, e) {
                    return this.getSlideDistance(-this.x, e);
                  }, this),
                  i = t.map(function (t) {
                    return Math.abs(t);
                  }),
                  n = Math.min.apply(Math, i),
                  s = i.indexOf(n),
                  o = t[s],
                  r = this.slides.length,
                  a = o >= 0 ? 1 : -1;
                return { a: s, b: e.modulo(s + a, r) };
              }),
              (s.getFadeDragLimitIndexes = function () {
                for (var t = 0, e = 0; e < this.slides.length - 1; e++) {
                  var i = this.slides[e];
                  if (-this.x < i.target) break;
                  t = e;
                }
                return { a: t, b: t + 1 };
              }),
              (s.wrapDifference = function (t, e) {
                var i = e - t;
                if (!this.options.wrapAround) return i;
                var n = i + this.slideableWidth,
                  s = i - this.slideableWidth;
                return (
                  Math.abs(n) < Math.abs(i) && (i = n),
                  Math.abs(s) < Math.abs(i) && (i = s),
                  i
                );
              });
            var l = s._getWrapShiftCells;
            s._getWrapShiftCells = function () {
              this.options.fade || l.apply(this, arguments);
            };
            var c = s.shiftWrapCells;
            return (
              (s.shiftWrapCells = function () {
                this.options.fade || c.apply(this, arguments);
              }),
              t
            );
          });
        }),
        _s = ls(function (t, e) {
          e.__esModule = !0;
          var i = (function () {
            function t() {
              this.events = [];
            }
            return (
              (t.prototype.register = function (t, e, i) {
                return t && e && i
                  ? (this.events.push({ el: t, event: e, listener: i }),
                    t.addEventListener(e, i),
                    { el: t, event: e, listener: i })
                  : null;
              }),
              (t.prototype.unregister = function (t) {
                var e = t.el,
                  i = t.event,
                  n = t.listener;
                return e && i && n
                  ? ((this.events = this.events.filter(function (t) {
                      return e !== t.el || i !== t.event || n !== t.listener;
                    })),
                    e.removeEventListener(i, n),
                    { el: e, event: i, listener: n })
                  : null;
              }),
              (t.prototype.unregisterAll = function () {
                this.events.forEach(function (t) {
                  var e = t.el,
                    i = t.event,
                    n = t.listener;
                  return e.removeEventListener(i, n);
                }),
                  (this.events = []);
              }),
              t
            );
          })();
          e.default = i;
        }),
        Ss = (function (t) {
          return t &&
            t.__esModule &&
            Object.prototype.hasOwnProperty.call(t, "default")
            ? t.default
            : t;
        })(_s);
      const Cs = (function () {
          function t(e) {
            var i = this;
            if (
              /*!
               * @pixelunion/pxs-slideshow v2.0.0
               * (c) 2023 Pixel Union
               */
              ((function (t, e) {
                if (!(t instanceof e))
                  throw new TypeError("Cannot call a class as a function");
              })(this, t),
              (this.el = e.el),
              (this.settings = e.data),
              (this.paginationClicked = !1),
              (this.events = new Ss()),
              (this.slideshowContainer =
                this.el.querySelector("[data-slideshow]")),
              (this.carousel = this.el.querySelector(
                "[data-slideshow-wrapper]"
              )),
              (this.slides = this.el.querySelectorAll(
                "[data-slideshow-slide]"
              )),
              (this.pagination = this.el.querySelector(
                "[data-slideshow-pagination]"
              )),
              (this.paginationButtons = this.pagination
                ? this.pagination.querySelectorAll("[data-slide-button]")
                : null),
              (this.counter = this.el.querySelector("[data-slide-counter]")),
              this.el.style.setProperty(
                "--slide-text-color",
                "".concat(this.slides[0].dataset.textColor)
              ),
              this.carousel &&
                this.slides.length > 1 &&
                ((this.flickity = new ws(this.carousel, {
                  accessibility: !1,
                  adaptiveHeight: !0,
                  autoPlay:
                    !!this.settings.enable_autoplay &&
                    1e3 * this.settings.autoplay_interval,
                  cellAlign: "left",
                  cellSelector: "[data-slideshow-slide]",
                  contain: !0,
                  fade: this.settings.transition_fade,
                  imagesLoaded: !0,
                  pageDots: this.settings.show_pagination,
                  pauseAutoPlayOnHover: !0,
                  selectedAttraction: this.settings.slide_attraction
                    ? parseFloat(this.settings.slide_attraction)
                    : 0.03,
                  friction: this.settings.slide_friction
                    ? parseFloat(this.settings.slide_friction)
                    : 0.3,
                  wrapAround: !0,
                  arrowShape: {
                    x0: 10,
                    x1: 60,
                    y1: 50,
                    x2: 65,
                    y2: 45,
                    x3: 20,
                  },
                })),
                (this.prevNextButtons = this.el.querySelectorAll(
                  ".flickity-prev-next-button"
                )),
                2 === this.prevNextButtons.length &&
                  (this.prevNextButtons[0].setAttribute(
                    "aria-label",
                    this.settings.previous_text
                  ),
                  this.prevNextButtons[1].setAttribute(
                    "aria-label",
                    this.settings.next_text
                  )),
                this._updateTabindex(),
                this._positionNavigation(),
                this._updateCounter(1),
                this.flickity.on("change", function (t) {
                  i.el.style.setProperty(
                    "--slide-text-color",
                    "".concat(i.slides[t].dataset.textColor)
                  ),
                    i._updatePagination(),
                    i._positionNavigation(),
                    i._updateTabindex(),
                    i._updateCounter(t + 1);
                }),
                this.flickity.on("pointerDown", function () {
                  i.slideshowContainer.setAttribute("data-flickity-paused", !0),
                    i.flickity.pausePlayer();
                }),
                this.events.register(this.carousel, "rimg:load", function () {
                  i.flickity.resize(), i._positionNavigation();
                }),
                this.events.register(this.carousel, "focusin", function () {
                  i.slideshowContainer.setAttribute("data-flickity-paused", !0),
                    i.flickity.pausePlayer();
                }),
                this.events.register(window, "resize", function () {
                  i._positionNavigation();
                }),
                this.flickity.on("settle", function (t) {
                  i.paginationClicked &&
                    (i.slides[t].focus(), (i.paginationClicked = !1));
                }),
                this.pagination))
            )
              for (
                var n = function (t) {
                    i.events.register(
                      i.paginationButtons[t],
                      "click",
                      function () {
                        var e = parseInt(
                          i.paginationButtons[t].dataset.slideButton,
                          10
                        );
                        i.flickity.pausePlayer(),
                          i.slideshowContainer.setAttribute(
                            "data-flickity-paused",
                            !0
                          ),
                          i.flickity.select(e, !0, !1),
                          (i.paginationClicked = !0);
                      }
                    );
                  },
                  s = 0;
                s < this.paginationButtons.length;
                s++
              )
                n(s);
          }
          var e, i, n;
          return (
            (e = t),
            (i = [
              {
                key: "_updatePagination",
                value: function () {
                  if (this.pagination) {
                    for (var t = 0; t < this.paginationButtons.length; t++)
                      (this.paginationButtons[t].dataset.selected = "false"),
                        this.paginationButtons[t].setAttribute(
                          "aria-selected",
                          "false"
                        );
                    (this.paginationButtons[
                      this.flickity.selectedIndex
                    ].dataset.selected = "true"),
                      this.paginationButtons[
                        this.flickity.selectedIndex
                      ].setAttribute("aria-selected", "true");
                  }
                },
              },
              {
                key: "_positionNavigation",
                value: function () {
                  if (this.settings.mobile_navigation_adjust) {
                    var t = this.el.querySelectorAll(
                        ".flickity-prev-next-button"
                      ),
                      e = this.flickity.selectedElement.querySelector(
                        "[data-slide-image-wrapper]"
                      ).offsetHeight;
                    if (t) {
                      var i = "50%";
                      this.viewportIsMobile() && (i = "".concat(e / 2, "px")),
                        (t[0].style.top = i),
                        (t[1].style.top = i);
                    }
                    if (this.pagination) {
                      var n = "auto";
                      if (this.viewportIsMobile())
                        if (
                          this.flickity.selectedElement.querySelector(
                            "[data-slide-content]"
                          )
                        )
                          n = "".concat(e, "px");
                        else {
                          var s = this.pagination.offsetHeight;
                          n = "".concat(e - s, "px");
                        }
                      this.pagination.style.top = n;
                    }
                  }
                },
              },
              {
                key: "_updateTabindex",
                value: function () {
                  for (var t = 0; t < this.slides.length; t++)
                    for (
                      var e = this.slides[t].querySelectorAll("a"), i = 0;
                      i < e.length;
                      i++
                    )
                      e[i].setAttribute(
                        "tabindex",
                        t === this.flickity.selectedIndex ? "0" : "-1"
                      );
                },
              },
              {
                key: "_updateCounter",
                value: function (t) {
                  var e = this.counter.dataset.counterTemplate
                    .replace("", t)
                    .replace("", this.slides.length);
                  this.counter.innerHTML = e;
                },
              },
              {
                key: "viewportIsMobile",
                value: function () {
                  return window.innerWidth < 720;
                },
              },
              {
                key: "onSectionUnload",
                value: function () {
                  this.events.unregisterAll(), this.flickity.destroy();
                },
              },
              {
                key: "onSectionBlockSelect",
                value: function (t) {
                  var e = t.el.dataset.slideIndex;
                  this.flickity.select(e),
                    this.flickity.pausePlayer(),
                    this.flickity.resize();
                },
              },
              {
                key: "onSectionBlockDeselect",
                value: function () {
                  this.settings.enable_autoplay && this.flickity.playPlayer();
                },
              },
            ]) && rs(e.prototype, i),
            n && rs(e, n),
            t
          );
        })(),
        ks = "pxu-lia-block",
        xs = "pxu-lia-element",
        Es = "pxu-lia-block--play",
        As = "pxu-lia-block--reset",
        Ts = "pxu-lia-section--play",
        Ls = "pxu-lia-section--reset",
        Ds = (t) => {
          let { parentNode: e } = t;
          return e.querySelector(
            '[type="application/pxs-animation-mapping+json"]'
          )
            ? e
            : Ds(e);
        },
        Is = (t, e) => {
          (t.style.animationName = "none"),
            t.classList.add(As),
            e.forEach((t) => {
              t.style.animationName = "none";
            });
        },
        Ps = (t, e) => {
          (t.style.animationName = ""),
            t.classList.remove(As),
            e.forEach((t) => {
              t.style.animationName = "";
            });
        },
        Ms = (t, e) => {
          (t.style.animationPlayState = "running"),
            t.classList.add(Es),
            e.forEach((t) => {
              t.style.animationPlayState = "running";
            });
        },
        Os = function (t) {
          const e = [];
          if (
            "reset" ===
            (arguments.length > 1 && void 0 !== arguments[1]
              ? arguments[1]
              : "play")
          ) {
            t.forEach((t) => {
              const i = t.querySelectorAll(`.${xs}`);
              ((t, e) => {
                (t.style.animationPlayState = ""),
                  t.classList.remove(Es),
                  e.forEach((t) => {
                    t.style.animationPlayState = "";
                  });
              })(t, i),
                Is(t, i),
                e.push(() => {
                  Ps(t, i);
                });
            });
            const i = Ds(t[0]);
            i.classList.remove(Ts),
              i.classList.add(Ls),
              e.push(() => {
                i.classList.remove(Ls);
              });
          } else
            t.forEach((i, n) => {
              i.style.setProperty("--pxu-lia-outer-sequence", n);
              const s = i.querySelectorAll(`.${xs}`);
              s.forEach((t, e) => {
                t.style.setProperty("--pxu-lia-inner-sequence", e);
              }),
                i.classList.contains(Es)
                  ? (Is(i, s),
                    e.push(() => {
                      Ps(i, s), Ms(i, s);
                    }))
                  : Ms(i, s);
              const o = Ds(t[0]);
              o.classList.contains(Ts)
                ? (o.classList.add(Ls),
                  e.push(() => {
                    o.classList.remove(Ls), o.classList.add(Ts);
                  }))
                : o.classList.add(Ts);
            });
          window.requestAnimationFrame(() => e.forEach((t) => t()));
        },
        Fs = (t) => Os(t, "play"),
        qs = (t, e) => {
          const i = new Map();
          t.forEach((t) => {
            if (t.isIntersecting) {
              e.unobserve(t.target);
              const n = Ds(t.target),
                s = i.get(n);
              i.set(n, s ? [...s, t.target] : [t.target]);
            }
          }),
            i.forEach((t, e) => Fs(t));
        };
      let $s = null;
      class Bs extends Cs {
        constructor(t) {
          super(t),
            (this.carouselContainer = this.carousel.parentNode),
            (this.slideWrappers = this.carousel.querySelectorAll(
              "[data-slide-image-wrapper]"
            )),
            (this.header = document.querySelector(".site-header")),
            (this.announcementBar =
              document.querySelector(".announcement-bar")),
            (this.carouselContainer.classList.contains(
              "slideshow--height-fit_screen"
            ) ||
              this.carouselContainer.classList.contains(
                "slideshow--height-fit_screen-mobile"
              )) &&
              (this._setupCCSVariables(),
              this.events.register(window, "resize", () =>
                this._setupCCSVariables()
              ),
              this._positionNavigation()),
            this.slides.forEach((t) => $s && $s.unobserve(t)),
            Fs([this.slides[0]]),
            this.flickity &&
              this.flickity.on("change", (t) => {
                setTimeout(() => {
                  ((t) => {
                    Os(t, "reset");
                  })(
                    Array.prototype.filter.call(this.slides, (e, i) => i !== t)
                  );
                }, 100),
                  setTimeout(() => {
                    Fs([this.slides[t]]);
                  }, 150),
                  this._setContentHeight(),
                  this._positionNavigation();
              });
        }
        _setContentHeight() {
          const t = ((t) => {
            t = "string" == typeof t ? document.querySelector(t) : t;
            const e = window.getComputedStyle(t),
              i = parseFloat(e.marginTop) + parseFloat(e.marginBottom);
            return Math.ceil(t.offsetHeight + i);
          })(
            this.slides[this.flickity.selectedIndex].querySelector(
              ".slideshow-slide__content"
            )
          );
          this.el.style.setProperty("--content-height", `${t}px`);
        }
        _setupCCSVariables() {
          const t = this.header.offsetHeight;
          let e = 0;
          this.announcmentBar &&
            (e = document.querySelector(".announcement-bar").offsetHeight),
            this.el.style.setProperty("--header-height", t - e + "px"),
            this._setContentHeight(),
            this.flickity.resize();
        }
      }
      class Ns {
        constructor(t) {
          (this.el = t.el), (this.autoplay = t.data.autoplay), this.init();
        }
        init() {
          const t = this.el.querySelector("[data-video]");
          if (
            ((this.hasPlayed = !1),
            t && (this.video = new si(t)),
            this.video && this.autoplay)
          ) {
            const e = { play: 0.5, pause: 0.2 };
            (this.playPauseObserver = new IntersectionObserver(
              (t) => {
                const { intersectionRatio: i, isIntersecting: n } = t[0];
                i >= e.play && n && !this.hasPlayed
                  ? (this.video._autoplay(), (this.hasPlayed = !0))
                  : i <= e.pause && !1 === n && this.video._onPauseClick();
              },
              { threshold: [e.pause, e.play] }
            )),
              this.playPauseObserver.observe(t);
          }
        }
        onSectionUnload() {
          this.video && this.video.unload(),
            this.playPauseObserver && this.playPauseObserver.disconnect();
        }
      }
      class Rs {
        constructor(t) {
          (this.$el = e()(t.el)), (this.forms = new Z(this.$el));
        }
        onSectionUnload() {
          this.forms.unload();
        }
      }
      class zs {
        constructor(t) {
          (this.$el = e()(t.el)),
            (this.$window = e()(window)),
            (this.$carousel = this.$el.find("[data-highlights-slider]")),
            (this.slides = "[data-highlights-block]"),
            (this.flickity = null),
            (this.flickityOptions = null),
            this.$carousel.length > 0 &&
              this.$carousel.find(this.slides).length > 1 &&
              this._initSlider(),
            Ot.onChange((t) => this.onBreakpointChange(t));
        }
        _initSlider() {
          (this.flickityOptions = {
            autoPlay: 0,
            accessibility: !0,
            cellAlign: "left",
            cellSelector: this.slides,
            pageDots: !1,
            prevNextButtons: !1,
            contain: !0,
          }),
            this._bindFlickity();
        }
        onSectionUnload() {
          this._destroyFlickity(), this.$window.off(".twitter");
        }
        _bindFlickity() {
          Ot.max("M") &&
            null === this.flickity &&
            this.$carousel[0] &&
            (this.flickity = new (qt())(
              this.$carousel[0],
              this.flickityOptions
            ));
        }
        _destroyFlickity() {
          this.flickity && (this.flickity.destroy(), (this.flickity = null));
        }
        onBreakpointChange(t) {
          t.current.min("M") && this.flickity
            ? this._destroyFlickity()
            : t.previous.min("M") && this._bindFlickity();
        }
      }
      function Hs(t, e) {
        for (var i = 0; i < e.length; i++) {
          var n = e[i];
          (n.enumerable = n.enumerable || !1),
            (n.configurable = !0),
            "value" in n && (n.writable = !0),
            Object.defineProperty(t, n.key, n);
        }
      }
      var Us = (function (t, e) {
          return t((e = { exports: {} }), e.exports), e.exports;
        })(function (t, e) {
          e.__esModule = !0;
          var i = (function () {
            function t() {
              this.events = [];
            }
            return (
              (t.prototype.register = function (t, e, i) {
                return t && e && i
                  ? (this.events.push({ el: t, event: e, listener: i }),
                    t.addEventListener(e, i),
                    { el: t, event: e, listener: i })
                  : null;
              }),
              (t.prototype.unregister = function (t) {
                var e = t.el,
                  i = t.event,
                  n = t.listener;
                return e && i && n
                  ? ((this.events = this.events.filter(function (t) {
                      return e !== t.el || i !== t.event || n !== t.listener;
                    })),
                    e.removeEventListener(i, n),
                    { el: e, event: i, listener: n })
                  : null;
              }),
              (t.prototype.unregisterAll = function () {
                this.events.forEach(function (t) {
                  var e = t.el,
                    i = t.event,
                    n = t.listener;
                  return e.removeEventListener(i, n);
                }),
                  (this.events = []);
              }),
              t
            );
          })();
          e.default = i;
        }),
        js = (function (t) {
          return t &&
            t.__esModule &&
            Object.prototype.hasOwnProperty.call(t, "default")
            ? t.default
            : t;
        })(Us);
      const Ws = (function () {
        function t(e) {
          !(
            /*!
             * @pixelunion/pxs-shoppable-image v1.0.0
             * (c) 2023 Pixel Union
             */
            (function (t, e) {
              if (!(t instanceof e))
                throw new TypeError("Cannot call a class as a function");
            })(this, t)
          ),
            (this.el = e.el),
            (this.bounds = this.el.getBoundingClientRect()),
            (this.imageWrapper = this.el.querySelector(
              "[data-shoppable-image-wrapper]"
            )),
            (this.image = this.el.querySelector("[data-shoppable-image-img]")),
            (this.points = this.el.querySelectorAll("[data-hotspot]")),
            (this.tooltips = this.el.querySelectorAll(
              "[data-tooltip-wrapper]"
            )),
            (this.activeClass = "shoppable-image__hotspot--active"),
            (this.events = new js()),
            (this.window = window),
            (this.hoverTimer = null),
            (this.tooltipDelay = 300),
            (this.windowScrollTimer = null),
            (this.windowScrollEvent = null),
            this._bindEvents();
        }
        var e, i, n;
        return (
          (e = t),
          (i = [
            {
              key: "_bindEvents",
              value: function () {
                var t = this;
                this._positionElements(),
                  this.image &&
                    this.events.register(this.image, "rimg:load", function (e) {
                      return t._positionElements();
                    }),
                  this.events.register(this.el, "touchend", function () {
                    return t._clearAllActive();
                  });
                for (var e = 0; e < this.points.length; e++) {
                  var i = this.points[e],
                    n = this.tooltips[e];
                  this.events.register(i, "click", function (e) {
                    return t._setActivePoint(e);
                  }),
                    this.events.register(i, "touchend", function (e) {
                      return t._setActivePoint(e);
                    }),
                    this.events.register(i, "mouseover", function (e) {
                      return t._setActivePoint(e);
                    }),
                    this.events.register(i, "mouseout", function (e) {
                      return t._closeActivePoint(e);
                    }),
                    this.events.register(i, "focus", function (e) {
                      return t._setActivePoint(e);
                    }),
                    this.events.register(n, "touchend", function (t) {
                      return t.stopPropagation();
                    }),
                    this.events.register(n, "mouseover", function (e) {
                      return t._setActivePoint(e);
                    }),
                    this.events.register(n, "mouseout", function (e) {
                      return t._closeActivePoint(e);
                    }),
                    this.events.register(n, "focus", function (t) {
                      return t.stopPropagation();
                    });
                }
              },
            },
            {
              key: "_positionElements",
              value: function () {
                this.positionHotspots(), this.positionTooltips();
              },
            },
            {
              key: "_setActivePoint",
              value: function (t) {
                t.stopPropagation();
                var e = t.currentTarget,
                  i = null;
                if (
                  (null !== this.hoverTimer &&
                    (clearTimeout(this.hoverTimer), (this.hoverTimer = null)),
                  (i = e.closest("[data-hotspot]")),
                  "touchend" === t.type &&
                    i.classList.contains(this.activeClass))
                )
                  i.classList.remove(this.activeClass);
                else if (
                  !(
                    ("click" === t.type &&
                      i.classList.contains(this.activeClass)) ||
                    i.classList.contains(this.activeClass)
                  )
                ) {
                  var n = this.el.querySelector(".".concat(this.activeClass));
                  n && n.classList.remove(this.activeClass),
                    this.positionTooltips(),
                    i.classList.add(this.activeClass);
                }
              },
            },
            {
              key: "_closeActivePoint",
              value: function (t) {
                var e = this,
                  i = t.currentTarget,
                  n = null;
                (n = i.closest("[data-hotspot]")),
                  null !== this.hoverTimer && clearTimeout(this.hoverTimer),
                  (this.hoverTimer = setTimeout(function () {
                    n.classList.remove(e.activeClass);
                  }, this.tooltipDelay));
              },
            },
            {
              key: "_clearAllActive",
              value: function () {
                var t = this.el.querySelector(".".concat(this.activeClass));
                t && t.classList.remove(this.activeClass);
              },
            },
            {
              key: "_resetTooltips",
              value: function () {
                this.tooltips.forEach(function (t) {
                  t.classList.remove("tooltip--overflow-top"),
                    t.classList.remove("tooltip--overflow-right"),
                    t.classList.remove("tooltip--overflow-bottom"),
                    t.classList.remove("tooltip--overflow-left"),
                    (t.style.top = null),
                    (t.style.right = null),
                    (t.style.bottom = null),
                    (t.style.left = null);
                });
              },
            },
            {
              key: "positionHotspots",
              value: function () {
                var t = this;
                this.points.forEach(function (e) {
                  var i = parseInt(e.dataset.hotspotYAxis, 10),
                    n = parseInt(e.dataset.hotspotXAxis, 10),
                    s = e.getBoundingClientRect(),
                    o = t.imageWrapper.getBoundingClientRect(),
                    r = ((o.height - s.height) / o.height) * i;
                  e.style.bottom = "".concat(r, "%");
                  var a = ((o.width - s.width) / o.width) * n;
                  (e.style.left = "".concat(a, "%")),
                    (e.style.visibility = "visible");
                });
              },
            },
            {
              key: "positionTooltips",
              value: function () {
                var t = this;
                this._resetTooltips();
                var e = this.imageWrapper.getBoundingClientRect().right;
                this.tooltips.forEach(function (i) {
                  var n = i.getBoundingClientRect(),
                    s = window.getComputedStyle
                      ? getComputedStyle(i, null)
                      : i.currentStyle,
                    o = parseInt(s.marginTop, 10) || 0,
                    r = parseInt(s.marginRight, 10) || 0,
                    a = parseInt(s.marginBottom, 10) || 0,
                    l = parseInt(s.marginLeft, 10) || 0,
                    c = n.top - o,
                    h = n.right + r,
                    d = n.bottom + a,
                    u = n.left - l;
                  if (h >= e) {
                    i.classList.add("tooltip--overflow-right");
                    var p = e - h;
                    i.style.left = "".concat(p, "px");
                  }
                  if (u <= 0) {
                    i.classList.add("tooltip--overflow-left");
                    var f = Math.abs(u);
                    i.style.left = "".concat(f, "px");
                  }
                  if (
                    (c <= 0 && i.classList.add("tooltip--overflow-top"),
                    d >= t.window.innerHeight)
                  ) {
                    i.classList.add("tooltip--overflow-bottom");
                    var m = t.window.innerHeight - d;
                    i.style.top = "".concat(m, "px");
                  }
                });
              },
            },
            {
              key: "onSectionBlockSelect",
              value: function (t) {
                var e = this;
                this._clearAllActive();
                var i = !1;
                (this.windowScrollEvent = this.events.register(
                  this.window,
                  "scroll",
                  function () {
                    (i = !0),
                      null !== e.windowScrollTimer &&
                        clearTimeout(e.windowScrollTimer),
                      (e.windowScrollTimer = setTimeout(function () {
                        e.positionTooltips(),
                          t.el.classList.add(e.activeClass),
                          (e.windowScrollTimer = null);
                      }, 200));
                  }
                )),
                  !1 === i &&
                    (this.positionTooltips(),
                    t.el.classList.add(this.activeClass));
              },
            },
            {
              key: "onSectionBlockDeselect",
              value: function (t) {
                this.events.unregister(this.windowScrollEvent),
                  (this.windowScrollEvent = null),
                  t.el.classList.remove(this.activeClass);
              },
            },
            {
              key: "onSectionUnload",
              value: function () {
                this.events.unregisterAll();
              },
            },
          ]) && Hs(e.prototype, i),
          n && Hs(e, n),
          t
        );
      })();
      class Vs extends Ws {
        constructor(t) {
          super(t),
            (this.modalSelector = `[data-hotspot-modal-id='${t.id}']`),
            (this.modalEl = document.querySelector(this.modalSelector)),
            (this.modalWrapper = document.querySelector(
              `[data-hotspot-section-id='${t.id}']`
            )),
            (this.quickShopSelector = `[data-hotspot-section-id='${t.id}'] [data-hotspot-modal-quickshop]`),
            (this.quickshopSpinner = this.modalEl.querySelector(
              this.quickShopSelector
            ).innerHTML),
            (this.isOpen = !1),
            (this.modalSidebar = this.modalWrapper.querySelector(
              "[data-hotspot-modal-sidebar]"
            )),
            (this.modalSidebarItems = this.modalWrapper.querySelectorAll(
              "[data-hotspot-modal-sidebar-item]"
            )),
            (this.sidebarArrow = this.modalEl.querySelector(
              "[data-sidebar-arrow]"
            )),
            (this.sidebarItemActiveClass = "active-item"),
            (this.qsTrigger = null),
            (this.modal = new ee({ onClose: () => this.unload() })),
            this.points.forEach((t) => {
              this.events.register(t, "animationend", (e) => {
                "slide-fade-y" === e.animationName &&
                  e.elapsedTime > 0 &&
                  (t.classList.add("shoppable-image__hotspot--pulse"),
                  t.classList.remove("pxu-lia-element"),
                  (t.style.animationPlayState = ""));
              });
            }),
            this.tooltips.forEach((t) => {
              this.events.register(t, "click", (t) => this.onTooltipClick(t));
            }),
            this.modalSidebarItems.forEach((t) => {
              this.events.register(t, "click", (t) =>
                this.onSidebarItemClick(t)
              );
            });
        }
        onTooltipClick(t) {
          t.preventDefault();
          const e = t.currentTarget
              .querySelector("[data-tooltip]")
              .getAttribute("href"),
            i =
              t.currentTarget.closest("[data-hotspot]").dataset.hotspotProduct;
          if (
            (this.points.forEach((t) => {
              t.dataset.hotspotProduct === i && (this.qsTrigger = t);
            }),
            "#" === e)
          )
            return;
          this.modal.open(this.modalSelector, "quickshop-full hotspot__modal");
          const n = this.modalWrapper.querySelector(`[data-product-id='${i}']`);
          n.classList.add(this.sidebarItemActiveClass),
            this.positionSidebarArrow(n),
            (this.isOpen = !0),
            this._fetchQuickshop(i, e);
        }
        onSidebarItemClick(t) {
          t.preventDefault();
          const e = t.currentTarget,
            i = e.dataset.productQuickshopUrl,
            n = e.dataset.productId,
            s = this.modalWrapper.querySelectorAll(
              `.${this.sidebarItemActiveClass}`
            );
          (this.modalWrapper.querySelector(
            "[data-hotspot-modal-quickshop]"
          ).innerHTML = this.quickshopSpinner),
            this.positionSidebarArrow(e),
            s.forEach((t) => {
              t.classList.remove(this.sidebarItemActiveClass);
            }),
            e.classList.add(this.sidebarItemActiveClass),
            i && n && this._fetchQuickshop(n, i);
        }
        positionSidebarArrow(t) {
          const e = t
              .querySelector("[data-modal-sidebar-image]")
              .getBoundingClientRect(),
            i = t.offsetTop + e.height / 2;
          this.sidebarArrow.style.top = `${i}px`;
        }
        _fetchQuickshop(t, i) {
          const n = this.modal.$modalInner[0].querySelector(
              "[data-hotspot-modal-quickshop]"
            ),
            s = this.modal.$modalInner.find(
              "[data-hotspot-modal-sidebar-item]"
            ),
            o = this.modalWrapper.querySelector(".productitem-quickshop");
          o && (o.style.display = "block"),
            (this.productQuickshop = new mi({
              $el: s,
              id: this.sectionId,
              modal: this.modal,
              sectionContext: "shoppable-image",
              trigger: e()(this.qsTrigger),
              quickshopContainer: n,
              quickShopSelector: this.quickShopSelector,
              productUrl: i,
              view: "product-shoppable-img-qs",
            }));
        }
        unload() {
          this.productQuickshop && this.productQuickshop.unload();
          this.modalWrapper
            .querySelectorAll(`.${this.sidebarItemActiveClass}`)
            .forEach((t) => {
              t.classList.remove(this.sidebarItemActiveClass);
            });
        }
      }
      class Gs {
        constructor(t) {
          (this.$el = t.el),
            (this.$window = $(window)),
            (this.flickity = null),
            (this.events = new xt.Z()),
            (this.carousel = this.$el.querySelector(".testimonials")),
            (this.slides = this.$el.querySelectorAll(".testimonial")),
            (this.onBreakpointChange = () => {
              (Ot.max("XS") && this.slides.length > 1) ||
              (Ot.max("L") && this.slides.length >= 3) ||
              (Ot.min("XL") && this.slides.length > 3)
                ? this._initFlickity()
                : this._destroyFlickity();
            }),
            this.onBreakpointChange(),
            Ot.onChange(this.onBreakpointChange);
        }
        onSectionUnload() {
          this._destroyFlickity(),
            Ot.offChange(this.onBreakpointChange),
            this.events.unregisterAll();
        }
        _initFlickity() {
          this.Flickity ||
            ((this.flickity = new (qt())(this.carousel, {
              autoPlay: 0,
              accessibility: !0,
              cellAlign: "left",
              cellSelector: ".testimonial",
              groupCells: !0,
              pageDots: !0,
              contain: !0,
              adaptiveHeight: !1,
              arrowShape:
                "M65.29 11.99L27.28 50L65.3 87.99L70.25 83.06L37.19 50L70.26 16.94L65.29 11.99Z",
            })),
            this.events.register(this.carousel, "rimg:load", () => {
              this.flickity.resize();
            }));
        }
        _destroyFlickity() {
          this.flickity && (this.flickity.destroy(), (this.flickity = null));
        }
      }
      class Xs {
        constructor() {
          (this.$accountContents = e()("[data-template-account]")),
            (this.$loginContent = e()("[data-template-account-login]")),
            (this.$addressesContent = e()("[data-template-account-addresses]")),
            (this.$addressButtonFocus = null),
            (this._loginToggle = this._loginToggle.bind(this)),
            this.$loginContent.length && this._initLoginPage(),
            this.$addressesContent.length && this._initAddressPage(),
            this.$accountContents.length && this._init();
        }
        _init() {
          new Z(this.$accountContents);
        }
        _initLoginPage() {
          (this.$loginToggle = this.$loginContent.find("[data-login-toggle]")),
            (this.$login = this.$loginContent.find(
              "[data-account-login-main]"
            )),
            (this.$recovery = this.$loginContent.find(
              "[data-account-login-recovery]"
            )),
            (this.$recoveryHasMessage = this.$recovery.find(
              "[data-recovery-has-message]"
            )),
            this.$loginToggle.on("click", this._loginToggle),
            this.$recoveryHasMessage.length && this._loginToggle();
        }
        _loginToggle() {
          let t =
            arguments.length > 0 && void 0 !== arguments[0]
              ? arguments[0]
              : null;
          t && t.preventDefault(),
            this.$login.toggleClass("visible"),
            this.$recovery.toggleClass("visible");
        }
        _initAddressPage() {
          const t = this.$addressesContent.find("[data-address-id]");
          this.$addressesContent.on("click", "[data-edit-address]", (i) => {
            const n = e()(i.currentTarget),
              s = n.attr("data-edit-address");
            t.removeClass("visible"),
              (this.$addressButtonFocus = n),
              e()(`[data-address-id="${s}"]`)
                .addClass("visible")
                .find(".form-field-input")
                .eq(0)
                .focus();
          }),
            this.$addressesContent.on(
              "click",
              "[data-edit-address-cancel]",
              () => {
                t.removeClass("visible"),
                  e()('[data-address-id="new"]').addClass("visible"),
                  this.$addressButtonFocus.focus(),
                  (this.$addressButtonFocus = null);
              }
            ),
            this.$addressesContent.on("click", "[data-delete-address]", (t) => {
              const i = e()(t.target).attr("data-delete-address");
              Shopify.CustomerAddress.destroy(i, "");
            }),
            t.each((t, i) => {
              const n = e()(i).attr("data-address-id"),
                s = `customer_addr_${n}_country`,
                o = `customer_addr_${n}_province`,
                r = { hideElement: `address_province_container_${n}` };
              new Shopify.CountryProvinceSelector(s, o, r);
            });
        }
      }
      class Zs {
        constructor() {
          (this.$contactContents = e()("[data-template-contact]")),
            this.$contactContents.length && new Z(this.$contactContents);
        }
      }
      class Qs {
        constructor() {
          (this.el = document.querySelector(".template-giftcard")),
            (this.$el = e()(this.el)),
            (this.qrCode = this.el.querySelector("[data-giftcard-qr]")),
            (this.giftCardCode = this.el.querySelector("[data-giftcard-code]")),
            this._bindEvents(),
            this.addQrCode();
        }
        addQrCode() {
          return new QRCode(this.qrCode, {
            text: e()(this.qrCode).data("giftcard-qr"),
            width: 120,
            height: 120,
          });
        }
        _bindEvents() {
          this.$el.on("click", "[data-giftcard-print]", () => {
            window.print();
          }),
            this.$el.on("click", "[data-giftcard-code]", () => {
              this._selectText();
            });
        }
        _selectText() {
          let t,
            e = "";
          document.body.createTextRange
            ? ((e = document.body.createTextRange()),
              e.moveToElementText(this.giftCardCode),
              e.select())
            : window.getSelection &&
              ((t = window.getSelection()),
              (e = document.createRange()),
              e.selectNodeContents(this.giftCardCode),
              t.removeAllRanges(),
              t.addRange(e));
        }
      }
      class Ys {
        constructor() {
          (this.$pageContent = e()("[data-template-page]")),
            this.$pageContent.length && new X(this.$pageContent);
        }
      }
      class Ks {
        constructor() {
          (this.el = document.querySelector(".template-order")),
            (this.checkboxEls = this.el.querySelectorAll("[data-checkbox]")),
            (this.atcButton = this.el.querySelector("[data-atc-button]")),
            (this.selectAllCheckbox = this.el.querySelector(
              "[data-select-all-checkbox]"
            )),
            (this.selectAllCheckboxInput = this.el.querySelector(
              "[data-select-all-checkbox-input]"
            )),
            (this.selectItemsCountEl = this.el.querySelector(
              "[data-select-items-count]"
            )),
            (this.lineCheckboxInputs = this.el.querySelectorAll(
              "[data-line-checkbox-input]"
            )),
            this.selectAllCheckboxInput &&
              ((this.lineCheckboxInputsArray = Array.from(
                this.lineCheckboxInputs
              )),
              (this.data = JSON.parse(
                this.el.querySelector("[data-order-line-items-data]").innerHTML
              )),
              (this.settings = JSON.parse(
                this.el.querySelector("[data-settings]").innerHTML
              )),
              (this.itemsToAddToCart = []),
              (this.messageBanner = null),
              (this.lastCheckedIndex = null),
              (this.currentCheckedIndex = null),
              (this.map = new Map()),
              (this.events = new xt.Z()),
              this._init());
        }
        get _selectedLines() {
          return this.el.querySelectorAll("[data-line-checkbox-input]:checked");
        }
        get _allLineCheckboxesAreChecked() {
          return (
            0 === this.lineCheckboxInputsArray.filter((t) => !t.checked).length
          );
        }
        get _noCheckboxIsChecked() {
          return (
            0 === this.lineCheckboxInputsArray.filter((t) => t.checked).length
          );
        }
        _init() {
          this.checkboxEls.forEach((t) => {
            this.map.set(t, new wi(t));
          }),
            this._bindCheckboxEvents(),
            this.events.register(this.atcButton, "click", (t) => {
              this._selectItemsToAddToCart(), this._addToCart(t);
            });
        }
        _bindCheckboxEvents() {
          this.events.register(this.selectAllCheckboxInput, "change", () => {
            const t = this.selectAllCheckboxInput.checked;
            this._onCheckboxChange(this.selectAllCheckboxInput, t),
              this.lineCheckboxInputs.forEach((e) => {
                (e.checked = t), this._onCheckboxChange(e, t);
              }),
              this._onCheckboxStateUpdate();
          }),
            this.lineCheckboxInputs.forEach((t) => {
              this.events.register(t, "change", () => {
                const e = t.checked;
                this._onCheckboxChange(t, e),
                  e && this._updateCheckedIndexes(t),
                  this._onCheckboxStateUpdate();
              });
            }),
            this.events.register(document, "click", (t) => {
              t.shiftKey &&
                "INPUT" === t.target.nodeName &&
                window.requestAnimationFrame(() => {
                  if (
                    null !== this.lastCheckedIndex &&
                    null !== this.currentCheckedIndex
                  ) {
                    const t =
                      this.lineCheckboxInputsArray[this.lastCheckedIndex]
                        .checked;
                    let e = null,
                      i = null;
                    this.lastCheckedIndex < this.currentCheckedIndex
                      ? ((e = this.lastCheckedIndex),
                        (i = this.currentCheckedIndex))
                      : ((e = this.currentCheckedIndex),
                        (i = this.lastCheckedIndex));
                    for (let n = e; n < i; n++) {
                      const e = this.lineCheckboxInputsArray[n];
                      (e.checked = t), this._onCheckboxChange(e, t);
                    }
                    this._onCheckboxStateUpdate(), this._resetCheckedIndexes();
                  }
                });
            });
        }
        _updateCheckedIndexes(t) {
          null === this.lastCheckedIndex
            ? (this.lastCheckedIndex = this.lineCheckboxInputsArray.indexOf(t))
            : (this.currentCheckedIndex =
                this.lineCheckboxInputsArray.indexOf(t));
        }
        _resetCheckedIndexes() {
          (this.lastCheckedIndex = null), (this.currentCheckedIndex = null);
        }
        _onCheckboxChange(t, e) {
          let i =
            arguments.length > 2 && void 0 !== arguments[2] && arguments[2];
          const n = t.parentElement;
          e
            ? (this.map.get(n).unsetIndeterminate(),
              this.map.get(n).check(),
              t.closest("[data-order-row]")?.classList.add("checkbox-selected"))
            : i
            ? (this.map.get(n).uncheck(),
              this.map.get(n).setIndeterminate(),
              t.closest("[data-order-row]")?.classList.add("checkbox-selected"))
            : (this.map.get(n).uncheck(),
              this.map.get(n).unsetIndeterminate(),
              t
                .closest("[data-order-row]")
                ?.classList.remove("checkbox-selected"));
        }
        _onCheckboxStateUpdate() {
          let t = !1,
            e = !1;
          this._allLineCheckboxesAreChecked
            ? ((t = !0), (e = !1))
            : this._noCheckboxIsChecked || ((t = !1), (e = !0)),
            (this.selectAllCheckboxInput.checked = t),
            (this.selectAllCheckboxInput.indeterminate = e),
            this._onCheckboxChange(this.selectAllCheckboxInput, t, e),
            this._noCheckboxIsChecked
              ? (this._disableAtcButton(),
                this.selectAllCheckbox.classList.remove(
                  "order-checkbox--active"
                ))
              : (this._enableAtcButton(),
                this.selectAllCheckbox.classList.add("order-checkbox--active"),
                (this.selectItemsCountEl.textContent =
                  this._selectedLines.length));
        }
        _selectItemsToAddToCart() {
          this.itemsToAddToCart.length = 0;
          const t = [];
          this._selectedLines.forEach((e) => {
            t.push(Number(e.getAttribute("data-line-item-id")));
          }),
            this.data.forEach((e) => {
              t.includes(e.id) &&
                this.itemsToAddToCart.push({
                  id: e.variant_id,
                  quantity: e.quantity,
                  selling_plan: e.selling_plan_allocation
                    ? e.selling_plan_allocation.selling_plan.id
                    : null,
                });
            });
        }
        _addToCart(t) {
          t.stopPropagation(), this._setAtcButtonProcessing();
          const e = { items: this.itemsToAddToCart };
          fetch(`${window.Theme.routes.cart_add_url}.js`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(e),
          })
            .then((t) => t.json())
            .then(
              (t) => (
                this._removeAtcButtonProcessing(),
                "Cart Error" === t.message
                  ? Promise.reject(t)
                  : this._onSuccess()
              )
            )
            .catch((t) => {
              this._showErrorBanner(t.description);
            });
        }
        _onSuccess() {
          return fetch(`${window.Theme.routes.cart_url}.js`, {
            method: "GET",
            headers: { "Content-Type": "application/json" },
          })
            .then((t) => (t.ok ? t.json() : Promise.reject(t)))
            .then((t) => {
              if (this.settings.cart_redirection)
                return void (location.href = window.Theme.routes.cart_url);
              const e = new CustomEvent("cartcount:update", { detail: t });
              window.dispatchEvent(e),
                this._showSuccessBanner(this.settings.success_message);
            })
            .catch((t) => {
              this._showErrorBanner(t.message);
            });
        }
        _showSuccessBanner(t) {
          this.messageBanner = new ge(t, "success");
        }
        _showErrorBanner(t) {
          this.messageBanner = new ge(t, "error");
        }
        _enableAtcButton() {
          this.atcButton.classList.remove("disabled"),
            (this.atcButton.disabled = !1);
        }
        _disableAtcButton() {
          this.atcButton.classList.add("disabled"),
            (this.atcButton.disabled = !0);
        }
        _removeAtcButtonProcessing() {
          this.atcButton.classList.remove("processing"),
            (this.atcButton.disabled = !1);
        }
        _setAtcButtonProcessing() {
          this.atcButton.classList.add("processing"),
            (this.atcButton.disabled = !0);
        }
      }
      class Js {
        constructor(t) {
          (this.el = t),
            (this.events = new xt.Z()),
            (this.initialHTML = this.el.innerHTML),
            (this.productTemplate = this.el.querySelector(
              "[data-product-compare-drawer-item-template]"
            )),
            this.events.register(this.el, "click", (t) => {
              const e = t.target.closest(
                "[data-product-compare-drawer-remove]"
              );
              e && this._removeProduct(e.dataset.productCompareDrawerRemove);
            });
          const e = (t) => {
            let { products: e } = t;
            this._reset(),
              e.length || this.el.scroll(0, 0),
              e.forEach((t) => this._addProduct(t)),
              B.watch(this.el);
          };
          e({ products: bi.products }), bi.runOnUpdate(e);
        }
        unload() {
          this.events.unregisterAll();
        }
        _reset() {
          B.unwatch(this.el), (this.el.innerHTML = this.initialHTML);
        }
        _addProduct(t) {
          let { handle: e, data: i } = t;
          const n = this.productTemplate.cloneNode(!0).content,
            s = new DocumentFragment(),
            o = n.querySelector("[data-product-compare-drawer-title]"),
            r = n.querySelector("[data-product-compare-drawer-image]"),
            a = n.querySelector("[data-product-compare-drawer-remove]"),
            l = this.el.querySelector(
              "[data-product-compare-drawer-item-placeholder]"
            );
          (o.innerHTML = i.title),
            (o.href = i.url),
            (a.dataset.productCompareDrawerRemove = e),
            (r.innerHTML = i.image),
            r.style.setProperty(
              "--product-grid-item-image-aspect-ratio",
              i.imageAspectRatio
            ),
            s.append(n),
            this.el.insertBefore(s, l),
            l && l.remove();
        }
        _removeProduct(t) {
          bi.remove(t);
        }
      }
      const to = "pxuProductCompareFlyoutV1";
      class eo {
        constructor(t) {
          (this.el = t),
            (this.events = new xt.Z()),
            (this.compareDrawerLink = this.el.querySelector(
              "[data-product-compare-drawer-link]"
            )),
            (this.compareDrawerLinkHref = this.compareDrawerLink.href),
            (this.compareDrawerClearAllButton = this.el.querySelector(
              "[data-product-compare-clear-all]"
            )),
            (this.compareDrawerTitle = this.el.querySelector(
              "[data-product-compare-drawer-title]"
            )),
            (this.compareDrawerNotification = this.el.querySelector(
              "[data-product-compare-drawer-notification]"
            )),
            (this.compareDrawerCountOne =
              this.compareDrawerNotification.dataset.productCountOne),
            (this.compareDrawerCountOther =
              this.compareDrawerNotification.dataset.productCountOther),
            (this.compareDrawerHeader = this.el.querySelector(
              "[data-product-compare-drawer-header]"
            )),
            (this.compareDrawerContent = new Js(
              this.el.querySelector("[data-compare-drawer-items-container]")
            )),
            (this.preferredState = this._loadPreferredState() || "open"),
            (this.drawerAnimation = Mt({ state: "hidden", el: this.el })),
            this.events.register(window, "resize", () => {
              "hidden" !== this.drawerAnimation.state &&
                this._updateDrawerPosition();
            }),
            this.events.register(this.compareDrawerHeader, "click", () => {
              "open" === this.drawerAnimation.state
                ? (this._savePreferredState("closed"), this._closeDrawer())
                : (this._savePreferredState("open"), this._openDrawer());
            }),
            this.events.register(
              this.compareDrawerClearAllButton,
              "click",
              () => {
                bi.removeAll();
              }
            );
          let e = bi.products.length;
          const i = (t) => {
            let { products: i } = t;
            i.length > 0
              ? i.length > e
                ? (this._openDrawer(), this._savePreferredState("open"))
                : this._showDrawer()
              : this._hideDrawer(),
              (e = i.length),
              this._updateDrawerCompareLink(),
              this._updateDrawerNotification();
          };
          i({ products: bi.products }), bi.runOnUpdate(i);
        }
        unload() {
          this.events.unregisterAll(),
            this.compareDrawerContent.unload(),
            this.drawerAnimation.unload();
        }
        _showDrawer() {
          this.drawerAnimation.animateTo(this.preferredState, {
            onStart: () => {
              this._updateDrawerPosition();
            },
          });
        }
        _openDrawer() {
          this.drawerAnimation.animateTo("open", {
            onStart: () => {
              this._updateDrawerPosition();
            },
          }),
            this._updateDrawerCompareLink(),
            this._updateDrawerNotification();
        }
        _hideDrawer() {
          this.drawerAnimation.animateTo("hidden");
        }
        _closeDrawer() {
          this.drawerAnimation.animateTo("closed"),
            this._updateDrawerCompareLink(),
            this._updateDrawerNotification();
        }
        _updateDrawerPosition() {
          this.el.style.setProperty(
            "--compare-drawer-header-height",
            `${this.compareDrawerHeader.offsetHeight}px`
          );
        }
        _updateDrawerNotification() {
          if (1 === bi.products.length)
            this.compareDrawerNotification.innerHTML =
              this.compareDrawerCountOne;
          else {
            const t = this.compareDrawerCountOther.replace(
              "** count **",
              bi.products.length
            );
            this.compareDrawerNotification.innerHTML = t;
          }
        }
        _updateDrawerCompareLink() {
          const t = this.compareDrawerLink.dataset.productCompareDrawerLinkText,
            e = /\/$/.test(this.compareDrawerLinkHref) ? "" : "/",
            [i, ...n] = bi.products;
          if (
            (bi.products.length > 1
              ? this.compareDrawerLink.classList.remove("disabled")
              : this.compareDrawerLink.classList.add("disabled"),
            bi.products.length > 0
              ? (this.compareDrawerLink.innerHTML = `${t} (${bi.products.length})`)
              : (this.compareDrawerLink.innerHTML = `${t}`),
            !i)
          )
            return;
          const s = n
            .map((t) => {
              let { handle: e } = t;
              return e;
            })
            .join(",");
          this.compareDrawerLink.href = `${this.compareDrawerLinkHref}${e}products/${i.handle}?view=compare&compare=${s}`;
        }
        _loadPreferredState() {
          try {
            return JSON.parse(sessionStorage.getItem(to));
          } catch (t) {
            return null;
          }
        }
        _savePreferredState(t) {
          (this.preferredState = t),
            sessionStorage.setItem(to, JSON.stringify(t));
        }
      }
      const io = () => {
        let t = !1,
          e = 0;
        document.body.addEventListener("touchstart", (i) => {
          i.target.closest && i.target.closest(".flickity-slider")
            ? ((t = !0), (e = i.touches[0].pageX))
            : (t = !1);
        }),
          document.body.addEventListener(
            "touchmove",
            (i) => {
              t &&
                i.cancelable &&
                Math.abs(i.touches[0].pageX - e) > 10 &&
                i.preventDefault();
            },
            { passive: !1 }
          );
      };
      function no(t) {
        let { target: e } = t;
        (e.dataset && !e.dataset.swatchTooltip) ||
          window.requestAnimationFrame(() =>
            (function (t) {
              const { innerWidth: e } = window,
                { x: i, width: n } = t.getBoundingClientRect(),
                s =
                  0.5 * parseFloat(window.getComputedStyle(t, ":after").width);
              let o = 0,
                r = 0;
              i < 0.5 * e
                ? ((o = i + 0.5 * n - 10), (r = s - o))
                : ((o = e - i - 0.5 * n - 10), (r = o - s)),
                t.style.setProperty(
                  "--swatch-tooltip-offset",
                  `${s >= o ? r : 0}px`
                );
            })(e)
          );
      }
      class so {
        constructor() {
          window.addEventListener("mouseover", no);
        }
        unload() {
          window.removeEventListener("mouseover", no);
        }
      }
      const oo = () => {
        ($s = new IntersectionObserver(qs, { threshold: 0.3 })),
          "reduceAnimations" in document.body.dataset ||
            document.querySelectorAll(`.${ks}`).forEach((t) => $s.observe(t)),
          B.init('[data-rimg="lazy"]', { round: 1 });
        const t = () => Fe(document);
        "requestIdleCallback" in window ? window.requestIdleCallback(t) : t();
        const e = new R();
        e.register("static-header", (t) => new Ki(t)),
          e.register("static-announcement", (t) => new U(t)),
          e.register("static-footer", (t) => new Bi(t)),
          e.register("static-article", (t) => new Q(t)),
          e.register("static-blog", (t) => new Y(t)),
          e.register("static-cart", (t) => new At(t)),
          e.register("static-collection", (t) => new xi(t)),
          e.register("static-collection-faceted-filters", (t) => new Hn(t)),
          e.register("static-subcollections-menu", (t) => new Nn(t)),
          e.register("static-password", (t) => new Ji(t)),
          e.register("static-product", (t) => new Tn(t)),
          e.register("static-product-compare", (t) => new Mn(t)),
          e.register("static-product-recommendations", (t) => new Fn(t)),
          e.register("static-recently-viewed", (t) => new qn(t)),
          e.register("static-search", (t) => new $n(t)),
          e.register("static-search-faceted-filters", (t) => new Un(t)),
          e.register("static-utility-bar", (t) => new Bn(t)),
          e.register(
            "static-subcollections-featured-collection",
            (t) => new zn(t)
          ),
          e.register("dynamic-blog-posts", (t) => new jn(t), { lazy: !0 }),
          e.register("dynamic-promo-mosaic", (t) => new Gn(t), { lazy: !0 }),
          e.register("dynamic-menu-list", (t) => new Zn(t), { lazy: !0 }),
          e.register("dynamic-twitter-feed", (t) => new Kn(t), { lazy: !0 }),
          e.register("dynamic-collection-list", (t) => new Jn(t), { lazy: !0 }),
          e.register("dynamic-countdown-timer", (t) => new is(t), { lazy: !0 }),
          e.register("dynamic-featured-collection", (t) => new Xn(t), {
            lazy: !0,
          }),
          e.register("dynamic-featured-product", (t) => new ns(t), {
            lazy: !0,
          }),
          e.register("dynamic-rich-text", (t) => new ss(t), { lazy: !0 }),
          e.register("dynamic-page", (t) => new ss(t), { lazy: !0 }),
          e.register("dynamic-html", (t) => new ss(t), { lazy: !0 }),
          e.register("dynamic-search", (t) => new os(t), { lazy: !0 }),
          e.register("dynamic-highlights-banner", (t) => new zs(t)),
          e.register("pxs-slideshow", (t) => new Bs(t), { lazy: !0 }),
          e.register("dynamic-video", (t) => new Ns(t), { lazy: !0 }),
          e.register("pxs-newsletter", (t) => new Rs(t), { lazy: !0 }),
          e.register("pxs-map", (t) => new d(t), { lazy: !0 }),
          e.register("pxs-shoppable-image", (t) => new Vs(t), { lazy: !1 }),
          e.register("dynamic-testimonials", (t) => new Gs(t), { lazy: !0 }),
          e.register("age-gate", (t) => new y(t)),
          document.body.classList.contains("template-giftcard") && new Qs(),
          document.querySelector("[data-template-account]") && new Xs(),
          document.querySelector("[data-template-contact]") && new Zs(),
          document.body.classList.contains("template-page") && new Ys(),
          document.body.classList.contains("template-order") && new Ks(),
          document.querySelector("[data-swatch-tooltip]") && new so();
        const i = document.querySelector("[data-product-compare-drawer]");
        i && new eo(i);
      };
      io(), H.length ? s()(H, oo) : oo();
      const ro = document.getElementById("age-gate-page");
      ro && new v(ro);
    })();
})();

